import { installStorefrontLifecycle } from "./storefront-lifecycle.js";
import "./lyo-cart-bridge-v7.js";
var um = e => {
  throw TypeError(e);
};
var Ju = (e, t, n) => t.has(e) || um("Cannot " + n);
var C = (e, t, n) => (Ju(e, t, "read from private field"), n ? n.call(e) : t.get(e)),
  H = (e, t, n) => t.has(e) ? um("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, n),
  V = (e, t, n, r) => (Ju(e, t, "write to private field"), r ? r.call(e, n) : t.set(e, n), n),
  ee = (e, t, n) => (Ju(e, t, "access private method"), n);
var ma = (e, t, n, r) => ({
  set _(s) {
    V(e, t, s, n);
  },
  get _() {
    return C(e, t, r);
  }
});
function FE(e, t) {
  for (var n = 0; n < t.length; n++) {
    const r = t[n];
    if (typeof r != "string" && !Array.isArray(r)) {
      for (const s in r) if (s !== "default" && !(s in e)) {
        const o = Object.getOwnPropertyDescriptor(r, s);
        o && Object.defineProperty(e, s, o.get ? o : {
          enumerable: !0,
          get: () => r[s]
        });
      }
    }
  }
  return Object.freeze(Object.defineProperty(e, Symbol.toStringTag, {
    value: "Module"
  }));
}
(function () {
  const t = document.createElement("link").relList;
  if (t && t.supports && t.supports("modulepreload")) return;
  for (const s of document.querySelectorAll('link[rel="modulepreload"]')) r(s);
  new MutationObserver(s => {
    for (const o of s) if (o.type === "childList") for (const i of o.addedNodes) i.tagName === "LINK" && i.rel === "modulepreload" && r(i);
  }).observe(document, {
    childList: !0,
    subtree: !0
  });
  function n(s) {
    const o = {};
    return s.integrity && (o.integrity = s.integrity), s.referrerPolicy && (o.referrerPolicy = s.referrerPolicy), s.crossOrigin === "use-credentials" ? o.credentials = "include" : s.crossOrigin === "anonymous" ? o.credentials = "omit" : o.credentials = "same-origin", o;
  }
  function r(s) {
    if (s.ep) return;
    s.ep = !0;
    const o = n(s);
    fetch(s.href, o);
  }
})();
function Yv(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Xv = {
    exports: {}
  },
  fu = {},
  Zv = {
    exports: {}
  },
  Z = {};
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Yi = Symbol.for("react.element"),
  _E = Symbol.for("react.portal"),
  VE = Symbol.for("react.fragment"),
  BE = Symbol.for("react.strict_mode"),
  zE = Symbol.for("react.profiler"),
  $E = Symbol.for("react.provider"),
  UE = Symbol.for("react.context"),
  WE = Symbol.for("react.forward_ref"),
  HE = Symbol.for("react.suspense"),
  qE = Symbol.for("react.memo"),
  KE = Symbol.for("react.lazy"),
  cm = Symbol.iterator;
function QE(e) {
  return e === null || typeof e != "object" ? null : (e = cm && e[cm] || e["@@iterator"], typeof e == "function" ? e : null);
}
var Jv = {
    isMounted: function () {
      return !1;
    },
    enqueueForceUpdate: function () {},
    enqueueReplaceState: function () {},
    enqueueSetState: function () {}
  },
  e0 = Object.assign,
  t0 = {};
function To(e, t, n) {
  this.props = e, this.context = t, this.refs = t0, this.updater = n || Jv;
}
To.prototype.isReactComponent = {};
To.prototype.setState = function (e, t) {
  if (typeof e != "object" && typeof e != "function" && e != null) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
  this.updater.enqueueSetState(this, e, t, "setState");
};
To.prototype.forceUpdate = function (e) {
  this.updater.enqueueForceUpdate(this, e, "forceUpdate");
};
function n0() {}
n0.prototype = To.prototype;
function nh(e, t, n) {
  this.props = e, this.context = t, this.refs = t0, this.updater = n || Jv;
}
var rh = nh.prototype = new n0();
rh.constructor = nh;
e0(rh, To.prototype);
rh.isPureReactComponent = !0;
var dm = Array.isArray,
  r0 = Object.prototype.hasOwnProperty,
  sh = {
    current: null
  },
  s0 = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
  };
function o0(e, t, n) {
  var r,
    s = {},
    o = null,
    i = null;
  if (t != null) for (r in t.ref !== void 0 && (i = t.ref), t.key !== void 0 && (o = "" + t.key), t) r0.call(t, r) && !s0.hasOwnProperty(r) && (s[r] = t[r]);
  var a = arguments.length - 2;
  if (a === 1) s.children = n;else if (1 < a) {
    for (var l = Array(a), u = 0; u < a; u++) l[u] = arguments[u + 2];
    s.children = l;
  }
  if (e && e.defaultProps) for (r in a = e.defaultProps, a) s[r] === void 0 && (s[r] = a[r]);
  return {
    $$typeof: Yi,
    type: e,
    key: o,
    ref: i,
    props: s,
    _owner: sh.current
  };
}
function GE(e, t) {
  return {
    $$typeof: Yi,
    type: e.type,
    key: t,
    ref: e.ref,
    props: e.props,
    _owner: e._owner
  };
}
function oh(e) {
  return typeof e == "object" && e !== null && e.$$typeof === Yi;
}
function YE(e) {
  var t = {
    "=": "=0",
    ":": "=2"
  };
  return "$" + e.replace(/[=:]/g, function (n) {
    return t[n];
  });
}
var fm = /\/+/g;
function ec(e, t) {
  return typeof e == "object" && e !== null && e.key != null ? YE("" + e.key) : t.toString(36);
}
function Qa(e, t, n, r, s) {
  var o = typeof e;
  (o === "undefined" || o === "boolean") && (e = null);
  var i = !1;
  if (e === null) i = !0;else switch (o) {
    case "string":
    case "number":
      i = !0;
      break;
    case "object":
      switch (e.$$typeof) {
        case Yi:
        case _E:
          i = !0;
      }
  }
  if (i) return i = e, s = s(i), e = r === "" ? "." + ec(i, 0) : r, dm(s) ? (n = "", e != null && (n = e.replace(fm, "$&/") + "/"), Qa(s, t, n, "", function (u) {
    return u;
  })) : s != null && (oh(s) && (s = GE(s, n + (!s.key || i && i.key === s.key ? "" : ("" + s.key).replace(fm, "$&/") + "/") + e)), t.push(s)), 1;
  if (i = 0, r = r === "" ? "." : r + ":", dm(e)) for (var a = 0; a < e.length; a++) {
    o = e[a];
    var l = r + ec(o, a);
    i += Qa(o, t, n, l, s);
  } else if (l = QE(e), typeof l == "function") for (e = l.call(e), a = 0; !(o = e.next()).done;) o = o.value, l = r + ec(o, a++), i += Qa(o, t, n, l, s);else if (o === "object") throw t = String(e), Error("Objects are not valid as a React child (found: " + (t === "[object Object]" ? "object with keys {" + Object.keys(e).join(", ") + "}" : t) + "). If you meant to render a collection of children, use an array instead.");
  return i;
}
function ga(e, t, n) {
  if (e == null) return e;
  var r = [],
    s = 0;
  return Qa(e, r, "", "", function (o) {
    return t.call(n, o, s++);
  }), r;
}
function XE(e) {
  if (e._status === -1) {
    var t = e._result;
    t = t(), t.then(function (n) {
      (e._status === 0 || e._status === -1) && (e._status = 1, e._result = n);
    }, function (n) {
      (e._status === 0 || e._status === -1) && (e._status = 2, e._result = n);
    }), e._status === -1 && (e._status = 0, e._result = t);
  }
  if (e._status === 1) return e._result.default;
  throw e._result;
}
var tt = {
    current: null
  },
  Ga = {
    transition: null
  },
  ZE = {
    ReactCurrentDispatcher: tt,
    ReactCurrentBatchConfig: Ga,
    ReactCurrentOwner: sh
  };
function i0() {
  throw Error("act(...) is not supported in production builds of React.");
}
Z.Children = {
  map: ga,
  forEach: function (e, t, n) {
    ga(e, function () {
      t.apply(this, arguments);
    }, n);
  },
  count: function (e) {
    var t = 0;
    return ga(e, function () {
      t++;
    }), t;
  },
  toArray: function (e) {
    return ga(e, function (t) {
      return t;
    }) || [];
  },
  only: function (e) {
    if (!oh(e)) throw Error("React.Children.only expected to receive a single React element child.");
    return e;
  }
};
Z.Component = To;
Z.Fragment = VE;
Z.Profiler = zE;
Z.PureComponent = nh;
Z.StrictMode = BE;
Z.Suspense = HE;
Z.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ZE;
Z.act = i0;
Z.cloneElement = function (e, t, n) {
  if (e == null) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + e + ".");
  var r = e0({}, e.props),
    s = e.key,
    o = e.ref,
    i = e._owner;
  if (t != null) {
    if (t.ref !== void 0 && (o = t.ref, i = sh.current), t.key !== void 0 && (s = "" + t.key), e.type && e.type.defaultProps) var a = e.type.defaultProps;
    for (l in t) r0.call(t, l) && !s0.hasOwnProperty(l) && (r[l] = t[l] === void 0 && a !== void 0 ? a[l] : t[l]);
  }
  var l = arguments.length - 2;
  if (l === 1) r.children = n;else if (1 < l) {
    a = Array(l);
    for (var u = 0; u < l; u++) a[u] = arguments[u + 2];
    r.children = a;
  }
  return {
    $$typeof: Yi,
    type: e.type,
    key: s,
    ref: o,
    props: r,
    _owner: i
  };
};
Z.createContext = function (e) {
  return e = {
    $$typeof: UE,
    _currentValue: e,
    _currentValue2: e,
    _threadCount: 0,
    Provider: null,
    Consumer: null,
    _defaultValue: null,
    _globalName: null
  }, e.Provider = {
    $$typeof: $E,
    _context: e
  }, e.Consumer = e;
};
Z.createElement = o0;
Z.createFactory = function (e) {
  var t = o0.bind(null, e);
  return t.type = e, t;
};
Z.createRef = function () {
  return {
    current: null
  };
};
Z.forwardRef = function (e) {
  return {
    $$typeof: WE,
    render: e
  };
};
Z.isValidElement = oh;
Z.lazy = function (e) {
  return {
    $$typeof: KE,
    _payload: {
      _status: -1,
      _result: e
    },
    _init: XE
  };
};
Z.memo = function (e, t) {
  return {
    $$typeof: qE,
    type: e,
    compare: t === void 0 ? null : t
  };
};
Z.startTransition = function (e) {
  var t = Ga.transition;
  Ga.transition = {};
  try {
    e();
  } finally {
    Ga.transition = t;
  }
};
Z.unstable_act = i0;
Z.useCallback = function (e, t) {
  return tt.current.useCallback(e, t);
};
Z.useContext = function (e) {
  return tt.current.useContext(e);
};
Z.useDebugValue = function () {};
Z.useDeferredValue = function (e) {
  return tt.current.useDeferredValue(e);
};
Z.useEffect = function (e, t) {
  return tt.current.useEffect(e, t);
};
Z.useId = function () {
  return tt.current.useId();
};
Z.useImperativeHandle = function (e, t, n) {
  return tt.current.useImperativeHandle(e, t, n);
};
Z.useInsertionEffect = function (e, t) {
  return tt.current.useInsertionEffect(e, t);
};
Z.useLayoutEffect = function (e, t) {
  return tt.current.useLayoutEffect(e, t);
};
Z.useMemo = function (e, t) {
  return tt.current.useMemo(e, t);
};
Z.useReducer = function (e, t, n) {
  return tt.current.useReducer(e, t, n);
};
Z.useRef = function (e) {
  return tt.current.useRef(e);
};
Z.useState = function (e) {
  return tt.current.useState(e);
};
Z.useSyncExternalStore = function (e, t, n) {
  return tt.current.useSyncExternalStore(e, t, n);
};
Z.useTransition = function () {
  return tt.current.useTransition();
};
Z.version = "18.3.1";
Zv.exports = Z;
var y = Zv.exports;
const L = Yv(y),
  ih = FE({
    __proto__: null,
    default: L
  }, [y]);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var JE = y,
  eC = Symbol.for("react.element"),
  tC = Symbol.for("react.fragment"),
  nC = Object.prototype.hasOwnProperty,
  rC = JE.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,
  sC = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
  };
function a0(e, t, n) {
  var r,
    s = {},
    o = null,
    i = null;
  n !== void 0 && (o = "" + n), t.key !== void 0 && (o = "" + t.key), t.ref !== void 0 && (i = t.ref);
  for (r in t) nC.call(t, r) && !sC.hasOwnProperty(r) && (s[r] = t[r]);
  if (e && e.defaultProps) for (r in t = e.defaultProps, t) s[r] === void 0 && (s[r] = t[r]);
  return {
    $$typeof: eC,
    type: e,
    key: o,
    ref: i,
    props: s,
    _owner: rC.current
  };
}
fu.Fragment = tC;
fu.jsx = a0;
fu.jsxs = a0;
Xv.exports = fu;
var p = Xv.exports,
  l0 = {
    exports: {}
  },
  vt = {},
  u0 = {
    exports: {}
  },
  c0 = {};
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
(function (e) {
  function t(N, j) {
    var F = N.length;
    N.push(j);
    e: for (; 0 < F;) {
      var W = F - 1 >>> 1,
        $ = N[W];
      if (0 < s($, j)) N[W] = j, N[F] = $, F = W;else break e;
    }
  }
  function n(N) {
    return N.length === 0 ? null : N[0];
  }
  function r(N) {
    if (N.length === 0) return null;
    var j = N[0],
      F = N.pop();
    if (F !== j) {
      N[0] = F;
      e: for (var W = 0, $ = N.length, X = $ >>> 1; W < X;) {
        var J = 2 * (W + 1) - 1,
          Te = N[J],
          $e = J + 1,
          re = N[$e];
        if (0 > s(Te, F)) $e < $ && 0 > s(re, Te) ? (N[W] = re, N[$e] = F, W = $e) : (N[W] = Te, N[J] = F, W = J);else if ($e < $ && 0 > s(re, F)) N[W] = re, N[$e] = F, W = $e;else break e;
      }
    }
    return j;
  }
  function s(N, j) {
    var F = N.sortIndex - j.sortIndex;
    return F !== 0 ? F : N.id - j.id;
  }
  if (typeof performance == "object" && typeof performance.now == "function") {
    var o = performance;
    e.unstable_now = function () {
      return o.now();
    };
  } else {
    var i = Date,
      a = i.now();
    e.unstable_now = function () {
      return i.now() - a;
    };
  }
  var l = [],
    u = [],
    d = 1,
    c = null,
    f = 3,
    h = !1,
    w = !1,
    m = !1,
    x = typeof setTimeout == "function" ? setTimeout : null,
    g = typeof clearTimeout == "function" ? clearTimeout : null,
    v = typeof setImmediate < "u" ? setImmediate : null;
  typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
  function b(N) {
    for (var j = n(u); j !== null;) {
      if (j.callback === null) r(u);else if (j.startTime <= N) r(u), j.sortIndex = j.expirationTime, t(l, j);else break;
      j = n(u);
    }
  }
  function S(N) {
    if (m = !1, b(N), !w) if (n(l) !== null) w = !0, z(E);else {
      var j = n(u);
      j !== null && K(S, j.startTime - N);
    }
  }
  function E(N, j) {
    w = !1, m && (m = !1, g(k), k = -1), h = !0;
    var F = f;
    try {
      for (b(j), c = n(l); c !== null && (!(c.expirationTime > j) || N && !I());) {
        var W = c.callback;
        if (typeof W == "function") {
          c.callback = null, f = c.priorityLevel;
          var $ = W(c.expirationTime <= j);
          j = e.unstable_now(), typeof $ == "function" ? c.callback = $ : c === n(l) && r(l), b(j);
        } else r(l);
        c = n(l);
      }
      if (c !== null) var X = !0;else {
        var J = n(u);
        J !== null && K(S, J.startTime - j), X = !1;
      }
      return X;
    } finally {
      c = null, f = F, h = !1;
    }
  }
  var P = !1,
    T = null,
    k = -1,
    A = 5,
    R = -1;
  function I() {
    return !(e.unstable_now() - R < A);
  }
  function O() {
    if (T !== null) {
      var N = e.unstable_now();
      R = N;
      var j = !0;
      try {
        j = T(!0, N);
      } finally {
        j ? U() : (P = !1, T = null);
      }
    } else P = !1;
  }
  var U;
  if (typeof v == "function") U = function () {
    v(O);
  };else if (typeof MessageChannel < "u") {
    var D = new MessageChannel(),
      q = D.port2;
    D.port1.onmessage = O, U = function () {
      q.postMessage(null);
    };
  } else U = function () {
    x(O, 0);
  };
  function z(N) {
    T = N, P || (P = !0, U());
  }
  function K(N, j) {
    k = x(function () {
      N(e.unstable_now());
    }, j);
  }
  e.unstable_IdlePriority = 5, e.unstable_ImmediatePriority = 1, e.unstable_LowPriority = 4, e.unstable_NormalPriority = 3, e.unstable_Profiling = null, e.unstable_UserBlockingPriority = 2, e.unstable_cancelCallback = function (N) {
    N.callback = null;
  }, e.unstable_continueExecution = function () {
    w || h || (w = !0, z(E));
  }, e.unstable_forceFrameRate = function (N) {
    0 > N || 125 < N ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : A = 0 < N ? Math.floor(1e3 / N) : 5;
  }, e.unstable_getCurrentPriorityLevel = function () {
    return f;
  }, e.unstable_getFirstCallbackNode = function () {
    return n(l);
  }, e.unstable_next = function (N) {
    switch (f) {
      case 1:
      case 2:
      case 3:
        var j = 3;
        break;
      default:
        j = f;
    }
    var F = f;
    f = j;
    try {
      return N();
    } finally {
      f = F;
    }
  }, e.unstable_pauseExecution = function () {}, e.unstable_requestPaint = function () {}, e.unstable_runWithPriority = function (N, j) {
    switch (N) {
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
        break;
      default:
        N = 3;
    }
    var F = f;
    f = N;
    try {
      return j();
    } finally {
      f = F;
    }
  }, e.unstable_scheduleCallback = function (N, j, F) {
    var W = e.unstable_now();
    switch (typeof F == "object" && F !== null ? (F = F.delay, F = typeof F == "number" && 0 < F ? W + F : W) : F = W, N) {
      case 1:
        var $ = -1;
        break;
      case 2:
        $ = 250;
        break;
      case 5:
        $ = 1073741823;
        break;
      case 4:
        $ = 1e4;
        break;
      default:
        $ = 5e3;
    }
    return $ = F + $, N = {
      id: d++,
      callback: j,
      priorityLevel: N,
      startTime: F,
      expirationTime: $,
      sortIndex: -1
    }, F > W ? (N.sortIndex = F, t(u, N), n(l) === null && N === n(u) && (m ? (g(k), k = -1) : m = !0, K(S, F - W))) : (N.sortIndex = $, t(l, N), w || h || (w = !0, z(E))), N;
  }, e.unstable_shouldYield = I, e.unstable_wrapCallback = function (N) {
    var j = f;
    return function () {
      var F = f;
      f = j;
      try {
        return N.apply(this, arguments);
      } finally {
        f = F;
      }
    };
  };
})(c0);
u0.exports = c0;
var oC = u0.exports;
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var iC = y,
  yt = oC;
function M(e) {
  for (var t = "https://reactjs.org/docs/error-decoder.html?invariant=" + e, n = 1; n < arguments.length; n++) t += "&args[]=" + encodeURIComponent(arguments[n]);
  return "Minified React error #" + e + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var d0 = new Set(),
  vi = {};
function ps(e, t) {
  co(e, t), co(e + "Capture", t);
}
function co(e, t) {
  for (vi[e] = t, e = 0; e < t.length; e++) d0.add(t[e]);
}
var Rn = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"),
  ad = Object.prototype.hasOwnProperty,
  aC = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
  hm = {},
  pm = {};
function lC(e) {
  return ad.call(pm, e) ? !0 : ad.call(hm, e) ? !1 : aC.test(e) ? pm[e] = !0 : (hm[e] = !0, !1);
}
function uC(e, t, n, r) {
  if (n !== null && n.type === 0) return !1;
  switch (typeof t) {
    case "function":
    case "symbol":
      return !0;
    case "boolean":
      return r ? !1 : n !== null ? !n.acceptsBooleans : (e = e.toLowerCase().slice(0, 5), e !== "data-" && e !== "aria-");
    default:
      return !1;
  }
}
function cC(e, t, n, r) {
  if (t === null || typeof t > "u" || uC(e, t, n, r)) return !0;
  if (r) return !1;
  if (n !== null) switch (n.type) {
    case 3:
      return !t;
    case 4:
      return t === !1;
    case 5:
      return isNaN(t);
    case 6:
      return isNaN(t) || 1 > t;
  }
  return !1;
}
function nt(e, t, n, r, s, o, i) {
  this.acceptsBooleans = t === 2 || t === 3 || t === 4, this.attributeName = r, this.attributeNamespace = s, this.mustUseProperty = n, this.propertyName = e, this.type = t, this.sanitizeURL = o, this.removeEmptyString = i;
}
var ze = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function (e) {
  ze[e] = new nt(e, 0, !1, e, null, !1, !1);
});
[["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function (e) {
  var t = e[0];
  ze[t] = new nt(t, 1, !1, e[1], null, !1, !1);
});
["contentEditable", "draggable", "spellCheck", "value"].forEach(function (e) {
  ze[e] = new nt(e, 2, !1, e.toLowerCase(), null, !1, !1);
});
["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function (e) {
  ze[e] = new nt(e, 2, !1, e, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function (e) {
  ze[e] = new nt(e, 3, !1, e.toLowerCase(), null, !1, !1);
});
["checked", "multiple", "muted", "selected"].forEach(function (e) {
  ze[e] = new nt(e, 3, !0, e, null, !1, !1);
});
["capture", "download"].forEach(function (e) {
  ze[e] = new nt(e, 4, !1, e, null, !1, !1);
});
["cols", "rows", "size", "span"].forEach(function (e) {
  ze[e] = new nt(e, 6, !1, e, null, !1, !1);
});
["rowSpan", "start"].forEach(function (e) {
  ze[e] = new nt(e, 5, !1, e.toLowerCase(), null, !1, !1);
});
var ah = /[\-:]([a-z])/g;
function lh(e) {
  return e[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function (e) {
  var t = e.replace(ah, lh);
  ze[t] = new nt(t, 1, !1, e, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function (e) {
  var t = e.replace(ah, lh);
  ze[t] = new nt(t, 1, !1, e, "http://www.w3.org/1999/xlink", !1, !1);
});
["xml:base", "xml:lang", "xml:space"].forEach(function (e) {
  var t = e.replace(ah, lh);
  ze[t] = new nt(t, 1, !1, e, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
["tabIndex", "crossOrigin"].forEach(function (e) {
  ze[e] = new nt(e, 1, !1, e.toLowerCase(), null, !1, !1);
});
ze.xlinkHref = new nt("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
["src", "href", "action", "formAction"].forEach(function (e) {
  ze[e] = new nt(e, 1, !1, e.toLowerCase(), null, !0, !0);
});
function uh(e, t, n, r) {
  var s = ze.hasOwnProperty(t) ? ze[t] : null;
  (s !== null ? s.type !== 0 : r || !(2 < t.length) || t[0] !== "o" && t[0] !== "O" || t[1] !== "n" && t[1] !== "N") && (cC(t, n, s, r) && (n = null), r || s === null ? lC(t) && (n === null ? e.removeAttribute(t) : e.setAttribute(t, "" + n)) : s.mustUseProperty ? e[s.propertyName] = n === null ? s.type === 3 ? !1 : "" : n : (t = s.attributeName, r = s.attributeNamespace, n === null ? e.removeAttribute(t) : (s = s.type, n = s === 3 || s === 4 && n === !0 ? "" : "" + n, r ? e.setAttributeNS(r, t, n) : e.setAttribute(t, n))));
}
var Dn = iC.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
  ya = Symbol.for("react.element"),
  ks = Symbol.for("react.portal"),
  Rs = Symbol.for("react.fragment"),
  ch = Symbol.for("react.strict_mode"),
  ld = Symbol.for("react.profiler"),
  f0 = Symbol.for("react.provider"),
  h0 = Symbol.for("react.context"),
  dh = Symbol.for("react.forward_ref"),
  ud = Symbol.for("react.suspense"),
  cd = Symbol.for("react.suspense_list"),
  fh = Symbol.for("react.memo"),
  Zn = Symbol.for("react.lazy"),
  p0 = Symbol.for("react.offscreen"),
  mm = Symbol.iterator;
function Bo(e) {
  return e === null || typeof e != "object" ? null : (e = mm && e[mm] || e["@@iterator"], typeof e == "function" ? e : null);
}
var be = Object.assign,
  tc;
function Zo(e) {
  if (tc === void 0) try {
    throw Error();
  } catch (n) {
    var t = n.stack.trim().match(/\n( *(at )?)/);
    tc = t && t[1] || "";
  }
  return `
` + tc + e;
}
var nc = !1;
function rc(e, t) {
  if (!e || nc) return "";
  nc = !0;
  var n = Error.prepareStackTrace;
  Error.prepareStackTrace = void 0;
  try {
    if (t) {
      if (t = function () {
        throw Error();
      }, Object.defineProperty(t.prototype, "props", {
        set: function () {
          throw Error();
        }
      }), typeof Reflect == "object" && Reflect.construct) {
        try {
          Reflect.construct(t, []);
        } catch (u) {
          var r = u;
        }
        Reflect.construct(e, [], t);
      } else {
        try {
          t.call();
        } catch (u) {
          r = u;
        }
        e.call(t.prototype);
      }
    } else {
      try {
        throw Error();
      } catch (u) {
        r = u;
      }
      e();
    }
  } catch (u) {
    if (u && r && typeof u.stack == "string") {
      for (var s = u.stack.split(`
`), o = r.stack.split(`
`), i = s.length - 1, a = o.length - 1; 1 <= i && 0 <= a && s[i] !== o[a];) a--;
      for (; 1 <= i && 0 <= a; i--, a--) if (s[i] !== o[a]) {
        if (i !== 1 || a !== 1) do if (i--, a--, 0 > a || s[i] !== o[a]) {
          var l = `
` + s[i].replace(" at new ", " at ");
          return e.displayName && l.includes("<anonymous>") && (l = l.replace("<anonymous>", e.displayName)), l;
        } while (1 <= i && 0 <= a);
        break;
      }
    }
  } finally {
    nc = !1, Error.prepareStackTrace = n;
  }
  return (e = e ? e.displayName || e.name : "") ? Zo(e) : "";
}
function dC(e) {
  switch (e.tag) {
    case 5:
      return Zo(e.type);
    case 16:
      return Zo("Lazy");
    case 13:
      return Zo("Suspense");
    case 19:
      return Zo("SuspenseList");
    case 0:
    case 2:
    case 15:
      return e = rc(e.type, !1), e;
    case 11:
      return e = rc(e.type.render, !1), e;
    case 1:
      return e = rc(e.type, !0), e;
    default:
      return "";
  }
}
function dd(e) {
  if (e == null) return null;
  if (typeof e == "function") return e.displayName || e.name || null;
  if (typeof e == "string") return e;
  switch (e) {
    case Rs:
      return "Fragment";
    case ks:
      return "Portal";
    case ld:
      return "Profiler";
    case ch:
      return "StrictMode";
    case ud:
      return "Suspense";
    case cd:
      return "SuspenseList";
  }
  if (typeof e == "object") switch (e.$$typeof) {
    case h0:
      return (e.displayName || "Context") + ".Consumer";
    case f0:
      return (e._context.displayName || "Context") + ".Provider";
    case dh:
      var t = e.render;
      return e = e.displayName, e || (e = t.displayName || t.name || "", e = e !== "" ? "ForwardRef(" + e + ")" : "ForwardRef"), e;
    case fh:
      return t = e.displayName || null, t !== null ? t : dd(e.type) || "Memo";
    case Zn:
      t = e._payload, e = e._init;
      try {
        return dd(e(t));
      } catch {}
  }
  return null;
}
function fC(e) {
  var t = e.type;
  switch (e.tag) {
    case 24:
      return "Cache";
    case 9:
      return (t.displayName || "Context") + ".Consumer";
    case 10:
      return (t._context.displayName || "Context") + ".Provider";
    case 18:
      return "DehydratedFragment";
    case 11:
      return e = t.render, e = e.displayName || e.name || "", t.displayName || (e !== "" ? "ForwardRef(" + e + ")" : "ForwardRef");
    case 7:
      return "Fragment";
    case 5:
      return t;
    case 4:
      return "Portal";
    case 3:
      return "Root";
    case 6:
      return "Text";
    case 16:
      return dd(t);
    case 8:
      return t === ch ? "StrictMode" : "Mode";
    case 22:
      return "Offscreen";
    case 12:
      return "Profiler";
    case 21:
      return "Scope";
    case 13:
      return "Suspense";
    case 19:
      return "SuspenseList";
    case 25:
      return "TracingMarker";
    case 1:
    case 0:
    case 17:
    case 2:
    case 14:
    case 15:
      if (typeof t == "function") return t.displayName || t.name || null;
      if (typeof t == "string") return t;
  }
  return null;
}
function Cr(e) {
  switch (typeof e) {
    case "boolean":
    case "number":
    case "string":
    case "undefined":
      return e;
    case "object":
      return e;
    default:
      return "";
  }
}
function m0(e) {
  var t = e.type;
  return (e = e.nodeName) && e.toLowerCase() === "input" && (t === "checkbox" || t === "radio");
}
function hC(e) {
  var t = m0(e) ? "checked" : "value",
    n = Object.getOwnPropertyDescriptor(e.constructor.prototype, t),
    r = "" + e[t];
  if (!e.hasOwnProperty(t) && typeof n < "u" && typeof n.get == "function" && typeof n.set == "function") {
    var s = n.get,
      o = n.set;
    return Object.defineProperty(e, t, {
      configurable: !0,
      get: function () {
        return s.call(this);
      },
      set: function (i) {
        r = "" + i, o.call(this, i);
      }
    }), Object.defineProperty(e, t, {
      enumerable: n.enumerable
    }), {
      getValue: function () {
        return r;
      },
      setValue: function (i) {
        r = "" + i;
      },
      stopTracking: function () {
        e._valueTracker = null, delete e[t];
      }
    };
  }
}
function va(e) {
  e._valueTracker || (e._valueTracker = hC(e));
}
function g0(e) {
  if (!e) return !1;
  var t = e._valueTracker;
  if (!t) return !0;
  var n = t.getValue(),
    r = "";
  return e && (r = m0(e) ? e.checked ? "true" : "false" : e.value), e = r, e !== n ? (t.setValue(e), !0) : !1;
}
function wl(e) {
  if (e = e || (typeof document < "u" ? document : void 0), typeof e > "u") return null;
  try {
    return e.activeElement || e.body;
  } catch {
    return e.body;
  }
}
function fd(e, t) {
  var n = t.checked;
  return be({}, t, {
    defaultChecked: void 0,
    defaultValue: void 0,
    value: void 0,
    checked: n ?? e._wrapperState.initialChecked
  });
}
function gm(e, t) {
  var n = t.defaultValue == null ? "" : t.defaultValue,
    r = t.checked != null ? t.checked : t.defaultChecked;
  n = Cr(t.value != null ? t.value : n), e._wrapperState = {
    initialChecked: r,
    initialValue: n,
    controlled: t.type === "checkbox" || t.type === "radio" ? t.checked != null : t.value != null
  };
}
function y0(e, t) {
  t = t.checked, t != null && uh(e, "checked", t, !1);
}
function hd(e, t) {
  y0(e, t);
  var n = Cr(t.value),
    r = t.type;
  if (n != null) r === "number" ? (n === 0 && e.value === "" || e.value != n) && (e.value = "" + n) : e.value !== "" + n && (e.value = "" + n);else if (r === "submit" || r === "reset") {
    e.removeAttribute("value");
    return;
  }
  t.hasOwnProperty("value") ? pd(e, t.type, n) : t.hasOwnProperty("defaultValue") && pd(e, t.type, Cr(t.defaultValue)), t.checked == null && t.defaultChecked != null && (e.defaultChecked = !!t.defaultChecked);
}
function ym(e, t, n) {
  if (t.hasOwnProperty("value") || t.hasOwnProperty("defaultValue")) {
    var r = t.type;
    if (!(r !== "submit" && r !== "reset" || t.value !== void 0 && t.value !== null)) return;
    t = "" + e._wrapperState.initialValue, n || t === e.value || (e.value = t), e.defaultValue = t;
  }
  n = e.name, n !== "" && (e.name = ""), e.defaultChecked = !!e._wrapperState.initialChecked, n !== "" && (e.name = n);
}
function pd(e, t, n) {
  (t !== "number" || wl(e.ownerDocument) !== e) && (n == null ? e.defaultValue = "" + e._wrapperState.initialValue : e.defaultValue !== "" + n && (e.defaultValue = "" + n));
}
var Jo = Array.isArray;
function $s(e, t, n, r) {
  if (e = e.options, t) {
    t = {};
    for (var s = 0; s < n.length; s++) t["$" + n[s]] = !0;
    for (n = 0; n < e.length; n++) s = t.hasOwnProperty("$" + e[n].value), e[n].selected !== s && (e[n].selected = s), s && r && (e[n].defaultSelected = !0);
  } else {
    for (n = "" + Cr(n), t = null, s = 0; s < e.length; s++) {
      if (e[s].value === n) {
        e[s].selected = !0, r && (e[s].defaultSelected = !0);
        return;
      }
      t !== null || e[s].disabled || (t = e[s]);
    }
    t !== null && (t.selected = !0);
  }
}
function md(e, t) {
  if (t.dangerouslySetInnerHTML != null) throw Error(M(91));
  return be({}, t, {
    value: void 0,
    defaultValue: void 0,
    children: "" + e._wrapperState.initialValue
  });
}
function vm(e, t) {
  var n = t.value;
  if (n == null) {
    if (n = t.children, t = t.defaultValue, n != null) {
      if (t != null) throw Error(M(92));
      if (Jo(n)) {
        if (1 < n.length) throw Error(M(93));
        n = n[0];
      }
      t = n;
    }
    t == null && (t = ""), n = t;
  }
  e._wrapperState = {
    initialValue: Cr(n)
  };
}
function v0(e, t) {
  var n = Cr(t.value),
    r = Cr(t.defaultValue);
  n != null && (n = "" + n, n !== e.value && (e.value = n), t.defaultValue == null && e.defaultValue !== n && (e.defaultValue = n)), r != null && (e.defaultValue = "" + r);
}
function xm(e) {
  var t = e.textContent;
  t === e._wrapperState.initialValue && t !== "" && t !== null && (e.value = t);
}
function x0(e) {
  switch (e) {
    case "svg":
      return "http://www.w3.org/2000/svg";
    case "math":
      return "http://www.w3.org/1998/Math/MathML";
    default:
      return "http://www.w3.org/1999/xhtml";
  }
}
function gd(e, t) {
  return e == null || e === "http://www.w3.org/1999/xhtml" ? x0(t) : e === "http://www.w3.org/2000/svg" && t === "foreignObject" ? "http://www.w3.org/1999/xhtml" : e;
}
var xa,
  w0 = function (e) {
    return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function (t, n, r, s) {
      MSApp.execUnsafeLocalFunction(function () {
        return e(t, n, r, s);
      });
    } : e;
  }(function (e, t) {
    if (e.namespaceURI !== "http://www.w3.org/2000/svg" || "innerHTML" in e) e.innerHTML = t;else {
      for (xa = xa || document.createElement("div"), xa.innerHTML = "<svg>" + t.valueOf().toString() + "</svg>", t = xa.firstChild; e.firstChild;) e.removeChild(e.firstChild);
      for (; t.firstChild;) e.appendChild(t.firstChild);
    }
  });
function xi(e, t) {
  if (t) {
    var n = e.firstChild;
    if (n && n === e.lastChild && n.nodeType === 3) {
      n.nodeValue = t;
      return;
    }
  }
  e.textContent = t;
}
var si = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  },
  pC = ["Webkit", "ms", "Moz", "O"];
Object.keys(si).forEach(function (e) {
  pC.forEach(function (t) {
    t = t + e.charAt(0).toUpperCase() + e.substring(1), si[t] = si[e];
  });
});
function b0(e, t, n) {
  return t == null || typeof t == "boolean" || t === "" ? "" : n || typeof t != "number" || t === 0 || si.hasOwnProperty(e) && si[e] ? ("" + t).trim() : t + "px";
}
function S0(e, t) {
  e = e.style;
  for (var n in t) if (t.hasOwnProperty(n)) {
    var r = n.indexOf("--") === 0,
      s = b0(n, t[n], r);
    n === "float" && (n = "cssFloat"), r ? e.setProperty(n, s) : e[n] = s;
  }
}
var mC = be({
  menuitem: !0
}, {
  area: !0,
  base: !0,
  br: !0,
  col: !0,
  embed: !0,
  hr: !0,
  img: !0,
  input: !0,
  keygen: !0,
  link: !0,
  meta: !0,
  param: !0,
  source: !0,
  track: !0,
  wbr: !0
});
function yd(e, t) {
  if (t) {
    if (mC[e] && (t.children != null || t.dangerouslySetInnerHTML != null)) throw Error(M(137, e));
    if (t.dangerouslySetInnerHTML != null) {
      if (t.children != null) throw Error(M(60));
      if (typeof t.dangerouslySetInnerHTML != "object" || !("__html" in t.dangerouslySetInnerHTML)) throw Error(M(61));
    }
    if (t.style != null && typeof t.style != "object") throw Error(M(62));
  }
}
function vd(e, t) {
  if (e.indexOf("-") === -1) return typeof t.is == "string";
  switch (e) {
    case "annotation-xml":
    case "color-profile":
    case "font-face":
    case "font-face-src":
    case "font-face-uri":
    case "font-face-format":
    case "font-face-name":
    case "missing-glyph":
      return !1;
    default:
      return !0;
  }
}
var xd = null;
function hh(e) {
  return e = e.target || e.srcElement || window, e.correspondingUseElement && (e = e.correspondingUseElement), e.nodeType === 3 ? e.parentNode : e;
}
var wd = null,
  Us = null,
  Ws = null;
function wm(e) {
  if (e = Ji(e)) {
    if (typeof wd != "function") throw Error(M(280));
    var t = e.stateNode;
    t && (t = yu(t), wd(e.stateNode, e.type, t));
  }
}
function E0(e) {
  Us ? Ws ? Ws.push(e) : Ws = [e] : Us = e;
}
function C0() {
  if (Us) {
    var e = Us,
      t = Ws;
    if (Ws = Us = null, wm(e), t) for (e = 0; e < t.length; e++) wm(t[e]);
  }
}
function T0(e, t) {
  return e(t);
}
function P0() {}
var sc = !1;
function k0(e, t, n) {
  if (sc) return e(t, n);
  sc = !0;
  try {
    return T0(e, t, n);
  } finally {
    sc = !1, (Us !== null || Ws !== null) && (P0(), C0());
  }
}
function wi(e, t) {
  var n = e.stateNode;
  if (n === null) return null;
  var r = yu(n);
  if (r === null) return null;
  n = r[t];
  e: switch (t) {
    case "onClick":
    case "onClickCapture":
    case "onDoubleClick":
    case "onDoubleClickCapture":
    case "onMouseDown":
    case "onMouseDownCapture":
    case "onMouseMove":
    case "onMouseMoveCapture":
    case "onMouseUp":
    case "onMouseUpCapture":
    case "onMouseEnter":
      (r = !r.disabled) || (e = e.type, r = !(e === "button" || e === "input" || e === "select" || e === "textarea")), e = !r;
      break e;
    default:
      e = !1;
  }
  if (e) return null;
  if (n && typeof n != "function") throw Error(M(231, t, typeof n));
  return n;
}
var bd = !1;
if (Rn) try {
  var zo = {};
  Object.defineProperty(zo, "passive", {
    get: function () {
      bd = !0;
    }
  }), window.addEventListener("test", zo, zo), window.removeEventListener("test", zo, zo);
} catch {
  bd = !1;
}
function gC(e, t, n, r, s, o, i, a, l) {
  var u = Array.prototype.slice.call(arguments, 3);
  try {
    t.apply(n, u);
  } catch (d) {
    this.onError(d);
  }
}
var oi = !1,
  bl = null,
  Sl = !1,
  Sd = null,
  yC = {
    onError: function (e) {
      oi = !0, bl = e;
    }
  };
function vC(e, t, n, r, s, o, i, a, l) {
  oi = !1, bl = null, gC.apply(yC, arguments);
}
function xC(e, t, n, r, s, o, i, a, l) {
  if (vC.apply(this, arguments), oi) {
    if (oi) {
      var u = bl;
      oi = !1, bl = null;
    } else throw Error(M(198));
    Sl || (Sl = !0, Sd = u);
  }
}
function ms(e) {
  var t = e,
    n = e;
  if (e.alternate) for (; t.return;) t = t.return;else {
    e = t;
    do t = e, t.flags & 4098 && (n = t.return), e = t.return; while (e);
  }
  return t.tag === 3 ? n : null;
}
function R0(e) {
  if (e.tag === 13) {
    var t = e.memoizedState;
    if (t === null && (e = e.alternate, e !== null && (t = e.memoizedState)), t !== null) return t.dehydrated;
  }
  return null;
}
function bm(e) {
  if (ms(e) !== e) throw Error(M(188));
}
function wC(e) {
  var t = e.alternate;
  if (!t) {
    if (t = ms(e), t === null) throw Error(M(188));
    return t !== e ? null : e;
  }
  for (var n = e, r = t;;) {
    var s = n.return;
    if (s === null) break;
    var o = s.alternate;
    if (o === null) {
      if (r = s.return, r !== null) {
        n = r;
        continue;
      }
      break;
    }
    if (s.child === o.child) {
      for (o = s.child; o;) {
        if (o === n) return bm(s), e;
        if (o === r) return bm(s), t;
        o = o.sibling;
      }
      throw Error(M(188));
    }
    if (n.return !== r.return) n = s, r = o;else {
      for (var i = !1, a = s.child; a;) {
        if (a === n) {
          i = !0, n = s, r = o;
          break;
        }
        if (a === r) {
          i = !0, r = s, n = o;
          break;
        }
        a = a.sibling;
      }
      if (!i) {
        for (a = o.child; a;) {
          if (a === n) {
            i = !0, n = o, r = s;
            break;
          }
          if (a === r) {
            i = !0, r = o, n = s;
            break;
          }
          a = a.sibling;
        }
        if (!i) throw Error(M(189));
      }
    }
    if (n.alternate !== r) throw Error(M(190));
  }
  if (n.tag !== 3) throw Error(M(188));
  return n.stateNode.current === n ? e : t;
}
function N0(e) {
  return e = wC(e), e !== null ? A0(e) : null;
}
function A0(e) {
  if (e.tag === 5 || e.tag === 6) return e;
  for (e = e.child; e !== null;) {
    var t = A0(e);
    if (t !== null) return t;
    e = e.sibling;
  }
  return null;
}
var j0 = yt.unstable_scheduleCallback,
  Sm = yt.unstable_cancelCallback,
  bC = yt.unstable_shouldYield,
  SC = yt.unstable_requestPaint,
  Ce = yt.unstable_now,
  EC = yt.unstable_getCurrentPriorityLevel,
  ph = yt.unstable_ImmediatePriority,
  M0 = yt.unstable_UserBlockingPriority,
  El = yt.unstable_NormalPriority,
  CC = yt.unstable_LowPriority,
  O0 = yt.unstable_IdlePriority,
  hu = null,
  cn = null;
function TC(e) {
  if (cn && typeof cn.onCommitFiberRoot == "function") try {
    cn.onCommitFiberRoot(hu, e, void 0, (e.current.flags & 128) === 128);
  } catch {}
}
var Ht = Math.clz32 ? Math.clz32 : RC,
  PC = Math.log,
  kC = Math.LN2;
function RC(e) {
  return e >>>= 0, e === 0 ? 32 : 31 - (PC(e) / kC | 0) | 0;
}
var wa = 64,
  ba = 4194304;
function ei(e) {
  switch (e & -e) {
    case 1:
      return 1;
    case 2:
      return 2;
    case 4:
      return 4;
    case 8:
      return 8;
    case 16:
      return 16;
    case 32:
      return 32;
    case 64:
    case 128:
    case 256:
    case 512:
    case 1024:
    case 2048:
    case 4096:
    case 8192:
    case 16384:
    case 32768:
    case 65536:
    case 131072:
    case 262144:
    case 524288:
    case 1048576:
    case 2097152:
      return e & 4194240;
    case 4194304:
    case 8388608:
    case 16777216:
    case 33554432:
    case 67108864:
      return e & 130023424;
    case 134217728:
      return 134217728;
    case 268435456:
      return 268435456;
    case 536870912:
      return 536870912;
    case 1073741824:
      return 1073741824;
    default:
      return e;
  }
}
function Cl(e, t) {
  var n = e.pendingLanes;
  if (n === 0) return 0;
  var r = 0,
    s = e.suspendedLanes,
    o = e.pingedLanes,
    i = n & 268435455;
  if (i !== 0) {
    var a = i & ~s;
    a !== 0 ? r = ei(a) : (o &= i, o !== 0 && (r = ei(o)));
  } else i = n & ~s, i !== 0 ? r = ei(i) : o !== 0 && (r = ei(o));
  if (r === 0) return 0;
  if (t !== 0 && t !== r && !(t & s) && (s = r & -r, o = t & -t, s >= o || s === 16 && (o & 4194240) !== 0)) return t;
  if (r & 4 && (r |= n & 16), t = e.entangledLanes, t !== 0) for (e = e.entanglements, t &= r; 0 < t;) n = 31 - Ht(t), s = 1 << n, r |= e[n], t &= ~s;
  return r;
}
function NC(e, t) {
  switch (e) {
    case 1:
    case 2:
    case 4:
      return t + 250;
    case 8:
    case 16:
    case 32:
    case 64:
    case 128:
    case 256:
    case 512:
    case 1024:
    case 2048:
    case 4096:
    case 8192:
    case 16384:
    case 32768:
    case 65536:
    case 131072:
    case 262144:
    case 524288:
    case 1048576:
    case 2097152:
      return t + 5e3;
    case 4194304:
    case 8388608:
    case 16777216:
    case 33554432:
    case 67108864:
      return -1;
    case 134217728:
    case 268435456:
    case 536870912:
    case 1073741824:
      return -1;
    default:
      return -1;
  }
}
function AC(e, t) {
  for (var n = e.suspendedLanes, r = e.pingedLanes, s = e.expirationTimes, o = e.pendingLanes; 0 < o;) {
    var i = 31 - Ht(o),
      a = 1 << i,
      l = s[i];
    l === -1 ? (!(a & n) || a & r) && (s[i] = NC(a, t)) : l <= t && (e.expiredLanes |= a), o &= ~a;
  }
}
function Ed(e) {
  return e = e.pendingLanes & -1073741825, e !== 0 ? e : e & 1073741824 ? 1073741824 : 0;
}
function L0() {
  var e = wa;
  return wa <<= 1, !(wa & 4194240) && (wa = 64), e;
}
function oc(e) {
  for (var t = [], n = 0; 31 > n; n++) t.push(e);
  return t;
}
function Xi(e, t, n) {
  e.pendingLanes |= t, t !== 536870912 && (e.suspendedLanes = 0, e.pingedLanes = 0), e = e.eventTimes, t = 31 - Ht(t), e[t] = n;
}
function jC(e, t) {
  var n = e.pendingLanes & ~t;
  e.pendingLanes = t, e.suspendedLanes = 0, e.pingedLanes = 0, e.expiredLanes &= t, e.mutableReadLanes &= t, e.entangledLanes &= t, t = e.entanglements;
  var r = e.eventTimes;
  for (e = e.expirationTimes; 0 < n;) {
    var s = 31 - Ht(n),
      o = 1 << s;
    t[s] = 0, r[s] = -1, e[s] = -1, n &= ~o;
  }
}
function mh(e, t) {
  var n = e.entangledLanes |= t;
  for (e = e.entanglements; n;) {
    var r = 31 - Ht(n),
      s = 1 << r;
    s & t | e[r] & t && (e[r] |= t), n &= ~s;
  }
}
var oe = 0;
function D0(e) {
  return e &= -e, 1 < e ? 4 < e ? e & 268435455 ? 16 : 536870912 : 4 : 1;
}
var I0,
  gh,
  F0,
  _0,
  V0,
  Cd = !1,
  Sa = [],
  pr = null,
  mr = null,
  gr = null,
  bi = new Map(),
  Si = new Map(),
  er = [],
  MC = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function Em(e, t) {
  switch (e) {
    case "focusin":
    case "focusout":
      pr = null;
      break;
    case "dragenter":
    case "dragleave":
      mr = null;
      break;
    case "mouseover":
    case "mouseout":
      gr = null;
      break;
    case "pointerover":
    case "pointerout":
      bi.delete(t.pointerId);
      break;
    case "gotpointercapture":
    case "lostpointercapture":
      Si.delete(t.pointerId);
  }
}
function $o(e, t, n, r, s, o) {
  return e === null || e.nativeEvent !== o ? (e = {
    blockedOn: t,
    domEventName: n,
    eventSystemFlags: r,
    nativeEvent: o,
    targetContainers: [s]
  }, t !== null && (t = Ji(t), t !== null && gh(t)), e) : (e.eventSystemFlags |= r, t = e.targetContainers, s !== null && t.indexOf(s) === -1 && t.push(s), e);
}
function OC(e, t, n, r, s) {
  switch (t) {
    case "focusin":
      return pr = $o(pr, e, t, n, r, s), !0;
    case "dragenter":
      return mr = $o(mr, e, t, n, r, s), !0;
    case "mouseover":
      return gr = $o(gr, e, t, n, r, s), !0;
    case "pointerover":
      var o = s.pointerId;
      return bi.set(o, $o(bi.get(o) || null, e, t, n, r, s)), !0;
    case "gotpointercapture":
      return o = s.pointerId, Si.set(o, $o(Si.get(o) || null, e, t, n, r, s)), !0;
  }
  return !1;
}
function B0(e) {
  var t = $r(e.target);
  if (t !== null) {
    var n = ms(t);
    if (n !== null) {
      if (t = n.tag, t === 13) {
        if (t = R0(n), t !== null) {
          e.blockedOn = t, V0(e.priority, function () {
            F0(n);
          });
          return;
        }
      } else if (t === 3 && n.stateNode.current.memoizedState.isDehydrated) {
        e.blockedOn = n.tag === 3 ? n.stateNode.containerInfo : null;
        return;
      }
    }
  }
  e.blockedOn = null;
}
function Ya(e) {
  if (e.blockedOn !== null) return !1;
  for (var t = e.targetContainers; 0 < t.length;) {
    var n = Td(e.domEventName, e.eventSystemFlags, t[0], e.nativeEvent);
    if (n === null) {
      n = e.nativeEvent;
      var r = new n.constructor(n.type, n);
      xd = r, n.target.dispatchEvent(r), xd = null;
    } else return t = Ji(n), t !== null && gh(t), e.blockedOn = n, !1;
    t.shift();
  }
  return !0;
}
function Cm(e, t, n) {
  Ya(e) && n.delete(t);
}
function LC() {
  Cd = !1, pr !== null && Ya(pr) && (pr = null), mr !== null && Ya(mr) && (mr = null), gr !== null && Ya(gr) && (gr = null), bi.forEach(Cm), Si.forEach(Cm);
}
function Uo(e, t) {
  e.blockedOn === t && (e.blockedOn = null, Cd || (Cd = !0, yt.unstable_scheduleCallback(yt.unstable_NormalPriority, LC)));
}
function Ei(e) {
  function t(s) {
    return Uo(s, e);
  }
  if (0 < Sa.length) {
    Uo(Sa[0], e);
    for (var n = 1; n < Sa.length; n++) {
      var r = Sa[n];
      r.blockedOn === e && (r.blockedOn = null);
    }
  }
  for (pr !== null && Uo(pr, e), mr !== null && Uo(mr, e), gr !== null && Uo(gr, e), bi.forEach(t), Si.forEach(t), n = 0; n < er.length; n++) r = er[n], r.blockedOn === e && (r.blockedOn = null);
  for (; 0 < er.length && (n = er[0], n.blockedOn === null);) B0(n), n.blockedOn === null && er.shift();
}
var Hs = Dn.ReactCurrentBatchConfig,
  Tl = !0;
function DC(e, t, n, r) {
  var s = oe,
    o = Hs.transition;
  Hs.transition = null;
  try {
    oe = 1, yh(e, t, n, r);
  } finally {
    oe = s, Hs.transition = o;
  }
}
function IC(e, t, n, r) {
  var s = oe,
    o = Hs.transition;
  Hs.transition = null;
  try {
    oe = 4, yh(e, t, n, r);
  } finally {
    oe = s, Hs.transition = o;
  }
}
function yh(e, t, n, r) {
  if (Tl) {
    var s = Td(e, t, n, r);
    if (s === null) mc(e, t, r, Pl, n), Em(e, r);else if (OC(s, e, t, n, r)) r.stopPropagation();else if (Em(e, r), t & 4 && -1 < MC.indexOf(e)) {
      for (; s !== null;) {
        var o = Ji(s);
        if (o !== null && I0(o), o = Td(e, t, n, r), o === null && mc(e, t, r, Pl, n), o === s) break;
        s = o;
      }
      s !== null && r.stopPropagation();
    } else mc(e, t, r, null, n);
  }
}
var Pl = null;
function Td(e, t, n, r) {
  if (Pl = null, e = hh(r), e = $r(e), e !== null) if (t = ms(e), t === null) e = null;else if (n = t.tag, n === 13) {
    if (e = R0(t), e !== null) return e;
    e = null;
  } else if (n === 3) {
    if (t.stateNode.current.memoizedState.isDehydrated) return t.tag === 3 ? t.stateNode.containerInfo : null;
    e = null;
  } else t !== e && (e = null);
  return Pl = e, null;
}
function z0(e) {
  switch (e) {
    case "cancel":
    case "click":
    case "close":
    case "contextmenu":
    case "copy":
    case "cut":
    case "auxclick":
    case "dblclick":
    case "dragend":
    case "dragstart":
    case "drop":
    case "focusin":
    case "focusout":
    case "input":
    case "invalid":
    case "keydown":
    case "keypress":
    case "keyup":
    case "mousedown":
    case "mouseup":
    case "paste":
    case "pause":
    case "play":
    case "pointercancel":
    case "pointerdown":
    case "pointerup":
    case "ratechange":
    case "reset":
    case "resize":
    case "seeked":
    case "submit":
    case "touchcancel":
    case "touchend":
    case "touchstart":
    case "volumechange":
    case "change":
    case "selectionchange":
    case "textInput":
    case "compositionstart":
    case "compositionend":
    case "compositionupdate":
    case "beforeblur":
    case "afterblur":
    case "beforeinput":
    case "blur":
    case "fullscreenchange":
    case "focus":
    case "hashchange":
    case "popstate":
    case "select":
    case "selectstart":
      return 1;
    case "drag":
    case "dragenter":
    case "dragexit":
    case "dragleave":
    case "dragover":
    case "mousemove":
    case "mouseout":
    case "mouseover":
    case "pointermove":
    case "pointerout":
    case "pointerover":
    case "scroll":
    case "toggle":
    case "touchmove":
    case "wheel":
    case "mouseenter":
    case "mouseleave":
    case "pointerenter":
    case "pointerleave":
      return 4;
    case "message":
      switch (EC()) {
        case ph:
          return 1;
        case M0:
          return 4;
        case El:
        case CC:
          return 16;
        case O0:
          return 536870912;
        default:
          return 16;
      }
    default:
      return 16;
  }
}
var cr = null,
  vh = null,
  Xa = null;
function $0() {
  if (Xa) return Xa;
  var e,
    t = vh,
    n = t.length,
    r,
    s = "value" in cr ? cr.value : cr.textContent,
    o = s.length;
  for (e = 0; e < n && t[e] === s[e]; e++);
  var i = n - e;
  for (r = 1; r <= i && t[n - r] === s[o - r]; r++);
  return Xa = s.slice(e, 1 < r ? 1 - r : void 0);
}
function Za(e) {
  var t = e.keyCode;
  return "charCode" in e ? (e = e.charCode, e === 0 && t === 13 && (e = 13)) : e = t, e === 10 && (e = 13), 32 <= e || e === 13 ? e : 0;
}
function Ea() {
  return !0;
}
function Tm() {
  return !1;
}
function xt(e) {
  function t(n, r, s, o, i) {
    this._reactName = n, this._targetInst = s, this.type = r, this.nativeEvent = o, this.target = i, this.currentTarget = null;
    for (var a in e) e.hasOwnProperty(a) && (n = e[a], this[a] = n ? n(o) : o[a]);
    return this.isDefaultPrevented = (o.defaultPrevented != null ? o.defaultPrevented : o.returnValue === !1) ? Ea : Tm, this.isPropagationStopped = Tm, this;
  }
  return be(t.prototype, {
    preventDefault: function () {
      this.defaultPrevented = !0;
      var n = this.nativeEvent;
      n && (n.preventDefault ? n.preventDefault() : typeof n.returnValue != "unknown" && (n.returnValue = !1), this.isDefaultPrevented = Ea);
    },
    stopPropagation: function () {
      var n = this.nativeEvent;
      n && (n.stopPropagation ? n.stopPropagation() : typeof n.cancelBubble != "unknown" && (n.cancelBubble = !0), this.isPropagationStopped = Ea);
    },
    persist: function () {},
    isPersistent: Ea
  }), t;
}
var Po = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function (e) {
      return e.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
  },
  xh = xt(Po),
  Zi = be({}, Po, {
    view: 0,
    detail: 0
  }),
  FC = xt(Zi),
  ic,
  ac,
  Wo,
  pu = be({}, Zi, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: wh,
    button: 0,
    buttons: 0,
    relatedTarget: function (e) {
      return e.relatedTarget === void 0 ? e.fromElement === e.srcElement ? e.toElement : e.fromElement : e.relatedTarget;
    },
    movementX: function (e) {
      return "movementX" in e ? e.movementX : (e !== Wo && (Wo && e.type === "mousemove" ? (ic = e.screenX - Wo.screenX, ac = e.screenY - Wo.screenY) : ac = ic = 0, Wo = e), ic);
    },
    movementY: function (e) {
      return "movementY" in e ? e.movementY : ac;
    }
  }),
  Pm = xt(pu),
  _C = be({}, pu, {
    dataTransfer: 0
  }),
  VC = xt(_C),
  BC = be({}, Zi, {
    relatedTarget: 0
  }),
  lc = xt(BC),
  zC = be({}, Po, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  }),
  $C = xt(zC),
  UC = be({}, Po, {
    clipboardData: function (e) {
      return "clipboardData" in e ? e.clipboardData : window.clipboardData;
    }
  }),
  WC = xt(UC),
  HC = be({}, Po, {
    data: 0
  }),
  km = xt(HC),
  qC = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  },
  KC = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  },
  QC = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
  };
function GC(e) {
  var t = this.nativeEvent;
  return t.getModifierState ? t.getModifierState(e) : (e = QC[e]) ? !!t[e] : !1;
}
function wh() {
  return GC;
}
var YC = be({}, Zi, {
    key: function (e) {
      if (e.key) {
        var t = qC[e.key] || e.key;
        if (t !== "Unidentified") return t;
      }
      return e.type === "keypress" ? (e = Za(e), e === 13 ? "Enter" : String.fromCharCode(e)) : e.type === "keydown" || e.type === "keyup" ? KC[e.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: wh,
    charCode: function (e) {
      return e.type === "keypress" ? Za(e) : 0;
    },
    keyCode: function (e) {
      return e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
    },
    which: function (e) {
      return e.type === "keypress" ? Za(e) : e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
    }
  }),
  XC = xt(YC),
  ZC = be({}, pu, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
  }),
  Rm = xt(ZC),
  JC = be({}, Zi, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: wh
  }),
  eT = xt(JC),
  tT = be({}, Po, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  }),
  nT = xt(tT),
  rT = be({}, pu, {
    deltaX: function (e) {
      return "deltaX" in e ? e.deltaX : "wheelDeltaX" in e ? -e.wheelDeltaX : 0;
    },
    deltaY: function (e) {
      return "deltaY" in e ? e.deltaY : "wheelDeltaY" in e ? -e.wheelDeltaY : "wheelDelta" in e ? -e.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }),
  sT = xt(rT),
  oT = [9, 13, 27, 32],
  bh = Rn && "CompositionEvent" in window,
  ii = null;
Rn && "documentMode" in document && (ii = document.documentMode);
var iT = Rn && "TextEvent" in window && !ii,
  U0 = Rn && (!bh || ii && 8 < ii && 11 >= ii),
  Nm = " ",
  Am = !1;
function W0(e, t) {
  switch (e) {
    case "keyup":
      return oT.indexOf(t.keyCode) !== -1;
    case "keydown":
      return t.keyCode !== 229;
    case "keypress":
    case "mousedown":
    case "focusout":
      return !0;
    default:
      return !1;
  }
}
function H0(e) {
  return e = e.detail, typeof e == "object" && "data" in e ? e.data : null;
}
var Ns = !1;
function aT(e, t) {
  switch (e) {
    case "compositionend":
      return H0(t);
    case "keypress":
      return t.which !== 32 ? null : (Am = !0, Nm);
    case "textInput":
      return e = t.data, e === Nm && Am ? null : e;
    default:
      return null;
  }
}
function lT(e, t) {
  if (Ns) return e === "compositionend" || !bh && W0(e, t) ? (e = $0(), Xa = vh = cr = null, Ns = !1, e) : null;
  switch (e) {
    case "paste":
      return null;
    case "keypress":
      if (!(t.ctrlKey || t.altKey || t.metaKey) || t.ctrlKey && t.altKey) {
        if (t.char && 1 < t.char.length) return t.char;
        if (t.which) return String.fromCharCode(t.which);
      }
      return null;
    case "compositionend":
      return U0 && t.locale !== "ko" ? null : t.data;
    default:
      return null;
  }
}
var uT = {
  color: !0,
  date: !0,
  datetime: !0,
  "datetime-local": !0,
  email: !0,
  month: !0,
  number: !0,
  password: !0,
  range: !0,
  search: !0,
  tel: !0,
  text: !0,
  time: !0,
  url: !0,
  week: !0
};
function jm(e) {
  var t = e && e.nodeName && e.nodeName.toLowerCase();
  return t === "input" ? !!uT[e.type] : t === "textarea";
}
function q0(e, t, n, r) {
  E0(r), t = kl(t, "onChange"), 0 < t.length && (n = new xh("onChange", "change", null, n, r), e.push({
    event: n,
    listeners: t
  }));
}
var ai = null,
  Ci = null;
function cT(e) {
  rx(e, 0);
}
function mu(e) {
  var t = Ms(e);
  if (g0(t)) return e;
}
function dT(e, t) {
  if (e === "change") return t;
}
var K0 = !1;
if (Rn) {
  var uc;
  if (Rn) {
    var cc = "oninput" in document;
    if (!cc) {
      var Mm = document.createElement("div");
      Mm.setAttribute("oninput", "return;"), cc = typeof Mm.oninput == "function";
    }
    uc = cc;
  } else uc = !1;
  K0 = uc && (!document.documentMode || 9 < document.documentMode);
}
function Om() {
  ai && (ai.detachEvent("onpropertychange", Q0), Ci = ai = null);
}
function Q0(e) {
  if (e.propertyName === "value" && mu(Ci)) {
    var t = [];
    q0(t, Ci, e, hh(e)), k0(cT, t);
  }
}
function fT(e, t, n) {
  e === "focusin" ? (Om(), ai = t, Ci = n, ai.attachEvent("onpropertychange", Q0)) : e === "focusout" && Om();
}
function hT(e) {
  if (e === "selectionchange" || e === "keyup" || e === "keydown") return mu(Ci);
}
function pT(e, t) {
  if (e === "click") return mu(t);
}
function mT(e, t) {
  if (e === "input" || e === "change") return mu(t);
}
function gT(e, t) {
  return e === t && (e !== 0 || 1 / e === 1 / t) || e !== e && t !== t;
}
var Qt = typeof Object.is == "function" ? Object.is : gT;
function Ti(e, t) {
  if (Qt(e, t)) return !0;
  if (typeof e != "object" || e === null || typeof t != "object" || t === null) return !1;
  var n = Object.keys(e),
    r = Object.keys(t);
  if (n.length !== r.length) return !1;
  for (r = 0; r < n.length; r++) {
    var s = n[r];
    if (!ad.call(t, s) || !Qt(e[s], t[s])) return !1;
  }
  return !0;
}
function Lm(e) {
  for (; e && e.firstChild;) e = e.firstChild;
  return e;
}
function Dm(e, t) {
  var n = Lm(e);
  e = 0;
  for (var r; n;) {
    if (n.nodeType === 3) {
      if (r = e + n.textContent.length, e <= t && r >= t) return {
        node: n,
        offset: t - e
      };
      e = r;
    }
    e: {
      for (; n;) {
        if (n.nextSibling) {
          n = n.nextSibling;
          break e;
        }
        n = n.parentNode;
      }
      n = void 0;
    }
    n = Lm(n);
  }
}
function G0(e, t) {
  return e && t ? e === t ? !0 : e && e.nodeType === 3 ? !1 : t && t.nodeType === 3 ? G0(e, t.parentNode) : "contains" in e ? e.contains(t) : e.compareDocumentPosition ? !!(e.compareDocumentPosition(t) & 16) : !1 : !1;
}
function Y0() {
  for (var e = window, t = wl(); t instanceof e.HTMLIFrameElement;) {
    try {
      var n = typeof t.contentWindow.location.href == "string";
    } catch {
      n = !1;
    }
    if (n) e = t.contentWindow;else break;
    t = wl(e.document);
  }
  return t;
}
function Sh(e) {
  var t = e && e.nodeName && e.nodeName.toLowerCase();
  return t && (t === "input" && (e.type === "text" || e.type === "search" || e.type === "tel" || e.type === "url" || e.type === "password") || t === "textarea" || e.contentEditable === "true");
}
function yT(e) {
  var t = Y0(),
    n = e.focusedElem,
    r = e.selectionRange;
  if (t !== n && n && n.ownerDocument && G0(n.ownerDocument.documentElement, n)) {
    if (r !== null && Sh(n)) {
      if (t = r.start, e = r.end, e === void 0 && (e = t), "selectionStart" in n) n.selectionStart = t, n.selectionEnd = Math.min(e, n.value.length);else if (e = (t = n.ownerDocument || document) && t.defaultView || window, e.getSelection) {
        e = e.getSelection();
        var s = n.textContent.length,
          o = Math.min(r.start, s);
        r = r.end === void 0 ? o : Math.min(r.end, s), !e.extend && o > r && (s = r, r = o, o = s), s = Dm(n, o);
        var i = Dm(n, r);
        s && i && (e.rangeCount !== 1 || e.anchorNode !== s.node || e.anchorOffset !== s.offset || e.focusNode !== i.node || e.focusOffset !== i.offset) && (t = t.createRange(), t.setStart(s.node, s.offset), e.removeAllRanges(), o > r ? (e.addRange(t), e.extend(i.node, i.offset)) : (t.setEnd(i.node, i.offset), e.addRange(t)));
      }
    }
    for (t = [], e = n; e = e.parentNode;) e.nodeType === 1 && t.push({
      element: e,
      left: e.scrollLeft,
      top: e.scrollTop
    });
    for (typeof n.focus == "function" && n.focus(), n = 0; n < t.length; n++) e = t[n], e.element.scrollLeft = e.left, e.element.scrollTop = e.top;
  }
}
var vT = Rn && "documentMode" in document && 11 >= document.documentMode,
  As = null,
  Pd = null,
  li = null,
  kd = !1;
function Im(e, t, n) {
  var r = n.window === n ? n.document : n.nodeType === 9 ? n : n.ownerDocument;
  kd || As == null || As !== wl(r) || (r = As, "selectionStart" in r && Sh(r) ? r = {
    start: r.selectionStart,
    end: r.selectionEnd
  } : (r = (r.ownerDocument && r.ownerDocument.defaultView || window).getSelection(), r = {
    anchorNode: r.anchorNode,
    anchorOffset: r.anchorOffset,
    focusNode: r.focusNode,
    focusOffset: r.focusOffset
  }), li && Ti(li, r) || (li = r, r = kl(Pd, "onSelect"), 0 < r.length && (t = new xh("onSelect", "select", null, t, n), e.push({
    event: t,
    listeners: r
  }), t.target = As)));
}
function Ca(e, t) {
  var n = {};
  return n[e.toLowerCase()] = t.toLowerCase(), n["Webkit" + e] = "webkit" + t, n["Moz" + e] = "moz" + t, n;
}
var js = {
    animationend: Ca("Animation", "AnimationEnd"),
    animationiteration: Ca("Animation", "AnimationIteration"),
    animationstart: Ca("Animation", "AnimationStart"),
    transitionend: Ca("Transition", "TransitionEnd")
  },
  dc = {},
  X0 = {};
Rn && (X0 = document.createElement("div").style, "AnimationEvent" in window || (delete js.animationend.animation, delete js.animationiteration.animation, delete js.animationstart.animation), "TransitionEvent" in window || delete js.transitionend.transition);
function gu(e) {
  if (dc[e]) return dc[e];
  if (!js[e]) return e;
  var t = js[e],
    n;
  for (n in t) if (t.hasOwnProperty(n) && n in X0) return dc[e] = t[n];
  return e;
}
var Z0 = gu("animationend"),
  J0 = gu("animationiteration"),
  ex = gu("animationstart"),
  tx = gu("transitionend"),
  nx = new Map(),
  Fm = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function jr(e, t) {
  nx.set(e, t), ps(t, [e]);
}
for (var fc = 0; fc < Fm.length; fc++) {
  var hc = Fm[fc],
    xT = hc.toLowerCase(),
    wT = hc[0].toUpperCase() + hc.slice(1);
  jr(xT, "on" + wT);
}
jr(Z0, "onAnimationEnd");
jr(J0, "onAnimationIteration");
jr(ex, "onAnimationStart");
jr("dblclick", "onDoubleClick");
jr("focusin", "onFocus");
jr("focusout", "onBlur");
jr(tx, "onTransitionEnd");
co("onMouseEnter", ["mouseout", "mouseover"]);
co("onMouseLeave", ["mouseout", "mouseover"]);
co("onPointerEnter", ["pointerout", "pointerover"]);
co("onPointerLeave", ["pointerout", "pointerover"]);
ps("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
ps("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
ps("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]);
ps("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
ps("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
ps("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var ti = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),
  bT = new Set("cancel close invalid load scroll toggle".split(" ").concat(ti));
function _m(e, t, n) {
  var r = e.type || "unknown-event";
  e.currentTarget = n, xC(r, t, void 0, e), e.currentTarget = null;
}
function rx(e, t) {
  t = (t & 4) !== 0;
  for (var n = 0; n < e.length; n++) {
    var r = e[n],
      s = r.event;
    r = r.listeners;
    e: {
      var o = void 0;
      if (t) for (var i = r.length - 1; 0 <= i; i--) {
        var a = r[i],
          l = a.instance,
          u = a.currentTarget;
        if (a = a.listener, l !== o && s.isPropagationStopped()) break e;
        _m(s, a, u), o = l;
      } else for (i = 0; i < r.length; i++) {
        if (a = r[i], l = a.instance, u = a.currentTarget, a = a.listener, l !== o && s.isPropagationStopped()) break e;
        _m(s, a, u), o = l;
      }
    }
  }
  if (Sl) throw e = Sd, Sl = !1, Sd = null, e;
}
function de(e, t) {
  var n = t[Md];
  n === void 0 && (n = t[Md] = new Set());
  var r = e + "__bubble";
  n.has(r) || (sx(t, e, 2, !1), n.add(r));
}
function pc(e, t, n) {
  var r = 0;
  t && (r |= 4), sx(n, e, r, t);
}
var Ta = "_reactListening" + Math.random().toString(36).slice(2);
function Pi(e) {
  if (!e[Ta]) {
    e[Ta] = !0, d0.forEach(function (n) {
      n !== "selectionchange" && (bT.has(n) || pc(n, !1, e), pc(n, !0, e));
    });
    var t = e.nodeType === 9 ? e : e.ownerDocument;
    t === null || t[Ta] || (t[Ta] = !0, pc("selectionchange", !1, t));
  }
}
function sx(e, t, n, r) {
  switch (z0(t)) {
    case 1:
      var s = DC;
      break;
    case 4:
      s = IC;
      break;
    default:
      s = yh;
  }
  n = s.bind(null, t, n, e), s = void 0, !bd || t !== "touchstart" && t !== "touchmove" && t !== "wheel" || (s = !0), r ? s !== void 0 ? e.addEventListener(t, n, {
    capture: !0,
    passive: s
  }) : e.addEventListener(t, n, !0) : s !== void 0 ? e.addEventListener(t, n, {
    passive: s
  }) : e.addEventListener(t, n, !1);
}
function mc(e, t, n, r, s) {
  var o = r;
  if (!(t & 1) && !(t & 2) && r !== null) e: for (;;) {
    if (r === null) return;
    var i = r.tag;
    if (i === 3 || i === 4) {
      var a = r.stateNode.containerInfo;
      if (a === s || a.nodeType === 8 && a.parentNode === s) break;
      if (i === 4) for (i = r.return; i !== null;) {
        var l = i.tag;
        if ((l === 3 || l === 4) && (l = i.stateNode.containerInfo, l === s || l.nodeType === 8 && l.parentNode === s)) return;
        i = i.return;
      }
      for (; a !== null;) {
        if (i = $r(a), i === null) return;
        if (l = i.tag, l === 5 || l === 6) {
          r = o = i;
          continue e;
        }
        a = a.parentNode;
      }
    }
    r = r.return;
  }
  k0(function () {
    var u = o,
      d = hh(n),
      c = [];
    e: {
      var f = nx.get(e);
      if (f !== void 0) {
        var h = xh,
          w = e;
        switch (e) {
          case "keypress":
            if (Za(n) === 0) break e;
          case "keydown":
          case "keyup":
            h = XC;
            break;
          case "focusin":
            w = "focus", h = lc;
            break;
          case "focusout":
            w = "blur", h = lc;
            break;
          case "beforeblur":
          case "afterblur":
            h = lc;
            break;
          case "click":
            if (n.button === 2) break e;
          case "auxclick":
          case "dblclick":
          case "mousedown":
          case "mousemove":
          case "mouseup":
          case "mouseout":
          case "mouseover":
          case "contextmenu":
            h = Pm;
            break;
          case "drag":
          case "dragend":
          case "dragenter":
          case "dragexit":
          case "dragleave":
          case "dragover":
          case "dragstart":
          case "drop":
            h = VC;
            break;
          case "touchcancel":
          case "touchend":
          case "touchmove":
          case "touchstart":
            h = eT;
            break;
          case Z0:
          case J0:
          case ex:
            h = $C;
            break;
          case tx:
            h = nT;
            break;
          case "scroll":
            h = FC;
            break;
          case "wheel":
            h = sT;
            break;
          case "copy":
          case "cut":
          case "paste":
            h = WC;
            break;
          case "gotpointercapture":
          case "lostpointercapture":
          case "pointercancel":
          case "pointerdown":
          case "pointermove":
          case "pointerout":
          case "pointerover":
          case "pointerup":
            h = Rm;
        }
        var m = (t & 4) !== 0,
          x = !m && e === "scroll",
          g = m ? f !== null ? f + "Capture" : null : f;
        m = [];
        for (var v = u, b; v !== null;) {
          b = v;
          var S = b.stateNode;
          if (b.tag === 5 && S !== null && (b = S, g !== null && (S = wi(v, g), S != null && m.push(ki(v, S, b)))), x) break;
          v = v.return;
        }
        0 < m.length && (f = new h(f, w, null, n, d), c.push({
          event: f,
          listeners: m
        }));
      }
    }
    if (!(t & 7)) {
      e: {
        if (f = e === "mouseover" || e === "pointerover", h = e === "mouseout" || e === "pointerout", f && n !== xd && (w = n.relatedTarget || n.fromElement) && ($r(w) || w[Nn])) break e;
        if ((h || f) && (f = d.window === d ? d : (f = d.ownerDocument) ? f.defaultView || f.parentWindow : window, h ? (w = n.relatedTarget || n.toElement, h = u, w = w ? $r(w) : null, w !== null && (x = ms(w), w !== x || w.tag !== 5 && w.tag !== 6) && (w = null)) : (h = null, w = u), h !== w)) {
          if (m = Pm, S = "onMouseLeave", g = "onMouseEnter", v = "mouse", (e === "pointerout" || e === "pointerover") && (m = Rm, S = "onPointerLeave", g = "onPointerEnter", v = "pointer"), x = h == null ? f : Ms(h), b = w == null ? f : Ms(w), f = new m(S, v + "leave", h, n, d), f.target = x, f.relatedTarget = b, S = null, $r(d) === u && (m = new m(g, v + "enter", w, n, d), m.target = b, m.relatedTarget = x, S = m), x = S, h && w) t: {
            for (m = h, g = w, v = 0, b = m; b; b = Ss(b)) v++;
            for (b = 0, S = g; S; S = Ss(S)) b++;
            for (; 0 < v - b;) m = Ss(m), v--;
            for (; 0 < b - v;) g = Ss(g), b--;
            for (; v--;) {
              if (m === g || g !== null && m === g.alternate) break t;
              m = Ss(m), g = Ss(g);
            }
            m = null;
          } else m = null;
          h !== null && Vm(c, f, h, m, !1), w !== null && x !== null && Vm(c, x, w, m, !0);
        }
      }
      e: {
        if (f = u ? Ms(u) : window, h = f.nodeName && f.nodeName.toLowerCase(), h === "select" || h === "input" && f.type === "file") var E = dT;else if (jm(f)) {
          if (K0) E = mT;else {
            E = hT;
            var P = fT;
          }
        } else (h = f.nodeName) && h.toLowerCase() === "input" && (f.type === "checkbox" || f.type === "radio") && (E = pT);
        if (E && (E = E(e, u))) {
          q0(c, E, n, d);
          break e;
        }
        P && P(e, f, u), e === "focusout" && (P = f._wrapperState) && P.controlled && f.type === "number" && pd(f, "number", f.value);
      }
      switch (P = u ? Ms(u) : window, e) {
        case "focusin":
          (jm(P) || P.contentEditable === "true") && (As = P, Pd = u, li = null);
          break;
        case "focusout":
          li = Pd = As = null;
          break;
        case "mousedown":
          kd = !0;
          break;
        case "contextmenu":
        case "mouseup":
        case "dragend":
          kd = !1, Im(c, n, d);
          break;
        case "selectionchange":
          if (vT) break;
        case "keydown":
        case "keyup":
          Im(c, n, d);
      }
      var T;
      if (bh) e: {
        switch (e) {
          case "compositionstart":
            var k = "onCompositionStart";
            break e;
          case "compositionend":
            k = "onCompositionEnd";
            break e;
          case "compositionupdate":
            k = "onCompositionUpdate";
            break e;
        }
        k = void 0;
      } else Ns ? W0(e, n) && (k = "onCompositionEnd") : e === "keydown" && n.keyCode === 229 && (k = "onCompositionStart");
      k && (U0 && n.locale !== "ko" && (Ns || k !== "onCompositionStart" ? k === "onCompositionEnd" && Ns && (T = $0()) : (cr = d, vh = "value" in cr ? cr.value : cr.textContent, Ns = !0)), P = kl(u, k), 0 < P.length && (k = new km(k, e, null, n, d), c.push({
        event: k,
        listeners: P
      }), T ? k.data = T : (T = H0(n), T !== null && (k.data = T)))), (T = iT ? aT(e, n) : lT(e, n)) && (u = kl(u, "onBeforeInput"), 0 < u.length && (d = new km("onBeforeInput", "beforeinput", null, n, d), c.push({
        event: d,
        listeners: u
      }), d.data = T));
    }
    rx(c, t);
  });
}
function ki(e, t, n) {
  return {
    instance: e,
    listener: t,
    currentTarget: n
  };
}
function kl(e, t) {
  for (var n = t + "Capture", r = []; e !== null;) {
    var s = e,
      o = s.stateNode;
    s.tag === 5 && o !== null && (s = o, o = wi(e, n), o != null && r.unshift(ki(e, o, s)), o = wi(e, t), o != null && r.push(ki(e, o, s))), e = e.return;
  }
  return r;
}
function Ss(e) {
  if (e === null) return null;
  do e = e.return; while (e && e.tag !== 5);
  return e || null;
}
function Vm(e, t, n, r, s) {
  for (var o = t._reactName, i = []; n !== null && n !== r;) {
    var a = n,
      l = a.alternate,
      u = a.stateNode;
    if (l !== null && l === r) break;
    a.tag === 5 && u !== null && (a = u, s ? (l = wi(n, o), l != null && i.unshift(ki(n, l, a))) : s || (l = wi(n, o), l != null && i.push(ki(n, l, a)))), n = n.return;
  }
  i.length !== 0 && e.push({
    event: t,
    listeners: i
  });
}
var ST = /\r\n?/g,
  ET = /\u0000|\uFFFD/g;
function Bm(e) {
  return (typeof e == "string" ? e : "" + e).replace(ST, `
`).replace(ET, "");
}
function Pa(e, t, n) {
  if (t = Bm(t), Bm(e) !== t && n) throw Error(M(425));
}
function Rl() {}
var Rd = null,
  Nd = null;
function Ad(e, t) {
  return e === "textarea" || e === "noscript" || typeof t.children == "string" || typeof t.children == "number" || typeof t.dangerouslySetInnerHTML == "object" && t.dangerouslySetInnerHTML !== null && t.dangerouslySetInnerHTML.__html != null;
}
var jd = typeof setTimeout == "function" ? setTimeout : void 0,
  CT = typeof clearTimeout == "function" ? clearTimeout : void 0,
  zm = typeof Promise == "function" ? Promise : void 0,
  TT = typeof queueMicrotask == "function" ? queueMicrotask : typeof zm < "u" ? function (e) {
    return zm.resolve(null).then(e).catch(PT);
  } : jd;
function PT(e) {
  setTimeout(function () {
    throw e;
  });
}
function gc(e, t) {
  var n = t,
    r = 0;
  do {
    var s = n.nextSibling;
    if (e.removeChild(n), s && s.nodeType === 8) if (n = s.data, n === "/$") {
      if (r === 0) {
        e.removeChild(s), Ei(t);
        return;
      }
      r--;
    } else n !== "$" && n !== "$?" && n !== "$!" || r++;
    n = s;
  } while (n);
  Ei(t);
}
function yr(e) {
  for (; e != null; e = e.nextSibling) {
    var t = e.nodeType;
    if (t === 1 || t === 3) break;
    if (t === 8) {
      if (t = e.data, t === "$" || t === "$!" || t === "$?") break;
      if (t === "/$") return null;
    }
  }
  return e;
}
function $m(e) {
  e = e.previousSibling;
  for (var t = 0; e;) {
    if (e.nodeType === 8) {
      var n = e.data;
      if (n === "$" || n === "$!" || n === "$?") {
        if (t === 0) return e;
        t--;
      } else n === "/$" && t++;
    }
    e = e.previousSibling;
  }
  return null;
}
var ko = Math.random().toString(36).slice(2),
  an = "__reactFiber$" + ko,
  Ri = "__reactProps$" + ko,
  Nn = "__reactContainer$" + ko,
  Md = "__reactEvents$" + ko,
  kT = "__reactListeners$" + ko,
  RT = "__reactHandles$" + ko;
function $r(e) {
  var t = e[an];
  if (t) return t;
  for (var n = e.parentNode; n;) {
    if (t = n[Nn] || n[an]) {
      if (n = t.alternate, t.child !== null || n !== null && n.child !== null) for (e = $m(e); e !== null;) {
        if (n = e[an]) return n;
        e = $m(e);
      }
      return t;
    }
    e = n, n = e.parentNode;
  }
  return null;
}
function Ji(e) {
  return e = e[an] || e[Nn], !e || e.tag !== 5 && e.tag !== 6 && e.tag !== 13 && e.tag !== 3 ? null : e;
}
function Ms(e) {
  if (e.tag === 5 || e.tag === 6) return e.stateNode;
  throw Error(M(33));
}
function yu(e) {
  return e[Ri] || null;
}
var Od = [],
  Os = -1;
function Mr(e) {
  return {
    current: e
  };
}
function fe(e) {
  0 > Os || (e.current = Od[Os], Od[Os] = null, Os--);
}
function ue(e, t) {
  Os++, Od[Os] = e.current, e.current = t;
}
var Tr = {},
  Ke = Mr(Tr),
  lt = Mr(!1),
  is = Tr;
function fo(e, t) {
  var n = e.type.contextTypes;
  if (!n) return Tr;
  var r = e.stateNode;
  if (r && r.__reactInternalMemoizedUnmaskedChildContext === t) return r.__reactInternalMemoizedMaskedChildContext;
  var s = {},
    o;
  for (o in n) s[o] = t[o];
  return r && (e = e.stateNode, e.__reactInternalMemoizedUnmaskedChildContext = t, e.__reactInternalMemoizedMaskedChildContext = s), s;
}
function ut(e) {
  return e = e.childContextTypes, e != null;
}
function Nl() {
  fe(lt), fe(Ke);
}
function Um(e, t, n) {
  if (Ke.current !== Tr) throw Error(M(168));
  ue(Ke, t), ue(lt, n);
}
function ox(e, t, n) {
  var r = e.stateNode;
  if (t = t.childContextTypes, typeof r.getChildContext != "function") return n;
  r = r.getChildContext();
  for (var s in r) if (!(s in t)) throw Error(M(108, fC(e) || "Unknown", s));
  return be({}, n, r);
}
function Al(e) {
  return e = (e = e.stateNode) && e.__reactInternalMemoizedMergedChildContext || Tr, is = Ke.current, ue(Ke, e), ue(lt, lt.current), !0;
}
function Wm(e, t, n) {
  var r = e.stateNode;
  if (!r) throw Error(M(169));
  n ? (e = ox(e, t, is), r.__reactInternalMemoizedMergedChildContext = e, fe(lt), fe(Ke), ue(Ke, e)) : fe(lt), ue(lt, n);
}
var Sn = null,
  vu = !1,
  yc = !1;
function ix(e) {
  Sn === null ? Sn = [e] : Sn.push(e);
}
function NT(e) {
  vu = !0, ix(e);
}
function Or() {
  if (!yc && Sn !== null) {
    yc = !0;
    var e = 0,
      t = oe;
    try {
      var n = Sn;
      for (oe = 1; e < n.length; e++) {
        var r = n[e];
        do r = r(!0); while (r !== null);
      }
      Sn = null, vu = !1;
    } catch (s) {
      throw Sn !== null && (Sn = Sn.slice(e + 1)), j0(ph, Or), s;
    } finally {
      oe = t, yc = !1;
    }
  }
  return null;
}
var Ls = [],
  Ds = 0,
  jl = null,
  Ml = 0,
  Ct = [],
  Tt = 0,
  as = null,
  Cn = 1,
  Tn = "";
function Vr(e, t) {
  Ls[Ds++] = Ml, Ls[Ds++] = jl, jl = e, Ml = t;
}
function ax(e, t, n) {
  Ct[Tt++] = Cn, Ct[Tt++] = Tn, Ct[Tt++] = as, as = e;
  var r = Cn;
  e = Tn;
  var s = 32 - Ht(r) - 1;
  r &= ~(1 << s), n += 1;
  var o = 32 - Ht(t) + s;
  if (30 < o) {
    var i = s - s % 5;
    o = (r & (1 << i) - 1).toString(32), r >>= i, s -= i, Cn = 1 << 32 - Ht(t) + s | n << s | r, Tn = o + e;
  } else Cn = 1 << o | n << s | r, Tn = e;
}
function Eh(e) {
  e.return !== null && (Vr(e, 1), ax(e, 1, 0));
}
function Ch(e) {
  for (; e === jl;) jl = Ls[--Ds], Ls[Ds] = null, Ml = Ls[--Ds], Ls[Ds] = null;
  for (; e === as;) as = Ct[--Tt], Ct[Tt] = null, Tn = Ct[--Tt], Ct[Tt] = null, Cn = Ct[--Tt], Ct[Tt] = null;
}
var mt = null,
  pt = null,
  me = !1,
  Wt = null;
function lx(e, t) {
  var n = kt(5, null, null, 0);
  n.elementType = "DELETED", n.stateNode = t, n.return = e, t = e.deletions, t === null ? (e.deletions = [n], e.flags |= 16) : t.push(n);
}
function Hm(e, t) {
  switch (e.tag) {
    case 5:
      var n = e.type;
      return t = t.nodeType !== 1 || n.toLowerCase() !== t.nodeName.toLowerCase() ? null : t, t !== null ? (e.stateNode = t, mt = e, pt = yr(t.firstChild), !0) : !1;
    case 6:
      return t = e.pendingProps === "" || t.nodeType !== 3 ? null : t, t !== null ? (e.stateNode = t, mt = e, pt = null, !0) : !1;
    case 13:
      return t = t.nodeType !== 8 ? null : t, t !== null ? (n = as !== null ? {
        id: Cn,
        overflow: Tn
      } : null, e.memoizedState = {
        dehydrated: t,
        treeContext: n,
        retryLane: 1073741824
      }, n = kt(18, null, null, 0), n.stateNode = t, n.return = e, e.child = n, mt = e, pt = null, !0) : !1;
    default:
      return !1;
  }
}
function Ld(e) {
  return (e.mode & 1) !== 0 && (e.flags & 128) === 0;
}
function Dd(e) {
  if (me) {
    var t = pt;
    if (t) {
      var n = t;
      if (!Hm(e, t)) {
        if (Ld(e)) throw Error(M(418));
        t = yr(n.nextSibling);
        var r = mt;
        t && Hm(e, t) ? lx(r, n) : (e.flags = e.flags & -4097 | 2, me = !1, mt = e);
      }
    } else {
      if (Ld(e)) throw Error(M(418));
      e.flags = e.flags & -4097 | 2, me = !1, mt = e;
    }
  }
}
function qm(e) {
  for (e = e.return; e !== null && e.tag !== 5 && e.tag !== 3 && e.tag !== 13;) e = e.return;
  mt = e;
}
function ka(e) {
  if (e !== mt) return !1;
  if (!me) return qm(e), me = !0, !1;
  var t;
  if ((t = e.tag !== 3) && !(t = e.tag !== 5) && (t = e.type, t = t !== "head" && t !== "body" && !Ad(e.type, e.memoizedProps)), t && (t = pt)) {
    if (Ld(e)) throw ux(), Error(M(418));
    for (; t;) lx(e, t), t = yr(t.nextSibling);
  }
  if (qm(e), e.tag === 13) {
    if (e = e.memoizedState, e = e !== null ? e.dehydrated : null, !e) throw Error(M(317));
    e: {
      for (e = e.nextSibling, t = 0; e;) {
        if (e.nodeType === 8) {
          var n = e.data;
          if (n === "/$") {
            if (t === 0) {
              pt = yr(e.nextSibling);
              break e;
            }
            t--;
          } else n !== "$" && n !== "$!" && n !== "$?" || t++;
        }
        e = e.nextSibling;
      }
      pt = null;
    }
  } else pt = mt ? yr(e.stateNode.nextSibling) : null;
  return !0;
}
function ux() {
  for (var e = pt; e;) e = yr(e.nextSibling);
}
function ho() {
  pt = mt = null, me = !1;
}
function Th(e) {
  Wt === null ? Wt = [e] : Wt.push(e);
}
var AT = Dn.ReactCurrentBatchConfig;
function Ho(e, t, n) {
  if (e = n.ref, e !== null && typeof e != "function" && typeof e != "object") {
    if (n._owner) {
      if (n = n._owner, n) {
        if (n.tag !== 1) throw Error(M(309));
        var r = n.stateNode;
      }
      if (!r) throw Error(M(147, e));
      var s = r,
        o = "" + e;
      return t !== null && t.ref !== null && typeof t.ref == "function" && t.ref._stringRef === o ? t.ref : (t = function (i) {
        var a = s.refs;
        i === null ? delete a[o] : a[o] = i;
      }, t._stringRef = o, t);
    }
    if (typeof e != "string") throw Error(M(284));
    if (!n._owner) throw Error(M(290, e));
  }
  return e;
}
function Ra(e, t) {
  throw e = Object.prototype.toString.call(t), Error(M(31, e === "[object Object]" ? "object with keys {" + Object.keys(t).join(", ") + "}" : e));
}
function Km(e) {
  var t = e._init;
  return t(e._payload);
}
function cx(e) {
  function t(g, v) {
    if (e) {
      var b = g.deletions;
      b === null ? (g.deletions = [v], g.flags |= 16) : b.push(v);
    }
  }
  function n(g, v) {
    if (!e) return null;
    for (; v !== null;) t(g, v), v = v.sibling;
    return null;
  }
  function r(g, v) {
    for (g = new Map(); v !== null;) v.key !== null ? g.set(v.key, v) : g.set(v.index, v), v = v.sibling;
    return g;
  }
  function s(g, v) {
    return g = br(g, v), g.index = 0, g.sibling = null, g;
  }
  function o(g, v, b) {
    return g.index = b, e ? (b = g.alternate, b !== null ? (b = b.index, b < v ? (g.flags |= 2, v) : b) : (g.flags |= 2, v)) : (g.flags |= 1048576, v);
  }
  function i(g) {
    return e && g.alternate === null && (g.flags |= 2), g;
  }
  function a(g, v, b, S) {
    return v === null || v.tag !== 6 ? (v = Cc(b, g.mode, S), v.return = g, v) : (v = s(v, b), v.return = g, v);
  }
  function l(g, v, b, S) {
    var E = b.type;
    return E === Rs ? d(g, v, b.props.children, S, b.key) : v !== null && (v.elementType === E || typeof E == "object" && E !== null && E.$$typeof === Zn && Km(E) === v.type) ? (S = s(v, b.props), S.ref = Ho(g, v, b), S.return = g, S) : (S = ol(b.type, b.key, b.props, null, g.mode, S), S.ref = Ho(g, v, b), S.return = g, S);
  }
  function u(g, v, b, S) {
    return v === null || v.tag !== 4 || v.stateNode.containerInfo !== b.containerInfo || v.stateNode.implementation !== b.implementation ? (v = Tc(b, g.mode, S), v.return = g, v) : (v = s(v, b.children || []), v.return = g, v);
  }
  function d(g, v, b, S, E) {
    return v === null || v.tag !== 7 ? (v = rs(b, g.mode, S, E), v.return = g, v) : (v = s(v, b), v.return = g, v);
  }
  function c(g, v, b) {
    if (typeof v == "string" && v !== "" || typeof v == "number") return v = Cc("" + v, g.mode, b), v.return = g, v;
    if (typeof v == "object" && v !== null) {
      switch (v.$$typeof) {
        case ya:
          return b = ol(v.type, v.key, v.props, null, g.mode, b), b.ref = Ho(g, null, v), b.return = g, b;
        case ks:
          return v = Tc(v, g.mode, b), v.return = g, v;
        case Zn:
          var S = v._init;
          return c(g, S(v._payload), b);
      }
      if (Jo(v) || Bo(v)) return v = rs(v, g.mode, b, null), v.return = g, v;
      Ra(g, v);
    }
    return null;
  }
  function f(g, v, b, S) {
    var E = v !== null ? v.key : null;
    if (typeof b == "string" && b !== "" || typeof b == "number") return E !== null ? null : a(g, v, "" + b, S);
    if (typeof b == "object" && b !== null) {
      switch (b.$$typeof) {
        case ya:
          return b.key === E ? l(g, v, b, S) : null;
        case ks:
          return b.key === E ? u(g, v, b, S) : null;
        case Zn:
          return E = b._init, f(g, v, E(b._payload), S);
      }
      if (Jo(b) || Bo(b)) return E !== null ? null : d(g, v, b, S, null);
      Ra(g, b);
    }
    return null;
  }
  function h(g, v, b, S, E) {
    if (typeof S == "string" && S !== "" || typeof S == "number") return g = g.get(b) || null, a(v, g, "" + S, E);
    if (typeof S == "object" && S !== null) {
      switch (S.$$typeof) {
        case ya:
          return g = g.get(S.key === null ? b : S.key) || null, l(v, g, S, E);
        case ks:
          return g = g.get(S.key === null ? b : S.key) || null, u(v, g, S, E);
        case Zn:
          var P = S._init;
          return h(g, v, b, P(S._payload), E);
      }
      if (Jo(S) || Bo(S)) return g = g.get(b) || null, d(v, g, S, E, null);
      Ra(v, S);
    }
    return null;
  }
  function w(g, v, b, S) {
    for (var E = null, P = null, T = v, k = v = 0, A = null; T !== null && k < b.length; k++) {
      T.index > k ? (A = T, T = null) : A = T.sibling;
      var R = f(g, T, b[k], S);
      if (R === null) {
        T === null && (T = A);
        break;
      }
      e && T && R.alternate === null && t(g, T), v = o(R, v, k), P === null ? E = R : P.sibling = R, P = R, T = A;
    }
    if (k === b.length) return n(g, T), me && Vr(g, k), E;
    if (T === null) {
      for (; k < b.length; k++) T = c(g, b[k], S), T !== null && (v = o(T, v, k), P === null ? E = T : P.sibling = T, P = T);
      return me && Vr(g, k), E;
    }
    for (T = r(g, T); k < b.length; k++) A = h(T, g, k, b[k], S), A !== null && (e && A.alternate !== null && T.delete(A.key === null ? k : A.key), v = o(A, v, k), P === null ? E = A : P.sibling = A, P = A);
    return e && T.forEach(function (I) {
      return t(g, I);
    }), me && Vr(g, k), E;
  }
  function m(g, v, b, S) {
    var E = Bo(b);
    if (typeof E != "function") throw Error(M(150));
    if (b = E.call(b), b == null) throw Error(M(151));
    for (var P = E = null, T = v, k = v = 0, A = null, R = b.next(); T !== null && !R.done; k++, R = b.next()) {
      T.index > k ? (A = T, T = null) : A = T.sibling;
      var I = f(g, T, R.value, S);
      if (I === null) {
        T === null && (T = A);
        break;
      }
      e && T && I.alternate === null && t(g, T), v = o(I, v, k), P === null ? E = I : P.sibling = I, P = I, T = A;
    }
    if (R.done) return n(g, T), me && Vr(g, k), E;
    if (T === null) {
      for (; !R.done; k++, R = b.next()) R = c(g, R.value, S), R !== null && (v = o(R, v, k), P === null ? E = R : P.sibling = R, P = R);
      return me && Vr(g, k), E;
    }
    for (T = r(g, T); !R.done; k++, R = b.next()) R = h(T, g, k, R.value, S), R !== null && (e && R.alternate !== null && T.delete(R.key === null ? k : R.key), v = o(R, v, k), P === null ? E = R : P.sibling = R, P = R);
    return e && T.forEach(function (O) {
      return t(g, O);
    }), me && Vr(g, k), E;
  }
  function x(g, v, b, S) {
    if (typeof b == "object" && b !== null && b.type === Rs && b.key === null && (b = b.props.children), typeof b == "object" && b !== null) {
      switch (b.$$typeof) {
        case ya:
          e: {
            for (var E = b.key, P = v; P !== null;) {
              if (P.key === E) {
                if (E = b.type, E === Rs) {
                  if (P.tag === 7) {
                    n(g, P.sibling), v = s(P, b.props.children), v.return = g, g = v;
                    break e;
                  }
                } else if (P.elementType === E || typeof E == "object" && E !== null && E.$$typeof === Zn && Km(E) === P.type) {
                  n(g, P.sibling), v = s(P, b.props), v.ref = Ho(g, P, b), v.return = g, g = v;
                  break e;
                }
                n(g, P);
                break;
              } else t(g, P);
              P = P.sibling;
            }
            b.type === Rs ? (v = rs(b.props.children, g.mode, S, b.key), v.return = g, g = v) : (S = ol(b.type, b.key, b.props, null, g.mode, S), S.ref = Ho(g, v, b), S.return = g, g = S);
          }
          return i(g);
        case ks:
          e: {
            for (P = b.key; v !== null;) {
              if (v.key === P) {
                if (v.tag === 4 && v.stateNode.containerInfo === b.containerInfo && v.stateNode.implementation === b.implementation) {
                  n(g, v.sibling), v = s(v, b.children || []), v.return = g, g = v;
                  break e;
                } else {
                  n(g, v);
                  break;
                }
              } else t(g, v);
              v = v.sibling;
            }
            v = Tc(b, g.mode, S), v.return = g, g = v;
          }
          return i(g);
        case Zn:
          return P = b._init, x(g, v, P(b._payload), S);
      }
      if (Jo(b)) return w(g, v, b, S);
      if (Bo(b)) return m(g, v, b, S);
      Ra(g, b);
    }
    return typeof b == "string" && b !== "" || typeof b == "number" ? (b = "" + b, v !== null && v.tag === 6 ? (n(g, v.sibling), v = s(v, b), v.return = g, g = v) : (n(g, v), v = Cc(b, g.mode, S), v.return = g, g = v), i(g)) : n(g, v);
  }
  return x;
}
var po = cx(!0),
  dx = cx(!1),
  Ol = Mr(null),
  Ll = null,
  Is = null,
  Ph = null;
function kh() {
  Ph = Is = Ll = null;
}
function Rh(e) {
  var t = Ol.current;
  fe(Ol), e._currentValue = t;
}
function Id(e, t, n) {
  for (; e !== null;) {
    var r = e.alternate;
    if ((e.childLanes & t) !== t ? (e.childLanes |= t, r !== null && (r.childLanes |= t)) : r !== null && (r.childLanes & t) !== t && (r.childLanes |= t), e === n) break;
    e = e.return;
  }
}
function qs(e, t) {
  Ll = e, Ph = Is = null, e = e.dependencies, e !== null && e.firstContext !== null && (e.lanes & t && (at = !0), e.firstContext = null);
}
function jt(e) {
  var t = e._currentValue;
  if (Ph !== e) if (e = {
    context: e,
    memoizedValue: t,
    next: null
  }, Is === null) {
    if (Ll === null) throw Error(M(308));
    Is = e, Ll.dependencies = {
      lanes: 0,
      firstContext: e
    };
  } else Is = Is.next = e;
  return t;
}
var Ur = null;
function Nh(e) {
  Ur === null ? Ur = [e] : Ur.push(e);
}
function fx(e, t, n, r) {
  var s = t.interleaved;
  return s === null ? (n.next = n, Nh(t)) : (n.next = s.next, s.next = n), t.interleaved = n, An(e, r);
}
function An(e, t) {
  e.lanes |= t;
  var n = e.alternate;
  for (n !== null && (n.lanes |= t), n = e, e = e.return; e !== null;) e.childLanes |= t, n = e.alternate, n !== null && (n.childLanes |= t), n = e, e = e.return;
  return n.tag === 3 ? n.stateNode : null;
}
var Jn = !1;
function Ah(e) {
  e.updateQueue = {
    baseState: e.memoizedState,
    firstBaseUpdate: null,
    lastBaseUpdate: null,
    shared: {
      pending: null,
      interleaved: null,
      lanes: 0
    },
    effects: null
  };
}
function hx(e, t) {
  e = e.updateQueue, t.updateQueue === e && (t.updateQueue = {
    baseState: e.baseState,
    firstBaseUpdate: e.firstBaseUpdate,
    lastBaseUpdate: e.lastBaseUpdate,
    shared: e.shared,
    effects: e.effects
  });
}
function kn(e, t) {
  return {
    eventTime: e,
    lane: t,
    tag: 0,
    payload: null,
    callback: null,
    next: null
  };
}
function vr(e, t, n) {
  var r = e.updateQueue;
  if (r === null) return null;
  if (r = r.shared, ne & 2) {
    var s = r.pending;
    return s === null ? t.next = t : (t.next = s.next, s.next = t), r.pending = t, An(e, n);
  }
  return s = r.interleaved, s === null ? (t.next = t, Nh(r)) : (t.next = s.next, s.next = t), r.interleaved = t, An(e, n);
}
function Ja(e, t, n) {
  if (t = t.updateQueue, t !== null && (t = t.shared, (n & 4194240) !== 0)) {
    var r = t.lanes;
    r &= e.pendingLanes, n |= r, t.lanes = n, mh(e, n);
  }
}
function Qm(e, t) {
  var n = e.updateQueue,
    r = e.alternate;
  if (r !== null && (r = r.updateQueue, n === r)) {
    var s = null,
      o = null;
    if (n = n.firstBaseUpdate, n !== null) {
      do {
        var i = {
          eventTime: n.eventTime,
          lane: n.lane,
          tag: n.tag,
          payload: n.payload,
          callback: n.callback,
          next: null
        };
        o === null ? s = o = i : o = o.next = i, n = n.next;
      } while (n !== null);
      o === null ? s = o = t : o = o.next = t;
    } else s = o = t;
    n = {
      baseState: r.baseState,
      firstBaseUpdate: s,
      lastBaseUpdate: o,
      shared: r.shared,
      effects: r.effects
    }, e.updateQueue = n;
    return;
  }
  e = n.lastBaseUpdate, e === null ? n.firstBaseUpdate = t : e.next = t, n.lastBaseUpdate = t;
}
function Dl(e, t, n, r) {
  var s = e.updateQueue;
  Jn = !1;
  var o = s.firstBaseUpdate,
    i = s.lastBaseUpdate,
    a = s.shared.pending;
  if (a !== null) {
    s.shared.pending = null;
    var l = a,
      u = l.next;
    l.next = null, i === null ? o = u : i.next = u, i = l;
    var d = e.alternate;
    d !== null && (d = d.updateQueue, a = d.lastBaseUpdate, a !== i && (a === null ? d.firstBaseUpdate = u : a.next = u, d.lastBaseUpdate = l));
  }
  if (o !== null) {
    var c = s.baseState;
    i = 0, d = u = l = null, a = o;
    do {
      var f = a.lane,
        h = a.eventTime;
      if ((r & f) === f) {
        d !== null && (d = d.next = {
          eventTime: h,
          lane: 0,
          tag: a.tag,
          payload: a.payload,
          callback: a.callback,
          next: null
        });
        e: {
          var w = e,
            m = a;
          switch (f = t, h = n, m.tag) {
            case 1:
              if (w = m.payload, typeof w == "function") {
                c = w.call(h, c, f);
                break e;
              }
              c = w;
              break e;
            case 3:
              w.flags = w.flags & -65537 | 128;
            case 0:
              if (w = m.payload, f = typeof w == "function" ? w.call(h, c, f) : w, f == null) break e;
              c = be({}, c, f);
              break e;
            case 2:
              Jn = !0;
          }
        }
        a.callback !== null && a.lane !== 0 && (e.flags |= 64, f = s.effects, f === null ? s.effects = [a] : f.push(a));
      } else h = {
        eventTime: h,
        lane: f,
        tag: a.tag,
        payload: a.payload,
        callback: a.callback,
        next: null
      }, d === null ? (u = d = h, l = c) : d = d.next = h, i |= f;
      if (a = a.next, a === null) {
        if (a = s.shared.pending, a === null) break;
        f = a, a = f.next, f.next = null, s.lastBaseUpdate = f, s.shared.pending = null;
      }
    } while (!0);
    if (d === null && (l = c), s.baseState = l, s.firstBaseUpdate = u, s.lastBaseUpdate = d, t = s.shared.interleaved, t !== null) {
      s = t;
      do i |= s.lane, s = s.next; while (s !== t);
    } else o === null && (s.shared.lanes = 0);
    us |= i, e.lanes = i, e.memoizedState = c;
  }
}
function Gm(e, t, n) {
  if (e = t.effects, t.effects = null, e !== null) for (t = 0; t < e.length; t++) {
    var r = e[t],
      s = r.callback;
    if (s !== null) {
      if (r.callback = null, r = n, typeof s != "function") throw Error(M(191, s));
      s.call(r);
    }
  }
}
var ea = {},
  dn = Mr(ea),
  Ni = Mr(ea),
  Ai = Mr(ea);
function Wr(e) {
  if (e === ea) throw Error(M(174));
  return e;
}
function jh(e, t) {
  switch (ue(Ai, t), ue(Ni, e), ue(dn, ea), e = t.nodeType, e) {
    case 9:
    case 11:
      t = (t = t.documentElement) ? t.namespaceURI : gd(null, "");
      break;
    default:
      e = e === 8 ? t.parentNode : t, t = e.namespaceURI || null, e = e.tagName, t = gd(t, e);
  }
  fe(dn), ue(dn, t);
}
function mo() {
  fe(dn), fe(Ni), fe(Ai);
}
function px(e) {
  Wr(Ai.current);
  var t = Wr(dn.current),
    n = gd(t, e.type);
  t !== n && (ue(Ni, e), ue(dn, n));
}
function Mh(e) {
  Ni.current === e && (fe(dn), fe(Ni));
}
var ve = Mr(0);
function Il(e) {
  for (var t = e; t !== null;) {
    if (t.tag === 13) {
      var n = t.memoizedState;
      if (n !== null && (n = n.dehydrated, n === null || n.data === "$?" || n.data === "$!")) return t;
    } else if (t.tag === 19 && t.memoizedProps.revealOrder !== void 0) {
      if (t.flags & 128) return t;
    } else if (t.child !== null) {
      t.child.return = t, t = t.child;
      continue;
    }
    if (t === e) break;
    for (; t.sibling === null;) {
      if (t.return === null || t.return === e) return null;
      t = t.return;
    }
    t.sibling.return = t.return, t = t.sibling;
  }
  return null;
}
var vc = [];
function Oh() {
  for (var e = 0; e < vc.length; e++) vc[e]._workInProgressVersionPrimary = null;
  vc.length = 0;
}
var el = Dn.ReactCurrentDispatcher,
  xc = Dn.ReactCurrentBatchConfig,
  ls = 0,
  xe = null,
  Ae = null,
  Oe = null,
  Fl = !1,
  ui = !1,
  ji = 0,
  jT = 0;
function Ue() {
  throw Error(M(321));
}
function Lh(e, t) {
  if (t === null) return !1;
  for (var n = 0; n < t.length && n < e.length; n++) if (!Qt(e[n], t[n])) return !1;
  return !0;
}
function Dh(e, t, n, r, s, o) {
  if (ls = o, xe = t, t.memoizedState = null, t.updateQueue = null, t.lanes = 0, el.current = e === null || e.memoizedState === null ? DT : IT, e = n(r, s), ui) {
    o = 0;
    do {
      if (ui = !1, ji = 0, 25 <= o) throw Error(M(301));
      o += 1, Oe = Ae = null, t.updateQueue = null, el.current = FT, e = n(r, s);
    } while (ui);
  }
  if (el.current = _l, t = Ae !== null && Ae.next !== null, ls = 0, Oe = Ae = xe = null, Fl = !1, t) throw Error(M(300));
  return e;
}
function Ih() {
  var e = ji !== 0;
  return ji = 0, e;
}
function en() {
  var e = {
    memoizedState: null,
    baseState: null,
    baseQueue: null,
    queue: null,
    next: null
  };
  return Oe === null ? xe.memoizedState = Oe = e : Oe = Oe.next = e, Oe;
}
function Mt() {
  if (Ae === null) {
    var e = xe.alternate;
    e = e !== null ? e.memoizedState : null;
  } else e = Ae.next;
  var t = Oe === null ? xe.memoizedState : Oe.next;
  if (t !== null) Oe = t, Ae = e;else {
    if (e === null) throw Error(M(310));
    Ae = e, e = {
      memoizedState: Ae.memoizedState,
      baseState: Ae.baseState,
      baseQueue: Ae.baseQueue,
      queue: Ae.queue,
      next: null
    }, Oe === null ? xe.memoizedState = Oe = e : Oe = Oe.next = e;
  }
  return Oe;
}
function Mi(e, t) {
  return typeof t == "function" ? t(e) : t;
}
function wc(e) {
  var t = Mt(),
    n = t.queue;
  if (n === null) throw Error(M(311));
  n.lastRenderedReducer = e;
  var r = Ae,
    s = r.baseQueue,
    o = n.pending;
  if (o !== null) {
    if (s !== null) {
      var i = s.next;
      s.next = o.next, o.next = i;
    }
    r.baseQueue = s = o, n.pending = null;
  }
  if (s !== null) {
    o = s.next, r = r.baseState;
    var a = i = null,
      l = null,
      u = o;
    do {
      var d = u.lane;
      if ((ls & d) === d) l !== null && (l = l.next = {
        lane: 0,
        action: u.action,
        hasEagerState: u.hasEagerState,
        eagerState: u.eagerState,
        next: null
      }), r = u.hasEagerState ? u.eagerState : e(r, u.action);else {
        var c = {
          lane: d,
          action: u.action,
          hasEagerState: u.hasEagerState,
          eagerState: u.eagerState,
          next: null
        };
        l === null ? (a = l = c, i = r) : l = l.next = c, xe.lanes |= d, us |= d;
      }
      u = u.next;
    } while (u !== null && u !== o);
    l === null ? i = r : l.next = a, Qt(r, t.memoizedState) || (at = !0), t.memoizedState = r, t.baseState = i, t.baseQueue = l, n.lastRenderedState = r;
  }
  if (e = n.interleaved, e !== null) {
    s = e;
    do o = s.lane, xe.lanes |= o, us |= o, s = s.next; while (s !== e);
  } else s === null && (n.lanes = 0);
  return [t.memoizedState, n.dispatch];
}
function bc(e) {
  var t = Mt(),
    n = t.queue;
  if (n === null) throw Error(M(311));
  n.lastRenderedReducer = e;
  var r = n.dispatch,
    s = n.pending,
    o = t.memoizedState;
  if (s !== null) {
    n.pending = null;
    var i = s = s.next;
    do o = e(o, i.action), i = i.next; while (i !== s);
    Qt(o, t.memoizedState) || (at = !0), t.memoizedState = o, t.baseQueue === null && (t.baseState = o), n.lastRenderedState = o;
  }
  return [o, r];
}
function mx() {}
function gx(e, t) {
  var n = xe,
    r = Mt(),
    s = t(),
    o = !Qt(r.memoizedState, s);
  if (o && (r.memoizedState = s, at = !0), r = r.queue, Fh(xx.bind(null, n, r, e), [e]), r.getSnapshot !== t || o || Oe !== null && Oe.memoizedState.tag & 1) {
    if (n.flags |= 2048, Oi(9, vx.bind(null, n, r, s, t), void 0, null), De === null) throw Error(M(349));
    ls & 30 || yx(n, t, s);
  }
  return s;
}
function yx(e, t, n) {
  e.flags |= 16384, e = {
    getSnapshot: t,
    value: n
  }, t = xe.updateQueue, t === null ? (t = {
    lastEffect: null,
    stores: null
  }, xe.updateQueue = t, t.stores = [e]) : (n = t.stores, n === null ? t.stores = [e] : n.push(e));
}
function vx(e, t, n, r) {
  t.value = n, t.getSnapshot = r, wx(t) && bx(e);
}
function xx(e, t, n) {
  return n(function () {
    wx(t) && bx(e);
  });
}
function wx(e) {
  var t = e.getSnapshot;
  e = e.value;
  try {
    var n = t();
    return !Qt(e, n);
  } catch {
    return !0;
  }
}
function bx(e) {
  var t = An(e, 1);
  t !== null && qt(t, e, 1, -1);
}
function Ym(e) {
  var t = en();
  return typeof e == "function" && (e = e()), t.memoizedState = t.baseState = e, e = {
    pending: null,
    interleaved: null,
    lanes: 0,
    dispatch: null,
    lastRenderedReducer: Mi,
    lastRenderedState: e
  }, t.queue = e, e = e.dispatch = LT.bind(null, xe, e), [t.memoizedState, e];
}
function Oi(e, t, n, r) {
  return e = {
    tag: e,
    create: t,
    destroy: n,
    deps: r,
    next: null
  }, t = xe.updateQueue, t === null ? (t = {
    lastEffect: null,
    stores: null
  }, xe.updateQueue = t, t.lastEffect = e.next = e) : (n = t.lastEffect, n === null ? t.lastEffect = e.next = e : (r = n.next, n.next = e, e.next = r, t.lastEffect = e)), e;
}
function Sx() {
  return Mt().memoizedState;
}
function tl(e, t, n, r) {
  var s = en();
  xe.flags |= e, s.memoizedState = Oi(1 | t, n, void 0, r === void 0 ? null : r);
}
function xu(e, t, n, r) {
  var s = Mt();
  r = r === void 0 ? null : r;
  var o = void 0;
  if (Ae !== null) {
    var i = Ae.memoizedState;
    if (o = i.destroy, r !== null && Lh(r, i.deps)) {
      s.memoizedState = Oi(t, n, o, r);
      return;
    }
  }
  xe.flags |= e, s.memoizedState = Oi(1 | t, n, o, r);
}
function Xm(e, t) {
  return tl(8390656, 8, e, t);
}
function Fh(e, t) {
  return xu(2048, 8, e, t);
}
function Ex(e, t) {
  return xu(4, 2, e, t);
}
function Cx(e, t) {
  return xu(4, 4, e, t);
}
function Tx(e, t) {
  if (typeof t == "function") return e = e(), t(e), function () {
    t(null);
  };
  if (t != null) return e = e(), t.current = e, function () {
    t.current = null;
  };
}
function Px(e, t, n) {
  return n = n != null ? n.concat([e]) : null, xu(4, 4, Tx.bind(null, t, e), n);
}
function _h() {}
function kx(e, t) {
  var n = Mt();
  t = t === void 0 ? null : t;
  var r = n.memoizedState;
  return r !== null && t !== null && Lh(t, r[1]) ? r[0] : (n.memoizedState = [e, t], e);
}
function Rx(e, t) {
  var n = Mt();
  t = t === void 0 ? null : t;
  var r = n.memoizedState;
  return r !== null && t !== null && Lh(t, r[1]) ? r[0] : (e = e(), n.memoizedState = [e, t], e);
}
function Nx(e, t, n) {
  return ls & 21 ? (Qt(n, t) || (n = L0(), xe.lanes |= n, us |= n, e.baseState = !0), t) : (e.baseState && (e.baseState = !1, at = !0), e.memoizedState = n);
}
function MT(e, t) {
  var n = oe;
  oe = n !== 0 && 4 > n ? n : 4, e(!0);
  var r = xc.transition;
  xc.transition = {};
  try {
    e(!1), t();
  } finally {
    oe = n, xc.transition = r;
  }
}
function Ax() {
  return Mt().memoizedState;
}
function OT(e, t, n) {
  var r = wr(e);
  if (n = {
    lane: r,
    action: n,
    hasEagerState: !1,
    eagerState: null,
    next: null
  }, jx(e)) Mx(t, n);else if (n = fx(e, t, n, r), n !== null) {
    var s = Je();
    qt(n, e, r, s), Ox(n, t, r);
  }
}
function LT(e, t, n) {
  var r = wr(e),
    s = {
      lane: r,
      action: n,
      hasEagerState: !1,
      eagerState: null,
      next: null
    };
  if (jx(e)) Mx(t, s);else {
    var o = e.alternate;
    if (e.lanes === 0 && (o === null || o.lanes === 0) && (o = t.lastRenderedReducer, o !== null)) try {
      var i = t.lastRenderedState,
        a = o(i, n);
      if (s.hasEagerState = !0, s.eagerState = a, Qt(a, i)) {
        var l = t.interleaved;
        l === null ? (s.next = s, Nh(t)) : (s.next = l.next, l.next = s), t.interleaved = s;
        return;
      }
    } catch {} finally {}
    n = fx(e, t, s, r), n !== null && (s = Je(), qt(n, e, r, s), Ox(n, t, r));
  }
}
function jx(e) {
  var t = e.alternate;
  return e === xe || t !== null && t === xe;
}
function Mx(e, t) {
  ui = Fl = !0;
  var n = e.pending;
  n === null ? t.next = t : (t.next = n.next, n.next = t), e.pending = t;
}
function Ox(e, t, n) {
  if (n & 4194240) {
    var r = t.lanes;
    r &= e.pendingLanes, n |= r, t.lanes = n, mh(e, n);
  }
}
var _l = {
    readContext: jt,
    useCallback: Ue,
    useContext: Ue,
    useEffect: Ue,
    useImperativeHandle: Ue,
    useInsertionEffect: Ue,
    useLayoutEffect: Ue,
    useMemo: Ue,
    useReducer: Ue,
    useRef: Ue,
    useState: Ue,
    useDebugValue: Ue,
    useDeferredValue: Ue,
    useTransition: Ue,
    useMutableSource: Ue,
    useSyncExternalStore: Ue,
    useId: Ue,
    unstable_isNewReconciler: !1
  },
  DT = {
    readContext: jt,
    useCallback: function (e, t) {
      return en().memoizedState = [e, t === void 0 ? null : t], e;
    },
    useContext: jt,
    useEffect: Xm,
    useImperativeHandle: function (e, t, n) {
      return n = n != null ? n.concat([e]) : null, tl(4194308, 4, Tx.bind(null, t, e), n);
    },
    useLayoutEffect: function (e, t) {
      return tl(4194308, 4, e, t);
    },
    useInsertionEffect: function (e, t) {
      return tl(4, 2, e, t);
    },
    useMemo: function (e, t) {
      var n = en();
      return t = t === void 0 ? null : t, e = e(), n.memoizedState = [e, t], e;
    },
    useReducer: function (e, t, n) {
      var r = en();
      return t = n !== void 0 ? n(t) : t, r.memoizedState = r.baseState = t, e = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: e,
        lastRenderedState: t
      }, r.queue = e, e = e.dispatch = OT.bind(null, xe, e), [r.memoizedState, e];
    },
    useRef: function (e) {
      var t = en();
      return e = {
        current: e
      }, t.memoizedState = e;
    },
    useState: Ym,
    useDebugValue: _h,
    useDeferredValue: function (e) {
      return en().memoizedState = e;
    },
    useTransition: function () {
      var e = Ym(!1),
        t = e[0];
      return e = MT.bind(null, e[1]), en().memoizedState = e, [t, e];
    },
    useMutableSource: function () {},
    useSyncExternalStore: function (e, t, n) {
      var r = xe,
        s = en();
      if (me) {
        if (n === void 0) throw Error(M(407));
        n = n();
      } else {
        if (n = t(), De === null) throw Error(M(349));
        ls & 30 || yx(r, t, n);
      }
      s.memoizedState = n;
      var o = {
        value: n,
        getSnapshot: t
      };
      return s.queue = o, Xm(xx.bind(null, r, o, e), [e]), r.flags |= 2048, Oi(9, vx.bind(null, r, o, n, t), void 0, null), n;
    },
    useId: function () {
      var e = en(),
        t = De.identifierPrefix;
      if (me) {
        var n = Tn,
          r = Cn;
        n = (r & ~(1 << 32 - Ht(r) - 1)).toString(32) + n, t = ":" + t + "R" + n, n = ji++, 0 < n && (t += "H" + n.toString(32)), t += ":";
      } else n = jT++, t = ":" + t + "r" + n.toString(32) + ":";
      return e.memoizedState = t;
    },
    unstable_isNewReconciler: !1
  },
  IT = {
    readContext: jt,
    useCallback: kx,
    useContext: jt,
    useEffect: Fh,
    useImperativeHandle: Px,
    useInsertionEffect: Ex,
    useLayoutEffect: Cx,
    useMemo: Rx,
    useReducer: wc,
    useRef: Sx,
    useState: function () {
      return wc(Mi);
    },
    useDebugValue: _h,
    useDeferredValue: function (e) {
      var t = Mt();
      return Nx(t, Ae.memoizedState, e);
    },
    useTransition: function () {
      var e = wc(Mi)[0],
        t = Mt().memoizedState;
      return [e, t];
    },
    useMutableSource: mx,
    useSyncExternalStore: gx,
    useId: Ax,
    unstable_isNewReconciler: !1
  },
  FT = {
    readContext: jt,
    useCallback: kx,
    useContext: jt,
    useEffect: Fh,
    useImperativeHandle: Px,
    useInsertionEffect: Ex,
    useLayoutEffect: Cx,
    useMemo: Rx,
    useReducer: bc,
    useRef: Sx,
    useState: function () {
      return bc(Mi);
    },
    useDebugValue: _h,
    useDeferredValue: function (e) {
      var t = Mt();
      return Ae === null ? t.memoizedState = e : Nx(t, Ae.memoizedState, e);
    },
    useTransition: function () {
      var e = bc(Mi)[0],
        t = Mt().memoizedState;
      return [e, t];
    },
    useMutableSource: mx,
    useSyncExternalStore: gx,
    useId: Ax,
    unstable_isNewReconciler: !1
  };
function Bt(e, t) {
  if (e && e.defaultProps) {
    t = be({}, t), e = e.defaultProps;
    for (var n in e) t[n] === void 0 && (t[n] = e[n]);
    return t;
  }
  return t;
}
function Fd(e, t, n, r) {
  t = e.memoizedState, n = n(r, t), n = n == null ? t : be({}, t, n), e.memoizedState = n, e.lanes === 0 && (e.updateQueue.baseState = n);
}
var wu = {
  isMounted: function (e) {
    return (e = e._reactInternals) ? ms(e) === e : !1;
  },
  enqueueSetState: function (e, t, n) {
    e = e._reactInternals;
    var r = Je(),
      s = wr(e),
      o = kn(r, s);
    o.payload = t, n != null && (o.callback = n), t = vr(e, o, s), t !== null && (qt(t, e, s, r), Ja(t, e, s));
  },
  enqueueReplaceState: function (e, t, n) {
    e = e._reactInternals;
    var r = Je(),
      s = wr(e),
      o = kn(r, s);
    o.tag = 1, o.payload = t, n != null && (o.callback = n), t = vr(e, o, s), t !== null && (qt(t, e, s, r), Ja(t, e, s));
  },
  enqueueForceUpdate: function (e, t) {
    e = e._reactInternals;
    var n = Je(),
      r = wr(e),
      s = kn(n, r);
    s.tag = 2, t != null && (s.callback = t), t = vr(e, s, r), t !== null && (qt(t, e, r, n), Ja(t, e, r));
  }
};
function Zm(e, t, n, r, s, o, i) {
  return e = e.stateNode, typeof e.shouldComponentUpdate == "function" ? e.shouldComponentUpdate(r, o, i) : t.prototype && t.prototype.isPureReactComponent ? !Ti(n, r) || !Ti(s, o) : !0;
}
function Lx(e, t, n) {
  var r = !1,
    s = Tr,
    o = t.contextType;
  return typeof o == "object" && o !== null ? o = jt(o) : (s = ut(t) ? is : Ke.current, r = t.contextTypes, o = (r = r != null) ? fo(e, s) : Tr), t = new t(n, o), e.memoizedState = t.state !== null && t.state !== void 0 ? t.state : null, t.updater = wu, e.stateNode = t, t._reactInternals = e, r && (e = e.stateNode, e.__reactInternalMemoizedUnmaskedChildContext = s, e.__reactInternalMemoizedMaskedChildContext = o), t;
}
function Jm(e, t, n, r) {
  e = t.state, typeof t.componentWillReceiveProps == "function" && t.componentWillReceiveProps(n, r), typeof t.UNSAFE_componentWillReceiveProps == "function" && t.UNSAFE_componentWillReceiveProps(n, r), t.state !== e && wu.enqueueReplaceState(t, t.state, null);
}
function _d(e, t, n, r) {
  var s = e.stateNode;
  s.props = n, s.state = e.memoizedState, s.refs = {}, Ah(e);
  var o = t.contextType;
  typeof o == "object" && o !== null ? s.context = jt(o) : (o = ut(t) ? is : Ke.current, s.context = fo(e, o)), s.state = e.memoizedState, o = t.getDerivedStateFromProps, typeof o == "function" && (Fd(e, t, o, n), s.state = e.memoizedState), typeof t.getDerivedStateFromProps == "function" || typeof s.getSnapshotBeforeUpdate == "function" || typeof s.UNSAFE_componentWillMount != "function" && typeof s.componentWillMount != "function" || (t = s.state, typeof s.componentWillMount == "function" && s.componentWillMount(), typeof s.UNSAFE_componentWillMount == "function" && s.UNSAFE_componentWillMount(), t !== s.state && wu.enqueueReplaceState(s, s.state, null), Dl(e, n, s, r), s.state = e.memoizedState), typeof s.componentDidMount == "function" && (e.flags |= 4194308);
}
function go(e, t) {
  try {
    var n = "",
      r = t;
    do n += dC(r), r = r.return; while (r);
    var s = n;
  } catch (o) {
    s = `
Error generating stack: ` + o.message + `
` + o.stack;
  }
  return {
    value: e,
    source: t,
    stack: s,
    digest: null
  };
}
function Sc(e, t, n) {
  return {
    value: e,
    source: null,
    stack: n ?? null,
    digest: t ?? null
  };
}
function Vd(e, t) {
  try {
    console.error(t.value);
  } catch (n) {
    setTimeout(function () {
      throw n;
    });
  }
}
var _T = typeof WeakMap == "function" ? WeakMap : Map;
function Dx(e, t, n) {
  n = kn(-1, n), n.tag = 3, n.payload = {
    element: null
  };
  var r = t.value;
  return n.callback = function () {
    Bl || (Bl = !0, Gd = r), Vd(e, t);
  }, n;
}
function Ix(e, t, n) {
  n = kn(-1, n), n.tag = 3;
  var r = e.type.getDerivedStateFromError;
  if (typeof r == "function") {
    var s = t.value;
    n.payload = function () {
      return r(s);
    }, n.callback = function () {
      Vd(e, t);
    };
  }
  var o = e.stateNode;
  return o !== null && typeof o.componentDidCatch == "function" && (n.callback = function () {
    Vd(e, t), typeof r != "function" && (xr === null ? xr = new Set([this]) : xr.add(this));
    var i = t.stack;
    this.componentDidCatch(t.value, {
      componentStack: i !== null ? i : ""
    });
  }), n;
}
function eg(e, t, n) {
  var r = e.pingCache;
  if (r === null) {
    r = e.pingCache = new _T();
    var s = new Set();
    r.set(t, s);
  } else s = r.get(t), s === void 0 && (s = new Set(), r.set(t, s));
  s.has(n) || (s.add(n), e = ZT.bind(null, e, t, n), t.then(e, e));
}
function tg(e) {
  do {
    var t;
    if ((t = e.tag === 13) && (t = e.memoizedState, t = t !== null ? t.dehydrated !== null : !0), t) return e;
    e = e.return;
  } while (e !== null);
  return null;
}
function ng(e, t, n, r, s) {
  return e.mode & 1 ? (e.flags |= 65536, e.lanes = s, e) : (e === t ? e.flags |= 65536 : (e.flags |= 128, n.flags |= 131072, n.flags &= -52805, n.tag === 1 && (n.alternate === null ? n.tag = 17 : (t = kn(-1, 1), t.tag = 2, vr(n, t, 1))), n.lanes |= 1), e);
}
var VT = Dn.ReactCurrentOwner,
  at = !1;
function Ye(e, t, n, r) {
  t.child = e === null ? dx(t, null, n, r) : po(t, e.child, n, r);
}
function rg(e, t, n, r, s) {
  n = n.render;
  var o = t.ref;
  return qs(t, s), r = Dh(e, t, n, r, o, s), n = Ih(), e !== null && !at ? (t.updateQueue = e.updateQueue, t.flags &= -2053, e.lanes &= ~s, jn(e, t, s)) : (me && n && Eh(t), t.flags |= 1, Ye(e, t, r, s), t.child);
}
function sg(e, t, n, r, s) {
  if (e === null) {
    var o = n.type;
    return typeof o == "function" && !qh(o) && o.defaultProps === void 0 && n.compare === null && n.defaultProps === void 0 ? (t.tag = 15, t.type = o, Fx(e, t, o, r, s)) : (e = ol(n.type, null, r, t, t.mode, s), e.ref = t.ref, e.return = t, t.child = e);
  }
  if (o = e.child, !(e.lanes & s)) {
    var i = o.memoizedProps;
    if (n = n.compare, n = n !== null ? n : Ti, n(i, r) && e.ref === t.ref) return jn(e, t, s);
  }
  return t.flags |= 1, e = br(o, r), e.ref = t.ref, e.return = t, t.child = e;
}
function Fx(e, t, n, r, s) {
  if (e !== null) {
    var o = e.memoizedProps;
    if (Ti(o, r) && e.ref === t.ref) if (at = !1, t.pendingProps = r = o, (e.lanes & s) !== 0) e.flags & 131072 && (at = !0);else return t.lanes = e.lanes, jn(e, t, s);
  }
  return Bd(e, t, n, r, s);
}
function _x(e, t, n) {
  var r = t.pendingProps,
    s = r.children,
    o = e !== null ? e.memoizedState : null;
  if (r.mode === "hidden") {
    if (!(t.mode & 1)) t.memoizedState = {
      baseLanes: 0,
      cachePool: null,
      transitions: null
    }, ue(_s, ft), ft |= n;else {
      if (!(n & 1073741824)) return e = o !== null ? o.baseLanes | n : n, t.lanes = t.childLanes = 1073741824, t.memoizedState = {
        baseLanes: e,
        cachePool: null,
        transitions: null
      }, t.updateQueue = null, ue(_s, ft), ft |= e, null;
      t.memoizedState = {
        baseLanes: 0,
        cachePool: null,
        transitions: null
      }, r = o !== null ? o.baseLanes : n, ue(_s, ft), ft |= r;
    }
  } else o !== null ? (r = o.baseLanes | n, t.memoizedState = null) : r = n, ue(_s, ft), ft |= r;
  return Ye(e, t, s, n), t.child;
}
function Vx(e, t) {
  var n = t.ref;
  (e === null && n !== null || e !== null && e.ref !== n) && (t.flags |= 512, t.flags |= 2097152);
}
function Bd(e, t, n, r, s) {
  var o = ut(n) ? is : Ke.current;
  return o = fo(t, o), qs(t, s), n = Dh(e, t, n, r, o, s), r = Ih(), e !== null && !at ? (t.updateQueue = e.updateQueue, t.flags &= -2053, e.lanes &= ~s, jn(e, t, s)) : (me && r && Eh(t), t.flags |= 1, Ye(e, t, n, s), t.child);
}
function og(e, t, n, r, s) {
  if (ut(n)) {
    var o = !0;
    Al(t);
  } else o = !1;
  if (qs(t, s), t.stateNode === null) nl(e, t), Lx(t, n, r), _d(t, n, r, s), r = !0;else if (e === null) {
    var i = t.stateNode,
      a = t.memoizedProps;
    i.props = a;
    var l = i.context,
      u = n.contextType;
    typeof u == "object" && u !== null ? u = jt(u) : (u = ut(n) ? is : Ke.current, u = fo(t, u));
    var d = n.getDerivedStateFromProps,
      c = typeof d == "function" || typeof i.getSnapshotBeforeUpdate == "function";
    c || typeof i.UNSAFE_componentWillReceiveProps != "function" && typeof i.componentWillReceiveProps != "function" || (a !== r || l !== u) && Jm(t, i, r, u), Jn = !1;
    var f = t.memoizedState;
    i.state = f, Dl(t, r, i, s), l = t.memoizedState, a !== r || f !== l || lt.current || Jn ? (typeof d == "function" && (Fd(t, n, d, r), l = t.memoizedState), (a = Jn || Zm(t, n, a, r, f, l, u)) ? (c || typeof i.UNSAFE_componentWillMount != "function" && typeof i.componentWillMount != "function" || (typeof i.componentWillMount == "function" && i.componentWillMount(), typeof i.UNSAFE_componentWillMount == "function" && i.UNSAFE_componentWillMount()), typeof i.componentDidMount == "function" && (t.flags |= 4194308)) : (typeof i.componentDidMount == "function" && (t.flags |= 4194308), t.memoizedProps = r, t.memoizedState = l), i.props = r, i.state = l, i.context = u, r = a) : (typeof i.componentDidMount == "function" && (t.flags |= 4194308), r = !1);
  } else {
    i = t.stateNode, hx(e, t), a = t.memoizedProps, u = t.type === t.elementType ? a : Bt(t.type, a), i.props = u, c = t.pendingProps, f = i.context, l = n.contextType, typeof l == "object" && l !== null ? l = jt(l) : (l = ut(n) ? is : Ke.current, l = fo(t, l));
    var h = n.getDerivedStateFromProps;
    (d = typeof h == "function" || typeof i.getSnapshotBeforeUpdate == "function") || typeof i.UNSAFE_componentWillReceiveProps != "function" && typeof i.componentWillReceiveProps != "function" || (a !== c || f !== l) && Jm(t, i, r, l), Jn = !1, f = t.memoizedState, i.state = f, Dl(t, r, i, s);
    var w = t.memoizedState;
    a !== c || f !== w || lt.current || Jn ? (typeof h == "function" && (Fd(t, n, h, r), w = t.memoizedState), (u = Jn || Zm(t, n, u, r, f, w, l) || !1) ? (d || typeof i.UNSAFE_componentWillUpdate != "function" && typeof i.componentWillUpdate != "function" || (typeof i.componentWillUpdate == "function" && i.componentWillUpdate(r, w, l), typeof i.UNSAFE_componentWillUpdate == "function" && i.UNSAFE_componentWillUpdate(r, w, l)), typeof i.componentDidUpdate == "function" && (t.flags |= 4), typeof i.getSnapshotBeforeUpdate == "function" && (t.flags |= 1024)) : (typeof i.componentDidUpdate != "function" || a === e.memoizedProps && f === e.memoizedState || (t.flags |= 4), typeof i.getSnapshotBeforeUpdate != "function" || a === e.memoizedProps && f === e.memoizedState || (t.flags |= 1024), t.memoizedProps = r, t.memoizedState = w), i.props = r, i.state = w, i.context = l, r = u) : (typeof i.componentDidUpdate != "function" || a === e.memoizedProps && f === e.memoizedState || (t.flags |= 4), typeof i.getSnapshotBeforeUpdate != "function" || a === e.memoizedProps && f === e.memoizedState || (t.flags |= 1024), r = !1);
  }
  return zd(e, t, n, r, o, s);
}
function zd(e, t, n, r, s, o) {
  Vx(e, t);
  var i = (t.flags & 128) !== 0;
  if (!r && !i) return s && Wm(t, n, !1), jn(e, t, o);
  r = t.stateNode, VT.current = t;
  var a = i && typeof n.getDerivedStateFromError != "function" ? null : r.render();
  return t.flags |= 1, e !== null && i ? (t.child = po(t, e.child, null, o), t.child = po(t, null, a, o)) : Ye(e, t, a, o), t.memoizedState = r.state, s && Wm(t, n, !0), t.child;
}
function Bx(e) {
  var t = e.stateNode;
  t.pendingContext ? Um(e, t.pendingContext, t.pendingContext !== t.context) : t.context && Um(e, t.context, !1), jh(e, t.containerInfo);
}
function ig(e, t, n, r, s) {
  return ho(), Th(s), t.flags |= 256, Ye(e, t, n, r), t.child;
}
var $d = {
  dehydrated: null,
  treeContext: null,
  retryLane: 0
};
function Ud(e) {
  return {
    baseLanes: e,
    cachePool: null,
    transitions: null
  };
}
function zx(e, t, n) {
  var r = t.pendingProps,
    s = ve.current,
    o = !1,
    i = (t.flags & 128) !== 0,
    a;
  if ((a = i) || (a = e !== null && e.memoizedState === null ? !1 : (s & 2) !== 0), a ? (o = !0, t.flags &= -129) : (e === null || e.memoizedState !== null) && (s |= 1), ue(ve, s & 1), e === null) return Dd(t), e = t.memoizedState, e !== null && (e = e.dehydrated, e !== null) ? (t.mode & 1 ? e.data === "$!" ? t.lanes = 8 : t.lanes = 1073741824 : t.lanes = 1, null) : (i = r.children, e = r.fallback, o ? (r = t.mode, o = t.child, i = {
    mode: "hidden",
    children: i
  }, !(r & 1) && o !== null ? (o.childLanes = 0, o.pendingProps = i) : o = Eu(i, r, 0, null), e = rs(e, r, n, null), o.return = t, e.return = t, o.sibling = e, t.child = o, t.child.memoizedState = Ud(n), t.memoizedState = $d, e) : Vh(t, i));
  if (s = e.memoizedState, s !== null && (a = s.dehydrated, a !== null)) return BT(e, t, i, r, a, s, n);
  if (o) {
    o = r.fallback, i = t.mode, s = e.child, a = s.sibling;
    var l = {
      mode: "hidden",
      children: r.children
    };
    return !(i & 1) && t.child !== s ? (r = t.child, r.childLanes = 0, r.pendingProps = l, t.deletions = null) : (r = br(s, l), r.subtreeFlags = s.subtreeFlags & 14680064), a !== null ? o = br(a, o) : (o = rs(o, i, n, null), o.flags |= 2), o.return = t, r.return = t, r.sibling = o, t.child = r, r = o, o = t.child, i = e.child.memoizedState, i = i === null ? Ud(n) : {
      baseLanes: i.baseLanes | n,
      cachePool: null,
      transitions: i.transitions
    }, o.memoizedState = i, o.childLanes = e.childLanes & ~n, t.memoizedState = $d, r;
  }
  return o = e.child, e = o.sibling, r = br(o, {
    mode: "visible",
    children: r.children
  }), !(t.mode & 1) && (r.lanes = n), r.return = t, r.sibling = null, e !== null && (n = t.deletions, n === null ? (t.deletions = [e], t.flags |= 16) : n.push(e)), t.child = r, t.memoizedState = null, r;
}
function Vh(e, t) {
  return t = Eu({
    mode: "visible",
    children: t
  }, e.mode, 0, null), t.return = e, e.child = t;
}
function Na(e, t, n, r) {
  return r !== null && Th(r), po(t, e.child, null, n), e = Vh(t, t.pendingProps.children), e.flags |= 2, t.memoizedState = null, e;
}
function BT(e, t, n, r, s, o, i) {
  if (n) return t.flags & 256 ? (t.flags &= -257, r = Sc(Error(M(422))), Na(e, t, i, r)) : t.memoizedState !== null ? (t.child = e.child, t.flags |= 128, null) : (o = r.fallback, s = t.mode, r = Eu({
    mode: "visible",
    children: r.children
  }, s, 0, null), o = rs(o, s, i, null), o.flags |= 2, r.return = t, o.return = t, r.sibling = o, t.child = r, t.mode & 1 && po(t, e.child, null, i), t.child.memoizedState = Ud(i), t.memoizedState = $d, o);
  if (!(t.mode & 1)) return Na(e, t, i, null);
  if (s.data === "$!") {
    if (r = s.nextSibling && s.nextSibling.dataset, r) var a = r.dgst;
    return r = a, o = Error(M(419)), r = Sc(o, r, void 0), Na(e, t, i, r);
  }
  if (a = (i & e.childLanes) !== 0, at || a) {
    if (r = De, r !== null) {
      switch (i & -i) {
        case 4:
          s = 2;
          break;
        case 16:
          s = 8;
          break;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
          s = 32;
          break;
        case 536870912:
          s = 268435456;
          break;
        default:
          s = 0;
      }
      s = s & (r.suspendedLanes | i) ? 0 : s, s !== 0 && s !== o.retryLane && (o.retryLane = s, An(e, s), qt(r, e, s, -1));
    }
    return Hh(), r = Sc(Error(M(421))), Na(e, t, i, r);
  }
  return s.data === "$?" ? (t.flags |= 128, t.child = e.child, t = JT.bind(null, e), s._reactRetry = t, null) : (e = o.treeContext, pt = yr(s.nextSibling), mt = t, me = !0, Wt = null, e !== null && (Ct[Tt++] = Cn, Ct[Tt++] = Tn, Ct[Tt++] = as, Cn = e.id, Tn = e.overflow, as = t), t = Vh(t, r.children), t.flags |= 4096, t);
}
function ag(e, t, n) {
  e.lanes |= t;
  var r = e.alternate;
  r !== null && (r.lanes |= t), Id(e.return, t, n);
}
function Ec(e, t, n, r, s) {
  var o = e.memoizedState;
  o === null ? e.memoizedState = {
    isBackwards: t,
    rendering: null,
    renderingStartTime: 0,
    last: r,
    tail: n,
    tailMode: s
  } : (o.isBackwards = t, o.rendering = null, o.renderingStartTime = 0, o.last = r, o.tail = n, o.tailMode = s);
}
function $x(e, t, n) {
  var r = t.pendingProps,
    s = r.revealOrder,
    o = r.tail;
  if (Ye(e, t, r.children, n), r = ve.current, r & 2) r = r & 1 | 2, t.flags |= 128;else {
    if (e !== null && e.flags & 128) e: for (e = t.child; e !== null;) {
      if (e.tag === 13) e.memoizedState !== null && ag(e, n, t);else if (e.tag === 19) ag(e, n, t);else if (e.child !== null) {
        e.child.return = e, e = e.child;
        continue;
      }
      if (e === t) break e;
      for (; e.sibling === null;) {
        if (e.return === null || e.return === t) break e;
        e = e.return;
      }
      e.sibling.return = e.return, e = e.sibling;
    }
    r &= 1;
  }
  if (ue(ve, r), !(t.mode & 1)) t.memoizedState = null;else switch (s) {
    case "forwards":
      for (n = t.child, s = null; n !== null;) e = n.alternate, e !== null && Il(e) === null && (s = n), n = n.sibling;
      n = s, n === null ? (s = t.child, t.child = null) : (s = n.sibling, n.sibling = null), Ec(t, !1, s, n, o);
      break;
    case "backwards":
      for (n = null, s = t.child, t.child = null; s !== null;) {
        if (e = s.alternate, e !== null && Il(e) === null) {
          t.child = s;
          break;
        }
        e = s.sibling, s.sibling = n, n = s, s = e;
      }
      Ec(t, !0, n, null, o);
      break;
    case "together":
      Ec(t, !1, null, null, void 0);
      break;
    default:
      t.memoizedState = null;
  }
  return t.child;
}
function nl(e, t) {
  !(t.mode & 1) && e !== null && (e.alternate = null, t.alternate = null, t.flags |= 2);
}
function jn(e, t, n) {
  if (e !== null && (t.dependencies = e.dependencies), us |= t.lanes, !(n & t.childLanes)) return null;
  if (e !== null && t.child !== e.child) throw Error(M(153));
  if (t.child !== null) {
    for (e = t.child, n = br(e, e.pendingProps), t.child = n, n.return = t; e.sibling !== null;) e = e.sibling, n = n.sibling = br(e, e.pendingProps), n.return = t;
    n.sibling = null;
  }
  return t.child;
}
function zT(e, t, n) {
  switch (t.tag) {
    case 3:
      Bx(t), ho();
      break;
    case 5:
      px(t);
      break;
    case 1:
      ut(t.type) && Al(t);
      break;
    case 4:
      jh(t, t.stateNode.containerInfo);
      break;
    case 10:
      var r = t.type._context,
        s = t.memoizedProps.value;
      ue(Ol, r._currentValue), r._currentValue = s;
      break;
    case 13:
      if (r = t.memoizedState, r !== null) return r.dehydrated !== null ? (ue(ve, ve.current & 1), t.flags |= 128, null) : n & t.child.childLanes ? zx(e, t, n) : (ue(ve, ve.current & 1), e = jn(e, t, n), e !== null ? e.sibling : null);
      ue(ve, ve.current & 1);
      break;
    case 19:
      if (r = (n & t.childLanes) !== 0, e.flags & 128) {
        if (r) return $x(e, t, n);
        t.flags |= 128;
      }
      if (s = t.memoizedState, s !== null && (s.rendering = null, s.tail = null, s.lastEffect = null), ue(ve, ve.current), r) break;
      return null;
    case 22:
    case 23:
      return t.lanes = 0, _x(e, t, n);
  }
  return jn(e, t, n);
}
var Ux, Wd, Wx, Hx;
Ux = function (e, t) {
  for (var n = t.child; n !== null;) {
    if (n.tag === 5 || n.tag === 6) e.appendChild(n.stateNode);else if (n.tag !== 4 && n.child !== null) {
      n.child.return = n, n = n.child;
      continue;
    }
    if (n === t) break;
    for (; n.sibling === null;) {
      if (n.return === null || n.return === t) return;
      n = n.return;
    }
    n.sibling.return = n.return, n = n.sibling;
  }
};
Wd = function () {};
Wx = function (e, t, n, r) {
  var s = e.memoizedProps;
  if (s !== r) {
    e = t.stateNode, Wr(dn.current);
    var o = null;
    switch (n) {
      case "input":
        s = fd(e, s), r = fd(e, r), o = [];
        break;
      case "select":
        s = be({}, s, {
          value: void 0
        }), r = be({}, r, {
          value: void 0
        }), o = [];
        break;
      case "textarea":
        s = md(e, s), r = md(e, r), o = [];
        break;
      default:
        typeof s.onClick != "function" && typeof r.onClick == "function" && (e.onclick = Rl);
    }
    yd(n, r);
    var i;
    n = null;
    for (u in s) if (!r.hasOwnProperty(u) && s.hasOwnProperty(u) && s[u] != null) if (u === "style") {
      var a = s[u];
      for (i in a) a.hasOwnProperty(i) && (n || (n = {}), n[i] = "");
    } else u !== "dangerouslySetInnerHTML" && u !== "children" && u !== "suppressContentEditableWarning" && u !== "suppressHydrationWarning" && u !== "autoFocus" && (vi.hasOwnProperty(u) ? o || (o = []) : (o = o || []).push(u, null));
    for (u in r) {
      var l = r[u];
      if (a = s != null ? s[u] : void 0, r.hasOwnProperty(u) && l !== a && (l != null || a != null)) if (u === "style") {
        if (a) {
          for (i in a) !a.hasOwnProperty(i) || l && l.hasOwnProperty(i) || (n || (n = {}), n[i] = "");
          for (i in l) l.hasOwnProperty(i) && a[i] !== l[i] && (n || (n = {}), n[i] = l[i]);
        } else n || (o || (o = []), o.push(u, n)), n = l;
      } else u === "dangerouslySetInnerHTML" ? (l = l ? l.__html : void 0, a = a ? a.__html : void 0, l != null && a !== l && (o = o || []).push(u, l)) : u === "children" ? typeof l != "string" && typeof l != "number" || (o = o || []).push(u, "" + l) : u !== "suppressContentEditableWarning" && u !== "suppressHydrationWarning" && (vi.hasOwnProperty(u) ? (l != null && u === "onScroll" && de("scroll", e), o || a === l || (o = [])) : (o = o || []).push(u, l));
    }
    n && (o = o || []).push("style", n);
    var u = o;
    (t.updateQueue = u) && (t.flags |= 4);
  }
};
Hx = function (e, t, n, r) {
  n !== r && (t.flags |= 4);
};
function qo(e, t) {
  if (!me) switch (e.tailMode) {
    case "hidden":
      t = e.tail;
      for (var n = null; t !== null;) t.alternate !== null && (n = t), t = t.sibling;
      n === null ? e.tail = null : n.sibling = null;
      break;
    case "collapsed":
      n = e.tail;
      for (var r = null; n !== null;) n.alternate !== null && (r = n), n = n.sibling;
      r === null ? t || e.tail === null ? e.tail = null : e.tail.sibling = null : r.sibling = null;
  }
}
function We(e) {
  var t = e.alternate !== null && e.alternate.child === e.child,
    n = 0,
    r = 0;
  if (t) for (var s = e.child; s !== null;) n |= s.lanes | s.childLanes, r |= s.subtreeFlags & 14680064, r |= s.flags & 14680064, s.return = e, s = s.sibling;else for (s = e.child; s !== null;) n |= s.lanes | s.childLanes, r |= s.subtreeFlags, r |= s.flags, s.return = e, s = s.sibling;
  return e.subtreeFlags |= r, e.childLanes = n, t;
}
function $T(e, t, n) {
  var r = t.pendingProps;
  switch (Ch(t), t.tag) {
    case 2:
    case 16:
    case 15:
    case 0:
    case 11:
    case 7:
    case 8:
    case 12:
    case 9:
    case 14:
      return We(t), null;
    case 1:
      return ut(t.type) && Nl(), We(t), null;
    case 3:
      return r = t.stateNode, mo(), fe(lt), fe(Ke), Oh(), r.pendingContext && (r.context = r.pendingContext, r.pendingContext = null), (e === null || e.child === null) && (ka(t) ? t.flags |= 4 : e === null || e.memoizedState.isDehydrated && !(t.flags & 256) || (t.flags |= 1024, Wt !== null && (Zd(Wt), Wt = null))), Wd(e, t), We(t), null;
    case 5:
      Mh(t);
      var s = Wr(Ai.current);
      if (n = t.type, e !== null && t.stateNode != null) Wx(e, t, n, r, s), e.ref !== t.ref && (t.flags |= 512, t.flags |= 2097152);else {
        if (!r) {
          if (t.stateNode === null) throw Error(M(166));
          return We(t), null;
        }
        if (e = Wr(dn.current), ka(t)) {
          r = t.stateNode, n = t.type;
          var o = t.memoizedProps;
          switch (r[an] = t, r[Ri] = o, e = (t.mode & 1) !== 0, n) {
            case "dialog":
              de("cancel", r), de("close", r);
              break;
            case "iframe":
            case "object":
            case "embed":
              de("load", r);
              break;
            case "video":
            case "audio":
              for (s = 0; s < ti.length; s++) de(ti[s], r);
              break;
            case "source":
              de("error", r);
              break;
            case "img":
            case "image":
            case "link":
              de("error", r), de("load", r);
              break;
            case "details":
              de("toggle", r);
              break;
            case "input":
              gm(r, o), de("invalid", r);
              break;
            case "select":
              r._wrapperState = {
                wasMultiple: !!o.multiple
              }, de("invalid", r);
              break;
            case "textarea":
              vm(r, o), de("invalid", r);
          }
          yd(n, o), s = null;
          for (var i in o) if (o.hasOwnProperty(i)) {
            var a = o[i];
            i === "children" ? typeof a == "string" ? r.textContent !== a && (o.suppressHydrationWarning !== !0 && Pa(r.textContent, a, e), s = ["children", a]) : typeof a == "number" && r.textContent !== "" + a && (o.suppressHydrationWarning !== !0 && Pa(r.textContent, a, e), s = ["children", "" + a]) : vi.hasOwnProperty(i) && a != null && i === "onScroll" && de("scroll", r);
          }
          switch (n) {
            case "input":
              va(r), ym(r, o, !0);
              break;
            case "textarea":
              va(r), xm(r);
              break;
            case "select":
            case "option":
              break;
            default:
              typeof o.onClick == "function" && (r.onclick = Rl);
          }
          r = s, t.updateQueue = r, r !== null && (t.flags |= 4);
        } else {
          i = s.nodeType === 9 ? s : s.ownerDocument, e === "http://www.w3.org/1999/xhtml" && (e = x0(n)), e === "http://www.w3.org/1999/xhtml" ? n === "script" ? (e = i.createElement("div"), e.innerHTML = "<script><\/script>", e = e.removeChild(e.firstChild)) : typeof r.is == "string" ? e = i.createElement(n, {
            is: r.is
          }) : (e = i.createElement(n), n === "select" && (i = e, r.multiple ? i.multiple = !0 : r.size && (i.size = r.size))) : e = i.createElementNS(e, n), e[an] = t, e[Ri] = r, Ux(e, t, !1, !1), t.stateNode = e;
          e: {
            switch (i = vd(n, r), n) {
              case "dialog":
                de("cancel", e), de("close", e), s = r;
                break;
              case "iframe":
              case "object":
              case "embed":
                de("load", e), s = r;
                break;
              case "video":
              case "audio":
                for (s = 0; s < ti.length; s++) de(ti[s], e);
                s = r;
                break;
              case "source":
                de("error", e), s = r;
                break;
              case "img":
              case "image":
              case "link":
                de("error", e), de("load", e), s = r;
                break;
              case "details":
                de("toggle", e), s = r;
                break;
              case "input":
                gm(e, r), s = fd(e, r), de("invalid", e);
                break;
              case "option":
                s = r;
                break;
              case "select":
                e._wrapperState = {
                  wasMultiple: !!r.multiple
                }, s = be({}, r, {
                  value: void 0
                }), de("invalid", e);
                break;
              case "textarea":
                vm(e, r), s = md(e, r), de("invalid", e);
                break;
              default:
                s = r;
            }
            yd(n, s), a = s;
            for (o in a) if (a.hasOwnProperty(o)) {
              var l = a[o];
              o === "style" ? S0(e, l) : o === "dangerouslySetInnerHTML" ? (l = l ? l.__html : void 0, l != null && w0(e, l)) : o === "children" ? typeof l == "string" ? (n !== "textarea" || l !== "") && xi(e, l) : typeof l == "number" && xi(e, "" + l) : o !== "suppressContentEditableWarning" && o !== "suppressHydrationWarning" && o !== "autoFocus" && (vi.hasOwnProperty(o) ? l != null && o === "onScroll" && de("scroll", e) : l != null && uh(e, o, l, i));
            }
            switch (n) {
              case "input":
                va(e), ym(e, r, !1);
                break;
              case "textarea":
                va(e), xm(e);
                break;
              case "option":
                r.value != null && e.setAttribute("value", "" + Cr(r.value));
                break;
              case "select":
                e.multiple = !!r.multiple, o = r.value, o != null ? $s(e, !!r.multiple, o, !1) : r.defaultValue != null && $s(e, !!r.multiple, r.defaultValue, !0);
                break;
              default:
                typeof s.onClick == "function" && (e.onclick = Rl);
            }
            switch (n) {
              case "button":
              case "input":
              case "select":
              case "textarea":
                r = !!r.autoFocus;
                break e;
              case "img":
                r = !0;
                break e;
              default:
                r = !1;
            }
          }
          r && (t.flags |= 4);
        }
        t.ref !== null && (t.flags |= 512, t.flags |= 2097152);
      }
      return We(t), null;
    case 6:
      if (e && t.stateNode != null) Hx(e, t, e.memoizedProps, r);else {
        if (typeof r != "string" && t.stateNode === null) throw Error(M(166));
        if (n = Wr(Ai.current), Wr(dn.current), ka(t)) {
          if (r = t.stateNode, n = t.memoizedProps, r[an] = t, (o = r.nodeValue !== n) && (e = mt, e !== null)) switch (e.tag) {
            case 3:
              Pa(r.nodeValue, n, (e.mode & 1) !== 0);
              break;
            case 5:
              e.memoizedProps.suppressHydrationWarning !== !0 && Pa(r.nodeValue, n, (e.mode & 1) !== 0);
          }
          o && (t.flags |= 4);
        } else r = (n.nodeType === 9 ? n : n.ownerDocument).createTextNode(r), r[an] = t, t.stateNode = r;
      }
      return We(t), null;
    case 13:
      if (fe(ve), r = t.memoizedState, e === null || e.memoizedState !== null && e.memoizedState.dehydrated !== null) {
        if (me && pt !== null && t.mode & 1 && !(t.flags & 128)) ux(), ho(), t.flags |= 98560, o = !1;else if (o = ka(t), r !== null && r.dehydrated !== null) {
          if (e === null) {
            if (!o) throw Error(M(318));
            if (o = t.memoizedState, o = o !== null ? o.dehydrated : null, !o) throw Error(M(317));
            o[an] = t;
          } else ho(), !(t.flags & 128) && (t.memoizedState = null), t.flags |= 4;
          We(t), o = !1;
        } else Wt !== null && (Zd(Wt), Wt = null), o = !0;
        if (!o) return t.flags & 65536 ? t : null;
      }
      return t.flags & 128 ? (t.lanes = n, t) : (r = r !== null, r !== (e !== null && e.memoizedState !== null) && r && (t.child.flags |= 8192, t.mode & 1 && (e === null || ve.current & 1 ? je === 0 && (je = 3) : Hh())), t.updateQueue !== null && (t.flags |= 4), We(t), null);
    case 4:
      return mo(), Wd(e, t), e === null && Pi(t.stateNode.containerInfo), We(t), null;
    case 10:
      return Rh(t.type._context), We(t), null;
    case 17:
      return ut(t.type) && Nl(), We(t), null;
    case 19:
      if (fe(ve), o = t.memoizedState, o === null) return We(t), null;
      if (r = (t.flags & 128) !== 0, i = o.rendering, i === null) {
        if (r) qo(o, !1);else {
          if (je !== 0 || e !== null && e.flags & 128) for (e = t.child; e !== null;) {
            if (i = Il(e), i !== null) {
              for (t.flags |= 128, qo(o, !1), r = i.updateQueue, r !== null && (t.updateQueue = r, t.flags |= 4), t.subtreeFlags = 0, r = n, n = t.child; n !== null;) o = n, e = r, o.flags &= 14680066, i = o.alternate, i === null ? (o.childLanes = 0, o.lanes = e, o.child = null, o.subtreeFlags = 0, o.memoizedProps = null, o.memoizedState = null, o.updateQueue = null, o.dependencies = null, o.stateNode = null) : (o.childLanes = i.childLanes, o.lanes = i.lanes, o.child = i.child, o.subtreeFlags = 0, o.deletions = null, o.memoizedProps = i.memoizedProps, o.memoizedState = i.memoizedState, o.updateQueue = i.updateQueue, o.type = i.type, e = i.dependencies, o.dependencies = e === null ? null : {
                lanes: e.lanes,
                firstContext: e.firstContext
              }), n = n.sibling;
              return ue(ve, ve.current & 1 | 2), t.child;
            }
            e = e.sibling;
          }
          o.tail !== null && Ce() > yo && (t.flags |= 128, r = !0, qo(o, !1), t.lanes = 4194304);
        }
      } else {
        if (!r) if (e = Il(i), e !== null) {
          if (t.flags |= 128, r = !0, n = e.updateQueue, n !== null && (t.updateQueue = n, t.flags |= 4), qo(o, !0), o.tail === null && o.tailMode === "hidden" && !i.alternate && !me) return We(t), null;
        } else 2 * Ce() - o.renderingStartTime > yo && n !== 1073741824 && (t.flags |= 128, r = !0, qo(o, !1), t.lanes = 4194304);
        o.isBackwards ? (i.sibling = t.child, t.child = i) : (n = o.last, n !== null ? n.sibling = i : t.child = i, o.last = i);
      }
      return o.tail !== null ? (t = o.tail, o.rendering = t, o.tail = t.sibling, o.renderingStartTime = Ce(), t.sibling = null, n = ve.current, ue(ve, r ? n & 1 | 2 : n & 1), t) : (We(t), null);
    case 22:
    case 23:
      return Wh(), r = t.memoizedState !== null, e !== null && e.memoizedState !== null !== r && (t.flags |= 8192), r && t.mode & 1 ? ft & 1073741824 && (We(t), t.subtreeFlags & 6 && (t.flags |= 8192)) : We(t), null;
    case 24:
      return null;
    case 25:
      return null;
  }
  throw Error(M(156, t.tag));
}
function UT(e, t) {
  switch (Ch(t), t.tag) {
    case 1:
      return ut(t.type) && Nl(), e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
    case 3:
      return mo(), fe(lt), fe(Ke), Oh(), e = t.flags, e & 65536 && !(e & 128) ? (t.flags = e & -65537 | 128, t) : null;
    case 5:
      return Mh(t), null;
    case 13:
      if (fe(ve), e = t.memoizedState, e !== null && e.dehydrated !== null) {
        if (t.alternate === null) throw Error(M(340));
        ho();
      }
      return e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
    case 19:
      return fe(ve), null;
    case 4:
      return mo(), null;
    case 10:
      return Rh(t.type._context), null;
    case 22:
    case 23:
      return Wh(), null;
    case 24:
      return null;
    default:
      return null;
  }
}
var Aa = !1,
  qe = !1,
  WT = typeof WeakSet == "function" ? WeakSet : Set,
  _ = null;
function Fs(e, t) {
  var n = e.ref;
  if (n !== null) if (typeof n == "function") try {
    n(null);
  } catch (r) {
    Ee(e, t, r);
  } else n.current = null;
}
function Hd(e, t, n) {
  try {
    n();
  } catch (r) {
    Ee(e, t, r);
  }
}
var lg = !1;
function HT(e, t) {
  if (Rd = Tl, e = Y0(), Sh(e)) {
    if ("selectionStart" in e) var n = {
      start: e.selectionStart,
      end: e.selectionEnd
    };else e: {
      n = (n = e.ownerDocument) && n.defaultView || window;
      var r = n.getSelection && n.getSelection();
      if (r && r.rangeCount !== 0) {
        n = r.anchorNode;
        var s = r.anchorOffset,
          o = r.focusNode;
        r = r.focusOffset;
        try {
          n.nodeType, o.nodeType;
        } catch {
          n = null;
          break e;
        }
        var i = 0,
          a = -1,
          l = -1,
          u = 0,
          d = 0,
          c = e,
          f = null;
        t: for (;;) {
          for (var h; c !== n || s !== 0 && c.nodeType !== 3 || (a = i + s), c !== o || r !== 0 && c.nodeType !== 3 || (l = i + r), c.nodeType === 3 && (i += c.nodeValue.length), (h = c.firstChild) !== null;) f = c, c = h;
          for (;;) {
            if (c === e) break t;
            if (f === n && ++u === s && (a = i), f === o && ++d === r && (l = i), (h = c.nextSibling) !== null) break;
            c = f, f = c.parentNode;
          }
          c = h;
        }
        n = a === -1 || l === -1 ? null : {
          start: a,
          end: l
        };
      } else n = null;
    }
    n = n || {
      start: 0,
      end: 0
    };
  } else n = null;
  for (Nd = {
    focusedElem: e,
    selectionRange: n
  }, Tl = !1, _ = t; _ !== null;) if (t = _, e = t.child, (t.subtreeFlags & 1028) !== 0 && e !== null) e.return = t, _ = e;else for (; _ !== null;) {
    t = _;
    try {
      var w = t.alternate;
      if (t.flags & 1024) switch (t.tag) {
        case 0:
        case 11:
        case 15:
          break;
        case 1:
          if (w !== null) {
            var m = w.memoizedProps,
              x = w.memoizedState,
              g = t.stateNode,
              v = g.getSnapshotBeforeUpdate(t.elementType === t.type ? m : Bt(t.type, m), x);
            g.__reactInternalSnapshotBeforeUpdate = v;
          }
          break;
        case 3:
          var b = t.stateNode.containerInfo;
          b.nodeType === 1 ? b.textContent = "" : b.nodeType === 9 && b.documentElement && b.removeChild(b.documentElement);
          break;
        case 5:
        case 6:
        case 4:
        case 17:
          break;
        default:
          throw Error(M(163));
      }
    } catch (S) {
      Ee(t, t.return, S);
    }
    if (e = t.sibling, e !== null) {
      e.return = t.return, _ = e;
      break;
    }
    _ = t.return;
  }
  return w = lg, lg = !1, w;
}
function ci(e, t, n) {
  var r = t.updateQueue;
  if (r = r !== null ? r.lastEffect : null, r !== null) {
    var s = r = r.next;
    do {
      if ((s.tag & e) === e) {
        var o = s.destroy;
        s.destroy = void 0, o !== void 0 && Hd(t, n, o);
      }
      s = s.next;
    } while (s !== r);
  }
}
function bu(e, t) {
  if (t = t.updateQueue, t = t !== null ? t.lastEffect : null, t !== null) {
    var n = t = t.next;
    do {
      if ((n.tag & e) === e) {
        var r = n.create;
        n.destroy = r();
      }
      n = n.next;
    } while (n !== t);
  }
}
function qd(e) {
  var t = e.ref;
  if (t !== null) {
    var n = e.stateNode;
    switch (e.tag) {
      case 5:
        e = n;
        break;
      default:
        e = n;
    }
    typeof t == "function" ? t(e) : t.current = e;
  }
}
function qx(e) {
  var t = e.alternate;
  t !== null && (e.alternate = null, qx(t)), e.child = null, e.deletions = null, e.sibling = null, e.tag === 5 && (t = e.stateNode, t !== null && (delete t[an], delete t[Ri], delete t[Md], delete t[kT], delete t[RT])), e.stateNode = null, e.return = null, e.dependencies = null, e.memoizedProps = null, e.memoizedState = null, e.pendingProps = null, e.stateNode = null, e.updateQueue = null;
}
function Kx(e) {
  return e.tag === 5 || e.tag === 3 || e.tag === 4;
}
function ug(e) {
  e: for (;;) {
    for (; e.sibling === null;) {
      if (e.return === null || Kx(e.return)) return null;
      e = e.return;
    }
    for (e.sibling.return = e.return, e = e.sibling; e.tag !== 5 && e.tag !== 6 && e.tag !== 18;) {
      if (e.flags & 2 || e.child === null || e.tag === 4) continue e;
      e.child.return = e, e = e.child;
    }
    if (!(e.flags & 2)) return e.stateNode;
  }
}
function Kd(e, t, n) {
  var r = e.tag;
  if (r === 5 || r === 6) e = e.stateNode, t ? n.nodeType === 8 ? n.parentNode.insertBefore(e, t) : n.insertBefore(e, t) : (n.nodeType === 8 ? (t = n.parentNode, t.insertBefore(e, n)) : (t = n, t.appendChild(e)), n = n._reactRootContainer, n != null || t.onclick !== null || (t.onclick = Rl));else if (r !== 4 && (e = e.child, e !== null)) for (Kd(e, t, n), e = e.sibling; e !== null;) Kd(e, t, n), e = e.sibling;
}
function Qd(e, t, n) {
  var r = e.tag;
  if (r === 5 || r === 6) e = e.stateNode, t ? n.insertBefore(e, t) : n.appendChild(e);else if (r !== 4 && (e = e.child, e !== null)) for (Qd(e, t, n), e = e.sibling; e !== null;) Qd(e, t, n), e = e.sibling;
}
var Ie = null,
  Ut = !1;
function qn(e, t, n) {
  for (n = n.child; n !== null;) Qx(e, t, n), n = n.sibling;
}
function Qx(e, t, n) {
  if (cn && typeof cn.onCommitFiberUnmount == "function") try {
    cn.onCommitFiberUnmount(hu, n);
  } catch {}
  switch (n.tag) {
    case 5:
      qe || Fs(n, t);
    case 6:
      var r = Ie,
        s = Ut;
      Ie = null, qn(e, t, n), Ie = r, Ut = s, Ie !== null && (Ut ? (e = Ie, n = n.stateNode, e.nodeType === 8 ? e.parentNode.removeChild(n) : e.removeChild(n)) : Ie.removeChild(n.stateNode));
      break;
    case 18:
      Ie !== null && (Ut ? (e = Ie, n = n.stateNode, e.nodeType === 8 ? gc(e.parentNode, n) : e.nodeType === 1 && gc(e, n), Ei(e)) : gc(Ie, n.stateNode));
      break;
    case 4:
      r = Ie, s = Ut, Ie = n.stateNode.containerInfo, Ut = !0, qn(e, t, n), Ie = r, Ut = s;
      break;
    case 0:
    case 11:
    case 14:
    case 15:
      if (!qe && (r = n.updateQueue, r !== null && (r = r.lastEffect, r !== null))) {
        s = r = r.next;
        do {
          var o = s,
            i = o.destroy;
          o = o.tag, i !== void 0 && (o & 2 || o & 4) && Hd(n, t, i), s = s.next;
        } while (s !== r);
      }
      qn(e, t, n);
      break;
    case 1:
      if (!qe && (Fs(n, t), r = n.stateNode, typeof r.componentWillUnmount == "function")) try {
        r.props = n.memoizedProps, r.state = n.memoizedState, r.componentWillUnmount();
      } catch (a) {
        Ee(n, t, a);
      }
      qn(e, t, n);
      break;
    case 21:
      qn(e, t, n);
      break;
    case 22:
      n.mode & 1 ? (qe = (r = qe) || n.memoizedState !== null, qn(e, t, n), qe = r) : qn(e, t, n);
      break;
    default:
      qn(e, t, n);
  }
}
function cg(e) {
  var t = e.updateQueue;
  if (t !== null) {
    e.updateQueue = null;
    var n = e.stateNode;
    n === null && (n = e.stateNode = new WT()), t.forEach(function (r) {
      var s = eP.bind(null, e, r);
      n.has(r) || (n.add(r), r.then(s, s));
    });
  }
}
function It(e, t) {
  var n = t.deletions;
  if (n !== null) for (var r = 0; r < n.length; r++) {
    var s = n[r];
    try {
      var o = e,
        i = t,
        a = i;
      e: for (; a !== null;) {
        switch (a.tag) {
          case 5:
            Ie = a.stateNode, Ut = !1;
            break e;
          case 3:
            Ie = a.stateNode.containerInfo, Ut = !0;
            break e;
          case 4:
            Ie = a.stateNode.containerInfo, Ut = !0;
            break e;
        }
        a = a.return;
      }
      if (Ie === null) throw Error(M(160));
      Qx(o, i, s), Ie = null, Ut = !1;
      var l = s.alternate;
      l !== null && (l.return = null), s.return = null;
    } catch (u) {
      Ee(s, t, u);
    }
  }
  if (t.subtreeFlags & 12854) for (t = t.child; t !== null;) Gx(t, e), t = t.sibling;
}
function Gx(e, t) {
  var n = e.alternate,
    r = e.flags;
  switch (e.tag) {
    case 0:
    case 11:
    case 14:
    case 15:
      if (It(t, e), Zt(e), r & 4) {
        try {
          ci(3, e, e.return), bu(3, e);
        } catch (m) {
          Ee(e, e.return, m);
        }
        try {
          ci(5, e, e.return);
        } catch (m) {
          Ee(e, e.return, m);
        }
      }
      break;
    case 1:
      It(t, e), Zt(e), r & 512 && n !== null && Fs(n, n.return);
      break;
    case 5:
      if (It(t, e), Zt(e), r & 512 && n !== null && Fs(n, n.return), e.flags & 32) {
        var s = e.stateNode;
        try {
          xi(s, "");
        } catch (m) {
          Ee(e, e.return, m);
        }
      }
      if (r & 4 && (s = e.stateNode, s != null)) {
        var o = e.memoizedProps,
          i = n !== null ? n.memoizedProps : o,
          a = e.type,
          l = e.updateQueue;
        if (e.updateQueue = null, l !== null) try {
          a === "input" && o.type === "radio" && o.name != null && y0(s, o), vd(a, i);
          var u = vd(a, o);
          for (i = 0; i < l.length; i += 2) {
            var d = l[i],
              c = l[i + 1];
            d === "style" ? S0(s, c) : d === "dangerouslySetInnerHTML" ? w0(s, c) : d === "children" ? xi(s, c) : uh(s, d, c, u);
          }
          switch (a) {
            case "input":
              hd(s, o);
              break;
            case "textarea":
              v0(s, o);
              break;
            case "select":
              var f = s._wrapperState.wasMultiple;
              s._wrapperState.wasMultiple = !!o.multiple;
              var h = o.value;
              h != null ? $s(s, !!o.multiple, h, !1) : f !== !!o.multiple && (o.defaultValue != null ? $s(s, !!o.multiple, o.defaultValue, !0) : $s(s, !!o.multiple, o.multiple ? [] : "", !1));
          }
          s[Ri] = o;
        } catch (m) {
          Ee(e, e.return, m);
        }
      }
      break;
    case 6:
      if (It(t, e), Zt(e), r & 4) {
        if (e.stateNode === null) throw Error(M(162));
        s = e.stateNode, o = e.memoizedProps;
        try {
          s.nodeValue = o;
        } catch (m) {
          Ee(e, e.return, m);
        }
      }
      break;
    case 3:
      if (It(t, e), Zt(e), r & 4 && n !== null && n.memoizedState.isDehydrated) try {
        Ei(t.containerInfo);
      } catch (m) {
        Ee(e, e.return, m);
      }
      break;
    case 4:
      It(t, e), Zt(e);
      break;
    case 13:
      It(t, e), Zt(e), s = e.child, s.flags & 8192 && (o = s.memoizedState !== null, s.stateNode.isHidden = o, !o || s.alternate !== null && s.alternate.memoizedState !== null || ($h = Ce())), r & 4 && cg(e);
      break;
    case 22:
      if (d = n !== null && n.memoizedState !== null, e.mode & 1 ? (qe = (u = qe) || d, It(t, e), qe = u) : It(t, e), Zt(e), r & 8192) {
        if (u = e.memoizedState !== null, (e.stateNode.isHidden = u) && !d && e.mode & 1) for (_ = e, d = e.child; d !== null;) {
          for (c = _ = d; _ !== null;) {
            switch (f = _, h = f.child, f.tag) {
              case 0:
              case 11:
              case 14:
              case 15:
                ci(4, f, f.return);
                break;
              case 1:
                Fs(f, f.return);
                var w = f.stateNode;
                if (typeof w.componentWillUnmount == "function") {
                  r = f, n = f.return;
                  try {
                    t = r, w.props = t.memoizedProps, w.state = t.memoizedState, w.componentWillUnmount();
                  } catch (m) {
                    Ee(r, n, m);
                  }
                }
                break;
              case 5:
                Fs(f, f.return);
                break;
              case 22:
                if (f.memoizedState !== null) {
                  fg(c);
                  continue;
                }
            }
            h !== null ? (h.return = f, _ = h) : fg(c);
          }
          d = d.sibling;
        }
        e: for (d = null, c = e;;) {
          if (c.tag === 5) {
            if (d === null) {
              d = c;
              try {
                s = c.stateNode, u ? (o = s.style, typeof o.setProperty == "function" ? o.setProperty("display", "none", "important") : o.display = "none") : (a = c.stateNode, l = c.memoizedProps.style, i = l != null && l.hasOwnProperty("display") ? l.display : null, a.style.display = b0("display", i));
              } catch (m) {
                Ee(e, e.return, m);
              }
            }
          } else if (c.tag === 6) {
            if (d === null) try {
              c.stateNode.nodeValue = u ? "" : c.memoizedProps;
            } catch (m) {
              Ee(e, e.return, m);
            }
          } else if ((c.tag !== 22 && c.tag !== 23 || c.memoizedState === null || c === e) && c.child !== null) {
            c.child.return = c, c = c.child;
            continue;
          }
          if (c === e) break e;
          for (; c.sibling === null;) {
            if (c.return === null || c.return === e) break e;
            d === c && (d = null), c = c.return;
          }
          d === c && (d = null), c.sibling.return = c.return, c = c.sibling;
        }
      }
      break;
    case 19:
      It(t, e), Zt(e), r & 4 && cg(e);
      break;
    case 21:
      break;
    default:
      It(t, e), Zt(e);
  }
}
function Zt(e) {
  var t = e.flags;
  if (t & 2) {
    try {
      e: {
        for (var n = e.return; n !== null;) {
          if (Kx(n)) {
            var r = n;
            break e;
          }
          n = n.return;
        }
        throw Error(M(160));
      }
      switch (r.tag) {
        case 5:
          var s = r.stateNode;
          r.flags & 32 && (xi(s, ""), r.flags &= -33);
          var o = ug(e);
          Qd(e, o, s);
          break;
        case 3:
        case 4:
          var i = r.stateNode.containerInfo,
            a = ug(e);
          Kd(e, a, i);
          break;
        default:
          throw Error(M(161));
      }
    } catch (l) {
      Ee(e, e.return, l);
    }
    e.flags &= -3;
  }
  t & 4096 && (e.flags &= -4097);
}
function qT(e, t, n) {
  _ = e, Yx(e);
}
function Yx(e, t, n) {
  for (var r = (e.mode & 1) !== 0; _ !== null;) {
    var s = _,
      o = s.child;
    if (s.tag === 22 && r) {
      var i = s.memoizedState !== null || Aa;
      if (!i) {
        var a = s.alternate,
          l = a !== null && a.memoizedState !== null || qe;
        a = Aa;
        var u = qe;
        if (Aa = i, (qe = l) && !u) for (_ = s; _ !== null;) i = _, l = i.child, i.tag === 22 && i.memoizedState !== null ? hg(s) : l !== null ? (l.return = i, _ = l) : hg(s);
        for (; o !== null;) _ = o, Yx(o), o = o.sibling;
        _ = s, Aa = a, qe = u;
      }
      dg(e);
    } else s.subtreeFlags & 8772 && o !== null ? (o.return = s, _ = o) : dg(e);
  }
}
function dg(e) {
  for (; _ !== null;) {
    var t = _;
    if (t.flags & 8772) {
      var n = t.alternate;
      try {
        if (t.flags & 8772) switch (t.tag) {
          case 0:
          case 11:
          case 15:
            qe || bu(5, t);
            break;
          case 1:
            var r = t.stateNode;
            if (t.flags & 4 && !qe) if (n === null) r.componentDidMount();else {
              var s = t.elementType === t.type ? n.memoizedProps : Bt(t.type, n.memoizedProps);
              r.componentDidUpdate(s, n.memoizedState, r.__reactInternalSnapshotBeforeUpdate);
            }
            var o = t.updateQueue;
            o !== null && Gm(t, o, r);
            break;
          case 3:
            var i = t.updateQueue;
            if (i !== null) {
              if (n = null, t.child !== null) switch (t.child.tag) {
                case 5:
                  n = t.child.stateNode;
                  break;
                case 1:
                  n = t.child.stateNode;
              }
              Gm(t, i, n);
            }
            break;
          case 5:
            var a = t.stateNode;
            if (n === null && t.flags & 4) {
              n = a;
              var l = t.memoizedProps;
              switch (t.type) {
                case "button":
                case "input":
                case "select":
                case "textarea":
                  l.autoFocus && n.focus();
                  break;
                case "img":
                  l.src && (n.src = l.src);
              }
            }
            break;
          case 6:
            break;
          case 4:
            break;
          case 12:
            break;
          case 13:
            if (t.memoizedState === null) {
              var u = t.alternate;
              if (u !== null) {
                var d = u.memoizedState;
                if (d !== null) {
                  var c = d.dehydrated;
                  c !== null && Ei(c);
                }
              }
            }
            break;
          case 19:
          case 17:
          case 21:
          case 22:
          case 23:
          case 25:
            break;
          default:
            throw Error(M(163));
        }
        qe || t.flags & 512 && qd(t);
      } catch (f) {
        Ee(t, t.return, f);
      }
    }
    if (t === e) {
      _ = null;
      break;
    }
    if (n = t.sibling, n !== null) {
      n.return = t.return, _ = n;
      break;
    }
    _ = t.return;
  }
}
function fg(e) {
  for (; _ !== null;) {
    var t = _;
    if (t === e) {
      _ = null;
      break;
    }
    var n = t.sibling;
    if (n !== null) {
      n.return = t.return, _ = n;
      break;
    }
    _ = t.return;
  }
}
function hg(e) {
  for (; _ !== null;) {
    var t = _;
    try {
      switch (t.tag) {
        case 0:
        case 11:
        case 15:
          var n = t.return;
          try {
            bu(4, t);
          } catch (l) {
            Ee(t, n, l);
          }
          break;
        case 1:
          var r = t.stateNode;
          if (typeof r.componentDidMount == "function") {
            var s = t.return;
            try {
              r.componentDidMount();
            } catch (l) {
              Ee(t, s, l);
            }
          }
          var o = t.return;
          try {
            qd(t);
          } catch (l) {
            Ee(t, o, l);
          }
          break;
        case 5:
          var i = t.return;
          try {
            qd(t);
          } catch (l) {
            Ee(t, i, l);
          }
      }
    } catch (l) {
      Ee(t, t.return, l);
    }
    if (t === e) {
      _ = null;
      break;
    }
    var a = t.sibling;
    if (a !== null) {
      a.return = t.return, _ = a;
      break;
    }
    _ = t.return;
  }
}
var KT = Math.ceil,
  Vl = Dn.ReactCurrentDispatcher,
  Bh = Dn.ReactCurrentOwner,
  Nt = Dn.ReactCurrentBatchConfig,
  ne = 0,
  De = null,
  ke = null,
  Be = 0,
  ft = 0,
  _s = Mr(0),
  je = 0,
  Li = null,
  us = 0,
  Su = 0,
  zh = 0,
  di = null,
  it = null,
  $h = 0,
  yo = 1 / 0,
  bn = null,
  Bl = !1,
  Gd = null,
  xr = null,
  ja = !1,
  dr = null,
  zl = 0,
  fi = 0,
  Yd = null,
  rl = -1,
  sl = 0;
function Je() {
  return ne & 6 ? Ce() : rl !== -1 ? rl : rl = Ce();
}
function wr(e) {
  return e.mode & 1 ? ne & 2 && Be !== 0 ? Be & -Be : AT.transition !== null ? (sl === 0 && (sl = L0()), sl) : (e = oe, e !== 0 || (e = window.event, e = e === void 0 ? 16 : z0(e.type)), e) : 1;
}
function qt(e, t, n, r) {
  if (50 < fi) throw fi = 0, Yd = null, Error(M(185));
  Xi(e, n, r), (!(ne & 2) || e !== De) && (e === De && (!(ne & 2) && (Su |= n), je === 4 && tr(e, Be)), ct(e, r), n === 1 && ne === 0 && !(t.mode & 1) && (yo = Ce() + 500, vu && Or()));
}
function ct(e, t) {
  var n = e.callbackNode;
  AC(e, t);
  var r = Cl(e, e === De ? Be : 0);
  if (r === 0) n !== null && Sm(n), e.callbackNode = null, e.callbackPriority = 0;else if (t = r & -r, e.callbackPriority !== t) {
    if (n != null && Sm(n), t === 1) e.tag === 0 ? NT(pg.bind(null, e)) : ix(pg.bind(null, e)), TT(function () {
      !(ne & 6) && Or();
    }), n = null;else {
      switch (D0(r)) {
        case 1:
          n = ph;
          break;
        case 4:
          n = M0;
          break;
        case 16:
          n = El;
          break;
        case 536870912:
          n = O0;
          break;
        default:
          n = El;
      }
      n = sw(n, Xx.bind(null, e));
    }
    e.callbackPriority = t, e.callbackNode = n;
  }
}
function Xx(e, t) {
  if (rl = -1, sl = 0, ne & 6) throw Error(M(327));
  var n = e.callbackNode;
  if (Ks() && e.callbackNode !== n) return null;
  var r = Cl(e, e === De ? Be : 0);
  if (r === 0) return null;
  if (r & 30 || r & e.expiredLanes || t) t = $l(e, r);else {
    t = r;
    var s = ne;
    ne |= 2;
    var o = Jx();
    (De !== e || Be !== t) && (bn = null, yo = Ce() + 500, ns(e, t));
    do try {
      YT();
      break;
    } catch (a) {
      Zx(e, a);
    } while (!0);
    kh(), Vl.current = o, ne = s, ke !== null ? t = 0 : (De = null, Be = 0, t = je);
  }
  if (t !== 0) {
    if (t === 2 && (s = Ed(e), s !== 0 && (r = s, t = Xd(e, s))), t === 1) throw n = Li, ns(e, 0), tr(e, r), ct(e, Ce()), n;
    if (t === 6) tr(e, r);else {
      if (s = e.current.alternate, !(r & 30) && !QT(s) && (t = $l(e, r), t === 2 && (o = Ed(e), o !== 0 && (r = o, t = Xd(e, o))), t === 1)) throw n = Li, ns(e, 0), tr(e, r), ct(e, Ce()), n;
      switch (e.finishedWork = s, e.finishedLanes = r, t) {
        case 0:
        case 1:
          throw Error(M(345));
        case 2:
          Br(e, it, bn);
          break;
        case 3:
          if (tr(e, r), (r & 130023424) === r && (t = $h + 500 - Ce(), 10 < t)) {
            if (Cl(e, 0) !== 0) break;
            if (s = e.suspendedLanes, (s & r) !== r) {
              Je(), e.pingedLanes |= e.suspendedLanes & s;
              break;
            }
            e.timeoutHandle = jd(Br.bind(null, e, it, bn), t);
            break;
          }
          Br(e, it, bn);
          break;
        case 4:
          if (tr(e, r), (r & 4194240) === r) break;
          for (t = e.eventTimes, s = -1; 0 < r;) {
            var i = 31 - Ht(r);
            o = 1 << i, i = t[i], i > s && (s = i), r &= ~o;
          }
          if (r = s, r = Ce() - r, r = (120 > r ? 120 : 480 > r ? 480 : 1080 > r ? 1080 : 1920 > r ? 1920 : 3e3 > r ? 3e3 : 4320 > r ? 4320 : 1960 * KT(r / 1960)) - r, 10 < r) {
            e.timeoutHandle = jd(Br.bind(null, e, it, bn), r);
            break;
          }
          Br(e, it, bn);
          break;
        case 5:
          Br(e, it, bn);
          break;
        default:
          throw Error(M(329));
      }
    }
  }
  return ct(e, Ce()), e.callbackNode === n ? Xx.bind(null, e) : null;
}
function Xd(e, t) {
  var n = di;
  return e.current.memoizedState.isDehydrated && (ns(e, t).flags |= 256), e = $l(e, t), e !== 2 && (t = it, it = n, t !== null && Zd(t)), e;
}
function Zd(e) {
  it === null ? it = e : it.push.apply(it, e);
}
function QT(e) {
  for (var t = e;;) {
    if (t.flags & 16384) {
      var n = t.updateQueue;
      if (n !== null && (n = n.stores, n !== null)) for (var r = 0; r < n.length; r++) {
        var s = n[r],
          o = s.getSnapshot;
        s = s.value;
        try {
          if (!Qt(o(), s)) return !1;
        } catch {
          return !1;
        }
      }
    }
    if (n = t.child, t.subtreeFlags & 16384 && n !== null) n.return = t, t = n;else {
      if (t === e) break;
      for (; t.sibling === null;) {
        if (t.return === null || t.return === e) return !0;
        t = t.return;
      }
      t.sibling.return = t.return, t = t.sibling;
    }
  }
  return !0;
}
function tr(e, t) {
  for (t &= ~zh, t &= ~Su, e.suspendedLanes |= t, e.pingedLanes &= ~t, e = e.expirationTimes; 0 < t;) {
    var n = 31 - Ht(t),
      r = 1 << n;
    e[n] = -1, t &= ~r;
  }
}
function pg(e) {
  if (ne & 6) throw Error(M(327));
  Ks();
  var t = Cl(e, 0);
  if (!(t & 1)) return ct(e, Ce()), null;
  var n = $l(e, t);
  if (e.tag !== 0 && n === 2) {
    var r = Ed(e);
    r !== 0 && (t = r, n = Xd(e, r));
  }
  if (n === 1) throw n = Li, ns(e, 0), tr(e, t), ct(e, Ce()), n;
  if (n === 6) throw Error(M(345));
  return e.finishedWork = e.current.alternate, e.finishedLanes = t, Br(e, it, bn), ct(e, Ce()), null;
}
function Uh(e, t) {
  var n = ne;
  ne |= 1;
  try {
    return e(t);
  } finally {
    ne = n, ne === 0 && (yo = Ce() + 500, vu && Or());
  }
}
function cs(e) {
  dr !== null && dr.tag === 0 && !(ne & 6) && Ks();
  var t = ne;
  ne |= 1;
  var n = Nt.transition,
    r = oe;
  try {
    if (Nt.transition = null, oe = 1, e) return e();
  } finally {
    oe = r, Nt.transition = n, ne = t, !(ne & 6) && Or();
  }
}
function Wh() {
  ft = _s.current, fe(_s);
}
function ns(e, t) {
  e.finishedWork = null, e.finishedLanes = 0;
  var n = e.timeoutHandle;
  if (n !== -1 && (e.timeoutHandle = -1, CT(n)), ke !== null) for (n = ke.return; n !== null;) {
    var r = n;
    switch (Ch(r), r.tag) {
      case 1:
        r = r.type.childContextTypes, r != null && Nl();
        break;
      case 3:
        mo(), fe(lt), fe(Ke), Oh();
        break;
      case 5:
        Mh(r);
        break;
      case 4:
        mo();
        break;
      case 13:
        fe(ve);
        break;
      case 19:
        fe(ve);
        break;
      case 10:
        Rh(r.type._context);
        break;
      case 22:
      case 23:
        Wh();
    }
    n = n.return;
  }
  if (De = e, ke = e = br(e.current, null), Be = ft = t, je = 0, Li = null, zh = Su = us = 0, it = di = null, Ur !== null) {
    for (t = 0; t < Ur.length; t++) if (n = Ur[t], r = n.interleaved, r !== null) {
      n.interleaved = null;
      var s = r.next,
        o = n.pending;
      if (o !== null) {
        var i = o.next;
        o.next = s, r.next = i;
      }
      n.pending = r;
    }
    Ur = null;
  }
  return e;
}
function Zx(e, t) {
  do {
    var n = ke;
    try {
      if (kh(), el.current = _l, Fl) {
        for (var r = xe.memoizedState; r !== null;) {
          var s = r.queue;
          s !== null && (s.pending = null), r = r.next;
        }
        Fl = !1;
      }
      if (ls = 0, Oe = Ae = xe = null, ui = !1, ji = 0, Bh.current = null, n === null || n.return === null) {
        je = 1, Li = t, ke = null;
        break;
      }
      e: {
        var o = e,
          i = n.return,
          a = n,
          l = t;
        if (t = Be, a.flags |= 32768, l !== null && typeof l == "object" && typeof l.then == "function") {
          var u = l,
            d = a,
            c = d.tag;
          if (!(d.mode & 1) && (c === 0 || c === 11 || c === 15)) {
            var f = d.alternate;
            f ? (d.updateQueue = f.updateQueue, d.memoizedState = f.memoizedState, d.lanes = f.lanes) : (d.updateQueue = null, d.memoizedState = null);
          }
          var h = tg(i);
          if (h !== null) {
            h.flags &= -257, ng(h, i, a, o, t), h.mode & 1 && eg(o, u, t), t = h, l = u;
            var w = t.updateQueue;
            if (w === null) {
              var m = new Set();
              m.add(l), t.updateQueue = m;
            } else w.add(l);
            break e;
          } else {
            if (!(t & 1)) {
              eg(o, u, t), Hh();
              break e;
            }
            l = Error(M(426));
          }
        } else if (me && a.mode & 1) {
          var x = tg(i);
          if (x !== null) {
            !(x.flags & 65536) && (x.flags |= 256), ng(x, i, a, o, t), Th(go(l, a));
            break e;
          }
        }
        o = l = go(l, a), je !== 4 && (je = 2), di === null ? di = [o] : di.push(o), o = i;
        do {
          switch (o.tag) {
            case 3:
              o.flags |= 65536, t &= -t, o.lanes |= t;
              var g = Dx(o, l, t);
              Qm(o, g);
              break e;
            case 1:
              a = l;
              var v = o.type,
                b = o.stateNode;
              if (!(o.flags & 128) && (typeof v.getDerivedStateFromError == "function" || b !== null && typeof b.componentDidCatch == "function" && (xr === null || !xr.has(b)))) {
                o.flags |= 65536, t &= -t, o.lanes |= t;
                var S = Ix(o, a, t);
                Qm(o, S);
                break e;
              }
          }
          o = o.return;
        } while (o !== null);
      }
      tw(n);
    } catch (E) {
      t = E, ke === n && n !== null && (ke = n = n.return);
      continue;
    }
    break;
  } while (!0);
}
function Jx() {
  var e = Vl.current;
  return Vl.current = _l, e === null ? _l : e;
}
function Hh() {
  (je === 0 || je === 3 || je === 2) && (je = 4), De === null || !(us & 268435455) && !(Su & 268435455) || tr(De, Be);
}
function $l(e, t) {
  var n = ne;
  ne |= 2;
  var r = Jx();
  (De !== e || Be !== t) && (bn = null, ns(e, t));
  do try {
    GT();
    break;
  } catch (s) {
    Zx(e, s);
  } while (!0);
  if (kh(), ne = n, Vl.current = r, ke !== null) throw Error(M(261));
  return De = null, Be = 0, je;
}
function GT() {
  for (; ke !== null;) ew(ke);
}
function YT() {
  for (; ke !== null && !bC();) ew(ke);
}
function ew(e) {
  var t = rw(e.alternate, e, ft);
  e.memoizedProps = e.pendingProps, t === null ? tw(e) : ke = t, Bh.current = null;
}
function tw(e) {
  var t = e;
  do {
    var n = t.alternate;
    if (e = t.return, t.flags & 32768) {
      if (n = UT(n, t), n !== null) {
        n.flags &= 32767, ke = n;
        return;
      }
      if (e !== null) e.flags |= 32768, e.subtreeFlags = 0, e.deletions = null;else {
        je = 6, ke = null;
        return;
      }
    } else if (n = $T(n, t, ft), n !== null) {
      ke = n;
      return;
    }
    if (t = t.sibling, t !== null) {
      ke = t;
      return;
    }
    ke = t = e;
  } while (t !== null);
  je === 0 && (je = 5);
}
function Br(e, t, n) {
  var r = oe,
    s = Nt.transition;
  try {
    Nt.transition = null, oe = 1, XT(e, t, n, r);
  } finally {
    Nt.transition = s, oe = r;
  }
  return null;
}
function XT(e, t, n, r) {
  do Ks(); while (dr !== null);
  if (ne & 6) throw Error(M(327));
  n = e.finishedWork;
  var s = e.finishedLanes;
  if (n === null) return null;
  if (e.finishedWork = null, e.finishedLanes = 0, n === e.current) throw Error(M(177));
  e.callbackNode = null, e.callbackPriority = 0;
  var o = n.lanes | n.childLanes;
  if (jC(e, o), e === De && (ke = De = null, Be = 0), !(n.subtreeFlags & 2064) && !(n.flags & 2064) || ja || (ja = !0, sw(El, function () {
    return Ks(), null;
  })), o = (n.flags & 15990) !== 0, n.subtreeFlags & 15990 || o) {
    o = Nt.transition, Nt.transition = null;
    var i = oe;
    oe = 1;
    var a = ne;
    ne |= 4, Bh.current = null, HT(e, n), Gx(n, e), yT(Nd), Tl = !!Rd, Nd = Rd = null, e.current = n, qT(n), SC(), ne = a, oe = i, Nt.transition = o;
  } else e.current = n;
  if (ja && (ja = !1, dr = e, zl = s), o = e.pendingLanes, o === 0 && (xr = null), TC(n.stateNode), ct(e, Ce()), t !== null) for (r = e.onRecoverableError, n = 0; n < t.length; n++) s = t[n], r(s.value, {
    componentStack: s.stack,
    digest: s.digest
  });
  if (Bl) throw Bl = !1, e = Gd, Gd = null, e;
  return zl & 1 && e.tag !== 0 && Ks(), o = e.pendingLanes, o & 1 ? e === Yd ? fi++ : (fi = 0, Yd = e) : fi = 0, Or(), null;
}
function Ks() {
  if (dr !== null) {
    var e = D0(zl),
      t = Nt.transition,
      n = oe;
    try {
      if (Nt.transition = null, oe = 16 > e ? 16 : e, dr === null) var r = !1;else {
        if (e = dr, dr = null, zl = 0, ne & 6) throw Error(M(331));
        var s = ne;
        for (ne |= 4, _ = e.current; _ !== null;) {
          var o = _,
            i = o.child;
          if (_.flags & 16) {
            var a = o.deletions;
            if (a !== null) {
              for (var l = 0; l < a.length; l++) {
                var u = a[l];
                for (_ = u; _ !== null;) {
                  var d = _;
                  switch (d.tag) {
                    case 0:
                    case 11:
                    case 15:
                      ci(8, d, o);
                  }
                  var c = d.child;
                  if (c !== null) c.return = d, _ = c;else for (; _ !== null;) {
                    d = _;
                    var f = d.sibling,
                      h = d.return;
                    if (qx(d), d === u) {
                      _ = null;
                      break;
                    }
                    if (f !== null) {
                      f.return = h, _ = f;
                      break;
                    }
                    _ = h;
                  }
                }
              }
              var w = o.alternate;
              if (w !== null) {
                var m = w.child;
                if (m !== null) {
                  w.child = null;
                  do {
                    var x = m.sibling;
                    m.sibling = null, m = x;
                  } while (m !== null);
                }
              }
              _ = o;
            }
          }
          if (o.subtreeFlags & 2064 && i !== null) i.return = o, _ = i;else e: for (; _ !== null;) {
            if (o = _, o.flags & 2048) switch (o.tag) {
              case 0:
              case 11:
              case 15:
                ci(9, o, o.return);
            }
            var g = o.sibling;
            if (g !== null) {
              g.return = o.return, _ = g;
              break e;
            }
            _ = o.return;
          }
        }
        var v = e.current;
        for (_ = v; _ !== null;) {
          i = _;
          var b = i.child;
          if (i.subtreeFlags & 2064 && b !== null) b.return = i, _ = b;else e: for (i = v; _ !== null;) {
            if (a = _, a.flags & 2048) try {
              switch (a.tag) {
                case 0:
                case 11:
                case 15:
                  bu(9, a);
              }
            } catch (E) {
              Ee(a, a.return, E);
            }
            if (a === i) {
              _ = null;
              break e;
            }
            var S = a.sibling;
            if (S !== null) {
              S.return = a.return, _ = S;
              break e;
            }
            _ = a.return;
          }
        }
        if (ne = s, Or(), cn && typeof cn.onPostCommitFiberRoot == "function") try {
          cn.onPostCommitFiberRoot(hu, e);
        } catch {}
        r = !0;
      }
      return r;
    } finally {
      oe = n, Nt.transition = t;
    }
  }
  return !1;
}
function mg(e, t, n) {
  t = go(n, t), t = Dx(e, t, 1), e = vr(e, t, 1), t = Je(), e !== null && (Xi(e, 1, t), ct(e, t));
}
function Ee(e, t, n) {
  if (e.tag === 3) mg(e, e, n);else for (; t !== null;) {
    if (t.tag === 3) {
      mg(t, e, n);
      break;
    } else if (t.tag === 1) {
      var r = t.stateNode;
      if (typeof t.type.getDerivedStateFromError == "function" || typeof r.componentDidCatch == "function" && (xr === null || !xr.has(r))) {
        e = go(n, e), e = Ix(t, e, 1), t = vr(t, e, 1), e = Je(), t !== null && (Xi(t, 1, e), ct(t, e));
        break;
      }
    }
    t = t.return;
  }
}
function ZT(e, t, n) {
  var r = e.pingCache;
  r !== null && r.delete(t), t = Je(), e.pingedLanes |= e.suspendedLanes & n, De === e && (Be & n) === n && (je === 4 || je === 3 && (Be & 130023424) === Be && 500 > Ce() - $h ? ns(e, 0) : zh |= n), ct(e, t);
}
function nw(e, t) {
  t === 0 && (e.mode & 1 ? (t = ba, ba <<= 1, !(ba & 130023424) && (ba = 4194304)) : t = 1);
  var n = Je();
  e = An(e, t), e !== null && (Xi(e, t, n), ct(e, n));
}
function JT(e) {
  var t = e.memoizedState,
    n = 0;
  t !== null && (n = t.retryLane), nw(e, n);
}
function eP(e, t) {
  var n = 0;
  switch (e.tag) {
    case 13:
      var r = e.stateNode,
        s = e.memoizedState;
      s !== null && (n = s.retryLane);
      break;
    case 19:
      r = e.stateNode;
      break;
    default:
      throw Error(M(314));
  }
  r !== null && r.delete(t), nw(e, n);
}
var rw;
rw = function (e, t, n) {
  if (e !== null) {
    if (e.memoizedProps !== t.pendingProps || lt.current) at = !0;else {
      if (!(e.lanes & n) && !(t.flags & 128)) return at = !1, zT(e, t, n);
      at = !!(e.flags & 131072);
    }
  } else at = !1, me && t.flags & 1048576 && ax(t, Ml, t.index);
  switch (t.lanes = 0, t.tag) {
    case 2:
      var r = t.type;
      nl(e, t), e = t.pendingProps;
      var s = fo(t, Ke.current);
      qs(t, n), s = Dh(null, t, r, e, s, n);
      var o = Ih();
      return t.flags |= 1, typeof s == "object" && s !== null && typeof s.render == "function" && s.$$typeof === void 0 ? (t.tag = 1, t.memoizedState = null, t.updateQueue = null, ut(r) ? (o = !0, Al(t)) : o = !1, t.memoizedState = s.state !== null && s.state !== void 0 ? s.state : null, Ah(t), s.updater = wu, t.stateNode = s, s._reactInternals = t, _d(t, r, e, n), t = zd(null, t, r, !0, o, n)) : (t.tag = 0, me && o && Eh(t), Ye(null, t, s, n), t = t.child), t;
    case 16:
      r = t.elementType;
      e: {
        switch (nl(e, t), e = t.pendingProps, s = r._init, r = s(r._payload), t.type = r, s = t.tag = nP(r), e = Bt(r, e), s) {
          case 0:
            t = Bd(null, t, r, e, n);
            break e;
          case 1:
            t = og(null, t, r, e, n);
            break e;
          case 11:
            t = rg(null, t, r, e, n);
            break e;
          case 14:
            t = sg(null, t, r, Bt(r.type, e), n);
            break e;
        }
        throw Error(M(306, r, ""));
      }
      return t;
    case 0:
      return r = t.type, s = t.pendingProps, s = t.elementType === r ? s : Bt(r, s), Bd(e, t, r, s, n);
    case 1:
      return r = t.type, s = t.pendingProps, s = t.elementType === r ? s : Bt(r, s), og(e, t, r, s, n);
    case 3:
      e: {
        if (Bx(t), e === null) throw Error(M(387));
        r = t.pendingProps, o = t.memoizedState, s = o.element, hx(e, t), Dl(t, r, null, n);
        var i = t.memoizedState;
        if (r = i.element, o.isDehydrated) {
          if (o = {
            element: r,
            isDehydrated: !1,
            cache: i.cache,
            pendingSuspenseBoundaries: i.pendingSuspenseBoundaries,
            transitions: i.transitions
          }, t.updateQueue.baseState = o, t.memoizedState = o, t.flags & 256) {
            s = go(Error(M(423)), t), t = ig(e, t, r, n, s);
            break e;
          } else if (r !== s) {
            s = go(Error(M(424)), t), t = ig(e, t, r, n, s);
            break e;
          } else for (pt = yr(t.stateNode.containerInfo.firstChild), mt = t, me = !0, Wt = null, n = dx(t, null, r, n), t.child = n; n;) n.flags = n.flags & -3 | 4096, n = n.sibling;
        } else {
          if (ho(), r === s) {
            t = jn(e, t, n);
            break e;
          }
          Ye(e, t, r, n);
        }
        t = t.child;
      }
      return t;
    case 5:
      return px(t), e === null && Dd(t), r = t.type, s = t.pendingProps, o = e !== null ? e.memoizedProps : null, i = s.children, Ad(r, s) ? i = null : o !== null && Ad(r, o) && (t.flags |= 32), Vx(e, t), Ye(e, t, i, n), t.child;
    case 6:
      return e === null && Dd(t), null;
    case 13:
      return zx(e, t, n);
    case 4:
      return jh(t, t.stateNode.containerInfo), r = t.pendingProps, e === null ? t.child = po(t, null, r, n) : Ye(e, t, r, n), t.child;
    case 11:
      return r = t.type, s = t.pendingProps, s = t.elementType === r ? s : Bt(r, s), rg(e, t, r, s, n);
    case 7:
      return Ye(e, t, t.pendingProps, n), t.child;
    case 8:
      return Ye(e, t, t.pendingProps.children, n), t.child;
    case 12:
      return Ye(e, t, t.pendingProps.children, n), t.child;
    case 10:
      e: {
        if (r = t.type._context, s = t.pendingProps, o = t.memoizedProps, i = s.value, ue(Ol, r._currentValue), r._currentValue = i, o !== null) if (Qt(o.value, i)) {
          if (o.children === s.children && !lt.current) {
            t = jn(e, t, n);
            break e;
          }
        } else for (o = t.child, o !== null && (o.return = t); o !== null;) {
          var a = o.dependencies;
          if (a !== null) {
            i = o.child;
            for (var l = a.firstContext; l !== null;) {
              if (l.context === r) {
                if (o.tag === 1) {
                  l = kn(-1, n & -n), l.tag = 2;
                  var u = o.updateQueue;
                  if (u !== null) {
                    u = u.shared;
                    var d = u.pending;
                    d === null ? l.next = l : (l.next = d.next, d.next = l), u.pending = l;
                  }
                }
                o.lanes |= n, l = o.alternate, l !== null && (l.lanes |= n), Id(o.return, n, t), a.lanes |= n;
                break;
              }
              l = l.next;
            }
          } else if (o.tag === 10) i = o.type === t.type ? null : o.child;else if (o.tag === 18) {
            if (i = o.return, i === null) throw Error(M(341));
            i.lanes |= n, a = i.alternate, a !== null && (a.lanes |= n), Id(i, n, t), i = o.sibling;
          } else i = o.child;
          if (i !== null) i.return = o;else for (i = o; i !== null;) {
            if (i === t) {
              i = null;
              break;
            }
            if (o = i.sibling, o !== null) {
              o.return = i.return, i = o;
              break;
            }
            i = i.return;
          }
          o = i;
        }
        Ye(e, t, s.children, n), t = t.child;
      }
      return t;
    case 9:
      return s = t.type, r = t.pendingProps.children, qs(t, n), s = jt(s), r = r(s), t.flags |= 1, Ye(e, t, r, n), t.child;
    case 14:
      return r = t.type, s = Bt(r, t.pendingProps), s = Bt(r.type, s), sg(e, t, r, s, n);
    case 15:
      return Fx(e, t, t.type, t.pendingProps, n);
    case 17:
      return r = t.type, s = t.pendingProps, s = t.elementType === r ? s : Bt(r, s), nl(e, t), t.tag = 1, ut(r) ? (e = !0, Al(t)) : e = !1, qs(t, n), Lx(t, r, s), _d(t, r, s, n), zd(null, t, r, !0, e, n);
    case 19:
      return $x(e, t, n);
    case 22:
      return _x(e, t, n);
  }
  throw Error(M(156, t.tag));
};
function sw(e, t) {
  return j0(e, t);
}
function tP(e, t, n, r) {
  this.tag = e, this.key = n, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = t, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = r, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
}
function kt(e, t, n, r) {
  return new tP(e, t, n, r);
}
function qh(e) {
  return e = e.prototype, !(!e || !e.isReactComponent);
}
function nP(e) {
  if (typeof e == "function") return qh(e) ? 1 : 0;
  if (e != null) {
    if (e = e.$$typeof, e === dh) return 11;
    if (e === fh) return 14;
  }
  return 2;
}
function br(e, t) {
  var n = e.alternate;
  return n === null ? (n = kt(e.tag, t, e.key, e.mode), n.elementType = e.elementType, n.type = e.type, n.stateNode = e.stateNode, n.alternate = e, e.alternate = n) : (n.pendingProps = t, n.type = e.type, n.flags = 0, n.subtreeFlags = 0, n.deletions = null), n.flags = e.flags & 14680064, n.childLanes = e.childLanes, n.lanes = e.lanes, n.child = e.child, n.memoizedProps = e.memoizedProps, n.memoizedState = e.memoizedState, n.updateQueue = e.updateQueue, t = e.dependencies, n.dependencies = t === null ? null : {
    lanes: t.lanes,
    firstContext: t.firstContext
  }, n.sibling = e.sibling, n.index = e.index, n.ref = e.ref, n;
}
function ol(e, t, n, r, s, o) {
  var i = 2;
  if (r = e, typeof e == "function") qh(e) && (i = 1);else if (typeof e == "string") i = 5;else e: switch (e) {
    case Rs:
      return rs(n.children, s, o, t);
    case ch:
      i = 8, s |= 8;
      break;
    case ld:
      return e = kt(12, n, t, s | 2), e.elementType = ld, e.lanes = o, e;
    case ud:
      return e = kt(13, n, t, s), e.elementType = ud, e.lanes = o, e;
    case cd:
      return e = kt(19, n, t, s), e.elementType = cd, e.lanes = o, e;
    case p0:
      return Eu(n, s, o, t);
    default:
      if (typeof e == "object" && e !== null) switch (e.$$typeof) {
        case f0:
          i = 10;
          break e;
        case h0:
          i = 9;
          break e;
        case dh:
          i = 11;
          break e;
        case fh:
          i = 14;
          break e;
        case Zn:
          i = 16, r = null;
          break e;
      }
      throw Error(M(130, e == null ? e : typeof e, ""));
  }
  return t = kt(i, n, t, s), t.elementType = e, t.type = r, t.lanes = o, t;
}
function rs(e, t, n, r) {
  return e = kt(7, e, r, t), e.lanes = n, e;
}
function Eu(e, t, n, r) {
  return e = kt(22, e, r, t), e.elementType = p0, e.lanes = n, e.stateNode = {
    isHidden: !1
  }, e;
}
function Cc(e, t, n) {
  return e = kt(6, e, null, t), e.lanes = n, e;
}
function Tc(e, t, n) {
  return t = kt(4, e.children !== null ? e.children : [], e.key, t), t.lanes = n, t.stateNode = {
    containerInfo: e.containerInfo,
    pendingChildren: null,
    implementation: e.implementation
  }, t;
}
function rP(e, t, n, r, s) {
  this.tag = t, this.containerInfo = e, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.pendingContext = this.context = null, this.callbackPriority = 0, this.eventTimes = oc(0), this.expirationTimes = oc(-1), this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = oc(0), this.identifierPrefix = r, this.onRecoverableError = s, this.mutableSourceEagerHydrationData = null;
}
function Kh(e, t, n, r, s, o, i, a, l) {
  return e = new rP(e, t, n, a, l), t === 1 ? (t = 1, o === !0 && (t |= 8)) : t = 0, o = kt(3, null, null, t), e.current = o, o.stateNode = e, o.memoizedState = {
    element: r,
    isDehydrated: n,
    cache: null,
    transitions: null,
    pendingSuspenseBoundaries: null
  }, Ah(o), e;
}
function sP(e, t, n) {
  var r = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
  return {
    $$typeof: ks,
    key: r == null ? null : "" + r,
    children: e,
    containerInfo: t,
    implementation: n
  };
}
function ow(e) {
  if (!e) return Tr;
  e = e._reactInternals;
  e: {
    if (ms(e) !== e || e.tag !== 1) throw Error(M(170));
    var t = e;
    do {
      switch (t.tag) {
        case 3:
          t = t.stateNode.context;
          break e;
        case 1:
          if (ut(t.type)) {
            t = t.stateNode.__reactInternalMemoizedMergedChildContext;
            break e;
          }
      }
      t = t.return;
    } while (t !== null);
    throw Error(M(171));
  }
  if (e.tag === 1) {
    var n = e.type;
    if (ut(n)) return ox(e, n, t);
  }
  return t;
}
function iw(e, t, n, r, s, o, i, a, l) {
  return e = Kh(n, r, !0, e, s, o, i, a, l), e.context = ow(null), n = e.current, r = Je(), s = wr(n), o = kn(r, s), o.callback = t ?? null, vr(n, o, s), e.current.lanes = s, Xi(e, s, r), ct(e, r), e;
}
function Cu(e, t, n, r) {
  var s = t.current,
    o = Je(),
    i = wr(s);
  return n = ow(n), t.context === null ? t.context = n : t.pendingContext = n, t = kn(o, i), t.payload = {
    element: e
  }, r = r === void 0 ? null : r, r !== null && (t.callback = r), e = vr(s, t, i), e !== null && (qt(e, s, i, o), Ja(e, s, i)), i;
}
function Ul(e) {
  if (e = e.current, !e.child) return null;
  switch (e.child.tag) {
    case 5:
      return e.child.stateNode;
    default:
      return e.child.stateNode;
  }
}
function gg(e, t) {
  if (e = e.memoizedState, e !== null && e.dehydrated !== null) {
    var n = e.retryLane;
    e.retryLane = n !== 0 && n < t ? n : t;
  }
}
function Qh(e, t) {
  gg(e, t), (e = e.alternate) && gg(e, t);
}
function oP() {
  return null;
}
var aw = typeof reportError == "function" ? reportError : function (e) {
  console.error(e);
};
function Gh(e) {
  this._internalRoot = e;
}
Tu.prototype.render = Gh.prototype.render = function (e) {
  var t = this._internalRoot;
  if (t === null) throw Error(M(409));
  Cu(e, t, null, null);
};
Tu.prototype.unmount = Gh.prototype.unmount = function () {
  var e = this._internalRoot;
  if (e !== null) {
    this._internalRoot = null;
    var t = e.containerInfo;
    cs(function () {
      Cu(null, e, null, null);
    }), t[Nn] = null;
  }
};
function Tu(e) {
  this._internalRoot = e;
}
Tu.prototype.unstable_scheduleHydration = function (e) {
  if (e) {
    var t = _0();
    e = {
      blockedOn: null,
      target: e,
      priority: t
    };
    for (var n = 0; n < er.length && t !== 0 && t < er[n].priority; n++);
    er.splice(n, 0, e), n === 0 && B0(e);
  }
};
function Yh(e) {
  return !(!e || e.nodeType !== 1 && e.nodeType !== 9 && e.nodeType !== 11);
}
function Pu(e) {
  return !(!e || e.nodeType !== 1 && e.nodeType !== 9 && e.nodeType !== 11 && (e.nodeType !== 8 || e.nodeValue !== " react-mount-point-unstable "));
}
function yg() {}
function iP(e, t, n, r, s) {
  if (s) {
    if (typeof r == "function") {
      var o = r;
      r = function () {
        var u = Ul(i);
        o.call(u);
      };
    }
    var i = iw(t, r, e, 0, null, !1, !1, "", yg);
    return e._reactRootContainer = i, e[Nn] = i.current, Pi(e.nodeType === 8 ? e.parentNode : e), cs(), i;
  }
  for (; s = e.lastChild;) e.removeChild(s);
  if (typeof r == "function") {
    var a = r;
    r = function () {
      var u = Ul(l);
      a.call(u);
    };
  }
  var l = Kh(e, 0, !1, null, null, !1, !1, "", yg);
  return e._reactRootContainer = l, e[Nn] = l.current, Pi(e.nodeType === 8 ? e.parentNode : e), cs(function () {
    Cu(t, l, n, r);
  }), l;
}
function ku(e, t, n, r, s) {
  var o = n._reactRootContainer;
  if (o) {
    var i = o;
    if (typeof s == "function") {
      var a = s;
      s = function () {
        var l = Ul(i);
        a.call(l);
      };
    }
    Cu(t, i, e, s);
  } else i = iP(n, t, e, s, r);
  return Ul(i);
}
I0 = function (e) {
  switch (e.tag) {
    case 3:
      var t = e.stateNode;
      if (t.current.memoizedState.isDehydrated) {
        var n = ei(t.pendingLanes);
        n !== 0 && (mh(t, n | 1), ct(t, Ce()), !(ne & 6) && (yo = Ce() + 500, Or()));
      }
      break;
    case 13:
      cs(function () {
        var r = An(e, 1);
        if (r !== null) {
          var s = Je();
          qt(r, e, 1, s);
        }
      }), Qh(e, 1);
  }
};
gh = function (e) {
  if (e.tag === 13) {
    var t = An(e, 134217728);
    if (t !== null) {
      var n = Je();
      qt(t, e, 134217728, n);
    }
    Qh(e, 134217728);
  }
};
F0 = function (e) {
  if (e.tag === 13) {
    var t = wr(e),
      n = An(e, t);
    if (n !== null) {
      var r = Je();
      qt(n, e, t, r);
    }
    Qh(e, t);
  }
};
_0 = function () {
  return oe;
};
V0 = function (e, t) {
  var n = oe;
  try {
    return oe = e, t();
  } finally {
    oe = n;
  }
};
wd = function (e, t, n) {
  switch (t) {
    case "input":
      if (hd(e, n), t = n.name, n.type === "radio" && t != null) {
        for (n = e; n.parentNode;) n = n.parentNode;
        for (n = n.querySelectorAll("input[name=" + JSON.stringify("" + t) + '][type="radio"]'), t = 0; t < n.length; t++) {
          var r = n[t];
          if (r !== e && r.form === e.form) {
            var s = yu(r);
            if (!s) throw Error(M(90));
            g0(r), hd(r, s);
          }
        }
      }
      break;
    case "textarea":
      v0(e, n);
      break;
    case "select":
      t = n.value, t != null && $s(e, !!n.multiple, t, !1);
  }
};
T0 = Uh;
P0 = cs;
var aP = {
    usingClientEntryPoint: !1,
    Events: [Ji, Ms, yu, E0, C0, Uh]
  },
  Ko = {
    findFiberByHostInstance: $r,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
  },
  lP = {
    bundleType: Ko.bundleType,
    version: Ko.version,
    rendererPackageName: Ko.rendererPackageName,
    rendererConfig: Ko.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: Dn.ReactCurrentDispatcher,
    findHostInstanceByFiber: function (e) {
      return e = N0(e), e === null ? null : e.stateNode;
    },
    findFiberByHostInstance: Ko.findFiberByHostInstance || oP,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
  };
if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
  var Ma = __REACT_DEVTOOLS_GLOBAL_HOOK__;
  if (!Ma.isDisabled && Ma.supportsFiber) try {
    hu = Ma.inject(lP), cn = Ma;
  } catch {}
}
vt.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = aP;
vt.createPortal = function (e, t) {
  var n = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
  if (!Yh(t)) throw Error(M(200));
  return sP(e, t, null, n);
};
vt.createRoot = function (e, t) {
  if (!Yh(e)) throw Error(M(299));
  var n = !1,
    r = "",
    s = aw;
  return t != null && (t.unstable_strictMode === !0 && (n = !0), t.identifierPrefix !== void 0 && (r = t.identifierPrefix), t.onRecoverableError !== void 0 && (s = t.onRecoverableError)), t = Kh(e, 1, !1, null, null, n, !1, r, s), e[Nn] = t.current, Pi(e.nodeType === 8 ? e.parentNode : e), new Gh(t);
};
vt.findDOMNode = function (e) {
  if (e == null) return null;
  if (e.nodeType === 1) return e;
  var t = e._reactInternals;
  if (t === void 0) throw typeof e.render == "function" ? Error(M(188)) : (e = Object.keys(e).join(","), Error(M(268, e)));
  return e = N0(t), e = e === null ? null : e.stateNode, e;
};
vt.flushSync = function (e) {
  return cs(e);
};
vt.hydrate = function (e, t, n) {
  if (!Pu(t)) throw Error(M(200));
  return ku(null, e, t, !0, n);
};
vt.hydrateRoot = function (e, t, n) {
  if (!Yh(e)) throw Error(M(405));
  var r = n != null && n.hydratedSources || null,
    s = !1,
    o = "",
    i = aw;
  if (n != null && (n.unstable_strictMode === !0 && (s = !0), n.identifierPrefix !== void 0 && (o = n.identifierPrefix), n.onRecoverableError !== void 0 && (i = n.onRecoverableError)), t = iw(t, null, e, 1, n ?? null, s, !1, o, i), e[Nn] = t.current, Pi(e), r) for (e = 0; e < r.length; e++) n = r[e], s = n._getVersion, s = s(n._source), t.mutableSourceEagerHydrationData == null ? t.mutableSourceEagerHydrationData = [n, s] : t.mutableSourceEagerHydrationData.push(n, s);
  return new Tu(t);
};
vt.render = function (e, t, n) {
  if (!Pu(t)) throw Error(M(200));
  return ku(null, e, t, !1, n);
};
vt.unmountComponentAtNode = function (e) {
  if (!Pu(e)) throw Error(M(40));
  return e._reactRootContainer ? (cs(function () {
    ku(null, null, e, !1, function () {
      e._reactRootContainer = null, e[Nn] = null;
    });
  }), !0) : !1;
};
vt.unstable_batchedUpdates = Uh;
vt.unstable_renderSubtreeIntoContainer = function (e, t, n, r) {
  if (!Pu(n)) throw Error(M(200));
  if (e == null || e._reactInternals === void 0) throw Error(M(38));
  return ku(e, t, n, !1, r);
};
vt.version = "18.3.1-next-f1338f8080-20240426";
function lw() {
  if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) try {
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(lw);
  } catch (e) {
    console.error(e);
  }
}
lw(), l0.exports = vt;
var ta = l0.exports;
const uw = Yv(ta);
var cw,
  vg = ta;
cw = vg.createRoot, vg.hydrateRoot;
const uP = "modulepreload",
  cP = function (e) {
    return "/" + e;
  },
  xg = {},
  In = function (t, n, r) {
    let s = Promise.resolve();
    if (n && n.length > 0) {
      document.getElementsByTagName("link");
      const i = document.querySelector("meta[property=csp-nonce]"),
        a = (i == null ? void 0 : i.nonce) || (i == null ? void 0 : i.getAttribute("nonce"));
      s = Promise.allSettled(n.map(l => {
        if (l = cP(l), l in xg) return;
        xg[l] = !0;
        const u = l.endsWith(".css"),
          d = u ? '[rel="stylesheet"]' : "";
        if (document.querySelector(`link[href="${l}"]${d}`)) return;
        const c = document.createElement("link");
        if (c.rel = u ? "stylesheet" : uP, u || (c.as = "script"), c.crossOrigin = "", c.href = l, a && c.setAttribute("nonce", a), document.head.appendChild(c), u) return new Promise((f, h) => {
          c.addEventListener("load", f), c.addEventListener("error", () => h(new Error(`Unable to preload CSS for ${l}`)));
        });
      }));
    }
    function o(i) {
      const a = new Event("vite:preloadError", {
        cancelable: !0
      });
      if (a.payload = i, window.dispatchEvent(a), !a.defaultPrevented) throw i;
    }
    return s.then(i => {
      for (const a of i || []) a.status === "rejected" && o(a.reason);
      return t().catch(o);
    });
  };
var na = class {
    constructor() {
      this.listeners = new Set(), this.subscribe = this.subscribe.bind(this);
    }
    subscribe(e) {
      return this.listeners.add(e), this.onSubscribe(), () => {
        this.listeners.delete(e), this.onUnsubscribe();
      };
    }
    hasListeners() {
      return this.listeners.size > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
  },
  ds = typeof window > "u" || "Deno" in globalThis;
function ot() {}
function dP(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Jd(e) {
  return typeof e == "number" && e >= 0 && e !== 1 / 0;
}
function dw(e, t) {
  return Math.max(e + (t || 0) - Date.now(), 0);
}
function Sr(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Et(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function wg(e, t) {
  const {
    type: n = "all",
    exact: r,
    fetchStatus: s,
    predicate: o,
    queryKey: i,
    stale: a
  } = e;
  if (i) {
    if (r) {
      if (t.queryHash !== Xh(i, t.options)) return !1;
    } else if (!Ii(t.queryKey, i)) return !1;
  }
  if (n !== "all") {
    const l = t.isActive();
    if (n === "active" && !l || n === "inactive" && l) return !1;
  }
  return !(typeof a == "boolean" && t.isStale() !== a || s && s !== t.state.fetchStatus || o && !o(t));
}
function bg(e, t) {
  const {
    exact: n,
    status: r,
    predicate: s,
    mutationKey: o
  } = e;
  if (o) {
    if (!t.options.mutationKey) return !1;
    if (n) {
      if (Di(t.options.mutationKey) !== Di(o)) return !1;
    } else if (!Ii(t.options.mutationKey, o)) return !1;
  }
  return !(r && t.state.status !== r || s && !s(t));
}
function Xh(e, t) {
  return ((t == null ? void 0 : t.queryKeyHashFn) || Di)(e);
}
function Di(e) {
  return JSON.stringify(e, (t, n) => tf(n) ? Object.keys(n).sort().reduce((r, s) => (r[s] = n[s], r), {}) : n);
}
function Ii(e, t) {
  return e === t ? !0 : typeof e != typeof t ? !1 : e && t && typeof e == "object" && typeof t == "object" ? Object.keys(t).every(n => Ii(e[n], t[n])) : !1;
}
function fw(e, t) {
  if (e === t) return e;
  const n = Sg(e) && Sg(t);
  if (n || tf(e) && tf(t)) {
    const r = n ? e : Object.keys(e),
      s = r.length,
      o = n ? t : Object.keys(t),
      i = o.length,
      a = n ? [] : {},
      l = new Set(r);
    let u = 0;
    for (let d = 0; d < i; d++) {
      const c = n ? d : o[d];
      (!n && l.has(c) || n) && e[c] === void 0 && t[c] === void 0 ? (a[c] = void 0, u++) : (a[c] = fw(e[c], t[c]), a[c] === e[c] && e[c] !== void 0 && u++);
    }
    return s === i && u === s ? e : a;
  }
  return t;
}
function ef(e, t) {
  if (!t || Object.keys(e).length !== Object.keys(t).length) return !1;
  for (const n in e) if (e[n] !== t[n]) return !1;
  return !0;
}
function Sg(e) {
  return Array.isArray(e) && e.length === Object.keys(e).length;
}
function tf(e) {
  if (!Eg(e)) return !1;
  const t = e.constructor;
  if (t === void 0) return !0;
  const n = t.prototype;
  return !(!Eg(n) || !n.hasOwnProperty("isPrototypeOf") || Object.getPrototypeOf(e) !== Object.prototype);
}
function Eg(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function fP(e) {
  return new Promise(t => {
    setTimeout(t, e);
  });
}
function nf(e, t, n) {
  return typeof n.structuralSharing == "function" ? n.structuralSharing(e, t) : n.structuralSharing !== !1 ? fw(e, t) : t;
}
function hP(e, t, n = 0) {
  const r = [...e, t];
  return n && r.length > n ? r.slice(1) : r;
}
function pP(e, t, n = 0) {
  const r = [t, ...e];
  return n && r.length > n ? r.slice(0, -1) : r;
}
var Zh = Symbol();
function hw(e, t) {
  return !e.queryFn && t != null && t.initialPromise ? () => t.initialPromise : !e.queryFn || e.queryFn === Zh ? () => Promise.reject(new Error(`Missing queryFn: '${e.queryHash}'`)) : e.queryFn;
}
function mP(e, t) {
  return typeof e == "function" ? e(...t) : !!e;
}
var Kr,
  nr,
  Zs,
  zv,
  gP = (zv = class extends na {
    constructor() {
      super();
      H(this, Kr);
      H(this, nr);
      H(this, Zs);
      V(this, Zs, t => {
        if (!ds && window.addEventListener) {
          const n = () => t();
          return window.addEventListener("visibilitychange", n, !1), () => {
            window.removeEventListener("visibilitychange", n);
          };
        }
      });
    }
    onSubscribe() {
      C(this, nr) || this.setEventListener(C(this, Zs));
    }
    onUnsubscribe() {
      var t;
      this.hasListeners() || ((t = C(this, nr)) == null || t.call(this), V(this, nr, void 0));
    }
    setEventListener(t) {
      var n;
      V(this, Zs, t), (n = C(this, nr)) == null || n.call(this), V(this, nr, t(r => {
        typeof r == "boolean" ? this.setFocused(r) : this.onFocus();
      }));
    }
    setFocused(t) {
      C(this, Kr) !== t && (V(this, Kr, t), this.onFocus());
    }
    onFocus() {
      const t = this.isFocused();
      this.listeners.forEach(n => {
        n(t);
      });
    }
    isFocused() {
      var t;
      return typeof C(this, Kr) == "boolean" ? C(this, Kr) : ((t = globalThis.document) == null ? void 0 : t.visibilityState) !== "hidden";
    }
  }, Kr = new WeakMap(), nr = new WeakMap(), Zs = new WeakMap(), zv),
  Jh = new gP(),
  Js,
  rr,
  eo,
  $v,
  yP = ($v = class extends na {
    constructor() {
      super();
      H(this, Js, !0);
      H(this, rr);
      H(this, eo);
      V(this, eo, t => {
        if (!ds && window.addEventListener) {
          const n = () => t(!0),
            r = () => t(!1);
          return window.addEventListener("online", n, !1), window.addEventListener("offline", r, !1), () => {
            window.removeEventListener("online", n), window.removeEventListener("offline", r);
          };
        }
      });
    }
    onSubscribe() {
      C(this, rr) || this.setEventListener(C(this, eo));
    }
    onUnsubscribe() {
      var t;
      this.hasListeners() || ((t = C(this, rr)) == null || t.call(this), V(this, rr, void 0));
    }
    setEventListener(t) {
      var n;
      V(this, eo, t), (n = C(this, rr)) == null || n.call(this), V(this, rr, t(this.setOnline.bind(this)));
    }
    setOnline(t) {
      C(this, Js) !== t && (V(this, Js, t), this.listeners.forEach(r => {
        r(t);
      }));
    }
    isOnline() {
      return C(this, Js);
    }
  }, Js = new WeakMap(), rr = new WeakMap(), eo = new WeakMap(), $v),
  Wl = new yP();
function rf() {
  let e, t;
  const n = new Promise((s, o) => {
    e = s, t = o;
  });
  n.status = "pending", n.catch(() => {});
  function r(s) {
    Object.assign(n, s), delete n.resolve, delete n.reject;
  }
  return n.resolve = s => {
    r({
      status: "fulfilled",
      value: s
    }), e(s);
  }, n.reject = s => {
    r({
      status: "rejected",
      reason: s
    }), t(s);
  }, n;
}
function vP(e) {
  return Math.min(1e3 * 2 ** e, 3e4);
}
function pw(e) {
  return (e ?? "online") === "online" ? Wl.isOnline() : !0;
}
var mw = class extends Error {
  constructor(e) {
    super("CancelledError"), this.revert = e == null ? void 0 : e.revert, this.silent = e == null ? void 0 : e.silent;
  }
};
function Pc(e) {
  return e instanceof mw;
}
function gw(e) {
  let t = !1,
    n = 0,
    r = !1,
    s;
  const o = rf(),
    i = m => {
      var x;
      r || (f(new mw(m)), (x = e.abort) == null || x.call(e));
    },
    a = () => {
      t = !0;
    },
    l = () => {
      t = !1;
    },
    u = () => Jh.isFocused() && (e.networkMode === "always" || Wl.isOnline()) && e.canRun(),
    d = () => pw(e.networkMode) && e.canRun(),
    c = m => {
      var x;
      r || (r = !0, (x = e.onSuccess) == null || x.call(e, m), s == null || s(), o.resolve(m));
    },
    f = m => {
      var x;
      r || (r = !0, (x = e.onError) == null || x.call(e, m), s == null || s(), o.reject(m));
    },
    h = () => new Promise(m => {
      var x;
      s = g => {
        (r || u()) && m(g);
      }, (x = e.onPause) == null || x.call(e);
    }).then(() => {
      var m;
      s = void 0, r || (m = e.onContinue) == null || m.call(e);
    }),
    w = () => {
      if (r) return;
      let m;
      const x = n === 0 ? e.initialPromise : void 0;
      try {
        m = x ?? e.fn();
      } catch (g) {
        m = Promise.reject(g);
      }
      Promise.resolve(m).then(c).catch(g => {
        var P;
        if (r) return;
        const v = e.retry ?? (ds ? 0 : 3),
          b = e.retryDelay ?? vP,
          S = typeof b == "function" ? b(n, g) : b,
          E = v === !0 || typeof v == "number" && n < v || typeof v == "function" && v(n, g);
        if (t || !E) {
          f(g);
          return;
        }
        n++, (P = e.onFail) == null || P.call(e, n, g), fP(S).then(() => u() ? void 0 : h()).then(() => {
          t ? f(g) : w();
        });
      });
    };
  return {
    promise: o,
    cancel: i,
    continue: () => (s == null || s(), o),
    cancelRetry: a,
    continueRetry: l,
    canStart: d,
    start: () => (d() ? w() : h().then(w), o)
  };
}
var xP = e => setTimeout(e, 0);
function wP() {
  let e = [],
    t = 0,
    n = a => {
      a();
    },
    r = a => {
      a();
    },
    s = xP;
  const o = a => {
      t ? e.push(a) : s(() => {
        n(a);
      });
    },
    i = () => {
      const a = e;
      e = [], a.length && s(() => {
        r(() => {
          a.forEach(l => {
            n(l);
          });
        });
      });
    };
  return {
    batch: a => {
      let l;
      t++;
      try {
        l = a();
      } finally {
        t--, t || i();
      }
      return l;
    },
    batchCalls: a => (...l) => {
      o(() => {
        a(...l);
      });
    },
    schedule: o,
    setNotifyFunction: a => {
      n = a;
    },
    setBatchNotifyFunction: a => {
      r = a;
    },
    setScheduler: a => {
      s = a;
    }
  };
}
var _e = wP(),
  Qr,
  Uv,
  yw = (Uv = class {
    constructor() {
      H(this, Qr);
    }
    destroy() {
      this.clearGcTimeout();
    }
    scheduleGc() {
      this.clearGcTimeout(), Jd(this.gcTime) && V(this, Qr, setTimeout(() => {
        this.optionalRemove();
      }, this.gcTime));
    }
    updateGcTime(e) {
      this.gcTime = Math.max(this.gcTime || 0, e ?? (ds ? 1 / 0 : 5 * 60 * 1e3));
    }
    clearGcTimeout() {
      C(this, Qr) && (clearTimeout(C(this, Qr)), V(this, Qr, void 0));
    }
  }, Qr = new WeakMap(), Uv),
  to,
  Gr,
  St,
  Yr,
  He,
  qi,
  Xr,
  zt,
  xn,
  Wv,
  bP = (Wv = class extends yw {
    constructor(t) {
      super();
      H(this, zt);
      H(this, to);
      H(this, Gr);
      H(this, St);
      H(this, Yr);
      H(this, He);
      H(this, qi);
      H(this, Xr);
      V(this, Xr, !1), V(this, qi, t.defaultOptions), this.setOptions(t.options), this.observers = [], V(this, Yr, t.client), V(this, St, C(this, Yr).getQueryCache()), this.queryKey = t.queryKey, this.queryHash = t.queryHash, V(this, to, SP(this.options)), this.state = t.state ?? C(this, to), this.scheduleGc();
    }
    get meta() {
      return this.options.meta;
    }
    get promise() {
      var t;
      return (t = C(this, He)) == null ? void 0 : t.promise;
    }
    setOptions(t) {
      this.options = {
        ...C(this, qi),
        ...t
      }, this.updateGcTime(this.options.gcTime);
    }
    optionalRemove() {
      !this.observers.length && this.state.fetchStatus === "idle" && C(this, St).remove(this);
    }
    setData(t, n) {
      const r = nf(this.state.data, t, this.options);
      return ee(this, zt, xn).call(this, {
        data: r,
        type: "success",
        dataUpdatedAt: n == null ? void 0 : n.updatedAt,
        manual: n == null ? void 0 : n.manual
      }), r;
    }
    setState(t, n) {
      ee(this, zt, xn).call(this, {
        type: "setState",
        state: t,
        setStateOptions: n
      });
    }
    cancel(t) {
      var r, s;
      const n = (r = C(this, He)) == null ? void 0 : r.promise;
      return (s = C(this, He)) == null || s.cancel(t), n ? n.then(ot).catch(ot) : Promise.resolve();
    }
    destroy() {
      super.destroy(), this.cancel({
        silent: !0
      });
    }
    reset() {
      this.destroy(), this.setState(C(this, to));
    }
    isActive() {
      return this.observers.some(t => Et(t.options.enabled, this) !== !1);
    }
    isDisabled() {
      return this.getObserversCount() > 0 ? !this.isActive() : this.options.queryFn === Zh || this.state.dataUpdateCount + this.state.errorUpdateCount === 0;
    }
    isStatic() {
      return this.getObserversCount() > 0 ? this.observers.some(t => Sr(t.options.staleTime, this) === "static") : !1;
    }
    isStale() {
      return this.getObserversCount() > 0 ? this.observers.some(t => t.getCurrentResult().isStale) : this.state.data === void 0 || this.state.isInvalidated;
    }
    isStaleByTime(t = 0) {
      return this.state.data === void 0 ? !0 : t === "static" ? !1 : this.state.isInvalidated ? !0 : !dw(this.state.dataUpdatedAt, t);
    }
    onFocus() {
      var n;
      const t = this.observers.find(r => r.shouldFetchOnWindowFocus());
      t == null || t.refetch({
        cancelRefetch: !1
      }), (n = C(this, He)) == null || n.continue();
    }
    onOnline() {
      var n;
      const t = this.observers.find(r => r.shouldFetchOnReconnect());
      t == null || t.refetch({
        cancelRefetch: !1
      }), (n = C(this, He)) == null || n.continue();
    }
    addObserver(t) {
      this.observers.includes(t) || (this.observers.push(t), this.clearGcTimeout(), C(this, St).notify({
        type: "observerAdded",
        query: this,
        observer: t
      }));
    }
    removeObserver(t) {
      this.observers.includes(t) && (this.observers = this.observers.filter(n => n !== t), this.observers.length || (C(this, He) && (C(this, Xr) ? C(this, He).cancel({
        revert: !0
      }) : C(this, He).cancelRetry()), this.scheduleGc()), C(this, St).notify({
        type: "observerRemoved",
        query: this,
        observer: t
      }));
    }
    getObserversCount() {
      return this.observers.length;
    }
    invalidate() {
      this.state.isInvalidated || ee(this, zt, xn).call(this, {
        type: "invalidate"
      });
    }
    fetch(t, n) {
      var u, d, c;
      if (this.state.fetchStatus !== "idle") {
        if (this.state.data !== void 0 && n != null && n.cancelRefetch) this.cancel({
          silent: !0
        });else if (C(this, He)) return C(this, He).continueRetry(), C(this, He).promise;
      }
      if (t && this.setOptions(t), !this.options.queryFn) {
        const f = this.observers.find(h => h.options.queryFn);
        f && this.setOptions(f.options);
      }
      const r = new AbortController(),
        s = f => {
          Object.defineProperty(f, "signal", {
            enumerable: !0,
            get: () => (V(this, Xr, !0), r.signal)
          });
        },
        o = () => {
          const f = hw(this.options, n),
            w = (() => {
              const m = {
                client: C(this, Yr),
                queryKey: this.queryKey,
                meta: this.meta
              };
              return s(m), m;
            })();
          return V(this, Xr, !1), this.options.persister ? this.options.persister(f, w, this) : f(w);
        },
        a = (() => {
          const f = {
            fetchOptions: n,
            options: this.options,
            queryKey: this.queryKey,
            client: C(this, Yr),
            state: this.state,
            fetchFn: o
          };
          return s(f), f;
        })();
      (u = this.options.behavior) == null || u.onFetch(a, this), V(this, Gr, this.state), (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((d = a.fetchOptions) == null ? void 0 : d.meta)) && ee(this, zt, xn).call(this, {
        type: "fetch",
        meta: (c = a.fetchOptions) == null ? void 0 : c.meta
      });
      const l = f => {
        var h, w, m, x;
        Pc(f) && f.silent || ee(this, zt, xn).call(this, {
          type: "error",
          error: f
        }), Pc(f) || ((w = (h = C(this, St).config).onError) == null || w.call(h, f, this), (x = (m = C(this, St).config).onSettled) == null || x.call(m, this.state.data, f, this)), this.scheduleGc();
      };
      return V(this, He, gw({
        initialPromise: n == null ? void 0 : n.initialPromise,
        fn: a.fetchFn,
        abort: r.abort.bind(r),
        onSuccess: f => {
          var h, w, m, x;
          if (f === void 0) {
            l(new Error(`${this.queryHash} data is undefined`));
            return;
          }
          try {
            this.setData(f);
          } catch (g) {
            l(g);
            return;
          }
          (w = (h = C(this, St).config).onSuccess) == null || w.call(h, f, this), (x = (m = C(this, St).config).onSettled) == null || x.call(m, f, this.state.error, this), this.scheduleGc();
        },
        onError: l,
        onFail: (f, h) => {
          ee(this, zt, xn).call(this, {
            type: "failed",
            failureCount: f,
            error: h
          });
        },
        onPause: () => {
          ee(this, zt, xn).call(this, {
            type: "pause"
          });
        },
        onContinue: () => {
          ee(this, zt, xn).call(this, {
            type: "continue"
          });
        },
        retry: a.options.retry,
        retryDelay: a.options.retryDelay,
        networkMode: a.options.networkMode,
        canRun: () => !0
      })), C(this, He).start();
    }
  }, to = new WeakMap(), Gr = new WeakMap(), St = new WeakMap(), Yr = new WeakMap(), He = new WeakMap(), qi = new WeakMap(), Xr = new WeakMap(), zt = new WeakSet(), xn = function (t) {
    const n = r => {
      switch (t.type) {
        case "failed":
          return {
            ...r,
            fetchFailureCount: t.failureCount,
            fetchFailureReason: t.error
          };
        case "pause":
          return {
            ...r,
            fetchStatus: "paused"
          };
        case "continue":
          return {
            ...r,
            fetchStatus: "fetching"
          };
        case "fetch":
          return {
            ...r,
            ...vw(r.data, this.options),
            fetchMeta: t.meta ?? null
          };
        case "success":
          return V(this, Gr, void 0), {
            ...r,
            data: t.data,
            dataUpdateCount: r.dataUpdateCount + 1,
            dataUpdatedAt: t.dataUpdatedAt ?? Date.now(),
            error: null,
            isInvalidated: !1,
            status: "success",
            ...(!t.manual && {
              fetchStatus: "idle",
              fetchFailureCount: 0,
              fetchFailureReason: null
            })
          };
        case "error":
          const s = t.error;
          return Pc(s) && s.revert && C(this, Gr) ? {
            ...C(this, Gr),
            fetchStatus: "idle"
          } : {
            ...r,
            error: s,
            errorUpdateCount: r.errorUpdateCount + 1,
            errorUpdatedAt: Date.now(),
            fetchFailureCount: r.fetchFailureCount + 1,
            fetchFailureReason: s,
            fetchStatus: "idle",
            status: "error"
          };
        case "invalidate":
          return {
            ...r,
            isInvalidated: !0
          };
        case "setState":
          return {
            ...r,
            ...t.state
          };
      }
    };
    this.state = n(this.state), _e.batch(() => {
      this.observers.forEach(r => {
        r.onQueryUpdate();
      }), C(this, St).notify({
        query: this,
        type: "updated",
        action: t
      });
    });
  }, Wv);
function vw(e, t) {
  return {
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchStatus: pw(t.networkMode) ? "fetching" : "paused",
    ...(e === void 0 && {
      error: null,
      status: "pending"
    })
  };
}
function SP(e) {
  const t = typeof e.initialData == "function" ? e.initialData() : e.initialData,
    n = t !== void 0,
    r = n ? typeof e.initialDataUpdatedAt == "function" ? e.initialDataUpdatedAt() : e.initialDataUpdatedAt : 0;
  return {
    data: t,
    dataUpdateCount: 0,
    dataUpdatedAt: n ? r ?? Date.now() : 0,
    error: null,
    errorUpdateCount: 0,
    errorUpdatedAt: 0,
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchMeta: null,
    isInvalidated: !1,
    status: n ? "success" : "pending",
    fetchStatus: "idle"
  };
}
var nn,
  Hv,
  EP = (Hv = class extends na {
    constructor(t = {}) {
      super();
      H(this, nn);
      this.config = t, V(this, nn, new Map());
    }
    build(t, n, r) {
      const s = n.queryKey,
        o = n.queryHash ?? Xh(s, n);
      let i = this.get(o);
      return i || (i = new bP({
        client: t,
        queryKey: s,
        queryHash: o,
        options: t.defaultQueryOptions(n),
        state: r,
        defaultOptions: t.getQueryDefaults(s)
      }), this.add(i)), i;
    }
    add(t) {
      C(this, nn).has(t.queryHash) || (C(this, nn).set(t.queryHash, t), this.notify({
        type: "added",
        query: t
      }));
    }
    remove(t) {
      const n = C(this, nn).get(t.queryHash);
      n && (t.destroy(), n === t && C(this, nn).delete(t.queryHash), this.notify({
        type: "removed",
        query: t
      }));
    }
    clear() {
      _e.batch(() => {
        this.getAll().forEach(t => {
          this.remove(t);
        });
      });
    }
    get(t) {
      return C(this, nn).get(t);
    }
    getAll() {
      return [...C(this, nn).values()];
    }
    find(t) {
      const n = {
        exact: !0,
        ...t
      };
      return this.getAll().find(r => wg(n, r));
    }
    findAll(t = {}) {
      const n = this.getAll();
      return Object.keys(t).length > 0 ? n.filter(r => wg(t, r)) : n;
    }
    notify(t) {
      _e.batch(() => {
        this.listeners.forEach(n => {
          n(t);
        });
      });
    }
    onFocus() {
      _e.batch(() => {
        this.getAll().forEach(t => {
          t.onFocus();
        });
      });
    }
    onOnline() {
      _e.batch(() => {
        this.getAll().forEach(t => {
          t.onOnline();
        });
      });
    }
  }, nn = new WeakMap(), Hv),
  rn,
  Qe,
  Zr,
  sn,
  Gn,
  qv,
  CP = (qv = class extends yw {
    constructor(t) {
      super();
      H(this, sn);
      H(this, rn);
      H(this, Qe);
      H(this, Zr);
      this.mutationId = t.mutationId, V(this, Qe, t.mutationCache), V(this, rn, []), this.state = t.state || TP(), this.setOptions(t.options), this.scheduleGc();
    }
    setOptions(t) {
      this.options = t, this.updateGcTime(this.options.gcTime);
    }
    get meta() {
      return this.options.meta;
    }
    addObserver(t) {
      C(this, rn).includes(t) || (C(this, rn).push(t), this.clearGcTimeout(), C(this, Qe).notify({
        type: "observerAdded",
        mutation: this,
        observer: t
      }));
    }
    removeObserver(t) {
      V(this, rn, C(this, rn).filter(n => n !== t)), this.scheduleGc(), C(this, Qe).notify({
        type: "observerRemoved",
        mutation: this,
        observer: t
      });
    }
    optionalRemove() {
      C(this, rn).length || (this.state.status === "pending" ? this.scheduleGc() : C(this, Qe).remove(this));
    }
    continue() {
      var t;
      return ((t = C(this, Zr)) == null ? void 0 : t.continue()) ?? this.execute(this.state.variables);
    }
    async execute(t) {
      var o, i, a, l, u, d, c, f, h, w, m, x, g, v, b, S, E, P, T, k;
      const n = () => {
        ee(this, sn, Gn).call(this, {
          type: "continue"
        });
      };
      V(this, Zr, gw({
        fn: () => this.options.mutationFn ? this.options.mutationFn(t) : Promise.reject(new Error("No mutationFn found")),
        onFail: (A, R) => {
          ee(this, sn, Gn).call(this, {
            type: "failed",
            failureCount: A,
            error: R
          });
        },
        onPause: () => {
          ee(this, sn, Gn).call(this, {
            type: "pause"
          });
        },
        onContinue: n,
        retry: this.options.retry ?? 0,
        retryDelay: this.options.retryDelay,
        networkMode: this.options.networkMode,
        canRun: () => C(this, Qe).canRun(this)
      }));
      const r = this.state.status === "pending",
        s = !C(this, Zr).canStart();
      try {
        if (r) n();else {
          ee(this, sn, Gn).call(this, {
            type: "pending",
            variables: t,
            isPaused: s
          }), await ((i = (o = C(this, Qe).config).onMutate) == null ? void 0 : i.call(o, t, this));
          const R = await ((l = (a = this.options).onMutate) == null ? void 0 : l.call(a, t));
          R !== this.state.context && ee(this, sn, Gn).call(this, {
            type: "pending",
            context: R,
            variables: t,
            isPaused: s
          });
        }
        const A = await C(this, Zr).start();
        return await ((d = (u = C(this, Qe).config).onSuccess) == null ? void 0 : d.call(u, A, t, this.state.context, this)), await ((f = (c = this.options).onSuccess) == null ? void 0 : f.call(c, A, t, this.state.context)), await ((w = (h = C(this, Qe).config).onSettled) == null ? void 0 : w.call(h, A, null, this.state.variables, this.state.context, this)), await ((x = (m = this.options).onSettled) == null ? void 0 : x.call(m, A, null, t, this.state.context)), ee(this, sn, Gn).call(this, {
          type: "success",
          data: A
        }), A;
      } catch (A) {
        try {
          throw await ((v = (g = C(this, Qe).config).onError) == null ? void 0 : v.call(g, A, t, this.state.context, this)), await ((S = (b = this.options).onError) == null ? void 0 : S.call(b, A, t, this.state.context)), await ((P = (E = C(this, Qe).config).onSettled) == null ? void 0 : P.call(E, void 0, A, this.state.variables, this.state.context, this)), await ((k = (T = this.options).onSettled) == null ? void 0 : k.call(T, void 0, A, t, this.state.context)), A;
        } finally {
          ee(this, sn, Gn).call(this, {
            type: "error",
            error: A
          });
        }
      } finally {
        C(this, Qe).runNext(this);
      }
    }
  }, rn = new WeakMap(), Qe = new WeakMap(), Zr = new WeakMap(), sn = new WeakSet(), Gn = function (t) {
    const n = r => {
      switch (t.type) {
        case "failed":
          return {
            ...r,
            failureCount: t.failureCount,
            failureReason: t.error
          };
        case "pause":
          return {
            ...r,
            isPaused: !0
          };
        case "continue":
          return {
            ...r,
            isPaused: !1
          };
        case "pending":
          return {
            ...r,
            context: t.context,
            data: void 0,
            failureCount: 0,
            failureReason: null,
            error: null,
            isPaused: t.isPaused,
            status: "pending",
            variables: t.variables,
            submittedAt: Date.now()
          };
        case "success":
          return {
            ...r,
            data: t.data,
            failureCount: 0,
            failureReason: null,
            error: null,
            status: "success",
            isPaused: !1
          };
        case "error":
          return {
            ...r,
            data: void 0,
            error: t.error,
            failureCount: r.failureCount + 1,
            failureReason: t.error,
            isPaused: !1,
            status: "error"
          };
      }
    };
    this.state = n(this.state), _e.batch(() => {
      C(this, rn).forEach(r => {
        r.onMutationUpdate(t);
      }), C(this, Qe).notify({
        mutation: this,
        type: "updated",
        action: t
      });
    });
  }, qv);
function TP() {
  return {
    context: void 0,
    data: void 0,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: !1,
    status: "idle",
    variables: void 0,
    submittedAt: 0
  };
}
var En,
  $t,
  Ki,
  Kv,
  PP = (Kv = class extends na {
    constructor(t = {}) {
      super();
      H(this, En);
      H(this, $t);
      H(this, Ki);
      this.config = t, V(this, En, new Set()), V(this, $t, new Map()), V(this, Ki, 0);
    }
    build(t, n, r) {
      const s = new CP({
        mutationCache: this,
        mutationId: ++ma(this, Ki)._,
        options: t.defaultMutationOptions(n),
        state: r
      });
      return this.add(s), s;
    }
    add(t) {
      C(this, En).add(t);
      const n = Oa(t);
      if (typeof n == "string") {
        const r = C(this, $t).get(n);
        r ? r.push(t) : C(this, $t).set(n, [t]);
      }
      this.notify({
        type: "added",
        mutation: t
      });
    }
    remove(t) {
      if (C(this, En).delete(t)) {
        const n = Oa(t);
        if (typeof n == "string") {
          const r = C(this, $t).get(n);
          if (r) if (r.length > 1) {
            const s = r.indexOf(t);
            s !== -1 && r.splice(s, 1);
          } else r[0] === t && C(this, $t).delete(n);
        }
      }
      this.notify({
        type: "removed",
        mutation: t
      });
    }
    canRun(t) {
      const n = Oa(t);
      if (typeof n == "string") {
        const r = C(this, $t).get(n),
          s = r == null ? void 0 : r.find(o => o.state.status === "pending");
        return !s || s === t;
      } else return !0;
    }
    runNext(t) {
      var r;
      const n = Oa(t);
      if (typeof n == "string") {
        const s = (r = C(this, $t).get(n)) == null ? void 0 : r.find(o => o !== t && o.state.isPaused);
        return (s == null ? void 0 : s.continue()) ?? Promise.resolve();
      } else return Promise.resolve();
    }
    clear() {
      _e.batch(() => {
        C(this, En).forEach(t => {
          this.notify({
            type: "removed",
            mutation: t
          });
        }), C(this, En).clear(), C(this, $t).clear();
      });
    }
    getAll() {
      return Array.from(C(this, En));
    }
    find(t) {
      const n = {
        exact: !0,
        ...t
      };
      return this.getAll().find(r => bg(n, r));
    }
    findAll(t = {}) {
      return this.getAll().filter(n => bg(t, n));
    }
    notify(t) {
      _e.batch(() => {
        this.listeners.forEach(n => {
          n(t);
        });
      });
    }
    resumePausedMutations() {
      const t = this.getAll().filter(n => n.state.isPaused);
      return _e.batch(() => Promise.all(t.map(n => n.continue().catch(ot))));
    }
  }, En = new WeakMap(), $t = new WeakMap(), Ki = new WeakMap(), Kv);
function Oa(e) {
  var t;
  return (t = e.options.scope) == null ? void 0 : t.id;
}
function Cg(e) {
  return {
    onFetch: (t, n) => {
      var d, c, f, h, w;
      const r = t.options,
        s = (f = (c = (d = t.fetchOptions) == null ? void 0 : d.meta) == null ? void 0 : c.fetchMore) == null ? void 0 : f.direction,
        o = ((h = t.state.data) == null ? void 0 : h.pages) || [],
        i = ((w = t.state.data) == null ? void 0 : w.pageParams) || [];
      let a = {
          pages: [],
          pageParams: []
        },
        l = 0;
      const u = async () => {
        let m = !1;
        const x = b => {
            Object.defineProperty(b, "signal", {
              enumerable: !0,
              get: () => (t.signal.aborted ? m = !0 : t.signal.addEventListener("abort", () => {
                m = !0;
              }), t.signal)
            });
          },
          g = hw(t.options, t.fetchOptions),
          v = async (b, S, E) => {
            if (m) return Promise.reject();
            if (S == null && b.pages.length) return Promise.resolve(b);
            const T = (() => {
                const I = {
                  client: t.client,
                  queryKey: t.queryKey,
                  pageParam: S,
                  direction: E ? "backward" : "forward",
                  meta: t.options.meta
                };
                return x(I), I;
              })(),
              k = await g(T),
              {
                maxPages: A
              } = t.options,
              R = E ? pP : hP;
            return {
              pages: R(b.pages, k, A),
              pageParams: R(b.pageParams, S, A)
            };
          };
        if (s && o.length) {
          const b = s === "backward",
            S = b ? kP : Tg,
            E = {
              pages: o,
              pageParams: i
            },
            P = S(r, E);
          a = await v(E, P, b);
        } else {
          const b = e ?? o.length;
          do {
            const S = l === 0 ? i[0] ?? r.initialPageParam : Tg(r, a);
            if (l > 0 && S == null) break;
            a = await v(a, S), l++;
          } while (l < b);
        }
        return a;
      };
      t.options.persister ? t.fetchFn = () => {
        var m, x;
        return (x = (m = t.options).persister) == null ? void 0 : x.call(m, u, {
          client: t.client,
          queryKey: t.queryKey,
          meta: t.options.meta,
          signal: t.signal
        }, n);
      } : t.fetchFn = u;
    }
  };
}
function Tg(e, {
  pages: t,
  pageParams: n
}) {
  const r = t.length - 1;
  return t.length > 0 ? e.getNextPageParam(t[r], t, n[r], n) : void 0;
}
function kP(e, {
  pages: t,
  pageParams: n
}) {
  var r;
  return t.length > 0 ? (r = e.getPreviousPageParam) == null ? void 0 : r.call(e, t[0], t, n[0], n) : void 0;
}
var Se,
  sr,
  or,
  no,
  ro,
  ir,
  so,
  oo,
  Qv,
  RP = (Qv = class {
    constructor(e = {}) {
      H(this, Se);
      H(this, sr);
      H(this, or);
      H(this, no);
      H(this, ro);
      H(this, ir);
      H(this, so);
      H(this, oo);
      V(this, Se, e.queryCache || new EP()), V(this, sr, e.mutationCache || new PP()), V(this, or, e.defaultOptions || {}), V(this, no, new Map()), V(this, ro, new Map()), V(this, ir, 0);
    }
    mount() {
      ma(this, ir)._++, C(this, ir) === 1 && (V(this, so, Jh.subscribe(async e => {
        e && (await this.resumePausedMutations(), C(this, Se).onFocus());
      })), V(this, oo, Wl.subscribe(async e => {
        e && (await this.resumePausedMutations(), C(this, Se).onOnline());
      })));
    }
    unmount() {
      var e, t;
      ma(this, ir)._--, C(this, ir) === 0 && ((e = C(this, so)) == null || e.call(this), V(this, so, void 0), (t = C(this, oo)) == null || t.call(this), V(this, oo, void 0));
    }
    isFetching(e) {
      return C(this, Se).findAll({
        ...e,
        fetchStatus: "fetching"
      }).length;
    }
    isMutating(e) {
      return C(this, sr).findAll({
        ...e,
        status: "pending"
      }).length;
    }
    getQueryData(e) {
      var n;
      const t = this.defaultQueryOptions({
        queryKey: e
      });
      return (n = C(this, Se).get(t.queryHash)) == null ? void 0 : n.state.data;
    }
    ensureQueryData(e) {
      const t = this.defaultQueryOptions(e),
        n = C(this, Se).build(this, t),
        r = n.state.data;
      return r === void 0 ? this.fetchQuery(e) : (e.revalidateIfStale && n.isStaleByTime(Sr(t.staleTime, n)) && this.prefetchQuery(t), Promise.resolve(r));
    }
    getQueriesData(e) {
      return C(this, Se).findAll(e).map(({
        queryKey: t,
        state: n
      }) => {
        const r = n.data;
        return [t, r];
      });
    }
    setQueryData(e, t, n) {
      const r = this.defaultQueryOptions({
          queryKey: e
        }),
        s = C(this, Se).get(r.queryHash),
        o = s == null ? void 0 : s.state.data,
        i = dP(t, o);
      if (i !== void 0) return C(this, Se).build(this, r).setData(i, {
        ...n,
        manual: !0
      });
    }
    setQueriesData(e, t, n) {
      return _e.batch(() => C(this, Se).findAll(e).map(({
        queryKey: r
      }) => [r, this.setQueryData(r, t, n)]));
    }
    getQueryState(e) {
      var n;
      const t = this.defaultQueryOptions({
        queryKey: e
      });
      return (n = C(this, Se).get(t.queryHash)) == null ? void 0 : n.state;
    }
    removeQueries(e) {
      const t = C(this, Se);
      _e.batch(() => {
        t.findAll(e).forEach(n => {
          t.remove(n);
        });
      });
    }
    resetQueries(e, t) {
      const n = C(this, Se);
      return _e.batch(() => (n.findAll(e).forEach(r => {
        r.reset();
      }), this.refetchQueries({
        type: "active",
        ...e
      }, t)));
    }
    cancelQueries(e, t = {}) {
      const n = {
          revert: !0,
          ...t
        },
        r = _e.batch(() => C(this, Se).findAll(e).map(s => s.cancel(n)));
      return Promise.all(r).then(ot).catch(ot);
    }
    invalidateQueries(e, t = {}) {
      return _e.batch(() => (C(this, Se).findAll(e).forEach(n => {
        n.invalidate();
      }), (e == null ? void 0 : e.refetchType) === "none" ? Promise.resolve() : this.refetchQueries({
        ...e,
        type: (e == null ? void 0 : e.refetchType) ?? (e == null ? void 0 : e.type) ?? "active"
      }, t)));
    }
    refetchQueries(e, t = {}) {
      const n = {
          ...t,
          cancelRefetch: t.cancelRefetch ?? !0
        },
        r = _e.batch(() => C(this, Se).findAll(e).filter(s => !s.isDisabled() && !s.isStatic()).map(s => {
          let o = s.fetch(void 0, n);
          return n.throwOnError || (o = o.catch(ot)), s.state.fetchStatus === "paused" ? Promise.resolve() : o;
        }));
      return Promise.all(r).then(ot);
    }
    fetchQuery(e) {
      const t = this.defaultQueryOptions(e);
      t.retry === void 0 && (t.retry = !1);
      const n = C(this, Se).build(this, t);
      return n.isStaleByTime(Sr(t.staleTime, n)) ? n.fetch(t) : Promise.resolve(n.state.data);
    }
    prefetchQuery(e) {
      return this.fetchQuery(e).then(ot).catch(ot);
    }
    fetchInfiniteQuery(e) {
      return e.behavior = Cg(e.pages), this.fetchQuery(e);
    }
    prefetchInfiniteQuery(e) {
      return this.fetchInfiniteQuery(e).then(ot).catch(ot);
    }
    ensureInfiniteQueryData(e) {
      return e.behavior = Cg(e.pages), this.ensureQueryData(e);
    }
    resumePausedMutations() {
      return Wl.isOnline() ? C(this, sr).resumePausedMutations() : Promise.resolve();
    }
    getQueryCache() {
      return C(this, Se);
    }
    getMutationCache() {
      return C(this, sr);
    }
    getDefaultOptions() {
      return C(this, or);
    }
    setDefaultOptions(e) {
      V(this, or, e);
    }
    setQueryDefaults(e, t) {
      C(this, no).set(Di(e), {
        queryKey: e,
        defaultOptions: t
      });
    }
    getQueryDefaults(e) {
      const t = [...C(this, no).values()],
        n = {};
      return t.forEach(r => {
        Ii(e, r.queryKey) && Object.assign(n, r.defaultOptions);
      }), n;
    }
    setMutationDefaults(e, t) {
      C(this, ro).set(Di(e), {
        mutationKey: e,
        defaultOptions: t
      });
    }
    getMutationDefaults(e) {
      const t = [...C(this, ro).values()],
        n = {};
      return t.forEach(r => {
        Ii(e, r.mutationKey) && Object.assign(n, r.defaultOptions);
      }), n;
    }
    defaultQueryOptions(e) {
      if (e._defaulted) return e;
      const t = {
        ...C(this, or).queries,
        ...this.getQueryDefaults(e.queryKey),
        ...e,
        _defaulted: !0
      };
      return t.queryHash || (t.queryHash = Xh(t.queryKey, t)), t.refetchOnReconnect === void 0 && (t.refetchOnReconnect = t.networkMode !== "always"), t.throwOnError === void 0 && (t.throwOnError = !!t.suspense), !t.networkMode && t.persister && (t.networkMode = "offlineFirst"), t.queryFn === Zh && (t.enabled = !1), t;
    }
    defaultMutationOptions(e) {
      return e != null && e._defaulted ? e : {
        ...C(this, or).mutations,
        ...((e == null ? void 0 : e.mutationKey) && this.getMutationDefaults(e.mutationKey)),
        ...e,
        _defaulted: !0
      };
    }
    clear() {
      C(this, Se).clear(), C(this, sr).clear();
    }
  }, Se = new WeakMap(), sr = new WeakMap(), or = new WeakMap(), no = new WeakMap(), ro = new WeakMap(), ir = new WeakMap(), so = new WeakMap(), oo = new WeakMap(), Qv),
  rt,
  te,
  Qi,
  Ge,
  Jr,
  io,
  ar,
  lr,
  Gi,
  ao,
  lo,
  es,
  ts,
  ur,
  uo,
  se,
  ni,
  sf,
  of,
  af,
  lf,
  uf,
  cf,
  df,
  xw,
  Gv,
  NP = (Gv = class extends na {
    constructor(t, n) {
      super();
      H(this, se);
      H(this, rt);
      H(this, te);
      H(this, Qi);
      H(this, Ge);
      H(this, Jr);
      H(this, io);
      H(this, ar);
      H(this, lr);
      H(this, Gi);
      H(this, ao);
      H(this, lo);
      H(this, es);
      H(this, ts);
      H(this, ur);
      H(this, uo, new Set());
      this.options = n, V(this, rt, t), V(this, lr, null), V(this, ar, rf()), this.options.experimental_prefetchInRender || C(this, ar).reject(new Error("experimental_prefetchInRender feature flag is not enabled")), this.bindMethods(), this.setOptions(n);
    }
    bindMethods() {
      this.refetch = this.refetch.bind(this);
    }
    onSubscribe() {
      this.listeners.size === 1 && (C(this, te).addObserver(this), Pg(C(this, te), this.options) ? ee(this, se, ni).call(this) : this.updateResult(), ee(this, se, lf).call(this));
    }
    onUnsubscribe() {
      this.hasListeners() || this.destroy();
    }
    shouldFetchOnReconnect() {
      return ff(C(this, te), this.options, this.options.refetchOnReconnect);
    }
    shouldFetchOnWindowFocus() {
      return ff(C(this, te), this.options, this.options.refetchOnWindowFocus);
    }
    destroy() {
      this.listeners = new Set(), ee(this, se, uf).call(this), ee(this, se, cf).call(this), C(this, te).removeObserver(this);
    }
    setOptions(t) {
      const n = this.options,
        r = C(this, te);
      if (this.options = C(this, rt).defaultQueryOptions(t), this.options.enabled !== void 0 && typeof this.options.enabled != "boolean" && typeof this.options.enabled != "function" && typeof Et(this.options.enabled, C(this, te)) != "boolean") throw new Error("Expected enabled to be a boolean or a callback that returns a boolean");
      ee(this, se, df).call(this), C(this, te).setOptions(this.options), n._defaulted && !ef(this.options, n) && C(this, rt).getQueryCache().notify({
        type: "observerOptionsUpdated",
        query: C(this, te),
        observer: this
      });
      const s = this.hasListeners();
      s && kg(C(this, te), r, this.options, n) && ee(this, se, ni).call(this), this.updateResult(), s && (C(this, te) !== r || Et(this.options.enabled, C(this, te)) !== Et(n.enabled, C(this, te)) || Sr(this.options.staleTime, C(this, te)) !== Sr(n.staleTime, C(this, te))) && ee(this, se, sf).call(this);
      const o = ee(this, se, of).call(this);
      s && (C(this, te) !== r || Et(this.options.enabled, C(this, te)) !== Et(n.enabled, C(this, te)) || o !== C(this, ur)) && ee(this, se, af).call(this, o);
    }
    getOptimisticResult(t) {
      const n = C(this, rt).getQueryCache().build(C(this, rt), t),
        r = this.createResult(n, t);
      return jP(this, r) && (V(this, Ge, r), V(this, io, this.options), V(this, Jr, C(this, te).state)), r;
    }
    getCurrentResult() {
      return C(this, Ge);
    }
    trackResult(t, n) {
      return new Proxy(t, {
        get: (r, s) => (this.trackProp(s), n == null || n(s), Reflect.get(r, s))
      });
    }
    trackProp(t) {
      C(this, uo).add(t);
    }
    getCurrentQuery() {
      return C(this, te);
    }
    refetch({
      ...t
    } = {}) {
      return this.fetch({
        ...t
      });
    }
    fetchOptimistic(t) {
      const n = C(this, rt).defaultQueryOptions(t),
        r = C(this, rt).getQueryCache().build(C(this, rt), n);
      return r.fetch().then(() => this.createResult(r, n));
    }
    fetch(t) {
      return ee(this, se, ni).call(this, {
        ...t,
        cancelRefetch: t.cancelRefetch ?? !0
      }).then(() => (this.updateResult(), C(this, Ge)));
    }
    createResult(t, n) {
      var A;
      const r = C(this, te),
        s = this.options,
        o = C(this, Ge),
        i = C(this, Jr),
        a = C(this, io),
        u = t !== r ? t.state : C(this, Qi),
        {
          state: d
        } = t;
      let c = {
          ...d
        },
        f = !1,
        h;
      if (n._optimisticResults) {
        const R = this.hasListeners(),
          I = !R && Pg(t, n),
          O = R && kg(t, r, n, s);
        (I || O) && (c = {
          ...c,
          ...vw(d.data, t.options)
        }), n._optimisticResults === "isRestoring" && (c.fetchStatus = "idle");
      }
      let {
        error: w,
        errorUpdatedAt: m,
        status: x
      } = c;
      h = c.data;
      let g = !1;
      if (n.placeholderData !== void 0 && h === void 0 && x === "pending") {
        let R;
        o != null && o.isPlaceholderData && n.placeholderData === (a == null ? void 0 : a.placeholderData) ? (R = o.data, g = !0) : R = typeof n.placeholderData == "function" ? n.placeholderData((A = C(this, lo)) == null ? void 0 : A.state.data, C(this, lo)) : n.placeholderData, R !== void 0 && (x = "success", h = nf(o == null ? void 0 : o.data, R, n), f = !0);
      }
      if (n.select && h !== void 0 && !g) if (o && h === (i == null ? void 0 : i.data) && n.select === C(this, Gi)) h = C(this, ao);else try {
        V(this, Gi, n.select), h = n.select(h), h = nf(o == null ? void 0 : o.data, h, n), V(this, ao, h), V(this, lr, null);
      } catch (R) {
        V(this, lr, R);
      }
      C(this, lr) && (w = C(this, lr), h = C(this, ao), m = Date.now(), x = "error");
      const v = c.fetchStatus === "fetching",
        b = x === "pending",
        S = x === "error",
        E = b && v,
        P = h !== void 0,
        k = {
          status: x,
          fetchStatus: c.fetchStatus,
          isPending: b,
          isSuccess: x === "success",
          isError: S,
          isInitialLoading: E,
          isLoading: E,
          data: h,
          dataUpdatedAt: c.dataUpdatedAt,
          error: w,
          errorUpdatedAt: m,
          failureCount: c.fetchFailureCount,
          failureReason: c.fetchFailureReason,
          errorUpdateCount: c.errorUpdateCount,
          isFetched: c.dataUpdateCount > 0 || c.errorUpdateCount > 0,
          isFetchedAfterMount: c.dataUpdateCount > u.dataUpdateCount || c.errorUpdateCount > u.errorUpdateCount,
          isFetching: v,
          isRefetching: v && !b,
          isLoadingError: S && !P,
          isPaused: c.fetchStatus === "paused",
          isPlaceholderData: f,
          isRefetchError: S && P,
          isStale: ep(t, n),
          refetch: this.refetch,
          promise: C(this, ar),
          isEnabled: Et(n.enabled, t) !== !1
        };
      if (this.options.experimental_prefetchInRender) {
        const R = U => {
            k.status === "error" ? U.reject(k.error) : k.data !== void 0 && U.resolve(k.data);
          },
          I = () => {
            const U = V(this, ar, k.promise = rf());
            R(U);
          },
          O = C(this, ar);
        switch (O.status) {
          case "pending":
            t.queryHash === r.queryHash && R(O);
            break;
          case "fulfilled":
            (k.status === "error" || k.data !== O.value) && I();
            break;
          case "rejected":
            (k.status !== "error" || k.error !== O.reason) && I();
            break;
        }
      }
      return k;
    }
    updateResult() {
      const t = C(this, Ge),
        n = this.createResult(C(this, te), this.options);
      if (V(this, Jr, C(this, te).state), V(this, io, this.options), C(this, Jr).data !== void 0 && V(this, lo, C(this, te)), ef(n, t)) return;
      V(this, Ge, n);
      const r = () => {
        if (!t) return !0;
        const {
            notifyOnChangeProps: s
          } = this.options,
          o = typeof s == "function" ? s() : s;
        if (o === "all" || !o && !C(this, uo).size) return !0;
        const i = new Set(o ?? C(this, uo));
        return this.options.throwOnError && i.add("error"), Object.keys(C(this, Ge)).some(a => {
          const l = a;
          return C(this, Ge)[l] !== t[l] && i.has(l);
        });
      };
      ee(this, se, xw).call(this, {
        listeners: r()
      });
    }
    onQueryUpdate() {
      this.updateResult(), this.hasListeners() && ee(this, se, lf).call(this);
    }
  }, rt = new WeakMap(), te = new WeakMap(), Qi = new WeakMap(), Ge = new WeakMap(), Jr = new WeakMap(), io = new WeakMap(), ar = new WeakMap(), lr = new WeakMap(), Gi = new WeakMap(), ao = new WeakMap(), lo = new WeakMap(), es = new WeakMap(), ts = new WeakMap(), ur = new WeakMap(), uo = new WeakMap(), se = new WeakSet(), ni = function (t) {
    ee(this, se, df).call(this);
    let n = C(this, te).fetch(this.options, t);
    return t != null && t.throwOnError || (n = n.catch(ot)), n;
  }, sf = function () {
    ee(this, se, uf).call(this);
    const t = Sr(this.options.staleTime, C(this, te));
    if (ds || C(this, Ge).isStale || !Jd(t)) return;
    const r = dw(C(this, Ge).dataUpdatedAt, t) + 1;
    V(this, es, setTimeout(() => {
      C(this, Ge).isStale || this.updateResult();
    }, r));
  }, of = function () {
    return (typeof this.options.refetchInterval == "function" ? this.options.refetchInterval(C(this, te)) : this.options.refetchInterval) ?? !1;
  }, af = function (t) {
    ee(this, se, cf).call(this), V(this, ur, t), !(ds || Et(this.options.enabled, C(this, te)) === !1 || !Jd(C(this, ur)) || C(this, ur) === 0) && V(this, ts, setInterval(() => {
      (this.options.refetchIntervalInBackground || Jh.isFocused()) && ee(this, se, ni).call(this);
    }, C(this, ur)));
  }, lf = function () {
    ee(this, se, sf).call(this), ee(this, se, af).call(this, ee(this, se, of).call(this));
  }, uf = function () {
    C(this, es) && (clearTimeout(C(this, es)), V(this, es, void 0));
  }, cf = function () {
    C(this, ts) && (clearInterval(C(this, ts)), V(this, ts, void 0));
  }, df = function () {
    const t = C(this, rt).getQueryCache().build(C(this, rt), this.options);
    if (t === C(this, te)) return;
    const n = C(this, te);
    V(this, te, t), V(this, Qi, t.state), this.hasListeners() && (n == null || n.removeObserver(this), t.addObserver(this));
  }, xw = function (t) {
    _e.batch(() => {
      t.listeners && this.listeners.forEach(n => {
        n(C(this, Ge));
      }), C(this, rt).getQueryCache().notify({
        query: C(this, te),
        type: "observerResultsUpdated"
      });
    });
  }, Gv);
function AP(e, t) {
  return Et(t.enabled, e) !== !1 && e.state.data === void 0 && !(e.state.status === "error" && t.retryOnMount === !1);
}
function Pg(e, t) {
  return AP(e, t) || e.state.data !== void 0 && ff(e, t, t.refetchOnMount);
}
function ff(e, t, n) {
  if (Et(t.enabled, e) !== !1 && Sr(t.staleTime, e) !== "static") {
    const r = typeof n == "function" ? n(e) : n;
    return r === "always" || r !== !1 && ep(e, t);
  }
  return !1;
}
function kg(e, t, n, r) {
  return (e !== t || Et(r.enabled, e) === !1) && (!n.suspense || e.state.status !== "error") && ep(e, n);
}
function ep(e, t) {
  return Et(t.enabled, e) !== !1 && e.isStaleByTime(Sr(t.staleTime, e));
}
function jP(e, t) {
  return !ef(e.getCurrentResult(), t);
}
var ww = y.createContext(void 0),
  MP = e => {
    const t = y.useContext(ww);
    if (!t) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return t;
  },
  OP = ({
    client: e,
    children: t
  }) => (y.useEffect(() => (e.mount(), () => {
    e.unmount();
  }), [e]), p.jsx(ww.Provider, {
    value: e,
    children: t
  })),
  bw = y.createContext(!1),
  LP = () => y.useContext(bw);
bw.Provider;
function DP() {
  let e = !1;
  return {
    clearReset: () => {
      e = !1;
    },
    reset: () => {
      e = !0;
    },
    isReset: () => e
  };
}
var IP = y.createContext(DP()),
  FP = () => y.useContext(IP),
  _P = (e, t) => {
    (e.suspense || e.throwOnError || e.experimental_prefetchInRender) && (t.isReset() || (e.retryOnMount = !1));
  },
  VP = e => {
    y.useEffect(() => {
      e.clearReset();
    }, [e]);
  },
  BP = ({
    result: e,
    errorResetBoundary: t,
    throwOnError: n,
    query: r,
    suspense: s
  }) => e.isError && !t.isReset() && !e.isFetching && r && (s && e.data === void 0 || mP(n, [e.error, r])),
  zP = e => {
    if (e.suspense) {
      const t = r => r === "static" ? r : Math.max(r ?? 1e3, 1e3),
        n = e.staleTime;
      e.staleTime = typeof n == "function" ? (...r) => t(n(...r)) : t(n), typeof e.gcTime == "number" && (e.gcTime = Math.max(e.gcTime, 1e3));
    }
  },
  $P = (e, t) => e.isLoading && e.isFetching && !t,
  UP = (e, t) => (e == null ? void 0 : e.suspense) && t.isPending,
  Rg = (e, t, n) => t.fetchOptimistic(e).catch(() => {
    n.clearReset();
  });
function WP(e, t, n) {
  var c, f, h, w, m;
  const r = LP(),
    s = FP(),
    o = MP(),
    i = o.defaultQueryOptions(e);
  (f = (c = o.getDefaultOptions().queries) == null ? void 0 : c._experimental_beforeQuery) == null || f.call(c, i), i._optimisticResults = r ? "isRestoring" : "optimistic", zP(i), _P(i, s), VP(s);
  const a = !o.getQueryCache().get(i.queryHash),
    [l] = y.useState(() => new t(o, i)),
    u = l.getOptimisticResult(i),
    d = !r && e.subscribed !== !1;
  if (y.useSyncExternalStore(y.useCallback(x => {
    const g = d ? l.subscribe(_e.batchCalls(x)) : ot;
    return l.updateResult(), g;
  }, [l, d]), () => l.getCurrentResult(), () => l.getCurrentResult()), y.useEffect(() => {
    l.setOptions(i);
  }, [i, l]), UP(i, u)) throw Rg(i, l, s);
  if (BP({
    result: u,
    errorResetBoundary: s,
    throwOnError: i.throwOnError,
    query: o.getQueryCache().get(i.queryHash),
    suspense: i.suspense
  })) throw u.error;
  if ((w = (h = o.getDefaultOptions().queries) == null ? void 0 : h._experimental_afterQuery) == null || w.call(h, i, u), i.experimental_prefetchInRender && !ds && $P(u, r)) {
    const x = a ? Rg(i, l, s) : (m = o.getQueryCache().get(i.queryHash)) == null ? void 0 : m.promise;
    x == null || x.catch(ot).finally(() => {
      l.updateResult();
    });
  }
  return i.notifyOnChangeProps ? u : l.trackResult(u);
}
function HP(e, t) {
  return WP(e, NP);
}
/**
 * @remix-run/router v1.23.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function Fi() {
  return Fi = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Fi.apply(this, arguments);
}
var fr;
(function (e) {
  e.Pop = "POP", e.Push = "PUSH", e.Replace = "REPLACE";
})(fr || (fr = {}));
const Ng = "popstate";
function qP(e) {
  e === void 0 && (e = {});
  function t(r, s) {
    let {
      pathname: o,
      search: i,
      hash: a
    } = r.location;
    return hf("", {
      pathname: o,
      search: i,
      hash: a
    }, s.state && s.state.usr || null, s.state && s.state.key || "default");
  }
  function n(r, s) {
    return typeof s == "string" ? s : Hl(s);
  }
  return QP(t, n, null, e);
}
function we(e, t) {
  if (e === !1 || e === null || typeof e > "u") throw new Error(t);
}
function Sw(e, t) {
  if (!e) {
    typeof console < "u" && console.warn(t);
    try {
      throw new Error(t);
    } catch {}
  }
}
function KP() {
  return Math.random().toString(36).substr(2, 8);
}
function Ag(e, t) {
  return {
    usr: e.state,
    key: e.key,
    idx: t
  };
}
function hf(e, t, n, r) {
  return n === void 0 && (n = null), Fi({
    pathname: typeof e == "string" ? e : e.pathname,
    search: "",
    hash: ""
  }, typeof t == "string" ? Ro(t) : t, {
    state: n,
    key: t && t.key || r || KP()
  });
}
function Hl(e) {
  let {
    pathname: t = "/",
    search: n = "",
    hash: r = ""
  } = e;
  return n && n !== "?" && (t += n.charAt(0) === "?" ? n : "?" + n), r && r !== "#" && (t += r.charAt(0) === "#" ? r : "#" + r), t;
}
function Ro(e) {
  let t = {};
  if (e) {
    let n = e.indexOf("#");
    n >= 0 && (t.hash = e.substr(n), e = e.substr(0, n));
    let r = e.indexOf("?");
    r >= 0 && (t.search = e.substr(r), e = e.substr(0, r)), e && (t.pathname = e);
  }
  return t;
}
function QP(e, t, n, r) {
  r === void 0 && (r = {});
  let {
      window: s = document.defaultView,
      v5Compat: o = !1
    } = r,
    i = s.history,
    a = fr.Pop,
    l = null,
    u = d();
  u == null && (u = 0, i.replaceState(Fi({}, i.state, {
    idx: u
  }), ""));
  function d() {
    return (i.state || {
      idx: null
    }).idx;
  }
  function c() {
    a = fr.Pop;
    let x = d(),
      g = x == null ? null : x - u;
    u = x, l && l({
      action: a,
      location: m.location,
      delta: g
    });
  }
  function f(x, g) {
    a = fr.Push;
    let v = hf(m.location, x, g);
    u = d() + 1;
    let b = Ag(v, u),
      S = m.createHref(v);
    try {
      i.pushState(b, "", S);
    } catch (E) {
      if (E instanceof DOMException && E.name === "DataCloneError") throw E;
      s.location.assign(S);
    }
    o && l && l({
      action: a,
      location: m.location,
      delta: 1
    });
  }
  function h(x, g) {
    a = fr.Replace;
    let v = hf(m.location, x, g);
    u = d();
    let b = Ag(v, u),
      S = m.createHref(v);
    i.replaceState(b, "", S), o && l && l({
      action: a,
      location: m.location,
      delta: 0
    });
  }
  function w(x) {
    let g = s.location.origin !== "null" ? s.location.origin : s.location.href,
      v = typeof x == "string" ? x : Hl(x);
    return v = v.replace(/ $/, "%20"), we(g, "No window.location.(origin|href) available to create URL for href: " + v), new URL(v, g);
  }
  let m = {
    get action() {
      return a;
    },
    get location() {
      return e(s, i);
    },
    listen(x) {
      if (l) throw new Error("A history only accepts one active listener");
      return s.addEventListener(Ng, c), l = x, () => {
        s.removeEventListener(Ng, c), l = null;
      };
    },
    createHref(x) {
      return t(s, x);
    },
    createURL: w,
    encodeLocation(x) {
      let g = w(x);
      return {
        pathname: g.pathname,
        search: g.search,
        hash: g.hash
      };
    },
    push: f,
    replace: h,
    go(x) {
      return i.go(x);
    }
  };
  return m;
}
var jg;
(function (e) {
  e.data = "data", e.deferred = "deferred", e.redirect = "redirect", e.error = "error";
})(jg || (jg = {}));
function GP(e, t, n) {
  return n === void 0 && (n = "/"), YP(e, t, n, !1);
}
function YP(e, t, n, r) {
  let s = typeof t == "string" ? Ro(t) : t,
    o = vo(s.pathname || "/", n);
  if (o == null) return null;
  let i = Ew(e);
  XP(i);
  let a = null;
  for (let l = 0; a == null && l < i.length; ++l) {
    let u = lk(o);
    a = ik(i[l], u, r);
  }
  return a;
}
function Ew(e, t, n, r) {
  t === void 0 && (t = []), n === void 0 && (n = []), r === void 0 && (r = "");
  let s = (o, i, a) => {
    let l = {
      relativePath: a === void 0 ? o.path || "" : a,
      caseSensitive: o.caseSensitive === !0,
      childrenIndex: i,
      route: o
    };
    l.relativePath.startsWith("/") && (we(l.relativePath.startsWith(r), 'Absolute route path "' + l.relativePath + '" nested under path ' + ('"' + r + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes."), l.relativePath = l.relativePath.slice(r.length));
    let u = Er([r, l.relativePath]),
      d = n.concat(l);
    o.children && o.children.length > 0 && (we(o.index !== !0, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + u + '".')), Ew(o.children, t, d, u)), !(o.path == null && !o.index) && t.push({
      path: u,
      score: sk(u, o.index),
      routesMeta: d
    });
  };
  return e.forEach((o, i) => {
    var a;
    if (o.path === "" || !((a = o.path) != null && a.includes("?"))) s(o, i);else for (let l of Cw(o.path)) s(o, i, l);
  }), t;
}
function Cw(e) {
  let t = e.split("/");
  if (t.length === 0) return [];
  let [n, ...r] = t,
    s = n.endsWith("?"),
    o = n.replace(/\?$/, "");
  if (r.length === 0) return s ? [o, ""] : [o];
  let i = Cw(r.join("/")),
    a = [];
  return a.push(...i.map(l => l === "" ? o : [o, l].join("/"))), s && a.push(...i), a.map(l => e.startsWith("/") && l === "" ? "/" : l);
}
function XP(e) {
  e.sort((t, n) => t.score !== n.score ? n.score - t.score : ok(t.routesMeta.map(r => r.childrenIndex), n.routesMeta.map(r => r.childrenIndex)));
}
const ZP = /^:[\w-]+$/,
  JP = 3,
  ek = 2,
  tk = 1,
  nk = 10,
  rk = -2,
  Mg = e => e === "*";
function sk(e, t) {
  let n = e.split("/"),
    r = n.length;
  return n.some(Mg) && (r += rk), t && (r += ek), n.filter(s => !Mg(s)).reduce((s, o) => s + (ZP.test(o) ? JP : o === "" ? tk : nk), r);
}
function ok(e, t) {
  return e.length === t.length && e.slice(0, -1).every((r, s) => r === t[s]) ? e[e.length - 1] - t[t.length - 1] : 0;
}
function ik(e, t, n) {
  let {
      routesMeta: r
    } = e,
    s = {},
    o = "/",
    i = [];
  for (let a = 0; a < r.length; ++a) {
    let l = r[a],
      u = a === r.length - 1,
      d = o === "/" ? t : t.slice(o.length) || "/",
      c = ql({
        path: l.relativePath,
        caseSensitive: l.caseSensitive,
        end: u
      }, d),
      f = l.route;
    if (!c && u && n && !r[r.length - 1].route.index && (c = ql({
      path: l.relativePath,
      caseSensitive: l.caseSensitive,
      end: !1
    }, d)), !c) return null;
    Object.assign(s, c.params), i.push({
      params: s,
      pathname: Er([o, c.pathname]),
      pathnameBase: fk(Er([o, c.pathnameBase])),
      route: f
    }), c.pathnameBase !== "/" && (o = Er([o, c.pathnameBase]));
  }
  return i;
}
function ql(e, t) {
  typeof e == "string" && (e = {
    path: e,
    caseSensitive: !1,
    end: !0
  });
  let [n, r] = ak(e.path, e.caseSensitive, e.end),
    s = t.match(n);
  if (!s) return null;
  let o = s[0],
    i = o.replace(/(.)\/+$/, "$1"),
    a = s.slice(1);
  return {
    params: r.reduce((u, d, c) => {
      let {
        paramName: f,
        isOptional: h
      } = d;
      if (f === "*") {
        let m = a[c] || "";
        i = o.slice(0, o.length - m.length).replace(/(.)\/+$/, "$1");
      }
      const w = a[c];
      return h && !w ? u[f] = void 0 : u[f] = (w || "").replace(/%2F/g, "/"), u;
    }, {}),
    pathname: o,
    pathnameBase: i,
    pattern: e
  };
}
function ak(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !0), Sw(e === "*" || !e.endsWith("*") || e.endsWith("/*"), 'Route path "' + e + '" will be treated as if it were ' + ('"' + e.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + e.replace(/\*$/, "/*") + '".'));
  let r = [],
    s = "^" + e.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (i, a, l) => (r.push({
      paramName: a,
      isOptional: l != null
    }), l ? "/?([^\\/]+)?" : "/([^\\/]+)"));
  return e.endsWith("*") ? (r.push({
    paramName: "*"
  }), s += e === "*" || e === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$") : n ? s += "\\/*$" : e !== "" && e !== "/" && (s += "(?:(?=\\/|$))"), [new RegExp(s, t ? void 0 : "i"), r];
}
function lk(e) {
  try {
    return e.split("/").map(t => decodeURIComponent(t).replace(/\//g, "%2F")).join("/");
  } catch (t) {
    return Sw(!1, 'The URL path "' + e + '" could not be decoded because it is is a malformed URL segment. This is probably due to a bad percent ' + ("encoding (" + t + ").")), e;
  }
}
function vo(e, t) {
  if (t === "/") return e;
  if (!e.toLowerCase().startsWith(t.toLowerCase())) return null;
  let n = t.endsWith("/") ? t.length - 1 : t.length,
    r = e.charAt(n);
  return r && r !== "/" ? null : e.slice(n) || "/";
}
function uk(e, t) {
  t === void 0 && (t = "/");
  let {
    pathname: n,
    search: r = "",
    hash: s = ""
  } = typeof e == "string" ? Ro(e) : e;
  return {
    pathname: n ? n.startsWith("/") ? n : ck(n, t) : t,
    search: hk(r),
    hash: pk(s)
  };
}
function ck(e, t) {
  let n = t.replace(/\/+$/, "").split("/");
  return e.split("/").forEach(s => {
    s === ".." ? n.length > 1 && n.pop() : s !== "." && n.push(s);
  }), n.length > 1 ? n.join("/") : "/";
}
function kc(e, t, n, r) {
  return "Cannot include a '" + e + "' character in a manually specified " + ("`to." + t + "` field [" + JSON.stringify(r) + "].  Please separate it out to the ") + ("`to." + n + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
function dk(e) {
  return e.filter((t, n) => n === 0 || t.route.path && t.route.path.length > 0);
}
function tp(e, t) {
  let n = dk(e);
  return t ? n.map((r, s) => s === n.length - 1 ? r.pathname : r.pathnameBase) : n.map(r => r.pathnameBase);
}
function np(e, t, n, r) {
  r === void 0 && (r = !1);
  let s;
  typeof e == "string" ? s = Ro(e) : (s = Fi({}, e), we(!s.pathname || !s.pathname.includes("?"), kc("?", "pathname", "search", s)), we(!s.pathname || !s.pathname.includes("#"), kc("#", "pathname", "hash", s)), we(!s.search || !s.search.includes("#"), kc("#", "search", "hash", s)));
  let o = e === "" || s.pathname === "",
    i = o ? "/" : s.pathname,
    a;
  if (i == null) a = n;else {
    let c = t.length - 1;
    if (!r && i.startsWith("..")) {
      let f = i.split("/");
      for (; f[0] === "..";) f.shift(), c -= 1;
      s.pathname = f.join("/");
    }
    a = c >= 0 ? t[c] : "/";
  }
  let l = uk(s, a),
    u = i && i !== "/" && i.endsWith("/"),
    d = (o || i === ".") && n.endsWith("/");
  return !l.pathname.endsWith("/") && (u || d) && (l.pathname += "/"), l;
}
const Er = e => e.join("/").replace(/\/\/+/g, "/"),
  fk = e => e.replace(/\/+$/, "").replace(/^\/*/, "/"),
  hk = e => !e || e === "?" ? "" : e.startsWith("?") ? e : "?" + e,
  pk = e => !e || e === "#" ? "" : e.startsWith("#") ? e : "#" + e;
function mk(e) {
  return e != null && typeof e.status == "number" && typeof e.statusText == "string" && typeof e.internal == "boolean" && "data" in e;
}
const Tw = ["post", "put", "patch", "delete"];
new Set(Tw);
const gk = ["get", ...Tw];
new Set(gk);
/**
 * React Router v6.30.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function _i() {
  return _i = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, _i.apply(this, arguments);
}
const Ru = y.createContext(null),
  Pw = y.createContext(null),
  Fn = y.createContext(null),
  ra = y.createContext(null),
  _n = y.createContext({
    outlet: null,
    matches: [],
    isDataRoute: !1
  }),
  kw = y.createContext(null);
function yk(e, t) {
  let {
    relative: n
  } = t === void 0 ? {} : t;
  No() || we(!1);
  let {
      basename: r,
      navigator: s
    } = y.useContext(Fn),
    {
      hash: o,
      pathname: i,
      search: a
    } = Nu(e, {
      relative: n
    }),
    l = i;
  return r !== "/" && (l = i === "/" ? r : Er([r, i])), s.createHref({
    pathname: l,
    search: a,
    hash: o
  });
}
function No() {
  return y.useContext(ra) != null;
}
function Vn() {
  return No() || we(!1), y.useContext(ra).location;
}
function vk() {
  return y.useContext(ra).navigationType;
}
function Rw(e) {
  y.useContext(Fn).static || y.useLayoutEffect(e);
}
function rp() {
  let {
    isDataRoute: e
  } = y.useContext(_n);
  return e ? jk() : xk();
}
function xk() {
  No() || we(!1);
  let e = y.useContext(Ru),
    {
      basename: t,
      future: n,
      navigator: r
    } = y.useContext(Fn),
    {
      matches: s
    } = y.useContext(_n),
    {
      pathname: o
    } = Vn(),
    i = JSON.stringify(tp(s, n.v7_relativeSplatPath)),
    a = y.useRef(!1);
  return Rw(() => {
    a.current = !0;
  }), y.useCallback(function (u, d) {
    if (d === void 0 && (d = {}), !a.current) return;
    if (typeof u == "number") {
      r.go(u);
      return;
    }
    let c = np(u, JSON.parse(i), o, d.relative === "path");
    e == null && t !== "/" && (c.pathname = c.pathname === "/" ? t : Er([t, c.pathname])), (d.replace ? r.replace : r.push)(c, d.state, d);
  }, [t, r, i, o, e]);
}
function y5() {
  let {
      matches: e
    } = y.useContext(_n),
    t = e[e.length - 1];
  return t ? t.params : {};
}
function Nu(e, t) {
  let {
      relative: n
    } = t === void 0 ? {} : t,
    {
      future: r
    } = y.useContext(Fn),
    {
      matches: s
    } = y.useContext(_n),
    {
      pathname: o
    } = Vn(),
    i = JSON.stringify(tp(s, r.v7_relativeSplatPath));
  return y.useMemo(() => np(e, JSON.parse(i), o, n === "path"), [e, i, o, n]);
}
function wk(e, t) {
  return bk(e, t);
}
function bk(e, t, n, r) {
  No() || we(!1);
  let {
      navigator: s
    } = y.useContext(Fn),
    {
      matches: o
    } = y.useContext(_n),
    i = o[o.length - 1],
    a = i ? i.params : {};
  i && i.pathname;
  let l = i ? i.pathnameBase : "/";
  i && i.route;
  let u = Vn(),
    d;
  if (t) {
    var c;
    let x = typeof t == "string" ? Ro(t) : t;
    l === "/" || (c = x.pathname) != null && c.startsWith(l) || we(!1), d = x;
  } else d = u;
  let f = d.pathname || "/",
    h = f;
  if (l !== "/") {
    let x = l.replace(/^\//, "").split("/");
    h = "/" + f.replace(/^\//, "").split("/").slice(x.length).join("/");
  }
  let w = GP(e, {
      pathname: h
    }),
    m = Pk(w && w.map(x => Object.assign({}, x, {
      params: Object.assign({}, a, x.params),
      pathname: Er([l, s.encodeLocation ? s.encodeLocation(x.pathname).pathname : x.pathname]),
      pathnameBase: x.pathnameBase === "/" ? l : Er([l, s.encodeLocation ? s.encodeLocation(x.pathnameBase).pathname : x.pathnameBase])
    })), o, n, r);
  return t && m ? y.createElement(ra.Provider, {
    value: {
      location: _i({
        pathname: "/",
        search: "",
        hash: "",
        state: null,
        key: "default"
      }, d),
      navigationType: fr.Pop
    }
  }, m) : m;
}
function Sk() {
  let e = Ak(),
    t = mk(e) ? e.status + " " + e.statusText : e instanceof Error ? e.message : JSON.stringify(e),
    n = e instanceof Error ? e.stack : null,
    s = {
      padding: "0.5rem",
      backgroundColor: "rgba(200,200,200, 0.5)"
    };
  return y.createElement(y.Fragment, null, y.createElement("h2", null, "Unexpected Application Error!"), y.createElement("h3", {
    style: {
      fontStyle: "italic"
    }
  }, t), n ? y.createElement("pre", {
    style: s
  }, n) : null, null);
}
const Ek = y.createElement(Sk, null);
class Ck extends y.Component {
  constructor(t) {
    super(t), this.state = {
      location: t.location,
      revalidation: t.revalidation,
      error: t.error
    };
  }
  static getDerivedStateFromError(t) {
    return {
      error: t
    };
  }
  static getDerivedStateFromProps(t, n) {
    return n.location !== t.location || n.revalidation !== "idle" && t.revalidation === "idle" ? {
      error: t.error,
      location: t.location,
      revalidation: t.revalidation
    } : {
      error: t.error !== void 0 ? t.error : n.error,
      location: n.location,
      revalidation: t.revalidation || n.revalidation
    };
  }
  componentDidCatch(t, n) {
    console.error("React Router caught the following error during render", t, n);
  }
  render() {
    return this.state.error !== void 0 ? y.createElement(_n.Provider, {
      value: this.props.routeContext
    }, y.createElement(kw.Provider, {
      value: this.state.error,
      children: this.props.component
    })) : this.props.children;
  }
}
function Tk(e) {
  let {
      routeContext: t,
      match: n,
      children: r
    } = e,
    s = y.useContext(Ru);
  return s && s.static && s.staticContext && (n.route.errorElement || n.route.ErrorBoundary) && (s.staticContext._deepestRenderedBoundaryId = n.route.id), y.createElement(_n.Provider, {
    value: t
  }, r);
}
function Pk(e, t, n, r) {
  var s;
  if (t === void 0 && (t = []), n === void 0 && (n = null), r === void 0 && (r = null), e == null) {
    var o;
    if (!n) return null;
    if (n.errors) e = n.matches;else if ((o = r) != null && o.v7_partialHydration && t.length === 0 && !n.initialized && n.matches.length > 0) e = n.matches;else return null;
  }
  let i = e,
    a = (s = n) == null ? void 0 : s.errors;
  if (a != null) {
    let d = i.findIndex(c => c.route.id && (a == null ? void 0 : a[c.route.id]) !== void 0);
    d >= 0 || we(!1), i = i.slice(0, Math.min(i.length, d + 1));
  }
  let l = !1,
    u = -1;
  if (n && r && r.v7_partialHydration) for (let d = 0; d < i.length; d++) {
    let c = i[d];
    if ((c.route.HydrateFallback || c.route.hydrateFallbackElement) && (u = d), c.route.id) {
      let {
          loaderData: f,
          errors: h
        } = n,
        w = c.route.loader && f[c.route.id] === void 0 && (!h || h[c.route.id] === void 0);
      if (c.route.lazy || w) {
        l = !0, u >= 0 ? i = i.slice(0, u + 1) : i = [i[0]];
        break;
      }
    }
  }
  return i.reduceRight((d, c, f) => {
    let h,
      w = !1,
      m = null,
      x = null;
    n && (h = a && c.route.id ? a[c.route.id] : void 0, m = c.route.errorElement || Ek, l && (u < 0 && f === 0 ? (w = !0, x = null) : u === f && (w = !0, x = c.route.hydrateFallbackElement || null)));
    let g = t.concat(i.slice(0, f + 1)),
      v = () => {
        let b;
        return h ? b = m : w ? b = x : c.route.Component ? b = y.createElement(c.route.Component, null) : c.route.element ? b = c.route.element : b = d, y.createElement(Tk, {
          match: c,
          routeContext: {
            outlet: d,
            matches: g,
            isDataRoute: n != null
          },
          children: b
        });
      };
    return n && (c.route.ErrorBoundary || c.route.errorElement || f === 0) ? y.createElement(Ck, {
      location: n.location,
      revalidation: n.revalidation,
      component: m,
      error: h,
      children: v(),
      routeContext: {
        outlet: null,
        matches: g,
        isDataRoute: !0
      }
    }) : v();
  }, null);
}
var Nw = function (e) {
    return e.UseBlocker = "useBlocker", e.UseRevalidator = "useRevalidator", e.UseNavigateStable = "useNavigate", e;
  }(Nw || {}),
  Kl = function (e) {
    return e.UseBlocker = "useBlocker", e.UseLoaderData = "useLoaderData", e.UseActionData = "useActionData", e.UseRouteError = "useRouteError", e.UseNavigation = "useNavigation", e.UseRouteLoaderData = "useRouteLoaderData", e.UseMatches = "useMatches", e.UseRevalidator = "useRevalidator", e.UseNavigateStable = "useNavigate", e.UseRouteId = "useRouteId", e;
  }(Kl || {});
function kk(e) {
  let t = y.useContext(Ru);
  return t || we(!1), t;
}
function Rk(e) {
  let t = y.useContext(Pw);
  return t || we(!1), t;
}
function Nk(e) {
  let t = y.useContext(_n);
  return t || we(!1), t;
}
function Aw(e) {
  let t = Nk(),
    n = t.matches[t.matches.length - 1];
  return n.route.id || we(!1), n.route.id;
}
function Ak() {
  var e;
  let t = y.useContext(kw),
    n = Rk(Kl.UseRouteError),
    r = Aw(Kl.UseRouteError);
  return t !== void 0 ? t : (e = n.errors) == null ? void 0 : e[r];
}
function jk() {
  let {
      router: e
    } = kk(Nw.UseNavigateStable),
    t = Aw(Kl.UseNavigateStable),
    n = y.useRef(!1);
  return Rw(() => {
    n.current = !0;
  }), y.useCallback(function (s, o) {
    o === void 0 && (o = {}), n.current && (typeof s == "number" ? e.navigate(s) : e.navigate(s, _i({
      fromRouteId: t
    }, o)));
  }, [e, t]);
}
function Mk(e, t) {
  e == null || e.v7_startTransition, e == null || e.v7_relativeSplatPath;
}
function Ok(e) {
  let {
    to: t,
    replace: n,
    state: r,
    relative: s
  } = e;
  No() || we(!1);
  let {
      future: o,
      static: i
    } = y.useContext(Fn),
    {
      matches: a
    } = y.useContext(_n),
    {
      pathname: l
    } = Vn(),
    u = rp(),
    d = np(t, tp(a, o.v7_relativeSplatPath), l, s === "path"),
    c = JSON.stringify(d);
  return y.useEffect(() => u(JSON.parse(c), {
    replace: n,
    state: r,
    relative: s
  }), [u, c, s, n, r]), null;
}
function bt(e) {
  we(!1);
}
function Lk(e) {
  let {
    basename: t = "/",
    children: n = null,
    location: r,
    navigationType: s = fr.Pop,
    navigator: o,
    static: i = !1,
    future: a
  } = e;
  No() && we(!1);
  let l = t.replace(/^\/*/, "/"),
    u = y.useMemo(() => ({
      basename: l,
      navigator: o,
      static: i,
      future: _i({
        v7_relativeSplatPath: !1
      }, a)
    }), [l, a, o, i]);
  typeof r == "string" && (r = Ro(r));
  let {
      pathname: d = "/",
      search: c = "",
      hash: f = "",
      state: h = null,
      key: w = "default"
    } = r,
    m = y.useMemo(() => {
      let x = vo(d, l);
      return x == null ? null : {
        location: {
          pathname: x,
          search: c,
          hash: f,
          state: h,
          key: w
        },
        navigationType: s
      };
    }, [l, d, c, f, h, w, s]);
  return m == null ? null : y.createElement(Fn.Provider, {
    value: u
  }, y.createElement(ra.Provider, {
    children: n,
    value: m
  }));
}
function Dk(e) {
  let {
    children: t,
    location: n
  } = e;
  return wk(pf(t), n);
}
new Promise(() => {});
function pf(e, t) {
  t === void 0 && (t = []);
  let n = [];
  return y.Children.forEach(e, (r, s) => {
    if (!y.isValidElement(r)) return;
    let o = [...t, s];
    if (r.type === y.Fragment) {
      n.push.apply(n, pf(r.props.children, o));
      return;
    }
    r.type !== bt && we(!1), !r.props.index || !r.props.children || we(!1);
    let i = {
      id: r.props.id || o.join("-"),
      caseSensitive: r.props.caseSensitive,
      element: r.props.element,
      Component: r.props.Component,
      index: r.props.index,
      path: r.props.path,
      loader: r.props.loader,
      action: r.props.action,
      errorElement: r.props.errorElement,
      ErrorBoundary: r.props.ErrorBoundary,
      hasErrorBoundary: r.props.ErrorBoundary != null || r.props.errorElement != null,
      shouldRevalidate: r.props.shouldRevalidate,
      handle: r.props.handle,
      lazy: r.props.lazy
    };
    r.props.children && (i.children = pf(r.props.children, o)), n.push(i);
  }), n;
}
/**
 * React Router DOM v6.30.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function Ql() {
  return Ql = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ql.apply(this, arguments);
}
function jw(e, t) {
  if (e == null) return {};
  var n = {},
    r = Object.keys(e),
    s,
    o;
  for (o = 0; o < r.length; o++) s = r[o], !(t.indexOf(s) >= 0) && (n[s] = e[s]);
  return n;
}
function Ik(e) {
  return !!(e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
}
function Fk(e, t) {
  return e.button === 0 && (!t || t === "_self") && !Ik(e);
}
function mf(e) {
  return e === void 0 && (e = ""), new URLSearchParams(typeof e == "string" || Array.isArray(e) || e instanceof URLSearchParams ? e : Object.keys(e).reduce((t, n) => {
    let r = e[n];
    return t.concat(Array.isArray(r) ? r.map(s => [n, s]) : [[n, r]]);
  }, []));
}
function _k(e, t) {
  let n = mf(e);
  return t && t.forEach((r, s) => {
    n.has(s) || t.getAll(s).forEach(o => {
      n.append(s, o);
    });
  }), n;
}
const Vk = ["onClick", "relative", "reloadDocument", "replace", "state", "target", "to", "preventScrollReset", "viewTransition"],
  Bk = ["aria-current", "caseSensitive", "className", "end", "style", "to", "viewTransition", "children"],
  zk = "6";
try {
  window.__reactRouterVersion = zk;
} catch {}
const $k = y.createContext({
    isTransitioning: !1
  }),
  Uk = "startTransition",
  Og = ih[Uk];
function Wk(props) {
  const history = y.useRef();
  if (!history.current) history.current = qP({
    v5Compat: true
  });
  const base = history.current;
  const [state, setState] = y.useState({
    action: base.action,
    location: base.location
  });
  y.useLayoutEffect(() => base.listen(setState), [base]);
  const navigator = y.useMemo(() => ({
    ...base,
    createHref: to => window.LyoShopify.href(to),
    push: (to, data, options) => {
      const target = window.LyoShopify.href(to);
      if (window.LyoShopify.shouldReload(target)) window.location.assign(target);
      else base.push(target, data, options);
    },
    replace: (to, data, options) => {
      const target = window.LyoShopify.href(to);
      if (window.LyoShopify.shouldReload(target)) window.location.replace(target);
      else base.replace(target, data, options);
    },
    encodeLocation: to => typeof to === 'string' ? Ro(to) : to
  }), [base]);
  return y.createElement(Lk, {
    children: props.children,
    location: window.LyoShopify.virtual(state.location),
    navigationType: state.action,
    navigator,
    future: props.future
  });
}
const Hk = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u",
  qk = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i,
  Le = y.forwardRef(function (t, n) {
    let {
        onClick: r,
        relative: s,
        reloadDocument: o,
        replace: i,
        state: a,
        target: l,
        to: u,
        preventScrollReset: d,
        viewTransition: c
      } = t,
      f = jw(t, Vk),
      {
        basename: h
      } = y.useContext(Fn),
      w,
      m = !1;
    if (typeof u == "string" && qk.test(u) && (w = u, Hk)) try {
      let b = new URL(window.location.href),
        S = u.startsWith("//") ? new URL(b.protocol + u) : new URL(u),
        E = vo(S.pathname, h);
      S.origin === b.origin && E != null ? u = E + S.search + S.hash : m = !0;
    } catch {}
    let x = yk(u, {
        relative: s
      }),
      g = Qk(u, {
        replace: i,
        state: a,
        target: l,
        preventScrollReset: d,
        relative: s,
        viewTransition: c
      });
    function v(b) {
      r && r(b), b.defaultPrevented || g(b);
    }
    return y.createElement("a", Ql({}, f, {
      href: w || x,
      onClick: m || o ? r : v,
      ref: n,
      target: l
    }));
  }),
  Lg = y.forwardRef(function (t, n) {
    let {
        "aria-current": r = "page",
        caseSensitive: s = !1,
        className: o = "",
        end: i = !1,
        style: a,
        to: l,
        viewTransition: u,
        children: d
      } = t,
      c = jw(t, Bk),
      f = Nu(l, {
        relative: c.relative
      }),
      h = Vn(),
      w = y.useContext(Pw),
      {
        navigator: m,
        basename: x
      } = y.useContext(Fn),
      g = w != null && Gk(f) && u === !0,
      v = m.encodeLocation ? m.encodeLocation(f).pathname : f.pathname,
      b = h.pathname,
      S = w && w.navigation && w.navigation.location ? w.navigation.location.pathname : null;
    s || (b = b.toLowerCase(), S = S ? S.toLowerCase() : null, v = v.toLowerCase()), S && x && (S = vo(S, x) || S);
    const E = v !== "/" && v.endsWith("/") ? v.length - 1 : v.length;
    let P = b === v || !i && b.startsWith(v) && b.charAt(E) === "/",
      T = S != null && (S === v || !i && S.startsWith(v) && S.charAt(v.length) === "/"),
      k = {
        isActive: P,
        isPending: T,
        isTransitioning: g
      },
      A = P ? r : void 0,
      R;
    typeof o == "function" ? R = o(k) : R = [o, P ? "active" : null, T ? "pending" : null, g ? "transitioning" : null].filter(Boolean).join(" ");
    let I = typeof a == "function" ? a(k) : a;
    return y.createElement(Le, Ql({}, c, {
      "aria-current": A,
      className: R,
      ref: n,
      style: I,
      to: l,
      viewTransition: u
    }), typeof d == "function" ? d(k) : d);
  });
var gf;
(function (e) {
  e.UseScrollRestoration = "useScrollRestoration", e.UseSubmit = "useSubmit", e.UseSubmitFetcher = "useSubmitFetcher", e.UseFetcher = "useFetcher", e.useViewTransitionState = "useViewTransitionState";
})(gf || (gf = {}));
var Dg;
(function (e) {
  e.UseFetcher = "useFetcher", e.UseFetchers = "useFetchers", e.UseScrollRestoration = "useScrollRestoration";
})(Dg || (Dg = {}));
function Kk(e) {
  let t = y.useContext(Ru);
  return t || we(!1), t;
}
function Qk(e, t) {
  let {
      target: n,
      replace: r,
      state: s,
      preventScrollReset: o,
      relative: i,
      viewTransition: a
    } = t === void 0 ? {} : t,
    l = rp(),
    u = Vn(),
    d = Nu(e, {
      relative: i
    });
  return y.useCallback(c => {
    if (Fk(c, n)) {
      c.preventDefault();
      let f = r !== void 0 ? r : Hl(u) === Hl(d);
      l(e, {
        replace: f,
        state: s,
        preventScrollReset: o,
        relative: i,
        viewTransition: a
      });
    }
  }, [u, l, d, r, s, n, e, o, i, a]);
}
function v5(e) {
  let t = y.useRef(mf(e)),
    n = y.useRef(!1),
    r = Vn(),
    s = y.useMemo(() => _k(r.search, n.current ? null : t.current), [r.search]),
    o = rp(),
    i = y.useCallback((a, l) => {
      const u = mf(typeof a == "function" ? a(s) : a);
      n.current = !0, o("?" + u, l);
    }, [o, s]);
  return [s, i];
}
function Gk(e, t) {
  t === void 0 && (t = {});
  let n = y.useContext($k);
  n == null && we(!1);
  let {
      basename: r
    } = Kk(gf.useViewTransitionState),
    s = Nu(e, {
      relative: t.relative
    });
  if (!n.isTransitioning) return !1;
  let o = vo(n.currentLocation.pathname, r) || n.currentLocation.pathname,
    i = vo(n.nextLocation.pathname, r) || n.nextLocation.pathname;
  return ql(s.pathname, i) != null || ql(s.pathname, o) != null;
}
var Ig = ["light", "dark"],
  Yk = "(prefers-color-scheme: dark)",
  Xk = y.createContext(void 0),
  Zk = {
    setTheme: e => {},
    themes: []
  },
  Jk = () => {
    var e;
    return (e = y.useContext(Xk)) != null ? e : Zk;
  };
y.memo(({
  forcedTheme: e,
  storageKey: t,
  attribute: n,
  enableSystem: r,
  enableColorScheme: s,
  defaultTheme: o,
  value: i,
  attrs: a,
  nonce: l
}) => {
  let u = o === "system",
    d = n === "class" ? `var d=document.documentElement,c=d.classList;${`c.remove(${a.map(w => `'${w}'`).join(",")})`};` : `var d=document.documentElement,n='${n}',s='setAttribute';`,
    c = s ? Ig.includes(o) && o ? `if(e==='light'||e==='dark'||!e)d.style.colorScheme=e||'${o}'` : "if(e==='light'||e==='dark')d.style.colorScheme=e" : "",
    f = (w, m = !1, x = !0) => {
      let g = i ? i[w] : w,
        v = m ? w + "|| ''" : `'${g}'`,
        b = "";
      return s && x && !m && Ig.includes(w) && (b += `d.style.colorScheme = '${w}';`), n === "class" ? m || g ? b += `c.add(${v})` : b += "null" : g && (b += `d[s](n,${v})`), b;
    },
    h = e ? `!function(){${d}${f(e)}}()` : r ? `!function(){try{${d}var e=localStorage.getItem('${t}');if('system'===e||(!e&&${u})){var t='${Yk}',m=window.matchMedia(t);if(m.media!==t||m.matches){${f("dark")}}else{${f("light")}}}else if(e){${i ? `var x=${JSON.stringify(i)};` : ""}${f(i ? "x[e]" : "e", !0)}}${u ? "" : "else{" + f(o, !1, !1) + "}"}${c}}catch(e){}}()` : `!function(){try{${d}var e=localStorage.getItem('${t}');if(e){${i ? `var x=${JSON.stringify(i)};` : ""}${f(i ? "x[e]" : "e", !0)}}else{${f(o, !1, !1)};}${c}}catch(t){}}();`;
  return y.createElement("script", {
    nonce: l,
    dangerouslySetInnerHTML: {
      __html: h
    }
  });
});
var e2 = e => {
    switch (e) {
      case "success":
        return r2;
      case "info":
        return o2;
      case "warning":
        return s2;
      case "error":
        return i2;
      default:
        return null;
    }
  },
  t2 = Array(12).fill(0),
  n2 = ({
    visible: e,
    className: t
  }) => L.createElement("div", {
    className: ["sonner-loading-wrapper", t].filter(Boolean).join(" "),
    "data-visible": e
  }, L.createElement("div", {
    className: "sonner-spinner"
  }, t2.map((n, r) => L.createElement("div", {
    className: "sonner-loading-bar",
    key: `spinner-bar-${r}`
  })))),
  r2 = L.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    height: "20",
    width: "20"
  }, L.createElement("path", {
    fillRule: "evenodd",
    d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z",
    clipRule: "evenodd"
  })),
  s2 = L.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    height: "20",
    width: "20"
  }, L.createElement("path", {
    fillRule: "evenodd",
    d: "M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z",
    clipRule: "evenodd"
  })),
  o2 = L.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    height: "20",
    width: "20"
  }, L.createElement("path", {
    fillRule: "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z",
    clipRule: "evenodd"
  })),
  i2 = L.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    height: "20",
    width: "20"
  }, L.createElement("path", {
    fillRule: "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-5a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0v-4.5A.75.75 0 0110 5zm0 10a1 1 0 100-2 1 1 0 000 2z",
    clipRule: "evenodd"
  })),
  a2 = L.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "12",
    height: "12",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, L.createElement("line", {
    x1: "18",
    y1: "6",
    x2: "6",
    y2: "18"
  }), L.createElement("line", {
    x1: "6",
    y1: "6",
    x2: "18",
    y2: "18"
  })),
  l2 = () => {
    let [e, t] = L.useState(document.hidden);
    return L.useEffect(() => {
      let n = () => {
        t(document.hidden);
      };
      return document.addEventListener("visibilitychange", n), () => window.removeEventListener("visibilitychange", n);
    }, []), e;
  },
  yf = 1,
  u2 = class {
    constructor() {
      this.subscribe = e => (this.subscribers.push(e), () => {
        let t = this.subscribers.indexOf(e);
        this.subscribers.splice(t, 1);
      }), this.publish = e => {
        this.subscribers.forEach(t => t(e));
      }, this.addToast = e => {
        this.publish(e), this.toasts = [...this.toasts, e];
      }, this.create = e => {
        var t;
        let {
            message: n,
            ...r
          } = e,
          s = typeof (e == null ? void 0 : e.id) == "number" || ((t = e.id) == null ? void 0 : t.length) > 0 ? e.id : yf++,
          o = this.toasts.find(a => a.id === s),
          i = e.dismissible === void 0 ? !0 : e.dismissible;
        return this.dismissedToasts.has(s) && this.dismissedToasts.delete(s), o ? this.toasts = this.toasts.map(a => a.id === s ? (this.publish({
          ...a,
          ...e,
          id: s,
          title: n
        }), {
          ...a,
          ...e,
          id: s,
          dismissible: i,
          title: n
        }) : a) : this.addToast({
          title: n,
          ...r,
          dismissible: i,
          id: s
        }), s;
      }, this.dismiss = e => (this.dismissedToasts.add(e), e || this.toasts.forEach(t => {
        this.subscribers.forEach(n => n({
          id: t.id,
          dismiss: !0
        }));
      }), this.subscribers.forEach(t => t({
        id: e,
        dismiss: !0
      })), e), this.message = (e, t) => this.create({
        ...t,
        message: e
      }), this.error = (e, t) => this.create({
        ...t,
        message: e,
        type: "error"
      }), this.success = (e, t) => this.create({
        ...t,
        type: "success",
        message: e
      }), this.info = (e, t) => this.create({
        ...t,
        type: "info",
        message: e
      }), this.warning = (e, t) => this.create({
        ...t,
        type: "warning",
        message: e
      }), this.loading = (e, t) => this.create({
        ...t,
        type: "loading",
        message: e
      }), this.promise = (e, t) => {
        if (!t) return;
        let n;
        t.loading !== void 0 && (n = this.create({
          ...t,
          promise: e,
          type: "loading",
          message: t.loading,
          description: typeof t.description != "function" ? t.description : void 0
        }));
        let r = e instanceof Promise ? e : e(),
          s = n !== void 0,
          o,
          i = r.then(async l => {
            if (o = ["resolve", l], L.isValidElement(l)) s = !1, this.create({
              id: n,
              type: "default",
              message: l
            });else if (d2(l) && !l.ok) {
              s = !1;
              let u = typeof t.error == "function" ? await t.error(`HTTP error! status: ${l.status}`) : t.error,
                d = typeof t.description == "function" ? await t.description(`HTTP error! status: ${l.status}`) : t.description;
              this.create({
                id: n,
                type: "error",
                message: u,
                description: d
              });
            } else if (t.success !== void 0) {
              s = !1;
              let u = typeof t.success == "function" ? await t.success(l) : t.success,
                d = typeof t.description == "function" ? await t.description(l) : t.description;
              this.create({
                id: n,
                type: "success",
                message: u,
                description: d
              });
            }
          }).catch(async l => {
            if (o = ["reject", l], t.error !== void 0) {
              s = !1;
              let u = typeof t.error == "function" ? await t.error(l) : t.error,
                d = typeof t.description == "function" ? await t.description(l) : t.description;
              this.create({
                id: n,
                type: "error",
                message: u,
                description: d
              });
            }
          }).finally(() => {
            var l;
            s && (this.dismiss(n), n = void 0), (l = t.finally) == null || l.call(t);
          }),
          a = () => new Promise((l, u) => i.then(() => o[0] === "reject" ? u(o[1]) : l(o[1])).catch(u));
        return typeof n != "string" && typeof n != "number" ? {
          unwrap: a
        } : Object.assign(n, {
          unwrap: a
        });
      }, this.custom = (e, t) => {
        let n = (t == null ? void 0 : t.id) || yf++;
        return this.create({
          jsx: e(n),
          id: n,
          ...t
        }), n;
      }, this.getActiveToasts = () => this.toasts.filter(e => !this.dismissedToasts.has(e.id)), this.subscribers = [], this.toasts = [], this.dismissedToasts = new Set();
    }
  },
  st = new u2(),
  c2 = (e, t) => {
    let n = (t == null ? void 0 : t.id) || yf++;
    return st.addToast({
      title: e,
      ...t,
      id: n
    }), n;
  },
  d2 = e => e && typeof e == "object" && "ok" in e && typeof e.ok == "boolean" && "status" in e && typeof e.status == "number",
  f2 = c2,
  h2 = () => st.toasts,
  p2 = () => st.getActiveToasts(),
  La = Object.assign(f2, {
    success: st.success,
    info: st.info,
    warning: st.warning,
    error: st.error,
    custom: st.custom,
    message: st.message,
    promise: st.promise,
    dismiss: st.dismiss,
    loading: st.loading
  }, {
    getHistory: h2,
    getToasts: p2
  });
function m2(e, {
  insertAt: t
} = {}) {
  if (typeof document > "u") return;
  let n = document.head || document.getElementsByTagName("head")[0],
    r = document.createElement("style");
  r.type = "text/css", t === "top" && n.firstChild ? n.insertBefore(r, n.firstChild) : n.appendChild(r), r.styleSheet ? r.styleSheet.cssText = e : r.appendChild(document.createTextNode(e));
}
m2(`:where(html[dir="ltr"]),:where([data-sonner-toaster][dir="ltr"]){--toast-icon-margin-start: -3px;--toast-icon-margin-end: 4px;--toast-svg-margin-start: -1px;--toast-svg-margin-end: 0px;--toast-button-margin-start: auto;--toast-button-margin-end: 0;--toast-close-button-start: 0;--toast-close-button-end: unset;--toast-close-button-transform: translate(-35%, -35%)}:where(html[dir="rtl"]),:where([data-sonner-toaster][dir="rtl"]){--toast-icon-margin-start: 4px;--toast-icon-margin-end: -3px;--toast-svg-margin-start: 0px;--toast-svg-margin-end: -1px;--toast-button-margin-start: 0;--toast-button-margin-end: auto;--toast-close-button-start: unset;--toast-close-button-end: 0;--toast-close-button-transform: translate(35%, -35%)}:where([data-sonner-toaster]){position:fixed;width:var(--width);font-family:ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;--gray1: hsl(0, 0%, 99%);--gray2: hsl(0, 0%, 97.3%);--gray3: hsl(0, 0%, 95.1%);--gray4: hsl(0, 0%, 93%);--gray5: hsl(0, 0%, 90.9%);--gray6: hsl(0, 0%, 88.7%);--gray7: hsl(0, 0%, 85.8%);--gray8: hsl(0, 0%, 78%);--gray9: hsl(0, 0%, 56.1%);--gray10: hsl(0, 0%, 52.3%);--gray11: hsl(0, 0%, 43.5%);--gray12: hsl(0, 0%, 9%);--border-radius: 8px;box-sizing:border-box;padding:0;margin:0;list-style:none;outline:none;z-index:999999999;transition:transform .4s ease}:where([data-sonner-toaster][data-lifted="true"]){transform:translateY(-10px)}@media (hover: none) and (pointer: coarse){:where([data-sonner-toaster][data-lifted="true"]){transform:none}}:where([data-sonner-toaster][data-x-position="right"]){right:var(--offset-right)}:where([data-sonner-toaster][data-x-position="left"]){left:var(--offset-left)}:where([data-sonner-toaster][data-x-position="center"]){left:50%;transform:translate(-50%)}:where([data-sonner-toaster][data-y-position="top"]){top:var(--offset-top)}:where([data-sonner-toaster][data-y-position="bottom"]){bottom:var(--offset-bottom)}:where([data-sonner-toast]){--y: translateY(100%);--lift-amount: calc(var(--lift) * var(--gap));z-index:var(--z-index);position:absolute;opacity:0;transform:var(--y);filter:blur(0);touch-action:none;transition:transform .4s,opacity .4s,height .4s,box-shadow .2s;box-sizing:border-box;outline:none;overflow-wrap:anywhere}:where([data-sonner-toast][data-styled="true"]){padding:16px;background:var(--normal-bg);border:1px solid var(--normal-border);color:var(--normal-text);border-radius:var(--border-radius);box-shadow:0 4px 12px #0000001a;width:var(--width);font-size:13px;display:flex;align-items:center;gap:6px}:where([data-sonner-toast]:focus-visible){box-shadow:0 4px 12px #0000001a,0 0 0 2px #0003}:where([data-sonner-toast][data-y-position="top"]){top:0;--y: translateY(-100%);--lift: 1;--lift-amount: calc(1 * var(--gap))}:where([data-sonner-toast][data-y-position="bottom"]){bottom:0;--y: translateY(100%);--lift: -1;--lift-amount: calc(var(--lift) * var(--gap))}:where([data-sonner-toast]) :where([data-description]){font-weight:400;line-height:1.4;color:inherit}:where([data-sonner-toast]) :where([data-title]){font-weight:500;line-height:1.5;color:inherit}:where([data-sonner-toast]) :where([data-icon]){display:flex;height:16px;width:16px;position:relative;justify-content:flex-start;align-items:center;flex-shrink:0;margin-left:var(--toast-icon-margin-start);margin-right:var(--toast-icon-margin-end)}:where([data-sonner-toast][data-promise="true"]) :where([data-icon])>svg{opacity:0;transform:scale(.8);transform-origin:center;animation:sonner-fade-in .3s ease forwards}:where([data-sonner-toast]) :where([data-icon])>*{flex-shrink:0}:where([data-sonner-toast]) :where([data-icon]) svg{margin-left:var(--toast-svg-margin-start);margin-right:var(--toast-svg-margin-end)}:where([data-sonner-toast]) :where([data-content]){display:flex;flex-direction:column;gap:2px}[data-sonner-toast][data-styled=true] [data-button]{border-radius:4px;padding-left:8px;padding-right:8px;height:24px;font-size:12px;color:var(--normal-bg);background:var(--normal-text);margin-left:var(--toast-button-margin-start);margin-right:var(--toast-button-margin-end);border:none;cursor:pointer;outline:none;display:flex;align-items:center;flex-shrink:0;transition:opacity .4s,box-shadow .2s}:where([data-sonner-toast]) :where([data-button]):focus-visible{box-shadow:0 0 0 2px #0006}:where([data-sonner-toast]) :where([data-button]):first-of-type{margin-left:var(--toast-button-margin-start);margin-right:var(--toast-button-margin-end)}:where([data-sonner-toast]) :where([data-cancel]){color:var(--normal-text);background:rgba(0,0,0,.08)}:where([data-sonner-toast][data-theme="dark"]) :where([data-cancel]){background:rgba(255,255,255,.3)}:where([data-sonner-toast]) :where([data-close-button]){position:absolute;left:var(--toast-close-button-start);right:var(--toast-close-button-end);top:0;height:20px;width:20px;display:flex;justify-content:center;align-items:center;padding:0;color:var(--gray12);border:1px solid var(--gray4);transform:var(--toast-close-button-transform);border-radius:50%;cursor:pointer;z-index:1;transition:opacity .1s,background .2s,border-color .2s}[data-sonner-toast] [data-close-button]{background:var(--gray1)}:where([data-sonner-toast]) :where([data-close-button]):focus-visible{box-shadow:0 4px 12px #0000001a,0 0 0 2px #0003}:where([data-sonner-toast]) :where([data-disabled="true"]){cursor:not-allowed}:where([data-sonner-toast]):hover :where([data-close-button]):hover{background:var(--gray2);border-color:var(--gray5)}:where([data-sonner-toast][data-swiping="true"]):before{content:"";position:absolute;left:-50%;right:-50%;height:100%;z-index:-1}:where([data-sonner-toast][data-y-position="top"][data-swiping="true"]):before{bottom:50%;transform:scaleY(3) translateY(50%)}:where([data-sonner-toast][data-y-position="bottom"][data-swiping="true"]):before{top:50%;transform:scaleY(3) translateY(-50%)}:where([data-sonner-toast][data-swiping="false"][data-removed="true"]):before{content:"";position:absolute;inset:0;transform:scaleY(2)}:where([data-sonner-toast]):after{content:"";position:absolute;left:0;height:calc(var(--gap) + 1px);bottom:100%;width:100%}:where([data-sonner-toast][data-mounted="true"]){--y: translateY(0);opacity:1}:where([data-sonner-toast][data-expanded="false"][data-front="false"]){--scale: var(--toasts-before) * .05 + 1;--y: translateY(calc(var(--lift-amount) * var(--toasts-before))) scale(calc(-1 * var(--scale)));height:var(--front-toast-height)}:where([data-sonner-toast])>*{transition:opacity .4s}:where([data-sonner-toast][data-expanded="false"][data-front="false"][data-styled="true"])>*{opacity:0}:where([data-sonner-toast][data-visible="false"]){opacity:0;pointer-events:none}:where([data-sonner-toast][data-mounted="true"][data-expanded="true"]){--y: translateY(calc(var(--lift) * var(--offset)));height:var(--initial-height)}:where([data-sonner-toast][data-removed="true"][data-front="true"][data-swipe-out="false"]){--y: translateY(calc(var(--lift) * -100%));opacity:0}:where([data-sonner-toast][data-removed="true"][data-front="false"][data-swipe-out="false"][data-expanded="true"]){--y: translateY(calc(var(--lift) * var(--offset) + var(--lift) * -100%));opacity:0}:where([data-sonner-toast][data-removed="true"][data-front="false"][data-swipe-out="false"][data-expanded="false"]){--y: translateY(40%);opacity:0;transition:transform .5s,opacity .2s}:where([data-sonner-toast][data-removed="true"][data-front="false"]):before{height:calc(var(--initial-height) + 20%)}[data-sonner-toast][data-swiping=true]{transform:var(--y) translateY(var(--swipe-amount-y, 0px)) translate(var(--swipe-amount-x, 0px));transition:none}[data-sonner-toast][data-swiped=true]{user-select:none}[data-sonner-toast][data-swipe-out=true][data-y-position=bottom],[data-sonner-toast][data-swipe-out=true][data-y-position=top]{animation-duration:.2s;animation-timing-function:ease-out;animation-fill-mode:forwards}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=left]{animation-name:swipe-out-left}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=right]{animation-name:swipe-out-right}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=up]{animation-name:swipe-out-up}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=down]{animation-name:swipe-out-down}@keyframes swipe-out-left{0%{transform:var(--y) translate(var(--swipe-amount-x));opacity:1}to{transform:var(--y) translate(calc(var(--swipe-amount-x) - 100%));opacity:0}}@keyframes swipe-out-right{0%{transform:var(--y) translate(var(--swipe-amount-x));opacity:1}to{transform:var(--y) translate(calc(var(--swipe-amount-x) + 100%));opacity:0}}@keyframes swipe-out-up{0%{transform:var(--y) translateY(var(--swipe-amount-y));opacity:1}to{transform:var(--y) translateY(calc(var(--swipe-amount-y) - 100%));opacity:0}}@keyframes swipe-out-down{0%{transform:var(--y) translateY(var(--swipe-amount-y));opacity:1}to{transform:var(--y) translateY(calc(var(--swipe-amount-y) + 100%));opacity:0}}@media (max-width: 600px){[data-sonner-toaster]{position:fixed;right:var(--mobile-offset-right);left:var(--mobile-offset-left);width:100%}[data-sonner-toaster][dir=rtl]{left:calc(var(--mobile-offset-left) * -1)}[data-sonner-toaster] [data-sonner-toast]{left:0;right:0;width:calc(100% - var(--mobile-offset-left) * 2)}[data-sonner-toaster][data-x-position=left]{left:var(--mobile-offset-left)}[data-sonner-toaster][data-y-position=bottom]{bottom:var(--mobile-offset-bottom)}[data-sonner-toaster][data-y-position=top]{top:var(--mobile-offset-top)}[data-sonner-toaster][data-x-position=center]{left:var(--mobile-offset-left);right:var(--mobile-offset-right);transform:none}}[data-sonner-toaster][data-theme=light]{--normal-bg: #fff;--normal-border: var(--gray4);--normal-text: var(--gray12);--success-bg: hsl(143, 85%, 96%);--success-border: hsl(145, 92%, 91%);--success-text: hsl(140, 100%, 27%);--info-bg: hsl(208, 100%, 97%);--info-border: hsl(221, 91%, 91%);--info-text: hsl(210, 92%, 45%);--warning-bg: hsl(49, 100%, 97%);--warning-border: hsl(49, 91%, 91%);--warning-text: hsl(31, 92%, 45%);--error-bg: hsl(359, 100%, 97%);--error-border: hsl(359, 100%, 94%);--error-text: hsl(360, 100%, 45%)}[data-sonner-toaster][data-theme=light] [data-sonner-toast][data-invert=true]{--normal-bg: #000;--normal-border: hsl(0, 0%, 20%);--normal-text: var(--gray1)}[data-sonner-toaster][data-theme=dark] [data-sonner-toast][data-invert=true]{--normal-bg: #fff;--normal-border: var(--gray3);--normal-text: var(--gray12)}[data-sonner-toaster][data-theme=dark]{--normal-bg: #000;--normal-bg-hover: hsl(0, 0%, 12%);--normal-border: hsl(0, 0%, 20%);--normal-border-hover: hsl(0, 0%, 25%);--normal-text: var(--gray1);--success-bg: hsl(150, 100%, 6%);--success-border: hsl(147, 100%, 12%);--success-text: hsl(150, 86%, 65%);--info-bg: hsl(215, 100%, 6%);--info-border: hsl(223, 100%, 12%);--info-text: hsl(216, 87%, 65%);--warning-bg: hsl(64, 100%, 6%);--warning-border: hsl(60, 100%, 12%);--warning-text: hsl(46, 87%, 65%);--error-bg: hsl(358, 76%, 10%);--error-border: hsl(357, 89%, 16%);--error-text: hsl(358, 100%, 81%)}[data-sonner-toaster][data-theme=dark] [data-sonner-toast] [data-close-button]{background:var(--normal-bg);border-color:var(--normal-border);color:var(--normal-text)}[data-sonner-toaster][data-theme=dark] [data-sonner-toast] [data-close-button]:hover{background:var(--normal-bg-hover);border-color:var(--normal-border-hover)}[data-rich-colors=true][data-sonner-toast][data-type=success],[data-rich-colors=true][data-sonner-toast][data-type=success] [data-close-button]{background:var(--success-bg);border-color:var(--success-border);color:var(--success-text)}[data-rich-colors=true][data-sonner-toast][data-type=info],[data-rich-colors=true][data-sonner-toast][data-type=info] [data-close-button]{background:var(--info-bg);border-color:var(--info-border);color:var(--info-text)}[data-rich-colors=true][data-sonner-toast][data-type=warning],[data-rich-colors=true][data-sonner-toast][data-type=warning] [data-close-button]{background:var(--warning-bg);border-color:var(--warning-border);color:var(--warning-text)}[data-rich-colors=true][data-sonner-toast][data-type=error],[data-rich-colors=true][data-sonner-toast][data-type=error] [data-close-button]{background:var(--error-bg);border-color:var(--error-border);color:var(--error-text)}.sonner-loading-wrapper{--size: 16px;height:var(--size);width:var(--size);position:absolute;inset:0;z-index:10}.sonner-loading-wrapper[data-visible=false]{transform-origin:center;animation:sonner-fade-out .2s ease forwards}.sonner-spinner{position:relative;top:50%;left:50%;height:var(--size);width:var(--size)}.sonner-loading-bar{animation:sonner-spin 1.2s linear infinite;background:var(--gray11);border-radius:6px;height:8%;left:-10%;position:absolute;top:-3.9%;width:24%}.sonner-loading-bar:nth-child(1){animation-delay:-1.2s;transform:rotate(.0001deg) translate(146%)}.sonner-loading-bar:nth-child(2){animation-delay:-1.1s;transform:rotate(30deg) translate(146%)}.sonner-loading-bar:nth-child(3){animation-delay:-1s;transform:rotate(60deg) translate(146%)}.sonner-loading-bar:nth-child(4){animation-delay:-.9s;transform:rotate(90deg) translate(146%)}.sonner-loading-bar:nth-child(5){animation-delay:-.8s;transform:rotate(120deg) translate(146%)}.sonner-loading-bar:nth-child(6){animation-delay:-.7s;transform:rotate(150deg) translate(146%)}.sonner-loading-bar:nth-child(7){animation-delay:-.6s;transform:rotate(180deg) translate(146%)}.sonner-loading-bar:nth-child(8){animation-delay:-.5s;transform:rotate(210deg) translate(146%)}.sonner-loading-bar:nth-child(9){animation-delay:-.4s;transform:rotate(240deg) translate(146%)}.sonner-loading-bar:nth-child(10){animation-delay:-.3s;transform:rotate(270deg) translate(146%)}.sonner-loading-bar:nth-child(11){animation-delay:-.2s;transform:rotate(300deg) translate(146%)}.sonner-loading-bar:nth-child(12){animation-delay:-.1s;transform:rotate(330deg) translate(146%)}@keyframes sonner-fade-in{0%{opacity:0;transform:scale(.8)}to{opacity:1;transform:scale(1)}}@keyframes sonner-fade-out{0%{opacity:1;transform:scale(1)}to{opacity:0;transform:scale(.8)}}@keyframes sonner-spin{0%{opacity:1}to{opacity:.15}}@media (prefers-reduced-motion){[data-sonner-toast],[data-sonner-toast]>*,.sonner-loading-bar{transition:none!important;animation:none!important}}.sonner-loader{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);transform-origin:center;transition:opacity .2s,transform .2s}.sonner-loader[data-visible=false]{opacity:0;transform:scale(.8) translate(-50%,-50%)}
`);
function Da(e) {
  return e.label !== void 0;
}
var g2 = 3,
  y2 = "32px",
  v2 = "16px",
  Fg = 4e3,
  x2 = 356,
  w2 = 14,
  b2 = 20,
  S2 = 200;
function Ft(...e) {
  return e.filter(Boolean).join(" ");
}
function E2(e) {
  let [t, n] = e.split("-"),
    r = [];
  return t && r.push(t), n && r.push(n), r;
}
var C2 = e => {
  var t, n, r, s, o, i, a, l, u, d, c;
  let {
      invert: f,
      toast: h,
      unstyled: w,
      interacting: m,
      setHeights: x,
      visibleToasts: g,
      heights: v,
      index: b,
      toasts: S,
      expanded: E,
      removeToast: P,
      defaultRichColors: T,
      closeButton: k,
      style: A,
      cancelButtonStyle: R,
      actionButtonStyle: I,
      className: O = "",
      descriptionClassName: U = "",
      duration: D,
      position: q,
      gap: z,
      loadingIcon: K,
      expandByDefault: N,
      classNames: j,
      icons: F,
      closeButtonAriaLabel: W = "Close toast",
      pauseWhenPageIsHidden: $
    } = e,
    [X, J] = L.useState(null),
    [Te, $e] = L.useState(null),
    [re, gs] = L.useState(!1),
    [Bn, Dr] = L.useState(!1),
    [zn, ys] = L.useState(!1),
    [$n, fa] = L.useState(!1),
    [Gu, ha] = L.useState(!1),
    [Yu, _o] = L.useState(0),
    [vs, rm] = L.useState(0),
    Vo = L.useRef(h.duration || D || Fg),
    sm = L.useRef(null),
    Ir = L.useRef(null),
    RE = b === 0,
    NE = b + 1 <= g,
    wt = h.type,
    xs = h.dismissible !== !1,
    AE = h.className || "",
    jE = h.descriptionClassName || "",
    pa = L.useMemo(() => v.findIndex(Q => Q.toastId === h.id) || 0, [v, h.id]),
    ME = L.useMemo(() => {
      var Q;
      return (Q = h.closeButton) != null ? Q : k;
    }, [h.closeButton, k]),
    om = L.useMemo(() => h.duration || D || Fg, [h.duration, D]),
    Xu = L.useRef(0),
    ws = L.useRef(0),
    im = L.useRef(0),
    bs = L.useRef(null),
    [OE, LE] = q.split("-"),
    am = L.useMemo(() => v.reduce((Q, ie, pe) => pe >= pa ? Q : Q + ie.height, 0), [v, pa]),
    lm = l2(),
    DE = h.invert || f,
    Zu = wt === "loading";
  ws.current = L.useMemo(() => pa * z + am, [pa, am]), L.useEffect(() => {
    Vo.current = om;
  }, [om]), L.useEffect(() => {
    gs(!0);
  }, []), L.useEffect(() => {
    let Q = Ir.current;
    if (Q) {
      let ie = Q.getBoundingClientRect().height;
      return rm(ie), x(pe => [{
        toastId: h.id,
        height: ie,
        position: h.position
      }, ...pe]), () => x(pe => pe.filter(Ot => Ot.toastId !== h.id));
    }
  }, [x, h.id]), L.useLayoutEffect(() => {
    if (!re) return;
    let Q = Ir.current,
      ie = Q.style.height;
    Q.style.height = "auto";
    let pe = Q.getBoundingClientRect().height;
    Q.style.height = ie, rm(pe), x(Ot => Ot.find(Lt => Lt.toastId === h.id) ? Ot.map(Lt => Lt.toastId === h.id ? {
      ...Lt,
      height: pe
    } : Lt) : [{
      toastId: h.id,
      height: pe,
      position: h.position
    }, ...Ot]);
  }, [re, h.title, h.description, x, h.id]);
  let Un = L.useCallback(() => {
    Dr(!0), _o(ws.current), x(Q => Q.filter(ie => ie.toastId !== h.id)), setTimeout(() => {
      P(h);
    }, S2);
  }, [h, P, x, ws]);
  L.useEffect(() => {
    if (h.promise && wt === "loading" || h.duration === 1 / 0 || h.type === "loading") return;
    let Q;
    return E || m || $ && lm ? (() => {
      if (im.current < Xu.current) {
        let ie = new Date().getTime() - Xu.current;
        Vo.current = Vo.current - ie;
      }
      im.current = new Date().getTime();
    })() : Vo.current !== 1 / 0 && (Xu.current = new Date().getTime(), Q = setTimeout(() => {
      var ie;
      (ie = h.onAutoClose) == null || ie.call(h, h), Un();
    }, Vo.current)), () => clearTimeout(Q);
  }, [E, m, h, wt, $, lm, Un]), L.useEffect(() => {
    h.delete && Un();
  }, [Un, h.delete]);
  function IE() {
    var Q, ie, pe;
    return F != null && F.loading ? L.createElement("div", {
      className: Ft(j == null ? void 0 : j.loader, (Q = h == null ? void 0 : h.classNames) == null ? void 0 : Q.loader, "sonner-loader"),
      "data-visible": wt === "loading"
    }, F.loading) : K ? L.createElement("div", {
      className: Ft(j == null ? void 0 : j.loader, (ie = h == null ? void 0 : h.classNames) == null ? void 0 : ie.loader, "sonner-loader"),
      "data-visible": wt === "loading"
    }, K) : L.createElement(n2, {
      className: Ft(j == null ? void 0 : j.loader, (pe = h == null ? void 0 : h.classNames) == null ? void 0 : pe.loader),
      visible: wt === "loading"
    });
  }
  return L.createElement("li", {
    tabIndex: 0,
    ref: Ir,
    className: Ft(O, AE, j == null ? void 0 : j.toast, (t = h == null ? void 0 : h.classNames) == null ? void 0 : t.toast, j == null ? void 0 : j.default, j == null ? void 0 : j[wt], (n = h == null ? void 0 : h.classNames) == null ? void 0 : n[wt]),
    "data-sonner-toast": "",
    "data-rich-colors": (r = h.richColors) != null ? r : T,
    "data-styled": !(h.jsx || h.unstyled || w),
    "data-mounted": re,
    "data-promise": !!h.promise,
    "data-swiped": Gu,
    "data-removed": Bn,
    "data-visible": NE,
    "data-y-position": OE,
    "data-x-position": LE,
    "data-index": b,
    "data-front": RE,
    "data-swiping": zn,
    "data-dismissible": xs,
    "data-type": wt,
    "data-invert": DE,
    "data-swipe-out": $n,
    "data-swipe-direction": Te,
    "data-expanded": !!(E || N && re),
    style: {
      "--index": b,
      "--toasts-before": b,
      "--z-index": S.length - b,
      "--offset": `${Bn ? Yu : ws.current}px`,
      "--initial-height": N ? "auto" : `${vs}px`,
      ...A,
      ...h.style
    },
    onDragEnd: () => {
      ys(!1), J(null), bs.current = null;
    },
    onPointerDown: Q => {
      Zu || !xs || (sm.current = new Date(), _o(ws.current), Q.target.setPointerCapture(Q.pointerId), Q.target.tagName !== "BUTTON" && (ys(!0), bs.current = {
        x: Q.clientX,
        y: Q.clientY
      }));
    },
    onPointerUp: () => {
      var Q, ie, pe, Ot;
      if ($n || !xs) return;
      bs.current = null;
      let Lt = Number(((Q = Ir.current) == null ? void 0 : Q.style.getPropertyValue("--swipe-amount-x").replace("px", "")) || 0),
        Wn = Number(((ie = Ir.current) == null ? void 0 : ie.style.getPropertyValue("--swipe-amount-y").replace("px", "")) || 0),
        Fr = new Date().getTime() - ((pe = sm.current) == null ? void 0 : pe.getTime()),
        Dt = X === "x" ? Lt : Wn,
        Hn = Math.abs(Dt) / Fr;
      if (Math.abs(Dt) >= b2 || Hn > 0.11) {
        _o(ws.current), (Ot = h.onDismiss) == null || Ot.call(h, h), $e(X === "x" ? Lt > 0 ? "right" : "left" : Wn > 0 ? "down" : "up"), Un(), fa(!0), ha(!1);
        return;
      }
      ys(!1), J(null);
    },
    onPointerMove: Q => {
      var ie, pe, Ot, Lt;
      if (!bs.current || !xs || ((ie = window.getSelection()) == null ? void 0 : ie.toString().length) > 0) return;
      let Wn = Q.clientY - bs.current.y,
        Fr = Q.clientX - bs.current.x,
        Dt = (pe = e.swipeDirections) != null ? pe : E2(q);
      !X && (Math.abs(Fr) > 1 || Math.abs(Wn) > 1) && J(Math.abs(Fr) > Math.abs(Wn) ? "x" : "y");
      let Hn = {
        x: 0,
        y: 0
      };
      X === "y" ? (Dt.includes("top") || Dt.includes("bottom")) && (Dt.includes("top") && Wn < 0 || Dt.includes("bottom") && Wn > 0) && (Hn.y = Wn) : X === "x" && (Dt.includes("left") || Dt.includes("right")) && (Dt.includes("left") && Fr < 0 || Dt.includes("right") && Fr > 0) && (Hn.x = Fr), (Math.abs(Hn.x) > 0 || Math.abs(Hn.y) > 0) && ha(!0), (Ot = Ir.current) == null || Ot.style.setProperty("--swipe-amount-x", `${Hn.x}px`), (Lt = Ir.current) == null || Lt.style.setProperty("--swipe-amount-y", `${Hn.y}px`);
    }
  }, ME && !h.jsx ? L.createElement("button", {
    "aria-label": W,
    "data-disabled": Zu,
    "data-close-button": !0,
    onClick: Zu || !xs ? () => {} : () => {
      var Q;
      Un(), (Q = h.onDismiss) == null || Q.call(h, h);
    },
    className: Ft(j == null ? void 0 : j.closeButton, (s = h == null ? void 0 : h.classNames) == null ? void 0 : s.closeButton)
  }, (o = F == null ? void 0 : F.close) != null ? o : a2) : null, h.jsx || y.isValidElement(h.title) ? h.jsx ? h.jsx : typeof h.title == "function" ? h.title() : h.title : L.createElement(L.Fragment, null, wt || h.icon || h.promise ? L.createElement("div", {
    "data-icon": "",
    className: Ft(j == null ? void 0 : j.icon, (i = h == null ? void 0 : h.classNames) == null ? void 0 : i.icon)
  }, h.promise || h.type === "loading" && !h.icon ? h.icon || IE() : null, h.type !== "loading" ? h.icon || (F == null ? void 0 : F[wt]) || e2(wt) : null) : null, L.createElement("div", {
    "data-content": "",
    className: Ft(j == null ? void 0 : j.content, (a = h == null ? void 0 : h.classNames) == null ? void 0 : a.content)
  }, L.createElement("div", {
    "data-title": "",
    className: Ft(j == null ? void 0 : j.title, (l = h == null ? void 0 : h.classNames) == null ? void 0 : l.title)
  }, typeof h.title == "function" ? h.title() : h.title), h.description ? L.createElement("div", {
    "data-description": "",
    className: Ft(U, jE, j == null ? void 0 : j.description, (u = h == null ? void 0 : h.classNames) == null ? void 0 : u.description)
  }, typeof h.description == "function" ? h.description() : h.description) : null), y.isValidElement(h.cancel) ? h.cancel : h.cancel && Da(h.cancel) ? L.createElement("button", {
    "data-button": !0,
    "data-cancel": !0,
    style: h.cancelButtonStyle || R,
    onClick: Q => {
      var ie, pe;
      Da(h.cancel) && xs && ((pe = (ie = h.cancel).onClick) == null || pe.call(ie, Q), Un());
    },
    className: Ft(j == null ? void 0 : j.cancelButton, (d = h == null ? void 0 : h.classNames) == null ? void 0 : d.cancelButton)
  }, h.cancel.label) : null, y.isValidElement(h.action) ? h.action : h.action && Da(h.action) ? L.createElement("button", {
    "data-button": !0,
    "data-action": !0,
    style: h.actionButtonStyle || I,
    onClick: Q => {
      var ie, pe;
      Da(h.action) && ((pe = (ie = h.action).onClick) == null || pe.call(ie, Q), !Q.defaultPrevented && Un());
    },
    className: Ft(j == null ? void 0 : j.actionButton, (c = h == null ? void 0 : h.classNames) == null ? void 0 : c.actionButton)
  }, h.action.label) : null));
};
function _g() {
  if (typeof window > "u" || typeof document > "u") return "ltr";
  let e = document.documentElement.getAttribute("dir");
  return e === "auto" || !e ? window.getComputedStyle(document.documentElement).direction : e;
}
function T2(e, t) {
  let n = {};
  return [e, t].forEach((r, s) => {
    let o = s === 1,
      i = o ? "--mobile-offset" : "--offset",
      a = o ? v2 : y2;
    function l(u) {
      ["top", "right", "bottom", "left"].forEach(d => {
        n[`${i}-${d}`] = typeof u == "number" ? `${u}px` : u;
      });
    }
    typeof r == "number" || typeof r == "string" ? l(r) : typeof r == "object" ? ["top", "right", "bottom", "left"].forEach(u => {
      r[u] === void 0 ? n[`${i}-${u}`] = a : n[`${i}-${u}`] = typeof r[u] == "number" ? `${r[u]}px` : r[u];
    }) : l(a);
  }), n;
}
var P2 = y.forwardRef(function (e, t) {
  let {
      invert: n,
      position: r = "bottom-right",
      hotkey: s = ["altKey", "KeyT"],
      expand: o,
      closeButton: i,
      className: a,
      offset: l,
      mobileOffset: u,
      theme: d = "light",
      richColors: c,
      duration: f,
      style: h,
      visibleToasts: w = g2,
      toastOptions: m,
      dir: x = _g(),
      gap: g = w2,
      loadingIcon: v,
      icons: b,
      containerAriaLabel: S = "Notifications",
      pauseWhenPageIsHidden: E
    } = e,
    [P, T] = L.useState([]),
    k = L.useMemo(() => Array.from(new Set([r].concat(P.filter($ => $.position).map($ => $.position)))), [P, r]),
    [A, R] = L.useState([]),
    [I, O] = L.useState(!1),
    [U, D] = L.useState(!1),
    [q, z] = L.useState(d !== "system" ? d : typeof window < "u" && window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light"),
    K = L.useRef(null),
    N = s.join("+").replace(/Key/g, "").replace(/Digit/g, ""),
    j = L.useRef(null),
    F = L.useRef(!1),
    W = L.useCallback($ => {
      T(X => {
        var J;
        return (J = X.find(Te => Te.id === $.id)) != null && J.delete || st.dismiss($.id), X.filter(({
          id: Te
        }) => Te !== $.id);
      });
    }, []);
  return L.useEffect(() => st.subscribe($ => {
    if ($.dismiss) {
      T(X => X.map(J => J.id === $.id ? {
        ...J,
        delete: !0
      } : J));
      return;
    }
    setTimeout(() => {
      uw.flushSync(() => {
        T(X => {
          let J = X.findIndex(Te => Te.id === $.id);
          return J !== -1 ? [...X.slice(0, J), {
            ...X[J],
            ...$
          }, ...X.slice(J + 1)] : [$, ...X];
        });
      });
    });
  }), []), L.useEffect(() => {
    if (d !== "system") {
      z(d);
      return;
    }
    if (d === "system" && (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? z("dark") : z("light")), typeof window > "u") return;
    let $ = window.matchMedia("(prefers-color-scheme: dark)");
    try {
      $.addEventListener("change", ({
        matches: X
      }) => {
        z(X ? "dark" : "light");
      });
    } catch {
      $.addListener(({
        matches: J
      }) => {
        try {
          z(J ? "dark" : "light");
        } catch (Te) {
          console.error(Te);
        }
      });
    }
  }, [d]), L.useEffect(() => {
    P.length <= 1 && O(!1);
  }, [P]), L.useEffect(() => {
    let $ = X => {
      var J, Te;
      s.every($e => X[$e] || X.code === $e) && (O(!0), (J = K.current) == null || J.focus()), X.code === "Escape" && (document.activeElement === K.current || (Te = K.current) != null && Te.contains(document.activeElement)) && O(!1);
    };
    return document.addEventListener("keydown", $), () => document.removeEventListener("keydown", $);
  }, [s]), L.useEffect(() => {
    if (K.current) return () => {
      j.current && (j.current.focus({
        preventScroll: !0
      }), j.current = null, F.current = !1);
    };
  }, [K.current]), L.createElement("section", {
    ref: t,
    "aria-label": `${S} ${N}`,
    tabIndex: -1,
    "aria-live": "polite",
    "aria-relevant": "additions text",
    "aria-atomic": "false",
    suppressHydrationWarning: !0
  }, k.map(($, X) => {
    var J;
    let [Te, $e] = $.split("-");
    return P.length ? L.createElement("ol", {
      key: $,
      dir: x === "auto" ? _g() : x,
      tabIndex: -1,
      ref: K,
      className: a,
      "data-sonner-toaster": !0,
      "data-theme": q,
      "data-y-position": Te,
      "data-lifted": I && P.length > 1 && !o,
      "data-x-position": $e,
      style: {
        "--front-toast-height": `${((J = A[0]) == null ? void 0 : J.height) || 0}px`,
        "--width": `${x2}px`,
        "--gap": `${g}px`,
        ...h,
        ...T2(l, u)
      },
      onBlur: re => {
        F.current && !re.currentTarget.contains(re.relatedTarget) && (F.current = !1, j.current && (j.current.focus({
          preventScroll: !0
        }), j.current = null));
      },
      onFocus: re => {
        re.target instanceof HTMLElement && re.target.dataset.dismissible === "false" || F.current || (F.current = !0, j.current = re.relatedTarget);
      },
      onMouseEnter: () => O(!0),
      onMouseMove: () => O(!0),
      onMouseLeave: () => {
        U || O(!1);
      },
      onDragEnd: () => O(!1),
      onPointerDown: re => {
        re.target instanceof HTMLElement && re.target.dataset.dismissible === "false" || D(!0);
      },
      onPointerUp: () => D(!1)
    }, P.filter(re => !re.position && X === 0 || re.position === $).map((re, gs) => {
      var Bn, Dr;
      return L.createElement(C2, {
        key: re.id,
        icons: b,
        index: gs,
        toast: re,
        defaultRichColors: c,
        duration: (Bn = m == null ? void 0 : m.duration) != null ? Bn : f,
        className: m == null ? void 0 : m.className,
        descriptionClassName: m == null ? void 0 : m.descriptionClassName,
        invert: n,
        visibleToasts: w,
        closeButton: (Dr = m == null ? void 0 : m.closeButton) != null ? Dr : i,
        interacting: U,
        position: $,
        style: m == null ? void 0 : m.style,
        unstyled: m == null ? void 0 : m.unstyled,
        classNames: m == null ? void 0 : m.classNames,
        cancelButtonStyle: m == null ? void 0 : m.cancelButtonStyle,
        actionButtonStyle: m == null ? void 0 : m.actionButtonStyle,
        removeToast: W,
        toasts: P.filter(zn => zn.position == re.position),
        heights: A.filter(zn => zn.position == re.position),
        setHeights: R,
        expandByDefault: o,
        gap: g,
        loadingIcon: v,
        expanded: I,
        pauseWhenPageIsHidden: E,
        swipeDirections: e.swipeDirections
      });
    })) : null;
  }));
});
const k2 = ({
    ...e
  }) => {
    const {
      theme: t = "system"
    } = Jk();
    return p.jsx(P2, {
      theme: t,
      className: "toaster group",
      toastOptions: {
        classNames: {
          toast: "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground"
        }
      },
      ...e
    });
  },
  R2 = 1,
  N2 = 1e6;
let Rc = 0;
function A2() {
  return Rc = (Rc + 1) % Number.MAX_SAFE_INTEGER, Rc.toString();
}
const Nc = new Map(),
  Vg = e => {
    if (Nc.has(e)) return;
    const t = setTimeout(() => {
      Nc.delete(e), hi({
        type: "REMOVE_TOAST",
        toastId: e
      });
    }, N2);
    Nc.set(e, t);
  },
  j2 = (e, t) => {
    switch (t.type) {
      case "ADD_TOAST":
        return {
          ...e,
          toasts: [t.toast, ...e.toasts].slice(0, R2)
        };
      case "UPDATE_TOAST":
        return {
          ...e,
          toasts: e.toasts.map(n => n.id === t.toast.id ? {
            ...n,
            ...t.toast
          } : n)
        };
      case "DISMISS_TOAST":
        {
          const {
            toastId: n
          } = t;
          return n ? Vg(n) : e.toasts.forEach(r => {
            Vg(r.id);
          }), {
            ...e,
            toasts: e.toasts.map(r => r.id === n || n === void 0 ? {
              ...r,
              open: !1
            } : r)
          };
        }
      case "REMOVE_TOAST":
        return t.toastId === void 0 ? {
          ...e,
          toasts: []
        } : {
          ...e,
          toasts: e.toasts.filter(n => n.id !== t.toastId)
        };
    }
  },
  il = [];
let al = {
  toasts: []
};
function hi(e) {
  al = j2(al, e), il.forEach(t => {
    t(al);
  });
}
function M2({
  ...e
}) {
  const t = A2(),
    n = s => hi({
      type: "UPDATE_TOAST",
      toast: {
        ...s,
        id: t
      }
    }),
    r = () => hi({
      type: "DISMISS_TOAST",
      toastId: t
    });
  return hi({
    type: "ADD_TOAST",
    toast: {
      ...e,
      id: t,
      open: !0,
      onOpenChange: s => {
        s || r();
      }
    }
  }), {
    id: t,
    dismiss: r,
    update: n
  };
}
function O2() {
  const [e, t] = y.useState(al);
  return y.useEffect(() => (il.push(t), () => {
    const n = il.indexOf(t);
    n > -1 && il.splice(n, 1);
  }), [e]), {
    ...e,
    toast: M2,
    dismiss: n => hi({
      type: "DISMISS_TOAST",
      toastId: n
    })
  };
}
function ge(e, t, {
  checkForDefaultPrevented: n = !0
} = {}) {
  return function (s) {
    if (e == null || e(s), n === !1 || !s.defaultPrevented) return t == null ? void 0 : t(s);
  };
}
function Bg(e, t) {
  if (typeof e == "function") return e(t);
  e != null && (e.current = t);
}
function Mw(...e) {
  return t => {
    let n = !1;
    const r = e.map(s => {
      const o = Bg(s, t);
      return !n && typeof o == "function" && (n = !0), o;
    });
    if (n) return () => {
      for (let s = 0; s < r.length; s++) {
        const o = r[s];
        typeof o == "function" ? o() : Bg(e[s], null);
      }
    };
  };
}
function et(...e) {
  return y.useCallback(Mw(...e), e);
}
function L2(e, t) {
  const n = y.createContext(t),
    r = o => {
      const {
          children: i,
          ...a
        } = o,
        l = y.useMemo(() => a, Object.values(a));
      return p.jsx(n.Provider, {
        value: l,
        children: i
      });
    };
  r.displayName = e + "Provider";
  function s(o) {
    const i = y.useContext(n);
    if (i) return i;
    if (t !== void 0) return t;
    throw new Error(`\`${o}\` must be used within \`${e}\``);
  }
  return [r, s];
}
function sa(e, t = []) {
  let n = [];
  function r(o, i) {
    const a = y.createContext(i),
      l = n.length;
    n = [...n, i];
    const u = c => {
      var g;
      const {
          scope: f,
          children: h,
          ...w
        } = c,
        m = ((g = f == null ? void 0 : f[e]) == null ? void 0 : g[l]) || a,
        x = y.useMemo(() => w, Object.values(w));
      return p.jsx(m.Provider, {
        value: x,
        children: h
      });
    };
    u.displayName = o + "Provider";
    function d(c, f) {
      var m;
      const h = ((m = f == null ? void 0 : f[e]) == null ? void 0 : m[l]) || a,
        w = y.useContext(h);
      if (w) return w;
      if (i !== void 0) return i;
      throw new Error(`\`${c}\` must be used within \`${o}\``);
    }
    return [u, d];
  }
  const s = () => {
    const o = n.map(i => y.createContext(i));
    return function (a) {
      const l = (a == null ? void 0 : a[e]) || o;
      return y.useMemo(() => ({
        [`__scope${e}`]: {
          ...a,
          [e]: l
        }
      }), [a, l]);
    };
  };
  return s.scopeName = e, [r, D2(s, ...t)];
}
function D2(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map(s => ({
      useScope: s(),
      scopeName: s.scopeName
    }));
    return function (o) {
      const i = r.reduce((a, {
        useScope: l,
        scopeName: u
      }) => {
        const c = l(o)[`__scope${u}`];
        return {
          ...a,
          ...c
        };
      }, {});
      return y.useMemo(() => ({
        [`__scope${t.scopeName}`]: i
      }), [i]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function Vi(e) {
  const t = F2(e),
    n = y.forwardRef((r, s) => {
      const {
          children: o,
          ...i
        } = r,
        a = y.Children.toArray(o),
        l = a.find(V2);
      if (l) {
        const u = l.props.children,
          d = a.map(c => c === l ? y.Children.count(u) > 1 ? y.Children.only(null) : y.isValidElement(u) ? u.props.children : null : c);
        return p.jsx(t, {
          ...i,
          ref: s,
          children: y.isValidElement(u) ? y.cloneElement(u, void 0, d) : null
        });
      }
      return p.jsx(t, {
        ...i,
        ref: s,
        children: o
      });
    });
  return n.displayName = `${e}.Slot`, n;
}
var I2 = Vi("Slot");
function F2(e) {
  const t = y.forwardRef((n, r) => {
    const {
      children: s,
      ...o
    } = n;
    if (y.isValidElement(s)) {
      const i = z2(s),
        a = B2(o, s.props);
      return s.type !== y.Fragment && (a.ref = r ? Mw(r, i) : i), y.cloneElement(s, a);
    }
    return y.Children.count(s) > 1 ? y.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var Ow = Symbol("radix.slottable");
function _2(e) {
  const t = ({
    children: n
  }) => p.jsx(p.Fragment, {
    children: n
  });
  return t.displayName = `${e}.Slottable`, t.__radixId = Ow, t;
}
function V2(e) {
  return y.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === Ow;
}
function B2(e, t) {
  const n = {
    ...t
  };
  for (const r in t) {
    const s = e[r],
      o = t[r];
    /^on[A-Z]/.test(r) ? s && o ? n[r] = (...a) => {
      const l = o(...a);
      return s(...a), l;
    } : s && (n[r] = s) : r === "style" ? n[r] = {
      ...s,
      ...o
    } : r === "className" && (n[r] = [s, o].filter(Boolean).join(" "));
  }
  return {
    ...e,
    ...n
  };
}
function z2(e) {
  var r, s;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get,
    n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (s = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : s.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function $2(e) {
  const t = e + "CollectionProvider",
    [n, r] = sa(t),
    [s, o] = n(t, {
      collectionRef: {
        current: null
      },
      itemMap: new Map()
    }),
    i = m => {
      const {
          scope: x,
          children: g
        } = m,
        v = L.useRef(null),
        b = L.useRef(new Map()).current;
      return p.jsx(s, {
        scope: x,
        itemMap: b,
        collectionRef: v,
        children: g
      });
    };
  i.displayName = t;
  const a = e + "CollectionSlot",
    l = Vi(a),
    u = L.forwardRef((m, x) => {
      const {
          scope: g,
          children: v
        } = m,
        b = o(a, g),
        S = et(x, b.collectionRef);
      return p.jsx(l, {
        ref: S,
        children: v
      });
    });
  u.displayName = a;
  const d = e + "CollectionItemSlot",
    c = "data-radix-collection-item",
    f = Vi(d),
    h = L.forwardRef((m, x) => {
      const {
          scope: g,
          children: v,
          ...b
        } = m,
        S = L.useRef(null),
        E = et(x, S),
        P = o(d, g);
      return L.useEffect(() => (P.itemMap.set(S, {
        ref: S,
        ...b
      }), () => void P.itemMap.delete(S))), p.jsx(f, {
        [c]: "",
        ref: E,
        children: v
      });
    });
  h.displayName = d;
  function w(m) {
    const x = o(e + "CollectionConsumer", m);
    return L.useCallback(() => {
      const v = x.collectionRef.current;
      if (!v) return [];
      const b = Array.from(v.querySelectorAll(`[${c}]`));
      return Array.from(x.itemMap.values()).sort((P, T) => b.indexOf(P.ref.current) - b.indexOf(T.ref.current));
    }, [x.collectionRef, x.itemMap]);
  }
  return [{
    Provider: i,
    Slot: u,
    ItemSlot: h
  }, w, r];
}
var U2 = ["a", "button", "div", "form", "h2", "h3", "img", "input", "label", "li", "nav", "ol", "p", "select", "span", "svg", "ul"],
  Re = U2.reduce((e, t) => {
    const n = Vi(`Primitive.${t}`),
      r = y.forwardRef((s, o) => {
        const {
            asChild: i,
            ...a
          } = s,
          l = i ? n : t;
        return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), p.jsx(l, {
          ...a,
          ref: o
        });
      });
    return r.displayName = `Primitive.${t}`, {
      ...e,
      [t]: r
    };
  }, {});
function Lw(e, t) {
  e && ta.flushSync(() => e.dispatchEvent(t));
}
function pn(e) {
  const t = y.useRef(e);
  return y.useEffect(() => {
    t.current = e;
  }), y.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
function W2(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = pn(e);
  y.useEffect(() => {
    const r = s => {
      s.key === "Escape" && n(s);
    };
    return t.addEventListener("keydown", r, {
      capture: !0
    }), () => t.removeEventListener("keydown", r, {
      capture: !0
    });
  }, [n, t]);
}
var H2 = "DismissableLayer",
  vf = "dismissableLayer.update",
  q2 = "dismissableLayer.pointerDownOutside",
  K2 = "dismissableLayer.focusOutside",
  zg,
  Dw = y.createContext({
    layers: new Set(),
    layersWithOutsidePointerEventsDisabled: new Set(),
    branches: new Set()
  }),
  Au = y.forwardRef((e, t) => {
    const {
        disableOutsidePointerEvents: n = !1,
        onEscapeKeyDown: r,
        onPointerDownOutside: s,
        onFocusOutside: o,
        onInteractOutside: i,
        onDismiss: a,
        ...l
      } = e,
      u = y.useContext(Dw),
      [d, c] = y.useState(null),
      f = (d == null ? void 0 : d.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document),
      [, h] = y.useState({}),
      w = et(t, T => c(T)),
      m = Array.from(u.layers),
      [x] = [...u.layersWithOutsidePointerEventsDisabled].slice(-1),
      g = m.indexOf(x),
      v = d ? m.indexOf(d) : -1,
      b = u.layersWithOutsidePointerEventsDisabled.size > 0,
      S = v >= g,
      E = G2(T => {
        const k = T.target,
          A = [...u.branches].some(R => R.contains(k));
        !S || A || (s == null || s(T), i == null || i(T), T.defaultPrevented || a == null || a());
      }, f),
      P = Y2(T => {
        const k = T.target;
        [...u.branches].some(R => R.contains(k)) || (o == null || o(T), i == null || i(T), T.defaultPrevented || a == null || a());
      }, f);
    return W2(T => {
      v === u.layers.size - 1 && (r == null || r(T), !T.defaultPrevented && a && (T.preventDefault(), a()));
    }, f), y.useEffect(() => {
      if (d) return n && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (zg = f.body.style.pointerEvents, f.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(d)), u.layers.add(d), $g(), () => {
        n && u.layersWithOutsidePointerEventsDisabled.size === 1 && (f.body.style.pointerEvents = zg);
      };
    }, [d, f, n, u]), y.useEffect(() => () => {
      d && (u.layers.delete(d), u.layersWithOutsidePointerEventsDisabled.delete(d), $g());
    }, [d, u]), y.useEffect(() => {
      const T = () => h({});
      return document.addEventListener(vf, T), () => document.removeEventListener(vf, T);
    }, []), p.jsx(Re.div, window.LyoEditor.mediaProps({
      ...l,
      ref: w,
      style: {
        pointerEvents: b ? S ? "auto" : "none" : void 0,
        ...e.style
      },
      onFocusCapture: ge(e.onFocusCapture, P.onFocusCapture),
      onBlurCapture: ge(e.onBlurCapture, P.onBlurCapture),
      onPointerDownCapture: ge(e.onPointerDownCapture, E.onPointerDownCapture)
    }));
  });
Au.displayName = H2;
var Q2 = "DismissableLayerBranch",
  Iw = y.forwardRef((e, t) => {
    const n = y.useContext(Dw),
      r = y.useRef(null),
      s = et(t, r);
    return y.useEffect(() => {
      const o = r.current;
      if (o) return n.branches.add(o), () => {
        n.branches.delete(o);
      };
    }, [n.branches]), p.jsx(Re.div, {
      ...e,
      ref: s
    });
  });
Iw.displayName = Q2;
function G2(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = pn(e),
    r = y.useRef(!1),
    s = y.useRef(() => {});
  return y.useEffect(() => {
    const o = a => {
        if (a.target && !r.current) {
          let l = function () {
            Fw(q2, n, u, {
              discrete: !0
            });
          };
          const u = {
            originalEvent: a
          };
          a.pointerType === "touch" ? (t.removeEventListener("click", s.current), s.current = l, t.addEventListener("click", s.current, {
            once: !0
          })) : l();
        } else t.removeEventListener("click", s.current);
        r.current = !1;
      },
      i = window.setTimeout(() => {
        t.addEventListener("pointerdown", o);
      }, 0);
    return () => {
      window.clearTimeout(i), t.removeEventListener("pointerdown", o), t.removeEventListener("click", s.current);
    };
  }, [t, n]), {
    onPointerDownCapture: () => r.current = !0
  };
}
function Y2(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = pn(e),
    r = y.useRef(!1);
  return y.useEffect(() => {
    const s = o => {
      o.target && !r.current && Fw(K2, n, {
        originalEvent: o
      }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", s), () => t.removeEventListener("focusin", s);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function $g() {
  const e = new CustomEvent(vf);
  document.dispatchEvent(e);
}
function Fw(e, t, n, {
  discrete: r
}) {
  const s = n.originalEvent.target,
    o = new CustomEvent(e, {
      bubbles: !1,
      cancelable: !0,
      detail: n
    });
  t && s.addEventListener(e, t, {
    once: !0
  }), r ? Lw(s, o) : s.dispatchEvent(o);
}
var X2 = Au,
  Z2 = Iw,
  Mn = globalThis != null && globalThis.document ? y.useLayoutEffect : () => {},
  J2 = "Portal",
  sp = y.forwardRef((e, t) => {
    var a;
    const {
        container: n,
        ...r
      } = e,
      [s, o] = y.useState(!1);
    Mn(() => o(!0), []);
    const i = n || s && ((a = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : a.body);
    return i ? uw.createPortal(p.jsx(Re.div, {
      ...r,
      ref: t
    }), i) : null;
  });
sp.displayName = J2;
function eR(e, t) {
  return y.useReducer((n, r) => t[n][r] ?? n, e);
}
var Ao = e => {
  const {
      present: t,
      children: n
    } = e,
    r = tR(t),
    s = typeof n == "function" ? n({
      present: r.isPresent
    }) : y.Children.only(n),
    o = et(r.ref, nR(s));
  return typeof n == "function" || r.isPresent ? y.cloneElement(s, {
    ref: o
  }) : null;
};
Ao.displayName = "Presence";
function tR(e) {
  const [t, n] = y.useState(),
    r = y.useRef(null),
    s = y.useRef(e),
    o = y.useRef("none"),
    i = e ? "mounted" : "unmounted",
    [a, l] = eR(i, {
      mounted: {
        UNMOUNT: "unmounted",
        ANIMATION_OUT: "unmountSuspended"
      },
      unmountSuspended: {
        MOUNT: "mounted",
        ANIMATION_END: "unmounted"
      },
      unmounted: {
        MOUNT: "mounted"
      }
    });
  return y.useEffect(() => {
    const u = Ia(r.current);
    o.current = a === "mounted" ? u : "none";
  }, [a]), Mn(() => {
    const u = r.current,
      d = s.current;
    if (d !== e) {
      const f = o.current,
        h = Ia(u);
      e ? l("MOUNT") : h === "none" || (u == null ? void 0 : u.display) === "none" ? l("UNMOUNT") : l(d && f !== h ? "ANIMATION_OUT" : "UNMOUNT"), s.current = e;
    }
  }, [e, l]), Mn(() => {
    if (t) {
      let u;
      const d = t.ownerDocument.defaultView ?? window,
        c = h => {
          const m = Ia(r.current).includes(h.animationName);
          if (h.target === t && m && (l("ANIMATION_END"), !s.current)) {
            const x = t.style.animationFillMode;
            t.style.animationFillMode = "forwards", u = d.setTimeout(() => {
              t.style.animationFillMode === "forwards" && (t.style.animationFillMode = x);
            });
          }
        },
        f = h => {
          h.target === t && (o.current = Ia(r.current));
        };
      return t.addEventListener("animationstart", f), t.addEventListener("animationcancel", c), t.addEventListener("animationend", c), () => {
        d.clearTimeout(u), t.removeEventListener("animationstart", f), t.removeEventListener("animationcancel", c), t.removeEventListener("animationend", c);
      };
    } else l("ANIMATION_END");
  }, [t, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(a),
    ref: y.useCallback(u => {
      r.current = u ? getComputedStyle(u) : null, n(u);
    }, [])
  };
}
function Ia(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function nR(e) {
  var r, s;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get,
    n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (s = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : s.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var rR = ih[" useInsertionEffect ".trim().toString()] || Mn;
function _w({
  prop: e,
  defaultProp: t,
  onChange: n = () => {},
  caller: r
}) {
  const [s, o, i] = sR({
      defaultProp: t,
      onChange: n
    }),
    a = e !== void 0,
    l = a ? e : s;
  {
    const d = y.useRef(e !== void 0);
    y.useEffect(() => {
      const c = d.current;
      c !== a && console.warn(`${r} is changing from ${c ? "controlled" : "uncontrolled"} to ${a ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`), d.current = a;
    }, [a, r]);
  }
  const u = y.useCallback(d => {
    var c;
    if (a) {
      const f = oR(d) ? d(e) : d;
      f !== e && ((c = i.current) == null || c.call(i, f));
    } else o(d);
  }, [a, e, o, i]);
  return [l, u];
}
function sR({
  defaultProp: e,
  onChange: t
}) {
  const [n, r] = y.useState(e),
    s = y.useRef(n),
    o = y.useRef(t);
  return rR(() => {
    o.current = t;
  }, [t]), y.useEffect(() => {
    var i;
    s.current !== n && ((i = o.current) == null || i.call(o, n), s.current = n);
  }, [n, s]), [n, r, o];
}
function oR(e) {
  return typeof e == "function";
}
var iR = Object.freeze({
    position: "absolute",
    border: 0,
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    wordWrap: "normal"
  }),
  aR = "VisuallyHidden",
  ju = y.forwardRef((e, t) => p.jsx(Re.span, window.LyoEditor.mediaProps({
    ...e,
    ref: t,
    style: {
      ...iR,
      ...e.style
    }
  })));
ju.displayName = aR;
var lR = ju,
  op = "ToastProvider",
  [ip, uR, cR] = $2("Toast"),
  [Vw, x5] = sa("Toast", [cR]),
  [dR, Mu] = Vw(op),
  Bw = e => {
    const {
        __scopeToast: t,
        label: n = "Notification",
        duration: r = 5e3,
        swipeDirection: s = "right",
        swipeThreshold: o = 50,
        children: i
      } = e,
      [a, l] = y.useState(null),
      [u, d] = y.useState(0),
      c = y.useRef(!1),
      f = y.useRef(!1);
    return n.trim() || console.error(`Invalid prop \`label\` supplied to \`${op}\`. Expected non-empty \`string\`.`), p.jsx(ip.Provider, {
      scope: t,
      children: p.jsx(dR, {
        scope: t,
        label: n,
        duration: r,
        swipeDirection: s,
        swipeThreshold: o,
        toastCount: u,
        viewport: a,
        onViewportChange: l,
        onToastAdd: y.useCallback(() => d(h => h + 1), []),
        onToastRemove: y.useCallback(() => d(h => h - 1), []),
        isFocusedToastEscapeKeyDownRef: c,
        isClosePausedRef: f,
        children: i
      })
    });
  };
Bw.displayName = op;
var zw = "ToastViewport",
  fR = ["F8"],
  xf = "toast.viewportPause",
  wf = "toast.viewportResume",
  $w = y.forwardRef((e, t) => {
    const {
        __scopeToast: n,
        hotkey: r = fR,
        label: s = "Notifications ({hotkey})",
        ...o
      } = e,
      i = Mu(zw, n),
      a = uR(n),
      l = y.useRef(null),
      u = y.useRef(null),
      d = y.useRef(null),
      c = y.useRef(null),
      f = et(t, c, i.onViewportChange),
      h = r.join("+").replace(/Key/g, "").replace(/Digit/g, ""),
      w = i.toastCount > 0;
    y.useEffect(() => {
      const x = g => {
        var b;
        r.length !== 0 && r.every(S => g[S] || g.code === S) && ((b = c.current) == null || b.focus());
      };
      return document.addEventListener("keydown", x), () => document.removeEventListener("keydown", x);
    }, [r]), y.useEffect(() => {
      const x = l.current,
        g = c.current;
      if (w && x && g) {
        const v = () => {
            if (!i.isClosePausedRef.current) {
              const P = new CustomEvent(xf);
              g.dispatchEvent(P), i.isClosePausedRef.current = !0;
            }
          },
          b = () => {
            if (i.isClosePausedRef.current) {
              const P = new CustomEvent(wf);
              g.dispatchEvent(P), i.isClosePausedRef.current = !1;
            }
          },
          S = P => {
            !x.contains(P.relatedTarget) && b();
          },
          E = () => {
            x.contains(document.activeElement) || b();
          };
        return x.addEventListener("focusin", v), x.addEventListener("focusout", S), x.addEventListener("pointermove", v), x.addEventListener("pointerleave", E), window.addEventListener("blur", v), window.addEventListener("focus", b), () => {
          x.removeEventListener("focusin", v), x.removeEventListener("focusout", S), x.removeEventListener("pointermove", v), x.removeEventListener("pointerleave", E), window.removeEventListener("blur", v), window.removeEventListener("focus", b);
        };
      }
    }, [w, i.isClosePausedRef]);
    const m = y.useCallback(({
      tabbingDirection: x
    }) => {
      const v = a().map(b => {
        const S = b.ref.current,
          E = [S, ...TR(S)];
        return x === "forwards" ? E : E.reverse();
      });
      return (x === "forwards" ? v.reverse() : v).flat();
    }, [a]);
    return y.useEffect(() => {
      const x = c.current;
      if (x) {
        const g = v => {
          var E, P, T;
          const b = v.altKey || v.ctrlKey || v.metaKey;
          if (v.key === "Tab" && !b) {
            const k = document.activeElement,
              A = v.shiftKey;
            if (v.target === x && A) {
              (E = u.current) == null || E.focus();
              return;
            }
            const O = m({
                tabbingDirection: A ? "backwards" : "forwards"
              }),
              U = O.findIndex(D => D === k);
            Ac(O.slice(U + 1)) ? v.preventDefault() : A ? (P = u.current) == null || P.focus() : (T = d.current) == null || T.focus();
          }
        };
        return x.addEventListener("keydown", g), () => x.removeEventListener("keydown", g);
      }
    }, [a, m]), p.jsxs(Z2, window.LyoEditor.mediaProps({
      ref: l,
      role: "region",
      "aria-label": s.replace("{hotkey}", h),
      tabIndex: -1,
      style: {
        pointerEvents: w ? void 0 : "none"
      },
      children: [w && p.jsx(bf, {
        ref: u,
        onFocusFromOutsideViewport: () => {
          const x = m({
            tabbingDirection: "forwards"
          });
          Ac(x);
        }
      }), p.jsx(ip.Slot, {
        scope: n,
        children: p.jsx(Re.ol, {
          tabIndex: -1,
          ...o,
          ref: f
        })
      }), w && p.jsx(bf, {
        ref: d,
        onFocusFromOutsideViewport: () => {
          const x = m({
            tabbingDirection: "backwards"
          });
          Ac(x);
        }
      })]
    }));
  });
$w.displayName = zw;
var Uw = "ToastFocusProxy",
  bf = y.forwardRef((e, t) => {
    const {
        __scopeToast: n,
        onFocusFromOutsideViewport: r,
        ...s
      } = e,
      o = Mu(Uw, n);
    return p.jsx(ju, window.LyoEditor.mediaProps({
      "aria-hidden": !0,
      tabIndex: 0,
      ...s,
      ref: t,
      style: {
        position: "fixed"
      },
      onFocus: i => {
        var u;
        const a = i.relatedTarget;
        !((u = o.viewport) != null && u.contains(a)) && r();
      }
    }));
  });
bf.displayName = Uw;
var oa = "Toast",
  hR = "toast.swipeStart",
  pR = "toast.swipeMove",
  mR = "toast.swipeCancel",
  gR = "toast.swipeEnd",
  Ww = y.forwardRef((e, t) => {
    const {
        forceMount: n,
        open: r,
        defaultOpen: s,
        onOpenChange: o,
        ...i
      } = e,
      [a, l] = _w({
        prop: r,
        defaultProp: s ?? !0,
        onChange: o,
        caller: oa
      });
    return p.jsx(Ao, {
      present: n || a,
      children: p.jsx(xR, {
        open: a,
        ...i,
        ref: t,
        onClose: () => l(!1),
        onPause: pn(e.onPause),
        onResume: pn(e.onResume),
        onSwipeStart: ge(e.onSwipeStart, u => {
          u.currentTarget.setAttribute("data-swipe", "start");
        }),
        onSwipeMove: ge(e.onSwipeMove, u => {
          const {
            x: d,
            y: c
          } = u.detail.delta;
          u.currentTarget.setAttribute("data-swipe", "move"), u.currentTarget.style.setProperty("--radix-toast-swipe-move-x", `${d}px`), u.currentTarget.style.setProperty("--radix-toast-swipe-move-y", `${c}px`);
        }),
        onSwipeCancel: ge(e.onSwipeCancel, u => {
          u.currentTarget.setAttribute("data-swipe", "cancel"), u.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), u.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), u.currentTarget.style.removeProperty("--radix-toast-swipe-end-x"), u.currentTarget.style.removeProperty("--radix-toast-swipe-end-y");
        }),
        onSwipeEnd: ge(e.onSwipeEnd, u => {
          const {
            x: d,
            y: c
          } = u.detail.delta;
          u.currentTarget.setAttribute("data-swipe", "end"), u.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), u.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), u.currentTarget.style.setProperty("--radix-toast-swipe-end-x", `${d}px`), u.currentTarget.style.setProperty("--radix-toast-swipe-end-y", `${c}px`), l(!1);
        })
      })
    });
  });
Ww.displayName = oa;
var [yR, vR] = Vw(oa, {
    onClose() {}
  }),
  xR = y.forwardRef((e, t) => {
    const {
        __scopeToast: n,
        type: r = "foreground",
        duration: s,
        open: o,
        onClose: i,
        onEscapeKeyDown: a,
        onPause: l,
        onResume: u,
        onSwipeStart: d,
        onSwipeMove: c,
        onSwipeCancel: f,
        onSwipeEnd: h,
        ...w
      } = e,
      m = Mu(oa, n),
      [x, g] = y.useState(null),
      v = et(t, D => g(D)),
      b = y.useRef(null),
      S = y.useRef(null),
      E = s || m.duration,
      P = y.useRef(0),
      T = y.useRef(E),
      k = y.useRef(0),
      {
        onToastAdd: A,
        onToastRemove: R
      } = m,
      I = pn(() => {
        var q;
        (x == null ? void 0 : x.contains(document.activeElement)) && ((q = m.viewport) == null || q.focus()), i();
      }),
      O = y.useCallback(D => {
        !D || D === 1 / 0 || (window.clearTimeout(k.current), P.current = new Date().getTime(), k.current = window.setTimeout(I, D));
      }, [I]);
    y.useEffect(() => {
      const D = m.viewport;
      if (D) {
        const q = () => {
            O(T.current), u == null || u();
          },
          z = () => {
            const K = new Date().getTime() - P.current;
            T.current = T.current - K, window.clearTimeout(k.current), l == null || l();
          };
        return D.addEventListener(xf, z), D.addEventListener(wf, q), () => {
          D.removeEventListener(xf, z), D.removeEventListener(wf, q);
        };
      }
    }, [m.viewport, E, l, u, O]), y.useEffect(() => {
      o && !m.isClosePausedRef.current && O(E);
    }, [o, E, m.isClosePausedRef, O]), y.useEffect(() => (A(), () => R()), [A, R]);
    const U = y.useMemo(() => x ? Xw(x) : null, [x]);
    return m.viewport ? p.jsxs(p.Fragment, {
      children: [U && p.jsx(wR, {
        __scopeToast: n,
        role: "status",
        "aria-live": r === "foreground" ? "assertive" : "polite",
        "aria-atomic": !0,
        children: U
      }), p.jsx(yR, {
        scope: n,
        onClose: I,
        children: ta.createPortal(p.jsx(ip.ItemSlot, {
          scope: n,
          children: p.jsx(X2, {
            asChild: !0,
            onEscapeKeyDown: ge(a, () => {
              m.isFocusedToastEscapeKeyDownRef.current || I(), m.isFocusedToastEscapeKeyDownRef.current = !1;
            }),
            children: p.jsx(Re.li, window.LyoEditor.mediaProps({
              role: "status",
              "aria-live": "off",
              "aria-atomic": !0,
              tabIndex: 0,
              "data-state": o ? "open" : "closed",
              "data-swipe-direction": m.swipeDirection,
              ...w,
              ref: v,
              style: {
                userSelect: "none",
                touchAction: "none",
                ...e.style
              },
              onKeyDown: ge(e.onKeyDown, D => {
                D.key === "Escape" && (a == null || a(D.nativeEvent), D.nativeEvent.defaultPrevented || (m.isFocusedToastEscapeKeyDownRef.current = !0, I()));
              }),
              onPointerDown: ge(e.onPointerDown, D => {
                D.button === 0 && (b.current = {
                  x: D.clientX,
                  y: D.clientY
                });
              }),
              onPointerMove: ge(e.onPointerMove, D => {
                if (!b.current) return;
                const q = D.clientX - b.current.x,
                  z = D.clientY - b.current.y,
                  K = !!S.current,
                  N = ["left", "right"].includes(m.swipeDirection),
                  j = ["left", "up"].includes(m.swipeDirection) ? Math.min : Math.max,
                  F = N ? j(0, q) : 0,
                  W = N ? 0 : j(0, z),
                  $ = D.pointerType === "touch" ? 10 : 2,
                  X = {
                    x: F,
                    y: W
                  },
                  J = {
                    originalEvent: D,
                    delta: X
                  };
                K ? (S.current = X, Fa(pR, c, J, {
                  discrete: !1
                })) : Ug(X, m.swipeDirection, $) ? (S.current = X, Fa(hR, d, J, {
                  discrete: !1
                }), D.target.setPointerCapture(D.pointerId)) : (Math.abs(q) > $ || Math.abs(z) > $) && (b.current = null);
              }),
              onPointerUp: ge(e.onPointerUp, D => {
                const q = S.current,
                  z = D.target;
                if (z.hasPointerCapture(D.pointerId) && z.releasePointerCapture(D.pointerId), S.current = null, b.current = null, q) {
                  const K = D.currentTarget,
                    N = {
                      originalEvent: D,
                      delta: q
                    };
                  Ug(q, m.swipeDirection, m.swipeThreshold) ? Fa(gR, h, N, {
                    discrete: !0
                  }) : Fa(mR, f, N, {
                    discrete: !0
                  }), K.addEventListener("click", j => j.preventDefault(), {
                    once: !0
                  });
                }
              })
            }))
          })
        }), m.viewport)
      })]
    }) : null;
  }),
  wR = e => {
    const {
        __scopeToast: t,
        children: n,
        ...r
      } = e,
      s = Mu(oa, t),
      [o, i] = y.useState(!1),
      [a, l] = y.useState(!1);
    return ER(() => i(!0)), y.useEffect(() => {
      const u = window.setTimeout(() => l(!0), 1e3);
      return () => window.clearTimeout(u);
    }, []), a ? null : p.jsx(sp, {
      asChild: !0,
      children: p.jsx(ju, {
        ...r,
        children: o && p.jsxs(p.Fragment, {
          children: [s.label, " ", n]
        })
      })
    });
  },
  bR = "ToastTitle",
  Hw = y.forwardRef((e, t) => {
    const {
      __scopeToast: n,
      ...r
    } = e;
    return p.jsx(Re.div, {
      ...r,
      ref: t
    });
  });
Hw.displayName = bR;
var SR = "ToastDescription",
  qw = y.forwardRef((e, t) => {
    const {
      __scopeToast: n,
      ...r
    } = e;
    return p.jsx(Re.div, {
      ...r,
      ref: t
    });
  });
qw.displayName = SR;
var Kw = "ToastAction",
  Qw = y.forwardRef((e, t) => {
    const {
      altText: n,
      ...r
    } = e;
    return n.trim() ? p.jsx(Yw, {
      altText: n,
      asChild: !0,
      children: p.jsx(ap, {
        ...r,
        ref: t
      })
    }) : (console.error(`Invalid prop \`altText\` supplied to \`${Kw}\`. Expected non-empty \`string\`.`), null);
  });
Qw.displayName = Kw;
var Gw = "ToastClose",
  ap = y.forwardRef((e, t) => {
    const {
        __scopeToast: n,
        ...r
      } = e,
      s = vR(Gw, n);
    return p.jsx(Yw, {
      asChild: !0,
      children: p.jsx(Re.button, {
        type: "button",
        ...r,
        ref: t,
        onClick: ge(e.onClick, s.onClose)
      })
    });
  });
ap.displayName = Gw;
var Yw = y.forwardRef((e, t) => {
  const {
    __scopeToast: n,
    altText: r,
    ...s
  } = e;
  return p.jsx(Re.div, {
    "data-radix-toast-announce-exclude": "",
    "data-radix-toast-announce-alt": r || void 0,
    ...s,
    ref: t
  });
});
function Xw(e) {
  const t = [];
  return Array.from(e.childNodes).forEach(r => {
    if (r.nodeType === r.TEXT_NODE && r.textContent && t.push(r.textContent), CR(r)) {
      const s = r.ariaHidden || r.hidden || r.style.display === "none",
        o = r.dataset.radixToastAnnounceExclude === "";
      if (!s) if (o) {
        const i = r.dataset.radixToastAnnounceAlt;
        i && t.push(i);
      } else t.push(...Xw(r));
    }
  }), t;
}
function Fa(e, t, n, {
  discrete: r
}) {
  const s = n.originalEvent.currentTarget,
    o = new CustomEvent(e, {
      bubbles: !0,
      cancelable: !0,
      detail: n
    });
  t && s.addEventListener(e, t, {
    once: !0
  }), r ? Lw(s, o) : s.dispatchEvent(o);
}
var Ug = (e, t, n = 0) => {
  const r = Math.abs(e.x),
    s = Math.abs(e.y),
    o = r > s;
  return t === "left" || t === "right" ? o && r > n : !o && s > n;
};
function ER(e = () => {}) {
  const t = pn(e);
  Mn(() => {
    let n = 0,
      r = 0;
    return n = window.requestAnimationFrame(() => r = window.requestAnimationFrame(t)), () => {
      window.cancelAnimationFrame(n), window.cancelAnimationFrame(r);
    };
  }, [t]);
}
function CR(e) {
  return e.nodeType === e.ELEMENT_NODE;
}
function TR(e) {
  const t = [],
    n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
      acceptNode: r => {
        const s = r.tagName === "INPUT" && r.type === "hidden";
        return r.disabled || r.hidden || s ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      }
    });
  for (; n.nextNode();) t.push(n.currentNode);
  return t;
}
function Ac(e) {
  const t = document.activeElement;
  return e.some(n => n === t ? !0 : (n.focus(), document.activeElement !== t));
}
var PR = Bw,
  Zw = $w,
  Jw = Ww,
  e1 = Hw,
  t1 = qw,
  n1 = Qw,
  r1 = ap;
function s1(e) {
  var t,
    n,
    r = "";
  if (typeof e == "string" || typeof e == "number") r += e;else if (typeof e == "object") if (Array.isArray(e)) {
    var s = e.length;
    for (t = 0; t < s; t++) e[t] && (n = s1(e[t])) && (r && (r += " "), r += n);
  } else for (n in e) e[n] && (r && (r += " "), r += n);
  return r;
}
function o1() {
  for (var e, t, n = 0, r = "", s = arguments.length; n < s; n++) (e = arguments[n]) && (t = s1(e)) && (r && (r += " "), r += t);
  return r;
}
const Wg = e => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e,
  Hg = o1,
  lp = (e, t) => n => {
    var r;
    if ((t == null ? void 0 : t.variants) == null) return Hg(e, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
    const {
        variants: s,
        defaultVariants: o
      } = t,
      i = Object.keys(s).map(u => {
        const d = n == null ? void 0 : n[u],
          c = o == null ? void 0 : o[u];
        if (d === null) return null;
        const f = Wg(d) || Wg(c);
        return s[u][f];
      }),
      a = n && Object.entries(n).reduce((u, d) => {
        let [c, f] = d;
        return f === void 0 || (u[c] = f), u;
      }, {}),
      l = t == null || (r = t.compoundVariants) === null || r === void 0 ? void 0 : r.reduce((u, d) => {
        let {
          class: c,
          className: f,
          ...h
        } = d;
        return Object.entries(h).every(w => {
          let [m, x] = w;
          return Array.isArray(x) ? x.includes({
            ...o,
            ...a
          }[m]) : {
            ...o,
            ...a
          }[m] === x;
        }) ? [...u, c, f] : u;
      }, []);
    return Hg(e, i, l, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
  };
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kR = e => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(),
  i1 = (...e) => e.filter((t, n, r) => !!t && t.trim() !== "" && r.indexOf(t) === n).join(" ").trim();
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var RR = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NR = y.forwardRef(({
  color: e = "currentColor",
  size: t = 24,
  strokeWidth: n = 2,
  absoluteStrokeWidth: r,
  className: s = "",
  children: o,
  iconNode: i,
  ...a
}, l) => y.createElement("svg", {
  ref: l,
  ...RR,
  width: t,
  height: t,
  stroke: e,
  strokeWidth: r ? Number(n) * 24 / Number(t) : n,
  className: i1("lucide", s),
  ...a
}, [...i.map(([u, d]) => y.createElement(u, d)), ...(Array.isArray(o) ? o : [o])]));
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const he = (e, t) => {
  const n = y.forwardRef(({
    className: r,
    ...s
  }, o) => y.createElement(NR, {
    ref: o,
    iconNode: t,
    className: i1(`lucide-${kR(e)}`, r),
    ...s
  }));
  return n.displayName = `${e}`, n;
};
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ou = he("ArrowRight", [["path", {
  d: "M5 12h14",
  key: "1ays0h"
}], ["path", {
  d: "m12 5 7 7-7 7",
  key: "xquz4c"
}]]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const up = he("Check", [["path", {
  d: "M20 6 9 17l-5-5",
  key: "1gmf2c"
}]]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AR = he("CircleCheck", [["circle", {
  cx: "12",
  cy: "12",
  r: "10",
  key: "1mglay"
}], ["path", {
  d: "m9 12 2 2 4-4",
  key: "dzmm74"
}]]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jR = he("Feather", [["path", {
  d: "M12.67 19a2 2 0 0 0 1.416-.588l6.154-6.172a6 6 0 0 0-8.49-8.49L5.586 9.914A2 2 0 0 0 5 11.328V18a1 1 0 0 0 1 1z",
  key: "18jl4k"
}], ["path", {
  d: "M16 8 2 22",
  key: "vp34q"
}], ["path", {
  d: "M17.5 15H9",
  key: "1oz8nu"
}]]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MR = he("Heart", [["path", {
  d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z",
  key: "c3ymky"
}]]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OR = he("Instagram", [["rect", {
  width: "20",
  height: "20",
  x: "2",
  y: "2",
  rx: "5",
  ry: "5",
  key: "2e1cvw"
}], ["path", {
  d: "M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z",
  key: "9exkf1"
}], ["line", {
  x1: "17.5",
  x2: "17.51",
  y1: "6.5",
  y2: "6.5",
  key: "r4j83e"
}]]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const a1 = he("Leaf", [["path", {
  d: "M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z",
  key: "nnexq3"
}], ["path", {
  d: "M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12",
  key: "mt58a7"
}]]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cp = he("LoaderCircle", [["path", {
  d: "M21 12a9 9 0 1 1-6.219-8.56",
  key: "13zald"
}]]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LR = he("MapPin", [["path", {
  d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0",
  key: "1r0f0z"
}], ["circle", {
  cx: "12",
  cy: "10",
  r: "3",
  key: "ilqhr7"
}]]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const DR = he("Menu", [["line", {
  x1: "4",
  x2: "20",
  y1: "12",
  y2: "12",
  key: "1e0a9i"
}], ["line", {
  x1: "4",
  x2: "20",
  y1: "6",
  y2: "6",
  key: "1owob3"
}], ["line", {
  x1: "4",
  x2: "20",
  y1: "18",
  y2: "18",
  key: "yk5zj1"
}]]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const l1 = he("Minus", [["path", {
  d: "M5 12h14",
  key: "1ays0h"
}]]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IR = he("PackageCheck", [["path", {
  d: "m16 16 2 2 4-4",
  key: "gfu2re"
}], ["path", {
  d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14",
  key: "e7tb2h"
}], ["path", {
  d: "m7.5 4.27 9 5.15",
  key: "1c824w"
}], ["polyline", {
  points: "3.29 7 12 12 20.71 7",
  key: "ousv84"
}], ["line", {
  x1: "12",
  x2: "12",
  y1: "22",
  y2: "12",
  key: "a4e8g8"
}]]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const u1 = he("Package", [["path", {
  d: "M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z",
  key: "1a0edw"
}], ["path", {
  d: "M12 22V12",
  key: "d0xqtd"
}], ["path", {
  d: "m3.3 7 7.703 4.734a2 2 0 0 0 1.994 0L20.7 7",
  key: "yx3hmr"
}], ["path", {
  d: "m7.5 4.27 9 5.15",
  key: "1c824w"
}]]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dp = he("Plus", [["path", {
  d: "M5 12h14",
  key: "1ays0h"
}], ["path", {
  d: "M12 5v14",
  key: "s699le"
}]]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const c1 = he("ShieldCheck", [["path", {
  d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
  key: "oel41y"
}], ["path", {
  d: "m9 12 2 2 4-4",
  key: "dzmm74"
}]]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sf = he("ShoppingBag", [["path", {
  d: "M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z",
  key: "hou9p0"
}], ["path", {
  d: "M3 6h18",
  key: "d0wm0j"
}], ["path", {
  d: "M16 10a4 4 0 0 1-8 0",
  key: "1ltviw"
}]]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fp = he("Snowflake", [["line", {
  x1: "2",
  x2: "22",
  y1: "12",
  y2: "12",
  key: "1dnqot"
}], ["line", {
  x1: "12",
  x2: "12",
  y1: "2",
  y2: "22",
  key: "7eqyqh"
}], ["path", {
  d: "m20 16-4-4 4-4",
  key: "rquw4f"
}], ["path", {
  d: "m4 8 4 4-4 4",
  key: "12s3z9"
}], ["path", {
  d: "m16 4-4 4-4-4",
  key: "1tumq1"
}], ["path", {
  d: "m8 20 4-4 4 4",
  key: "9p200w"
}]]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FR = he("Soup", [["path", {
  d: "M12 21a9 9 0 0 0 9-9H3a9 9 0 0 0 9 9Z",
  key: "4rw317"
}], ["path", {
  d: "M7 21h10",
  key: "1b0cd5"
}], ["path", {
  d: "M19.5 12 22 6",
  key: "shfsr5"
}], ["path", {
  d: "M16.25 3c.27.1.8.53.75 1.36-.06.83-.93 1.2-1 2.02-.05.78.34 1.24.73 1.62",
  key: "rpc6vp"
}], ["path", {
  d: "M11.25 3c.27.1.8.53.74 1.36-.05.83-.93 1.2-.98 2.02-.06.78.33 1.24.72 1.62",
  key: "1lf63m"
}], ["path", {
  d: "M6.25 3c.27.1.8.53.75 1.36-.06.83-.93 1.2-1 2.02-.05.78.34 1.24.74 1.62",
  key: "97tijn"
}]]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _R = he("Sparkles", [["path", {
  d: "M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z",
  key: "4pj2yx"
}], ["path", {
  d: "M20 3v4",
  key: "1olli1"
}], ["path", {
  d: "M22 5h-4",
  key: "1gvqau"
}], ["path", {
  d: "M4 17v2",
  key: "vumght"
}], ["path", {
  d: "M5 18H3",
  key: "zchphs"
}]]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const VR = he("Sprout", [["path", {
  d: "M7 20h10",
  key: "e6iznv"
}], ["path", {
  d: "M10 20c5.5-2.5.8-6.4 3-10",
  key: "161w41"
}], ["path", {
  d: "M9.5 9.4c1.1.8 1.8 2.2 2.3 3.7-2 .4-3.5.4-4.8-.3-1.2-.6-2.3-1.9-3-4.2 2.8-.5 4.4 0 5.5.8z",
  key: "9gtqwd"
}], ["path", {
  d: "M14.1 6a7 7 0 0 0-1.1 4c1.9-.1 3.3-.6 4.3-1.4 1-1 1.6-2.3 1.7-4.6-2.7.1-4 1-4.9 2z",
  key: "bkxnd2"
}]]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BR = he("Star", [["path", {
  d: "M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z",
  key: "r04s7s"
}]]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zR = he("Trash2", [["path", {
  d: "M3 6h18",
  key: "d0wm0j"
}], ["path", {
  d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6",
  key: "4alrt4"
}], ["path", {
  d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2",
  key: "v07s0e"
}], ["line", {
  x1: "10",
  x2: "10",
  y1: "11",
  y2: "17",
  key: "1uufr5"
}], ["line", {
  x1: "14",
  x2: "14",
  y1: "11",
  y2: "17",
  key: "xtxkd"
}]]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $R = he("Truck", [["path", {
  d: "M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2",
  key: "wrbu53"
}], ["path", {
  d: "M15 18H9",
  key: "1lyqi6"
}], ["path", {
  d: "M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14",
  key: "lysw3i"
}], ["circle", {
  cx: "17",
  cy: "18",
  r: "2",
  key: "332jqn"
}], ["circle", {
  cx: "7",
  cy: "18",
  r: "2",
  key: "19iecd"
}]]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UR = he("Wheat", [["path", {
  d: "M2 22 16 8",
  key: "60hf96"
}], ["path", {
  d: "M3.47 12.53 5 11l1.53 1.53a3.5 3.5 0 0 1 0 4.94L5 19l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z",
  key: "1rdhi6"
}], ["path", {
  d: "M7.47 8.53 9 7l1.53 1.53a3.5 3.5 0 0 1 0 4.94L9 15l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z",
  key: "1sdzmb"
}], ["path", {
  d: "M11.47 4.53 13 3l1.53 1.53a3.5 3.5 0 0 1 0 4.94L13 11l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z",
  key: "eoatbi"
}], ["path", {
  d: "M20 2h2v2a4 4 0 0 1-4 4h-2V6a4 4 0 0 1 4-4Z",
  key: "19rau1"
}], ["path", {
  d: "M11.47 17.47 13 19l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L5 19l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z",
  key: "tc8ph9"
}], ["path", {
  d: "M15.47 13.47 17 15l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L9 15l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z",
  key: "2m8kc5"
}], ["path", {
  d: "M19.47 9.47 21 11l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L13 11l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z",
  key: "vex3ng"
}]]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ia = he("X", [["path", {
    d: "M18 6 6 18",
    key: "1bl5f8"
  }], ["path", {
    d: "m6 6 12 12",
    key: "d8bk6v"
  }]]),
  hp = "-",
  WR = e => {
    const t = qR(e),
      {
        conflictingClassGroups: n,
        conflictingClassGroupModifiers: r
      } = e;
    return {
      getClassGroupId: i => {
        const a = i.split(hp);
        return a[0] === "" && a.length !== 1 && a.shift(), d1(a, t) || HR(i);
      },
      getConflictingClassGroupIds: (i, a) => {
        const l = n[i] || [];
        return a && r[i] ? [...l, ...r[i]] : l;
      }
    };
  },
  d1 = (e, t) => {
    var i;
    if (e.length === 0) return t.classGroupId;
    const n = e[0],
      r = t.nextPart.get(n),
      s = r ? d1(e.slice(1), r) : void 0;
    if (s) return s;
    if (t.validators.length === 0) return;
    const o = e.join(hp);
    return (i = t.validators.find(({
      validator: a
    }) => a(o))) == null ? void 0 : i.classGroupId;
  },
  qg = /^\[(.+)\]$/,
  HR = e => {
    if (qg.test(e)) {
      const t = qg.exec(e)[1],
        n = t == null ? void 0 : t.substring(0, t.indexOf(":"));
      if (n) return "arbitrary.." + n;
    }
  },
  qR = e => {
    const {
        theme: t,
        prefix: n
      } = e,
      r = {
        nextPart: new Map(),
        validators: []
      };
    return QR(Object.entries(e.classGroups), n).forEach(([o, i]) => {
      Ef(i, r, o, t);
    }), r;
  },
  Ef = (e, t, n, r) => {
    e.forEach(s => {
      if (typeof s == "string") {
        const o = s === "" ? t : Kg(t, s);
        o.classGroupId = n;
        return;
      }
      if (typeof s == "function") {
        if (KR(s)) {
          Ef(s(r), t, n, r);
          return;
        }
        t.validators.push({
          validator: s,
          classGroupId: n
        });
        return;
      }
      Object.entries(s).forEach(([o, i]) => {
        Ef(i, Kg(t, o), n, r);
      });
    });
  },
  Kg = (e, t) => {
    let n = e;
    return t.split(hp).forEach(r => {
      n.nextPart.has(r) || n.nextPart.set(r, {
        nextPart: new Map(),
        validators: []
      }), n = n.nextPart.get(r);
    }), n;
  },
  KR = e => e.isThemeGetter,
  QR = (e, t) => t ? e.map(([n, r]) => {
    const s = r.map(o => typeof o == "string" ? t + o : typeof o == "object" ? Object.fromEntries(Object.entries(o).map(([i, a]) => [t + i, a])) : o);
    return [n, s];
  }) : e,
  GR = e => {
    if (e < 1) return {
      get: () => {},
      set: () => {}
    };
    let t = 0,
      n = new Map(),
      r = new Map();
    const s = (o, i) => {
      n.set(o, i), t++, t > e && (t = 0, r = n, n = new Map());
    };
    return {
      get(o) {
        let i = n.get(o);
        if (i !== void 0) return i;
        if ((i = r.get(o)) !== void 0) return s(o, i), i;
      },
      set(o, i) {
        n.has(o) ? n.set(o, i) : s(o, i);
      }
    };
  },
  f1 = "!",
  YR = e => {
    const {
        separator: t,
        experimentalParseClassName: n
      } = e,
      r = t.length === 1,
      s = t[0],
      o = t.length,
      i = a => {
        const l = [];
        let u = 0,
          d = 0,
          c;
        for (let x = 0; x < a.length; x++) {
          let g = a[x];
          if (u === 0) {
            if (g === s && (r || a.slice(x, x + o) === t)) {
              l.push(a.slice(d, x)), d = x + o;
              continue;
            }
            if (g === "/") {
              c = x;
              continue;
            }
          }
          g === "[" ? u++ : g === "]" && u--;
        }
        const f = l.length === 0 ? a : a.substring(d),
          h = f.startsWith(f1),
          w = h ? f.substring(1) : f,
          m = c && c > d ? c - d : void 0;
        return {
          modifiers: l,
          hasImportantModifier: h,
          baseClassName: w,
          maybePostfixModifierPosition: m
        };
      };
    return n ? a => n({
      className: a,
      parseClassName: i
    }) : i;
  },
  XR = e => {
    if (e.length <= 1) return e;
    const t = [];
    let n = [];
    return e.forEach(r => {
      r[0] === "[" ? (t.push(...n.sort(), r), n = []) : n.push(r);
    }), t.push(...n.sort()), t;
  },
  ZR = e => ({
    cache: GR(e.cacheSize),
    parseClassName: YR(e),
    ...WR(e)
  }),
  JR = /\s+/,
  eN = (e, t) => {
    const {
        parseClassName: n,
        getClassGroupId: r,
        getConflictingClassGroupIds: s
      } = t,
      o = [],
      i = e.trim().split(JR);
    let a = "";
    for (let l = i.length - 1; l >= 0; l -= 1) {
      const u = i[l],
        {
          modifiers: d,
          hasImportantModifier: c,
          baseClassName: f,
          maybePostfixModifierPosition: h
        } = n(u);
      let w = !!h,
        m = r(w ? f.substring(0, h) : f);
      if (!m) {
        if (!w) {
          a = u + (a.length > 0 ? " " + a : a);
          continue;
        }
        if (m = r(f), !m) {
          a = u + (a.length > 0 ? " " + a : a);
          continue;
        }
        w = !1;
      }
      const x = XR(d).join(":"),
        g = c ? x + f1 : x,
        v = g + m;
      if (o.includes(v)) continue;
      o.push(v);
      const b = s(m, w);
      for (let S = 0; S < b.length; ++S) {
        const E = b[S];
        o.push(g + E);
      }
      a = u + (a.length > 0 ? " " + a : a);
    }
    return a;
  };
function tN() {
  let e = 0,
    t,
    n,
    r = "";
  for (; e < arguments.length;) (t = arguments[e++]) && (n = h1(t)) && (r && (r += " "), r += n);
  return r;
}
const h1 = e => {
  if (typeof e == "string") return e;
  let t,
    n = "";
  for (let r = 0; r < e.length; r++) e[r] && (t = h1(e[r])) && (n && (n += " "), n += t);
  return n;
};
function nN(e, ...t) {
  let n,
    r,
    s,
    o = i;
  function i(l) {
    const u = t.reduce((d, c) => c(d), e());
    return n = ZR(u), r = n.cache.get, s = n.cache.set, o = a, a(l);
  }
  function a(l) {
    const u = r(l);
    if (u) return u;
    const d = eN(l, n);
    return s(l, d), d;
  }
  return function () {
    return o(tN.apply(null, arguments));
  };
}
const ce = e => {
    const t = n => n[e] || [];
    return t.isThemeGetter = !0, t;
  },
  p1 = /^\[(?:([a-z-]+):)?(.+)\]$/i,
  rN = /^\d+\/\d+$/,
  sN = new Set(["px", "full", "screen"]),
  oN = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/,
  iN = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/,
  aN = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/,
  lN = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/,
  uN = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/,
  vn = e => Qs(e) || sN.has(e) || rN.test(e),
  Kn = e => jo(e, "length", yN),
  Qs = e => !!e && !Number.isNaN(Number(e)),
  jc = e => jo(e, "number", Qs),
  Qo = e => !!e && Number.isInteger(Number(e)),
  cN = e => e.endsWith("%") && Qs(e.slice(0, -1)),
  G = e => p1.test(e),
  Qn = e => oN.test(e),
  dN = new Set(["length", "size", "percentage"]),
  fN = e => jo(e, dN, m1),
  hN = e => jo(e, "position", m1),
  pN = new Set(["image", "url"]),
  mN = e => jo(e, pN, xN),
  gN = e => jo(e, "", vN),
  Go = () => !0,
  jo = (e, t, n) => {
    const r = p1.exec(e);
    return r ? r[1] ? typeof t == "string" ? r[1] === t : t.has(r[1]) : n(r[2]) : !1;
  },
  yN = e => iN.test(e) && !aN.test(e),
  m1 = () => !1,
  vN = e => lN.test(e),
  xN = e => uN.test(e),
  wN = () => {
    const e = ce("colors"),
      t = ce("spacing"),
      n = ce("blur"),
      r = ce("brightness"),
      s = ce("borderColor"),
      o = ce("borderRadius"),
      i = ce("borderSpacing"),
      a = ce("borderWidth"),
      l = ce("contrast"),
      u = ce("grayscale"),
      d = ce("hueRotate"),
      c = ce("invert"),
      f = ce("gap"),
      h = ce("gradientColorStops"),
      w = ce("gradientColorStopPositions"),
      m = ce("inset"),
      x = ce("margin"),
      g = ce("opacity"),
      v = ce("padding"),
      b = ce("saturate"),
      S = ce("scale"),
      E = ce("sepia"),
      P = ce("skew"),
      T = ce("space"),
      k = ce("translate"),
      A = () => ["auto", "contain", "none"],
      R = () => ["auto", "hidden", "clip", "visible", "scroll"],
      I = () => ["auto", G, t],
      O = () => [G, t],
      U = () => ["", vn, Kn],
      D = () => ["auto", Qs, G],
      q = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"],
      z = () => ["solid", "dashed", "dotted", "double", "none"],
      K = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"],
      N = () => ["start", "end", "center", "between", "around", "evenly", "stretch"],
      j = () => ["", "0", G],
      F = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"],
      W = () => [Qs, G];
    return {
      cacheSize: 500,
      separator: ":",
      theme: {
        colors: [Go],
        spacing: [vn, Kn],
        blur: ["none", "", Qn, G],
        brightness: W(),
        borderColor: [e],
        borderRadius: ["none", "", "full", Qn, G],
        borderSpacing: O(),
        borderWidth: U(),
        contrast: W(),
        grayscale: j(),
        hueRotate: W(),
        invert: j(),
        gap: O(),
        gradientColorStops: [e],
        gradientColorStopPositions: [cN, Kn],
        inset: I(),
        margin: I(),
        opacity: W(),
        padding: O(),
        saturate: W(),
        scale: W(),
        sepia: j(),
        skew: W(),
        space: O(),
        translate: O()
      },
      classGroups: {
        aspect: [{
          aspect: ["auto", "square", "video", G]
        }],
        container: ["container"],
        columns: [{
          columns: [Qn]
        }],
        "break-after": [{
          "break-after": F()
        }],
        "break-before": [{
          "break-before": F()
        }],
        "break-inside": [{
          "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
        }],
        "box-decoration": [{
          "box-decoration": ["slice", "clone"]
        }],
        box: [{
          box: ["border", "content"]
        }],
        display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
        float: [{
          float: ["right", "left", "none", "start", "end"]
        }],
        clear: [{
          clear: ["left", "right", "both", "none", "start", "end"]
        }],
        isolation: ["isolate", "isolation-auto"],
        "object-fit": [{
          object: ["contain", "cover", "fill", "none", "scale-down"]
        }],
        "object-position": [{
          object: [...q(), G]
        }],
        overflow: [{
          overflow: R()
        }],
        "overflow-x": [{
          "overflow-x": R()
        }],
        "overflow-y": [{
          "overflow-y": R()
        }],
        overscroll: [{
          overscroll: A()
        }],
        "overscroll-x": [{
          "overscroll-x": A()
        }],
        "overscroll-y": [{
          "overscroll-y": A()
        }],
        position: ["static", "fixed", "absolute", "relative", "sticky"],
        inset: [{
          inset: [m]
        }],
        "inset-x": [{
          "inset-x": [m]
        }],
        "inset-y": [{
          "inset-y": [m]
        }],
        start: [{
          start: [m]
        }],
        end: [{
          end: [m]
        }],
        top: [{
          top: [m]
        }],
        right: [{
          right: [m]
        }],
        bottom: [{
          bottom: [m]
        }],
        left: [{
          left: [m]
        }],
        visibility: ["visible", "invisible", "collapse"],
        z: [{
          z: ["auto", Qo, G]
        }],
        basis: [{
          basis: I()
        }],
        "flex-direction": [{
          flex: ["row", "row-reverse", "col", "col-reverse"]
        }],
        "flex-wrap": [{
          flex: ["wrap", "wrap-reverse", "nowrap"]
        }],
        flex: [{
          flex: ["1", "auto", "initial", "none", G]
        }],
        grow: [{
          grow: j()
        }],
        shrink: [{
          shrink: j()
        }],
        order: [{
          order: ["first", "last", "none", Qo, G]
        }],
        "grid-cols": [{
          "grid-cols": [Go]
        }],
        "col-start-end": [{
          col: ["auto", {
            span: ["full", Qo, G]
          }, G]
        }],
        "col-start": [{
          "col-start": D()
        }],
        "col-end": [{
          "col-end": D()
        }],
        "grid-rows": [{
          "grid-rows": [Go]
        }],
        "row-start-end": [{
          row: ["auto", {
            span: [Qo, G]
          }, G]
        }],
        "row-start": [{
          "row-start": D()
        }],
        "row-end": [{
          "row-end": D()
        }],
        "grid-flow": [{
          "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
        }],
        "auto-cols": [{
          "auto-cols": ["auto", "min", "max", "fr", G]
        }],
        "auto-rows": [{
          "auto-rows": ["auto", "min", "max", "fr", G]
        }],
        gap: [{
          gap: [f]
        }],
        "gap-x": [{
          "gap-x": [f]
        }],
        "gap-y": [{
          "gap-y": [f]
        }],
        "justify-content": [{
          justify: ["normal", ...N()]
        }],
        "justify-items": [{
          "justify-items": ["start", "end", "center", "stretch"]
        }],
        "justify-self": [{
          "justify-self": ["auto", "start", "end", "center", "stretch"]
        }],
        "align-content": [{
          content: ["normal", ...N(), "baseline"]
        }],
        "align-items": [{
          items: ["start", "end", "center", "baseline", "stretch"]
        }],
        "align-self": [{
          self: ["auto", "start", "end", "center", "stretch", "baseline"]
        }],
        "place-content": [{
          "place-content": [...N(), "baseline"]
        }],
        "place-items": [{
          "place-items": ["start", "end", "center", "baseline", "stretch"]
        }],
        "place-self": [{
          "place-self": ["auto", "start", "end", "center", "stretch"]
        }],
        p: [{
          p: [v]
        }],
        px: [{
          px: [v]
        }],
        py: [{
          py: [v]
        }],
        ps: [{
          ps: [v]
        }],
        pe: [{
          pe: [v]
        }],
        pt: [{
          pt: [v]
        }],
        pr: [{
          pr: [v]
        }],
        pb: [{
          pb: [v]
        }],
        pl: [{
          pl: [v]
        }],
        m: [{
          m: [x]
        }],
        mx: [{
          mx: [x]
        }],
        my: [{
          my: [x]
        }],
        ms: [{
          ms: [x]
        }],
        me: [{
          me: [x]
        }],
        mt: [{
          mt: [x]
        }],
        mr: [{
          mr: [x]
        }],
        mb: [{
          mb: [x]
        }],
        ml: [{
          ml: [x]
        }],
        "space-x": [{
          "space-x": [T]
        }],
        "space-x-reverse": ["space-x-reverse"],
        "space-y": [{
          "space-y": [T]
        }],
        "space-y-reverse": ["space-y-reverse"],
        w: [{
          w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", G, t]
        }],
        "min-w": [{
          "min-w": [G, t, "min", "max", "fit"]
        }],
        "max-w": [{
          "max-w": [G, t, "none", "full", "min", "max", "fit", "prose", {
            screen: [Qn]
          }, Qn]
        }],
        h: [{
          h: [G, t, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
        }],
        "min-h": [{
          "min-h": [G, t, "min", "max", "fit", "svh", "lvh", "dvh"]
        }],
        "max-h": [{
          "max-h": [G, t, "min", "max", "fit", "svh", "lvh", "dvh"]
        }],
        size: [{
          size: [G, t, "auto", "min", "max", "fit"]
        }],
        "font-size": [{
          text: ["base", Qn, Kn]
        }],
        "font-smoothing": ["antialiased", "subpixel-antialiased"],
        "font-style": ["italic", "not-italic"],
        "font-weight": [{
          font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", jc]
        }],
        "font-family": [{
          font: [Go]
        }],
        "fvn-normal": ["normal-nums"],
        "fvn-ordinal": ["ordinal"],
        "fvn-slashed-zero": ["slashed-zero"],
        "fvn-figure": ["lining-nums", "oldstyle-nums"],
        "fvn-spacing": ["proportional-nums", "tabular-nums"],
        "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
        tracking: [{
          tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", G]
        }],
        "line-clamp": [{
          "line-clamp": ["none", Qs, jc]
        }],
        leading: [{
          leading: ["none", "tight", "snug", "normal", "relaxed", "loose", vn, G]
        }],
        "list-image": [{
          "list-image": ["none", G]
        }],
        "list-style-type": [{
          list: ["none", "disc", "decimal", G]
        }],
        "list-style-position": [{
          list: ["inside", "outside"]
        }],
        "placeholder-color": [{
          placeholder: [e]
        }],
        "placeholder-opacity": [{
          "placeholder-opacity": [g]
        }],
        "text-alignment": [{
          text: ["left", "center", "right", "justify", "start", "end"]
        }],
        "text-color": [{
          text: [e]
        }],
        "text-opacity": [{
          "text-opacity": [g]
        }],
        "text-decoration": ["underline", "overline", "line-through", "no-underline"],
        "text-decoration-style": [{
          decoration: [...z(), "wavy"]
        }],
        "text-decoration-thickness": [{
          decoration: ["auto", "from-font", vn, Kn]
        }],
        "underline-offset": [{
          "underline-offset": ["auto", vn, G]
        }],
        "text-decoration-color": [{
          decoration: [e]
        }],
        "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
        "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
        "text-wrap": [{
          text: ["wrap", "nowrap", "balance", "pretty"]
        }],
        indent: [{
          indent: O()
        }],
        "vertical-align": [{
          align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", G]
        }],
        whitespace: [{
          whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
        }],
        break: [{
          break: ["normal", "words", "all", "keep"]
        }],
        hyphens: [{
          hyphens: ["none", "manual", "auto"]
        }],
        content: [{
          content: ["none", G]
        }],
        "bg-attachment": [{
          bg: ["fixed", "local", "scroll"]
        }],
        "bg-clip": [{
          "bg-clip": ["border", "padding", "content", "text"]
        }],
        "bg-opacity": [{
          "bg-opacity": [g]
        }],
        "bg-origin": [{
          "bg-origin": ["border", "padding", "content"]
        }],
        "bg-position": [{
          bg: [...q(), hN]
        }],
        "bg-repeat": [{
          bg: ["no-repeat", {
            repeat: ["", "x", "y", "round", "space"]
          }]
        }],
        "bg-size": [{
          bg: ["auto", "cover", "contain", fN]
        }],
        "bg-image": [{
          bg: ["none", {
            "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
          }, mN]
        }],
        "bg-color": [{
          bg: [e]
        }],
        "gradient-from-pos": [{
          from: [w]
        }],
        "gradient-via-pos": [{
          via: [w]
        }],
        "gradient-to-pos": [{
          to: [w]
        }],
        "gradient-from": [{
          from: [h]
        }],
        "gradient-via": [{
          via: [h]
        }],
        "gradient-to": [{
          to: [h]
        }],
        rounded: [{
          rounded: [o]
        }],
        "rounded-s": [{
          "rounded-s": [o]
        }],
        "rounded-e": [{
          "rounded-e": [o]
        }],
        "rounded-t": [{
          "rounded-t": [o]
        }],
        "rounded-r": [{
          "rounded-r": [o]
        }],
        "rounded-b": [{
          "rounded-b": [o]
        }],
        "rounded-l": [{
          "rounded-l": [o]
        }],
        "rounded-ss": [{
          "rounded-ss": [o]
        }],
        "rounded-se": [{
          "rounded-se": [o]
        }],
        "rounded-ee": [{
          "rounded-ee": [o]
        }],
        "rounded-es": [{
          "rounded-es": [o]
        }],
        "rounded-tl": [{
          "rounded-tl": [o]
        }],
        "rounded-tr": [{
          "rounded-tr": [o]
        }],
        "rounded-br": [{
          "rounded-br": [o]
        }],
        "rounded-bl": [{
          "rounded-bl": [o]
        }],
        "border-w": [{
          border: [a]
        }],
        "border-w-x": [{
          "border-x": [a]
        }],
        "border-w-y": [{
          "border-y": [a]
        }],
        "border-w-s": [{
          "border-s": [a]
        }],
        "border-w-e": [{
          "border-e": [a]
        }],
        "border-w-t": [{
          "border-t": [a]
        }],
        "border-w-r": [{
          "border-r": [a]
        }],
        "border-w-b": [{
          "border-b": [a]
        }],
        "border-w-l": [{
          "border-l": [a]
        }],
        "border-opacity": [{
          "border-opacity": [g]
        }],
        "border-style": [{
          border: [...z(), "hidden"]
        }],
        "divide-x": [{
          "divide-x": [a]
        }],
        "divide-x-reverse": ["divide-x-reverse"],
        "divide-y": [{
          "divide-y": [a]
        }],
        "divide-y-reverse": ["divide-y-reverse"],
        "divide-opacity": [{
          "divide-opacity": [g]
        }],
        "divide-style": [{
          divide: z()
        }],
        "border-color": [{
          border: [s]
        }],
        "border-color-x": [{
          "border-x": [s]
        }],
        "border-color-y": [{
          "border-y": [s]
        }],
        "border-color-s": [{
          "border-s": [s]
        }],
        "border-color-e": [{
          "border-e": [s]
        }],
        "border-color-t": [{
          "border-t": [s]
        }],
        "border-color-r": [{
          "border-r": [s]
        }],
        "border-color-b": [{
          "border-b": [s]
        }],
        "border-color-l": [{
          "border-l": [s]
        }],
        "divide-color": [{
          divide: [s]
        }],
        "outline-style": [{
          outline: ["", ...z()]
        }],
        "outline-offset": [{
          "outline-offset": [vn, G]
        }],
        "outline-w": [{
          outline: [vn, Kn]
        }],
        "outline-color": [{
          outline: [e]
        }],
        "ring-w": [{
          ring: U()
        }],
        "ring-w-inset": ["ring-inset"],
        "ring-color": [{
          ring: [e]
        }],
        "ring-opacity": [{
          "ring-opacity": [g]
        }],
        "ring-offset-w": [{
          "ring-offset": [vn, Kn]
        }],
        "ring-offset-color": [{
          "ring-offset": [e]
        }],
        shadow: [{
          shadow: ["", "inner", "none", Qn, gN]
        }],
        "shadow-color": [{
          shadow: [Go]
        }],
        opacity: [{
          opacity: [g]
        }],
        "mix-blend": [{
          "mix-blend": [...K(), "plus-lighter", "plus-darker"]
        }],
        "bg-blend": [{
          "bg-blend": K()
        }],
        filter: [{
          filter: ["", "none"]
        }],
        blur: [{
          blur: [n]
        }],
        brightness: [{
          brightness: [r]
        }],
        contrast: [{
          contrast: [l]
        }],
        "drop-shadow": [{
          "drop-shadow": ["", "none", Qn, G]
        }],
        grayscale: [{
          grayscale: [u]
        }],
        "hue-rotate": [{
          "hue-rotate": [d]
        }],
        invert: [{
          invert: [c]
        }],
        saturate: [{
          saturate: [b]
        }],
        sepia: [{
          sepia: [E]
        }],
        "backdrop-filter": [{
          "backdrop-filter": ["", "none"]
        }],
        "backdrop-blur": [{
          "backdrop-blur": [n]
        }],
        "backdrop-brightness": [{
          "backdrop-brightness": [r]
        }],
        "backdrop-contrast": [{
          "backdrop-contrast": [l]
        }],
        "backdrop-grayscale": [{
          "backdrop-grayscale": [u]
        }],
        "backdrop-hue-rotate": [{
          "backdrop-hue-rotate": [d]
        }],
        "backdrop-invert": [{
          "backdrop-invert": [c]
        }],
        "backdrop-opacity": [{
          "backdrop-opacity": [g]
        }],
        "backdrop-saturate": [{
          "backdrop-saturate": [b]
        }],
        "backdrop-sepia": [{
          "backdrop-sepia": [E]
        }],
        "border-collapse": [{
          border: ["collapse", "separate"]
        }],
        "border-spacing": [{
          "border-spacing": [i]
        }],
        "border-spacing-x": [{
          "border-spacing-x": [i]
        }],
        "border-spacing-y": [{
          "border-spacing-y": [i]
        }],
        "table-layout": [{
          table: ["auto", "fixed"]
        }],
        caption: [{
          caption: ["top", "bottom"]
        }],
        transition: [{
          transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", G]
        }],
        duration: [{
          duration: W()
        }],
        ease: [{
          ease: ["linear", "in", "out", "in-out", G]
        }],
        delay: [{
          delay: W()
        }],
        animate: [{
          animate: ["none", "spin", "ping", "pulse", "bounce", G]
        }],
        transform: [{
          transform: ["", "gpu", "none"]
        }],
        scale: [{
          scale: [S]
        }],
        "scale-x": [{
          "scale-x": [S]
        }],
        "scale-y": [{
          "scale-y": [S]
        }],
        rotate: [{
          rotate: [Qo, G]
        }],
        "translate-x": [{
          "translate-x": [k]
        }],
        "translate-y": [{
          "translate-y": [k]
        }],
        "skew-x": [{
          "skew-x": [P]
        }],
        "skew-y": [{
          "skew-y": [P]
        }],
        "transform-origin": [{
          origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", G]
        }],
        accent: [{
          accent: ["auto", e]
        }],
        appearance: [{
          appearance: ["none", "auto"]
        }],
        cursor: [{
          cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", G]
        }],
        "caret-color": [{
          caret: [e]
        }],
        "pointer-events": [{
          "pointer-events": ["none", "auto"]
        }],
        resize: [{
          resize: ["none", "y", "x", ""]
        }],
        "scroll-behavior": [{
          scroll: ["auto", "smooth"]
        }],
        "scroll-m": [{
          "scroll-m": O()
        }],
        "scroll-mx": [{
          "scroll-mx": O()
        }],
        "scroll-my": [{
          "scroll-my": O()
        }],
        "scroll-ms": [{
          "scroll-ms": O()
        }],
        "scroll-me": [{
          "scroll-me": O()
        }],
        "scroll-mt": [{
          "scroll-mt": O()
        }],
        "scroll-mr": [{
          "scroll-mr": O()
        }],
        "scroll-mb": [{
          "scroll-mb": O()
        }],
        "scroll-ml": [{
          "scroll-ml": O()
        }],
        "scroll-p": [{
          "scroll-p": O()
        }],
        "scroll-px": [{
          "scroll-px": O()
        }],
        "scroll-py": [{
          "scroll-py": O()
        }],
        "scroll-ps": [{
          "scroll-ps": O()
        }],
        "scroll-pe": [{
          "scroll-pe": O()
        }],
        "scroll-pt": [{
          "scroll-pt": O()
        }],
        "scroll-pr": [{
          "scroll-pr": O()
        }],
        "scroll-pb": [{
          "scroll-pb": O()
        }],
        "scroll-pl": [{
          "scroll-pl": O()
        }],
        "snap-align": [{
          snap: ["start", "end", "center", "align-none"]
        }],
        "snap-stop": [{
          snap: ["normal", "always"]
        }],
        "snap-type": [{
          snap: ["none", "x", "y", "both"]
        }],
        "snap-strictness": [{
          snap: ["mandatory", "proximity"]
        }],
        touch: [{
          touch: ["auto", "none", "manipulation"]
        }],
        "touch-x": [{
          "touch-pan": ["x", "left", "right"]
        }],
        "touch-y": [{
          "touch-pan": ["y", "up", "down"]
        }],
        "touch-pz": ["touch-pinch-zoom"],
        select: [{
          select: ["none", "text", "all", "auto"]
        }],
        "will-change": [{
          "will-change": ["auto", "scroll", "contents", "transform", G]
        }],
        fill: [{
          fill: [e, "none"]
        }],
        "stroke-w": [{
          stroke: [vn, Kn, jc]
        }],
        stroke: [{
          stroke: [e, "none"]
        }],
        sr: ["sr-only", "not-sr-only"],
        "forced-color-adjust": [{
          "forced-color-adjust": ["auto", "none"]
        }]
      },
      conflictingClassGroups: {
        overflow: ["overflow-x", "overflow-y"],
        overscroll: ["overscroll-x", "overscroll-y"],
        inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
        "inset-x": ["right", "left"],
        "inset-y": ["top", "bottom"],
        flex: ["basis", "grow", "shrink"],
        gap: ["gap-x", "gap-y"],
        p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
        px: ["pr", "pl"],
        py: ["pt", "pb"],
        m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
        mx: ["mr", "ml"],
        my: ["mt", "mb"],
        size: ["w", "h"],
        "font-size": ["leading"],
        "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
        "fvn-ordinal": ["fvn-normal"],
        "fvn-slashed-zero": ["fvn-normal"],
        "fvn-figure": ["fvn-normal"],
        "fvn-spacing": ["fvn-normal"],
        "fvn-fraction": ["fvn-normal"],
        "line-clamp": ["display", "overflow"],
        rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
        "rounded-s": ["rounded-ss", "rounded-es"],
        "rounded-e": ["rounded-se", "rounded-ee"],
        "rounded-t": ["rounded-tl", "rounded-tr"],
        "rounded-r": ["rounded-tr", "rounded-br"],
        "rounded-b": ["rounded-br", "rounded-bl"],
        "rounded-l": ["rounded-tl", "rounded-bl"],
        "border-spacing": ["border-spacing-x", "border-spacing-y"],
        "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
        "border-w-x": ["border-w-r", "border-w-l"],
        "border-w-y": ["border-w-t", "border-w-b"],
        "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
        "border-color-x": ["border-color-r", "border-color-l"],
        "border-color-y": ["border-color-t", "border-color-b"],
        "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
        "scroll-mx": ["scroll-mr", "scroll-ml"],
        "scroll-my": ["scroll-mt", "scroll-mb"],
        "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
        "scroll-px": ["scroll-pr", "scroll-pl"],
        "scroll-py": ["scroll-pt", "scroll-pb"],
        touch: ["touch-x", "touch-y", "touch-pz"],
        "touch-x": ["touch"],
        "touch-y": ["touch"],
        "touch-pz": ["touch"]
      },
      conflictingClassGroupModifiers: {
        "font-size": ["leading"]
      }
    };
  },
  bN = nN(wN);
function Y(...e) {
  return bN(o1(e));
}
function xo(e, t) {
  return t === "fr" ? `${e.toFixed(2).replace(".", ",")} $` : `$${e.toFixed(2)}`;
}
const SN = PR,
  g1 = y.forwardRef(({
    className: e,
    ...t
  }, n) => p.jsx(Zw, {
    ref: n,
    className: Y("fixed top-0 z-[100] flex max-h-screen w-full flex-col-reverse p-4 sm:bottom-0 sm:right-0 sm:top-auto sm:flex-col md:max-w-[420px]", e),
    ...t
  }));
g1.displayName = Zw.displayName;
const EN = lp("group pointer-events-auto relative flex w-full items-center justify-between space-x-4 overflow-hidden rounded-md border p-6 pr-8 shadow-lg transition-all data-[swipe=cancel]:translate-x-0 data-[swipe=end]:translate-x-[var(--radix-toast-swipe-end-x)] data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)] data-[swipe=move]:transition-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[swipe=end]:animate-out data-[state=closed]:fade-out-80 data-[state=closed]:slide-out-to-right-full data-[state=open]:slide-in-from-top-full data-[state=open]:sm:slide-in-from-bottom-full", {
    variants: {
      variant: {
        default: "border bg-background text-foreground",
        destructive: "destructive group border-destructive bg-destructive text-destructive-foreground"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }),
  y1 = y.forwardRef(({
    className: e,
    variant: t,
    ...n
  }, r) => p.jsx(Jw, {
    ref: r,
    className: Y(EN({
      variant: t
    }), e),
    ...n
  }));
y1.displayName = Jw.displayName;
const CN = y.forwardRef(({
  className: e,
  ...t
}, n) => p.jsx(n1, {
  ref: n,
  className: Y("inline-flex h-8 shrink-0 items-center justify-center rounded-md border bg-transparent px-3 text-sm font-medium ring-offset-background transition-colors group-[.destructive]:border-muted/40 hover:bg-secondary group-[.destructive]:hover:border-destructive/30 group-[.destructive]:hover:bg-destructive group-[.destructive]:hover:text-destructive-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 group-[.destructive]:focus:ring-destructive disabled:pointer-events-none disabled:opacity-50", e),
  ...t
}));
CN.displayName = n1.displayName;
const v1 = y.forwardRef(({
  className: e,
  ...t
}, n) => p.jsx(r1, {
  ref: n,
  className: Y("absolute right-2 top-2 rounded-md p-1 text-foreground/50 opacity-0 transition-opacity group-hover:opacity-100 group-[.destructive]:text-red-300 hover:text-foreground group-[.destructive]:hover:text-red-50 focus:opacity-100 focus:outline-none focus:ring-2 group-[.destructive]:focus:ring-red-400 group-[.destructive]:focus:ring-offset-red-600", e),
  "toast-close": "",
  ...t,
  children: p.jsx(ia, {
    className: "h-4 w-4"
  })
}));
v1.displayName = r1.displayName;
const x1 = y.forwardRef(({
  className: e,
  ...t
}, n) => p.jsx(e1, {
  ref: n,
  className: Y("text-sm font-semibold", e),
  ...t
}));
x1.displayName = e1.displayName;
const w1 = y.forwardRef(({
  className: e,
  ...t
}, n) => p.jsx(t1, {
  ref: n,
  className: Y("text-sm opacity-90", e),
  ...t
}));
w1.displayName = t1.displayName;
function TN() {
  const {
    toasts: e
  } = O2();
  return p.jsxs(SN, {
    children: [e.map(function ({
      id: t,
      title: n,
      description: r,
      action: s,
      ...o
    }) {
      return p.jsxs(y1, {
        ...o,
        children: [p.jsxs("div", {
          className: "grid gap-1",
          children: [n && p.jsx(x1, {
            children: n
          }), r && p.jsx(w1, {
            children: r
          })]
        }), s, p.jsx(v1, {})]
      }, t);
    }), p.jsx(g1, {})]
  });
}
var PN = ih[" useId ".trim().toString()] || (() => {}),
  kN = 0;
function Mc(e) {
  const [t, n] = y.useState(PN());
  return Mn(() => {
    e || n(r => r ?? String(kN++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
const RN = ["top", "right", "bottom", "left"],
  Pr = Math.min,
  ht = Math.max,
  Gl = Math.round,
  _a = Math.floor,
  fn = e => ({
    x: e,
    y: e
  }),
  NN = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
  },
  AN = {
    start: "end",
    end: "start"
  };
function Cf(e, t, n) {
  return ht(e, Pr(t, n));
}
function On(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Ln(e) {
  return e.split("-")[0];
}
function Mo(e) {
  return e.split("-")[1];
}
function pp(e) {
  return e === "x" ? "y" : "x";
}
function mp(e) {
  return e === "y" ? "height" : "width";
}
const jN = new Set(["top", "bottom"]);
function un(e) {
  return jN.has(Ln(e)) ? "y" : "x";
}
function gp(e) {
  return pp(un(e));
}
function MN(e, t, n) {
  n === void 0 && (n = !1);
  const r = Mo(e),
    s = gp(e),
    o = mp(s);
  let i = s === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[o] > t.floating[o] && (i = Yl(i)), [i, Yl(i)];
}
function ON(e) {
  const t = Yl(e);
  return [Tf(e), t, Tf(t)];
}
function Tf(e) {
  return e.replace(/start|end/g, t => AN[t]);
}
const Qg = ["left", "right"],
  Gg = ["right", "left"],
  LN = ["top", "bottom"],
  DN = ["bottom", "top"];
function IN(e, t, n) {
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? Gg : Qg : t ? Qg : Gg;
    case "left":
    case "right":
      return t ? LN : DN;
    default:
      return [];
  }
}
function FN(e, t, n, r) {
  const s = Mo(e);
  let o = IN(Ln(e), n === "start", r);
  return s && (o = o.map(i => i + "-" + s), t && (o = o.concat(o.map(Tf)))), o;
}
function Yl(e) {
  return e.replace(/left|right|bottom|top/g, t => NN[t]);
}
function _N(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function b1(e) {
  return typeof e != "number" ? _N(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Xl(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: s
  } = e;
  return {
    width: r,
    height: s,
    top: n,
    left: t,
    right: t + r,
    bottom: n + s,
    x: t,
    y: n
  };
}
function Yg(e, t, n) {
  let {
    reference: r,
    floating: s
  } = e;
  const o = un(t),
    i = gp(t),
    a = mp(i),
    l = Ln(t),
    u = o === "y",
    d = r.x + r.width / 2 - s.width / 2,
    c = r.y + r.height / 2 - s.height / 2,
    f = r[a] / 2 - s[a] / 2;
  let h;
  switch (l) {
    case "top":
      h = {
        x: d,
        y: r.y - s.height
      };
      break;
    case "bottom":
      h = {
        x: d,
        y: r.y + r.height
      };
      break;
    case "right":
      h = {
        x: r.x + r.width,
        y: c
      };
      break;
    case "left":
      h = {
        x: r.x - s.width,
        y: c
      };
      break;
    default:
      h = {
        x: r.x,
        y: r.y
      };
  }
  switch (Mo(t)) {
    case "start":
      h[i] -= f * (n && u ? -1 : 1);
      break;
    case "end":
      h[i] += f * (n && u ? -1 : 1);
      break;
  }
  return h;
}
const VN = async (e, t, n) => {
  const {
      placement: r = "bottom",
      strategy: s = "absolute",
      middleware: o = [],
      platform: i
    } = n,
    a = o.filter(Boolean),
    l = await (i.isRTL == null ? void 0 : i.isRTL(t));
  let u = await i.getElementRects({
      reference: e,
      floating: t,
      strategy: s
    }),
    {
      x: d,
      y: c
    } = Yg(u, r, l),
    f = r,
    h = {},
    w = 0;
  for (let m = 0; m < a.length; m++) {
    const {
        name: x,
        fn: g
      } = a[m],
      {
        x: v,
        y: b,
        data: S,
        reset: E
      } = await g({
        x: d,
        y: c,
        initialPlacement: r,
        placement: f,
        strategy: s,
        middlewareData: h,
        rects: u,
        platform: i,
        elements: {
          reference: e,
          floating: t
        }
      });
    d = v ?? d, c = b ?? c, h = {
      ...h,
      [x]: {
        ...h[x],
        ...S
      }
    }, E && w <= 50 && (w++, typeof E == "object" && (E.placement && (f = E.placement), E.rects && (u = E.rects === !0 ? await i.getElementRects({
      reference: e,
      floating: t,
      strategy: s
    }) : E.rects), {
      x: d,
      y: c
    } = Yg(u, f, l)), m = -1);
  }
  return {
    x: d,
    y: c,
    placement: f,
    strategy: s,
    middlewareData: h
  };
};
async function Bi(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
      x: r,
      y: s,
      platform: o,
      rects: i,
      elements: a,
      strategy: l
    } = e,
    {
      boundary: u = "clippingAncestors",
      rootBoundary: d = "viewport",
      elementContext: c = "floating",
      altBoundary: f = !1,
      padding: h = 0
    } = On(t, e),
    w = b1(h),
    x = a[f ? c === "floating" ? "reference" : "floating" : c],
    g = Xl(await o.getClippingRect({
      element: (n = await (o.isElement == null ? void 0 : o.isElement(x))) == null || n ? x : x.contextElement || (await (o.getDocumentElement == null ? void 0 : o.getDocumentElement(a.floating))),
      boundary: u,
      rootBoundary: d,
      strategy: l
    })),
    v = c === "floating" ? {
      x: r,
      y: s,
      width: i.floating.width,
      height: i.floating.height
    } : i.reference,
    b = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(a.floating)),
    S = (await (o.isElement == null ? void 0 : o.isElement(b))) ? (await (o.getScale == null ? void 0 : o.getScale(b))) || {
      x: 1,
      y: 1
    } : {
      x: 1,
      y: 1
    },
    E = Xl(o.convertOffsetParentRelativeRectToViewportRelativeRect ? await o.convertOffsetParentRelativeRectToViewportRelativeRect({
      elements: a,
      rect: v,
      offsetParent: b,
      strategy: l
    }) : v);
  return {
    top: (g.top - E.top + w.top) / S.y,
    bottom: (E.bottom - g.bottom + w.bottom) / S.y,
    left: (g.left - E.left + w.left) / S.x,
    right: (E.right - g.right + w.right) / S.x
  };
}
const BN = e => ({
    name: "arrow",
    options: e,
    async fn(t) {
      const {
          x: n,
          y: r,
          placement: s,
          rects: o,
          platform: i,
          elements: a,
          middlewareData: l
        } = t,
        {
          element: u,
          padding: d = 0
        } = On(e, t) || {};
      if (u == null) return {};
      const c = b1(d),
        f = {
          x: n,
          y: r
        },
        h = gp(s),
        w = mp(h),
        m = await i.getDimensions(u),
        x = h === "y",
        g = x ? "top" : "left",
        v = x ? "bottom" : "right",
        b = x ? "clientHeight" : "clientWidth",
        S = o.reference[w] + o.reference[h] - f[h] - o.floating[w],
        E = f[h] - o.reference[h],
        P = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(u));
      let T = P ? P[b] : 0;
      (!T || !(await (i.isElement == null ? void 0 : i.isElement(P)))) && (T = a.floating[b] || o.floating[w]);
      const k = S / 2 - E / 2,
        A = T / 2 - m[w] / 2 - 1,
        R = Pr(c[g], A),
        I = Pr(c[v], A),
        O = R,
        U = T - m[w] - I,
        D = T / 2 - m[w] / 2 + k,
        q = Cf(O, D, U),
        z = !l.arrow && Mo(s) != null && D !== q && o.reference[w] / 2 - (D < O ? R : I) - m[w] / 2 < 0,
        K = z ? D < O ? D - O : D - U : 0;
      return {
        [h]: f[h] + K,
        data: {
          [h]: q,
          centerOffset: D - q - K,
          ...(z && {
            alignmentOffset: K
          })
        },
        reset: z
      };
    }
  }),
  zN = function (e) {
    return e === void 0 && (e = {}), {
      name: "flip",
      options: e,
      async fn(t) {
        var n, r;
        const {
            placement: s,
            middlewareData: o,
            rects: i,
            initialPlacement: a,
            platform: l,
            elements: u
          } = t,
          {
            mainAxis: d = !0,
            crossAxis: c = !0,
            fallbackPlacements: f,
            fallbackStrategy: h = "bestFit",
            fallbackAxisSideDirection: w = "none",
            flipAlignment: m = !0,
            ...x
          } = On(e, t);
        if ((n = o.arrow) != null && n.alignmentOffset) return {};
        const g = Ln(s),
          v = un(a),
          b = Ln(a) === a,
          S = await (l.isRTL == null ? void 0 : l.isRTL(u.floating)),
          E = f || (b || !m ? [Yl(a)] : ON(a)),
          P = w !== "none";
        !f && P && E.push(...FN(a, m, w, S));
        const T = [a, ...E],
          k = await Bi(t, x),
          A = [];
        let R = ((r = o.flip) == null ? void 0 : r.overflows) || [];
        if (d && A.push(k[g]), c) {
          const D = MN(s, i, S);
          A.push(k[D[0]], k[D[1]]);
        }
        if (R = [...R, {
          placement: s,
          overflows: A
        }], !A.every(D => D <= 0)) {
          var I, O;
          const D = (((I = o.flip) == null ? void 0 : I.index) || 0) + 1,
            q = T[D];
          if (q && (!(c === "alignment" ? v !== un(q) : !1) || R.every(N => N.overflows[0] > 0 && un(N.placement) === v))) return {
            data: {
              index: D,
              overflows: R
            },
            reset: {
              placement: q
            }
          };
          let z = (O = R.filter(K => K.overflows[0] <= 0).sort((K, N) => K.overflows[1] - N.overflows[1])[0]) == null ? void 0 : O.placement;
          if (!z) switch (h) {
            case "bestFit":
              {
                var U;
                const K = (U = R.filter(N => {
                  if (P) {
                    const j = un(N.placement);
                    return j === v || j === "y";
                  }
                  return !0;
                }).map(N => [N.placement, N.overflows.filter(j => j > 0).reduce((j, F) => j + F, 0)]).sort((N, j) => N[1] - j[1])[0]) == null ? void 0 : U[0];
                K && (z = K);
                break;
              }
            case "initialPlacement":
              z = a;
              break;
          }
          if (s !== z) return {
            reset: {
              placement: z
            }
          };
        }
        return {};
      }
    };
  };
function Xg(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function Zg(e) {
  return RN.some(t => e[t] >= 0);
}
const $N = function (e) {
    return e === void 0 && (e = {}), {
      name: "hide",
      options: e,
      async fn(t) {
        const {
            rects: n
          } = t,
          {
            strategy: r = "referenceHidden",
            ...s
          } = On(e, t);
        switch (r) {
          case "referenceHidden":
            {
              const o = await Bi(t, {
                  ...s,
                  elementContext: "reference"
                }),
                i = Xg(o, n.reference);
              return {
                data: {
                  referenceHiddenOffsets: i,
                  referenceHidden: Zg(i)
                }
              };
            }
          case "escaped":
            {
              const o = await Bi(t, {
                  ...s,
                  altBoundary: !0
                }),
                i = Xg(o, n.floating);
              return {
                data: {
                  escapedOffsets: i,
                  escaped: Zg(i)
                }
              };
            }
          default:
            return {};
        }
      }
    };
  },
  S1 = new Set(["left", "top"]);
async function UN(e, t) {
  const {
      placement: n,
      platform: r,
      elements: s
    } = e,
    o = await (r.isRTL == null ? void 0 : r.isRTL(s.floating)),
    i = Ln(n),
    a = Mo(n),
    l = un(n) === "y",
    u = S1.has(i) ? -1 : 1,
    d = o && l ? -1 : 1,
    c = On(t, e);
  let {
    mainAxis: f,
    crossAxis: h,
    alignmentAxis: w
  } = typeof c == "number" ? {
    mainAxis: c,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: c.mainAxis || 0,
    crossAxis: c.crossAxis || 0,
    alignmentAxis: c.alignmentAxis
  };
  return a && typeof w == "number" && (h = a === "end" ? w * -1 : w), l ? {
    x: h * d,
    y: f * u
  } : {
    x: f * u,
    y: h * d
  };
}
const WN = function (e) {
    return e === void 0 && (e = 0), {
      name: "offset",
      options: e,
      async fn(t) {
        var n, r;
        const {
            x: s,
            y: o,
            placement: i,
            middlewareData: a
          } = t,
          l = await UN(t, e);
        return i === ((n = a.offset) == null ? void 0 : n.placement) && (r = a.arrow) != null && r.alignmentOffset ? {} : {
          x: s + l.x,
          y: o + l.y,
          data: {
            ...l,
            placement: i
          }
        };
      }
    };
  },
  HN = function (e) {
    return e === void 0 && (e = {}), {
      name: "shift",
      options: e,
      async fn(t) {
        const {
            x: n,
            y: r,
            placement: s
          } = t,
          {
            mainAxis: o = !0,
            crossAxis: i = !1,
            limiter: a = {
              fn: x => {
                let {
                  x: g,
                  y: v
                } = x;
                return {
                  x: g,
                  y: v
                };
              }
            },
            ...l
          } = On(e, t),
          u = {
            x: n,
            y: r
          },
          d = await Bi(t, l),
          c = un(Ln(s)),
          f = pp(c);
        let h = u[f],
          w = u[c];
        if (o) {
          const x = f === "y" ? "top" : "left",
            g = f === "y" ? "bottom" : "right",
            v = h + d[x],
            b = h - d[g];
          h = Cf(v, h, b);
        }
        if (i) {
          const x = c === "y" ? "top" : "left",
            g = c === "y" ? "bottom" : "right",
            v = w + d[x],
            b = w - d[g];
          w = Cf(v, w, b);
        }
        const m = a.fn({
          ...t,
          [f]: h,
          [c]: w
        });
        return {
          ...m,
          data: {
            x: m.x - n,
            y: m.y - r,
            enabled: {
              [f]: o,
              [c]: i
            }
          }
        };
      }
    };
  },
  qN = function (e) {
    return e === void 0 && (e = {}), {
      options: e,
      fn(t) {
        const {
            x: n,
            y: r,
            placement: s,
            rects: o,
            middlewareData: i
          } = t,
          {
            offset: a = 0,
            mainAxis: l = !0,
            crossAxis: u = !0
          } = On(e, t),
          d = {
            x: n,
            y: r
          },
          c = un(s),
          f = pp(c);
        let h = d[f],
          w = d[c];
        const m = On(a, t),
          x = typeof m == "number" ? {
            mainAxis: m,
            crossAxis: 0
          } : {
            mainAxis: 0,
            crossAxis: 0,
            ...m
          };
        if (l) {
          const b = f === "y" ? "height" : "width",
            S = o.reference[f] - o.floating[b] + x.mainAxis,
            E = o.reference[f] + o.reference[b] - x.mainAxis;
          h < S ? h = S : h > E && (h = E);
        }
        if (u) {
          var g, v;
          const b = f === "y" ? "width" : "height",
            S = S1.has(Ln(s)),
            E = o.reference[c] - o.floating[b] + (S && ((g = i.offset) == null ? void 0 : g[c]) || 0) + (S ? 0 : x.crossAxis),
            P = o.reference[c] + o.reference[b] + (S ? 0 : ((v = i.offset) == null ? void 0 : v[c]) || 0) - (S ? x.crossAxis : 0);
          w < E ? w = E : w > P && (w = P);
        }
        return {
          [f]: h,
          [c]: w
        };
      }
    };
  },
  KN = function (e) {
    return e === void 0 && (e = {}), {
      name: "size",
      options: e,
      async fn(t) {
        var n, r;
        const {
            placement: s,
            rects: o,
            platform: i,
            elements: a
          } = t,
          {
            apply: l = () => {},
            ...u
          } = On(e, t),
          d = await Bi(t, u),
          c = Ln(s),
          f = Mo(s),
          h = un(s) === "y",
          {
            width: w,
            height: m
          } = o.floating;
        let x, g;
        c === "top" || c === "bottom" ? (x = c, g = f === ((await (i.isRTL == null ? void 0 : i.isRTL(a.floating))) ? "start" : "end") ? "left" : "right") : (g = c, x = f === "end" ? "top" : "bottom");
        const v = m - d.top - d.bottom,
          b = w - d.left - d.right,
          S = Pr(m - d[x], v),
          E = Pr(w - d[g], b),
          P = !t.middlewareData.shift;
        let T = S,
          k = E;
        if ((n = t.middlewareData.shift) != null && n.enabled.x && (k = b), (r = t.middlewareData.shift) != null && r.enabled.y && (T = v), P && !f) {
          const R = ht(d.left, 0),
            I = ht(d.right, 0),
            O = ht(d.top, 0),
            U = ht(d.bottom, 0);
          h ? k = w - 2 * (R !== 0 || I !== 0 ? R + I : ht(d.left, d.right)) : T = m - 2 * (O !== 0 || U !== 0 ? O + U : ht(d.top, d.bottom));
        }
        await l({
          ...t,
          availableWidth: k,
          availableHeight: T
        });
        const A = await i.getDimensions(a.floating);
        return w !== A.width || m !== A.height ? {
          reset: {
            rects: !0
          }
        } : {};
      }
    };
  };
function Lu() {
  return typeof window < "u";
}
function Oo(e) {
  return E1(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function gt(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function yn(e) {
  var t;
  return (t = (E1(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function E1(e) {
  return Lu() ? e instanceof Node || e instanceof gt(e).Node : !1;
}
function Gt(e) {
  return Lu() ? e instanceof Element || e instanceof gt(e).Element : !1;
}
function mn(e) {
  return Lu() ? e instanceof HTMLElement || e instanceof gt(e).HTMLElement : !1;
}
function Jg(e) {
  return !Lu() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof gt(e).ShadowRoot;
}
const QN = new Set(["inline", "contents"]);
function aa(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: s
  } = Yt(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !QN.has(s);
}
const GN = new Set(["table", "td", "th"]);
function YN(e) {
  return GN.has(Oo(e));
}
const XN = [":popover-open", ":modal"];
function Du(e) {
  return XN.some(t => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
const ZN = ["transform", "translate", "scale", "rotate", "perspective"],
  JN = ["transform", "translate", "scale", "rotate", "perspective", "filter"],
  eA = ["paint", "layout", "strict", "content"];
function yp(e) {
  const t = vp(),
    n = Gt(e) ? Yt(e) : e;
  return ZN.some(r => n[r] ? n[r] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || JN.some(r => (n.willChange || "").includes(r)) || eA.some(r => (n.contain || "").includes(r));
}
function tA(e) {
  let t = kr(e);
  for (; mn(t) && !wo(t);) {
    if (yp(t)) return t;
    if (Du(t)) return null;
    t = kr(t);
  }
  return null;
}
function vp() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
const nA = new Set(["html", "body", "#document"]);
function wo(e) {
  return nA.has(Oo(e));
}
function Yt(e) {
  return gt(e).getComputedStyle(e);
}
function Iu(e) {
  return Gt(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function kr(e) {
  if (Oo(e) === "html") return e;
  const t = e.assignedSlot || e.parentNode || Jg(e) && e.host || yn(e);
  return Jg(t) ? t.host : t;
}
function C1(e) {
  const t = kr(e);
  return wo(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : mn(t) && aa(t) ? t : C1(t);
}
function zi(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const s = C1(e),
    o = s === ((r = e.ownerDocument) == null ? void 0 : r.body),
    i = gt(s);
  if (o) {
    const a = Pf(i);
    return t.concat(i, i.visualViewport || [], aa(s) ? s : [], a && n ? zi(a) : []);
  }
  return t.concat(s, zi(s, [], n));
}
function Pf(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function T1(e) {
  const t = Yt(e);
  let n = parseFloat(t.width) || 0,
    r = parseFloat(t.height) || 0;
  const s = mn(e),
    o = s ? e.offsetWidth : n,
    i = s ? e.offsetHeight : r,
    a = Gl(n) !== o || Gl(r) !== i;
  return a && (n = o, r = i), {
    width: n,
    height: r,
    $: a
  };
}
function xp(e) {
  return Gt(e) ? e : e.contextElement;
}
function Gs(e) {
  const t = xp(e);
  if (!mn(t)) return fn(1);
  const n = t.getBoundingClientRect(),
    {
      width: r,
      height: s,
      $: o
    } = T1(t);
  let i = (o ? Gl(n.width) : n.width) / r,
    a = (o ? Gl(n.height) : n.height) / s;
  return (!i || !Number.isFinite(i)) && (i = 1), (!a || !Number.isFinite(a)) && (a = 1), {
    x: i,
    y: a
  };
}
const rA = fn(0);
function P1(e) {
  const t = gt(e);
  return !vp() || !t.visualViewport ? rA : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function sA(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== gt(e) ? !1 : t;
}
function fs(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const s = e.getBoundingClientRect(),
    o = xp(e);
  let i = fn(1);
  t && (r ? Gt(r) && (i = Gs(r)) : i = Gs(e));
  const a = sA(o, n, r) ? P1(o) : fn(0);
  let l = (s.left + a.x) / i.x,
    u = (s.top + a.y) / i.y,
    d = s.width / i.x,
    c = s.height / i.y;
  if (o) {
    const f = gt(o),
      h = r && Gt(r) ? gt(r) : r;
    let w = f,
      m = Pf(w);
    for (; m && r && h !== w;) {
      const x = Gs(m),
        g = m.getBoundingClientRect(),
        v = Yt(m),
        b = g.left + (m.clientLeft + parseFloat(v.paddingLeft)) * x.x,
        S = g.top + (m.clientTop + parseFloat(v.paddingTop)) * x.y;
      l *= x.x, u *= x.y, d *= x.x, c *= x.y, l += b, u += S, w = gt(m), m = Pf(w);
    }
  }
  return Xl({
    width: d,
    height: c,
    x: l,
    y: u
  });
}
function wp(e, t) {
  const n = Iu(e).scrollLeft;
  return t ? t.left + n : fs(yn(e)).left + n;
}
function k1(e, t, n) {
  n === void 0 && (n = !1);
  const r = e.getBoundingClientRect(),
    s = r.left + t.scrollLeft - (n ? 0 : wp(e, r)),
    o = r.top + t.scrollTop;
  return {
    x: s,
    y: o
  };
}
function oA(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: s
  } = e;
  const o = s === "fixed",
    i = yn(r),
    a = t ? Du(t.floating) : !1;
  if (r === i || a && o) return n;
  let l = {
      scrollLeft: 0,
      scrollTop: 0
    },
    u = fn(1);
  const d = fn(0),
    c = mn(r);
  if ((c || !c && !o) && ((Oo(r) !== "body" || aa(i)) && (l = Iu(r)), mn(r))) {
    const h = fs(r);
    u = Gs(r), d.x = h.x + r.clientLeft, d.y = h.y + r.clientTop;
  }
  const f = i && !c && !o ? k1(i, l, !0) : fn(0);
  return {
    width: n.width * u.x,
    height: n.height * u.y,
    x: n.x * u.x - l.scrollLeft * u.x + d.x + f.x,
    y: n.y * u.y - l.scrollTop * u.y + d.y + f.y
  };
}
function iA(e) {
  return Array.from(e.getClientRects());
}
function aA(e) {
  const t = yn(e),
    n = Iu(e),
    r = e.ownerDocument.body,
    s = ht(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth),
    o = ht(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let i = -n.scrollLeft + wp(e);
  const a = -n.scrollTop;
  return Yt(r).direction === "rtl" && (i += ht(t.clientWidth, r.clientWidth) - s), {
    width: s,
    height: o,
    x: i,
    y: a
  };
}
function lA(e, t) {
  const n = gt(e),
    r = yn(e),
    s = n.visualViewport;
  let o = r.clientWidth,
    i = r.clientHeight,
    a = 0,
    l = 0;
  if (s) {
    o = s.width, i = s.height;
    const u = vp();
    (!u || u && t === "fixed") && (a = s.offsetLeft, l = s.offsetTop);
  }
  return {
    width: o,
    height: i,
    x: a,
    y: l
  };
}
const uA = new Set(["absolute", "fixed"]);
function cA(e, t) {
  const n = fs(e, !0, t === "fixed"),
    r = n.top + e.clientTop,
    s = n.left + e.clientLeft,
    o = mn(e) ? Gs(e) : fn(1),
    i = e.clientWidth * o.x,
    a = e.clientHeight * o.y,
    l = s * o.x,
    u = r * o.y;
  return {
    width: i,
    height: a,
    x: l,
    y: u
  };
}
function ey(e, t, n) {
  let r;
  if (t === "viewport") r = lA(e, n);else if (t === "document") r = aA(yn(e));else if (Gt(t)) r = cA(t, n);else {
    const s = P1(e);
    r = {
      x: t.x - s.x,
      y: t.y - s.y,
      width: t.width,
      height: t.height
    };
  }
  return Xl(r);
}
function R1(e, t) {
  const n = kr(e);
  return n === t || !Gt(n) || wo(n) ? !1 : Yt(n).position === "fixed" || R1(n, t);
}
function dA(e, t) {
  const n = t.get(e);
  if (n) return n;
  let r = zi(e, [], !1).filter(a => Gt(a) && Oo(a) !== "body"),
    s = null;
  const o = Yt(e).position === "fixed";
  let i = o ? kr(e) : e;
  for (; Gt(i) && !wo(i);) {
    const a = Yt(i),
      l = yp(i);
    !l && a.position === "fixed" && (s = null), (o ? !l && !s : !l && a.position === "static" && !!s && uA.has(s.position) || aa(i) && !l && R1(e, i)) ? r = r.filter(d => d !== i) : s = a, i = kr(i);
  }
  return t.set(e, r), r;
}
function fA(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: s
  } = e;
  const i = [...(n === "clippingAncestors" ? Du(t) ? [] : dA(t, this._c) : [].concat(n)), r],
    a = i[0],
    l = i.reduce((u, d) => {
      const c = ey(t, d, s);
      return u.top = ht(c.top, u.top), u.right = Pr(c.right, u.right), u.bottom = Pr(c.bottom, u.bottom), u.left = ht(c.left, u.left), u;
    }, ey(t, a, s));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function hA(e) {
  const {
    width: t,
    height: n
  } = T1(e);
  return {
    width: t,
    height: n
  };
}
function pA(e, t, n) {
  const r = mn(t),
    s = yn(t),
    o = n === "fixed",
    i = fs(e, !0, o, t);
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = fn(0);
  function u() {
    l.x = wp(s);
  }
  if (r || !r && !o) if ((Oo(t) !== "body" || aa(s)) && (a = Iu(t)), r) {
    const h = fs(t, !0, o, t);
    l.x = h.x + t.clientLeft, l.y = h.y + t.clientTop;
  } else s && u();
  o && !r && s && u();
  const d = s && !r && !o ? k1(s, a) : fn(0),
    c = i.left + a.scrollLeft - l.x - d.x,
    f = i.top + a.scrollTop - l.y - d.y;
  return {
    x: c,
    y: f,
    width: i.width,
    height: i.height
  };
}
function Oc(e) {
  return Yt(e).position === "static";
}
function ty(e, t) {
  if (!mn(e) || Yt(e).position === "fixed") return null;
  if (t) return t(e);
  let n = e.offsetParent;
  return yn(e) === n && (n = n.ownerDocument.body), n;
}
function N1(e, t) {
  const n = gt(e);
  if (Du(e)) return n;
  if (!mn(e)) {
    let s = kr(e);
    for (; s && !wo(s);) {
      if (Gt(s) && !Oc(s)) return s;
      s = kr(s);
    }
    return n;
  }
  let r = ty(e, t);
  for (; r && YN(r) && Oc(r);) r = ty(r, t);
  return r && wo(r) && Oc(r) && !yp(r) ? n : r || tA(e) || n;
}
const mA = async function (e) {
  const t = this.getOffsetParent || N1,
    n = this.getDimensions,
    r = await n(e.floating);
  return {
    reference: pA(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function gA(e) {
  return Yt(e).direction === "rtl";
}
const yA = {
  convertOffsetParentRelativeRectToViewportRelativeRect: oA,
  getDocumentElement: yn,
  getClippingRect: fA,
  getOffsetParent: N1,
  getElementRects: mA,
  getClientRects: iA,
  getDimensions: hA,
  getScale: Gs,
  isElement: Gt,
  isRTL: gA
};
function A1(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function vA(e, t) {
  let n = null,
    r;
  const s = yn(e);
  function o() {
    var a;
    clearTimeout(r), (a = n) == null || a.disconnect(), n = null;
  }
  function i(a, l) {
    a === void 0 && (a = !1), l === void 0 && (l = 1), o();
    const u = e.getBoundingClientRect(),
      {
        left: d,
        top: c,
        width: f,
        height: h
      } = u;
    if (a || t(), !f || !h) return;
    const w = _a(c),
      m = _a(s.clientWidth - (d + f)),
      x = _a(s.clientHeight - (c + h)),
      g = _a(d),
      b = {
        rootMargin: -w + "px " + -m + "px " + -x + "px " + -g + "px",
        threshold: ht(0, Pr(1, l)) || 1
      };
    let S = !0;
    function E(P) {
      const T = P[0].intersectionRatio;
      if (T !== l) {
        if (!S) return i();
        T ? i(!1, T) : r = setTimeout(() => {
          i(!1, 1e-7);
        }, 1e3);
      }
      T === 1 && !A1(u, e.getBoundingClientRect()) && i(), S = !1;
    }
    try {
      n = new IntersectionObserver(E, {
        ...b,
        root: s.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(E, b);
    }
    n.observe(e);
  }
  return i(!0), o;
}
function xA(e, t, n, r) {
  r === void 0 && (r = {});
  const {
      ancestorScroll: s = !0,
      ancestorResize: o = !0,
      elementResize: i = typeof ResizeObserver == "function",
      layoutShift: a = typeof IntersectionObserver == "function",
      animationFrame: l = !1
    } = r,
    u = xp(e),
    d = s || o ? [...(u ? zi(u) : []), ...zi(t)] : [];
  d.forEach(g => {
    s && g.addEventListener("scroll", n, {
      passive: !0
    }), o && g.addEventListener("resize", n);
  });
  const c = u && a ? vA(u, n) : null;
  let f = -1,
    h = null;
  i && (h = new ResizeObserver(g => {
    let [v] = g;
    v && v.target === u && h && (h.unobserve(t), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      var b;
      (b = h) == null || b.observe(t);
    })), n();
  }), u && !l && h.observe(u), h.observe(t));
  let w,
    m = l ? fs(e) : null;
  l && x();
  function x() {
    const g = fs(e);
    m && !A1(m, g) && n(), m = g, w = requestAnimationFrame(x);
  }
  return n(), () => {
    var g;
    d.forEach(v => {
      s && v.removeEventListener("scroll", n), o && v.removeEventListener("resize", n);
    }), c == null || c(), (g = h) == null || g.disconnect(), h = null, l && cancelAnimationFrame(w);
  };
}
const wA = WN,
  bA = HN,
  SA = zN,
  EA = KN,
  CA = $N,
  ny = BN,
  TA = qN,
  PA = (e, t, n) => {
    const r = new Map(),
      s = {
        platform: yA,
        ...n
      },
      o = {
        ...s.platform,
        _c: r
      };
    return VN(e, t, {
      ...s,
      platform: o
    });
  };
var kA = typeof document < "u",
  RA = function () {},
  ll = kA ? y.useLayoutEffect : RA;
function Zl(e, t) {
  if (e === t) return !0;
  if (typeof e != typeof t) return !1;
  if (typeof e == "function" && e.toString() === t.toString()) return !0;
  let n, r, s;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (r = n; r-- !== 0;) if (!Zl(e[r], t[r])) return !1;
      return !0;
    }
    if (s = Object.keys(e), n = s.length, n !== Object.keys(t).length) return !1;
    for (r = n; r-- !== 0;) if (!{}.hasOwnProperty.call(t, s[r])) return !1;
    for (r = n; r-- !== 0;) {
      const o = s[r];
      if (!(o === "_owner" && e.$$typeof) && !Zl(e[o], t[o])) return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function j1(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function ry(e, t) {
  const n = j1(e);
  return Math.round(t * n) / n;
}
function Lc(e) {
  const t = y.useRef(e);
  return ll(() => {
    t.current = e;
  }), t;
}
function NA(e) {
  e === void 0 && (e = {});
  const {
      placement: t = "bottom",
      strategy: n = "absolute",
      middleware: r = [],
      platform: s,
      elements: {
        reference: o,
        floating: i
      } = {},
      transform: a = !0,
      whileElementsMounted: l,
      open: u
    } = e,
    [d, c] = y.useState({
      x: 0,
      y: 0,
      strategy: n,
      placement: t,
      middlewareData: {},
      isPositioned: !1
    }),
    [f, h] = y.useState(r);
  Zl(f, r) || h(r);
  const [w, m] = y.useState(null),
    [x, g] = y.useState(null),
    v = y.useCallback(N => {
      N !== P.current && (P.current = N, m(N));
    }, []),
    b = y.useCallback(N => {
      N !== T.current && (T.current = N, g(N));
    }, []),
    S = o || w,
    E = i || x,
    P = y.useRef(null),
    T = y.useRef(null),
    k = y.useRef(d),
    A = l != null,
    R = Lc(l),
    I = Lc(s),
    O = Lc(u),
    U = y.useCallback(() => {
      if (!P.current || !T.current) return;
      const N = {
        placement: t,
        strategy: n,
        middleware: f
      };
      I.current && (N.platform = I.current), PA(P.current, T.current, N).then(j => {
        const F = {
          ...j,
          isPositioned: O.current !== !1
        };
        D.current && !Zl(k.current, F) && (k.current = F, ta.flushSync(() => {
          c(F);
        }));
      });
    }, [f, t, n, I, O]);
  ll(() => {
    u === !1 && k.current.isPositioned && (k.current.isPositioned = !1, c(N => ({
      ...N,
      isPositioned: !1
    })));
  }, [u]);
  const D = y.useRef(!1);
  ll(() => (D.current = !0, () => {
    D.current = !1;
  }), []), ll(() => {
    if (S && (P.current = S), E && (T.current = E), S && E) {
      if (R.current) return R.current(S, E, U);
      U();
    }
  }, [S, E, U, R, A]);
  const q = y.useMemo(() => ({
      reference: P,
      floating: T,
      setReference: v,
      setFloating: b
    }), [v, b]),
    z = y.useMemo(() => ({
      reference: S,
      floating: E
    }), [S, E]),
    K = y.useMemo(() => {
      const N = {
        position: n,
        left: 0,
        top: 0
      };
      if (!z.floating) return N;
      const j = ry(z.floating, d.x),
        F = ry(z.floating, d.y);
      return a ? {
        ...N,
        transform: "translate(" + j + "px, " + F + "px)",
        ...(j1(z.floating) >= 1.5 && {
          willChange: "transform"
        })
      } : {
        position: n,
        left: j,
        top: F
      };
    }, [n, a, z.floating, d.x, d.y]);
  return y.useMemo(() => ({
    ...d,
    update: U,
    refs: q,
    elements: z,
    floatingStyles: K
  }), [d, U, q, z, K]);
}
const AA = e => {
    function t(n) {
      return {}.hasOwnProperty.call(n, "current");
    }
    return {
      name: "arrow",
      options: e,
      fn(n) {
        const {
          element: r,
          padding: s
        } = typeof e == "function" ? e(n) : e;
        return r && t(r) ? r.current != null ? ny({
          element: r.current,
          padding: s
        }).fn(n) : {} : r ? ny({
          element: r,
          padding: s
        }).fn(n) : {};
      }
    };
  },
  jA = (e, t) => ({
    ...wA(e),
    options: [e, t]
  }),
  MA = (e, t) => ({
    ...bA(e),
    options: [e, t]
  }),
  OA = (e, t) => ({
    ...TA(e),
    options: [e, t]
  }),
  LA = (e, t) => ({
    ...SA(e),
    options: [e, t]
  }),
  DA = (e, t) => ({
    ...EA(e),
    options: [e, t]
  }),
  IA = (e, t) => ({
    ...CA(e),
    options: [e, t]
  }),
  FA = (e, t) => ({
    ...AA(e),
    options: [e, t]
  });
var _A = "Arrow",
  M1 = y.forwardRef((e, t) => {
    const {
      children: n,
      width: r = 10,
      height: s = 5,
      ...o
    } = e;
    return p.jsx(Re.svg, {
      ...o,
      ref: t,
      width: r,
      height: s,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : p.jsx("polygon", {
        points: "0,0 30,0 15,10"
      })
    });
  });
M1.displayName = _A;
var VA = M1;
function BA(e) {
  const [t, n] = y.useState(void 0);
  return Mn(() => {
    if (e) {
      n({
        width: e.offsetWidth,
        height: e.offsetHeight
      });
      const r = new ResizeObserver(s => {
        if (!Array.isArray(s) || !s.length) return;
        const o = s[0];
        let i, a;
        if ("borderBoxSize" in o) {
          const l = o.borderBoxSize,
            u = Array.isArray(l) ? l[0] : l;
          i = u.inlineSize, a = u.blockSize;
        } else i = e.offsetWidth, a = e.offsetHeight;
        n({
          width: i,
          height: a
        });
      });
      return r.observe(e, {
        box: "border-box"
      }), () => r.unobserve(e);
    } else n(void 0);
  }, [e]), t;
}
var O1 = "Popper",
  [L1, D1] = sa(O1),
  [w5, I1] = L1(O1),
  F1 = "PopperAnchor",
  _1 = y.forwardRef((e, t) => {
    const {
        __scopePopper: n,
        virtualRef: r,
        ...s
      } = e,
      o = I1(F1, n),
      i = y.useRef(null),
      a = et(t, i);
    return y.useEffect(() => {
      o.onAnchorChange((r == null ? void 0 : r.current) || i.current);
    }), r ? null : p.jsx(Re.div, {
      ...s,
      ref: a
    });
  });
_1.displayName = F1;
var bp = "PopperContent",
  [zA, $A] = L1(bp),
  V1 = y.forwardRef((e, t) => {
    var re, gs, Bn, Dr, zn, ys;
    const {
        __scopePopper: n,
        side: r = "bottom",
        sideOffset: s = 0,
        align: o = "center",
        alignOffset: i = 0,
        arrowPadding: a = 0,
        avoidCollisions: l = !0,
        collisionBoundary: u = [],
        collisionPadding: d = 0,
        sticky: c = "partial",
        hideWhenDetached: f = !1,
        updatePositionStrategy: h = "optimized",
        onPlaced: w,
        ...m
      } = e,
      x = I1(bp, n),
      [g, v] = y.useState(null),
      b = et(t, $n => v($n)),
      [S, E] = y.useState(null),
      P = BA(S),
      T = (P == null ? void 0 : P.width) ?? 0,
      k = (P == null ? void 0 : P.height) ?? 0,
      A = r + (o !== "center" ? "-" + o : ""),
      R = typeof d == "number" ? d : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...d
      },
      I = Array.isArray(u) ? u : [u],
      O = I.length > 0,
      U = {
        padding: R,
        boundary: I.filter(WA),
        altBoundary: O
      },
      {
        refs: D,
        floatingStyles: q,
        placement: z,
        isPositioned: K,
        middlewareData: N
      } = NA({
        strategy: "fixed",
        placement: A,
        whileElementsMounted: (...$n) => xA(...$n, {
          animationFrame: h === "always"
        }),
        elements: {
          reference: x.anchor
        },
        middleware: [jA({
          mainAxis: s + k,
          alignmentAxis: i
        }), l && MA({
          mainAxis: !0,
          crossAxis: !1,
          limiter: c === "partial" ? OA() : void 0,
          ...U
        }), l && LA({
          ...U
        }), DA({
          ...U,
          apply: ({
            elements: $n,
            rects: fa,
            availableWidth: Gu,
            availableHeight: ha
          }) => {
            const {
                width: Yu,
                height: _o
              } = fa.reference,
              vs = $n.floating.style;
            vs.setProperty("--radix-popper-available-width", `${Gu}px`), vs.setProperty("--radix-popper-available-height", `${ha}px`), vs.setProperty("--radix-popper-anchor-width", `${Yu}px`), vs.setProperty("--radix-popper-anchor-height", `${_o}px`);
          }
        }), S && FA({
          element: S,
          padding: a
        }), HA({
          arrowWidth: T,
          arrowHeight: k
        }), f && IA({
          strategy: "referenceHidden",
          ...U
        })]
      }),
      [j, F] = $1(z),
      W = pn(w);
    Mn(() => {
      K && (W == null || W());
    }, [K, W]);
    const $ = (re = N.arrow) == null ? void 0 : re.x,
      X = (gs = N.arrow) == null ? void 0 : gs.y,
      J = ((Bn = N.arrow) == null ? void 0 : Bn.centerOffset) !== 0,
      [Te, $e] = y.useState();
    return Mn(() => {
      g && $e(window.getComputedStyle(g).zIndex);
    }, [g]), p.jsx("div", window.LyoEditor.mediaProps({
      ref: D.setFloating,
      "data-radix-popper-content-wrapper": "",
      style: {
        ...q,
        transform: K ? q.transform : "translate(0, -200%)",
        minWidth: "max-content",
        zIndex: Te,
        "--radix-popper-transform-origin": [(Dr = N.transformOrigin) == null ? void 0 : Dr.x, (zn = N.transformOrigin) == null ? void 0 : zn.y].join(" "),
        ...(((ys = N.hide) == null ? void 0 : ys.referenceHidden) && {
          visibility: "hidden",
          pointerEvents: "none"
        })
      },
      dir: e.dir,
      children: p.jsx(zA, {
        scope: n,
        placedSide: j,
        onArrowChange: E,
        arrowX: $,
        arrowY: X,
        shouldHideArrow: J,
        children: p.jsx(Re.div, window.LyoEditor.mediaProps({
          "data-side": j,
          "data-align": F,
          ...m,
          ref: b,
          style: {
            ...m.style,
            animation: K ? void 0 : "none"
          }
        }))
      })
    }));
  });
V1.displayName = bp;
var B1 = "PopperArrow",
  UA = {
    top: "bottom",
    right: "left",
    bottom: "top",
    left: "right"
  },
  z1 = y.forwardRef(function (t, n) {
    const {
        __scopePopper: r,
        ...s
      } = t,
      o = $A(B1, r),
      i = UA[o.placedSide];
    return p.jsx("span", window.LyoEditor.mediaProps({
      ref: o.onArrowChange,
      style: {
        position: "absolute",
        left: o.arrowX,
        top: o.arrowY,
        [i]: 0,
        transformOrigin: {
          top: "",
          right: "0 0",
          bottom: "center 0",
          left: "100% 0"
        }[o.placedSide],
        transform: {
          top: "translateY(100%)",
          right: "translateY(50%) rotate(90deg) translateX(-50%)",
          bottom: "rotate(180deg)",
          left: "translateY(50%) rotate(-90deg) translateX(50%)"
        }[o.placedSide],
        visibility: o.shouldHideArrow ? "hidden" : void 0
      },
      children: p.jsx(VA, window.LyoEditor.mediaProps({
        ...s,
        ref: n,
        style: {
          ...s.style,
          display: "block"
        }
      }))
    }));
  });
z1.displayName = B1;
function WA(e) {
  return e !== null;
}
var HA = e => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var x, g, v;
    const {
        placement: n,
        rects: r,
        middlewareData: s
      } = t,
      i = ((x = s.arrow) == null ? void 0 : x.centerOffset) !== 0,
      a = i ? 0 : e.arrowWidth,
      l = i ? 0 : e.arrowHeight,
      [u, d] = $1(n),
      c = {
        start: "0%",
        center: "50%",
        end: "100%"
      }[d],
      f = (((g = s.arrow) == null ? void 0 : g.x) ?? 0) + a / 2,
      h = (((v = s.arrow) == null ? void 0 : v.y) ?? 0) + l / 2;
    let w = "",
      m = "";
    return u === "bottom" ? (w = i ? c : `${f}px`, m = `${-l}px`) : u === "top" ? (w = i ? c : `${f}px`, m = `${r.floating.height + l}px`) : u === "right" ? (w = `${-l}px`, m = i ? c : `${h}px`) : u === "left" && (w = `${r.floating.width + l}px`, m = i ? c : `${h}px`), {
      data: {
        x: w,
        y: m
      }
    };
  }
});
function $1(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var qA = _1,
  KA = V1,
  QA = z1,
  [Fu, b5] = sa("Tooltip", [D1]),
  Sp = D1(),
  U1 = "TooltipProvider",
  GA = 700,
  sy = "tooltip.open",
  [YA, W1] = Fu(U1),
  H1 = e => {
    const {
        __scopeTooltip: t,
        delayDuration: n = GA,
        skipDelayDuration: r = 300,
        disableHoverableContent: s = !1,
        children: o
      } = e,
      i = y.useRef(!0),
      a = y.useRef(!1),
      l = y.useRef(0);
    return y.useEffect(() => {
      const u = l.current;
      return () => window.clearTimeout(u);
    }, []), p.jsx(YA, {
      scope: t,
      isOpenDelayedRef: i,
      delayDuration: n,
      onOpen: y.useCallback(() => {
        window.clearTimeout(l.current), i.current = !1;
      }, []),
      onClose: y.useCallback(() => {
        window.clearTimeout(l.current), l.current = window.setTimeout(() => i.current = !0, r);
      }, [r]),
      isPointerInTransitRef: a,
      onPointerInTransitChange: y.useCallback(u => {
        a.current = u;
      }, []),
      disableHoverableContent: s,
      children: o
    });
  };
H1.displayName = U1;
var q1 = "Tooltip",
  [S5, _u] = Fu(q1),
  kf = "TooltipTrigger",
  XA = y.forwardRef((e, t) => {
    const {
        __scopeTooltip: n,
        ...r
      } = e,
      s = _u(kf, n),
      o = W1(kf, n),
      i = Sp(n),
      a = y.useRef(null),
      l = et(t, a, s.onTriggerChange),
      u = y.useRef(!1),
      d = y.useRef(!1),
      c = y.useCallback(() => u.current = !1, []);
    return y.useEffect(() => () => document.removeEventListener("pointerup", c), [c]), p.jsx(qA, {
      asChild: !0,
      ...i,
      children: p.jsx(Re.button, {
        "aria-describedby": s.open ? s.contentId : void 0,
        "data-state": s.stateAttribute,
        ...r,
        ref: l,
        onPointerMove: ge(e.onPointerMove, f => {
          f.pointerType !== "touch" && !d.current && !o.isPointerInTransitRef.current && (s.onTriggerEnter(), d.current = !0);
        }),
        onPointerLeave: ge(e.onPointerLeave, () => {
          s.onTriggerLeave(), d.current = !1;
        }),
        onPointerDown: ge(e.onPointerDown, () => {
          s.open && s.onClose(), u.current = !0, document.addEventListener("pointerup", c, {
            once: !0
          });
        }),
        onFocus: ge(e.onFocus, () => {
          u.current || s.onOpen();
        }),
        onBlur: ge(e.onBlur, s.onClose),
        onClick: ge(e.onClick, s.onClose)
      })
    });
  });
XA.displayName = kf;
var ZA = "TooltipPortal",
  [E5, JA] = Fu(ZA, {
    forceMount: void 0
  }),
  bo = "TooltipContent",
  K1 = y.forwardRef((e, t) => {
    const n = JA(bo, e.__scopeTooltip),
      {
        forceMount: r = n.forceMount,
        side: s = "top",
        ...o
      } = e,
      i = _u(bo, e.__scopeTooltip);
    return p.jsx(Ao, {
      present: r || i.open,
      children: i.disableHoverableContent ? p.jsx(Q1, {
        side: s,
        ...o,
        ref: t
      }) : p.jsx(ej, {
        side: s,
        ...o,
        ref: t
      })
    });
  }),
  ej = y.forwardRef((e, t) => {
    const n = _u(bo, e.__scopeTooltip),
      r = W1(bo, e.__scopeTooltip),
      s = y.useRef(null),
      o = et(t, s),
      [i, a] = y.useState(null),
      {
        trigger: l,
        onClose: u
      } = n,
      d = s.current,
      {
        onPointerInTransitChange: c
      } = r,
      f = y.useCallback(() => {
        a(null), c(!1);
      }, [c]),
      h = y.useCallback((w, m) => {
        const x = w.currentTarget,
          g = {
            x: w.clientX,
            y: w.clientY
          },
          v = oj(g, x.getBoundingClientRect()),
          b = ij(g, v),
          S = aj(m.getBoundingClientRect()),
          E = uj([...b, ...S]);
        a(E), c(!0);
      }, [c]);
    return y.useEffect(() => () => f(), [f]), y.useEffect(() => {
      if (l && d) {
        const w = x => h(x, d),
          m = x => h(x, l);
        return l.addEventListener("pointerleave", w), d.addEventListener("pointerleave", m), () => {
          l.removeEventListener("pointerleave", w), d.removeEventListener("pointerleave", m);
        };
      }
    }, [l, d, h, f]), y.useEffect(() => {
      if (i) {
        const w = m => {
          const x = m.target,
            g = {
              x: m.clientX,
              y: m.clientY
            },
            v = (l == null ? void 0 : l.contains(x)) || (d == null ? void 0 : d.contains(x)),
            b = !lj(g, i);
          v ? f() : b && (f(), u());
        };
        return document.addEventListener("pointermove", w), () => document.removeEventListener("pointermove", w);
      }
    }, [l, d, i, u, f]), p.jsx(Q1, {
      ...e,
      ref: o
    });
  }),
  [tj, nj] = Fu(q1, {
    isInside: !1
  }),
  rj = _2("TooltipContent"),
  Q1 = y.forwardRef((e, t) => {
    const {
        __scopeTooltip: n,
        children: r,
        "aria-label": s,
        onEscapeKeyDown: o,
        onPointerDownOutside: i,
        ...a
      } = e,
      l = _u(bo, n),
      u = Sp(n),
      {
        onClose: d
      } = l;
    return y.useEffect(() => (document.addEventListener(sy, d), () => document.removeEventListener(sy, d)), [d]), y.useEffect(() => {
      if (l.trigger) {
        const c = f => {
          const h = f.target;
          h != null && h.contains(l.trigger) && d();
        };
        return window.addEventListener("scroll", c, {
          capture: !0
        }), () => window.removeEventListener("scroll", c, {
          capture: !0
        });
      }
    }, [l.trigger, d]), p.jsx(Au, {
      asChild: !0,
      disableOutsidePointerEvents: !1,
      onEscapeKeyDown: o,
      onPointerDownOutside: i,
      onFocusOutside: c => c.preventDefault(),
      onDismiss: d,
      children: p.jsxs(KA, window.LyoEditor.mediaProps({
        "data-state": l.stateAttribute,
        ...u,
        ...a,
        ref: t,
        style: {
          ...a.style,
          "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
          "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
          "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
        },
        children: [p.jsx(rj, {
          children: r
        }), p.jsx(tj, {
          scope: n,
          isInside: !0,
          children: p.jsx(lR, {
            id: l.contentId,
            role: "tooltip",
            children: s || r
          })
        })]
      }))
    });
  });
K1.displayName = bo;
var G1 = "TooltipArrow",
  sj = y.forwardRef((e, t) => {
    const {
        __scopeTooltip: n,
        ...r
      } = e,
      s = Sp(n);
    return nj(G1, n).isInside ? null : p.jsx(QA, {
      ...s,
      ...r,
      ref: t
    });
  });
sj.displayName = G1;
function oj(e, t) {
  const n = Math.abs(t.top - e.y),
    r = Math.abs(t.bottom - e.y),
    s = Math.abs(t.right - e.x),
    o = Math.abs(t.left - e.x);
  switch (Math.min(n, r, s, o)) {
    case o:
      return "left";
    case s:
      return "right";
    case n:
      return "top";
    case r:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function ij(e, t, n = 5) {
  const r = [];
  switch (t) {
    case "top":
      r.push({
        x: e.x - n,
        y: e.y + n
      }, {
        x: e.x + n,
        y: e.y + n
      });
      break;
    case "bottom":
      r.push({
        x: e.x - n,
        y: e.y - n
      }, {
        x: e.x + n,
        y: e.y - n
      });
      break;
    case "left":
      r.push({
        x: e.x + n,
        y: e.y - n
      }, {
        x: e.x + n,
        y: e.y + n
      });
      break;
    case "right":
      r.push({
        x: e.x - n,
        y: e.y - n
      }, {
        x: e.x - n,
        y: e.y + n
      });
      break;
  }
  return r;
}
function aj(e) {
  const {
    top: t,
    right: n,
    bottom: r,
    left: s
  } = e;
  return [{
    x: s,
    y: t
  }, {
    x: n,
    y: t
  }, {
    x: n,
    y: r
  }, {
    x: s,
    y: r
  }];
}
function lj(e, t) {
  const {
    x: n,
    y: r
  } = e;
  let s = !1;
  for (let o = 0, i = t.length - 1; o < t.length; i = o++) {
    const a = t[o],
      l = t[i],
      u = a.x,
      d = a.y,
      c = l.x,
      f = l.y;
    d > r != f > r && n < (c - u) * (r - d) / (f - d) + u && (s = !s);
  }
  return s;
}
function uj(e) {
  const t = e.slice();
  return t.sort((n, r) => n.x < r.x ? -1 : n.x > r.x ? 1 : n.y < r.y ? -1 : n.y > r.y ? 1 : 0), cj(t);
}
function cj(e) {
  if (e.length <= 1) return e.slice();
  const t = [];
  for (let r = 0; r < e.length; r++) {
    const s = e[r];
    for (; t.length >= 2;) {
      const o = t[t.length - 1],
        i = t[t.length - 2];
      if ((o.x - i.x) * (s.y - i.y) >= (o.y - i.y) * (s.x - i.x)) t.pop();else break;
    }
    t.push(s);
  }
  t.pop();
  const n = [];
  for (let r = e.length - 1; r >= 0; r--) {
    const s = e[r];
    for (; n.length >= 2;) {
      const o = n[n.length - 1],
        i = n[n.length - 2];
      if ((o.x - i.x) * (s.y - i.y) >= (o.y - i.y) * (s.x - i.x)) n.pop();else break;
    }
    n.push(s);
  }
  return n.pop(), t.length === 1 && n.length === 1 && t[0].x === n[0].x && t[0].y === n[0].y ? t : t.concat(n);
}
var dj = H1,
  Y1 = K1;
const fj = dj,
  hj = y.forwardRef(({
    className: e,
    sideOffset: t = 4,
    ...n
  }, r) => p.jsx(Y1, {
    ref: r,
    sideOffset: t,
    className: Y("z-50 overflow-hidden rounded-md border bg-popover px-3 py-1.5 text-sm text-popover-foreground shadow-md animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2", e),
    ...n
  }));
hj.displayName = Y1.displayName;
const pj = () => {
    const {
        pathname: e
      } = Vn(),
      t = vk(),
      n = y.useRef(e);
    return y.useEffect(() => {
      const r = n.current !== e;
      n.current = e, r && t !== "POP" && window.scrollTo({
        top: 0,
        left: 0,
        behavior: "instant"
      });
    }, [e, t]), null;
  },
  Rf = {
    fr: {
      get "nav.shop"() {
        return window.LyoEditor.text("txt_f271e2b39ae3", "Nos Boîtes");
      },
      get "nav.story"() {
        return window.LyoEditor.text("txt_9fa20202bad2", "Notre mission");
      },
      get "nav.faq"() {
        return window.LyoEditor.text("txt_8db5189c5069", "FAQ");
      },
      get "nav.contact"() {
        return window.LyoEditor.text("txt_b2e57ca19a96", "Contact");
      },
      get "nav.menu"() {
        return window.LyoEditor.text("txt_d4875878b7d1", "Menu");
      },
      get "nav.close"() {
        return window.LyoEditor.text("txt_fb99c143d271", "Fermer");
      },
      get "shop.compose.title"() {
        return window.LyoEditor.text("txt_ef3570f72922", "Compose ta boîte");
      },
      get "shop.compose.help"() {
        return window.LyoEditor.text("txt_9a5b8e3f3821", "Choisis la quantité de chaque légume.");
      },
      get "shop.counter"() {
        return window.LyoEditor.text("txt_83f86dc03add", "sachets");
      },
      get "shop.add_more_pre"() {
        return window.LyoEditor.text("txt_10cf97c1336d", "Ajoute encore");
      },
      get "shop.add_more_post"() {
        return window.LyoEditor.text("txt_27adc9f4a06a", "sachets");
      },
      get "shop.complete"() {
        return window.LyoEditor.text("txt_6a1efd1ea6f4", "Composition complète");
      },
      get "shop.reset"() {
        return window.LyoEditor.text("txt_cef28a4bca18", "Réinitialiser");
      },
      get "shop.add"() {
        return window.LyoEditor.text("txt_a721fe72b2fe", "Ajouter au panier");
      },
      get "shop.placeholder.box3"() {
        return window.LyoEditor.text("txt_5fb6c6272862", "Boîte 3 : sac avec 3 sachets");
      },
      get "shop.placeholder.box6"() {
        return window.LyoEditor.text("txt_ae693e307e79", "Boîte 6 : sac avec 6 sachets");
      },
      get "shop.placeholder.box10"() {
        return window.LyoEditor.text("txt_3d85b9fca10c", "Boîte 10 : sac avec 10 sachets");
      },
      get "announce.bar"() {
        return window.LyoEditor.text("txt_d4aa947a78ea", "Livraison Express 48h GRATUITE sur toutes les boîtes");
      },
      get "launch.banner"() {
        return "🥕 Un sac de carotte offert dès 6 sacs — 50 premières commandes";
      },
      get "launch.badge"() {
        return "+ 1 SAC OFFERT";
      },
      get "launch.gift.name"() {
        return "Carotte 50 g — OFFERT";
      },
      get "launch.gift.sweet"() {
        return "Patate douce 50 g — OFFERT";
      },
      get "launch.gift.carrot"() {
        return "Carotte 50 g — OFFERT";
      },
      get "launch.gift.bean"() {
        return "Haricots verts 50 g — OFFERT";
      },
      get "launch.gift.meta"() {
        return "Cadeau de lancement · 0,00 $";
      },
      get "launch.selector.eyebrow"() {
        return "OFFRE DE LANCEMENT";
      },
      get "launch.selector.title"() {
        return "🥕 1 sac Carotte 50 g offert";
      },
      get "launch.selector.body"() {
        return "Choisis une boîte de 6 ou 10 sacs. Offre réservée aux 50 premières commandes.";
      },
      get "launch.nudge.one"() {
        return "Ajoute 1 sac et reçois un sac de carotte gratuit.";
      },
      get "launch.nudge.two"() {
        return "Ajoute 2 sacs et reçois un sac de carotte gratuit.";
      },
      get "risk.line"() {
        return window.LyoEditor.text("txt_b2fd7a0bb533", "✓ Satisfait ou remboursé 30 jours · Livraison gratuite");
      },
      get "selector.title"() {
        return window.LyoEditor.text("txt_cd6896d1e270", "Quelle saveur lui fera craquer?");
      },
      get "selector.1"() {
        return window.LyoEditor.text("txt_8096a2d70b61", "PATATE DOUCE 🍠");
      },
      get "selector.2"() {
        return window.LyoEditor.text("txt_d5b9f3851e47", "CAROTTE 🥕");
      },
      get "selector.3"() {
        return window.LyoEditor.text("txt_a01b707639aa", "HARICOTS VERTS 🌿");
      },
      get "truths.title"() {
        return window.LyoEditor.text("txt_88a5e6fb099f", "SIMPLE POUR TOI. IRRÉSISTIBLE POUR LUI.");
      },
      get "truths.1.title"() {
        return window.LyoEditor.text("txt_d02c0f6c46da", "Un seul légume");
      },
      get "truths.1.desc"() {
        return window.LyoEditor.text("txt_07d77f9e1d03", "Carotte, patate douce ou haricot vert. Rien d'autre.");
      },
      get "truths.2.title"() {
        return window.LyoEditor.text("txt_ecb84442b9e6", "Naturellement croquant");
      },
      get "truths.2.desc"() {
        return window.LyoEditor.text("txt_d10bc67397b3", "La lyophilisation aide à préserver le goût et la texture du légume.");
      },
      get "truths.3.title"() {
        return window.LyoEditor.text("txt_49e8df0816c9", "Sans ingrédients inutiles");
      },
      get "truths.3.desc"() {
        return window.LyoEditor.text("txt_1bd2569b4d6a", "Aucun additif ni agent de conservation.");
      },
      get "truths.4.title"() {
        return window.LyoEditor.text("txt_1631d5ed20e6", "Deux façons de lui faire plaisir");
      },
      get "truths.4.desc"() {
        return window.LyoEditor.text("txt_077ed2105cdf", "Comme gâterie ou émietté directement sur son repas.");
      },
      get "label.eyebrow"() {
        return window.LyoEditor.text("txt_9b52fb5df9d2", "Le test de l'étiquette");
      },
      get "label.title"() {
        return window.LyoEditor.text("txt_df66ebc7e40b", "Retourne le sac. Compte les ingrédients.");
      },
      get "label.typical"() {
        return window.LyoEditor.text("txt_874d94e3a6c8", "Gâterie typique");
      },
      get "label.vs"() {
        return window.LyoEditor.text("txt_b68efc4c2fea", "Nous vs eux");
      },
      get "label.us"() {
        return window.LyoEditor.text("txt_f32c148afc1b", "LyoPup");
      },
      get "label.typical.list"() {
        return window.LyoEditor.text("txt_773fc4cf7e12", "Farine de blé|Sous-produits de viande|Glycérine|Sirop de maïs|Arômes artificiels|BHA / BHT|Colorants|Et la liste continue");
      },
      get "label.us.word"() {
        return window.LyoEditor.text("txt_c92f1964f836", "Patate douce");
      },
      get "label.footer"() {
        return window.LyoEditor.text("txt_ef22a67c4fa1", "C'est tout.");
      },
      get "label.row.1.label"() {
        return window.LyoEditor.text("txt_826a935da630", "Un seul ingrédient");
      },
      get "label.row.1.them"() {
        return window.LyoEditor.text("txt_7718da84df01", "15+");
      },
      get "label.row.1.us"() {
        return window.LyoEditor.text("txt_eeebff394875", "1");
      },
      get "label.row.2.label"() {
        return window.LyoEditor.text("txt_21567463931e", "Sans agents de conservation");
      },
      get "label.row.2.them"() {
        return window.LyoEditor.text("txt_4afa4c3603d8", "Oui");
      },
      get "label.row.2.us"() {
        return window.LyoEditor.text("txt_2da4982d8d4a", "Aucun");
      },
      get "label.row.3.label"() {
        return window.LyoEditor.text("txt_5b8c7fb0d2ef", "Sans colorants ni arômes artificiels");
      },
      get "label.row.3.them"() {
        return window.LyoEditor.text("txt_28b617e177ab", "Oui");
      },
      get "label.row.3.us"() {
        return window.LyoEditor.text("txt_579bf61043ee", "Aucun");
      },
      get "label.row.4.label"() {
        return window.LyoEditor.text("txt_80ac2e7ba867", "Une liste facile à comprendre");
      },
      get "label.row.4.them"() {
        return window.LyoEditor.text("txt_951ed09a55b5", "Difficilement");
      },
      get "label.row.4.us"() {
        return window.LyoEditor.text("txt_02fd5d4c202d", "Oui");
      },
      get "badge.shipping"() {
        return window.LyoEditor.text("txt_d55dcf0d6756", "Livraison gratuite");
      },
      get "badge.quebec"() {
        return window.LyoEditor.text("txt_acb79e4e8110", "Préparé au Québec");
      },
      get "badge.guarantee"() {
        return window.LyoEditor.text("txt_0838f0d8e0b1", "Garantie 30 jours : il aime ou on te rembourse.");
      },
      get "ticker.ingredient"() {
        return window.LyoEditor.text("txt_50f193740a6d", "Un seul ingrédient par sac");
      },
      get "ticker.freeze"() {
        return window.LyoEditor.text("txt_d0aeadd668e4", "Lyophilisé au Québec");
      },
      get "ticker.preservative"() {
        return window.LyoEditor.text("txt_649c122254ad", "Sans agents de conservation");
      },
      get "trustbar.ingredient"() {
        return window.LyoEditor.text("txt_a9b753f3bf13", "Un seul ingrédient par sac");
      },
      get "trustbar.quebec"() {
        return window.LyoEditor.text("txt_1c5f278870e5", "Lyophilisé au Québec");
      },
      get "trustbar.guarantee"() {
        return window.LyoEditor.text("txt_fd7256663af7", "Il l'aime ou on te rembourse, 30 jours");
      },
      get "trustbar.shipping"() {
        return window.LyoEditor.text("txt_408ee6d0e221", "Livraison gratuite partout au Québec");
      },
      get "homeboxes.eyebrow"() {
        return window.LyoEditor.text("txt_4ef390e7db65", "TROUVEZ LE BON FORMAT");
      },
      get "homeboxes.title"() {
        return window.LyoEditor.text("txt_182a54b28151", "Quelle boîte lui convient?");
      },
      get "homeboxes.subtitle"() {
        return window.LyoEditor.text("txt_d02d7adf3b8f", "3, 6 ou 10 sacs : chaque boîte réunit nos trois saveurs, avec toujours un seul légume par sac.\n\nQue ce soit pour découvrir LyoPup ou faire le plein, choisis simplement le format qui convient à votre quotidien.");
      },
      get "homeboxes.cta"() {
        return window.LyoEditor.text("txt_53bd41d38f2e", "COMPARER LES TROIS BOÎTES");
      },
      get "flavcard.hint"() {
        return window.LyoEditor.text("txt_6597eb65dcfa", "Survole pour voir le légume");
      },
      get "chip.1"() {
        return window.LyoEditor.text("txt_7e1b75f537db", "1 ingrédient");
      },
      get "chip.2"() {
        return window.LyoEditor.text("txt_6ac03aad5a05", "Sans additifs");
      },
      get "chip.3"() {
        return window.LyoEditor.text("txt_1caf0d890f09", "Prêt à donner");
      },
      get "chip.4"() {
        return window.LyoEditor.text("txt_bd80265d2c1e", "Fait au Québec");
      },
      get "faq.q4"() {
        return window.LyoEditor.text("txt_ab50eb6e1bbc", "Qu'est-ce qu'il y a dans chaque sachet ?");
      },
      get "faq.a4"() {
        return window.LyoEditor.text("txt_97903625d54d", "Chaque sachet contient un seul ingrédient, affiché en un mot. Tu sais exactement ce que ton chien mange.");
      },
      get "faq.q5"() {
        return window.LyoEditor.text("txt_ea0d2541a5e1", "Comment je conserve les gâteries ?");
      },
      get "faq.a5"() {
        return window.LyoEditor.text("txt_d715e2808313", "À température ambiante, sac refermé. La lyophilisation conserve le légume naturellement. Pas besoin de frigo.");
      },
      get "faq.q6"() {
        return window.LyoEditor.text("txt_87e12189e4e9", "Vous livrez où, et en combien de temps ?");
      },
      get "faq.a6"() {
        return window.LyoEditor.text("txt_7d1f7f977ee6", "Partout au Québec, livraison gratuite sur toutes les boîtes. Expédition en quelques jours ouvrables depuis le Québec.");
      },
      get "faq.q7"() {
        return window.LyoEditor.text("txt_26cfbeb16205", "Et si mon chien n'aime pas ?");
      },
      get "faq.a7"() {
        return window.LyoEditor.text("txt_778ef69c6c66", "Satisfait ou remboursé : si ton chien n'en raffole pas dans les 30 jours, on te rembourse. Écris-nous, c'est tout.");
      },
      get "hero.eyebrow"() {
        return window.LyoEditor.text("txt_fd0117dce058", "GÂTERIES POUR CHIENS • 100 % LÉGUMES");
      },
      get "hero.title"() {
        return window.LyoEditor.text("txt_db45732401a8", "Il court dès qu'il entend le sac.");
      },
      get "hero.subtitle"() {
        return window.LyoEditor.text("txt_0faea2737fa4", "Des gâteries croquantes faites d'un seul légume, sans additifs ni agents de conservation.\n\nÀ offrir comme récompense ou directement sur son repas.");
      },
      get "hero.sticker.label"() {
        return window.LyoEditor.text("txt_ae91bcc23fed", "POUR COMMENCER");
      },
      get "hero.sticker.sub"() {
        return window.LyoEditor.text("txt_694675a6fca6", "Les 3 saveurs, une de chaque");
      },
      get "hero.flavourHint"() {
        return window.LyoEditor.text("txt_5954830911c2", "Voir les saveurs");
      },
      get "bybenefit.eyebrow"() {
        return window.LyoEditor.text("txt_d6ab59bc3f4f", "NOS TROIS LÉGUMES ET LEURS BIENFAITS");
      },
      get "bybenefit.title"() {
        return window.LyoEditor.text("txt_a8bf492937c3", "Trois légumes simples, sélectionnés pour leurs qualités nutritionnelles naturelles.");
      },
      get "bybenefit.1.title"() {
        return window.LyoEditor.text("txt_74b2c24bcf7d", "PATATE DOUCE");
      },
      get "bybenefit.1.veg"() {
        return window.LyoEditor.text("txt_efc5213cf4b7", "Patate douce");
      },
      get "bybenefit.1.desc"() {
        return window.LyoEditor.text("txt_3ec0199508e8", "Riche en fibres et naturellement source de vitamine B6 et de potassium.");
      },
      get "bybenefit.1.sens"() {
        return window.LyoEditor.text("txt_c17639c4f54b", "Elle favorise une digestion saine et procure une source d’énergie naturelle.");
      },
      get "bybenefit.2.title"() {
        return window.LyoEditor.text("txt_16772a88999b", "CAROTTE");
      },
      get "bybenefit.2.veg"() {
        return window.LyoEditor.text("txt_fbcfcea92745", "Carotte");
      },
      get "bybenefit.2.desc"() {
        return window.LyoEditor.text("txt_927f992a5a0b", "Source de fibres et de bêta-carotène, un précurseur de la vitamine A.");
      },
      get "bybenefit.2.sens"() {
        return window.LyoEditor.text("txt_af30a78efec6", "Elle contribue à une digestion saine et aide à soutenir la vision et les défenses naturelles.");
      },
      get "bybenefit.3.title"() {
        return window.LyoEditor.text("txt_7f7c89c2f068", "HARICOTS VERTS");
      },
      get "bybenefit.3.veg"() {
        return window.LyoEditor.text("txt_8def78e559c4", "Haricots verts");
      },
      get "bybenefit.3.desc"() {
        return window.LyoEditor.text("txt_fbe83145896c", "Faibles en calories et naturellement riches en fibres.");
      },
      get "bybenefit.3.sens"() {
        return window.LyoEditor.text("txt_6e27045cfbdc", "Ils favorisent la satiété et un transit régulier, tout en offrant une récompense légère.");
      },
      get "bybenefit.footer"() {
        return window.LyoEditor.text("txt_617430639e0b", "Un seul légume par sac. Rien d'autre.");
      },
      get "bybenefit.cta"() {
        return window.LyoEditor.text("txt_d34e43ad7d67", "DÉCOUVRIR NOS BOÎTES");
      },
      get "hero.cta"() {
        return window.LyoEditor.text("txt_4484363916ce", "CHOISIR SA BOÎTE");
      },
      get "hero.trust"() {
        return window.LyoEditor.text("txt_1ee2a1a1feb1", "Livraison gratuite · Satisfaction garantie");
      },
      get "brandstory.eyebrow"() {
        return window.LyoEditor.text("txt_b899104d556f", "Notre histoire");
      },
      get "brandstory.title"() {
        return window.LyoEditor.text("txt_6ee440a27854", "Pourquoi on a créé LyoPup");
      },
      get "brandstory.body"() {
        return window.LyoEditor.text("txt_9a398172513d", "La gâterie qu'on voulait pour nos propres chiens\n\nOn cherchait une gâterie simple pour nos propres chiens.\n\nMais partout, on retrouvait des listes d'ingrédients interminables, des agents de conservation et des ingrédients impossibles à prononcer.\n\nAlors on a créé la gâterie qu'on voulait leur donner.\n\nUn seul légume.\n\nLyophilisé pour préserver sa qualité.\n\nRien d'autre.");
      },
      get "ladder.intro"() {
        return window.LyoEditor.text("txt_375bb595cc76", "De 13,33 $ à 9,99 $ le sac selon la boîte, livraison incluse.");
      },
      get "trans.title"() {
        return window.LyoEditor.text("txt_7ddffc4efe48", "Du légume à la gâterie. C'est tout.");
      },
      get "eyebrow.single"() {
        return window.LyoEditor.text("txt_2c820cc7af6a", "Un seul ingrédient.");
      },
      get "eyebrow.method"() {
        return window.LyoEditor.text("txt_61ac2ac75ba5", "Notre méthode");
      },
      get "eyebrow.price"() {
        return window.LyoEditor.text("txt_29cda9db5137", "Le bon prix");
      },
      get "eyebrow.boxes"() {
        return window.LyoEditor.text("txt_ada4d6d78766", "Les boîtes");
      },
      get "trans.body"() {
        return window.LyoEditor.text("txt_03beafd315f2", "Tout commence par un vrai légume.\n\nOn choisit des légumes de qualité, puis on retire l'eau à froid pour garder le goût et le croquant.");
      },
      get "freeze.kicker"() {
        return window.LyoEditor.text("txt_88203f84bdf7", "Sublimation");
      },
      get "freeze.title"() {
        return window.LyoEditor.text("txt_2a66f2a10993", "Frais → croquant.\nGlisse pour retirer l'eau.");
      },
      get "freeze.hint"() {
        return window.LyoEditor.text("txt_d6d9125b4475", "On congèle le légume, puis on aspire l'eau. Il reste le croquant et le goût concentré, rien d'autre. Touche et glisse : ça marche aussi au doigt.");
      },
      get "freeze.fresh"() {
        return window.LyoEditor.text("txt_b6f901c948b3", "Frais");
      },
      get "freeze.dry"() {
        return window.LyoEditor.text("txt_3d4a967ea9a5", "Lyophilisé");
      },
      get "freeze.drag"() {
        return window.LyoEditor.text("txt_79d7eca015d7", "Glisse");
      },
      get "brandstory.cta"() {
        return window.LyoEditor.text("txt_ed10fb39244f", "Lire l'histoire");
      },
      get "img.missing"() {
        return window.LyoEditor.text("txt_3b2fba8483d6", "Image manquante : à déposer dans assets");
      },
      get "benefits.eyebrow"() {
        return window.LyoEditor.text("txt_42e40be8263f", "Les bienfaits");
      },
      get "benefits.title"() {
        return window.LyoEditor.text("txt_0a21e30e9219", "Pourquoi LyoPup");
      },
      get "benefit.1.title"() {
        return window.LyoEditor.text("txt_d68ba5121477", "Un seul ingrédient");
      },
      get "benefit.1.desc"() {
        return window.LyoEditor.text("txt_54978a14d63b", "Tu peux lire l'étiquette au complet.");
      },
      get "benefit.2.title"() {
        return window.LyoEditor.text("txt_5316ca493525", "Sans additifs");
      },
      get "benefit.2.desc"() {
        return window.LyoEditor.text("txt_bc11e067ebbd", "Aucun agent de conservation, colorant ni arôme.");
      },
      get "benefit.3.title"() {
        return window.LyoEditor.text("txt_7626bcde9709", "Croquant, pas mouillé");
      },
      get "benefit.3.desc"() {
        return window.LyoEditor.text("txt_a5239146b42a", "Le légume cru, il faut le couper, le garder au frigo, et il finit par pourrir. Pas celui-là.");
      },
      get "benefit.4.title"() {
        return window.LyoEditor.text("txt_b3853dd13b4f", "Lyophilisé");
      },
      get "benefit.4.desc"() {
        return window.LyoEditor.text("txt_d952da64d853", "Garde le croquant et le goût concentré.");
      },
      get "benefit.5.title"() {
        return window.LyoEditor.text("txt_9f45d3958239", "Une liste d'ingrédients d'un mot");
      },
      get "benefit.5.desc"() {
        return window.LyoEditor.text("txt_e9b7d09a0ca6", "Un seul ingrédient : tu sais exactement ce qu'il mange.");
      },
      get "benefit.6.title"() {
        return window.LyoEditor.text("txt_ca7d9c2f2b01", "Petits lots, fait main");
      },
      get "benefit.6.desc"() {
        return window.LyoEditor.text("txt_b15ec54b62a7", "Conçu au Québec.");
      },
      get "why.title"() {
        return window.LyoEditor.text("txt_55f855942c22", "Pourquoi les carottes crues échouent");
      },
      get "why.1.title"() {
        return window.LyoEditor.text("txt_2e8697afce2b", "Le conseil est bon");
      },
      get "why.1.desc"() {
        return window.LyoEditor.text("txt_c0a7298048d8", "Ta vétérinaire te dit de remplacer les gâteries du commerce par des légumes. Carottes, haricots verts. Elle a raison.");
      },
      get "why.2.title"() {
        return window.LyoEditor.text("txt_a36846be7dba", "L'exécution échoue");
      },
      get "why.2.desc"() {
        return window.LyoEditor.text("txt_0e857160aaf6", "Cru, c'est mouillé. Ça pourrit dans le frigo, il faut couper, et beaucoup de chiens recrachent.");
      },
      get "why.3.title"() {
        return window.LyoEditor.text("txt_a9a0117a08cc", "Ce qu'on change");
      },
      get "why.3.desc"() {
        return window.LyoEditor.text("txt_bdfdddbf6a3d", "On congèle le légume, puis on retire l'eau sous vide. Pas de cuisson, rien d'ajouté. Il reste le croquant et le goût concentré. Ça, il le mange.");
      },
      get "bybenefit.1.yield"() {
        return window.LyoEditor.text("txt_b1718630c3ea", "≈ une grosse patate douce dans ce sac");
      },
      get "bybenefit.2.yield"() {
        return window.LyoEditor.text("txt_a8abbbd8f6d6", "≈ 6 carottes moyennes dans ce sac");
      },
      get "bybenefit.3.yield"() {
        return window.LyoEditor.text("txt_21d0bbfdc182", "≈ presque une livre de haricots dans ce sac");
      },
      get "pillar.1"() {
        return window.LyoEditor.text("txt_4a782b82fd64", "1 seul ingrédient : tu peux le lire");
      },
      get "pillar.2"() {
        return window.LyoEditor.text("txt_b7d8e5dd90d9", "Un seul ingrédient : tu sais exactement ce qu'il mange");
      },
      get "pillar.3"() {
        return window.LyoEditor.text("txt_a87ca93dd960", "Croquant, prêt à donner, se garde à température ambiante");
      },
      get "pillar.4"() {
        return window.LyoEditor.text("txt_c50f240a8489", "En petits lots, fait main");
      },
      get "savings.title"() {
        return window.LyoEditor.text("txt_555304f40376", "Plus la boîte est grande, moins le sac coûte cher.");
      },
      get "savings.body"() {
        return window.LyoEditor.text("txt_b9ca049c5d51", "13,33 $ le sac dans la boîte Découverte. 9,99 $ dans le Garde-manger. Livraison gratuite dans les deux cas.");
      },
      get "compare.eyebrow"() {
        return window.LyoEditor.text("txt_f83e1ce6a262", "La différence");
      },
      get "compare.title"() {
        return window.LyoEditor.text("txt_379f99dafc50", "LyoPup vs une gâterie ordinaire");
      },
      get "compare.us"() {
        return window.LyoEditor.text("txt_f27f608c9671", "LyoPup");
      },
      get "compare.them"() {
        return window.LyoEditor.text("txt_48b86a3dc504", "Une gâterie ordinaire");
      },
      get "compare.row.1"() {
        return window.LyoEditor.text("txt_2ef82b6063f9", "Un seul ingrédient");
      },
      get "compare.row.2"() {
        return window.LyoEditor.text("txt_9163557c7aaa", "Sans additifs ni agents de conservation");
      },
      get "compare.row.3"() {
        return window.LyoEditor.text("txt_4e61075575fc", "Se garde à température ambiante");
      },
      get "compare.row.4"() {
        return window.LyoEditor.text("txt_dcee0aa04693", "Emballage minimal");
      },
      get "ladder.title"() {
        return window.LyoEditor.text("txt_1d2a782a1be6", "Choisis ta boîte");
      },
      get "ladder.popular"() {
        return window.LyoEditor.text("txt_ac92b04c7f2e", "Le plus populaire");
      },
      get "ladder.bestprice"() {
        return window.LyoEditor.text("txt_6edbfe8b67af", "meilleur prix par sac");
      },
      get "ladder.add"() {
        return window.LyoEditor.text("txt_986f94af5fd1", "Ajouter au panier");
      },
      get "ladder.bags"() {
        return window.LyoEditor.text("txt_2159c7fa8fe8", "sacs");
      },
      get "ladder.perbag"() {
        return window.LyoEditor.text("txt_c451b0791d01", "le sac");
      },
      get "ladder.shipping"() {
        return window.LyoEditor.text("txt_76c4824b9db3", "Livraison gratuite incluse");
      },
      get "box.discovery"() {
        return window.LyoEditor.text("txt_98aeaef94804", "Boîte Découverte");
      },
      get "box.discovery.desc"() {
        return window.LyoEditor.text("txt_79bf63a7980b", "L'essai parfait : 3 saveurs, une de chaque.");
      },
      get "box.grande"() {
        return window.LyoEditor.text("txt_2333dc452ab3", "La Grande Boîte");
      },
      get "box.grande.desc"() {
        return window.LyoEditor.text("txt_35812da5cc5e", "Choisis librement tes 6 saveurs.");
      },
      get "box.pantry"() {
        return window.LyoEditor.text("txt_151f2f27c7c7", "Le Garde-manger");
      },
      get "box.pantry.desc"() {
        return window.LyoEditor.text("txt_d905e08ad303", "2 sacs offerts + notre meilleur prix par sac.");
      },
      get "flav.carrot"() {
        return window.LyoEditor.text("txt_8b67973f6109", "Carotte");
      },
      get "flav.sweet"() {
        return window.LyoEditor.text("txt_cc9625c0b36b", "Patate douce");
      },
      get "flav.bean"() {
        return window.LyoEditor.text("txt_be7f4d65b66b", "Haricots verts");
      },
      get "how.title"() {
        return window.LyoEditor.text("txt_00bd4e5b0d6b", "Comment ça marche");
      },
      get "how.1.title"() {
        return window.LyoEditor.text("txt_075b45cfa4f9", "Choisis ta boîte");
      },
      get "how.1.sub"() {
        return window.LyoEditor.text("txt_1a62cfea5b3f", "Découverte, Grande Boîte ou Garde-Manger.");
      },
      get "how.2.title"() {
        return window.LyoEditor.text("txt_1fdf17d8e2da", "On prépare ta commande");
      },
      get "how.2.sub"() {
        return window.LyoEditor.text("txt_d7b5fc36f751", "Des légumes 100 % naturels, préparés et emballés avec soin au Québec.");
      },
      get "how.3.title"() {
        return window.LyoEditor.text("txt_c29ad023b629", "Livraison gratuite");
      },
      get "how.3.sub"() {
        return window.LyoEditor.text("txt_05002508d5af", "Directement à ta porte, partout au Québec.");
      },
      get "how.4.title"() {
        return window.LyoEditor.text("txt_cdc5e996e3b4", "Ajoute aux repas");
      },
      get "how.4.sub"() {
        return window.LyoEditor.text("txt_bafc66c921e3", "À mélanger à la nourriture ou à offrir comme récompense.");
      },
      get "how.5.title"() {
        return window.LyoEditor.text("txt_4e22cbd453d5", "Ton chien en redemande");
      },
      get "how.5.sub"() {
        return window.LyoEditor.text("txt_9cde47e3b410", "Une façon simple d'ajouter de la variété à chaque repas.");
      },
      get "trust.title"() {
        return window.LyoEditor.text("txt_54fe2d2efa76", "Pourquoi faire confiance à LyoPup ?");
      },
      get "trust.1.title"() {
        return window.LyoEditor.text("txt_a95615f6ee52", "Fièrement québécois");
      },
      get "trust.1.line"() {
        return window.LyoEditor.text("txt_210b57ad76f9", "Une entreprise locale créée par des amoureux des chiens.");
      },
      get "trust.2.title"() {
        return window.LyoEditor.text("txt_c47502df376e", "Des ingrédients simples et transparents");
      },
      get "trust.2.line"() {
        return window.LyoEditor.text("txt_d890e0f74043", "Un seul légume par sachet. Rien d'autre.");
      },
      get "trust.3.title"() {
        return window.LyoEditor.text("txt_ea3b1d0640b1", "Approvisionnement responsable");
      },
      get "trust.3.line"() {
        return window.LyoEditor.text("txt_5e818054c8e8", "On choisit des légumes de qualité chez des producteurs de confiance.");
      },
      get "trust.4.title"() {
        return window.LyoEditor.text("txt_e1522923c2be", "On enlève l'eau, rien d'autre");
      },
      get "trust.4.line"() {
        return window.LyoEditor.text("txt_2fe7e4396dcb", "Pas de cuisson à haute température, aucun agent de conservation, aucun additif.");
      },
      get "trust.5.title"() {
        return window.LyoEditor.text("txt_1d0c957cee28", "Préparé avec soin");
      },
      get "trust.5.line"() {
        return window.LyoEditor.text("txt_9ca3b7f5f60e", "Chaque sachet est emballé pour garder la fraîcheur et le croquant.");
      },
      get "trust.6.title"() {
        return window.LyoEditor.text("txt_f83e7fbe8262", "Achète en toute confiance");
      },
      get "trust.6.line"() {
        return window.LyoEditor.text("txt_fdda20e0e381", "Ton chien l'adore ou on te rembourse.");
      },
      get "faq.title"() {
        return window.LyoEditor.text("txt_a5edaa06e132", "Foire aux questions");
      },
      get "faq.q0a"() {
        return window.LyoEditor.text("txt_c8f51d6f92c8", "Mon chien mange pas de légumes.");
      },
      get "faq.a0a"() {
        return window.LyoEditor.text("txt_2a0011ed168b", "C'est l'objection numéro un, et elle est légitime. Deux réponses : le croquant et le goût concentré ne ressemblent pas au légume cru qu'il a refusé, et la boîte Découverte te donne les trois saveurs pour trouver la sienne. S'il n'en veut d'aucune, on te rembourse dans les 30 jours.");
      },
      get "faq.q0b"() {
        return window.LyoEditor.text("txt_4436aaf4dfd9", "13 $ pour un sac de légumes ?");
      },
      get "faq.a0b"() {
        return window.LyoEditor.text("txt_c331538a09a3", "Il faut environ 6 carottes moyennes pour remplir un sac. La lyophilisation retire l'eau. Et un légume frais, c'est presque 90 % d'eau. Tu paies ce qui reste : le légume au complet, sans l'eau.");
      },
      get "faq.q1"() {
        return window.LyoEditor.text("txt_4c075aff8f37", "Un seul ingrédient, vraiment ?");
      },
      get "faq.a1"() {
        return window.LyoEditor.text("txt_ed2375e20f1f", "Oui. Chaque sac contient un seul légume, lyophilisé. Pas d'agent de conservation, pas de colorant, pas d'« arôme naturel ». Tu peux lire l'étiquette en une seconde.");
      },
      get "faq.q2"() {
        return window.LyoEditor.text("txt_6b8cddd0a4ba", "Combien j'en donne par jour ?");
      },
      get "faq.a2"() {
        return window.LyoEditor.text("txt_7502b871f73c", "La règle générale des vétérinaires : pas plus d'environ 10 % de l'apport quotidien. Un morceau de carotte fait environ 2 à 3 calories, et un sac complet en fait environ 175. Compte-les comme n'importe quelle autre gâterie. Dans le doute, parles-en à ton vétérinaire.");
      },
      get "faq.q3"() {
        return window.LyoEditor.text("txt_0696ccb33433", "C'est bon pour les chiots et les chiens âgés ?");
      },
      get "faq.a3"() {
        return window.LyoEditor.text("txt_7faaa31e0b71", "Un légume lyophilisé convient à la plupart des chiens, du chiot au senior. Pour un chien avec une condition particulière, demande à ton vétérinaire : l'avantage d'un seul ingrédient, c'est que la réponse est facile à donner.");
      },
      get "final.title"() {
        return window.LyoEditor.text("txt_fbf11f967427", "Il l'aime, ou on te rembourse.");
      },
      get "final.cta"() {
        return window.LyoEditor.text("txt_b3b58b98813f", "Choisir ma boîte");
      },
      get "final.trust"() {
        return window.LyoEditor.text("txt_b56d0ea8e150", "Livraison gratuite · Satisfaction garantie");
      },
      get "email.placeholder"() {
        return window.LyoEditor.text("txt_08c4b0825d35", "Ton courriel");
      },
      get "email.cta"() {
        return window.LyoEditor.text("txt_a43703b3868a", "S'inscrire");
      },
      get "email.sending"() {
        return window.LyoEditor.text("txt_87caca209d59", "Un instant…");
      },
      get "email.success.title"() {
        return window.LyoEditor.text("txt_4efe2949f371", "C'est fait !");
      },
      get "email.success.body"() {
        return window.LyoEditor.text("txt_128e10c4ac04", "Tu recevras nos nouvelles par courriel.");
      },
      get "email.error"() {
        return window.LyoEditor.text("txt_486ae96a5be3", "Oups, ça n'a pas fonctionné. Réessaie dans un instant.");
      },
      get "email.invalid"() {
        return window.LyoEditor.text("txt_67eecc77fbf4", "Entre une adresse courriel valide.");
      },
      get "footer.signup.title"() {
        return window.LyoEditor.text("txt_f8f093ee0649", "Reçois 10% sur ta première commande");
      },
      get "footer.signup.placeholder"() {
        return window.LyoEditor.text("txt_a31358afd8ec", "Ton courriel");
      },
      get "footer.signup.cta"() {
        return window.LyoEditor.text("txt_c3c0000864a7", "S'inscrire");
      },
      get "footer.col.help"() {
        return window.LyoEditor.text("txt_5f99e4b6cfb9", "Aide");
      },
      get "footer.col.shop"() {
        return window.LyoEditor.text("txt_e2df91fc4715", "Nos Boîtes");
      },
      get "footer.faq"() {
        return window.LyoEditor.text("txt_98763d267e76", "FAQ");
      },
      get "footer.contact"() {
        return window.LyoEditor.text("txt_ac19e3a367f0", "Contact");
      },
      get "footer.refund"() {
        return window.LyoEditor.text("txt_4c01bbe4ae50", "Remboursement");
      },
      get "footer.shipping"() {
        return window.LyoEditor.text("txt_f1e56e1e9d80", "Livraison");
      },
      get "footer.terms"() {
        return window.LyoEditor.text("txt_0ae4a9a36980", "Conditions");
      },
      get "footer.rights"() {
        return window.LyoEditor.text("txt_99677e52c161", "Tous droits réservés.");
      },
      get "footer.made"() {
        return window.LyoEditor.text("txt_8936309d2a56", "Fait au Québec 🍁");
      },
      get "cart.label"() {
        return window.LyoEditor.text("txt_7f56130061e2", "Panier");
      },
      get "cart.title"() {
        return window.LyoEditor.text("txt_ce6276ad3533", "Ton panier");
      },
      get "cart.empty"() {
        return window.LyoEditor.text("txt_cb766338f77e", "Ton panier est vide.");
      },
      get "cart.empty.cta"() {
        return window.LyoEditor.text("txt_ca26633da227", "Voir les boîtes");
      },
      get "cart.items"() {
        return window.LyoEditor.text("txt_6d5097b5647a", "articles");
      },
      get "cart.item"() {
        return window.LyoEditor.text("txt_5b328dc108a6", "article");
      },
      get "cart.subtotal"() {
        return window.LyoEditor.text("txt_7632b2e82346", "Sous-total");
      },
      get "cart.shipping"() {
        return window.LyoEditor.text("txt_442e2f31b675", "Livraison gratuite incluse");
      },
      get "cart.checkout"() {
        return window.LyoEditor.text("txt_6aec09619049", "Passer à la caisse");
      },
      get "cart.continue"() {
        return window.LyoEditor.text("txt_d9a8fb110c6b", "Continuer mes achats");
      },
      get "cart.checkout.error.title"() {
        return window.LyoEditor.text("txt_78c8b45df4f9", "La fenêtre de paiement a été bloquée");
      },
      get "cart.checkout.error.body"() {
        return window.LyoEditor.text("txt_1c60f23cb48c", "Clique sur le lien ci-dessous pour continuer ta commande. Tu peux aussi copier le lien et l'ouvrir dans un nouvel onglet.");
      },
      get "cart.checkout.error.link"() {
        return window.LyoEditor.text("txt_e4d056ec4d47", "Continuer sur Shopify");
      },
      get "cart.checkout.error.copy"() {
        return window.LyoEditor.text("txt_677cf1352afc", "Copier le lien");
      },
      get "cart.copied"() {
        return window.LyoEditor.text("txt_f63bf139eeb1", "Copié");
      },
      get "cart.add.success"() {
        return window.LyoEditor.text("txt_12a78bb0bc68", "Ajouté au panier");
      },
      get "cart.add.error"() {
        return window.LyoEditor.text("txt_6d79611d7bac", "Impossible d'ajouter au panier. Dans Shopify: vérifie le stock au bon emplacement + publication Online Store / vitrine.");
      },
      get "cart.add.oos"() {
        return window.LyoEditor.text("txt_355a47c9df48", "Cette boîte est en rupture de stock.");
      },
      get "cart.add.throttled"() {
        return window.LyoEditor.text("txt_596031e621b3", "Shopify est saturé (trop de tentatives). Attends 1–2 minutes puis réessaie une seule fois.");
      },
      get "popup.badge"() {
        return "OFFRE DE BIENVENUE";
      },
      get "popup.title"() {
        return window.LyoEditor.text("txt_593e2565ed3a", "10 % de rabais sur ta première boîte");
      },
      get "popup.body"() {
        return window.LyoEditor.text("txt_68be776aa957", "Fais découvrir à ton chien des gâteries composées d’un seul légume, cultivées et lyophilisées au Québec.\n\nEntre ton courriel et reçois ton code immédiatement.");
      },
      get "popup.placeholder"() {
        return window.LyoEditor.text("txt_90dc5c6484b5", "Ton courriel");
      },
      get "popup.cta"() {
        return window.LyoEditor.text("txt_28891ca78be6", "Obtenir mon 10 %");
      },
      get "popup.thanks"() {
        return window.LyoEditor.text("txt_2af160366de5", "Merci ! Voici ton code :");
      },
      get "popup.dismiss"() {
        return window.LyoEditor.text("txt_b14d5d59d34f", "Continuer sans rabais");
      },
      get "pdp.add"() {
        return window.LyoEditor.text("txt_850c12d9df87", "Ajouter au panier");
      },
      get "pdp.qty"() {
        return window.LyoEditor.text("txt_ce5c52dc03e0", "Quantité");
      },
      get "pdp.recommended"() {
        return window.LyoEditor.text("txt_8dd2a04692de", "Recommandé");
      },
      get "pdp.includes"() {
        return window.LyoEditor.text("txt_e937da082876", "Ce qu'il y a dans la boîte");
      },
      get "pdp.guarantee"() {
        return window.LyoEditor.text("txt_e1b34e5a0ec9", "Satisfaction garantie : ton chien l'adore ou on te rembourse.");
      },
      get "pdp.shipping"() {
        return window.LyoEditor.text("txt_7236e5e50fb9", "Livraison gratuite partout au Québec.");
      },
      get "pdp.single"() {
        return window.LyoEditor.text("txt_d11ec6e0f1f0", "Un seul ingrédient.");
      },
      get "shop.title"() {
        return window.LyoEditor.text("txt_3d35f152dc4b", "Nos boîtes");
      },
      get "shop.subtitle"() {
        return window.LyoEditor.text("txt_fe11635f030c", "Pas de sac à l'unité en ligne. Que des boîtes, pour un meilleur prix et zéro emballage en trop.");
      },
      get "story.eyebrow"() {
        return window.LyoEditor.text("txt_42dc6bfad7b8", "NOTRE MISSION");
      },
      get "story.title"() {
        return window.LyoEditor.text("txt_5d9d170785ac", "Faire de chaque gâterie un choix plus sain.");
      },
      get "story.body.1"() {
        return window.LyoEditor.text("txt_f2785b99bf0e", "Nos chiens font partie de la famille. Leur faire plaisir devrait donc être aussi bon pour eux qu'agréable à donner.");
      },
      get "story.body.2"() {
        return window.LyoEditor.text("txt_9ad47efa05e6", "C'est avec cette conviction que LyoPup est née.");
      },
      get "story.body.3"() {
        return window.LyoEditor.text("txt_53fe529ab7e4", "Nous avons voulu revenir à l'essentiel : de vrais légumes, lyophilisés au Québec pour préserver leur goût et leur croquant. Chaque sac contient un seul ingrédient, sans additifs ni agents de conservation.");
      },
      get "story.body.4"() {
        return window.LyoEditor.text("txt_17d377f331d0", "Notre mission est simple : offrir aux chiens une gâterie plus saine qu'ils auront réellement hâte de manger.");
      },
      get "story.body.5"() {
        return window.LyoEditor.text("txt_8cf5f62336b6", "Parce qu'on ne devrait jamais avoir à choisir entre leur faire plaisir et prendre soin d'eux.");
      },
      get "story.cta"() {
        return window.LyoEditor.text("txt_8af3847d1aa6", "DÉCOUVRIR LYOPUP");
      },
      get "contact.title"() {
        return window.LyoEditor.text("txt_11d6de16cc2e", "Contact");
      },
      get "contact.body"() {
        return window.LyoEditor.text("txt_f8db151ad71b", "Une question, une commande spéciale, un câlin de chien à partager ? Écris-nous.");
      },
      get "contact.email.label"() {
        return window.LyoEditor.text("txt_ebf5365bd8cf", "Courriel");
      },
      get "contact.name.label"() {
        return window.LyoEditor.text("txt_85c53784ebce", "Nom");
      },
      get "contact.message.label"() {
        return window.LyoEditor.text("txt_315260bc9b00", "Message");
      },
      get "contact.cta"() {
        return window.LyoEditor.text("txt_74d861b9e6c8", "Envoyer");
      },
      get "contact.sent"() {
        return window.LyoEditor.text("txt_371a05a2fd84", "Message envoyé. Merci !");
      },
      get "policy.refund.title"() {
        return window.LyoEditor.text("txt_3fa1001bffc3", "Politique de remboursement");
      },
      get "policy.refund.body"() {
        return window.LyoEditor.text("txt_ecab07379f21", "Si ton chien n'aime pas LyoPup, écris-nous dans les 30 jours et on te rembourse intégralement. Pas de paperasse, pas de retour à organiser.");
      },
      get "policy.shipping.title"() {
        return window.LyoEditor.text("txt_79bd75372bf8", "Livraison");
      },
      get "policy.shipping.body"() {
        return window.LyoEditor.text("txt_c72c5f045317", "Livraison gratuite sur toutes les boîtes, partout au Québec. Expédition en 1-2 jours ouvrables depuis Montréal. Délai de livraison habituel : 2-5 jours ouvrables.");
      },
      get "policy.terms.title"() {
        return window.LyoEditor.text("txt_fc282743bbd5", "Conditions d'utilisation");
      },
      get "policy.terms.body"() {
        return window.LyoEditor.text("txt_e66e7200a752", "En utilisant ce site, tu acceptes nos conditions d'utilisation. Les images, textes et marque LyoPup sont protégés. Pour toute question, écris-nous.");
      },
      get "nf.title"() {
        return window.LyoEditor.text("txt_959fb98a6ab6", "Page introuvable");
      },
      get "nf.body"() {
        return window.LyoEditor.text("txt_45d05edc9e9c", "Cette page s'est sauvée comme un chien qui a vu un écureuil.");
      },
      get "nf.cta"() {
        return window.LyoEditor.text("txt_0095ca888dbf", "Retour à l'accueil");
      }
    },
    en: {
      get "nav.shop"() {
        return window.LyoEditor.text("txt_e0cfd8e98a83", "Our Boxes");
      },
      get "nav.story"() {
        return window.LyoEditor.text("txt_9645ce57ecde", "Our mission");
      },
      get "nav.faq"() {
        return window.LyoEditor.text("txt_7dc10ded8066", "FAQ");
      },
      get "nav.contact"() {
        return window.LyoEditor.text("txt_6db73326db8c", "Contact");
      },
      get "nav.menu"() {
        return window.LyoEditor.text("txt_0620d220816e", "Menu");
      },
      get "nav.close"() {
        return window.LyoEditor.text("txt_37720f4655d7", "Close");
      },
      get "shop.compose.title"() {
        return window.LyoEditor.text("txt_6e360aa0b5b7", "Build your box");
      },
      get "shop.compose.help"() {
        return window.LyoEditor.text("txt_67b8400ae9f0", "Choose how many of each vegetable.");
      },
      get "shop.counter"() {
        return window.LyoEditor.text("txt_db9383669031", "bags");
      },
      get "shop.add_more_pre"() {
        return window.LyoEditor.text("txt_c89c7d4a2a9d", "Add");
      },
      get "shop.add_more_post"() {
        return window.LyoEditor.text("txt_898728059541", "more bags");
      },
      get "shop.complete"() {
        return window.LyoEditor.text("txt_515c26a7b05f", "Box complete");
      },
      get "shop.reset"() {
        return window.LyoEditor.text("txt_7d88f0d25b01", "Reset");
      },
      get "shop.add"() {
        return window.LyoEditor.text("txt_6a072d0f645d", "Add to cart");
      },
      get "shop.placeholder.box3"() {
        return window.LyoEditor.text("txt_96b19d7b0ce3", "Box 3: bag with 3 pouches");
      },
      get "shop.placeholder.box6"() {
        return window.LyoEditor.text("txt_3b9d677e4f7e", "Box 6: bag with 6 pouches");
      },
      get "shop.placeholder.box10"() {
        return window.LyoEditor.text("txt_abb6efff0449", "Box 10: bag with 10 pouches");
      },
      get "announce.bar"() {
        return window.LyoEditor.text("txt_2ea40db435e3", "FREE 48-hour Express Shipping on every box");
      },
      get "launch.banner"() {
        return "🥕 Free carrot bag with 6+ bags — first 50 orders";
      },
      get "launch.badge"() {
        return "+ 1 FREE BAG";
      },
      get "launch.gift.name"() {
        return "Carrot 50 g — FREE";
      },
      get "launch.gift.sweet"() {
        return "Sweet Potato 50 g — FREE";
      },
      get "launch.gift.carrot"() {
        return "Carrot 50 g — FREE";
      },
      get "launch.gift.bean"() {
        return "Green Beans 50 g — FREE";
      },
      get "launch.gift.meta"() {
        return "Launch gift · $0.00";
      },
      get "launch.selector.eyebrow"() {
        return "LAUNCH OFFER";
      },
      get "launch.selector.title"() {
        return "🥕 1 free Carrot 50 g bag";
      },
      get "launch.selector.body"() {
        return "Choose a 6- or 10-bag box. Limited to the first 50 orders.";
      },
      get "launch.nudge.one"() {
        return "Add 1 bag and get a free carrot bag.";
      },
      get "launch.nudge.two"() {
        return "Add 2 bags and get a free carrot bag.";
      },
      get "risk.line"() {
        return window.LyoEditor.text("txt_4bbe23d32965", "✓ 30-day money-back guarantee · Free shipping");
      },
      get "selector.title"() {
        return window.LyoEditor.text("txt_828ac4e72caf", "Which flavour will he go crazy for?");
      },
      get "selector.1"() {
        return window.LyoEditor.text("txt_dd076274c9c6", "SWEET POTATO 🍠");
      },
      get "selector.2"() {
        return window.LyoEditor.text("txt_4aeae9399992", "CARROT 🥕");
      },
      get "selector.3"() {
        return window.LyoEditor.text("txt_8810b0cfcd5b", "GREEN BEANS 🌿");
      },
      get "truths.title"() {
        return window.LyoEditor.text("txt_233608cf9cd6", "SIMPLE FOR YOU. IRRESISTIBLE FOR HIM.");
      },
      get "truths.1.title"() {
        return window.LyoEditor.text("txt_cef58a2c8712", "One vegetable");
      },
      get "truths.1.desc"() {
        return window.LyoEditor.text("txt_f5bc3d870bb1", "Carrot, sweet potato or green bean. Nothing else.");
      },
      get "truths.2.title"() {
        return window.LyoEditor.text("txt_9d295040bce7", "Naturally crunchy");
      },
      get "truths.2.desc"() {
        return window.LyoEditor.text("txt_baa920131376", "Freeze-drying helps preserve the vegetable's taste and texture.");
      },
      get "truths.3.title"() {
        return window.LyoEditor.text("txt_9fe912fc9f56", "No unnecessary ingredients");
      },
      get "truths.3.desc"() {
        return window.LyoEditor.text("txt_8db75acdd619", "No additives or preservatives.");
      },
      get "truths.4.title"() {
        return window.LyoEditor.text("txt_434019e300f3", "Two ways to treat him");
      },
      get "truths.4.desc"() {
        return window.LyoEditor.text("txt_9022a7e4c9c1", "As a treat or crumbled right onto his meal.");
      },
      get "label.eyebrow"() {
        return window.LyoEditor.text("txt_304430cdf7c5", "The label test");
      },
      get "label.title"() {
        return window.LyoEditor.text("txt_3d714bda2468", "Turn the bag around. Count the ingredients.");
      },
      get "label.typical"() {
        return window.LyoEditor.text("txt_16eabfe806b1", "Typical treat");
      },
      get "label.vs"() {
        return window.LyoEditor.text("txt_5d69e027bee6", "Us vs them");
      },
      get "label.us"() {
        return window.LyoEditor.text("txt_83341a4335f4", "LyoPup");
      },
      get "label.typical.list"() {
        return window.LyoEditor.text("txt_6fec38cab29f", "Wheat flour|Meat by-products|Glycerin|Corn syrup|Artificial flavours|BHA / BHT|Colourings|And the list goes on");
      },
      get "label.us.word"() {
        return window.LyoEditor.text("txt_511995ff1956", "Sweet potato");
      },
      get "label.footer"() {
        return window.LyoEditor.text("txt_48fdc067eccf", "That's it.");
      },
      get "label.row.1.label"() {
        return window.LyoEditor.text("txt_20cc1d27f246", "One single ingredient");
      },
      get "label.row.1.them"() {
        return window.LyoEditor.text("txt_194bae595226", "15+");
      },
      get "label.row.1.us"() {
        return window.LyoEditor.text("txt_5d12170059ec", "1");
      },
      get "label.row.2.label"() {
        return window.LyoEditor.text("txt_3df82aef5f7d", "No preservatives");
      },
      get "label.row.2.them"() {
        return window.LyoEditor.text("txt_bfa246257373", "Yes");
      },
      get "label.row.2.us"() {
        return window.LyoEditor.text("txt_6c697de2ba67", "None");
      },
      get "label.row.3.label"() {
        return window.LyoEditor.text("txt_bbb4c1bc3db4", "No artificial colours or flavours");
      },
      get "label.row.3.them"() {
        return window.LyoEditor.text("txt_0ae3a8bd8fff", "Yes");
      },
      get "label.row.3.us"() {
        return window.LyoEditor.text("txt_a2db828b8a4b", "None");
      },
      get "label.row.4.label"() {
        return window.LyoEditor.text("txt_993da8673f36", "An easy-to-understand ingredient list");
      },
      get "label.row.4.them"() {
        return window.LyoEditor.text("txt_5c7562f4560e", "Barely");
      },
      get "label.row.4.us"() {
        return window.LyoEditor.text("txt_e485ac3b9572", "Yes");
      },
      get "badge.shipping"() {
        return window.LyoEditor.text("txt_501038020e03", "Free shipping");
      },
      get "badge.quebec"() {
        return window.LyoEditor.text("txt_da7e873957e6", "Prepared in Quebec");
      },
      get "badge.guarantee"() {
        return window.LyoEditor.text("txt_64d1f1e0679e", "30-day guarantee: he loves it or we refund you.");
      },
      get "ticker.ingredient"() {
        return window.LyoEditor.text("txt_16dc7659f138", "One ingredient per bag");
      },
      get "ticker.freeze"() {
        return window.LyoEditor.text("txt_661835333bc5", "Freeze-dried in Quebec");
      },
      get "ticker.preservative"() {
        return window.LyoEditor.text("txt_5aeca0a3b2ad", "No preservatives");
      },
      get "trustbar.ingredient"() {
        return window.LyoEditor.text("txt_67f91dedddae", "One ingredient per bag");
      },
      get "trustbar.quebec"() {
        return window.LyoEditor.text("txt_8621cb3ad8f1", "Freeze-dried in Quebec");
      },
      get "trustbar.guarantee"() {
        return window.LyoEditor.text("txt_26f521adbd41", "He loves it or we refund you, 30 days");
      },
      get "trustbar.shipping"() {
        return window.LyoEditor.text("txt_af4c594779c2", "Free shipping across Quebec");
      },
      get "homeboxes.eyebrow"() {
        return window.LyoEditor.text("txt_1cfa60f4b93d", "FIND THE RIGHT SIZE");
      },
      get "homeboxes.title"() {
        return window.LyoEditor.text("txt_8eb7a46375cc", "Which box is right for him?");
      },
      get "homeboxes.subtitle"() {
        return window.LyoEditor.text("txt_f35bfb42d88b", "3, 6 or 10 bags: every box brings together our three flavours, with always one vegetable per bag.\n\nWhether you're discovering LyoPup or stocking up, just pick the size that fits your routine.");
      },
      get "homeboxes.cta"() {
        return window.LyoEditor.text("txt_2d190abc4714", "COMPARE THE THREE BOXES");
      },
      get "flavcard.hint"() {
        return window.LyoEditor.text("txt_c0b46aeb7da3", "Hover to see the vegetable");
      },
      get "chip.1"() {
        return window.LyoEditor.text("txt_ef23988894cd", "1 ingredient");
      },
      get "chip.2"() {
        return window.LyoEditor.text("txt_e6d5f91ad51a", "No additives");
      },
      get "chip.3"() {
        return window.LyoEditor.text("txt_491b8b513668", "Ready to give");
      },
      get "chip.4"() {
        return window.LyoEditor.text("txt_b8792633a4da", "Made in Québec");
      },
      get "faq.q4"() {
        return window.LyoEditor.text("txt_f1a710c1c724", "What is in each bag?");
      },
      get "faq.a4"() {
        return window.LyoEditor.text("txt_5731ebfa530b", "Each bag contains one single ingredient, listed in one word. You know exactly what your dog is eating.");
      },
      get "faq.q5"() {
        return window.LyoEditor.text("txt_77f86a8cd49a", "How do I store the treats?");
      },
      get "faq.a5"() {
        return window.LyoEditor.text("txt_76cf74d0b780", "Room temperature, bag resealed. Freeze-drying preserves the vegetable naturally. No fridge needed.");
      },
      get "faq.q6"() {
        return window.LyoEditor.text("txt_3cd30145bb71", "Where do you ship, and how fast?");
      },
      get "faq.a6"() {
        return window.LyoEditor.text("txt_f780e192182d", "Everywhere in Québec, free shipping on all boxes. Ships within a few business days from Québec.");
      },
      get "faq.q7"() {
        return window.LyoEditor.text("txt_2a92fa625f4d", "What if my dog doesn't like them?");
      },
      get "faq.a7"() {
        return window.LyoEditor.text("txt_e2a3eb8cb838", "Money-back guarantee: if your dog isn't obsessed within 30 days, we refund you. Just write to us.");
      },
      get "hero.eyebrow"() {
        return window.LyoEditor.text("txt_1c4612ce06a2", "DOG TREATS • 100% VEGETABLES");
      },
      get "hero.title"() {
        return window.LyoEditor.text("txt_4ef6f67c98c5", "He comes running as soon as he hears the bag.");
      },
      get "hero.subtitle"() {
        return window.LyoEditor.text("txt_fdd124efbbb9", "Crunchy treats made from a single vegetable, with no additives or preservatives.\n\nGive as a reward or right on his meal.");
      },
      get "hero.sticker.label"() {
        return window.LyoEditor.text("txt_8a79dcbe7ef2", "START HERE");
      },
      get "hero.sticker.sub"() {
        return window.LyoEditor.text("txt_7e0ca6eb4dd6", "All 3 flavours, one of each");
      },
      get "hero.flavourHint"() {
        return window.LyoEditor.text("txt_4dcd52b252f0", "See the flavours");
      },
      get "bybenefit.eyebrow"() {
        return window.LyoEditor.text("txt_4b4bb6f2a925", "OUR THREE VEGETABLES AND THEIR BENEFITS");
      },
      get "bybenefit.title"() {
        return window.LyoEditor.text("txt_e09735d5a444", "Three simple vegetables, selected for their natural nutritional qualities.");
      },
      get "bybenefit.1.title"() {
        return window.LyoEditor.text("txt_e11ccc6ee050", "SWEET POTATO");
      },
      get "bybenefit.1.veg"() {
        return window.LyoEditor.text("txt_d2895366b163", "Sweet potato");
      },
      get "bybenefit.1.desc"() {
        return window.LyoEditor.text("txt_16695451c725", "Rich in fibre and a natural source of vitamin B6 and potassium.");
      },
      get "bybenefit.1.sens"() {
        return window.LyoEditor.text("txt_30e494b22e3f", "It promotes healthy digestion and provides a natural source of energy.");
      },
      get "bybenefit.2.title"() {
        return window.LyoEditor.text("txt_56dac07031b4", "CARROT");
      },
      get "bybenefit.2.veg"() {
        return window.LyoEditor.text("txt_1d427f5c434d", "Carrot");
      },
      get "bybenefit.2.desc"() {
        return window.LyoEditor.text("txt_b0f12bc9d69e", "A source of fibre and beta-carotene, a precursor to vitamin A.");
      },
      get "bybenefit.2.sens"() {
        return window.LyoEditor.text("txt_52a0e211db37", "It contributes to healthy digestion and helps support vision and natural defences.");
      },
      get "bybenefit.3.title"() {
        return window.LyoEditor.text("txt_ceb3a539ddea", "GREEN BEANS");
      },
      get "bybenefit.3.veg"() {
        return window.LyoEditor.text("txt_0ee8568762f6", "Green beans");
      },
      get "bybenefit.3.desc"() {
        return window.LyoEditor.text("txt_da17adb2f569", "Low in calories and naturally rich in fibre.");
      },
      get "bybenefit.3.sens"() {
        return window.LyoEditor.text("txt_77fcedc13a69", "They promote fullness and regular digestion while providing a light reward.");
      },
      get "bybenefit.footer"() {
        return window.LyoEditor.text("txt_f7cd3e9ca377", "One vegetable per bag. Nothing else.");
      },
      get "bybenefit.cta"() {
        return window.LyoEditor.text("txt_6fdb7b2a4105", "DISCOVER OUR BOXES");
      },
      get "hero.cta"() {
        return window.LyoEditor.text("txt_f2c7eed0913d", "CHOOSE HIS BOX");
      },
      get "hero.trust"() {
        return window.LyoEditor.text("txt_995aa4f1fdd9", "Free shipping · Satisfaction guaranteed");
      },
      get "brandstory.eyebrow"() {
        return window.LyoEditor.text("txt_9c1f246d0853", "Our story");
      },
      get "brandstory.title"() {
        return window.LyoEditor.text("txt_82fecc091f55", "Why we made LyoPup");
      },
      get "brandstory.body"() {
        return window.LyoEditor.text("txt_7c09a815d320", "The treat we wanted for our own dogs\n\nWe were looking for a simple treat for our own dogs.\n\nBut everywhere, we found endless ingredient lists, preservatives and impossible-to-pronounce ingredients.\n\nSo we created the treat we wanted to give them.\n\nOne vegetable.\n\nFreeze-dried to preserve its quality.\n\nNothing else.");
      },
      get "ladder.intro"() {
        return window.LyoEditor.text("txt_2af8a4d7835e", "From $13.33 down to $9.99 a bag depending on the box, shipping included.");
      },
      get "trans.title"() {
        return window.LyoEditor.text("txt_f907d1f20b8f", "From vegetable to treat. That's it.");
      },
      get "eyebrow.single"() {
        return window.LyoEditor.text("txt_c55a17fbbeac", "One ingredient.");
      },
      get "eyebrow.method"() {
        return window.LyoEditor.text("txt_052e68091aec", "Our method");
      },
      get "eyebrow.price"() {
        return window.LyoEditor.text("txt_97294e6c045d", "The right price");
      },
      get "eyebrow.boxes"() {
        return window.LyoEditor.text("txt_768669b18d20", "The boxes");
      },
      get "trans.body"() {
        return window.LyoEditor.text("txt_8f0de457f6d7", "Everything starts with a real vegetable.\n\nWe pick quality vegetables, then pull the water out cold to keep the taste and the crunch.");
      },
      get "freeze.kicker"() {
        return window.LyoEditor.text("txt_51d7f1083a57", "Sublimation");
      },
      get "freeze.title"() {
        return window.LyoEditor.text("txt_3d7a44476c24", "Fresh → crunch.\nDrag to pull the water out.");
      },
      get "freeze.hint"() {
        return window.LyoEditor.text("txt_a473cac59ce7", "Freeze-drying freezes the vegetable, then pulls the water off. What’s left: crunch, nutrients, nothing else. Drag with a finger; it works on phones too.");
      },
      get "freeze.fresh"() {
        return window.LyoEditor.text("txt_b0196542196c", "Fresh");
      },
      get "freeze.dry"() {
        return window.LyoEditor.text("txt_67415d99f5fd", "Freeze-dried");
      },
      get "freeze.drag"() {
        return window.LyoEditor.text("txt_ac9c1e9e3417", "Drag");
      },
      get "brandstory.cta"() {
        return window.LyoEditor.text("txt_e22ccc7c7657", "Read the story");
      },
      get "img.missing"() {
        return window.LyoEditor.text("txt_fd53707a1942", "Missing image: drop it in assets");
      },
      get "benefits.eyebrow"() {
        return window.LyoEditor.text("txt_bdb034199452", "The benefits");
      },
      get "benefits.title"() {
        return window.LyoEditor.text("txt_71e291ab26ca", "Why LyoPup");
      },
      get "benefit.1.title"() {
        return window.LyoEditor.text("txt_3e98b6a6980e", "One ingredient");
      },
      get "benefit.1.desc"() {
        return window.LyoEditor.text("txt_9e47682fb990", "You can read the whole label.");
      },
      get "benefit.2.title"() {
        return window.LyoEditor.text("txt_669e0f65597b", "No additives");
      },
      get "benefit.2.desc"() {
        return window.LyoEditor.text("txt_74c723e4532a", "No preservatives, dyes, or flavors.");
      },
      get "benefit.3.title"() {
        return window.LyoEditor.text("txt_263321d693a3", "Crunchy, not soggy");
      },
      get "benefit.3.desc"() {
        return window.LyoEditor.text("txt_667806e6c551", "A raw vegetable has to be chopped, kept cold, and it ends up rotting. Not this one.");
      },
      get "benefit.4.title"() {
        return window.LyoEditor.text("txt_04e4b5be75ab", "Freeze-dried");
      },
      get "benefit.4.desc"() {
        return window.LyoEditor.text("txt_3b98d905dd4c", "Keeps the crunch and the concentrated taste.");
      },
      get "benefit.5.title"() {
        return window.LyoEditor.text("txt_6f3257cccfd0", "A one-word ingredient list");
      },
      get "benefit.5.desc"() {
        return window.LyoEditor.text("txt_ce4ef078f653", "One ingredient: you know exactly what he's eating.");
      },
      get "benefit.6.title"() {
        return window.LyoEditor.text("txt_b8e11c8071be", "Small batches, handmade");
      },
      get "benefit.6.desc"() {
        return window.LyoEditor.text("txt_56584454b132", "Made in Québec.");
      },
      get "why.title"() {
        return window.LyoEditor.text("txt_dbec272a91bb", "Why raw carrots fail");
      },
      get "why.1.title"() {
        return window.LyoEditor.text("txt_aae49d7e1320", "The advice is good");
      },
      get "why.1.desc"() {
        return window.LyoEditor.text("txt_ceed709b310b", "Your vet tells you to swap store-bought treats for vegetables. Carrots, green beans. She's right.");
      },
      get "why.2.title"() {
        return window.LyoEditor.text("txt_09ac8b1e2388", "The execution fails");
      },
      get "why.2.desc"() {
        return window.LyoEditor.text("txt_9475460e7d17", "Raw means soggy. It rots in the fridge, you have to cut it, and plenty of dogs spit it out.");
      },
      get "why.3.title"() {
        return window.LyoEditor.text("txt_ccbf6578e4b9", "What we change");
      },
      get "why.3.desc"() {
        return window.LyoEditor.text("txt_f974e3ef5429", "We freeze the vegetable, then pull the water out under vacuum. No cooking, nothing added. What's left is the crunch and the concentrated taste. That, he eats.");
      },
      get "bybenefit.1.yield"() {
        return window.LyoEditor.text("txt_a4d988cedb37", "≈ one large sweet potato in this bag");
      },
      get "bybenefit.2.yield"() {
        return window.LyoEditor.text("txt_442ec5b60903", "≈ 6 medium carrots in this bag");
      },
      get "bybenefit.3.yield"() {
        return window.LyoEditor.text("txt_b001d3f4a8be", "≈ nearly a pound of green beans in this bag");
      },
      get "pillar.1"() {
        return window.LyoEditor.text("txt_14f3ead9ab47", "1 single ingredient: you can read it");
      },
      get "pillar.2"() {
        return window.LyoEditor.text("txt_2deaf0164bf5", "One ingredient: you know exactly what he's eating");
      },
      get "pillar.3"() {
        return window.LyoEditor.text("txt_6a2a77d4b364", "Crunchy, ready to give, keeps at room temperature");
      },
      get "pillar.4"() {
        return window.LyoEditor.text("txt_ddf0dfa8cab7", "Small batches, handmade");
      },
      get "savings.title"() {
        return window.LyoEditor.text("txt_07acb7c8e377", "The bigger the box, the cheaper the bag.");
      },
      get "savings.body"() {
        return window.LyoEditor.text("txt_ade36c512dec", "$13.33 a bag in the Discovery box. $9.99 in the Pantry. Free shipping either way.");
      },
      get "compare.eyebrow"() {
        return window.LyoEditor.text("txt_6bc7cc1a6186", "The difference");
      },
      get "compare.title"() {
        return window.LyoEditor.text("txt_3667b9570a95", "LyoPup vs an ordinary treat");
      },
      get "compare.us"() {
        return window.LyoEditor.text("txt_4ea1e74623c3", "LyoPup");
      },
      get "compare.them"() {
        return window.LyoEditor.text("txt_446fbc382cc9", "An ordinary treat");
      },
      get "compare.row.1"() {
        return window.LyoEditor.text("txt_d6f153f30ed7", "Single ingredient");
      },
      get "compare.row.2"() {
        return window.LyoEditor.text("txt_012043fb6bb4", "No additives or preservatives");
      },
      get "compare.row.3"() {
        return window.LyoEditor.text("txt_edff2df662a6", "Keeps at room temperature");
      },
      get "compare.row.4"() {
        return window.LyoEditor.text("txt_8fa9b652b8a4", "Minimal packaging");
      },
      get "ladder.title"() {
        return window.LyoEditor.text("txt_ab768c50afa8", "Choose your box");
      },
      get "ladder.popular"() {
        return window.LyoEditor.text("txt_7c165a8d816d", "Most popular");
      },
      get "ladder.bestprice"() {
        return window.LyoEditor.text("txt_f9b7f0826172", "best price per bag");
      },
      get "ladder.add"() {
        return window.LyoEditor.text("txt_a0524c02c1c3", "Add to cart");
      },
      get "ladder.bags"() {
        return window.LyoEditor.text("txt_8d6add66d671", "bags");
      },
      get "ladder.perbag"() {
        return window.LyoEditor.text("txt_562e391d53bf", "per bag");
      },
      get "ladder.shipping"() {
        return window.LyoEditor.text("txt_11a0521ec1cb", "Free shipping included");
      },
      get "box.discovery"() {
        return window.LyoEditor.text("txt_19a03f12a2a9", "Discovery Box");
      },
      get "box.discovery.desc"() {
        return window.LyoEditor.text("txt_3754374c9186", "The perfect try-out: 3 flavours, one of each.");
      },
      get "box.grande"() {
        return window.LyoEditor.text("txt_e74d7d8038f2", "The Big Box");
      },
      get "box.grande.desc"() {
        return window.LyoEditor.text("txt_652f788b8a1b", "Pick your 6 flavours freely.");
      },
      get "box.pantry"() {
        return window.LyoEditor.text("txt_c0a6228f18bd", "The Pantry");
      },
      get "box.pantry.desc"() {
        return window.LyoEditor.text("txt_e0c205469940", "2 bags free + our best price per bag.");
      },
      get "flav.carrot"() {
        return window.LyoEditor.text("txt_9c1863576679", "Carrot");
      },
      get "flav.sweet"() {
        return window.LyoEditor.text("txt_0017d025bff6", "Sweet potato");
      },
      get "flav.bean"() {
        return window.LyoEditor.text("txt_ace01e60d8db", "Green beans");
      },
      get "how.title"() {
        return window.LyoEditor.text("txt_dc25709f6ad4", "How it works");
      },
      get "how.1.title"() {
        return window.LyoEditor.text("txt_091f5baf5277", "Pick your box");
      },
      get "how.1.sub"() {
        return window.LyoEditor.text("txt_cddd5cccdcfb", "Discovery, Big Box, or Pantry.");
      },
      get "how.2.title"() {
        return window.LyoEditor.text("txt_84c1d5384a04", "We prepare your order");
      },
      get "how.2.sub"() {
        return window.LyoEditor.text("txt_fabb81350635", "100% natural vegetables, prepared and packed with care in Québec.");
      },
      get "how.3.title"() {
        return window.LyoEditor.text("txt_97512be3d08c", "Free shipping");
      },
      get "how.3.sub"() {
        return window.LyoEditor.text("txt_8f4ec6488bbf", "Straight to your door, anywhere in Québec.");
      },
      get "how.4.title"() {
        return window.LyoEditor.text("txt_0f1ee4d284c0", "Add it to meals");
      },
      get "how.4.sub"() {
        return window.LyoEditor.text("txt_01ef82154006", "Mix into food or give as a reward.");
      },
      get "how.5.title"() {
        return window.LyoEditor.text("txt_f18786d1830f", "Your dog asks for more");
      },
      get "how.5.sub"() {
        return window.LyoEditor.text("txt_6ac3e08ae0f7", "A simple way to add variety to every meal.");
      },
      get "trust.title"() {
        return window.LyoEditor.text("txt_91f942db0ee9", "Why trust LyoPup?");
      },
      get "trust.1.title"() {
        return window.LyoEditor.text("txt_4cf5115464a3", "Proudly Québécois");
      },
      get "trust.1.line"() {
        return window.LyoEditor.text("txt_c674fd4b4b86", "A local company built by dog lovers.");
      },
      get "trust.2.title"() {
        return window.LyoEditor.text("txt_4596e8d9c8ae", "Simple, transparent ingredients");
      },
      get "trust.2.line"() {
        return window.LyoEditor.text("txt_6741ba2fe505", "One vegetable per bag. Nothing else.");
      },
      get "trust.3.title"() {
        return window.LyoEditor.text("txt_af36b58ec20b", "Responsible sourcing");
      },
      get "trust.3.line"() {
        return window.LyoEditor.text("txt_45394ede3c52", "We favour quality vegetables from trusted growers.");
      },
      get "trust.4.title"() {
        return window.LyoEditor.text("txt_6566269822a1", "We remove the water, nothing else");
      },
      get "trust.4.line"() {
        return window.LyoEditor.text("txt_ac70e7aba427", "No high-heat cooking, no preservatives, no additives.");
      },
      get "trust.5.title"() {
        return window.LyoEditor.text("txt_e640712fcea5", "Prepared with care");
      },
      get "trust.5.line"() {
        return window.LyoEditor.text("txt_367f2f45553a", "Each bag is packed to deliver freshness and quality.");
      },
      get "trust.6.title"() {
        return window.LyoEditor.text("txt_2ab06a50eb0c", "Buy with confidence");
      },
      get "trust.6.line"() {
        return window.LyoEditor.text("txt_3f8cb11ba922", "Your dog loves it or your money back.");
      },
      get "faq.title"() {
        return window.LyoEditor.text("txt_3d1c1a80f97f", "Frequently asked questions");
      },
      get "faq.q0a"() {
        return window.LyoEditor.text("txt_6de07bb1fb22", "My dog doesn't eat vegetables.");
      },
      get "faq.a0a"() {
        return window.LyoEditor.text("txt_62a26e36f160", "That's the number one objection, and it's fair. Two answers: the crunch and concentrated taste are nothing like the raw vegetable he refused, and the Discovery box gives you all three flavours to find his. If he wants none of them, we refund you within 30 days.");
      },
      get "faq.q0b"() {
        return window.LyoEditor.text("txt_b6834c676f1c", "$13 for a bag of vegetables?");
      },
      get "faq.a0b"() {
        return window.LyoEditor.text("txt_9f04e5f823db", "It takes about 6 medium carrots to fill one bag. Freeze-drying removes the water. And a fresh vegetable is nearly 90% water. You pay for what's left: the whole vegetable, minus the water.");
      },
      get "faq.q1"() {
        return window.LyoEditor.text("txt_a452404b66ac", "One ingredient, really?");
      },
      get "faq.a1"() {
        return window.LyoEditor.text("txt_fae4a9fd52bf", "Yes. Each bag contains a single vegetable, freeze-dried. No preservatives, no dyes, no 'natural flavors.' You can read the label in one second.");
      },
      get "faq.q2"() {
        return window.LyoEditor.text("txt_d8ae9296ee60", "How many can I give per day?");
      },
      get "faq.a2"() {
        return window.LyoEditor.text("txt_ef8c8f23647e", "The general veterinary guideline: no more than about 10% of daily intake. One piece of carrot is around 2 to 3 calories, and a full bag is around 175. Count them like any other treat. When in doubt, talk to your vet.");
      },
      get "faq.q3"() {
        return window.LyoEditor.text("txt_be13ed6fefd9", "Is it good for puppies and senior dogs?");
      },
      get "faq.a3"() {
        return window.LyoEditor.text("txt_bba79d95c04e", "A freeze-dried vegetable suits most dogs, from puppy to senior. For a dog with a specific condition, ask your vet. The advantage of a single ingredient is that it's an easy question to answer.");
      },
      get "final.title"() {
        return window.LyoEditor.text("txt_c1a332e28841", "He loves it, or we refund you.");
      },
      get "final.cta"() {
        return window.LyoEditor.text("txt_495cdd3efd50", "Choose my box");
      },
      get "final.trust"() {
        return window.LyoEditor.text("txt_a4ccfe4c4593", "Free shipping · Satisfaction guaranteed");
      },
      get "email.placeholder"() {
        return window.LyoEditor.text("txt_8ccfd3bfd4c5", "Your email");
      },
      get "email.cta"() {
        return window.LyoEditor.text("txt_44a5ea2a2349", "Sign up");
      },
      get "email.sending"() {
        return window.LyoEditor.text("txt_4a3cbf9ccd4a", "One moment…");
      },
      get "email.success.title"() {
        return window.LyoEditor.text("txt_824166fad54d", "You're in!");
      },
      get "email.success.body"() {
        return window.LyoEditor.text("txt_0a41a8b004dd", "We'll send our news to your inbox.");
      },
      get "email.error"() {
        return window.LyoEditor.text("txt_783c7a7cb533", "Hmm, that didn't work. Please try again in a moment.");
      },
      get "email.invalid"() {
        return window.LyoEditor.text("txt_6a9e0922d5dc", "Please enter a valid email address.");
      },
      get "footer.signup.title"() {
        return window.LyoEditor.text("txt_bea25f05f7a1", "Get 10% off your first order");
      },
      get "footer.signup.placeholder"() {
        return window.LyoEditor.text("txt_b9a578e9875c", "Your email");
      },
      get "footer.signup.cta"() {
        return window.LyoEditor.text("txt_37b378659b75", "Sign up");
      },
      get "footer.col.help"() {
        return window.LyoEditor.text("txt_862790fcfaae", "Help");
      },
      get "footer.col.shop"() {
        return window.LyoEditor.text("txt_b346b914ccaa", "Our Boxes");
      },
      get "footer.faq"() {
        return window.LyoEditor.text("txt_fd2673eb88f9", "FAQ");
      },
      get "footer.contact"() {
        return window.LyoEditor.text("txt_83126326abba", "Contact");
      },
      get "footer.refund"() {
        return window.LyoEditor.text("txt_8b0e0e3cbd1e", "Refund");
      },
      get "footer.shipping"() {
        return window.LyoEditor.text("txt_9fc8166df32a", "Shipping");
      },
      get "footer.terms"() {
        return window.LyoEditor.text("txt_472a1ab3bae9", "Terms");
      },
      get "footer.rights"() {
        return window.LyoEditor.text("txt_22f3c3acecbc", "All rights reserved.");
      },
      get "footer.made"() {
        return window.LyoEditor.text("txt_ce47e346130f", "Made in Québec 🍁");
      },
      get "cart.label"() {
        return window.LyoEditor.text("txt_5ebdd3e44f1c", "Cart");
      },
      get "cart.title"() {
        return window.LyoEditor.text("txt_6e33bbf4ea47", "Your cart");
      },
      get "cart.empty"() {
        return window.LyoEditor.text("txt_3eb1360b29ea", "Your cart is empty.");
      },
      get "cart.empty.cta"() {
        return window.LyoEditor.text("txt_5c37cbf32413", "See the boxes");
      },
      get "cart.items"() {
        return window.LyoEditor.text("txt_25b67f5ef247", "items");
      },
      get "cart.item"() {
        return window.LyoEditor.text("txt_5bca78807fe4", "item");
      },
      get "cart.subtotal"() {
        return window.LyoEditor.text("txt_c0807f160a37", "Subtotal");
      },
      get "cart.shipping"() {
        return window.LyoEditor.text("txt_1c7a780888c6", "Free shipping included");
      },
      get "cart.checkout"() {
        return window.LyoEditor.text("txt_bf8a99649bd2", "Checkout");
      },
      get "cart.continue"() {
        return window.LyoEditor.text("txt_d261bffb0e3b", "Continue shopping");
      },
      get "cart.checkout.error.title"() {
        return window.LyoEditor.text("txt_954489ac341f", "Checkout window was blocked");
      },
      get "cart.checkout.error.body"() {
        return window.LyoEditor.text("txt_8854eba87a57", "Click the link below to complete your order. You can also copy the link and open it in a new tab.");
      },
      get "cart.checkout.error.link"() {
        return window.LyoEditor.text("txt_a368c3f5b65b", "Continue on Shopify");
      },
      get "cart.checkout.error.copy"() {
        return window.LyoEditor.text("txt_971b9bd03832", "Copy link");
      },
      get "cart.copied"() {
        return window.LyoEditor.text("txt_01853682b16e", "Copied");
      },
      get "cart.add.success"() {
        return window.LyoEditor.text("txt_ebe570275335", "Added to cart");
      },
      get "cart.add.error"() {
        return window.LyoEditor.text("txt_ce8acb4bb525", "Couldn't add to cart. In Shopify: check stock at the right location + Online Store / storefront publishing.");
      },
      get "cart.add.oos"() {
        return window.LyoEditor.text("txt_6f0c61b32997", "This box is out of stock.");
      },
      get "cart.add.throttled"() {
        return window.LyoEditor.text("txt_c09350543135", "Shopify is rate-limited (too many attempts). Wait 1–2 minutes, then try once.");
      },
      get "popup.badge"() {
        return "WELCOME OFFER";
      },
      get "popup.title"() {
        return window.LyoEditor.text("txt_561ecbd45786", "10% off your first box");
      },
      get "popup.body"() {
        return window.LyoEditor.text("txt_f58d059a31c7", "Let your dog discover treats made with a single vegetable, grown and freeze-dried in Quebec.\n\nEnter your email and receive your code instantly.");
      },
      get "popup.placeholder"() {
        return window.LyoEditor.text("txt_4367521d0f99", "Your email");
      },
      get "popup.cta"() {
        return window.LyoEditor.text("txt_70eb908f5c52", "Get my 10% off");
      },
      get "popup.thanks"() {
        return window.LyoEditor.text("txt_36925aafc48e", "Thanks! Here is your code:");
      },
      get "popup.dismiss"() {
        return window.LyoEditor.text("txt_1930d7ea6fab", "Continue without discount");
      },
      get "pdp.add"() {
        return window.LyoEditor.text("txt_8d58056381f0", "Add to cart");
      },
      get "pdp.qty"() {
        return window.LyoEditor.text("txt_50cc11e08108", "Quantity");
      },
      get "pdp.recommended"() {
        return window.LyoEditor.text("txt_ed80276d0050", "Recommended");
      },
      get "pdp.includes"() {
        return window.LyoEditor.text("txt_3cedc801a3fc", "What's in the box");
      },
      get "pdp.guarantee"() {
        return window.LyoEditor.text("txt_d630c29b92db", "Satisfaction guaranteed: your dog loves it or your money back.");
      },
      get "pdp.shipping"() {
        return window.LyoEditor.text("txt_c4cb5206eaed", "Free shipping across Québec.");
      },
      get "pdp.single"() {
        return window.LyoEditor.text("txt_3019cef9238b", "One ingredient.");
      },
      get "shop.title"() {
        return window.LyoEditor.text("txt_7f882be5295d", "Our boxes");
      },
      get "shop.subtitle"() {
        return window.LyoEditor.text("txt_e23a4b893f98", "No single bags online. Only boxes: better price, less packaging.");
      },
      get "story.eyebrow"() {
        return window.LyoEditor.text("txt_dc9624e3b7dc", "OUR MISSION");
      },
      get "story.title"() {
        return window.LyoEditor.text("txt_90c7ca4d1749", "Make every treat a healthier choice.");
      },
      get "story.body.1"() {
        return window.LyoEditor.text("txt_05b56e48ef81", "Our dogs are family. Treating them should be as good for them as it is satisfying to give.");
      },
      get "story.body.2"() {
        return window.LyoEditor.text("txt_294603133a76", "That's the conviction LyoPup was born from.");
      },
      get "story.body.3"() {
        return window.LyoEditor.text("txt_3e1df676d719", "We wanted to get back to basics: real vegetables, freeze-dried in Quebec to keep their taste and crunch. Each bag holds one ingredient, with no additives or preservatives.");
      },
      get "story.body.4"() {
        return window.LyoEditor.text("txt_05b26c6ec771", "Our mission is simple: give dogs a healthier treat they'll actually look forward to eating.");
      },
      get "story.body.5"() {
        return window.LyoEditor.text("txt_1d425e10c7c3", "Because you should never have to choose between treating them and taking care of them.");
      },
      get "story.cta"() {
        return window.LyoEditor.text("txt_7a60c08715cb", "DISCOVER LYOPUP");
      },
      get "contact.title"() {
        return window.LyoEditor.text("txt_54a572652c97", "Contact");
      },
      get "contact.body"() {
        return window.LyoEditor.text("txt_e0f490c847d6", "A question, a special order, a dog cuddle to share? Write to us.");
      },
      get "contact.email.label"() {
        return window.LyoEditor.text("txt_c0b023627289", "Email");
      },
      get "contact.name.label"() {
        return window.LyoEditor.text("txt_97da59d94d79", "Name");
      },
      get "contact.message.label"() {
        return window.LyoEditor.text("txt_e5c9e4b0e501", "Message");
      },
      get "contact.cta"() {
        return window.LyoEditor.text("txt_06b6a028592f", "Send");
      },
      get "contact.sent"() {
        return window.LyoEditor.text("txt_6438bcf7258f", "Message sent. Thank you!");
      },
      get "policy.refund.title"() {
        return window.LyoEditor.text("txt_e132283028f0", "Refund policy");
      },
      get "policy.refund.body"() {
        return window.LyoEditor.text("txt_300eac00c648", "If your dog doesn't love LyoPup, write to us within 30 days and we'll refund you in full. No paperwork, no return to ship back.");
      },
      get "policy.shipping.title"() {
        return window.LyoEditor.text("txt_799764cc3794", "Shipping");
      },
      get "policy.shipping.body"() {
        return window.LyoEditor.text("txt_4a9148e4556c", "Free shipping on every box, anywhere in Québec. Shipped in 1-2 business days from Montréal. Typical delivery: 2-5 business days.");
      },
      get "policy.terms.title"() {
        return window.LyoEditor.text("txt_c51d1b28d26a", "Terms of use");
      },
      get "policy.terms.body"() {
        return window.LyoEditor.text("txt_6495c79eae6c", "By using this site, you agree to our terms. Images, copy and the LyoPup mark are protected. Any questions, write to us.");
      },
      get "nf.title"() {
        return window.LyoEditor.text("txt_931c68e8f160", "Page not found");
      },
      get "nf.body"() {
        return window.LyoEditor.text("txt_056a8270701f", "This page ran off like a dog who spotted a squirrel.");
      },
      get "nf.cta"() {
        return window.LyoEditor.text("txt_f36bac8529c9", "Back home");
      }
    }
  },
  X1 = y.createContext(null),
  mj = ({
    children: e
  }) => {
    const [t, n] = y.useState(() => {
        const o = localStorage.getItem("lyopup-lang");
        return o === "en" || o === "fr" ? o : window.LyoShopify.config.lang || "fr";
      }),
      r = o => {
        n(o), localStorage.setItem("lyopup-lang", o), document.documentElement.lang = o;
      };
    y.useEffect(() => {
      document.documentElement.lang = t;
    }, [t]);
    const s = o => {
      var i, a;
      return (window.LyoShopify.config.translations?.[t]?.[o] || undefined) ?? ((i = Rf[t]) == null ? void 0 : i[o]) ?? ((a = Rf.fr) == null ? void 0 : a[o]) ?? o;
    };
    return p.jsx(X1.Provider, {
      value: {
        lang: t,
        setLang: r,
        t: s
      },
      children: e
    });
  },
  Me = () => {
    const e = y.useContext(X1);
    return e || {
      lang: "fr",
      setLang: () => {},
      t: t => {
        var n;
        return ((n = Rf.fr) == null ? void 0 : n[t]) ?? t;
      }
    };
  },
  Ep = y.createContext({});
function Cp(e) {
  const t = y.useRef(null);
  return t.current === null && (t.current = e()), t.current;
}
const gj = typeof window < "u",
  Z1 = gj ? y.useLayoutEffect : y.useEffect,
  Vu = y.createContext(null);
function Tp(e, t) {
  e.indexOf(t) === -1 && e.push(t);
}
function Jl(e, t) {
  const n = e.indexOf(t);
  n > -1 && e.splice(n, 1);
}
const gn = (e, t, n) => n > t ? t : n < e ? e : n;
let Bu = () => {},
  So = () => {};
const Rr = {},
  J1 = e => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(e),
  eb = e => typeof e == "object" && e !== null,
  tb = e => /^0[^.\s]+$/u.test(e);
function nb(e) {
  let t;
  return () => (t === void 0 && (t = e()), t);
}
const At = e => e,
  la = (...e) => e.reduce((t, n) => r => n(t(r))),
  $i = (e, t, n) => {
    const r = t - e;
    return r ? (n - e) / r : 1;
  };
class Pp {
  constructor() {
    this.subscriptions = [];
  }
  add(t) {
    return Tp(this.subscriptions, t), () => Jl(this.subscriptions, t);
  }
  notify(t, n, r) {
    const s = this.subscriptions.length;
    if (s) if (s === 1) this.subscriptions[0](t, n, r);else for (let o = 0; o < s; o++) {
      const i = this.subscriptions[o];
      i && i(t, n, r);
    }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
const dt = e => e * 1e3,
  Rt = e => e / 1e3,
  rb = (e, t) => t ? e * (1e3 / t) : 0,
  sb = (e, t, n) => (((1 - 3 * n + 3 * t) * e + (3 * n - 6 * t)) * e + 3 * t) * e,
  yj = 1e-7,
  vj = 12;
function xj(e, t, n, r, s) {
  let o,
    i,
    a = 0;
  do i = t + (n - t) / 2, o = sb(i, r, s) - e, o > 0 ? n = i : t = i; while (Math.abs(o) > yj && ++a < vj);
  return i;
}
function ua(e, t, n, r) {
  if (e === t && n === r) return At;
  const s = o => xj(o, 0, 1, e, n);
  return o => o === 0 || o === 1 ? o : sb(s(o), t, r);
}
const ob = e => t => t <= 0.5 ? e(2 * t) / 2 : (2 - e(2 * (1 - t))) / 2,
  ib = e => t => 1 - e(1 - t),
  ab = ua(0.33, 1.53, 0.69, 0.99),
  kp = ib(ab),
  lb = ob(kp),
  ub = e => e >= 1 ? 1 : (e *= 2) < 1 ? 0.5 * kp(e) : 0.5 * (2 - Math.pow(2, -10 * (e - 1))),
  Rp = e => 1 - Math.sin(Math.acos(e)),
  cb = ib(Rp),
  db = ob(Rp),
  wj = ua(0.42, 0, 1, 1),
  bj = ua(0, 0, 0.58, 1),
  fb = ua(0.42, 0, 0.58, 1),
  Sj = e => Array.isArray(e) && typeof e[0] != "number",
  hb = e => Array.isArray(e) && typeof e[0] == "number",
  oy = {
    linear: At,
    easeIn: wj,
    easeInOut: fb,
    easeOut: bj,
    circIn: Rp,
    circInOut: db,
    circOut: cb,
    backIn: kp,
    backInOut: lb,
    backOut: ab,
    anticipate: ub
  },
  Ej = e => typeof e == "string",
  iy = e => {
    if (hb(e)) {
      So(e.length === 4, "Cubic bezier arrays must contain four numerical values.", "cubic-bezier-length");
      const [t, n, r, s] = e;
      return ua(t, n, r, s);
    } else if (Ej(e)) return So(oy[e] !== void 0, `Invalid easing type '${e}'`, "invalid-easing-type"), oy[e];
    return e;
  },
  Va = ["setup", "read", "resolveKeyframes", "preUpdate", "update", "preRender", "render", "postRender"],
  ay = {
    value: null,
    addProjectionMetrics: null
  };
function Cj(e, t) {
  let n = new Set(),
    r = new Set(),
    s = !1,
    o = !1;
  const i = new WeakSet();
  let a = {
      delta: 0,
      timestamp: 0,
      isProcessing: !1
    },
    l = 0;
  function u(c) {
    i.has(c) && (d.schedule(c), e()), l++, c(a);
  }
  const d = {
    schedule: (c, f = !1, h = !1) => {
      const m = h && s ? n : r;
      return f && i.add(c), m.add(c), c;
    },
    cancel: c => {
      r.delete(c), i.delete(c);
    },
    process: c => {
      if (a = c, s) {
        o = !0;
        return;
      }
      s = !0;
      const f = n;
      n = r, r = f, n.forEach(u), t && ay.value && ay.value.frameloop[t].push(l), l = 0, n.clear(), s = !1, o && (o = !1, d.process(c));
    }
  };
  return d;
}
const Tj = 40;
function pb(e, t) {
  let n = !1,
    r = !0;
  const s = {
      delta: 0,
      timestamp: 0,
      isProcessing: !1
    },
    o = () => n = !0,
    i = Va.reduce((b, S) => (b[S] = Cj(o, t ? S : void 0), b), {}),
    {
      setup: a,
      read: l,
      resolveKeyframes: u,
      preUpdate: d,
      update: c,
      preRender: f,
      render: h,
      postRender: w
    } = i,
    m = () => {
      const b = Rr.useManualTiming,
        S = b ? s.timestamp : performance.now();
      n = !1, b || (s.delta = r ? 1e3 / 60 : Math.max(Math.min(S - s.timestamp, Tj), 1)), s.timestamp = S, s.isProcessing = !0, a.process(s), l.process(s), u.process(s), d.process(s), c.process(s), f.process(s), h.process(s), w.process(s), s.isProcessing = !1, n && t && (r = !1, e(m));
    },
    x = () => {
      n = !0, r = !0, s.isProcessing || e(m);
    };
  return {
    schedule: Va.reduce((b, S) => {
      const E = i[S];
      return b[S] = (P, T = !1, k = !1) => (n || x(), E.schedule(P, T, k)), b;
    }, {}),
    cancel: b => {
      for (let S = 0; S < Va.length; S++) i[Va[S]].cancel(b);
    },
    state: s,
    steps: i
  };
}
const {
  schedule: le,
  cancel: Nr,
  state: Fe,
  steps: Dc
} = pb(typeof requestAnimationFrame < "u" ? requestAnimationFrame : At, !0);
let ul;
function Pj() {
  ul = void 0;
}
const Xe = {
    now: () => (ul === void 0 && Xe.set(Fe.isProcessing || Rr.useManualTiming ? Fe.timestamp : performance.now()), ul),
    set: e => {
      ul = e, queueMicrotask(Pj);
    }
  },
  mb = e => t => typeof t == "string" && t.startsWith(e),
  gb = mb("--"),
  kj = mb("var(--"),
  Np = e => kj(e) ? Rj.test(e.split("/*")[0].trim()) : !1,
  Rj = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu;
function ly(e) {
  return typeof e != "string" ? !1 : e.split("/*")[0].includes("var(--");
}
const Lo = {
    test: e => typeof e == "number",
    parse: parseFloat,
    transform: e => e
  },
  Ui = {
    ...Lo,
    transform: e => gn(0, 1, e)
  },
  Ba = {
    ...Lo,
    default: 1
  },
  pi = e => Math.round(e * 1e5) / 1e5,
  Ap = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
function Nj(e) {
  return e == null;
}
const Aj = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu,
  jp = (e, t) => n => !!(typeof n == "string" && Aj.test(n) && n.startsWith(e) || t && !Nj(n) && Object.prototype.hasOwnProperty.call(n, t)),
  yb = (e, t, n) => r => {
    if (typeof r != "string") return r;
    const [s, o, i, a] = r.match(Ap);
    return {
      [e]: parseFloat(s),
      [t]: parseFloat(o),
      [n]: parseFloat(i),
      alpha: a !== void 0 ? parseFloat(a) : 1
    };
  },
  jj = e => gn(0, 255, e),
  Ic = {
    ...Lo,
    transform: e => Math.round(jj(e))
  },
  Hr = {
    test: jp("rgb", "red"),
    parse: yb("red", "green", "blue"),
    transform: ({
      red: e,
      green: t,
      blue: n,
      alpha: r = 1
    }) => "rgba(" + Ic.transform(e) + ", " + Ic.transform(t) + ", " + Ic.transform(n) + ", " + pi(Ui.transform(r)) + ")"
  };
function Mj(e) {
  let t = "",
    n = "",
    r = "",
    s = "";
  return e.length > 5 ? (t = e.substring(1, 3), n = e.substring(3, 5), r = e.substring(5, 7), s = e.substring(7, 9)) : (t = e.substring(1, 2), n = e.substring(2, 3), r = e.substring(3, 4), s = e.substring(4, 5), t += t, n += n, r += r, s += s), {
    red: parseInt(t, 16),
    green: parseInt(n, 16),
    blue: parseInt(r, 16),
    alpha: s ? parseInt(s, 16) / 255 : 1
  };
}
const Nf = {
    test: jp("#"),
    parse: Mj,
    transform: Hr.transform
  },
  ca = e => ({
    test: t => typeof t == "string" && t.endsWith(e) && t.split(" ").length === 1,
    parse: parseFloat,
    transform: t => `${t}${e}`
  }),
  wn = ca("deg"),
  hn = ca("%"),
  B = ca("px"),
  Oj = ca("vh"),
  Lj = ca("vw"),
  uy = {
    ...hn,
    parse: e => hn.parse(e) / 100,
    transform: e => hn.transform(e * 100)
  },
  Vs = {
    test: jp("hsl", "hue"),
    parse: yb("hue", "saturation", "lightness"),
    transform: ({
      hue: e,
      saturation: t,
      lightness: n,
      alpha: r = 1
    }) => "hsla(" + Math.round(e) + ", " + hn.transform(pi(t)) + ", " + hn.transform(pi(n)) + ", " + pi(Ui.transform(r)) + ")"
  },
  Pe = {
    test: e => Hr.test(e) || Nf.test(e) || Vs.test(e),
    parse: e => Hr.test(e) ? Hr.parse(e) : Vs.test(e) ? Vs.parse(e) : Nf.parse(e),
    transform: e => typeof e == "string" ? e : e.hasOwnProperty("red") ? Hr.transform(e) : Vs.transform(e),
    getAnimatableNone: e => {
      const t = Pe.parse(e);
      return t.alpha = 0, Pe.transform(t);
    }
  },
  Dj = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
function Ij(e) {
  var t, n;
  return isNaN(e) && typeof e == "string" && (((t = e.match(Ap)) == null ? void 0 : t.length) || 0) + (((n = e.match(Dj)) == null ? void 0 : n.length) || 0) > 0;
}
const vb = "number",
  xb = "color",
  Fj = "var",
  _j = "var(",
  cy = "${}",
  Vj = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function Eo(e) {
  const t = e.toString(),
    n = [],
    r = {
      color: [],
      number: [],
      var: []
    },
    s = [];
  let o = 0;
  const a = t.replace(Vj, l => (Pe.test(l) ? (r.color.push(o), s.push(xb), n.push(Pe.parse(l))) : l.startsWith(_j) ? (r.var.push(o), s.push(Fj), n.push(l)) : (r.number.push(o), s.push(vb), n.push(parseFloat(l))), ++o, cy)).split(cy);
  return {
    values: n,
    split: a,
    indexes: r,
    types: s
  };
}
function Bj(e) {
  return Eo(e).values;
}
function wb({
  split: e,
  types: t
}) {
  const n = e.length;
  return r => {
    let s = "";
    for (let o = 0; o < n; o++) if (s += e[o], r[o] !== void 0) {
      const i = t[o];
      i === vb ? s += pi(r[o]) : i === xb ? s += Pe.transform(r[o]) : s += r[o];
    }
    return s;
  };
}
function zj(e) {
  return wb(Eo(e));
}
const $j = e => typeof e == "number" ? 0 : Pe.test(e) ? Pe.getAnimatableNone(e) : e,
  Uj = (e, t) => typeof e == "number" ? t != null && t.trim().endsWith("/") ? e : 0 : $j(e);
function Wj(e) {
  const t = Eo(e);
  return wb(t)(t.values.map((r, s) => Uj(r, t.split[s])));
}
const Kt = {
  test: Ij,
  parse: Bj,
  createTransformer: zj,
  getAnimatableNone: Wj
};
function Fc(e, t, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + (t - e) * 6 * n : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
}
function Hj({
  hue: e,
  saturation: t,
  lightness: n,
  alpha: r
}) {
  e /= 360, t /= 100, n /= 100;
  let s = 0,
    o = 0,
    i = 0;
  if (!t) s = o = i = n;else {
    const a = n < 0.5 ? n * (1 + t) : n + t - n * t,
      l = 2 * n - a;
    s = Fc(l, a, e + 1 / 3), o = Fc(l, a, e), i = Fc(l, a, e - 1 / 3);
  }
  return {
    red: Math.round(s * 255),
    green: Math.round(o * 255),
    blue: Math.round(i * 255),
    alpha: r
  };
}
function eu(e, t) {
  return n => n > 0 ? t : e;
}
const ae = (e, t, n) => e + (t - e) * n,
  _c = (e, t, n) => {
    const r = e * e,
      s = n * (t * t - r) + r;
    return s < 0 ? 0 : Math.sqrt(s);
  },
  qj = [Nf, Hr, Vs],
  Kj = e => qj.find(t => t.test(e));
function dy(e) {
  const t = Kj(e);
  if (Bu(!!t, `'${e}' is not an animatable color. Use the equivalent color code instead.`, "color-not-animatable"), !t) return !1;
  let n = t.parse(e);
  return t === Vs && (n = Hj(n)), n;
}
const fy = (e, t) => {
    const n = dy(e),
      r = dy(t);
    if (!n || !r) return eu(e, t);
    const s = {
      ...n
    };
    return o => (s.red = _c(n.red, r.red, o), s.green = _c(n.green, r.green, o), s.blue = _c(n.blue, r.blue, o), s.alpha = ae(n.alpha, r.alpha, o), Hr.transform(s));
  },
  Af = new Set(["none", "hidden"]);
function Qj(e, t) {
  return Af.has(e) ? n => n <= 0 ? e : t : n => n >= 1 ? t : e;
}
function Gj(e, t) {
  return n => ae(e, t, n);
}
function Mp(e) {
  return typeof e == "number" ? Gj : typeof e == "string" ? Np(e) ? eu : Pe.test(e) ? fy : Zj : Array.isArray(e) ? bb : typeof e == "object" ? Pe.test(e) ? fy : Yj : eu;
}
function bb(e, t) {
  const n = [...e],
    r = n.length,
    s = e.map((o, i) => Mp(o)(o, t[i]));
  return o => {
    for (let i = 0; i < r; i++) n[i] = s[i](o);
    return n;
  };
}
function Yj(e, t) {
  const n = {
      ...e,
      ...t
    },
    r = {};
  for (const s in n) e[s] !== void 0 && t[s] !== void 0 && (r[s] = Mp(e[s])(e[s], t[s]));
  return s => {
    for (const o in r) n[o] = r[o](s);
    return n;
  };
}
function Xj(e, t) {
  const n = [],
    r = {
      color: 0,
      var: 0,
      number: 0
    };
  for (let s = 0; s < t.values.length; s++) {
    const o = t.types[s],
      i = e.indexes[o][r[o]],
      a = e.values[i] ?? 0;
    n[s] = a, r[o]++;
  }
  return n;
}
const Zj = (e, t) => {
  const n = Kt.createTransformer(t),
    r = Eo(e),
    s = Eo(t);
  return r.indexes.var.length === s.indexes.var.length && r.indexes.color.length === s.indexes.color.length && r.indexes.number.length >= s.indexes.number.length ? Af.has(e) && !s.values.length || Af.has(t) && !r.values.length ? Qj(e, t) : la(bb(Xj(r, s), s.values), n) : (Bu(!0, `Complex values '${e}' and '${t}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`, "complex-values-different"), eu(e, t));
};
function Sb(e, t, n) {
  return typeof e == "number" && typeof t == "number" && typeof n == "number" ? ae(e, t, n) : Mp(e)(e, t);
}
const Jj = e => {
    const t = ({
      timestamp: n
    }) => e(n);
    return {
      start: (n = !0) => le.update(t, n),
      stop: () => Nr(t),
      now: () => Fe.isProcessing ? Fe.timestamp : Xe.now()
    };
  },
  Eb = (e, t, n = 10) => {
    let r = "";
    const s = Math.max(Math.round(t / n), 2);
    for (let o = 0; o < s; o++) r += Math.round(e(o / (s - 1)) * 1e4) / 1e4 + ", ";
    return `linear(${r.substring(0, r.length - 2)})`;
  },
  tu = 2e4;
function Op(e) {
  let t = 0;
  const n = 50;
  let r = e.next(t);
  for (; !r.done && t < tu;) t += n, r = e.next(t);
  return t >= tu ? 1 / 0 : t;
}
function eM(e, t = 100, n) {
  const r = n({
      ...e,
      keyframes: [0, t]
    }),
    s = Math.min(Op(r), tu);
  return {
    type: "keyframes",
    ease: o => r.next(s * o).value / t,
    duration: Rt(s)
  };
}
const ye = {
  stiffness: 100,
  damping: 10,
  mass: 1,
  velocity: 0,
  duration: 800,
  bounce: 0.3,
  visualDuration: 0.3,
  restSpeed: {
    granular: 0.01,
    default: 2
  },
  restDelta: {
    granular: 0.005,
    default: 0.5
  },
  minDuration: 0.01,
  maxDuration: 10,
  minDamping: 0.05,
  maxDamping: 1
};
function jf(e, t) {
  return e * Math.sqrt(1 - t * t);
}
const tM = 12;
function nM(e, t, n) {
  let r = n;
  for (let s = 1; s < tM; s++) r = r - e(r) / t(r);
  return r;
}
const Vc = 0.001;
function rM({
  duration: e = ye.duration,
  bounce: t = ye.bounce,
  velocity: n = ye.velocity,
  mass: r = ye.mass
}) {
  let s, o;
  Bu(e <= dt(ye.maxDuration), "Spring duration must be 10 seconds or less", "spring-duration-limit");
  let i = 1 - t;
  i = gn(ye.minDamping, ye.maxDamping, i), e = gn(ye.minDuration, ye.maxDuration, Rt(e)), i < 1 ? (s = u => {
    const d = u * i,
      c = d * e,
      f = d - n,
      h = jf(u, i),
      w = Math.exp(-c);
    return Vc - f / h * w;
  }, o = u => {
    const c = u * i * e,
      f = c * n + n,
      h = Math.pow(i, 2) * Math.pow(u, 2) * e,
      w = Math.exp(-c),
      m = jf(Math.pow(u, 2), i);
    return (-s(u) + Vc > 0 ? -1 : 1) * ((f - h) * w) / m;
  }) : (s = u => {
    const d = Math.exp(-u * e),
      c = (u - n) * e + 1;
    return -Vc + d * c;
  }, o = u => {
    const d = Math.exp(-u * e),
      c = (n - u) * (e * e);
    return d * c;
  });
  const a = 5 / e,
    l = nM(s, o, a);
  if (e = dt(e), isNaN(l)) return {
    stiffness: ye.stiffness,
    damping: ye.damping,
    duration: e
  };
  {
    const u = Math.pow(l, 2) * r;
    return {
      stiffness: u,
      damping: i * 2 * Math.sqrt(r * u),
      duration: e
    };
  }
}
const sM = ["duration", "bounce"],
  oM = ["stiffness", "damping", "mass"];
function hy(e, t) {
  return t.some(n => e[n] !== void 0);
}
function iM(e) {
  let t = {
    velocity: ye.velocity,
    stiffness: ye.stiffness,
    damping: ye.damping,
    mass: ye.mass,
    isResolvedFromDuration: !1,
    ...e
  };
  if (!hy(e, oM) && hy(e, sM)) if (t.velocity = 0, e.visualDuration) {
    const n = e.visualDuration,
      r = 2 * Math.PI / (n * 1.2),
      s = r * r,
      o = 2 * gn(0.05, 1, 1 - (e.bounce || 0)) * Math.sqrt(s);
    t = {
      ...t,
      mass: ye.mass,
      stiffness: s,
      damping: o
    };
  } else {
    const n = rM({
      ...e,
      velocity: 0
    });
    t = {
      ...t,
      ...n,
      mass: ye.mass
    }, t.isResolvedFromDuration = !0;
  }
  return t;
}
function nu(e = ye.visualDuration, t = ye.bounce) {
  const n = typeof e != "object" ? {
    visualDuration: e,
    keyframes: [0, 1],
    bounce: t
  } : e;
  let {
    restSpeed: r,
    restDelta: s
  } = n;
  const o = n.keyframes[0],
    i = n.keyframes[n.keyframes.length - 1],
    a = {
      done: !1,
      value: o
    },
    {
      stiffness: l,
      damping: u,
      mass: d,
      duration: c,
      velocity: f,
      isResolvedFromDuration: h
    } = iM({
      ...n,
      velocity: -Rt(n.velocity || 0)
    }),
    w = f || 0,
    m = u / (2 * Math.sqrt(l * d)),
    x = i - o,
    g = Rt(Math.sqrt(l / d)),
    v = Math.abs(x) < 5;
  r || (r = v ? ye.restSpeed.granular : ye.restSpeed.default), s || (s = v ? ye.restDelta.granular : ye.restDelta.default);
  let b, S, E, P, T, k;
  if (m < 1) E = jf(g, m), P = (w + m * g * x) / E, b = R => {
    const I = Math.exp(-m * g * R);
    return i - I * (P * Math.sin(E * R) + x * Math.cos(E * R));
  }, T = m * g * P + x * E, k = m * g * x - P * E, S = R => Math.exp(-m * g * R) * (T * Math.sin(E * R) + k * Math.cos(E * R));else if (m === 1) {
    b = I => i - Math.exp(-g * I) * (x + (w + g * x) * I);
    const R = w + g * x;
    S = I => Math.exp(-g * I) * (g * R * I - w);
  } else {
    const R = g * Math.sqrt(m * m - 1);
    b = D => {
      const q = Math.exp(-m * g * D),
        z = Math.min(R * D, 300);
      return i - q * ((w + m * g * x) * Math.sinh(z) + R * x * Math.cosh(z)) / R;
    };
    const I = (w + m * g * x) / R,
      O = m * g * I - x * R,
      U = m * g * x - I * R;
    S = D => {
      const q = Math.exp(-m * g * D),
        z = Math.min(R * D, 300);
      return q * (O * Math.sinh(z) + U * Math.cosh(z));
    };
  }
  const A = {
    calculatedDuration: h && c || null,
    velocity: R => dt(S(R)),
    next: R => {
      if (!h && m < 1) {
        const O = Math.exp(-m * g * R),
          U = Math.sin(E * R),
          D = Math.cos(E * R),
          q = i - O * (P * U + x * D),
          z = dt(O * (T * U + k * D));
        return a.done = Math.abs(z) <= r && Math.abs(i - q) <= s, a.value = a.done ? i : q, a;
      }
      const I = b(R);
      if (h) a.done = R >= c;else {
        const O = dt(S(R));
        a.done = Math.abs(O) <= r && Math.abs(i - I) <= s;
      }
      return a.value = a.done ? i : I, a;
    },
    toString: () => {
      const R = Math.min(Op(A), tu),
        I = Eb(O => A.next(R * O).value, R, 30);
      return R + "ms " + I;
    },
    toTransition: () => {}
  };
  return A;
}
nu.applyToOptions = e => {
  const t = eM(e, 100, nu);
  return e.ease = t.ease, e.duration = dt(t.duration), e.type = "keyframes", e;
};
const aM = 5;
function Cb(e, t, n) {
  const r = Math.max(t - aM, 0);
  return rb(n - e(r), t - r);
}
function Mf({
  keyframes: e,
  velocity: t = 0,
  power: n = 0.8,
  timeConstant: r = 325,
  bounceDamping: s = 10,
  bounceStiffness: o = 500,
  modifyTarget: i,
  min: a,
  max: l,
  restDelta: u = 0.5,
  restSpeed: d
}) {
  const c = e[0],
    f = {
      done: !1,
      value: c
    },
    h = k => a !== void 0 && k < a || l !== void 0 && k > l,
    w = k => a === void 0 ? l : l === void 0 || Math.abs(a - k) < Math.abs(l - k) ? a : l;
  let m = n * t;
  const x = c + m,
    g = i === void 0 ? x : i(x);
  g !== x && (m = g - c);
  const v = k => -m * Math.exp(-k / r),
    b = k => g + v(k),
    S = k => {
      const A = v(k),
        R = b(k);
      f.done = Math.abs(A) <= u, f.value = f.done ? g : R;
    };
  let E, P;
  const T = k => {
    h(f.value) && (E = k, P = nu({
      keyframes: [f.value, w(f.value)],
      velocity: Cb(b, k, f.value),
      damping: s,
      stiffness: o,
      restDelta: u,
      restSpeed: d
    }));
  };
  return T(0), {
    calculatedDuration: null,
    next: k => {
      let A = !1;
      return !P && E === void 0 && (A = !0, S(k), T(k)), E !== void 0 && k >= E ? P.next(k - E) : (!A && S(k), f);
    }
  };
}
function lM(e, t, n) {
  const r = [],
    s = n || Rr.mix || Sb,
    o = e.length - 1;
  for (let i = 0; i < o; i++) {
    let a = s(e[i], e[i + 1]);
    if (t) {
      const l = Array.isArray(t) ? t[i] || At : t;
      a = la(l, a);
    }
    r.push(a);
  }
  return r;
}
function uM(e, t, {
  clamp: n = !0,
  ease: r,
  mixer: s
} = {}) {
  const o = e.length;
  if (So(o === t.length, "Both input and output ranges must be the same length", "range-length"), o === 1) return () => t[0];
  if (o === 2 && t[0] === t[1]) return () => t[1];
  const i = e[0] === e[1];
  e[0] > e[o - 1] && (e = [...e].reverse(), t = [...t].reverse());
  const a = lM(t, r, s),
    l = a.length,
    u = d => {
      if (i && d < e[0]) return t[0];
      let c = 0;
      if (l > 1) for (; c < e.length - 2 && !(d < e[c + 1]); c++);
      const f = $i(e[c], e[c + 1], d);
      return a[c](f);
    };
  return n ? d => u(gn(e[0], e[o - 1], d)) : u;
}
function cM(e, t) {
  const n = e[e.length - 1];
  for (let r = 1; r <= t; r++) {
    const s = $i(0, t, r);
    e.push(ae(n, 1, s));
  }
}
function dM(e) {
  const t = [0];
  return cM(t, e.length - 1), t;
}
function fM(e, t) {
  return e.map(n => n * t);
}
function hM(e, t) {
  return e.map(() => t || fb).splice(0, e.length - 1);
}
function mi({
  duration: e = 300,
  keyframes: t,
  times: n,
  ease: r = "easeInOut"
}) {
  const s = Sj(r) ? r.map(iy) : iy(r),
    o = {
      done: !1,
      value: t[0]
    },
    i = fM(n && n.length === t.length ? n : dM(t), e),
    a = uM(i, t, {
      ease: Array.isArray(s) ? s : hM(t, s)
    });
  return {
    calculatedDuration: e,
    next: l => (o.value = a(l), o.done = l >= e, o)
  };
}
const pM = e => e !== null;
function zu(e, {
  repeat: t,
  repeatType: n = "loop"
}, r, s = 1) {
  const o = e.filter(pM),
    a = s < 0 || t && n !== "loop" && t % 2 === 1 ? 0 : o.length - 1;
  return !a || r === void 0 ? o[a] : r;
}
const mM = {
  decay: Mf,
  inertia: Mf,
  tween: mi,
  keyframes: mi,
  spring: nu
};
function Tb(e) {
  typeof e.type == "string" && (e.type = mM[e.type]);
}
class Lp {
  constructor() {
    this.updateFinished();
  }
  get finished() {
    return this._finished;
  }
  updateFinished() {
    this._finished = new Promise(t => {
      this.resolve = t;
    });
  }
  notifyFinished() {
    this.resolve();
  }
  then(t, n) {
    return this.finished.then(t, n);
  }
}
const gM = e => e / 100;
class ru extends Lp {
  constructor(t) {
    super(), this.state = "idle", this.startTime = null, this.isStopped = !1, this.currentTime = 0, this.holdTime = null, this.playbackSpeed = 1, this.delayState = {
      done: !1,
      value: void 0
    }, this.stop = () => {
      var r, s;
      const {
        motionValue: n
      } = this.options;
      n && n.updatedAt !== Xe.now() && this.tick(Xe.now()), this.isStopped = !0, this.state !== "idle" && (this.teardown(), (s = (r = this.options).onStop) == null || s.call(r));
    }, this.options = t, this.initAnimation(), this.play(), t.autoplay === !1 && this.pause();
  }
  initAnimation() {
    const {
      options: t
    } = this;
    Tb(t);
    const {
      type: n = mi,
      repeat: r = 0,
      repeatDelay: s = 0,
      repeatType: o,
      velocity: i = 0
    } = t;
    let {
      keyframes: a
    } = t;
    const l = n || mi;
    l !== mi && typeof a[0] != "number" && (this.mixKeyframes = la(gM, Sb(a[0], a[1])), a = [0, 100]);
    const u = l({
      ...t,
      keyframes: a
    });
    o === "mirror" && (this.mirroredGenerator = l({
      ...t,
      keyframes: [...a].reverse(),
      velocity: -i
    })), u.calculatedDuration === null && (u.calculatedDuration = Op(u));
    const {
      calculatedDuration: d
    } = u;
    this.calculatedDuration = d, this.resolvedDuration = d + s, this.totalDuration = this.resolvedDuration * (r + 1) - s, this.generator = u;
  }
  updateTime(t) {
    const n = Math.round(t - this.startTime) * this.playbackSpeed;
    this.holdTime !== null ? this.currentTime = this.holdTime : this.currentTime = n;
  }
  tick(t, n = !1) {
    const {
      generator: r,
      totalDuration: s,
      mixKeyframes: o,
      mirroredGenerator: i,
      resolvedDuration: a,
      calculatedDuration: l
    } = this;
    if (this.startTime === null) return r.next(0);
    const {
      delay: u = 0,
      keyframes: d,
      repeat: c,
      repeatType: f,
      repeatDelay: h,
      type: w,
      onUpdate: m,
      finalKeyframe: x
    } = this.options;
    this.speed > 0 ? this.startTime = Math.min(this.startTime, t) : this.speed < 0 && (this.startTime = Math.min(t - s / this.speed, this.startTime)), n ? this.currentTime = t : this.updateTime(t);
    const g = this.currentTime - u * (this.playbackSpeed >= 0 ? 1 : -1),
      v = this.playbackSpeed >= 0 ? g < 0 : g > s;
    this.currentTime = Math.max(g, 0), this.state === "finished" && this.holdTime === null && (this.currentTime = s);
    let b = this.currentTime,
      S = r;
    if (c) {
      const k = Math.min(this.currentTime, s) / a;
      let A = Math.floor(k),
        R = k % 1;
      !R && k >= 1 && (R = 1), R === 1 && A--, A = Math.min(A, c + 1), !!(A % 2) && (f === "reverse" ? (R = 1 - R, h && (R -= h / a)) : f === "mirror" && (S = i)), b = gn(0, 1, R) * a;
    }
    let E;
    v ? (this.delayState.value = d[0], E = this.delayState) : E = S.next(b), o && !v && (E.value = o(E.value));
    let {
      done: P
    } = E;
    !v && l !== null && (P = this.playbackSpeed >= 0 ? this.currentTime >= s : this.currentTime <= 0);
    const T = this.holdTime === null && (this.state === "finished" || this.state === "running" && P);
    return T && w !== Mf && (E.value = zu(d, this.options, x, this.speed)), m && m(E.value), T && this.finish(), E;
  }
  then(t, n) {
    return this.finished.then(t, n);
  }
  get duration() {
    return Rt(this.calculatedDuration);
  }
  get iterationDuration() {
    const {
      delay: t = 0
    } = this.options || {};
    return this.duration + Rt(t);
  }
  get time() {
    return Rt(this.currentTime);
  }
  set time(t) {
    t = dt(t), this.currentTime = t, this.startTime === null || this.holdTime !== null || this.playbackSpeed === 0 ? this.holdTime = t : this.driver && (this.startTime = this.driver.now() - t / this.playbackSpeed), this.driver ? this.driver.start(!1) : (this.startTime = 0, this.state = "paused", this.holdTime = t, this.tick(t));
  }
  getGeneratorVelocity() {
    const t = this.currentTime;
    if (t <= 0) return this.options.velocity || 0;
    if (this.generator.velocity) return this.generator.velocity(t);
    const n = this.generator.next(t).value;
    return Cb(r => this.generator.next(r).value, t, n);
  }
  get speed() {
    return this.playbackSpeed;
  }
  set speed(t) {
    const n = this.playbackSpeed !== t;
    n && this.driver && this.updateTime(Xe.now()), this.playbackSpeed = t, n && this.driver && (this.time = Rt(this.currentTime));
  }
  play() {
    var s, o;
    if (this.isStopped) return;
    const {
      driver: t = Jj,
      startTime: n
    } = this.options;
    this.driver || (this.driver = t(i => this.tick(i))), (o = (s = this.options).onPlay) == null || o.call(s);
    const r = this.driver.now();
    this.state === "finished" ? (this.updateFinished(), this.startTime = r) : this.holdTime !== null ? this.startTime = r - this.holdTime : this.startTime || (this.startTime = n ?? r), this.state === "finished" && this.speed < 0 && (this.startTime += this.calculatedDuration), this.holdTime = null, this.state = "running", this.driver.start();
  }
  pause() {
    this.state = "paused", this.updateTime(Xe.now()), this.holdTime = this.currentTime;
  }
  complete() {
    this.state !== "running" && this.play(), this.state = "finished", this.holdTime = null;
  }
  finish() {
    var t, n;
    this.notifyFinished(), this.teardown(), this.state = "finished", (n = (t = this.options).onComplete) == null || n.call(t);
  }
  cancel() {
    var t, n;
    this.holdTime = null, this.startTime = 0, this.tick(0), this.teardown(), (n = (t = this.options).onCancel) == null || n.call(t);
  }
  teardown() {
    this.state = "idle", this.stopDriver(), this.startTime = this.holdTime = null;
  }
  stopDriver() {
    this.driver && (this.driver.stop(), this.driver = void 0);
  }
  sample(t) {
    return this.startTime = 0, this.tick(t, !0);
  }
  attachTimeline(t) {
    var n;
    return this.options.allowFlatten && (this.options.type = "keyframes", this.options.ease = "linear", this.initAnimation()), (n = this.driver) == null || n.stop(), t.observe(this);
  }
}
function yM(e) {
  for (let t = 1; t < e.length; t++) e[t] ?? (e[t] = e[t - 1]);
}
const qr = e => e * 180 / Math.PI,
  Of = e => {
    const t = qr(Math.atan2(e[1], e[0]));
    return Lf(t);
  },
  vM = {
    x: 4,
    y: 5,
    translateX: 4,
    translateY: 5,
    scaleX: 0,
    scaleY: 3,
    scale: e => (Math.abs(e[0]) + Math.abs(e[3])) / 2,
    rotate: Of,
    rotateZ: Of,
    skewX: e => qr(Math.atan(e[1])),
    skewY: e => qr(Math.atan(e[2])),
    skew: e => (Math.abs(e[1]) + Math.abs(e[2])) / 2
  },
  Lf = e => (e = e % 360, e < 0 && (e += 360), e),
  py = Of,
  my = e => Math.sqrt(e[0] * e[0] + e[1] * e[1]),
  gy = e => Math.sqrt(e[4] * e[4] + e[5] * e[5]),
  xM = {
    x: 12,
    y: 13,
    z: 14,
    translateX: 12,
    translateY: 13,
    translateZ: 14,
    scaleX: my,
    scaleY: gy,
    scale: e => (my(e) + gy(e)) / 2,
    rotateX: e => Lf(qr(Math.atan2(e[6], e[5]))),
    rotateY: e => Lf(qr(Math.atan2(-e[2], e[0]))),
    rotateZ: py,
    rotate: py,
    skewX: e => qr(Math.atan(e[4])),
    skewY: e => qr(Math.atan(e[1])),
    skew: e => (Math.abs(e[1]) + Math.abs(e[4])) / 2
  };
function Df(e) {
  return e.includes("scale") ? 1 : 0;
}
function If(e, t) {
  if (!e || e === "none") return Df(t);
  const n = e.match(/^matrix3d\(([-\d.e\s,]+)\)$/u);
  let r, s;
  if (n) r = xM, s = n;else {
    const a = e.match(/^matrix\(([-\d.e\s,]+)\)$/u);
    r = vM, s = a;
  }
  if (!s) return Df(t);
  const o = r[t],
    i = s[1].split(",").map(bM);
  return typeof o == "function" ? o(i) : i[o];
}
const wM = (e, t) => {
  const {
    transform: n = "none"
  } = getComputedStyle(e);
  return If(n, t);
};
function bM(e) {
  return parseFloat(e.trim());
}
const Do = ["transformPerspective", "x", "y", "z", "translateX", "translateY", "translateZ", "scale", "scaleX", "scaleY", "rotate", "rotateX", "rotateY", "rotateZ", "skew", "skewX", "skewY"],
  Io = new Set([...Do, "pathRotation"]),
  yy = e => e === Lo || e === B,
  SM = new Set(["x", "y", "z"]),
  EM = Do.filter(e => !SM.has(e));
function CM(e) {
  const t = [];
  return EM.forEach(n => {
    const r = e.getValue(n);
    r !== void 0 && (t.push([n, r.get()]), r.set(n.startsWith("scale") ? 1 : 0));
  }), t;
}
const hr = {
  width: ({
    x: e
  }, {
    paddingLeft: t = "0",
    paddingRight: n = "0",
    boxSizing: r
  }) => {
    const s = e.max - e.min;
    return r === "border-box" ? s : s - parseFloat(t) - parseFloat(n);
  },
  height: ({
    y: e
  }, {
    paddingTop: t = "0",
    paddingBottom: n = "0",
    boxSizing: r
  }) => {
    const s = e.max - e.min;
    return r === "border-box" ? s : s - parseFloat(t) - parseFloat(n);
  },
  top: (e, {
    top: t
  }) => parseFloat(t),
  left: (e, {
    left: t
  }) => parseFloat(t),
  bottom: ({
    y: e
  }, {
    top: t
  }) => parseFloat(t) + (e.max - e.min),
  right: ({
    x: e
  }, {
    left: t
  }) => parseFloat(t) + (e.max - e.min),
  x: (e, {
    transform: t
  }) => If(t, "x"),
  y: (e, {
    transform: t
  }) => If(t, "y")
};
hr.translateX = hr.x;
hr.translateY = hr.y;
const ss = new Set();
let Ff = !1,
  _f = !1,
  Vf = !1;
function Pb() {
  if (_f) {
    const e = Array.from(ss).filter(r => r.needsMeasurement),
      t = new Set(e.map(r => r.element)),
      n = new Map();
    t.forEach(r => {
      const s = CM(r);
      s.length && (n.set(r, s), r.render());
    }), e.forEach(r => r.measureInitialState()), t.forEach(r => {
      r.render();
      const s = n.get(r);
      s && s.forEach(([o, i]) => {
        var a;
        (a = r.getValue(o)) == null || a.set(i);
      });
    }), e.forEach(r => r.measureEndState()), e.forEach(r => {
      r.suspendedScrollY !== void 0 && window.scrollTo(0, r.suspendedScrollY);
    });
  }
  _f = !1, Ff = !1, ss.forEach(e => e.complete(Vf)), ss.clear();
}
function kb() {
  ss.forEach(e => {
    e.readKeyframes(), e.needsMeasurement && (_f = !0);
  });
}
function TM() {
  Vf = !0, kb(), Pb(), Vf = !1;
}
class Dp {
  constructor(t, n, r, s, o, i = !1) {
    this.state = "pending", this.isAsync = !1, this.needsMeasurement = !1, this.unresolvedKeyframes = [...t], this.onComplete = n, this.name = r, this.motionValue = s, this.element = o, this.isAsync = i;
  }
  scheduleResolve() {
    this.state = "scheduled", this.isAsync ? (ss.add(this), Ff || (Ff = !0, le.read(kb), le.resolveKeyframes(Pb))) : (this.readKeyframes(), this.complete());
  }
  readKeyframes() {
    const {
      unresolvedKeyframes: t,
      name: n,
      element: r,
      motionValue: s
    } = this;
    if (t[0] === null) {
      const o = s == null ? void 0 : s.get(),
        i = t[t.length - 1];
      if (o !== void 0) t[0] = o;else if (r && n) {
        const a = r.readValue(n, i);
        a != null && (t[0] = a);
      }
      t[0] === void 0 && (t[0] = i), s && o === void 0 && s.set(t[0]);
    }
    yM(t);
  }
  setFinalKeyframe() {}
  measureInitialState() {}
  renderEndStyles() {}
  measureEndState() {}
  complete(t = !1) {
    this.state = "complete", this.onComplete(this.unresolvedKeyframes, this.finalKeyframe, t), ss.delete(this);
  }
  cancel() {
    this.state === "scheduled" && (ss.delete(this), this.state = "pending");
  }
  resume() {
    this.state === "pending" && this.scheduleResolve();
  }
}
const PM = e => e.startsWith("--");
function Rb(e, t, n) {
  PM(t) ? e.style.setProperty(t, n) : e.style[t] = n;
}
const kM = {};
function Nb(e, t) {
  const n = nb(e);
  return () => kM[t] ?? n();
}
const RM = Nb(() => window.ScrollTimeline !== void 0, "scrollTimeline"),
  Ab = Nb(() => {
    try {
      document.createElement("div").animate({
        opacity: 0
      }, {
        easing: "linear(0, 1)"
      });
    } catch {
      return !1;
    }
    return !0;
  }, "linearEasing"),
  ri = ([e, t, n, r]) => `cubic-bezier(${e}, ${t}, ${n}, ${r})`,
  vy = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: ri([0, 0.65, 0.55, 1]),
    circOut: ri([0.55, 0, 1, 0.45]),
    backIn: ri([0.31, 0.01, 0.66, -0.59]),
    backOut: ri([0.33, 1.53, 0.69, 0.99])
  };
function jb(e, t) {
  if (e) return typeof e == "function" ? Ab() ? Eb(e, t) : "ease-out" : hb(e) ? ri(e) : Array.isArray(e) ? e.map(n => jb(n, t) || vy.easeOut) : vy[e];
}
function NM(e, t, n, {
  delay: r = 0,
  duration: s = 300,
  repeat: o = 0,
  repeatType: i = "loop",
  ease: a = "easeOut",
  times: l
} = {}, u = void 0) {
  const d = {
    [t]: n
  };
  l && (d.offset = l);
  const c = jb(a, s);
  Array.isArray(c) && (d.easing = c);
  const f = {
    delay: r,
    duration: s,
    easing: Array.isArray(c) ? "linear" : c,
    fill: "both",
    iterations: o + 1,
    direction: i === "reverse" ? "alternate" : "normal"
  };
  return u && (f.pseudoElement = u), e.animate(d, f);
}
function Mb(e) {
  return typeof e == "function" && "applyToOptions" in e;
}
function AM({
  type: e,
  ...t
}) {
  return Mb(e) && Ab() ? e.applyToOptions(t) : (t.duration ?? (t.duration = 300), t.ease ?? (t.ease = "easeOut"), t);
}
class Ob extends Lp {
  constructor(t) {
    if (super(), this.finishedTime = null, this.isStopped = !1, this.manualStartTime = null, !t) return;
    const {
      element: n,
      name: r,
      keyframes: s,
      pseudoElement: o,
      allowFlatten: i = !1,
      finalKeyframe: a,
      onComplete: l
    } = t;
    this.isPseudoElement = !!o, this.allowFlatten = i, this.options = t, So(typeof t.type != "string", `Mini animate() doesn't support "type" as a string.`, "mini-spring");
    const u = AM(t);
    this.animation = NM(n, r, s, u, o), u.autoplay === !1 && this.animation.pause(), this.animation.onfinish = () => {
      if (this.finishedTime = this.time, !o) {
        const d = zu(s, this.options, a, this.speed);
        this.updateMotionValue && this.updateMotionValue(d), Rb(n, r, d), this.animation.cancel();
      }
      l == null || l(), this.notifyFinished();
    };
  }
  play() {
    this.isStopped || (this.manualStartTime = null, this.animation.play(), this.state === "finished" && this.updateFinished());
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    var t, n;
    (n = (t = this.animation).finish) == null || n.call(t);
  }
  cancel() {
    try {
      this.animation.cancel();
    } catch {}
  }
  stop() {
    if (this.isStopped) return;
    this.isStopped = !0;
    const {
      state: t
    } = this;
    t === "idle" || t === "finished" || (this.updateMotionValue ? this.updateMotionValue() : this.commitStyles(), this.isPseudoElement || this.cancel());
  }
  commitStyles() {
    var n, r, s;
    const t = (n = this.options) == null ? void 0 : n.element;
    !this.isPseudoElement && t != null && t.isConnected && ((s = (r = this.animation).commitStyles) == null || s.call(r));
  }
  get duration() {
    var n, r;
    const t = ((r = (n = this.animation.effect) == null ? void 0 : n.getComputedTiming) == null ? void 0 : r.call(n).duration) || 0;
    return Rt(Number(t));
  }
  get iterationDuration() {
    const {
      delay: t = 0
    } = this.options || {};
    return this.duration + Rt(t);
  }
  get time() {
    return Rt(Number(this.animation.currentTime) || 0);
  }
  set time(t) {
    const n = this.finishedTime !== null;
    this.manualStartTime = null, this.finishedTime = null, this.animation.currentTime = dt(t), n && this.animation.pause();
  }
  get speed() {
    return this.animation.playbackRate;
  }
  set speed(t) {
    t < 0 && (this.finishedTime = null), this.animation.playbackRate = t;
  }
  get state() {
    return this.finishedTime !== null ? "finished" : this.animation.playState;
  }
  get startTime() {
    return this.manualStartTime ?? Number(this.animation.startTime);
  }
  set startTime(t) {
    this.manualStartTime = this.animation.startTime = t;
  }
  attachTimeline({
    timeline: t,
    rangeStart: n,
    rangeEnd: r,
    observe: s
  }) {
    var o;
    return this.allowFlatten && ((o = this.animation.effect) == null || o.updateTiming({
      easing: "linear"
    })), this.animation.onfinish = null, t && RM() ? (this.animation.timeline = t, n && (this.animation.rangeStart = n), r && (this.animation.rangeEnd = r), At) : s(this);
  }
}
const Lb = {
  anticipate: ub,
  backInOut: lb,
  circInOut: db
};
function jM(e) {
  return e in Lb;
}
function MM(e) {
  typeof e.ease == "string" && jM(e.ease) && (e.ease = Lb[e.ease]);
}
const Bc = 10;
class OM extends Ob {
  constructor(t) {
    MM(t), Tb(t), super(t), t.startTime !== void 0 && t.autoplay !== !1 && (this.startTime = t.startTime), this.options = t;
  }
  updateMotionValue(t) {
    const {
      motionValue: n,
      onUpdate: r,
      onComplete: s,
      element: o,
      ...i
    } = this.options;
    if (!n) return;
    if (t !== void 0) {
      n.set(t);
      return;
    }
    const a = new ru({
        ...i,
        autoplay: !1
      }),
      l = Math.max(Bc, Xe.now() - this.startTime),
      u = gn(0, Bc, l - Bc),
      d = a.sample(l).value,
      {
        name: c
      } = this.options;
    o && c && Rb(o, c, d), n.setWithVelocity(a.sample(Math.max(0, l - u)).value, d, u), a.stop();
  }
}
const xy = (e, t) => t === "zIndex" ? !1 : !!(typeof e == "number" || Array.isArray(e) || typeof e == "string" && (Kt.test(e) || e === "0") && !e.startsWith("url("));
function LM(e) {
  const t = e[0];
  if (e.length === 1) return !0;
  for (let n = 0; n < e.length; n++) if (e[n] !== t) return !0;
}
function DM(e, t, n, r) {
  const s = e[0];
  if (s === null) return !1;
  if (t === "display" || t === "visibility") return !0;
  const o = e[e.length - 1],
    i = xy(s, t),
    a = xy(o, t);
  return Bu(i === a, `You are trying to animate ${t} from "${s}" to "${o}". "${i ? o : s}" is not an animatable value.`, "value-not-animatable"), !i || !a ? !1 : LM(e) || (n === "spring" || Mb(n)) && r;
}
function Bf(e) {
  e.duration = 0, e.type = "keyframes";
}
const Db = new Set(["opacity", "clipPath", "filter", "transform"]),
  IM = /^(?:oklch|oklab|lab|lch|color|color-mix|light-dark)\(/;
function FM(e) {
  for (let t = 0; t < e.length; t++) if (typeof e[t] == "string" && IM.test(e[t])) return !0;
  return !1;
}
const _M = new Set(["color", "backgroundColor", "outlineColor", "fill", "stroke", "borderColor", "borderTopColor", "borderRightColor", "borderBottomColor", "borderLeftColor"]),
  VM = nb(() => Object.hasOwnProperty.call(Element.prototype, "animate"));
function BM(e) {
  var c;
  const {
    motionValue: t,
    name: n,
    repeatDelay: r,
    repeatType: s,
    damping: o,
    type: i,
    keyframes: a
  } = e;
  if (!(((c = t == null ? void 0 : t.owner) == null ? void 0 : c.current) instanceof HTMLElement)) return !1;
  const {
    onUpdate: u,
    transformTemplate: d
  } = t.owner.getProps();
  return VM() && n && (Db.has(n) || _M.has(n) && FM(a)) && (n !== "transform" || !d) && !u && !r && s !== "mirror" && o !== 0 && i !== "inertia";
}
const zM = 40;
class $M extends Lp {
  constructor({
    autoplay: t = !0,
    delay: n = 0,
    type: r = "keyframes",
    repeat: s = 0,
    repeatDelay: o = 0,
    repeatType: i = "loop",
    keyframes: a,
    name: l,
    motionValue: u,
    element: d,
    ...c
  }) {
    var w;
    super(), this.stop = () => {
      var m, x;
      this._animation && (this._animation.stop(), (m = this.stopTimeline) == null || m.call(this)), (x = this.keyframeResolver) == null || x.cancel();
    }, this.createdAt = Xe.now();
    const f = {
        autoplay: t,
        delay: n,
        type: r,
        repeat: s,
        repeatDelay: o,
        repeatType: i,
        name: l,
        motionValue: u,
        element: d,
        ...c
      },
      h = (d == null ? void 0 : d.KeyframeResolver) || Dp;
    this.keyframeResolver = new h(a, (m, x, g) => this.onKeyframesResolved(m, x, f, !g), l, u, d), (w = this.keyframeResolver) == null || w.scheduleResolve();
  }
  onKeyframesResolved(t, n, r, s) {
    var g, v;
    this.keyframeResolver = void 0;
    const {
      name: o,
      type: i,
      velocity: a,
      delay: l,
      isHandoff: u,
      onUpdate: d
    } = r;
    this.resolvedAt = Xe.now();
    let c = !0;
    DM(t, o, i, a) || (c = !1, (Rr.instantAnimations || !l) && (d == null || d(zu(t, r, n))), t[0] = t[t.length - 1], Bf(r), r.repeat = 0);
    const h = {
        startTime: s ? this.resolvedAt ? this.resolvedAt - this.createdAt > zM ? this.resolvedAt : this.createdAt : this.createdAt : void 0,
        finalKeyframe: n,
        ...r,
        keyframes: t
      },
      w = c && !u && BM(h),
      m = (v = (g = h.motionValue) == null ? void 0 : g.owner) == null ? void 0 : v.current;
    let x;
    if (w) try {
      x = new OM({
        ...h,
        element: m
      });
    } catch {
      x = new ru(h);
    } else x = new ru(h);
    x.finished.then(() => {
      this.notifyFinished();
    }).catch(At), this.pendingTimeline && (this.stopTimeline = x.attachTimeline(this.pendingTimeline), this.pendingTimeline = void 0), this._animation = x;
  }
  get finished() {
    return this._animation ? this.animation.finished : this._finished;
  }
  then(t, n) {
    return this.finished.finally(t).then(() => {});
  }
  get animation() {
    var t;
    return this._animation || ((t = this.keyframeResolver) == null || t.resume(), TM()), this._animation;
  }
  get duration() {
    return this.animation.duration;
  }
  get iterationDuration() {
    return this.animation.iterationDuration;
  }
  get time() {
    return this.animation.time;
  }
  set time(t) {
    this.animation.time = t;
  }
  get speed() {
    return this.animation.speed;
  }
  get state() {
    return this.animation.state;
  }
  set speed(t) {
    this.animation.speed = t;
  }
  get startTime() {
    return this.animation.startTime;
  }
  attachTimeline(t) {
    return this._animation ? this.stopTimeline = this.animation.attachTimeline(t) : this.pendingTimeline = t, () => this.stop();
  }
  play() {
    this.animation.play();
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    this.animation.complete();
  }
  cancel() {
    var t;
    this._animation && this.animation.cancel(), (t = this.keyframeResolver) == null || t.cancel();
  }
}
function Ib(e, t, n, r = 0, s = 1) {
  const o = Array.from(e).sort((u, d) => u.sortNodePosition(d)).indexOf(t),
    i = e.size,
    a = (i - 1) * r;
  return typeof n == "function" ? n(o, i) : s === 1 ? o * r : a - o * r;
}
const wy = 30,
  UM = e => !isNaN(parseFloat(e));
class WM {
  constructor(t, n = {}) {
    this.canTrackVelocity = null, this.events = {}, this.updateAndNotify = r => {
      var o;
      const s = Xe.now();
      if (this.updatedAt !== s && this.setPrevFrameValue(), this.prev = this.current, this.setCurrent(r), this.current !== this.prev && ((o = this.events.change) == null || o.notify(this.current), this.dependents)) for (const i of this.dependents) i.dirty();
    }, this.hasAnimated = !1, this.setCurrent(t), this.owner = n.owner;
  }
  setCurrent(t) {
    this.current = t, this.updatedAt = Xe.now(), this.canTrackVelocity === null && t !== void 0 && (this.canTrackVelocity = UM(this.current));
  }
  setPrevFrameValue(t = this.current) {
    this.prevFrameValue = t, this.prevUpdatedAt = this.updatedAt;
  }
  onChange(t) {
    return this.on("change", t);
  }
  on(t, n) {
    this.events[t] || (this.events[t] = new Pp());
    const r = this.events[t].add(n);
    return t === "change" ? () => {
      r(), le.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : r;
  }
  clearListeners() {
    for (const t in this.events) this.events[t].clear();
  }
  attach(t, n) {
    this.passiveEffect = t, this.stopPassiveEffect = n;
  }
  set(t) {
    this.passiveEffect ? this.passiveEffect(t, this.updateAndNotify) : this.updateAndNotify(t);
  }
  setWithVelocity(t, n, r) {
    this.set(n), this.prev = void 0, this.prevFrameValue = t, this.prevUpdatedAt = this.updatedAt - r;
  }
  jump(t, n = !0) {
    this.updateAndNotify(t), this.prev = t, this.prevUpdatedAt = this.prevFrameValue = void 0, n && this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  dirty() {
    var t;
    (t = this.events.change) == null || t.notify(this.current);
  }
  addDependent(t) {
    this.dependents || (this.dependents = new Set()), this.dependents.add(t);
  }
  removeDependent(t) {
    this.dependents && this.dependents.delete(t);
  }
  get() {
    return this.current;
  }
  getPrevious() {
    return this.prev;
  }
  getVelocity() {
    const t = Xe.now();
    if (!this.canTrackVelocity || this.prevFrameValue === void 0 || t - this.updatedAt > wy) return 0;
    const n = Math.min(this.updatedAt - this.prevUpdatedAt, wy);
    return rb(parseFloat(this.current) - parseFloat(this.prevFrameValue), n);
  }
  start(t) {
    return this.stop(), new Promise(n => {
      this.hasAnimated = !0, this.animation = t(n), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  destroy() {
    var t, n;
    (t = this.dependents) == null || t.clear(), (n = this.events.destroy) == null || n.notify(), this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function Co(e, t) {
  return new WM(e, t);
}
function Fb(e, t) {
  if (e != null && e.inherit && t) {
    const {
      inherit: n,
      ...r
    } = e;
    return {
      ...t,
      ...r
    };
  }
  return e;
}
function Ip(e, t) {
  const n = (e == null ? void 0 : e[t]) ?? (e == null ? void 0 : e.default) ?? e;
  return n !== e ? Fb(n, e) : n;
}
const HM = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
  },
  qM = e => ({
    type: "spring",
    stiffness: 550,
    damping: e === 0 ? 2 * Math.sqrt(550) : 30,
    restSpeed: 10
  }),
  KM = {
    type: "keyframes",
    duration: 0.8
  },
  QM = {
    type: "keyframes",
    ease: [0.25, 0.1, 0.35, 1],
    duration: 0.3
  },
  GM = (e, {
    keyframes: t
  }) => t.length > 2 ? KM : Io.has(e) ? e.startsWith("scale") ? qM(t[1]) : HM : QM,
  YM = new Set(["when", "delay", "delayChildren", "staggerChildren", "staggerDirection", "repeat", "repeatType", "repeatDelay", "from", "elapsed"]);
function XM(e) {
  for (const t in e) if (!YM.has(t)) return !0;
  return !1;
}
const Fp = (e, t, n, r = {}, s, o) => i => {
    const a = Ip(r, e) || {},
      l = a.delay || r.delay || 0;
    let {
      elapsed: u = 0
    } = r;
    u = u - dt(l);
    const d = {
      keyframes: Array.isArray(n) ? n : [null, n],
      ease: "easeOut",
      velocity: t.getVelocity(),
      ...a,
      delay: -u,
      onUpdate: f => {
        t.set(f), a.onUpdate && a.onUpdate(f);
      },
      onComplete: () => {
        i(), a.onComplete && a.onComplete();
      },
      name: e,
      motionValue: t,
      element: o ? void 0 : s
    };
    XM(a) || Object.assign(d, GM(e, d)), d.duration && (d.duration = dt(d.duration)), d.repeatDelay && (d.repeatDelay = dt(d.repeatDelay)), d.from !== void 0 && (d.keyframes[0] = d.from);
    let c = !1;
    if ((d.type === !1 || d.duration === 0 && !d.repeatDelay) && (Bf(d), d.delay === 0 && (c = !0)), (Rr.instantAnimations || Rr.skipAnimations || s != null && s.shouldSkipAnimations || a.skipAnimations) && (c = !0, Bf(d), d.delay = 0), d.allowFlatten = !a.type && !a.ease, c && !o && t.get() !== void 0) {
      const f = zu(d.keyframes, a);
      if (f !== void 0) {
        le.update(() => {
          d.onUpdate(f), d.onComplete();
        });
        return;
      }
    }
    return a.isSync ? new ru(d) : new $M(d);
  },
  ZM = /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u;
function JM(e) {
  const t = ZM.exec(e);
  if (!t) return [,];
  const [, n, r, s] = t;
  return [`--${n ?? r}`, s];
}
const eO = 4;
function _b(e, t, n = 1) {
  So(n <= eO, `Max CSS variable fallback depth detected in property "${e}". This may indicate a circular fallback dependency.`, "max-css-var-depth");
  const [r, s] = JM(e);
  if (!r) return;
  const o = window.getComputedStyle(t).getPropertyValue(r);
  if (o) {
    const i = o.trim();
    return J1(i) ? parseFloat(i) : i;
  }
  return Np(s) ? _b(s, t, n + 1) : s;
}
function by(e) {
  const t = [{}, {}];
  return e == null || e.values.forEach((n, r) => {
    t[0][r] = n.get(), t[1][r] = n.getVelocity();
  }), t;
}
function _p(e, t, n, r) {
  if (typeof t == "function") {
    const [s, o] = by(r);
    t = t(n !== void 0 ? n : e.custom, s, o);
  }
  if (typeof t == "string" && (t = e.variants && e.variants[t]), typeof t == "function") {
    const [s, o] = by(r);
    t = t(n !== void 0 ? n : e.custom, s, o);
  }
  return t;
}
function os(e, t, n) {
  const r = e.getProps();
  return _p(r, t, n !== void 0 ? n : r.custom, e);
}
const Vb = new Set(["width", "height", "top", "left", "right", "bottom", ...Do]),
  zf = e => Array.isArray(e);
function tO(e, t, n) {
  e.hasValue(t) ? e.getValue(t).set(n) : e.addValue(t, Co(n));
}
function nO(e) {
  return zf(e) ? e[e.length - 1] || 0 : e;
}
function rO(e, t) {
  const n = os(e, t);
  let {
    transitionEnd: r = {},
    transition: s = {},
    ...o
  } = n || {};
  o = {
    ...o,
    ...r
  };
  for (const i in o) {
    const a = nO(o[i]);
    tO(e, i, a);
  }
}
const Ve = e => !!(e && e.getVelocity);
function sO(e) {
  return !!(Ve(e) && e.add);
}
function $f(e, t) {
  const n = e.getValue("willChange");
  if (sO(n)) return n.add(t);
  if (!n && Rr.WillChange) {
    const r = new Rr.WillChange("auto");
    e.addValue("willChange", r), r.add(t);
  }
}
function Vp(e) {
  return e.replace(/([A-Z])/g, t => `-${t.toLowerCase()}`);
}
const oO = "framerAppearId",
  Bb = "data-" + Vp(oO);
function zb(e) {
  return e.props[Bb];
}
function iO({
  protectedKeys: e,
  needsAnimating: t
}, n) {
  const r = e.hasOwnProperty(n) && t[n] !== !0;
  return t[n] = !1, r;
}
function $b(e, t, {
  delay: n = 0,
  transitionOverride: r,
  type: s
} = {}) {
  let {
    transition: o,
    transitionEnd: i,
    ...a
  } = t;
  const l = e.getDefaultTransition();
  o = o ? Fb(o, l) : l;
  const u = o == null ? void 0 : o.reduceMotion,
    d = o == null ? void 0 : o.skipAnimations;
  r && (o = r);
  const c = [],
    f = s && e.animationState && e.animationState.getState()[s],
    h = o == null ? void 0 : o.path;
  h && h.animateVisualElement(e, a, o, n, c);
  for (const w in a) {
    const m = e.getValue(w, e.latestValues[w] ?? null),
      x = a[w];
    if (x === void 0 || f && iO(f, w)) continue;
    const g = {
      delay: n,
      ...Ip(o || {}, w)
    };
    d && (g.skipAnimations = !0);
    const v = m.get();
    if (v !== void 0 && !m.isAnimating() && !Array.isArray(x) && x === v && !g.velocity) {
      le.update(() => m.set(x));
      continue;
    }
    let b = !1;
    if (window.MotionHandoffAnimation) {
      const P = zb(e);
      if (P) {
        const T = window.MotionHandoffAnimation(P, w, le);
        T !== null && (g.startTime = T, b = !0);
      }
    }
    $f(e, w);
    const S = u ?? e.shouldReduceMotion;
    m.start(Fp(w, m, x, S && Vb.has(w) ? {
      type: !1
    } : g, e, b));
    const E = m.animation;
    E && c.push(E);
  }
  if (i) {
    const w = () => le.update(() => {
      i && rO(e, i);
    });
    c.length ? Promise.all(c).then(w) : w();
  }
  return c;
}
function Uf(e, t, n = {}) {
  var l;
  const r = os(e, t, n.type === "exit" ? (l = e.presenceContext) == null ? void 0 : l.custom : void 0);
  let {
    transition: s = e.getDefaultTransition() || {}
  } = r || {};
  n.transitionOverride && (s = n.transitionOverride);
  const o = r ? () => Promise.all($b(e, r, n)) : () => Promise.resolve(),
    i = e.variantChildren && e.variantChildren.size ? (u = 0) => {
      const {
        delayChildren: d = 0,
        staggerChildren: c,
        staggerDirection: f
      } = s;
      return aO(e, t, u, d, c, f, n);
    } : () => Promise.resolve(),
    {
      when: a
    } = s;
  if (a) {
    const [u, d] = a === "beforeChildren" ? [o, i] : [i, o];
    return u().then(() => d());
  } else return Promise.all([o(), i(n.delay)]);
}
function aO(e, t, n = 0, r = 0, s = 0, o = 1, i) {
  const a = [];
  for (const l of e.variantChildren) l.notify("AnimationStart", t), a.push(Uf(l, t, {
    ...i,
    delay: n + (typeof r == "function" ? 0 : r) + Ib(e.variantChildren, l, r, s, o)
  }).then(() => l.notify("AnimationComplete", t)));
  return Promise.all(a);
}
function lO(e, t, n = {}) {
  e.notify("AnimationStart", t);
  let r;
  if (Array.isArray(t)) {
    const s = t.map(o => Uf(e, o, n));
    r = Promise.all(s);
  } else if (typeof t == "string") r = Uf(e, t, n);else {
    const s = typeof t == "function" ? os(e, t, n.custom) : t;
    r = Promise.all($b(e, s, n));
  }
  return r.then(() => {
    e.notify("AnimationComplete", t);
  });
}
const uO = {
    test: e => e === "auto",
    parse: e => e
  },
  Ub = e => t => t.test(e),
  Wb = [Lo, B, hn, wn, Lj, Oj, uO],
  Sy = e => Wb.find(Ub(e));
function cO(e) {
  return typeof e == "number" ? e === 0 : e !== null ? e === "none" || e === "0" || tb(e) : !0;
}
const dO = new Set(["brightness", "contrast", "saturate", "opacity"]);
function fO(e) {
  const [t, n] = e.slice(0, -1).split("(");
  if (t === "drop-shadow") return e;
  const [r] = n.match(Ap) || [];
  if (!r) return e;
  const s = n.replace(r, "");
  let o = dO.has(t) ? 1 : 0;
  return r !== n && (o *= 100), t + "(" + o + s + ")";
}
const hO = /\b([a-z-]*)\(.*?\)/gu,
  Wf = {
    ...Kt,
    getAnimatableNone: e => {
      const t = e.match(hO);
      return t ? t.map(fO).join(" ") : e;
    }
  },
  Hf = {
    ...Kt,
    getAnimatableNone: e => {
      const t = Kt.parse(e);
      return Kt.createTransformer(e)(t.map(r => typeof r == "number" ? 0 : typeof r == "object" ? {
        ...r,
        alpha: 1
      } : r));
    }
  },
  Ey = {
    ...Lo,
    transform: Math.round
  },
  pO = {
    rotate: wn,
    pathRotation: wn,
    rotateX: wn,
    rotateY: wn,
    rotateZ: wn,
    scale: Ba,
    scaleX: Ba,
    scaleY: Ba,
    scaleZ: Ba,
    skew: wn,
    skewX: wn,
    skewY: wn,
    distance: B,
    translateX: B,
    translateY: B,
    translateZ: B,
    x: B,
    y: B,
    z: B,
    perspective: B,
    transformPerspective: B,
    opacity: Ui,
    originX: uy,
    originY: uy,
    originZ: B
  },
  su = {
    borderWidth: B,
    borderTopWidth: B,
    borderRightWidth: B,
    borderBottomWidth: B,
    borderLeftWidth: B,
    borderRadius: B,
    borderTopLeftRadius: B,
    borderTopRightRadius: B,
    borderBottomRightRadius: B,
    borderBottomLeftRadius: B,
    width: B,
    maxWidth: B,
    height: B,
    maxHeight: B,
    top: B,
    right: B,
    bottom: B,
    left: B,
    inset: B,
    insetBlock: B,
    insetBlockStart: B,
    insetBlockEnd: B,
    insetInline: B,
    insetInlineStart: B,
    insetInlineEnd: B,
    padding: B,
    paddingTop: B,
    paddingRight: B,
    paddingBottom: B,
    paddingLeft: B,
    paddingBlock: B,
    paddingBlockStart: B,
    paddingBlockEnd: B,
    paddingInline: B,
    paddingInlineStart: B,
    paddingInlineEnd: B,
    margin: B,
    marginTop: B,
    marginRight: B,
    marginBottom: B,
    marginLeft: B,
    marginBlock: B,
    marginBlockStart: B,
    marginBlockEnd: B,
    marginInline: B,
    marginInlineStart: B,
    marginInlineEnd: B,
    fontSize: B,
    backgroundPositionX: B,
    backgroundPositionY: B,
    ...pO,
    zIndex: Ey,
    fillOpacity: Ui,
    strokeOpacity: Ui,
    numOctaves: Ey
  },
  mO = {
    ...su,
    color: Pe,
    backgroundColor: Pe,
    outlineColor: Pe,
    fill: Pe,
    stroke: Pe,
    borderColor: Pe,
    borderTopColor: Pe,
    borderRightColor: Pe,
    borderBottomColor: Pe,
    borderLeftColor: Pe,
    filter: Wf,
    WebkitFilter: Wf,
    mask: Hf,
    WebkitMask: Hf
  },
  Hb = e => mO[e],
  gO = new Set([Wf, Hf]);
function qb(e, t) {
  let n = Hb(e);
  return gO.has(n) || (n = Kt), n.getAnimatableNone ? n.getAnimatableNone(t) : void 0;
}
const yO = new Set(["auto", "none", "0"]);
function vO(e, t, n) {
  let r = 0,
    s;
  for (; r < e.length && !s;) {
    const o = e[r];
    typeof o == "string" && !yO.has(o) && Eo(o).values.length && (s = e[r]), r++;
  }
  if (s && n) for (const o of t) e[o] = qb(n, s);
}
class xO extends Dp {
  constructor(t, n, r, s, o) {
    super(t, n, r, s, o, !0);
  }
  readKeyframes() {
    const {
      unresolvedKeyframes: t,
      element: n,
      name: r
    } = this;
    if (!n || !n.current) return;
    super.readKeyframes();
    for (let d = 0; d < t.length; d++) {
      let c = t[d];
      if (typeof c == "string" && (c = c.trim(), Np(c))) {
        const f = _b(c, n.current);
        f !== void 0 && (t[d] = f), d === t.length - 1 && (this.finalKeyframe = c);
      }
    }
    if (this.resolveNoneKeyframes(), !Vb.has(r) || t.length !== 2) return;
    const [s, o] = t,
      i = Sy(s),
      a = Sy(o),
      l = ly(s),
      u = ly(o);
    if (l !== u && hr[r]) {
      this.needsMeasurement = !0;
      return;
    }
    if (i !== a) if (yy(i) && yy(a)) for (let d = 0; d < t.length; d++) {
      const c = t[d];
      typeof c == "string" && (t[d] = parseFloat(c));
    } else hr[r] && (this.needsMeasurement = !0);
  }
  resolveNoneKeyframes() {
    const {
        unresolvedKeyframes: t,
        name: n
      } = this,
      r = [];
    for (let s = 0; s < t.length; s++) (t[s] === null || cO(t[s])) && r.push(s);
    r.length && vO(t, r, n);
  }
  measureInitialState() {
    const {
      element: t,
      unresolvedKeyframes: n,
      name: r
    } = this;
    if (!t || !t.current) return;
    r === "height" && (this.suspendedScrollY = window.pageYOffset), this.measuredOrigin = hr[r](t.measureViewportBox(), window.getComputedStyle(t.current)), n[0] = this.measuredOrigin;
    const s = n[n.length - 1];
    s !== void 0 && t.getValue(r, s).jump(s, !1);
  }
  measureEndState() {
    var a;
    const {
      element: t,
      name: n,
      unresolvedKeyframes: r
    } = this;
    if (!t || !t.current) return;
    const s = t.getValue(n);
    s && s.jump(this.measuredOrigin, !1);
    const o = r.length - 1,
      i = r[o];
    r[o] = hr[n](t.measureViewportBox(), window.getComputedStyle(t.current)), i !== null && this.finalKeyframe === void 0 && (this.finalKeyframe = i), (a = this.removedTransforms) != null && a.length && this.removedTransforms.forEach(([l, u]) => {
      t.getValue(l).set(u);
    }), this.resolveNoneKeyframes();
  }
}
function Kb(e, t, n) {
  if (e == null) return [];
  if (e instanceof EventTarget) return [e];
  if (typeof e == "string") {
    const s = document.querySelectorAll(e);
    return s ? Array.from(s) : [];
  }
  return Array.from(e).filter(r => r != null);
}
const qf = (e, t) => t && typeof e == "number" ? t.transform(e) : e;
function cl(e) {
  return eb(e) && "offsetHeight" in e && !("ownerSVGElement" in e);
}
const {
    schedule: Bp,
    cancel: C5
  } = pb(queueMicrotask, !1),
  Vt = {
    x: !1,
    y: !1
  };
function Qb() {
  return Vt.x || Vt.y;
}
function wO(e) {
  return e === "x" || e === "y" ? Vt[e] ? null : (Vt[e] = !0, () => {
    Vt[e] = !1;
  }) : Vt.x || Vt.y ? null : (Vt.x = Vt.y = !0, () => {
    Vt.x = Vt.y = !1;
  });
}
function Gb(e, t) {
  const n = Kb(e),
    r = new AbortController(),
    s = {
      passive: !0,
      ...t,
      signal: r.signal
    };
  return [n, s, () => r.abort()];
}
function bO(e) {
  return !(e.pointerType === "touch" || Qb());
}
function SO(e, t, n = {}) {
  const [r, s, o] = Gb(e, n);
  return r.forEach(i => {
    let a = !1,
      l = !1,
      u;
    const d = () => {
        i.removeEventListener("pointerleave", w);
      },
      c = x => {
        u && (u(x), u = void 0), d();
      },
      f = x => {
        a = !1, window.removeEventListener("pointerup", f), window.removeEventListener("pointercancel", f), l && (l = !1, c(x));
      },
      h = () => {
        a = !0, window.addEventListener("pointerup", f, s), window.addEventListener("pointercancel", f, s);
      },
      w = x => {
        if (x.pointerType !== "touch") {
          if (a) {
            l = !0;
            return;
          }
          c(x);
        }
      },
      m = x => {
        if (!bO(x)) return;
        l = !1;
        const g = t(i, x);
        typeof g == "function" && (u = g, i.addEventListener("pointerleave", w, s));
      };
    i.addEventListener("pointerenter", m, s), i.addEventListener("pointerdown", h, s);
  }), o;
}
const Yb = (e, t) => t ? e === t ? !0 : Yb(e, t.parentElement) : !1,
  zp = e => e.pointerType === "mouse" ? typeof e.button != "number" || e.button <= 0 : e.isPrimary !== !1,
  EO = new Set(["BUTTON", "INPUT", "SELECT", "TEXTAREA", "A"]);
function CO(e) {
  return EO.has(e.tagName) || e.isContentEditable === !0;
}
const TO = new Set(["INPUT", "SELECT", "TEXTAREA"]);
function PO(e) {
  return TO.has(e.tagName) || e.isContentEditable === !0;
}
const dl = new WeakSet();
function Cy(e) {
  return t => {
    t.key === "Enter" && e(t);
  };
}
function zc(e, t) {
  e.dispatchEvent(new PointerEvent("pointer" + t, {
    isPrimary: !0,
    bubbles: !0
  }));
}
const kO = (e, t) => {
  const n = e.currentTarget;
  if (!n) return;
  const r = Cy(() => {
    if (dl.has(n)) return;
    zc(n, "down");
    const s = Cy(() => {
        zc(n, "up");
      }),
      o = () => zc(n, "cancel");
    n.addEventListener("keyup", s, t), n.addEventListener("blur", o, t);
  });
  n.addEventListener("keydown", r, t), n.addEventListener("blur", () => n.removeEventListener("keydown", r), t);
};
function Ty(e) {
  return zp(e) && !Qb();
}
const Py = new WeakSet();
function RO(e, t, n = {}) {
  const [r, s, o] = Gb(e, n),
    i = a => {
      const l = a.currentTarget;
      if (!Ty(a) || Py.has(a)) return;
      dl.add(l), n.stopPropagation && Py.add(a);
      const u = t(l, a),
        d = (h, w) => {
          window.removeEventListener("pointerup", c), window.removeEventListener("pointercancel", f), dl.has(l) && dl.delete(l), Ty(h) && typeof u == "function" && u(h, {
            success: w
          });
        },
        c = h => {
          d(h, l === window || l === document || n.useGlobalTarget || Yb(l, h.target));
        },
        f = h => {
          d(h, !1);
        };
      window.addEventListener("pointerup", c, s), window.addEventListener("pointercancel", f, s);
    };
  return r.forEach(a => {
    (n.useGlobalTarget ? window : a).addEventListener("pointerdown", i, s), cl(a) && (a.addEventListener("focus", u => kO(u, s)), !CO(a) && !a.hasAttribute("tabindex") && (a.tabIndex = 0));
  }), o;
}
function $p(e) {
  return eb(e) && "ownerSVGElement" in e;
}
const fl = new WeakMap();
let Yn;
const Xb = (e, t, n) => (r, s) => s && s[0] ? s[0][e + "Size"] : $p(r) && "getBBox" in r ? r.getBBox()[t] : r[n],
  NO = Xb("inline", "width", "offsetWidth"),
  AO = Xb("block", "height", "offsetHeight");
function jO({
  target: e,
  borderBoxSize: t
}) {
  var n;
  (n = fl.get(e)) == null || n.forEach(r => {
    r(e, {
      get width() {
        return NO(e, t);
      },
      get height() {
        return AO(e, t);
      }
    });
  });
}
function MO(e) {
  e.forEach(jO);
}
function OO() {
  typeof ResizeObserver > "u" || (Yn = new ResizeObserver(MO));
}
function LO(e, t) {
  Yn || OO();
  const n = Kb(e);
  return n.forEach(r => {
    let s = fl.get(r);
    s || (s = new Set(), fl.set(r, s)), s.add(t), Yn == null || Yn.observe(r);
  }), () => {
    n.forEach(r => {
      const s = fl.get(r);
      s == null || s.delete(t), s != null && s.size || Yn == null || Yn.unobserve(r);
    });
  };
}
const hl = new Set();
let Bs;
function DO() {
  Bs = () => {
    const e = {
      get width() {
        return window.innerWidth;
      },
      get height() {
        return window.innerHeight;
      }
    };
    hl.forEach(t => t(e));
  }, window.addEventListener("resize", Bs);
}
function IO(e) {
  return hl.add(e), Bs || DO(), () => {
    hl.delete(e), !hl.size && typeof Bs == "function" && (window.removeEventListener("resize", Bs), Bs = void 0);
  };
}
function ky(e, t) {
  return typeof e == "function" ? IO(e) : LO(e, t);
}
function FO(e) {
  return $p(e) && e.tagName === "svg";
}
const _O = [...Wb, Pe, Kt],
  VO = e => _O.find(Ub(e)),
  Ry = () => ({
    translate: 0,
    scale: 1,
    origin: 0,
    originPoint: 0
  }),
  zs = () => ({
    x: Ry(),
    y: Ry()
  }),
  Ny = () => ({
    min: 0,
    max: 0
  }),
  Ne = () => ({
    x: Ny(),
    y: Ny()
  }),
  BO = new WeakMap();
function $u(e) {
  return e !== null && typeof e == "object" && typeof e.start == "function";
}
function Wi(e) {
  return typeof e == "string" || Array.isArray(e);
}
const Up = ["animate", "whileInView", "whileFocus", "whileHover", "whileTap", "whileDrag", "exit"],
  Wp = ["initial", ...Up];
function Uu(e) {
  return $u(e.animate) || Wp.some(t => Wi(e[t]));
}
function Zb(e) {
  return !!(Uu(e) || e.variants);
}
function zO(e, t, n) {
  for (const r in t) {
    const s = t[r],
      o = n[r];
    if (Ve(s)) e.addValue(r, s);else if (Ve(o)) e.addValue(r, Co(s, {
      owner: e
    }));else if (o !== s) if (e.hasValue(r)) {
      const i = e.getValue(r);
      i.liveStyle === !0 ? i.jump(s) : i.hasAnimated || i.set(s);
    } else {
      const i = e.getStaticValue(r);
      e.addValue(r, Co(i !== void 0 ? i : s, {
        owner: e
      }));
    }
  }
  for (const r in n) t[r] === void 0 && e.removeValue(r);
  return t;
}
const ou = {
    current: null
  },
  Hp = {
    current: !1
  },
  $O = typeof window < "u";
function Jb() {
  if (Hp.current = !0, !!$O) if (window.matchMedia) {
    const e = window.matchMedia("(prefers-reduced-motion)"),
      t = () => ou.current = e.matches;
    e.addEventListener("change", t), t();
  } else ou.current = !1;
}
const Ay = ["AnimationStart", "AnimationComplete", "Update", "BeforeLayoutMeasure", "LayoutMeasure", "LayoutAnimationStart", "LayoutAnimationComplete"];
let iu = {};
function eS(e) {
  iu = e;
}
function UO() {
  return iu;
}
class WO {
  scrapeMotionValuesFromProps(t, n, r) {
    return {};
  }
  constructor({
    parent: t,
    props: n,
    presenceContext: r,
    reducedMotionConfig: s,
    skipAnimations: o,
    blockInitialAnimation: i,
    visualState: a
  }, l = {}) {
    this.current = null, this.children = new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.shouldSkipAnimations = !1, this.values = new Map(), this.KeyframeResolver = Dp, this.features = {}, this.valueSubscriptions = new Map(), this.prevMotionValues = {}, this.hasBeenMounted = !1, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.renderScheduledAt = 0, this.scheduleRender = () => {
      const h = Xe.now();
      this.renderScheduledAt < h && (this.renderScheduledAt = h, le.render(this.render, !1, !0));
    };
    const {
      latestValues: u,
      renderState: d
    } = a;
    this.latestValues = u, this.baseTarget = {
      ...u
    }, this.initialValues = n.initial ? {
      ...u
    } : {}, this.renderState = d, this.parent = t, this.props = n, this.presenceContext = r, this.depth = t ? t.depth + 1 : 0, this.reducedMotionConfig = s, this.skipAnimationsConfig = o, this.options = l, this.blockInitialAnimation = !!i, this.isControllingVariants = Uu(n), this.isVariantNode = Zb(n), this.isVariantNode && (this.variantChildren = new Set()), this.manuallyAnimateOnMount = !!(t && t.current);
    const {
      willChange: c,
      ...f
    } = this.scrapeMotionValuesFromProps(n, {}, this);
    for (const h in f) {
      const w = f[h];
      u[h] !== void 0 && Ve(w) && w.set(u[h]);
    }
  }
  mount(t) {
    var n, r;
    if (this.hasBeenMounted) for (const s in this.initialValues) (n = this.values.get(s)) == null || n.jump(this.initialValues[s]), this.latestValues[s] = this.initialValues[s];
    this.current = t, BO.set(t, this), this.projection && !this.projection.instance && this.projection.mount(t), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((s, o) => this.bindToMotionValue(o, s)), this.reducedMotionConfig === "never" ? this.shouldReduceMotion = !1 : this.reducedMotionConfig === "always" ? this.shouldReduceMotion = !0 : (Hp.current || Jb(), this.shouldReduceMotion = ou.current), this.shouldSkipAnimations = this.skipAnimationsConfig ?? !1, (r = this.parent) == null || r.addChild(this), this.update(this.props, this.presenceContext), this.hasBeenMounted = !0;
  }
  unmount() {
    var t;
    this.projection && this.projection.unmount(), Nr(this.notifyUpdate), Nr(this.render), this.valueSubscriptions.forEach(n => n()), this.valueSubscriptions.clear(), this.removeFromVariantTree && this.removeFromVariantTree(), (t = this.parent) == null || t.removeChild(this);
    for (const n in this.events) this.events[n].clear();
    for (const n in this.features) {
      const r = this.features[n];
      r && (r.unmount(), r.isMounted = !1);
    }
    this.current = null;
  }
  addChild(t) {
    this.children.add(t), this.enteringChildren ?? (this.enteringChildren = new Set()), this.enteringChildren.add(t);
  }
  removeChild(t) {
    this.children.delete(t), this.enteringChildren && this.enteringChildren.delete(t);
  }
  bindToMotionValue(t, n) {
    if (this.valueSubscriptions.has(t) && this.valueSubscriptions.get(t)(), n.accelerate && Db.has(t) && this.current instanceof HTMLElement) {
      const {
          factory: i,
          keyframes: a,
          times: l,
          ease: u,
          duration: d
        } = n.accelerate,
        c = new Ob({
          element: this.current,
          name: t,
          keyframes: a,
          times: l,
          ease: u,
          duration: dt(d)
        }),
        f = i(c);
      this.valueSubscriptions.set(t, () => {
        f(), c.cancel();
      });
      return;
    }
    const r = Io.has(t);
    r && this.onBindTransform && this.onBindTransform();
    const s = n.on("change", i => {
      this.latestValues[t] = i, this.props.onUpdate && le.preRender(this.notifyUpdate), r && this.projection && (this.projection.isTransformDirty = !0), this.scheduleRender();
    });
    let o;
    typeof window < "u" && window.MotionCheckAppearSync && (o = window.MotionCheckAppearSync(this, t, n)), this.valueSubscriptions.set(t, () => {
      s(), o && o();
    });
  }
  sortNodePosition(t) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== t.type ? 0 : this.sortInstanceNodePosition(this.current, t.current);
  }
  updateFeatures() {
    let t = "animation";
    for (t in iu) {
      const n = iu[t];
      if (!n) continue;
      const {
        isEnabled: r,
        Feature: s
      } = n;
      if (!this.features[t] && s && r(this.props) && (this.features[t] = new s(this)), this.features[t]) {
        const o = this.features[t];
        o.isMounted ? o.update() : (o.mount(), o.isMounted = !0);
      }
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.props);
  }
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : Ne();
  }
  getStaticValue(t) {
    return this.latestValues[t];
  }
  setStaticValue(t, n) {
    this.latestValues[t] = n;
  }
  update(t, n) {
    (t.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = t, this.prevPresenceContext = this.presenceContext, this.presenceContext = n;
    for (let r = 0; r < Ay.length; r++) {
      const s = Ay[r];
      this.propEventSubscriptions[s] && (this.propEventSubscriptions[s](), delete this.propEventSubscriptions[s]);
      const o = "on" + s,
        i = t[o];
      i && (this.propEventSubscriptions[s] = this.on(s, i));
    }
    this.prevMotionValues = zO(this, this.scrapeMotionValuesFromProps(t, this.prevProps || {}, this), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue();
  }
  getProps() {
    return this.props;
  }
  getVariant(t) {
    return this.props.variants ? this.props.variants[t] : void 0;
  }
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  addVariantChild(t) {
    const n = this.getClosestVariantNode();
    if (n) return n.variantChildren && n.variantChildren.add(t), () => n.variantChildren.delete(t);
  }
  addValue(t, n) {
    const r = this.values.get(t);
    n !== r && (r && this.removeValue(t), this.bindToMotionValue(t, n), this.values.set(t, n), this.latestValues[t] = n.get());
  }
  removeValue(t) {
    this.values.delete(t);
    const n = this.valueSubscriptions.get(t);
    n && (n(), this.valueSubscriptions.delete(t)), delete this.latestValues[t], this.removeValueFromRenderState(t, this.renderState);
  }
  hasValue(t) {
    return this.values.has(t);
  }
  getValue(t, n) {
    if (this.props.values && this.props.values[t]) return this.props.values[t];
    let r = this.values.get(t);
    return r === void 0 && n !== void 0 && (r = Co(n === null ? void 0 : n, {
      owner: this
    }), this.addValue(t, r)), r;
  }
  readValue(t, n) {
    let r = this.latestValues[t] !== void 0 || !this.current ? this.latestValues[t] : this.getBaseTargetFromProps(this.props, t) ?? this.readValueFromInstance(this.current, t, this.options);
    return r != null && (typeof r == "string" && (J1(r) || tb(r)) ? r = parseFloat(r) : !VO(r) && Kt.test(n) && (r = qb(t, n)), this.setBaseTarget(t, Ve(r) ? r.get() : r)), Ve(r) ? r.get() : r;
  }
  setBaseTarget(t, n) {
    this.baseTarget[t] = n;
  }
  getBaseTarget(t) {
    var o;
    const {
      initial: n
    } = this.props;
    let r;
    if (typeof n == "string" || typeof n == "object") {
      const i = _p(this.props, n, (o = this.presenceContext) == null ? void 0 : o.custom);
      i && (r = i[t]);
    }
    if (n && r !== void 0) return r;
    const s = this.getBaseTargetFromProps(this.props, t);
    return s !== void 0 && !Ve(s) ? s : this.initialValues[t] !== void 0 && r === void 0 ? void 0 : this.baseTarget[t];
  }
  on(t, n) {
    return this.events[t] || (this.events[t] = new Pp()), this.events[t].add(n);
  }
  notify(t, ...n) {
    this.events[t] && this.events[t].notify(...n);
  }
  scheduleRenderMicrotask() {
    Bp.render(this.render);
  }
}
class tS extends WO {
  constructor() {
    super(...arguments), this.KeyframeResolver = xO;
  }
  sortInstanceNodePosition(t, n) {
    return t.compareDocumentPosition(n) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(t, n) {
    const r = t.style;
    return r ? r[n] : void 0;
  }
  removeValueFromRenderState(t, {
    vars: n,
    style: r
  }) {
    delete n[t], delete r[t];
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const {
      children: t
    } = this.props;
    Ve(t) && (this.childSubscription = t.on("change", n => {
      this.current && (this.current.textContent = `${n}`);
    }));
  }
}
class Lr {
  constructor(t) {
    this.isMounted = !1, this.node = t;
  }
  update() {}
}
function nS({
  top: e,
  left: t,
  right: n,
  bottom: r
}) {
  return {
    x: {
      min: t,
      max: n
    },
    y: {
      min: e,
      max: r
    }
  };
}
function HO({
  x: e,
  y: t
}) {
  return {
    top: t.min,
    right: e.max,
    bottom: t.max,
    left: e.min
  };
}
function qO(e, t) {
  if (!t) return e;
  const n = t({
      x: e.left,
      y: e.top
    }),
    r = t({
      x: e.right,
      y: e.bottom
    });
  return {
    top: n.y,
    left: n.x,
    bottom: r.y,
    right: r.x
  };
}
function $c(e) {
  return e === void 0 || e === 1;
}
function Kf({
  scale: e,
  scaleX: t,
  scaleY: n
}) {
  return !$c(e) || !$c(t) || !$c(n);
}
function zr(e) {
  return Kf(e) || rS(e) || e.z || e.rotate || e.rotateX || e.rotateY || e.skewX || e.skewY;
}
function rS(e) {
  return jy(e.x) || jy(e.y);
}
function jy(e) {
  return e && e !== "0%";
}
function au(e, t, n) {
  const r = e - n,
    s = t * r;
  return n + s;
}
function My(e, t, n, r, s) {
  return s !== void 0 && (e = au(e, s, r)), au(e, n, r) + t;
}
function Qf(e, t = 0, n = 1, r, s) {
  e.min = My(e.min, t, n, r, s), e.max = My(e.max, t, n, r, s);
}
function sS(e, {
  x: t,
  y: n
}) {
  Qf(e.x, t.translate, t.scale, t.originPoint), Qf(e.y, n.translate, n.scale, n.originPoint);
}
const Oy = 0.999999999999,
  Ly = 1.0000000000001;
function KO(e, t, n, r = !1) {
  var a;
  const s = n.length;
  if (!s) return;
  t.x = t.y = 1;
  let o, i;
  for (let l = 0; l < s; l++) {
    o = n[l], i = o.projectionDelta;
    const {
      visualElement: u
    } = o.options;
    u && u.props.style && u.props.style.display === "contents" || (r && o.options.layoutScroll && o.scroll && o !== o.root && (on(e.x, -o.scroll.offset.x), on(e.y, -o.scroll.offset.y)), i && (t.x *= i.x.scale, t.y *= i.y.scale, sS(e, i)), r && zr(o.latestValues) && pl(e, o.latestValues, (a = o.layout) == null ? void 0 : a.layoutBox));
  }
  t.x < Ly && t.x > Oy && (t.x = 1), t.y < Ly && t.y > Oy && (t.y = 1);
}
function on(e, t) {
  e.min += t, e.max += t;
}
function Dy(e, t, n, r, s = 0.5) {
  const o = ae(e.min, e.max, s);
  Qf(e, t, n, o, r);
}
function Iy(e, t) {
  return typeof e == "string" ? parseFloat(e) / 100 * (t.max - t.min) : e;
}
function pl(e, t, n) {
  const r = n ?? e;
  Dy(e.x, Iy(t.x, r.x), t.scaleX, t.scale, t.originX), Dy(e.y, Iy(t.y, r.y), t.scaleY, t.scale, t.originY);
}
function oS(e, t) {
  return nS(qO(e.getBoundingClientRect(), t));
}
function QO(e, t, n) {
  const r = oS(e, n),
    {
      scroll: s
    } = t;
  return s && (on(r.x, s.offset.x), on(r.y, s.offset.y)), r;
}
const GO = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
  },
  YO = Do.length;
function XO(e, t, n) {
  let r = "",
    s = !0;
  for (let i = 0; i < YO; i++) {
    const a = Do[i],
      l = e[a];
    if (l === void 0) continue;
    let u = !0;
    if (typeof l == "number") u = l === (a.startsWith("scale") ? 1 : 0);else {
      const d = parseFloat(l);
      u = a.startsWith("scale") ? d === 1 : d === 0;
    }
    if (!u || n) {
      const d = qf(l, su[a]);
      if (!u) {
        s = !1;
        const c = GO[a] || a;
        r += `${c}(${d}) `;
      }
      n && (t[a] = d);
    }
  }
  const o = e.pathRotation;
  return o && (s = !1, r += `rotate(${qf(o, su.pathRotation)}) `), r = r.trim(), n ? r = n(t, s ? "" : r) : s && (r = "none"), r;
}
function qp(e, t, n) {
  const {
    style: r,
    vars: s,
    transformOrigin: o
  } = e;
  let i = !1,
    a = !1;
  for (const l in t) {
    const u = t[l];
    if (Io.has(l)) {
      i = !0;
      continue;
    } else if (gb(l)) {
      s[l] = u;
      continue;
    } else {
      const d = qf(u, su[l]);
      l.startsWith("origin") ? (a = !0, o[l] = d) : r[l] = d;
    }
  }
  if (t.transform || (i || n ? r.transform = XO(t, e.transform, n) : r.transform && (r.transform = "none")), a) {
    const {
      originX: l = "50%",
      originY: u = "50%",
      originZ: d = 0
    } = o;
    r.transformOrigin = `${l} ${u} ${d}`;
  }
}
function iS(e, {
  style: t,
  vars: n
}, r, s) {
  const o = e.style;
  let i;
  for (i in t) o[i] = t[i];
  s == null || s.applyProjectionStyles(o, r);
  for (i in n) o.setProperty(i, n[i]);
}
function Fy(e, t) {
  return t.max === t.min ? 0 : e / (t.max - t.min) * 100;
}
const Yo = {
    correct: (e, t) => {
      if (!t.target) return e;
      if (typeof e == "string") if (B.test(e)) e = parseFloat(e);else return e;
      const n = Fy(e, t.target.x),
        r = Fy(e, t.target.y);
      return `${n}% ${r}%`;
    }
  },
  ZO = {
    correct: (e, {
      treeScale: t,
      projectionDelta: n
    }) => {
      const r = e,
        s = Kt.parse(e);
      if (s.length > 5) return r;
      const o = Kt.createTransformer(e),
        i = typeof s[0] != "number" ? 1 : 0,
        a = n.x.scale * t.x,
        l = n.y.scale * t.y;
      s[0 + i] /= a, s[1 + i] /= l;
      const u = ae(a, l, 0.5);
      return typeof s[2 + i] == "number" && (s[2 + i] /= u), typeof s[3 + i] == "number" && (s[3 + i] /= u), o(s);
    }
  },
  Gf = {
    borderRadius: {
      ...Yo,
      applyTo: ["borderTopLeftRadius", "borderTopRightRadius", "borderBottomLeftRadius", "borderBottomRightRadius"]
    },
    borderTopLeftRadius: Yo,
    borderTopRightRadius: Yo,
    borderBottomLeftRadius: Yo,
    borderBottomRightRadius: Yo,
    boxShadow: ZO
  };
function aS(e, {
  layout: t,
  layoutId: n
}) {
  return Io.has(e) || e.startsWith("origin") || (t || n !== void 0) && (!!Gf[e] || e === "opacity");
}
function Kp(e, t, n) {
  var i;
  const r = e.style,
    s = t == null ? void 0 : t.style,
    o = {};
  if (!r) return o;
  for (const a in r) (Ve(r[a]) || s && Ve(s[a]) || aS(a, e) || ((i = n == null ? void 0 : n.getValue(a)) == null ? void 0 : i.liveStyle) !== void 0) && (o[a] = r[a]);
  return o;
}
function JO(e) {
  return window.getComputedStyle(e);
}
class eL extends tS {
  constructor() {
    super(...arguments), this.type = "html", this.renderInstance = iS;
  }
  readValueFromInstance(t, n) {
    var r;
    if (Io.has(n)) return (r = this.projection) != null && r.isProjecting ? Df(n) : wM(t, n);
    {
      const s = JO(t),
        o = (gb(n) ? s.getPropertyValue(n) : s[n]) || 0;
      return typeof o == "string" ? o.trim() : o;
    }
  }
  measureInstanceViewportBox(t, {
    transformPagePoint: n
  }) {
    return oS(t, n);
  }
  build(t, n, r) {
    qp(t, n, r.transformTemplate);
  }
  scrapeMotionValuesFromProps(t, n, r) {
    return Kp(t, n, r);
  }
}
const tL = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
  },
  nL = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
  };
function rL(e, t, n = 1, r = 0, s = !0) {
  e.pathLength = 1;
  const o = s ? tL : nL;
  e[o.offset] = `${-r}`, e[o.array] = `${t} ${n}`;
}
const sL = ["offsetDistance", "offsetPath", "offsetRotate", "offsetAnchor"];
function lS(e, {
  attrX: t,
  attrY: n,
  attrScale: r,
  pathLength: s,
  pathSpacing: o = 1,
  pathOffset: i = 0,
  ...a
}, l, u, d) {
  if (qp(e, a, u), l) {
    e.style.viewBox && (e.attrs.viewBox = e.style.viewBox);
    return;
  }
  e.attrs = e.style, e.style = {};
  const {
    attrs: c,
    style: f
  } = e;
  c.transform && (f.transform = c.transform, delete c.transform), (f.transform || c.transformOrigin) && (f.transformOrigin = c.transformOrigin ?? "50% 50%", delete c.transformOrigin), f.transform && (f.transformBox = (d == null ? void 0 : d.transformBox) ?? "fill-box", delete c.transformBox);
  for (const h of sL) c[h] !== void 0 && (f[h] = c[h], delete c[h]);
  t !== void 0 && (c.x = t), n !== void 0 && (c.y = n), r !== void 0 && (c.scale = r), s !== void 0 && rL(c, s, o, i, !1);
}
const uS = new Set(["baseFrequency", "diffuseConstant", "kernelMatrix", "kernelUnitLength", "keySplines", "keyTimes", "limitingConeAngle", "markerHeight", "markerWidth", "numOctaves", "targetX", "targetY", "surfaceScale", "specularConstant", "specularExponent", "stdDeviation", "tableValues", "viewBox", "gradientTransform", "pathLength", "startOffset", "textLength", "lengthAdjust"]),
  cS = e => typeof e == "string" && e.toLowerCase() === "svg";
function oL(e, t, n, r) {
  iS(e, t, void 0, r);
  for (const s in t.attrs) e.setAttribute(uS.has(s) ? s : Vp(s), t.attrs[s]);
}
function dS(e, t, n) {
  const r = Kp(e, t, n);
  for (const s in e) if (Ve(e[s]) || Ve(t[s])) {
    const o = Do.indexOf(s) !== -1 ? "attr" + s.charAt(0).toUpperCase() + s.substring(1) : s;
    r[o] = e[s];
  }
  return r;
}
class iL extends tS {
  constructor() {
    super(...arguments), this.type = "svg", this.isSVGTag = !1, this.measureInstanceViewportBox = Ne;
  }
  getBaseTargetFromProps(t, n) {
    return t[n];
  }
  readValueFromInstance(t, n) {
    if (Io.has(n)) {
      const r = Hb(n);
      return r && r.default || 0;
    }
    return n = uS.has(n) ? n : Vp(n), t.getAttribute(n);
  }
  scrapeMotionValuesFromProps(t, n, r) {
    return dS(t, n, r);
  }
  build(t, n, r) {
    lS(t, n, this.isSVGTag, r.transformTemplate, r.style);
  }
  renderInstance(t, n, r, s) {
    oL(t, n, r, s);
  }
  mount(t) {
    this.isSVGTag = cS(t.tagName), super.mount(t);
  }
}
const aL = Wp.length;
function fS(e) {
  if (!e) return;
  if (!e.isControllingVariants) {
    const n = e.parent ? fS(e.parent) || {} : {};
    return e.props.initial !== void 0 && (n.initial = e.props.initial), n;
  }
  const t = {};
  for (let n = 0; n < aL; n++) {
    const r = Wp[n],
      s = e.props[r];
    (Wi(s) || s === !1) && (t[r] = s);
  }
  return t;
}
function hS(e, t) {
  if (!Array.isArray(t)) return !1;
  const n = t.length;
  if (n !== e.length) return !1;
  for (let r = 0; r < n; r++) if (t[r] !== e[r]) return !1;
  return !0;
}
const lL = [...Up].reverse(),
  uL = Up.length;
function cL(e) {
  return t => Promise.all(t.map(({
    animation: n,
    options: r
  }) => lO(e, n, r)));
}
function dL(e) {
  let t = cL(e),
    n = _y(),
    r = !0,
    s = !1;
  const o = u => (d, c) => {
    var h;
    const f = os(e, c, u === "exit" ? (h = e.presenceContext) == null ? void 0 : h.custom : void 0);
    if (f) {
      const {
        transition: w,
        transitionEnd: m,
        ...x
      } = f;
      d = {
        ...d,
        ...x,
        ...m
      };
    }
    return d;
  };
  function i(u) {
    t = u(e);
  }
  function a(u) {
    const {
        props: d
      } = e,
      c = fS(e.parent) || {},
      f = [],
      h = new Set();
    let w = {},
      m = 1 / 0;
    for (let g = 0; g < uL; g++) {
      const v = lL[g],
        b = n[v],
        S = d[v] !== void 0 ? d[v] : c[v],
        E = Wi(S),
        P = v === u ? b.isActive : null;
      P === !1 && (m = g);
      let T = S === c[v] && S !== d[v] && E;
      if (T && (r || s) && e.manuallyAnimateOnMount && (T = !1), b.protectedKeys = {
        ...w
      }, !b.isActive && P === null || !S && !b.prevProp || $u(S) || typeof S == "boolean") continue;
      if (v === "exit" && b.isActive && P !== !0) {
        b.prevResolvedValues && (w = {
          ...w,
          ...b.prevResolvedValues
        });
        continue;
      }
      const k = fL(b.prevProp, S);
      let A = k || v === u && b.isActive && !T && E || g > m && E,
        R = !1;
      const I = Array.isArray(S) ? S : [S];
      let O = I.reduce(o(v), {});
      P === !1 && (O = {});
      const {
          prevResolvedValues: U = {}
        } = b,
        D = {
          ...U,
          ...O
        },
        q = N => {
          A = !0, h.has(N) && (R = !0, h.delete(N)), b.needsAnimating[N] = !0;
          const j = e.getValue(N);
          j && (j.liveStyle = !1);
        };
      for (const N in D) {
        const j = O[N],
          F = U[N];
        if (w.hasOwnProperty(N)) continue;
        let W = !1;
        zf(j) && zf(F) ? W = !hS(j, F) || k : W = j !== F, W ? j != null ? q(N) : h.add(N) : j !== void 0 && h.has(N) ? q(N) : b.protectedKeys[N] = !0;
      }
      b.prevProp = S, b.prevResolvedValues = O, b.isActive && (w = {
        ...w,
        ...O
      }), (r || s) && e.blockInitialAnimation && (A = !1);
      const z = T && k;
      A && (!z || R) && f.push(...I.map(N => {
        const j = {
          type: v
        };
        if (typeof N == "string" && (r || s) && !z && e.manuallyAnimateOnMount && e.parent) {
          const {
              parent: F
            } = e,
            W = os(F, N);
          if (F.enteringChildren && W) {
            const {
              delayChildren: $
            } = W.transition || {};
            j.delay = Ib(F.enteringChildren, e, $);
          }
        }
        return {
          animation: N,
          options: j
        };
      }));
    }
    if (h.size) {
      const g = {};
      if (typeof d.initial != "boolean") {
        const v = os(e, Array.isArray(d.initial) ? d.initial[0] : d.initial);
        v && v.transition && (g.transition = v.transition);
      }
      h.forEach(v => {
        const b = e.getBaseTarget(v),
          S = e.getValue(v);
        S && (S.liveStyle = !0), g[v] = b ?? null;
      }), f.push({
        animation: g
      });
    }
    let x = !!f.length;
    return r && (d.initial === !1 || d.initial === d.animate) && !e.manuallyAnimateOnMount && (x = !1), r = !1, s = !1, x ? t(f) : Promise.resolve();
  }
  function l(u, d) {
    var f;
    if (n[u].isActive === d) return Promise.resolve();
    (f = e.variantChildren) == null || f.forEach(h => {
      var w;
      return (w = h.animationState) == null ? void 0 : w.setActive(u, d);
    }), n[u].isActive = d;
    const c = a(u);
    for (const h in n) n[h].protectedKeys = {};
    return c;
  }
  return {
    animateChanges: a,
    setActive: l,
    setAnimateFunction: i,
    getState: () => n,
    reset: () => {
      n = _y(), s = !0;
    }
  };
}
function fL(e, t) {
  return typeof t == "string" ? t !== e : Array.isArray(t) ? !hS(t, e) : !1;
}
function _r(e = !1) {
  return {
    isActive: e,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function _y() {
  return {
    animate: _r(!0),
    whileInView: _r(),
    whileHover: _r(),
    whileTap: _r(),
    whileDrag: _r(),
    whileFocus: _r(),
    exit: _r()
  };
}
function Yf(e, t) {
  e.min = t.min, e.max = t.max;
}
function _t(e, t) {
  Yf(e.x, t.x), Yf(e.y, t.y);
}
function Vy(e, t) {
  e.translate = t.translate, e.scale = t.scale, e.originPoint = t.originPoint, e.origin = t.origin;
}
const pS = 1e-4,
  hL = 1 - pS,
  pL = 1 + pS,
  mS = 0.01,
  mL = 0 - mS,
  gL = 0 + mS;
function Ze(e) {
  return e.max - e.min;
}
function yL(e, t, n) {
  return Math.abs(e - t) <= n;
}
function By(e, t, n, r = 0.5) {
  e.origin = r, e.originPoint = ae(t.min, t.max, e.origin), e.scale = Ze(n) / Ze(t), e.translate = ae(n.min, n.max, e.origin) - e.originPoint, (e.scale >= hL && e.scale <= pL || isNaN(e.scale)) && (e.scale = 1), (e.translate >= mL && e.translate <= gL || isNaN(e.translate)) && (e.translate = 0);
}
function gi(e, t, n, r) {
  By(e.x, t.x, n.x, r ? r.originX : void 0), By(e.y, t.y, n.y, r ? r.originY : void 0);
}
function zy(e, t, n, r = 0) {
  const s = r ? ae(n.min, n.max, r) : n.min;
  e.min = s + t.min, e.max = e.min + Ze(t);
}
function vL(e, t, n, r) {
  zy(e.x, t.x, n.x, r == null ? void 0 : r.x), zy(e.y, t.y, n.y, r == null ? void 0 : r.y);
}
function $y(e, t, n, r = 0) {
  const s = r ? ae(n.min, n.max, r) : n.min;
  e.min = t.min - s, e.max = e.min + Ze(t);
}
function lu(e, t, n, r) {
  $y(e.x, t.x, n.x, r == null ? void 0 : r.x), $y(e.y, t.y, n.y, r == null ? void 0 : r.y);
}
function Uy(e, t, n, r, s) {
  return e -= t, e = au(e, 1 / n, r), s !== void 0 && (e = au(e, 1 / s, r)), e;
}
function xL(e, t = 0, n = 1, r = 0.5, s, o = e, i = e) {
  if (hn.test(t) && (t = parseFloat(t), t = ae(i.min, i.max, t / 100) - i.min), typeof t != "number") return;
  let a = ae(o.min, o.max, r);
  e === o && (a -= t), e.min = Uy(e.min, t, n, a, s), e.max = Uy(e.max, t, n, a, s);
}
function Wy(e, t, [n, r, s], o, i) {
  xL(e, t[n], t[r], t[s], t.scale, o, i);
}
const wL = ["x", "scaleX", "originX"],
  bL = ["y", "scaleY", "originY"];
function Hy(e, t, n, r) {
  Wy(e.x, t, wL, n ? n.x : void 0, r ? r.x : void 0), Wy(e.y, t, bL, n ? n.y : void 0, r ? r.y : void 0);
}
function qy(e) {
  return e.translate === 0 && e.scale === 1;
}
function gS(e) {
  return qy(e.x) && qy(e.y);
}
function Ky(e, t) {
  return e.min === t.min && e.max === t.max;
}
function SL(e, t) {
  return Ky(e.x, t.x) && Ky(e.y, t.y);
}
function Qy(e, t) {
  return Math.round(e.min) === Math.round(t.min) && Math.round(e.max) === Math.round(t.max);
}
function yS(e, t) {
  return Qy(e.x, t.x) && Qy(e.y, t.y);
}
function Gy(e) {
  return Ze(e.x) / Ze(e.y);
}
function Yy(e, t) {
  return e.translate === t.translate && e.scale === t.scale && e.originPoint === t.originPoint;
}
function tn(e) {
  return [e("x"), e("y")];
}
function EL(e, t, n) {
  let r = "";
  const s = e.x.translate / t.x,
    o = e.y.translate / t.y,
    i = (n == null ? void 0 : n.z) || 0;
  if ((s || o || i) && (r = `translate3d(${s}px, ${o}px, ${i}px) `), (t.x !== 1 || t.y !== 1) && (r += `scale(${1 / t.x}, ${1 / t.y}) `), n) {
    const {
      transformPerspective: u,
      rotate: d,
      pathRotation: c,
      rotateX: f,
      rotateY: h,
      skewX: w,
      skewY: m
    } = n;
    u && (r = `perspective(${u}px) ${r}`), d && (r += `rotate(${d}deg) `), c && (r += `rotate(${c}deg) `), f && (r += `rotateX(${f}deg) `), h && (r += `rotateY(${h}deg) `), w && (r += `skewX(${w}deg) `), m && (r += `skewY(${m}deg) `);
  }
  const a = e.x.scale * t.x,
    l = e.y.scale * t.y;
  return (a !== 1 || l !== 1) && (r += `scale(${a}, ${l})`), r || "none";
}
const vS = ["borderTopLeftRadius", "borderTopRightRadius", "borderBottomLeftRadius", "borderBottomRightRadius"],
  CL = vS.length,
  Xy = e => typeof e == "string" ? parseFloat(e) : e,
  Zy = e => typeof e == "number" || B.test(e);
function TL(e, t, n, r, s, o) {
  s ? (e.opacity = ae(0, n.opacity ?? 1, PL(r)), e.opacityExit = ae(t.opacity ?? 1, 0, kL(r))) : o && (e.opacity = ae(t.opacity ?? 1, n.opacity ?? 1, r));
  for (let i = 0; i < CL; i++) {
    const a = vS[i];
    let l = Jy(t, a),
      u = Jy(n, a);
    if (l === void 0 && u === void 0) continue;
    l || (l = 0), u || (u = 0), l === 0 || u === 0 || Zy(l) === Zy(u) ? (e[a] = Math.max(ae(Xy(l), Xy(u), r), 0), (hn.test(u) || hn.test(l)) && (e[a] += "%")) : e[a] = u;
  }
  (t.rotate || n.rotate) && (e.rotate = ae(t.rotate || 0, n.rotate || 0, r));
}
function Jy(e, t) {
  return e[t] !== void 0 ? e[t] : e.borderRadius;
}
const PL = xS(0, 0.5, cb),
  kL = xS(0.5, 0.95, At);
function xS(e, t, n) {
  return r => r < e ? 0 : r > t ? 1 : n($i(e, t, r));
}
function RL(e, t, n) {
  const r = Ve(e) ? e : Co(e);
  return r.start(Fp("", r, t, n)), r.animation;
}
function Hi(e, t, n, r = {
  passive: !0
}) {
  return e.addEventListener(t, n, r), () => e.removeEventListener(t, n);
}
const NL = (e, t) => e.depth - t.depth;
class AL {
  constructor() {
    this.children = [], this.isDirty = !1;
  }
  add(t) {
    Tp(this.children, t), this.isDirty = !0;
  }
  remove(t) {
    Jl(this.children, t), this.isDirty = !0;
  }
  forEach(t) {
    this.isDirty && this.children.sort(NL), this.isDirty = !1, this.children.forEach(t);
  }
}
function jL(e, t) {
  const n = Xe.now(),
    r = ({
      timestamp: s
    }) => {
      const o = s - n;
      o >= t && (Nr(r), e(o - t));
    };
  return le.setup(r, !0), () => Nr(r);
}
function ml(e) {
  return Ve(e) ? e.get() : e;
}
class ML {
  constructor() {
    this.members = [];
  }
  add(t) {
    Tp(this.members, t);
    for (let n = this.members.length - 1; n >= 0; n--) {
      const r = this.members[n];
      if (r === t || r === this.lead || r === this.prevLead) continue;
      const s = r.instance;
      (!s || s.isConnected === !1) && !r.snapshot && (Jl(this.members, r), r.unmount());
    }
    t.scheduleRender();
  }
  remove(t) {
    if (Jl(this.members, t), t === this.prevLead && (this.prevLead = void 0), t === this.lead) {
      const n = this.members[this.members.length - 1];
      n && this.promote(n);
    }
  }
  relegate(t) {
    var n;
    for (let r = this.members.indexOf(t) - 1; r >= 0; r--) {
      const s = this.members[r];
      if (s.isPresent !== !1 && ((n = s.instance) == null ? void 0 : n.isConnected) !== !1) return this.promote(s), !0;
    }
    return !1;
  }
  promote(t, n) {
    var s;
    const r = this.lead;
    if (t !== r && (this.prevLead = r, this.lead = t, t.show(), r)) {
      r.updateSnapshot(), t.scheduleRender();
      const {
          layoutDependency: o
        } = r.options,
        {
          layoutDependency: i
        } = t.options;
      (o === void 0 || o !== i) && (t.resumeFrom = r, n && (r.preserveOpacity = !0), r.snapshot && (t.snapshot = r.snapshot, t.snapshot.latestValues = r.animationValues || r.latestValues), (s = t.root) != null && s.isUpdating && (t.isLayoutDirty = !0)), t.options.crossfade === !1 && r.hide();
    }
  }
  exitAnimationComplete() {
    this.members.forEach(t => {
      var n, r, s, o, i;
      (r = (n = t.options).onExitComplete) == null || r.call(n), (i = (s = t.resumingFrom) == null ? void 0 : (o = s.options).onExitComplete) == null || i.call(o);
    });
  }
  scheduleRender() {
    this.members.forEach(t => t.instance && t.scheduleRender(!1));
  }
  removeLeadSnapshot() {
    var t;
    (t = this.lead) != null && t.snapshot && (this.lead.snapshot = void 0);
  }
}
const gl = {
    hasAnimatedSinceResize: !0,
    hasEverUpdated: !1
  },
  Uc = ["", "X", "Y", "Z"],
  OL = 1e3;
let LL = 0;
function Wc(e, t, n, r) {
  const {
    latestValues: s
  } = t;
  s[e] && (n[e] = s[e], t.setStaticValue(e, 0), r && (r[e] = 0));
}
function wS(e) {
  if (e.hasCheckedOptimisedAppear = !0, e.root === e) return;
  const {
    visualElement: t
  } = e.options;
  if (!t) return;
  const n = zb(t);
  if (window.MotionHasOptimisedAnimation(n, "transform")) {
    const {
      layout: s,
      layoutId: o
    } = e.options;
    window.MotionCancelOptimisedAnimation(n, "transform", le, !(s || o));
  }
  const {
    parent: r
  } = e;
  r && !r.hasCheckedOptimisedAppear && wS(r);
}
function bS({
  attachResizeListener: e,
  defaultParent: t,
  measureScroll: n,
  checkIsScrollRoot: r,
  resetTransform: s
}) {
  return class {
    constructor(i = {}, a = t == null ? void 0 : t()) {
      this.id = LL++, this.animationId = 0, this.animationCommitId = 0, this.children = new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.isProjectionDirty = !1, this.isSharedProjectionDirty = !1, this.isTransformDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.hasCheckedOptimisedAppear = !1, this.treeScale = {
        x: 1,
        y: 1
      }, this.eventHandlers = new Map(), this.hasTreeAnimated = !1, this.layoutVersion = 0, this.updateScheduled = !1, this.scheduleUpdate = () => this.update(), this.projectionUpdateScheduled = !1, this.checkUpdateFailed = () => {
        this.isUpdating && (this.isUpdating = !1, this.clearAllSnapshots());
      }, this.updateProjection = () => {
        this.projectionUpdateScheduled = !1, this.nodes.forEach(FL), this.nodes.forEach(UL), this.nodes.forEach(WL), this.nodes.forEach(_L);
      }, this.resolvedRelativeTargetAt = 0, this.linkedParentVersion = 0, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = new Map(), this.latestValues = i, this.root = a ? a.root || a : this, this.path = a ? [...a.path, a] : [], this.parent = a, this.depth = a ? a.depth + 1 : 0;
      for (let l = 0; l < this.path.length; l++) this.path[l].shouldResetTransform = !0;
      this.root === this && (this.nodes = new AL());
    }
    addEventListener(i, a) {
      return this.eventHandlers.has(i) || this.eventHandlers.set(i, new Pp()), this.eventHandlers.get(i).add(a);
    }
    notifyListeners(i, ...a) {
      const l = this.eventHandlers.get(i);
      l && l.notify(...a);
    }
    hasListeners(i) {
      return this.eventHandlers.has(i);
    }
    mount(i) {
      if (this.instance) return;
      this.isSVG = $p(i) && !FO(i), this.instance = i;
      const {
        layoutId: a,
        layout: l,
        visualElement: u
      } = this.options;
      if (u && !u.current && u.mount(i), this.root.nodes.add(this), this.parent && this.parent.children.add(this), this.root.hasTreeAnimated && (l || a) && (this.isLayoutDirty = !0), e) {
        let d,
          c = 0;
        const f = () => this.root.updateBlockedByResize = !1;
        le.read(() => {
          c = window.innerWidth;
        }), e(i, () => {
          const h = window.innerWidth;
          h !== c && (c = h, this.root.updateBlockedByResize = !0, d && d(), d = jL(f, 250), gl.hasAnimatedSinceResize && (gl.hasAnimatedSinceResize = !1, this.nodes.forEach(nv)));
        });
      }
      a && this.root.registerSharedNode(a, this), this.options.animate !== !1 && u && (a || l) && this.addEventListener("didUpdate", ({
        delta: d,
        hasLayoutChanged: c,
        hasRelativeLayoutChanged: f,
        layout: h
      }) => {
        if (this.isTreeAnimationBlocked()) {
          this.target = void 0, this.relativeTarget = void 0;
          return;
        }
        const w = this.options.transition || u.getDefaultTransition() || GL,
          {
            onLayoutAnimationStart: m,
            onLayoutAnimationComplete: x
          } = u.getProps(),
          g = !this.targetLayout || !yS(this.targetLayout, h),
          v = !c && f;
        if (this.options.layoutRoot || this.resumeFrom || v || c && (g || !this.currentAnimation)) {
          this.resumeFrom && (this.resumingFrom = this.resumeFrom, this.resumingFrom.resumingFrom = void 0);
          const b = {
            ...Ip(w, "layout"),
            onPlay: m,
            onComplete: x
          };
          (u.shouldReduceMotion || this.options.layoutRoot) && (b.delay = 0, b.type = !1), this.startAnimation(b), this.setAnimationOrigin(d, v, b.path);
        } else c || nv(this), this.isLead() && this.options.onExitComplete && this.options.onExitComplete();
        this.targetLayout = h;
      });
    }
    unmount() {
      this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this);
      const i = this.getStack();
      i && i.remove(this), this.parent && this.parent.children.delete(this), this.instance = void 0, this.eventHandlers.clear(), Nr(this.updateProjection);
    }
    blockUpdate() {
      this.updateManuallyBlocked = !0;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = !1;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || !1;
    }
    startUpdate() {
      this.isUpdateBlocked() || (this.isUpdating = !0, this.nodes && this.nodes.forEach(HL), this.animationId++);
    }
    getTransformTemplate() {
      const {
        visualElement: i
      } = this.options;
      return i && i.getProps().transformTemplate;
    }
    willUpdate(i = !0) {
      if (this.root.hasTreeAnimated = !0, this.root.isUpdateBlocked()) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear && wS(this), !this.root.isUpdating && this.root.startUpdate(), this.isLayoutDirty) return;
      this.isLayoutDirty = !0;
      for (let d = 0; d < this.path.length; d++) {
        const c = this.path[d];
        c.shouldResetTransform = !0, (typeof c.latestValues.x == "string" || typeof c.latestValues.y == "string") && (c.isLayoutDirty = !0), c.updateScroll("snapshot"), c.options.layoutRoot && c.willUpdate(!1);
      }
      const {
        layoutId: a,
        layout: l
      } = this.options;
      if (a === void 0 && !l) return;
      const u = this.getTransformTemplate();
      this.prevTransformTemplateValue = u ? u(this.latestValues, "") : void 0, this.updateSnapshot(), i && this.notifyListeners("willUpdate");
    }
    update() {
      if (this.updateScheduled = !1, this.isUpdateBlocked()) {
        const l = this.updateBlockedByResize;
        this.unblockUpdate(), this.updateBlockedByResize = !1, this.clearAllSnapshots(), l && this.nodes.forEach(BL), this.nodes.forEach(ev);
        return;
      }
      if (this.animationId <= this.animationCommitId) {
        this.nodes.forEach(tv);
        return;
      }
      this.animationCommitId = this.animationId, this.isUpdating ? (this.isUpdating = !1, this.nodes.forEach(zL), this.nodes.forEach($L), this.nodes.forEach(DL), this.nodes.forEach(IL)) : this.nodes.forEach(tv), this.clearAllSnapshots();
      const a = Xe.now();
      Fe.delta = gn(0, 1e3 / 60, a - Fe.timestamp), Fe.timestamp = a, Fe.isProcessing = !0, Dc.update.process(Fe), Dc.preRender.process(Fe), Dc.render.process(Fe), Fe.isProcessing = !1;
    }
    didUpdate() {
      this.updateScheduled || (this.updateScheduled = !0, Bp.read(this.scheduleUpdate));
    }
    clearAllSnapshots() {
      this.nodes.forEach(VL), this.sharedNodes.forEach(qL);
    }
    scheduleUpdateProjection() {
      this.projectionUpdateScheduled || (this.projectionUpdateScheduled = !0, le.preRender(this.updateProjection, !1, !0));
    }
    scheduleCheckAfterUnmount() {
      le.postRender(() => {
        this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed();
      });
    }
    updateSnapshot() {
      this.snapshot || !this.instance || (this.snapshot = this.measure(), this.snapshot && !Ze(this.snapshot.measuredBox.x) && !Ze(this.snapshot.measuredBox.y) && (this.snapshot = void 0));
    }
    updateLayout() {
      if (!this.instance || (this.updateScroll(), !(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty)) return;
      if (this.resumeFrom && !this.resumeFrom.instance) for (let l = 0; l < this.path.length; l++) this.path[l].updateScroll();
      const i = this.layout;
      this.layout = this.measure(!1), this.layoutVersion++, this.layoutCorrected || (this.layoutCorrected = Ne()), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.layoutBox);
      const {
        visualElement: a
      } = this.options;
      a && a.notify("LayoutMeasure", this.layout.layoutBox, i ? i.layoutBox : void 0);
    }
    updateScroll(i = "measure") {
      let a = !!(this.options.layoutScroll && this.instance);
      if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === i && (a = !1), a && this.instance) {
        const l = r(this.instance);
        this.scroll = {
          animationId: this.root.animationId,
          phase: i,
          isRoot: l,
          offset: n(this.instance),
          wasRoot: this.scroll ? this.scroll.isRoot : l
        };
      }
    }
    resetTransform() {
      if (!s) return;
      const i = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout,
        a = this.projectionDelta && !gS(this.projectionDelta),
        l = this.getTransformTemplate(),
        u = l ? l(this.latestValues, "") : void 0,
        d = u !== this.prevTransformTemplateValue;
      i && this.instance && (a || zr(this.latestValues) || d) && (s(this.instance, u), this.shouldResetTransform = !1, this.scheduleRender());
    }
    measure(i = !0) {
      const a = this.measurePageBox();
      let l = this.removeElementScroll(a);
      return i && (l = this.removeTransform(l)), YL(l), {
        animationId: this.root.animationId,
        measuredBox: a,
        layoutBox: l,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      var u;
      const {
        visualElement: i
      } = this.options;
      if (!i) return Ne();
      const a = i.measureViewportBox();
      if (!(((u = this.scroll) == null ? void 0 : u.wasRoot) || this.path.some(XL))) {
        const {
          scroll: d
        } = this.root;
        d && (on(a.x, d.offset.x), on(a.y, d.offset.y));
      }
      return a;
    }
    removeElementScroll(i) {
      var l;
      const a = Ne();
      if (_t(a, i), (l = this.scroll) != null && l.wasRoot) return a;
      for (let u = 0; u < this.path.length; u++) {
        const d = this.path[u],
          {
            scroll: c,
            options: f
          } = d;
        d !== this.root && c && f.layoutScroll && (c.wasRoot && _t(a, i), on(a.x, c.offset.x), on(a.y, c.offset.y));
      }
      return a;
    }
    applyTransform(i, a = !1, l) {
      var d, c;
      const u = l || Ne();
      _t(u, i);
      for (let f = 0; f < this.path.length; f++) {
        const h = this.path[f];
        !a && h.options.layoutScroll && h.scroll && h !== h.root && (on(u.x, -h.scroll.offset.x), on(u.y, -h.scroll.offset.y)), zr(h.latestValues) && pl(u, h.latestValues, (d = h.layout) == null ? void 0 : d.layoutBox);
      }
      return zr(this.latestValues) && pl(u, this.latestValues, (c = this.layout) == null ? void 0 : c.layoutBox), u;
    }
    removeTransform(i) {
      var l;
      const a = Ne();
      _t(a, i);
      for (let u = 0; u < this.path.length; u++) {
        const d = this.path[u];
        if (!zr(d.latestValues)) continue;
        let c;
        d.instance && (Kf(d.latestValues) && d.updateSnapshot(), c = Ne(), _t(c, d.measurePageBox())), Hy(a, d.latestValues, (l = d.snapshot) == null ? void 0 : l.layoutBox, c);
      }
      return zr(this.latestValues) && Hy(a, this.latestValues), a;
    }
    setTargetDelta(i) {
      this.targetDelta = i, this.root.scheduleUpdateProjection(), this.isProjectionDirty = !0;
    }
    setOptions(i) {
      this.options = {
        ...this.options,
        ...i,
        crossfade: i.crossfade !== void 0 ? i.crossfade : !0
      };
    }
    clearMeasurements() {
      this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
    }
    forceRelativeParentToResolveTarget() {
      this.relativeParent && this.relativeParent.resolvedRelativeTargetAt !== Fe.timestamp && this.relativeParent.resolveTargetDelta(!0);
    }
    resolveTargetDelta(i = !1) {
      var h;
      const a = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = a.isProjectionDirty), this.isTransformDirty || (this.isTransformDirty = a.isTransformDirty), this.isSharedProjectionDirty || (this.isSharedProjectionDirty = a.isSharedProjectionDirty);
      const l = !!this.resumingFrom || this !== a;
      if (!(i || l && this.isSharedProjectionDirty || this.isProjectionDirty || (h = this.parent) != null && h.isProjectionDirty || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize)) return;
      const {
        layout: d,
        layoutId: c
      } = this.options;
      if (!this.layout || !(d || c)) return;
      this.resolvedRelativeTargetAt = Fe.timestamp;
      const f = this.getClosestProjectingParent();
      f && this.linkedParentVersion !== f.layoutVersion && !f.options.layoutRoot && this.removeRelativeTarget(), !this.targetDelta && !this.relativeTarget && (this.options.layoutAnchor !== !1 && f && f.layout ? this.createRelativeTarget(f, this.layout.layoutBox, f.layout.layoutBox) : this.removeRelativeTarget()), !(!this.relativeTarget && !this.targetDelta) && (this.target || (this.target = Ne(), this.targetWithTransforms = Ne()), this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target ? (this.forceRelativeParentToResolveTarget(), vL(this.target, this.relativeTarget, this.relativeParent.target, this.options.layoutAnchor || void 0)) : this.targetDelta ? (this.resumingFrom ? this.applyTransform(this.layout.layoutBox, !1, this.target) : _t(this.target, this.layout.layoutBox), sS(this.target, this.targetDelta)) : _t(this.target, this.layout.layoutBox), this.attemptToResolveRelativeTarget && (this.attemptToResolveRelativeTarget = !1, this.options.layoutAnchor !== !1 && f && !!f.resumingFrom == !!this.resumingFrom && !f.options.layoutScroll && f.target && this.animationProgress !== 1 ? this.createRelativeTarget(f, this.target, f.target) : this.relativeParent = this.relativeTarget = void 0));
    }
    getClosestProjectingParent() {
      if (!(!this.parent || Kf(this.parent.latestValues) || rS(this.parent.latestValues))) return this.parent.isProjecting() ? this.parent : this.parent.getClosestProjectingParent();
    }
    isProjecting() {
      return !!((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    createRelativeTarget(i, a, l) {
      this.relativeParent = i, this.linkedParentVersion = i.layoutVersion, this.forceRelativeParentToResolveTarget(), this.relativeTarget = Ne(), this.relativeTargetOrigin = Ne(), lu(this.relativeTargetOrigin, a, l, this.options.layoutAnchor || void 0), _t(this.relativeTarget, this.relativeTargetOrigin);
    }
    removeRelativeTarget() {
      this.relativeParent = this.relativeTarget = void 0;
    }
    calcProjection() {
      var w;
      const i = this.getLead(),
        a = !!this.resumingFrom || this !== i;
      let l = !0;
      if ((this.isProjectionDirty || (w = this.parent) != null && w.isProjectionDirty) && (l = !1), a && (this.isSharedProjectionDirty || this.isTransformDirty) && (l = !1), this.resolvedRelativeTargetAt === Fe.timestamp && (l = !1), l) return;
      const {
        layout: u,
        layoutId: d
      } = this.options;
      if (this.isTreeAnimating = !!(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !this.layout || !(u || d)) return;
      _t(this.layoutCorrected, this.layout.layoutBox);
      const c = this.treeScale.x,
        f = this.treeScale.y;
      KO(this.layoutCorrected, this.treeScale, this.path, a), i.layout && !i.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1) && (i.target = i.layout.layoutBox, i.targetWithTransforms = Ne());
      const {
        target: h
      } = i;
      if (!h) {
        this.prevProjectionDelta && (this.createProjectionDeltas(), this.scheduleRender());
        return;
      }
      !this.projectionDelta || !this.prevProjectionDelta ? this.createProjectionDeltas() : (Vy(this.prevProjectionDelta.x, this.projectionDelta.x), Vy(this.prevProjectionDelta.y, this.projectionDelta.y)), gi(this.projectionDelta, this.layoutCorrected, h, this.latestValues), (this.treeScale.x !== c || this.treeScale.y !== f || !Yy(this.projectionDelta.x, this.prevProjectionDelta.x) || !Yy(this.projectionDelta.y, this.prevProjectionDelta.y)) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", h));
    }
    hide() {
      this.isVisible = !1;
    }
    show() {
      this.isVisible = !0;
    }
    scheduleRender(i = !0) {
      var a;
      if ((a = this.options.visualElement) == null || a.scheduleRender(), i) {
        const l = this.getStack();
        l && l.scheduleRender();
      }
      this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
    }
    createProjectionDeltas() {
      this.prevProjectionDelta = zs(), this.projectionDelta = zs(), this.projectionDeltaWithTransform = zs();
    }
    setAnimationOrigin(i, a = !1, l) {
      const u = this.snapshot,
        d = u ? u.latestValues : {},
        c = {
          ...this.latestValues
        },
        f = zs();
      (!this.relativeParent || !this.relativeParent.options.layoutRoot) && (this.relativeTarget = this.relativeTargetOrigin = void 0), this.attemptToResolveRelativeTarget = !a;
      const h = Ne(),
        w = u ? u.source : void 0,
        m = this.layout ? this.layout.source : void 0,
        x = w !== m,
        g = this.getStack(),
        v = !g || g.members.length <= 1,
        b = !!(x && !v && this.options.crossfade === !0 && !this.path.some(QL));
      this.animationProgress = 0;
      let S;
      const E = l == null ? void 0 : l.interpolateProjection(i);
      this.mixTargetDelta = P => {
        const T = P / 1e3,
          k = E == null ? void 0 : E(T);
        k ? (f.x.translate = k.x, f.x.scale = ae(i.x.scale, 1, T), f.x.origin = i.x.origin, f.x.originPoint = i.x.originPoint, f.y.translate = k.y, f.y.scale = ae(i.y.scale, 1, T), f.y.origin = i.y.origin, f.y.originPoint = i.y.originPoint) : (rv(f.x, i.x, T), rv(f.y, i.y, T)), this.setTargetDelta(f), this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout && (lu(h, this.layout.layoutBox, this.relativeParent.layout.layoutBox, this.options.layoutAnchor || void 0), KL(this.relativeTarget, this.relativeTargetOrigin, h, T), S && SL(this.relativeTarget, S) && (this.isProjectionDirty = !1), S || (S = Ne()), _t(S, this.relativeTarget)), x && (this.animationValues = c, TL(c, d, this.latestValues, T, b, v)), k && k.rotate !== void 0 && (this.animationValues || (this.animationValues = c), this.animationValues.pathRotation = k.rotate), this.root.scheduleUpdateProjection(), this.scheduleRender(), this.animationProgress = T;
      }, this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(i) {
      var a, l, u;
      this.notifyListeners("animationStart"), (a = this.currentAnimation) == null || a.stop(), (u = (l = this.resumingFrom) == null ? void 0 : l.currentAnimation) == null || u.stop(), this.pendingAnimation && (Nr(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = le.update(() => {
        gl.hasAnimatedSinceResize = !0, this.motionValue || (this.motionValue = Co(0)), this.motionValue.jump(0, !1), this.currentAnimation = RL(this.motionValue, [0, 1e3], {
          ...i,
          velocity: 0,
          isSync: !0,
          onUpdate: d => {
            this.mixTargetDelta(d), i.onUpdate && i.onUpdate(d);
          },
          onStop: () => {},
          onComplete: () => {
            i.onComplete && i.onComplete(), this.completeAnimation();
          }
        }), this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation), this.pendingAnimation = void 0;
      });
    }
    completeAnimation() {
      this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0);
      const i = this.getStack();
      i && i.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      this.currentAnimation && (this.mixTargetDelta && this.mixTargetDelta(OL), this.currentAnimation.stop()), this.completeAnimation();
    }
    applyTransformsToTarget() {
      const i = this.getLead();
      let {
        targetWithTransforms: a,
        target: l,
        layout: u,
        latestValues: d
      } = i;
      if (!(!a || !l || !u)) {
        if (this !== i && this.layout && u && SS(this.options.animationType, this.layout.layoutBox, u.layoutBox)) {
          l = this.target || Ne();
          const c = Ze(this.layout.layoutBox.x);
          l.x.min = i.target.x.min, l.x.max = l.x.min + c;
          const f = Ze(this.layout.layoutBox.y);
          l.y.min = i.target.y.min, l.y.max = l.y.min + f;
        }
        _t(a, l), pl(a, d), gi(this.projectionDeltaWithTransform, this.layoutCorrected, a, d);
      }
    }
    registerSharedNode(i, a) {
      this.sharedNodes.has(i) || this.sharedNodes.set(i, new ML()), this.sharedNodes.get(i).add(a);
      const u = a.options.initialPromotionConfig;
      a.promote({
        transition: u ? u.transition : void 0,
        preserveFollowOpacity: u && u.shouldPreserveFollowOpacity ? u.shouldPreserveFollowOpacity(a) : void 0
      });
    }
    isLead() {
      const i = this.getStack();
      return i ? i.lead === this : !0;
    }
    getLead() {
      var a;
      const {
        layoutId: i
      } = this.options;
      return i ? ((a = this.getStack()) == null ? void 0 : a.lead) || this : this;
    }
    getPrevLead() {
      var a;
      const {
        layoutId: i
      } = this.options;
      return i ? (a = this.getStack()) == null ? void 0 : a.prevLead : void 0;
    }
    getStack() {
      const {
        layoutId: i
      } = this.options;
      if (i) return this.root.sharedNodes.get(i);
    }
    promote({
      needsReset: i,
      transition: a,
      preserveFollowOpacity: l
    } = {}) {
      const u = this.getStack();
      u && u.promote(this, l), i && (this.projectionDelta = void 0, this.needsReset = !0), a && this.setOptions({
        transition: a
      });
    }
    relegate() {
      const i = this.getStack();
      return i ? i.relegate(this) : !1;
    }
    resetSkewAndRotation() {
      const {
        visualElement: i
      } = this.options;
      if (!i) return;
      let a = !1;
      const {
        latestValues: l
      } = i;
      if ((l.z || l.rotate || l.rotateX || l.rotateY || l.rotateZ || l.skewX || l.skewY) && (a = !0), !a) return;
      const u = {};
      l.z && Wc("z", i, u, this.animationValues);
      for (let d = 0; d < Uc.length; d++) Wc(`rotate${Uc[d]}`, i, u, this.animationValues), Wc(`skew${Uc[d]}`, i, u, this.animationValues);
      i.render();
      for (const d in u) i.setStaticValue(d, u[d]), this.animationValues && (this.animationValues[d] = u[d]);
      i.scheduleRender();
    }
    applyProjectionStyles(i, a) {
      if (!this.instance || this.isSVG) return;
      if (!this.isVisible) {
        i.visibility = "hidden";
        return;
      }
      const l = this.getTransformTemplate();
      if (this.needsReset) {
        this.needsReset = !1, i.visibility = "", i.opacity = "", i.pointerEvents = ml(a == null ? void 0 : a.pointerEvents) || "", i.transform = l ? l(this.latestValues, "") : "none";
        return;
      }
      const u = this.getLead();
      if (!this.projectionDelta || !this.layout || !u.target) {
        this.options.layoutId && (i.opacity = this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1, i.pointerEvents = ml(a == null ? void 0 : a.pointerEvents) || ""), this.hasProjected && !zr(this.latestValues) && (i.transform = l ? l({}, "") : "none", this.hasProjected = !1);
        return;
      }
      i.visibility = "";
      const d = u.animationValues || u.latestValues;
      this.applyTransformsToTarget();
      let c = EL(this.projectionDeltaWithTransform, this.treeScale, d);
      l && (c = l(d, c)), i.transform = c;
      const {
        x: f,
        y: h
      } = this.projectionDelta;
      i.transformOrigin = `${f.origin * 100}% ${h.origin * 100}% 0`, u.animationValues ? i.opacity = u === this ? d.opacity ?? this.latestValues.opacity ?? 1 : this.preserveOpacity ? this.latestValues.opacity : d.opacityExit : i.opacity = u === this ? d.opacity !== void 0 ? d.opacity : "" : d.opacityExit !== void 0 ? d.opacityExit : 0;
      for (const w in Gf) {
        if (d[w] === void 0) continue;
        const {
            correct: m,
            applyTo: x,
            isCSSVariable: g
          } = Gf[w],
          v = c === "none" ? d[w] : m(d[w], u);
        if (x) {
          const b = x.length;
          for (let S = 0; S < b; S++) i[x[S]] = v;
        } else g ? this.options.visualElement.renderState.vars[w] = v : i[w] = v;
      }
      this.options.layoutId && (i.pointerEvents = u === this ? ml(a == null ? void 0 : a.pointerEvents) || "" : "none");
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    resetTree() {
      this.root.nodes.forEach(i => {
        var a;
        return (a = i.currentAnimation) == null ? void 0 : a.stop();
      }), this.root.nodes.forEach(ev), this.root.sharedNodes.clear();
    }
  };
}
function DL(e) {
  e.updateLayout();
}
function IL(e) {
  var n;
  const t = ((n = e.resumeFrom) == null ? void 0 : n.snapshot) || e.snapshot;
  if (e.isLead() && e.layout && t && e.hasListeners("didUpdate")) {
    const {
        layoutBox: r,
        measuredBox: s
      } = e.layout,
      {
        animationType: o
      } = e.options,
      i = t.source !== e.layout.source;
    if (o === "size") tn(c => {
      const f = i ? t.measuredBox[c] : t.layoutBox[c],
        h = Ze(f);
      f.min = r[c].min, f.max = f.min + h;
    });else if (o === "x" || o === "y") {
      const c = o === "x" ? "y" : "x";
      Yf(i ? t.measuredBox[c] : t.layoutBox[c], r[c]);
    } else SS(o, t.layoutBox, r) && tn(c => {
      const f = i ? t.measuredBox[c] : t.layoutBox[c],
        h = Ze(r[c]);
      f.max = f.min + h, e.relativeTarget && !e.currentAnimation && (e.isProjectionDirty = !0, e.relativeTarget[c].max = e.relativeTarget[c].min + h);
    });
    const a = zs();
    gi(a, r, t.layoutBox);
    const l = zs();
    i ? gi(l, e.applyTransform(s, !0), t.measuredBox) : gi(l, r, t.layoutBox);
    const u = !gS(a);
    let d = !1;
    if (!e.resumeFrom) {
      const c = e.getClosestProjectingParent();
      if (c && !c.resumeFrom) {
        const {
          snapshot: f,
          layout: h
        } = c;
        if (f && h) {
          const w = e.options.layoutAnchor || void 0,
            m = Ne();
          lu(m, t.layoutBox, f.layoutBox, w);
          const x = Ne();
          lu(x, r, h.layoutBox, w), yS(m, x) || (d = !0), c.options.layoutRoot && (e.relativeTarget = x, e.relativeTargetOrigin = m, e.relativeParent = c);
        }
      }
    }
    e.notifyListeners("didUpdate", {
      layout: r,
      snapshot: t,
      delta: l,
      layoutDelta: a,
      hasLayoutChanged: u,
      hasRelativeLayoutChanged: d
    });
  } else if (e.isLead()) {
    const {
      onExitComplete: r
    } = e.options;
    r && r();
  }
  e.options.transition = void 0;
}
function FL(e) {
  e.parent && (e.isProjecting() || (e.isProjectionDirty = e.parent.isProjectionDirty), e.isSharedProjectionDirty || (e.isSharedProjectionDirty = !!(e.isProjectionDirty || e.parent.isProjectionDirty || e.parent.isSharedProjectionDirty)), e.isTransformDirty || (e.isTransformDirty = e.parent.isTransformDirty));
}
function _L(e) {
  e.isProjectionDirty = e.isSharedProjectionDirty = e.isTransformDirty = !1;
}
function VL(e) {
  e.clearSnapshot();
}
function ev(e) {
  e.clearMeasurements();
}
function BL(e) {
  e.isLayoutDirty = !0, e.updateLayout();
}
function tv(e) {
  e.isLayoutDirty = !1;
}
function zL(e) {
  e.isAnimationBlocked && e.layout && !e.isLayoutDirty && (e.snapshot = e.layout, e.isLayoutDirty = !0);
}
function $L(e) {
  const {
    visualElement: t
  } = e.options;
  t && t.getProps().onBeforeLayoutMeasure && t.notify("BeforeLayoutMeasure"), e.resetTransform();
}
function nv(e) {
  e.finishAnimation(), e.targetDelta = e.relativeTarget = e.target = void 0, e.isProjectionDirty = !0;
}
function UL(e) {
  e.resolveTargetDelta();
}
function WL(e) {
  e.calcProjection();
}
function HL(e) {
  e.resetSkewAndRotation();
}
function qL(e) {
  e.removeLeadSnapshot();
}
function rv(e, t, n) {
  e.translate = ae(t.translate, 0, n), e.scale = ae(t.scale, 1, n), e.origin = t.origin, e.originPoint = t.originPoint;
}
function sv(e, t, n, r) {
  e.min = ae(t.min, n.min, r), e.max = ae(t.max, n.max, r);
}
function KL(e, t, n, r) {
  sv(e.x, t.x, n.x, r), sv(e.y, t.y, n.y, r);
}
function QL(e) {
  return e.animationValues && e.animationValues.opacityExit !== void 0;
}
const GL = {
    duration: 0.45,
    ease: [0.4, 0, 0.1, 1]
  },
  ov = e => typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(e),
  iv = ov("applewebkit/") && !ov("chrome/") ? Math.round : At;
function av(e) {
  e.min = iv(e.min), e.max = iv(e.max);
}
function YL(e) {
  av(e.x), av(e.y);
}
function SS(e, t, n) {
  return e === "position" || e === "preserve-aspect" && !yL(Gy(t), Gy(n), 0.2);
}
function XL(e) {
  var t;
  return e !== e.root && ((t = e.scroll) == null ? void 0 : t.wasRoot);
}
const ZL = bS({
    attachResizeListener: (e, t) => Hi(e, "resize", t),
    measureScroll: () => {
      var e, t;
      return {
        x: document.documentElement.scrollLeft || ((e = document.body) == null ? void 0 : e.scrollLeft) || 0,
        y: document.documentElement.scrollTop || ((t = document.body) == null ? void 0 : t.scrollTop) || 0
      };
    },
    checkIsScrollRoot: () => !0
  }),
  Hc = {
    current: void 0
  },
  ES = bS({
    measureScroll: e => ({
      x: e.scrollLeft,
      y: e.scrollTop
    }),
    defaultParent: () => {
      if (!Hc.current) {
        const e = new ZL({});
        e.mount(window), e.setOptions({
          layoutScroll: !0
        }), Hc.current = e;
      }
      return Hc.current;
    },
    resetTransform: (e, t) => {
      e.style.transform = t !== void 0 ? t : "none";
    },
    checkIsScrollRoot: e => window.getComputedStyle(e).position === "fixed"
  }),
  Qp = y.createContext({
    transformPagePoint: e => e,
    isStatic: !1,
    reducedMotion: "never"
  });
function lv(e, t) {
  if (typeof e == "function") return e(t);
  e != null && (e.current = t);
}
function JL(...e) {
  return t => {
    let n = !1;
    const r = e.map(s => {
      const o = lv(s, t);
      return !n && typeof o == "function" && (n = !0), o;
    });
    if (n) return () => {
      for (let s = 0; s < r.length; s++) {
        const o = r[s];
        typeof o == "function" ? o() : lv(e[s], null);
      }
    };
  };
}
function e4(...e) {
  return y.useCallback(JL(...e), e);
}
class t4 extends y.Component {
  getSnapshotBeforeUpdate(t) {
    const n = this.props.childRef.current;
    if (cl(n) && t.isPresent && !this.props.isPresent && this.props.pop !== !1) {
      const r = n.offsetParent,
        s = cl(r) && r.offsetWidth || 0,
        o = cl(r) && r.offsetHeight || 0,
        i = getComputedStyle(n),
        a = this.props.sizeRef.current;
      a.height = parseFloat(i.height), a.width = parseFloat(i.width), a.top = n.offsetTop, a.left = n.offsetLeft, a.right = s - a.width - a.left, a.bottom = o - a.height - a.top, a.direction = i.direction;
    }
    return null;
  }
  componentDidUpdate() {}
  render() {
    return this.props.children;
  }
}
function n4({
  children: e,
  isPresent: t,
  anchorX: n,
  anchorY: r,
  root: s,
  pop: o
}) {
  var f;
  const i = y.useId(),
    a = y.useRef(null),
    l = y.useRef({
      width: 0,
      height: 0,
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      direction: "ltr"
    }),
    {
      nonce: u
    } = y.useContext(Qp),
    d = ((f = e.props) == null ? void 0 : f.ref) ?? (e == null ? void 0 : e.ref),
    c = e4(a, d);
  return y.useInsertionEffect(() => {
    const {
      width: h,
      height: w,
      top: m,
      left: x,
      right: g,
      bottom: v,
      direction: b
    } = l.current;
    if (t || o === !1 || !a.current || !h || !w) return;
    const S = b === "rtl",
      E = n === "left" ? S ? `right: ${g}` : `left: ${x}` : S ? `left: ${x}` : `right: ${g}`,
      P = r === "bottom" ? `bottom: ${v}` : `top: ${m}`;
    a.current.dataset.motionPopId = i;
    const T = document.createElement("style");
    u && (T.nonce = u);
    const k = s ?? document.head;
    return k.appendChild(T), T.sheet && T.sheet.insertRule(`
          [data-motion-pop-id="${i}"] {
            position: absolute !important;
            width: ${h}px !important;
            height: ${w}px !important;
            ${E}px !important;
            ${P}px !important;
          }
        `), () => {
      var A;
      (A = a.current) == null || A.removeAttribute("data-motion-pop-id"), k.contains(T) && k.removeChild(T);
    };
  }, [t]), p.jsx(t4, {
    isPresent: t,
    childRef: a,
    sizeRef: l,
    pop: o,
    children: o === !1 ? e : y.cloneElement(e, {
      ref: c
    })
  });
}
const r4 = ({
  children: e,
  initial: t,
  isPresent: n,
  onExitComplete: r,
  custom: s,
  presenceAffectsLayout: o,
  mode: i,
  anchorX: a,
  anchorY: l,
  root: u
}) => {
  const d = Cp(s4),
    c = y.useId();
  let f = !0,
    h = y.useMemo(() => (f = !1, {
      id: c,
      initial: t,
      isPresent: n,
      custom: s,
      onExitComplete: w => {
        d.set(w, !0);
        for (const m of d.values()) if (!m) return;
        r && r();
      },
      register: w => (d.set(w, !1), () => d.delete(w))
    }), [n, d, r]);
  return o && f && (h = {
    ...h
  }), y.useMemo(() => {
    d.forEach((w, m) => d.set(m, !1));
  }, [n]), y.useEffect(() => {
    !n && !d.size && r && r();
  }, [n]), e = p.jsx(n4, {
    pop: i === "popLayout",
    isPresent: n,
    anchorX: a,
    anchorY: l,
    root: u,
    children: e
  }), p.jsx(Vu.Provider, {
    value: h,
    children: e
  });
};
function s4() {
  return new Map();
}
function CS(e = !0) {
  const t = y.useContext(Vu);
  if (t === null) return [!0, null];
  const {
      isPresent: n,
      onExitComplete: r,
      register: s
    } = t,
    o = y.useId();
  y.useEffect(() => {
    if (e) return s(o);
  }, [e]);
  const i = y.useCallback(() => e && r && r(o), [o, r, e]);
  return !n && r ? [!1, i] : [!0];
}
const za = e => e.key || "";
function uv(e) {
  const t = [];
  return y.Children.forEach(e, n => {
    y.isValidElement(n) && t.push(n);
  }), t;
}
const o4 = ({
    children: e,
    custom: t,
    initial: n = !0,
    onExitComplete: r,
    presenceAffectsLayout: s = !0,
    mode: o = "sync",
    propagate: i = !1,
    anchorX: a = "left",
    anchorY: l = "top",
    root: u
  }) => {
    const [d, c] = CS(i),
      f = y.useMemo(() => uv(e), [e]),
      h = i && !d ? [] : f.map(za),
      w = y.useRef(!0),
      m = y.useRef(f),
      x = Cp(() => new Map()),
      g = y.useRef(new Set()),
      [v, b] = y.useState(f),
      [S, E] = y.useState(f);
    Z1(() => {
      w.current = !1, m.current = f;
      for (let k = 0; k < S.length; k++) {
        const A = za(S[k]);
        h.includes(A) ? (x.delete(A), g.current.delete(A)) : x.get(A) !== !0 && x.set(A, !1);
      }
    }, [S, h.length, h.join("-")]);
    const P = [];
    if (f !== v) {
      let k = [...f];
      for (let A = 0; A < S.length; A++) {
        const R = S[A],
          I = za(R);
        h.includes(I) || (k.splice(A, 0, R), P.push(R));
      }
      return o === "wait" && P.length && (k = P), E(uv(k)), b(f), null;
    }
    const {
      forceRender: T
    } = y.useContext(Ep);
    return p.jsx(p.Fragment, {
      children: S.map(k => {
        const A = za(k),
          R = i && !d ? !1 : f === S || h.includes(A),
          I = () => {
            if (g.current.has(A)) return;
            if (x.has(A)) g.current.add(A), x.set(A, !0);else return;
            let O = !0;
            x.forEach(U => {
              U || (O = !1);
            }), O && (T == null || T(), E(m.current), i && (c == null || c()), r && r());
          };
        return p.jsx(r4, {
          isPresent: R,
          initial: !w.current || n ? void 0 : !1,
          custom: t,
          presenceAffectsLayout: s,
          mode: o,
          root: u,
          onExitComplete: R ? void 0 : I,
          anchorX: a,
          anchorY: l,
          children: k
        }, A);
      })
    });
  },
  TS = y.createContext({
    strict: !1
  }),
  cv = {
    animation: ["animate", "variants", "whileHover", "whileTap", "exit", "whileInView", "whileFocus", "whileDrag"],
    exit: ["exit"],
    drag: ["drag", "dragControls"],
    focus: ["whileFocus"],
    hover: ["whileHover", "onHoverStart", "onHoverEnd"],
    tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
    pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
    inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
    layout: ["layout", "layoutId"]
  };
let dv = !1;
function i4() {
  if (dv) return;
  const e = {};
  for (const t in cv) e[t] = {
    isEnabled: n => cv[t].some(r => !!n[r])
  };
  eS(e), dv = !0;
}
function PS() {
  return i4(), UO();
}
function a4(e) {
  const t = PS();
  for (const n in e) t[n] = {
    ...t[n],
    ...e[n]
  };
  eS(t);
}
const l4 = new Set(["animate", "exit", "variants", "initial", "style", "values", "variants", "transition", "transformTemplate", "custom", "inherit", "onBeforeLayoutMeasure", "onAnimationStart", "onAnimationComplete", "onUpdate", "onDragStart", "onDrag", "onDragEnd", "onMeasureDragConstraints", "onDirectionLock", "onDragTransitionEnd", "_dragX", "_dragY", "onHoverStart", "onHoverEnd", "onViewportEnter", "onViewportLeave", "globalTapTarget", "propagate", "ignoreStrict", "viewport"]);
function uu(e) {
  return e.startsWith("while") || e.startsWith("drag") && e !== "draggable" || e.startsWith("layout") || e.startsWith("onTap") || e.startsWith("onPan") || e.startsWith("onLayout") || l4.has(e);
}
let kS = e => !uu(e);
function u4(e) {
  typeof e == "function" && (kS = t => t.startsWith("on") ? !uu(t) : e(t));
}
try {
  u4(require("@emotion/is-prop-valid").default);
} catch {}
function c4(e, t, n) {
  const r = {};
  for (const s in e) s === "values" && typeof e.values == "object" || Ve(e[s]) || (kS(s) || n === !0 && uu(s) || !t && !uu(s) || e.draggable && s.startsWith("onDrag")) && (r[s] = e[s]);
  return r;
}
const Wu = y.createContext({});
function d4(e, t) {
  if (Uu(e)) {
    const {
      initial: n,
      animate: r
    } = e;
    return {
      initial: n === !1 || Wi(n) ? n : void 0,
      animate: Wi(r) ? r : void 0
    };
  }
  return e.inherit !== !1 ? t : {};
}
function f4(e) {
  const {
    initial: t,
    animate: n
  } = d4(e, y.useContext(Wu));
  return y.useMemo(() => ({
    initial: t,
    animate: n
  }), [fv(t), fv(n)]);
}
function fv(e) {
  return Array.isArray(e) ? e.join(" ") : e;
}
const Gp = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
});
function RS(e, t, n) {
  for (const r in t) !Ve(t[r]) && !aS(r, n) && (e[r] = t[r]);
}
function h4({
  transformTemplate: e
}, t) {
  return y.useMemo(() => {
    const n = Gp();
    return qp(n, t, e), Object.assign({}, n.vars, n.style);
  }, [t]);
}
function p4(e, t) {
  const n = e.style || {},
    r = {};
  return RS(r, n, e), Object.assign(r, h4(e, t)), r;
}
function m4(e, t) {
  const n = {},
    r = p4(e, t);
  return e.drag && e.dragListener !== !1 && (n.draggable = !1, r.userSelect = r.WebkitUserSelect = r.WebkitTouchCallout = "none", r.touchAction = e.drag === !0 ? "none" : `pan-${e.drag === "x" ? "y" : "x"}`), e.tabIndex === void 0 && (e.onTap || e.onTapStart || e.whileTap) && (n.tabIndex = 0), n.style = r, n;
}
const NS = () => ({
  ...Gp(),
  attrs: {}
});
function g4(e, t, n, r) {
  const s = y.useMemo(() => {
    const o = NS();
    return lS(o, t, cS(r), e.transformTemplate, e.style), {
      ...o.attrs,
      style: {
        ...o.style
      }
    };
  }, [t]);
  if (e.style) {
    const o = {};
    RS(o, e.style, e), s.style = {
      ...o,
      ...s.style
    };
  }
  return s;
}
const y4 = ["animate", "circle", "defs", "desc", "ellipse", "g", "image", "line", "filter", "marker", "mask", "metadata", "path", "pattern", "polygon", "polyline", "rect", "stop", "switch", "symbol", "svg", "text", "tspan", "use", "view"];
function Yp(e) {
  return typeof e != "string" || e.includes("-") ? !1 : !!(y4.indexOf(e) > -1 || /[A-Z]/u.test(e));
}
function v4(e, t, n, {
  latestValues: r
}, s, o = !1, i) {
  const l = (i ?? Yp(e) ? g4 : m4)(t, r, s, e),
    u = c4(t, typeof e == "string", o),
    d = e !== y.Fragment ? {
      ...u,
      ...l,
      ref: n
    } : {},
    {
      children: c
    } = t,
    f = y.useMemo(() => Ve(c) ? c.get() : c, [c]);
  return y.createElement(e, {
    ...d,
    children: f
  });
}
function x4({
  scrapeMotionValuesFromProps: e,
  createRenderState: t
}, n, r, s) {
  return {
    latestValues: w4(n, r, s, e),
    renderState: t()
  };
}
function w4(e, t, n, r) {
  const s = {},
    o = r(e, {});
  for (const f in o) s[f] = ml(o[f]);
  let {
    initial: i,
    animate: a
  } = e;
  const l = Uu(e),
    u = Zb(e);
  t && u && !l && e.inherit !== !1 && (i === void 0 && (i = t.initial), a === void 0 && (a = t.animate));
  let d = n ? n.initial === !1 : !1;
  d = d || i === !1;
  const c = d ? a : i;
  if (c && typeof c != "boolean" && !$u(c)) {
    const f = Array.isArray(c) ? c : [c];
    for (let h = 0; h < f.length; h++) {
      const w = _p(e, f[h]);
      if (w) {
        const {
          transitionEnd: m,
          transition: x,
          ...g
        } = w;
        for (const v in g) {
          let b = g[v];
          if (Array.isArray(b)) {
            const S = d ? b.length - 1 : 0;
            b = b[S];
          }
          b !== null && (s[v] = b);
        }
        for (const v in m) s[v] = m[v];
      }
    }
  }
  return s;
}
const AS = e => (t, n) => {
    const r = y.useContext(Wu),
      s = y.useContext(Vu),
      o = () => x4(e, t, r, s);
    return n ? o() : Cp(o);
  },
  b4 = AS({
    scrapeMotionValuesFromProps: Kp,
    createRenderState: Gp
  }),
  S4 = AS({
    scrapeMotionValuesFromProps: dS,
    createRenderState: NS
  }),
  E4 = Symbol.for("motionComponentSymbol");
function C4(e, t, n) {
  const r = y.useRef(n);
  y.useInsertionEffect(() => {
    r.current = n;
  });
  const s = y.useRef(null);
  return y.useCallback(o => {
    var a;
    o && ((a = e.onMount) == null || a.call(e, o)), t && (o ? t.mount(o) : t.unmount());
    const i = r.current;
    if (typeof i == "function") {
      if (o) {
        const l = i(o);
        typeof l == "function" && (s.current = l);
      } else s.current ? (s.current(), s.current = null) : i(o);
    } else i && (i.current = o);
  }, [t]);
}
const jS = y.createContext({});
function Ps(e) {
  return e && typeof e == "object" && Object.prototype.hasOwnProperty.call(e, "current");
}
function T4(e, t, n, r, s, o) {
  var b, S;
  const {
      visualElement: i
    } = y.useContext(Wu),
    a = y.useContext(TS),
    l = y.useContext(Vu),
    u = y.useContext(Qp),
    d = u.reducedMotion,
    c = u.skipAnimations,
    f = y.useRef(null),
    h = y.useRef(!1);
  r = r || a.renderer, !f.current && r && (f.current = r(e, {
    visualState: t,
    parent: i,
    props: n,
    presenceContext: l,
    blockInitialAnimation: l ? l.initial === !1 : !1,
    reducedMotionConfig: d,
    skipAnimations: c,
    isSVG: o
  }), h.current && f.current && (f.current.manuallyAnimateOnMount = !0));
  const w = f.current,
    m = y.useContext(jS);
  w && !w.projection && s && (w.type === "html" || w.type === "svg") && P4(f.current, n, s, m);
  const x = y.useRef(!1);
  y.useInsertionEffect(() => {
    w && x.current && w.update(n, l);
  });
  const g = n[Bb],
    v = y.useRef(!!g && typeof window < "u" && !((b = window.MotionHandoffIsComplete) != null && b.call(window, g)) && ((S = window.MotionHasOptimisedAnimation) == null ? void 0 : S.call(window, g)));
  return Z1(() => {
    h.current = !0, w && (x.current = !0, window.MotionIsMounted = !0, w.updateFeatures(), w.scheduleRenderMicrotask(), v.current && w.animationState && w.animationState.animateChanges());
  }), y.useEffect(() => {
    w && (!v.current && w.animationState && w.animationState.animateChanges(), v.current && (queueMicrotask(() => {
      var E;
      (E = window.MotionHandoffMarkAsComplete) == null || E.call(window, g);
    }), v.current = !1), w.enteringChildren = void 0);
  }), w;
}
function P4(e, t, n, r) {
  const {
    layoutId: s,
    layout: o,
    drag: i,
    dragConstraints: a,
    layoutScroll: l,
    layoutRoot: u,
    layoutAnchor: d,
    layoutCrossfade: c
  } = t;
  e.projection = new n(e.latestValues, t["data-framer-portal-id"] ? void 0 : MS(e.parent)), e.projection.setOptions({
    layoutId: s,
    layout: o,
    alwaysMeasureLayout: !!i || a && Ps(a),
    visualElement: e,
    animationType: typeof o == "string" ? o : "both",
    initialPromotionConfig: r,
    crossfade: c,
    layoutScroll: l,
    layoutRoot: u,
    layoutAnchor: d
  });
}
function MS(e) {
  if (e) return e.options.allowProjection !== !1 ? e.projection : MS(e.parent);
}
function qc(e, {
  forwardMotionProps: t = !1,
  type: n
} = {}, r, s) {
  r && a4(r);
  const o = n ? n === "svg" : Yp(e),
    i = o ? S4 : b4;
  function a(u, d) {
    let c;
    const f = {
        ...y.useContext(Qp),
        ...u,
        layoutId: k4(u)
      },
      {
        isStatic: h
      } = f,
      w = f4(u),
      m = i(u, h);
    if (!h && typeof window < "u") {
      R4();
      const x = N4(f);
      c = x.MeasureLayout, w.visualElement = T4(e, m, f, s, x.ProjectionNode, o);
    }
    return p.jsxs(Wu.Provider, {
      value: w,
      children: [c && w.visualElement ? p.jsx(c, {
        visualElement: w.visualElement,
        ...f
      }) : null, v4(e, u, C4(m, w.visualElement, d), m, h, t, o)]
    });
  }
  a.displayName = `motion.${typeof e == "string" ? e : `create(${e.displayName ?? e.name ?? ""})`}`;
  const l = y.forwardRef(a);
  return l[E4] = e, l;
}
function k4({
  layoutId: e
}) {
  const t = y.useContext(Ep).id;
  return t && e !== void 0 ? t + "-" + e : e;
}
function R4(e, t) {
  y.useContext(TS).strict;
}
function N4(e) {
  const t = PS(),
    {
      drag: n,
      layout: r
    } = t;
  if (!n && !r) return {};
  const s = {
    ...n,
    ...r
  };
  return {
    MeasureLayout: n != null && n.isEnabled(e) || r != null && r.isEnabled(e) ? s.MeasureLayout : void 0,
    ProjectionNode: s.ProjectionNode
  };
}
function A4(e, t) {
  if (typeof Proxy > "u") return qc;
  const n = new Map(),
    r = (o, i) => qc(o, i, e, t),
    s = (o, i) => r(o, i);
  return new Proxy(s, {
    get: (o, i) => i === "create" ? r : (n.has(i) || n.set(i, qc(i, void 0, e, t)), n.get(i))
  });
}
const j4 = (e, t) => t.isSVG ?? Yp(e) ? new iL(t) : new eL(t, {
  allowProjection: e !== y.Fragment
});
class M4 extends Lr {
  constructor(t) {
    super(t), t.animationState || (t.animationState = dL(t));
  }
  updateAnimationControlsSubscription() {
    const {
      animate: t
    } = this.node.getProps();
    $u(t) && (this.unmountControls = t.subscribe(this.node));
  }
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const {
        animate: t
      } = this.node.getProps(),
      {
        animate: n
      } = this.node.prevProps || {};
    t !== n && this.updateAnimationControlsSubscription();
  }
  unmount() {
    var t;
    this.node.animationState.reset(), (t = this.unmountControls) == null || t.call(this);
  }
}
let O4 = 0;
class L4 extends Lr {
  constructor() {
    super(...arguments), this.id = O4++, this.isExitComplete = !1;
  }
  update() {
    var o;
    if (!this.node.presenceContext) return;
    const {
        isPresent: t,
        onExitComplete: n
      } = this.node.presenceContext,
      {
        isPresent: r
      } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || t === r) return;
    if (t && r === !1) {
      if (this.isExitComplete) {
        const {
          initial: i,
          custom: a
        } = this.node.getProps();
        if (typeof i == "string" || typeof i == "object" && i !== null && !Array.isArray(i)) {
          const l = os(this.node, i, a);
          if (l) {
            const {
              transition: u,
              transitionEnd: d,
              ...c
            } = l;
            for (const f in c) (o = this.node.getValue(f)) == null || o.jump(c[f]);
          }
        }
        this.node.animationState.reset(), this.node.animationState.animateChanges();
      } else this.node.animationState.setActive("exit", !1);
      this.isExitComplete = !1;
      return;
    }
    const s = this.node.animationState.setActive("exit", !t);
    n && !t && s.then(() => {
      this.isExitComplete = !0, n(this.id);
    });
  }
  mount() {
    const {
      register: t,
      onExitComplete: n
    } = this.node.presenceContext || {};
    n && n(this.id), t && (this.unmount = t(this.id));
  }
  unmount() {}
}
const D4 = {
  animation: {
    Feature: M4
  },
  exit: {
    Feature: L4
  }
};
function da(e) {
  return {
    point: {
      x: e.pageX,
      y: e.pageY
    }
  };
}
const I4 = e => t => zp(t) && e(t, da(t));
function yi(e, t, n, r) {
  return Hi(e, t, I4(n), r);
}
const OS = ({
    current: e
  }) => e ? e.ownerDocument.defaultView : null,
  hv = (e, t) => Math.abs(e - t);
function F4(e, t) {
  const n = hv(e.x, t.x),
    r = hv(e.y, t.y);
  return Math.sqrt(n ** 2 + r ** 2);
}
const pv = new Set(["auto", "scroll"]);
class LS {
  constructor(t, n, {
    transformPagePoint: r,
    contextWindow: s = window,
    dragSnapToOrigin: o = !1,
    distanceThreshold: i = 3,
    element: a
  } = {}) {
    if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.lastRawMoveEventInfo = null, this.handlers = {}, this.contextWindow = window, this.scrollPositions = new Map(), this.removeScrollListeners = null, this.onElementScroll = h => {
      this.handleScroll(h.target);
    }, this.onWindowScroll = () => {
      this.handleScroll(window);
    }, this.updatePoint = () => {
      if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
      this.lastRawMoveEventInfo && (this.lastMoveEventInfo = $a(this.lastRawMoveEventInfo, this.transformPagePoint));
      const h = Kc(this.lastMoveEventInfo, this.history),
        w = this.startEvent !== null,
        m = F4(h.offset, {
          x: 0,
          y: 0
        }) >= this.distanceThreshold;
      if (!w && !m) return;
      const {
          point: x
        } = h,
        {
          timestamp: g
        } = Fe;
      this.history.push({
        ...x,
        timestamp: g
      });
      const {
        onStart: v,
        onMove: b
      } = this.handlers;
      w || (v && v(this.lastMoveEvent, h), this.startEvent = this.lastMoveEvent), b && b(this.lastMoveEvent, h);
    }, this.handlePointerMove = (h, w) => {
      this.lastMoveEvent = h, this.lastRawMoveEventInfo = w, this.lastMoveEventInfo = $a(w, this.transformPagePoint), le.update(this.updatePoint, !0);
    }, this.handlePointerUp = (h, w) => {
      this.end();
      const {
        onEnd: m,
        onSessionEnd: x,
        resumeAnimation: g
      } = this.handlers;
      if ((this.dragSnapToOrigin || !this.startEvent) && g && g(), !(this.lastMoveEvent && this.lastMoveEventInfo)) return;
      const v = Kc(h.type === "pointercancel" ? this.lastMoveEventInfo : $a(w, this.transformPagePoint), this.history);
      this.startEvent && m && m(h, v), x && x(h, v);
    }, !zp(t)) return;
    this.dragSnapToOrigin = o, this.handlers = n, this.transformPagePoint = r, this.distanceThreshold = i, this.contextWindow = s || window;
    const l = da(t),
      u = $a(l, this.transformPagePoint),
      {
        point: d
      } = u,
      {
        timestamp: c
      } = Fe;
    this.history = [{
      ...d,
      timestamp: c
    }];
    const {
      onSessionStart: f
    } = n;
    f && f(t, Kc(u, this.history)), this.removeListeners = la(yi(this.contextWindow, "pointermove", this.handlePointerMove), yi(this.contextWindow, "pointerup", this.handlePointerUp), yi(this.contextWindow, "pointercancel", this.handlePointerUp)), a && this.startScrollTracking(a);
  }
  startScrollTracking(t) {
    let n = t.parentElement;
    for (; n;) {
      const r = getComputedStyle(n);
      (pv.has(r.overflowX) || pv.has(r.overflowY)) && this.scrollPositions.set(n, {
        x: n.scrollLeft,
        y: n.scrollTop
      }), n = n.parentElement;
    }
    this.scrollPositions.set(window, {
      x: window.scrollX,
      y: window.scrollY
    }), window.addEventListener("scroll", this.onElementScroll, {
      capture: !0
    }), window.addEventListener("scroll", this.onWindowScroll), this.removeScrollListeners = () => {
      window.removeEventListener("scroll", this.onElementScroll, {
        capture: !0
      }), window.removeEventListener("scroll", this.onWindowScroll);
    };
  }
  handleScroll(t) {
    const n = this.scrollPositions.get(t);
    if (!n) return;
    const r = t === window,
      s = r ? {
        x: window.scrollX,
        y: window.scrollY
      } : {
        x: t.scrollLeft,
        y: t.scrollTop
      },
      o = {
        x: s.x - n.x,
        y: s.y - n.y
      };
    o.x === 0 && o.y === 0 || (r ? this.lastMoveEventInfo && (this.lastMoveEventInfo.point.x += o.x, this.lastMoveEventInfo.point.y += o.y) : this.history.length > 0 && (this.history[0].x -= o.x, this.history[0].y -= o.y), this.scrollPositions.set(t, s), le.update(this.updatePoint, !0));
  }
  updateHandlers(t) {
    this.handlers = t;
  }
  end() {
    this.removeListeners && this.removeListeners(), this.removeScrollListeners && this.removeScrollListeners(), this.scrollPositions.clear(), Nr(this.updatePoint);
  }
}
function $a(e, t) {
  return t ? {
    point: t(e.point)
  } : e;
}
function mv(e, t) {
  return {
    x: e.x - t.x,
    y: e.y - t.y
  };
}
function Kc({
  point: e
}, t) {
  return {
    point: e,
    delta: mv(e, DS(t)),
    offset: mv(e, _4(t)),
    velocity: V4(t, 0.1)
  };
}
function _4(e) {
  return e[0];
}
function DS(e) {
  return e[e.length - 1];
}
function V4(e, t) {
  if (e.length < 2) return {
    x: 0,
    y: 0
  };
  let n = e.length - 1,
    r = null;
  const s = DS(e);
  for (; n >= 0 && (r = e[n], !(s.timestamp - r.timestamp > dt(t)));) n--;
  if (!r) return {
    x: 0,
    y: 0
  };
  r === e[0] && e.length > 2 && s.timestamp - r.timestamp > dt(t) * 2 && (r = e[1]);
  const o = Rt(s.timestamp - r.timestamp);
  if (o === 0) return {
    x: 0,
    y: 0
  };
  const i = {
    x: (s.x - r.x) / o,
    y: (s.y - r.y) / o
  };
  return i.x === 1 / 0 && (i.x = 0), i.y === 1 / 0 && (i.y = 0), i;
}
function B4(e, {
  min: t,
  max: n
}, r) {
  return t !== void 0 && e < t ? e = r ? ae(t, e, r.min) : Math.max(e, t) : n !== void 0 && e > n && (e = r ? ae(n, e, r.max) : Math.min(e, n)), e;
}
function gv(e, t, n) {
  return {
    min: t !== void 0 ? e.min + t : void 0,
    max: n !== void 0 ? e.max + n - (e.max - e.min) : void 0
  };
}
function z4(e, {
  top: t,
  left: n,
  bottom: r,
  right: s
}) {
  return {
    x: gv(e.x, n, s),
    y: gv(e.y, t, r)
  };
}
function yv(e, t) {
  let n = t.min - e.min,
    r = t.max - e.max;
  return t.max - t.min < e.max - e.min && ([n, r] = [r, n]), {
    min: n,
    max: r
  };
}
function $4(e, t) {
  return {
    x: yv(e.x, t.x),
    y: yv(e.y, t.y)
  };
}
function U4(e, t) {
  let n = 0.5;
  const r = Ze(e),
    s = Ze(t);
  return s > r ? n = $i(t.min, t.max - r, e.min) : r > s && (n = $i(e.min, e.max - s, t.min)), gn(0, 1, n);
}
function W4(e, t) {
  const n = {};
  return t.min !== void 0 && (n.min = t.min - e.min), t.max !== void 0 && (n.max = t.max - e.min), n;
}
const Xf = 0.35;
function H4(e = Xf) {
  return e === !1 ? e = 0 : e === !0 && (e = Xf), {
    x: vv(e, "left", "right"),
    y: vv(e, "top", "bottom")
  };
}
function vv(e, t, n) {
  return {
    min: xv(e, t),
    max: xv(e, n)
  };
}
function xv(e, t) {
  return typeof e == "number" ? e : e[t] || 0;
}
const q4 = new WeakMap();
class K4 {
  constructor(t) {
    this.openDragLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = {
      x: 0,
      y: 0
    }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = Ne(), this.latestPointerEvent = null, this.latestPanInfo = null, this.visualElement = t;
  }
  start(t, {
    snapToCursor: n = !1,
    distanceThreshold: r
  } = {}) {
    const {
      presenceContext: s
    } = this.visualElement;
    if (s && s.isPresent === !1) return;
    const o = c => {
        n && this.snapToCursor(da(c).point), this.stopAnimation();
      },
      i = (c, f) => {
        const {
          drag: h,
          dragPropagation: w,
          onDragStart: m
        } = this.getProps();
        if (h && !w && (this.openDragLock && this.openDragLock(), this.openDragLock = wO(h), !this.openDragLock)) return;
        this.latestPointerEvent = c, this.latestPanInfo = f, this.isDragging = !0, this.currentDirection = null, this.resolveConstraints(), this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !0, this.visualElement.projection.target = void 0), tn(g => {
          let v = this.getAxisMotionValue(g).get() || 0;
          if (hn.test(v)) {
            const {
              projection: b
            } = this.visualElement;
            if (b && b.layout) {
              const S = b.layout.layoutBox[g];
              S && (v = Ze(S) * (parseFloat(v) / 100));
            }
          }
          this.originPoint[g] = v;
        }), m && le.update(() => m(c, f), !1, !0), $f(this.visualElement, "transform");
        const {
          animationState: x
        } = this.visualElement;
        x && x.setActive("whileDrag", !0);
      },
      a = (c, f) => {
        this.latestPointerEvent = c, this.latestPanInfo = f;
        const {
          dragPropagation: h,
          dragDirectionLock: w,
          onDirectionLock: m,
          onDrag: x
        } = this.getProps();
        if (!h && !this.openDragLock) return;
        const {
          offset: g
        } = f;
        if (w && this.currentDirection === null) {
          this.currentDirection = G4(g), this.currentDirection !== null && m && m(this.currentDirection);
          return;
        }
        this.updateAxis("x", f.point, g), this.updateAxis("y", f.point, g), this.visualElement.render(), x && le.update(() => x(c, f), !1, !0);
      },
      l = (c, f) => {
        this.latestPointerEvent = c, this.latestPanInfo = f, this.stop(c, f), this.latestPointerEvent = null, this.latestPanInfo = null;
      },
      u = () => {
        const {
          dragSnapToOrigin: c
        } = this.getProps();
        (c || this.constraints) && this.startAnimation({
          x: 0,
          y: 0
        });
      },
      {
        dragSnapToOrigin: d
      } = this.getProps();
    this.panSession = new LS(t, {
      onSessionStart: o,
      onStart: i,
      onMove: a,
      onSessionEnd: l,
      resumeAnimation: u
    }, {
      transformPagePoint: this.visualElement.getTransformPagePoint(),
      dragSnapToOrigin: d,
      distanceThreshold: r,
      contextWindow: OS(this.visualElement),
      element: this.visualElement.current
    });
  }
  stop(t, n) {
    const r = t || this.latestPointerEvent,
      s = n || this.latestPanInfo,
      o = this.isDragging;
    if (this.cancel(), !o || !s || !r) return;
    const {
      velocity: i
    } = s;
    this.startAnimation(i);
    const {
      onDragEnd: a
    } = this.getProps();
    a && le.postRender(() => a(r, s));
  }
  cancel() {
    this.isDragging = !1;
    const {
      projection: t,
      animationState: n
    } = this.visualElement;
    t && (t.isAnimationBlocked = !1), this.endPanSession();
    const {
      dragPropagation: r
    } = this.getProps();
    !r && this.openDragLock && (this.openDragLock(), this.openDragLock = null), n && n.setActive("whileDrag", !1);
  }
  endPanSession() {
    this.panSession && this.panSession.end(), this.panSession = void 0;
  }
  updateAxis(t, n, r) {
    const {
      drag: s
    } = this.getProps();
    if (!r || !Ua(t, s, this.currentDirection)) return;
    const o = this.getAxisMotionValue(t);
    let i = this.originPoint[t] + r[t];
    this.constraints && this.constraints[t] && (i = B4(i, this.constraints[t], this.elastic[t])), o.set(i);
  }
  resolveConstraints() {
    var o;
    const {
        dragConstraints: t,
        dragElastic: n
      } = this.getProps(),
      r = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(!1) : (o = this.visualElement.projection) == null ? void 0 : o.layout,
      s = this.constraints;
    t && Ps(t) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : t && r ? this.constraints = z4(r.layoutBox, t) : this.constraints = !1, this.elastic = H4(n), s !== this.constraints && !Ps(t) && r && this.constraints && !this.hasMutatedConstraints && tn(i => {
      this.constraints !== !1 && this.getAxisMotionValue(i) && (this.constraints[i] = W4(r.layoutBox[i], this.constraints[i]));
    });
  }
  resolveRefConstraints() {
    const {
      dragConstraints: t,
      onMeasureDragConstraints: n
    } = this.getProps();
    if (!t || !Ps(t)) return !1;
    const r = t.current;
    So(r !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.", "drag-constraints-ref");
    const {
      projection: s
    } = this.visualElement;
    if (!s || !s.layout) return !1;
    s.root && (s.root.scroll = void 0, s.root.updateScroll());
    const o = QO(r, s.root, this.visualElement.getTransformPagePoint());
    let i = $4(s.layout.layoutBox, o);
    if (n) {
      const a = n(HO(i));
      this.hasMutatedConstraints = !!a, a && (i = nS(a));
    }
    return i;
  }
  startAnimation(t) {
    const {
        drag: n,
        dragMomentum: r,
        dragElastic: s,
        dragTransition: o,
        dragSnapToOrigin: i,
        onDragTransitionEnd: a
      } = this.getProps(),
      l = this.constraints || {},
      u = tn(d => {
        if (!Ua(d, n, this.currentDirection)) return;
        let c = l && l[d] || {};
        (i === !0 || i === d) && (c = {
          min: 0,
          max: 0
        });
        const f = s ? 200 : 1e6,
          h = s ? 40 : 1e7,
          w = {
            type: "inertia",
            velocity: r ? t[d] : 0,
            bounceStiffness: f,
            bounceDamping: h,
            timeConstant: 750,
            restDelta: 1,
            restSpeed: 10,
            ...o,
            ...c
          };
        return this.startAxisValueAnimation(d, w);
      });
    return Promise.all(u).then(a);
  }
  startAxisValueAnimation(t, n) {
    const r = this.getAxisMotionValue(t);
    return $f(this.visualElement, t), r.start(Fp(t, r, 0, n, this.visualElement, !1));
  }
  stopAnimation() {
    tn(t => this.getAxisMotionValue(t).stop());
  }
  getAxisMotionValue(t) {
    const n = `_drag${t.toUpperCase()}`,
      s = this.visualElement.getProps()[n];
    return s || this.visualElement.getValue(t, this.visualElement.latestValues[t] ?? 0);
  }
  snapToCursor(t) {
    tn(n => {
      const {
        drag: r
      } = this.getProps();
      if (!Ua(n, r, this.currentDirection)) return;
      const {
          projection: s
        } = this.visualElement,
        o = this.getAxisMotionValue(n);
      if (s && s.layout) {
        const {
            min: i,
            max: a
          } = s.layout.layoutBox[n],
          l = o.get() || 0;
        o.set(t[n] - ae(i, a, 0.5) + l);
      }
    });
  }
  scalePositionWithinConstraints() {
    if (!this.visualElement.current) return;
    const {
        drag: t,
        dragConstraints: n
      } = this.getProps(),
      {
        projection: r
      } = this.visualElement;
    if (!Ps(n) || !r || !this.constraints) return;
    this.stopAnimation();
    const s = {
      x: 0,
      y: 0
    };
    tn(i => {
      const a = this.getAxisMotionValue(i);
      if (a && this.constraints !== !1) {
        const l = a.get();
        s[i] = U4({
          min: l,
          max: l
        }, this.constraints[i]);
      }
    });
    const {
      transformTemplate: o
    } = this.visualElement.getProps();
    this.visualElement.current.style.transform = o ? o({}, "") : "none", r.root && r.root.updateScroll(), r.updateLayout(), this.constraints = !1, this.resolveConstraints(), tn(i => {
      if (!Ua(i, t, null)) return;
      const a = this.getAxisMotionValue(i),
        {
          min: l,
          max: u
        } = this.constraints[i];
      a.set(ae(l, u, s[i]));
    }), this.visualElement.render();
  }
  addListeners() {
    if (!this.visualElement.current) return;
    q4.set(this.visualElement, this);
    const t = this.visualElement.current,
      n = yi(t, "pointerdown", u => {
        const {
            drag: d,
            dragListener: c = !0
          } = this.getProps(),
          f = u.target,
          h = f !== t && PO(f);
        d && c && !h && this.start(u);
      });
    let r;
    const s = () => {
        const {
          dragConstraints: u
        } = this.getProps();
        Ps(u) && u.current && (this.constraints = this.resolveRefConstraints(), r || (r = Q4(t, u.current, () => this.scalePositionWithinConstraints())));
      },
      {
        projection: o
      } = this.visualElement,
      i = o.addEventListener("measure", s);
    o && !o.layout && (o.root && o.root.updateScroll(), o.updateLayout()), le.read(s);
    const a = Hi(window, "resize", () => this.scalePositionWithinConstraints()),
      l = o.addEventListener("didUpdate", ({
        delta: u,
        hasLayoutChanged: d
      }) => {
        this.isDragging && d && (tn(c => {
          const f = this.getAxisMotionValue(c);
          f && (this.originPoint[c] += u[c].translate, f.set(f.get() + u[c].translate));
        }), this.visualElement.render());
      });
    return () => {
      a(), n(), i(), l && l(), r && r();
    };
  }
  getProps() {
    const t = this.visualElement.getProps(),
      {
        drag: n = !1,
        dragDirectionLock: r = !1,
        dragPropagation: s = !1,
        dragConstraints: o = !1,
        dragElastic: i = Xf,
        dragMomentum: a = !0
      } = t;
    return {
      ...t,
      drag: n,
      dragDirectionLock: r,
      dragPropagation: s,
      dragConstraints: o,
      dragElastic: i,
      dragMomentum: a
    };
  }
}
function wv(e) {
  let t = !0;
  return () => {
    if (t) {
      t = !1;
      return;
    }
    e();
  };
}
function Q4(e, t, n) {
  const r = ky(e, wv(n)),
    s = ky(t, wv(n));
  return () => {
    r(), s();
  };
}
function Ua(e, t, n) {
  return (t === !0 || t === e) && (n === null || n === e);
}
function G4(e, t = 10) {
  let n = null;
  return Math.abs(e.y) > t ? n = "y" : Math.abs(e.x) > t && (n = "x"), n;
}
class Y4 extends Lr {
  constructor(t) {
    super(t), this.removeGroupControls = At, this.removeListeners = At, this.controls = new K4(t);
  }
  mount() {
    const {
      dragControls: t
    } = this.node.getProps();
    t && (this.removeGroupControls = t.subscribe(this.controls)), this.removeListeners = this.controls.addListeners() || At;
  }
  update() {
    const {
        dragControls: t
      } = this.node.getProps(),
      {
        dragControls: n
      } = this.node.prevProps || {};
    t !== n && (this.removeGroupControls(), t && (this.removeGroupControls = t.subscribe(this.controls)));
  }
  unmount() {
    this.removeGroupControls(), this.removeListeners(), this.controls.isDragging || this.controls.endPanSession();
  }
}
const Qc = e => (t, n) => {
  e && le.update(() => e(t, n), !1, !0);
};
class X4 extends Lr {
  constructor() {
    super(...arguments), this.removePointerDownListener = At;
  }
  onPointerDown(t) {
    this.session = new LS(t, this.createPanHandlers(), {
      transformPagePoint: this.node.getTransformPagePoint(),
      contextWindow: OS(this.node)
    });
  }
  createPanHandlers() {
    const {
      onPanSessionStart: t,
      onPanStart: n,
      onPan: r,
      onPanEnd: s
    } = this.node.getProps();
    return {
      onSessionStart: Qc(t),
      onStart: Qc(n),
      onMove: Qc(r),
      onEnd: (o, i) => {
        delete this.session, s && le.postRender(() => s(o, i));
      }
    };
  }
  mount() {
    this.removePointerDownListener = yi(this.node.current, "pointerdown", t => this.onPointerDown(t));
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener(), this.session && this.session.end();
  }
}
let Gc = !1;
class Z4 extends y.Component {
  componentDidMount() {
    const {
        visualElement: t,
        layoutGroup: n,
        switchLayoutGroup: r,
        layoutId: s
      } = this.props,
      {
        projection: o
      } = t;
    o && (n.group && n.group.add(o), r && r.register && s && r.register(o), Gc && o.root.didUpdate(), o.addEventListener("animationComplete", () => {
      this.safeToRemove();
    }), o.setOptions({
      ...o.options,
      layoutDependency: this.props.layoutDependency,
      onExitComplete: () => this.safeToRemove()
    })), gl.hasEverUpdated = !0;
  }
  getSnapshotBeforeUpdate(t) {
    const {
        layoutDependency: n,
        visualElement: r,
        drag: s,
        isPresent: o
      } = this.props,
      {
        projection: i
      } = r;
    return i && (i.isPresent = o, t.layoutDependency !== n && i.setOptions({
      ...i.options,
      layoutDependency: n
    }), Gc = !0, s || t.layoutDependency !== n || n === void 0 || t.isPresent !== o ? i.willUpdate() : this.safeToRemove(), t.isPresent !== o && (o ? i.promote() : i.relegate() || le.postRender(() => {
      const a = i.getStack();
      (!a || !a.members.length) && this.safeToRemove();
    }))), null;
  }
  componentDidUpdate() {
    const {
        visualElement: t,
        layoutAnchor: n
      } = this.props,
      {
        projection: r
      } = t;
    r && (r.options.layoutAnchor = n, r.root.didUpdate(), Bp.postRender(() => {
      !r.currentAnimation && r.isLead() && this.safeToRemove();
    }));
  }
  componentWillUnmount() {
    const {
        visualElement: t,
        layoutGroup: n,
        switchLayoutGroup: r
      } = this.props,
      {
        projection: s
      } = t;
    Gc = !0, s && (s.scheduleCheckAfterUnmount(), n && n.group && n.group.remove(s), r && r.deregister && r.deregister(s));
  }
  safeToRemove() {
    const {
      safeToRemove: t
    } = this.props;
    t && t();
  }
  render() {
    return null;
  }
}
function IS(e) {
  const [t, n] = CS(),
    r = y.useContext(Ep);
  return p.jsx(Z4, {
    ...e,
    layoutGroup: r,
    switchLayoutGroup: y.useContext(jS),
    isPresent: t,
    safeToRemove: n
  });
}
const J4 = {
  pan: {
    Feature: X4
  },
  drag: {
    Feature: Y4,
    ProjectionNode: ES,
    MeasureLayout: IS
  }
};
function bv(e, t, n) {
  const {
    props: r
  } = e;
  e.animationState && r.whileHover && e.animationState.setActive("whileHover", n === "Start");
  const s = "onHover" + n,
    o = r[s];
  o && le.postRender(() => o(t, da(t)));
}
class eD extends Lr {
  mount() {
    const {
      current: t
    } = this.node;
    t && (this.unmount = SO(t, (n, r) => (bv(this.node, r, "Start"), s => bv(this.node, s, "End"))));
  }
  unmount() {}
}
class tD extends Lr {
  constructor() {
    super(...arguments), this.isActive = !1;
  }
  onFocus() {
    let t = !1;
    try {
      t = this.node.current.matches(":focus-visible");
    } catch {
      t = !0;
    }
    !t || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
  }
  onBlur() {
    !this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
  }
  mount() {
    this.unmount = la(Hi(this.node.current, "focus", () => this.onFocus()), Hi(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {}
}
function Sv(e, t, n) {
  const {
    props: r
  } = e;
  if (e.current instanceof HTMLButtonElement && e.current.disabled) return;
  e.animationState && r.whileTap && e.animationState.setActive("whileTap", n === "Start");
  const s = "onTap" + (n === "End" ? "" : n),
    o = r[s];
  o && le.postRender(() => o(t, da(t)));
}
class nD extends Lr {
  mount() {
    const {
      current: t
    } = this.node;
    if (!t) return;
    const {
      globalTapTarget: n,
      propagate: r
    } = this.node.props;
    this.unmount = RO(t, (s, o) => (Sv(this.node, o, "Start"), (i, {
      success: a
    }) => Sv(this.node, i, a ? "End" : "Cancel")), {
      useGlobalTarget: n,
      stopPropagation: (r == null ? void 0 : r.tap) === !1
    });
  }
  unmount() {}
}
const Zf = new WeakMap(),
  Yc = new WeakMap(),
  rD = e => {
    const t = Zf.get(e.target);
    t && t(e);
  },
  sD = e => {
    e.forEach(rD);
  };
function oD({
  root: e,
  ...t
}) {
  const n = e || document;
  Yc.has(n) || Yc.set(n, {});
  const r = Yc.get(n),
    s = JSON.stringify(t);
  return r[s] || (r[s] = new IntersectionObserver(sD, {
    root: e,
    ...t
  })), r[s];
}
function iD(e, t, n) {
  const r = oD(t);
  return Zf.set(e, n), r.observe(e), () => {
    Zf.delete(e), r.unobserve(e);
  };
}
const aD = {
  some: 0,
  all: 1
};
class lD extends Lr {
  constructor() {
    super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
  }
  startObserver() {
    var l;
    (l = this.stopObserver) == null || l.call(this);
    const {
        viewport: t = {}
      } = this.node.getProps(),
      {
        root: n,
        margin: r,
        amount: s = "some",
        once: o
      } = t,
      i = {
        root: n ? n.current : void 0,
        rootMargin: r,
        threshold: typeof s == "number" ? s : aD[s]
      },
      a = u => {
        const {
          isIntersecting: d
        } = u;
        if (this.isInView === d || (this.isInView = d, o && !d && this.hasEnteredView)) return;
        d && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", d);
        const {
            onViewportEnter: c,
            onViewportLeave: f
          } = this.node.getProps(),
          h = d ? c : f;
        h && h(u);
      };
    this.stopObserver = iD(this.node.current, i, a);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver > "u") return;
    const {
      props: t,
      prevProps: n
    } = this.node;
    ["amount", "margin", "root"].some(uD(t, n)) && this.startObserver();
  }
  unmount() {
    var t;
    (t = this.stopObserver) == null || t.call(this), this.hasEnteredView = !1, this.isInView = !1;
  }
}
function uD({
  viewport: e = {}
}, {
  viewport: t = {}
} = {}) {
  return n => e[n] !== t[n];
}
const cD = {
    inView: {
      Feature: lD
    },
    tap: {
      Feature: nD
    },
    focus: {
      Feature: tD
    },
    hover: {
      Feature: eD
    }
  },
  dD = {
    layout: {
      ProjectionNode: ES,
      MeasureLayout: IS
    }
  },
  fD = {
    ...D4,
    ...cD,
    ...J4,
    ...dD
  },
  Pt = A4(fD, j4);
function Fo() {
  !Hp.current && Jb();
  const [e] = y.useState(ou.current);
  return e;
}
const hD = ({
  inverse: e = !1
}) => {
  const {
    lang: t,
    setLang: n
  } = Me();
  return p.jsxs("button", {
    type: "button",
    onClick: () => n(t === "fr" ? "en" : "fr"),
    className: Y("inline-flex h-11 items-center justify-center gap-1 rounded-full border px-3 font-body text-xs font-semibold uppercase leading-none tracking-wider transition-colors", e ? "border-white/25 text-[#F4EEDF] hover:border-white/50 hover:bg-white/10" : "border-foreground/15 text-foreground hover:border-foreground/40 hover:bg-foreground/5"),
    "aria-label": t === "fr" ? window.LyoEditor.text("txt_9c3c9393a454", "Switch to English") : window.LyoEditor.text("txt_8eff3cfadf53", "Passer au français"),
    children: [p.jsx("span", {
      className: t === "fr" ? e ? "text-[#F4EEDF]" : "text-foreground" : e ? "text-[#F4EEDF]/40" : "text-foreground/40",
      get children() {
        return window.LyoEditor.text("txt_fd95afa79896", "FR");
      }
    }), p.jsx("span", {
      className: e ? "text-[#F4EEDF]/30" : "text-foreground/30",
      children: "/"
    }), p.jsx("span", {
      className: t === "en" ? e ? "text-[#F4EEDF]" : "text-foreground" : e ? "text-[#F4EEDF]/40" : "text-foreground/40",
      get children() {
        return window.LyoEditor.text("txt_4f654dee59c9", "EN");
      }
    })]
  });
};
var Xc = "focusScope.autoFocusOnMount",
  Zc = "focusScope.autoFocusOnUnmount",
  Ev = {
    bubbles: !1,
    cancelable: !0
  },
  pD = "FocusScope",
  FS = y.forwardRef((e, t) => {
    const {
        loop: n = !1,
        trapped: r = !1,
        onMountAutoFocus: s,
        onUnmountAutoFocus: o,
        ...i
      } = e,
      [a, l] = y.useState(null),
      u = pn(s),
      d = pn(o),
      c = y.useRef(null),
      f = et(t, m => l(m)),
      h = y.useRef({
        paused: !1,
        pause() {
          this.paused = !0;
        },
        resume() {
          this.paused = !1;
        }
      }).current;
    y.useEffect(() => {
      if (r) {
        let m = function (b) {
            if (h.paused || !a) return;
            const S = b.target;
            a.contains(S) ? c.current = S : Xn(c.current, {
              select: !0
            });
          },
          x = function (b) {
            if (h.paused || !a) return;
            const S = b.relatedTarget;
            S !== null && (a.contains(S) || Xn(c.current, {
              select: !0
            }));
          },
          g = function (b) {
            if (document.activeElement === document.body) for (const E of b) E.removedNodes.length > 0 && Xn(a);
          };
        document.addEventListener("focusin", m), document.addEventListener("focusout", x);
        const v = new MutationObserver(g);
        return a && v.observe(a, {
          childList: !0,
          subtree: !0
        }), () => {
          document.removeEventListener("focusin", m), document.removeEventListener("focusout", x), v.disconnect();
        };
      }
    }, [r, a, h.paused]), y.useEffect(() => {
      if (a) {
        Tv.add(h);
        const m = document.activeElement;
        if (!a.contains(m)) {
          const g = new CustomEvent(Xc, Ev);
          a.addEventListener(Xc, u), a.dispatchEvent(g), g.defaultPrevented || (mD(wD(_S(a)), {
            select: !0
          }), document.activeElement === m && Xn(a));
        }
        return () => {
          a.removeEventListener(Xc, u), setTimeout(() => {
            const g = new CustomEvent(Zc, Ev);
            a.addEventListener(Zc, d), a.dispatchEvent(g), g.defaultPrevented || Xn(m ?? document.body, {
              select: !0
            }), a.removeEventListener(Zc, d), Tv.remove(h);
          }, 0);
        };
      }
    }, [a, u, d, h]);
    const w = y.useCallback(m => {
      if (!n && !r || h.paused) return;
      const x = m.key === "Tab" && !m.altKey && !m.ctrlKey && !m.metaKey,
        g = document.activeElement;
      if (x && g) {
        const v = m.currentTarget,
          [b, S] = gD(v);
        b && S ? !m.shiftKey && g === S ? (m.preventDefault(), n && Xn(b, {
          select: !0
        })) : m.shiftKey && g === b && (m.preventDefault(), n && Xn(S, {
          select: !0
        })) : g === v && m.preventDefault();
      }
    }, [n, r, h.paused]);
    return p.jsx(Re.div, {
      tabIndex: -1,
      ...i,
      ref: f,
      onKeyDown: w
    });
  });
FS.displayName = pD;
function mD(e, {
  select: t = !1
} = {}) {
  const n = document.activeElement;
  for (const r of e) if (Xn(r, {
    select: t
  }), document.activeElement !== n) return;
}
function gD(e) {
  const t = _S(e),
    n = Cv(t, e),
    r = Cv(t.reverse(), e);
  return [n, r];
}
function _S(e) {
  const t = [],
    n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
      acceptNode: r => {
        const s = r.tagName === "INPUT" && r.type === "hidden";
        return r.disabled || r.hidden || s ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      }
    });
  for (; n.nextNode();) t.push(n.currentNode);
  return t;
}
function Cv(e, t) {
  for (const n of e) if (!yD(n, {
    upTo: t
  })) return n;
}
function yD(e, {
  upTo: t
}) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e;) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function vD(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Xn(e, {
  select: t = !1
} = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({
      preventScroll: !0
    }), e !== n && vD(e) && t && e.select();
  }
}
var Tv = xD();
function xD() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = Pv(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = Pv(e, t), (n = e[0]) == null || n.resume();
    }
  };
}
function Pv(e, t) {
  const n = [...e],
    r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function wD(e) {
  return e.filter(t => t.tagName !== "A");
}
var Jc = 0;
function bD() {
  y.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? kv()), document.body.insertAdjacentElement("beforeend", e[1] ?? kv()), Jc++, () => {
      Jc === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach(t => t.remove()), Jc--;
    };
  }, []);
}
function kv() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var ln = function () {
  return ln = Object.assign || function (t) {
    for (var n, r = 1, s = arguments.length; r < s; r++) {
      n = arguments[r];
      for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && (t[o] = n[o]);
    }
    return t;
  }, ln.apply(this, arguments);
};
function VS(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var s = 0, r = Object.getOwnPropertySymbols(e); s < r.length; s++) t.indexOf(r[s]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[s]) && (n[r[s]] = e[r[s]]);
  return n;
}
function SD(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, s = t.length, o; r < s; r++) (o || !(r in t)) && (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
  return e.concat(o || Array.prototype.slice.call(t));
}
var yl = "right-scroll-bar-position",
  vl = "width-before-scroll-bar",
  ED = "with-scroll-bars-hidden",
  CD = "--removed-body-scroll-bar-size";
function ed(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function TD(e, t) {
  var n = y.useState(function () {
    return {
      value: e,
      callback: t,
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var s = n.value;
          s !== r && (n.value = r, n.callback(r, s));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var PD = typeof window < "u" ? y.useLayoutEffect : y.useEffect,
  Rv = new WeakMap();
function kD(e, t) {
  var n = TD(null, function (r) {
    return e.forEach(function (s) {
      return ed(s, r);
    });
  });
  return PD(function () {
    var r = Rv.get(n);
    if (r) {
      var s = new Set(r),
        o = new Set(e),
        i = n.current;
      s.forEach(function (a) {
        o.has(a) || ed(a, null);
      }), o.forEach(function (a) {
        s.has(a) || ed(a, i);
      });
    }
    Rv.set(n, e);
  }, [e]), n;
}
function RD(e) {
  return e;
}
function ND(e, t) {
  t === void 0 && (t = RD);
  var n = [],
    r = !1,
    s = {
      read: function () {
        if (r) throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
        return n.length ? n[n.length - 1] : e;
      },
      useMedium: function (o) {
        var i = t(o, r);
        return n.push(i), function () {
          n = n.filter(function (a) {
            return a !== i;
          });
        };
      },
      assignSyncMedium: function (o) {
        for (r = !0; n.length;) {
          var i = n;
          n = [], i.forEach(o);
        }
        n = {
          push: function (a) {
            return o(a);
          },
          filter: function () {
            return n;
          }
        };
      },
      assignMedium: function (o) {
        r = !0;
        var i = [];
        if (n.length) {
          var a = n;
          n = [], a.forEach(o), i = n;
        }
        var l = function () {
            var d = i;
            i = [], d.forEach(o);
          },
          u = function () {
            return Promise.resolve().then(l);
          };
        u(), n = {
          push: function (d) {
            i.push(d), u();
          },
          filter: function (d) {
            return i = i.filter(d), n;
          }
        };
      }
    };
  return s;
}
function AD(e) {
  e === void 0 && (e = {});
  var t = ND(null);
  return t.options = ln({
    async: !0,
    ssr: !1
  }, e), t;
}
var BS = function (e) {
  var t = e.sideCar,
    n = VS(e, ["sideCar"]);
  if (!t) throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r) throw new Error("Sidecar medium not found");
  return y.createElement(r, ln({}, n));
};
BS.isSideCarExport = !0;
function jD(e, t) {
  return e.useMedium(t), BS;
}
var zS = AD(),
  td = function () {},
  Hu = y.forwardRef(function (e, t) {
    var n = y.useRef(null),
      r = y.useState({
        onScrollCapture: td,
        onWheelCapture: td,
        onTouchMoveCapture: td
      }),
      s = r[0],
      o = r[1],
      i = e.forwardProps,
      a = e.children,
      l = e.className,
      u = e.removeScrollBar,
      d = e.enabled,
      c = e.shards,
      f = e.sideCar,
      h = e.noRelative,
      w = e.noIsolation,
      m = e.inert,
      x = e.allowPinchZoom,
      g = e.as,
      v = g === void 0 ? "div" : g,
      b = e.gapMode,
      S = VS(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noRelative", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]),
      E = f,
      P = kD([n, t]),
      T = ln(ln({}, S), s);
    return y.createElement(y.Fragment, null, d && y.createElement(E, {
      sideCar: zS,
      removeScrollBar: u,
      shards: c,
      noRelative: h,
      noIsolation: w,
      inert: m,
      setCallbacks: o,
      allowPinchZoom: !!x,
      lockRef: n,
      gapMode: b
    }), i ? y.cloneElement(y.Children.only(a), ln(ln({}, T), {
      ref: P
    })) : y.createElement(v, ln({}, T, {
      className: l,
      ref: P
    }), a));
  });
Hu.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Hu.classNames = {
  fullWidth: vl,
  zeroRight: yl
};
var MD = function () {
  if (typeof __webpack_nonce__ < "u") return __webpack_nonce__;
};
function OD() {
  if (!document) return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = MD();
  return t && e.setAttribute("nonce", t), e;
}
function LD(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function DD(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var ID = function () {
    var e = 0,
      t = null;
    return {
      add: function (n) {
        e == 0 && (t = OD()) && (LD(t, n), DD(t)), e++;
      },
      remove: function () {
        e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
      }
    };
  },
  FD = function () {
    var e = ID();
    return function (t, n) {
      y.useEffect(function () {
        return e.add(t), function () {
          e.remove();
        };
      }, [t && n]);
    };
  },
  $S = function () {
    var e = FD(),
      t = function (n) {
        var r = n.styles,
          s = n.dynamic;
        return e(r, s), null;
      };
    return t;
  },
  _D = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0
  },
  nd = function (e) {
    return parseInt(e || "", 10) || 0;
  },
  VD = function (e) {
    var t = window.getComputedStyle(document.body),
      n = t[e === "padding" ? "paddingLeft" : "marginLeft"],
      r = t[e === "padding" ? "paddingTop" : "marginTop"],
      s = t[e === "padding" ? "paddingRight" : "marginRight"];
    return [nd(n), nd(r), nd(s)];
  },
  BD = function (e) {
    if (e === void 0 && (e = "margin"), typeof window > "u") return _D;
    var t = VD(e),
      n = document.documentElement.clientWidth,
      r = window.innerWidth;
    return {
      left: t[0],
      top: t[1],
      right: t[2],
      gap: Math.max(0, r - n + t[2] - t[0])
    };
  },
  zD = $S(),
  Ys = "data-scroll-locked",
  $D = function (e, t, n, r) {
    var s = e.left,
      o = e.top,
      i = e.right,
      a = e.gap;
    return n === void 0 && (n = "margin"), `
  .`.concat(ED, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(a, "px ").concat(r, `;
  }
  body[`).concat(Ys, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([t && "position: relative ".concat(r, ";"), n === "margin" && `
    padding-left: `.concat(s, `px;
    padding-top: `).concat(o, `px;
    padding-right: `).concat(i, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(a, "px ").concat(r, `;
    `), n === "padding" && "padding-right: ".concat(a, "px ").concat(r, ";")].filter(Boolean).join(""), `
  }
  
  .`).concat(yl, ` {
    right: `).concat(a, "px ").concat(r, `;
  }
  
  .`).concat(vl, ` {
    margin-right: `).concat(a, "px ").concat(r, `;
  }
  
  .`).concat(yl, " .").concat(yl, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(vl, " .").concat(vl, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(Ys, `] {
    `).concat(CD, ": ").concat(a, `px;
  }
`);
  },
  Nv = function () {
    var e = parseInt(document.body.getAttribute(Ys) || "0", 10);
    return isFinite(e) ? e : 0;
  },
  UD = function () {
    y.useEffect(function () {
      return document.body.setAttribute(Ys, (Nv() + 1).toString()), function () {
        var e = Nv() - 1;
        e <= 0 ? document.body.removeAttribute(Ys) : document.body.setAttribute(Ys, e.toString());
      };
    }, []);
  },
  WD = function (e) {
    var t = e.noRelative,
      n = e.noImportant,
      r = e.gapMode,
      s = r === void 0 ? "margin" : r;
    UD();
    var o = y.useMemo(function () {
      return BD(s);
    }, [s]);
    return y.createElement(zD, {
      styles: $D(o, !t, s, n ? "" : "!important")
    });
  },
  Jf = !1;
if (typeof window < "u") try {
  var Wa = Object.defineProperty({}, "passive", {
    get: function () {
      return Jf = !0, !0;
    }
  });
  window.addEventListener("test", Wa, Wa), window.removeEventListener("test", Wa, Wa);
} catch {
  Jf = !1;
}
var Es = Jf ? {
    passive: !1
  } : !1,
  HD = function (e) {
    return e.tagName === "TEXTAREA";
  },
  US = function (e, t) {
    if (!(e instanceof Element)) return !1;
    var n = window.getComputedStyle(e);
    return n[t] !== "hidden" && !(n.overflowY === n.overflowX && !HD(e) && n[t] === "visible");
  },
  qD = function (e) {
    return US(e, "overflowY");
  },
  KD = function (e) {
    return US(e, "overflowX");
  },
  Av = function (e, t) {
    var n = t.ownerDocument,
      r = t;
    do {
      typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
      var s = WS(e, r);
      if (s) {
        var o = HS(e, r),
          i = o[1],
          a = o[2];
        if (i > a) return !0;
      }
      r = r.parentNode;
    } while (r && r !== n.body);
    return !1;
  },
  QD = function (e) {
    var t = e.scrollTop,
      n = e.scrollHeight,
      r = e.clientHeight;
    return [t, n, r];
  },
  GD = function (e) {
    var t = e.scrollLeft,
      n = e.scrollWidth,
      r = e.clientWidth;
    return [t, n, r];
  },
  WS = function (e, t) {
    return e === "v" ? qD(t) : KD(t);
  },
  HS = function (e, t) {
    return e === "v" ? QD(t) : GD(t);
  },
  YD = function (e, t) {
    return e === "h" && t === "rtl" ? -1 : 1;
  },
  XD = function (e, t, n, r, s) {
    var o = YD(e, window.getComputedStyle(t).direction),
      i = o * r,
      a = n.target,
      l = t.contains(a),
      u = !1,
      d = i > 0,
      c = 0,
      f = 0;
    do {
      if (!a) break;
      var h = HS(e, a),
        w = h[0],
        m = h[1],
        x = h[2],
        g = m - x - o * w;
      (w || g) && WS(e, a) && (c += g, f += w);
      var v = a.parentNode;
      a = v && v.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? v.host : v;
    } while (!l && a !== document.body || l && (t.contains(a) || t === a));
    return (d && (Math.abs(c) < 1 || !s) || !d && (Math.abs(f) < 1 || !s)) && (u = !0), u;
  },
  Ha = function (e) {
    return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
  },
  jv = function (e) {
    return [e.deltaX, e.deltaY];
  },
  Mv = function (e) {
    return e && "current" in e ? e.current : e;
  },
  ZD = function (e, t) {
    return e[0] === t[0] && e[1] === t[1];
  },
  JD = function (e) {
    return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
  },
  e3 = 0,
  Cs = [];
function t3(e) {
  var t = y.useRef([]),
    n = y.useRef([0, 0]),
    r = y.useRef(),
    s = y.useState(e3++)[0],
    o = y.useState($S)[0],
    i = y.useRef(e);
  y.useEffect(function () {
    i.current = e;
  }, [e]), y.useEffect(function () {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(s));
      var m = SD([e.lockRef.current], (e.shards || []).map(Mv), !0).filter(Boolean);
      return m.forEach(function (x) {
        return x.classList.add("allow-interactivity-".concat(s));
      }), function () {
        document.body.classList.remove("block-interactivity-".concat(s)), m.forEach(function (x) {
          return x.classList.remove("allow-interactivity-".concat(s));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var a = y.useCallback(function (m, x) {
      if ("touches" in m && m.touches.length === 2 || m.type === "wheel" && m.ctrlKey) return !i.current.allowPinchZoom;
      var g = Ha(m),
        v = n.current,
        b = "deltaX" in m ? m.deltaX : v[0] - g[0],
        S = "deltaY" in m ? m.deltaY : v[1] - g[1],
        E,
        P = m.target,
        T = Math.abs(b) > Math.abs(S) ? "h" : "v";
      if ("touches" in m && T === "h" && P.type === "range") return !1;
      var k = Av(T, P);
      if (!k) return !0;
      if (k ? E = T : (E = T === "v" ? "h" : "v", k = Av(T, P)), !k) return !1;
      if (!r.current && "changedTouches" in m && (b || S) && (r.current = E), !E) return !0;
      var A = r.current || E;
      return XD(A, x, m, A === "h" ? b : S, !0);
    }, []),
    l = y.useCallback(function (m) {
      var x = m;
      if (!(!Cs.length || Cs[Cs.length - 1] !== o)) {
        var g = "deltaY" in x ? jv(x) : Ha(x),
          v = t.current.filter(function (E) {
            return E.name === x.type && (E.target === x.target || x.target === E.shadowParent) && ZD(E.delta, g);
          })[0];
        if (v && v.should) {
          x.cancelable && x.preventDefault();
          return;
        }
        if (!v) {
          var b = (i.current.shards || []).map(Mv).filter(Boolean).filter(function (E) {
              return E.contains(x.target);
            }),
            S = b.length > 0 ? a(x, b[0]) : !i.current.noIsolation;
          S && x.cancelable && x.preventDefault();
        }
      }
    }, []),
    u = y.useCallback(function (m, x, g, v) {
      var b = {
        name: m,
        delta: x,
        target: g,
        should: v,
        shadowParent: n3(g)
      };
      t.current.push(b), setTimeout(function () {
        t.current = t.current.filter(function (S) {
          return S !== b;
        });
      }, 1);
    }, []),
    d = y.useCallback(function (m) {
      n.current = Ha(m), r.current = void 0;
    }, []),
    c = y.useCallback(function (m) {
      u(m.type, jv(m), m.target, a(m, e.lockRef.current));
    }, []),
    f = y.useCallback(function (m) {
      u(m.type, Ha(m), m.target, a(m, e.lockRef.current));
    }, []);
  y.useEffect(function () {
    return Cs.push(o), e.setCallbacks({
      onScrollCapture: c,
      onWheelCapture: c,
      onTouchMoveCapture: f
    }), document.addEventListener("wheel", l, Es), document.addEventListener("touchmove", l, Es), document.addEventListener("touchstart", d, Es), function () {
      Cs = Cs.filter(function (m) {
        return m !== o;
      }), document.removeEventListener("wheel", l, Es), document.removeEventListener("touchmove", l, Es), document.removeEventListener("touchstart", d, Es);
    };
  }, []);
  var h = e.removeScrollBar,
    w = e.inert;
  return y.createElement(y.Fragment, null, w ? y.createElement(o, {
    styles: JD(s)
  }) : null, h ? y.createElement(WD, {
    noRelative: e.noRelative,
    gapMode: e.gapMode
  }) : null);
}
function n3(e) {
  for (var t = null; e !== null;) e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const r3 = jD(zS, t3);
var qS = y.forwardRef(function (e, t) {
  return y.createElement(Hu, ln({}, e, {
    ref: t,
    sideCar: r3
  }));
});
qS.classNames = Hu.classNames;
var s3 = function (e) {
    if (typeof document > "u") return null;
    var t = Array.isArray(e) ? e[0] : e;
    return t.ownerDocument.body;
  },
  Ts = new WeakMap(),
  qa = new WeakMap(),
  Ka = {},
  rd = 0,
  KS = function (e) {
    return e && (e.host || KS(e.parentNode));
  },
  o3 = function (e, t) {
    return t.map(function (n) {
      if (e.contains(n)) return n;
      var r = KS(n);
      return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
    }).filter(function (n) {
      return !!n;
    });
  },
  i3 = function (e, t, n, r) {
    var s = o3(t, Array.isArray(e) ? e : [e]);
    Ka[n] || (Ka[n] = new WeakMap());
    var o = Ka[n],
      i = [],
      a = new Set(),
      l = new Set(s),
      u = function (c) {
        !c || a.has(c) || (a.add(c), u(c.parentNode));
      };
    s.forEach(u);
    var d = function (c) {
      !c || l.has(c) || Array.prototype.forEach.call(c.children, function (f) {
        if (a.has(f)) d(f);else try {
          var h = f.getAttribute(r),
            w = h !== null && h !== "false",
            m = (Ts.get(f) || 0) + 1,
            x = (o.get(f) || 0) + 1;
          Ts.set(f, m), o.set(f, x), i.push(f), m === 1 && w && qa.set(f, !0), x === 1 && f.setAttribute(n, "true"), w || f.setAttribute(r, "true");
        } catch (g) {
          console.error("aria-hidden: cannot operate on ", f, g);
        }
      });
    };
    return d(t), a.clear(), rd++, function () {
      i.forEach(function (c) {
        var f = Ts.get(c) - 1,
          h = o.get(c) - 1;
        Ts.set(c, f), o.set(c, h), f || (qa.has(c) || c.removeAttribute(r), qa.delete(c)), h || c.removeAttribute(n);
      }), rd--, rd || (Ts = new WeakMap(), Ts = new WeakMap(), qa = new WeakMap(), Ka = {});
    };
  },
  a3 = function (e, t, n) {
    n === void 0 && (n = "data-aria-hidden");
    var r = Array.from(Array.isArray(e) ? e : [e]),
      s = s3(e);
    return s ? (r.push.apply(r, Array.from(s.querySelectorAll("[aria-live]"))), i3(r, s, n, "aria-hidden")) : function () {
      return null;
    };
  },
  qu = "Dialog",
  [QS, P5] = sa(qu),
  [l3, Xt] = QS(qu),
  GS = e => {
    const {
        __scopeDialog: t,
        children: n,
        open: r,
        defaultOpen: s,
        onOpenChange: o,
        modal: i = !0
      } = e,
      a = y.useRef(null),
      l = y.useRef(null),
      [u, d] = _w({
        prop: r,
        defaultProp: s ?? !1,
        onChange: o,
        caller: qu
      });
    return p.jsx(l3, {
      scope: t,
      triggerRef: a,
      contentRef: l,
      contentId: Mc(),
      titleId: Mc(),
      descriptionId: Mc(),
      open: u,
      onOpenChange: d,
      onOpenToggle: y.useCallback(() => d(c => !c), [d]),
      modal: i,
      children: n
    });
  };
GS.displayName = qu;
var YS = "DialogTrigger",
  XS = y.forwardRef((e, t) => {
    const {
        __scopeDialog: n,
        ...r
      } = e,
      s = Xt(YS, n),
      o = et(t, s.triggerRef);
    return p.jsx(Re.button, {
      type: "button",
      "aria-haspopup": "dialog",
      "aria-expanded": s.open,
      "aria-controls": s.contentId,
      "data-state": Jp(s.open),
      ...r,
      ref: o,
      onClick: ge(e.onClick, s.onOpenToggle)
    });
  });
XS.displayName = YS;
var Xp = "DialogPortal",
  [u3, ZS] = QS(Xp, {
    forceMount: void 0
  }),
  JS = e => {
    const {
        __scopeDialog: t,
        forceMount: n,
        children: r,
        container: s
      } = e,
      o = Xt(Xp, t);
    return p.jsx(u3, {
      scope: t,
      forceMount: n,
      children: y.Children.map(r, i => p.jsx(Ao, {
        present: n || o.open,
        children: p.jsx(sp, {
          asChild: !0,
          container: s,
          children: i
        })
      }))
    });
  };
JS.displayName = Xp;
var cu = "DialogOverlay",
  eE = y.forwardRef((e, t) => {
    const n = ZS(cu, e.__scopeDialog),
      {
        forceMount: r = n.forceMount,
        ...s
      } = e,
      o = Xt(cu, e.__scopeDialog);
    return o.modal ? p.jsx(Ao, {
      present: r || o.open,
      children: p.jsx(d3, {
        ...s,
        ref: t
      })
    }) : null;
  });
eE.displayName = cu;
var c3 = Vi("DialogOverlay.RemoveScroll"),
  d3 = y.forwardRef((e, t) => {
    const {
        __scopeDialog: n,
        ...r
      } = e,
      s = Xt(cu, n);
    return p.jsx(qS, {
      as: c3,
      allowPinchZoom: !0,
      shards: [s.contentRef],
      children: p.jsx(Re.div, window.LyoEditor.mediaProps({
        "data-state": Jp(s.open),
        ...r,
        ref: t,
        style: {
          pointerEvents: "auto",
          ...r.style
        }
      }))
    });
  }),
  hs = "DialogContent",
  tE = y.forwardRef((e, t) => {
    const n = ZS(hs, e.__scopeDialog),
      {
        forceMount: r = n.forceMount,
        ...s
      } = e,
      o = Xt(hs, e.__scopeDialog);
    return p.jsx(Ao, {
      present: r || o.open,
      children: o.modal ? p.jsx(f3, {
        ...s,
        ref: t
      }) : p.jsx(h3, {
        ...s,
        ref: t
      })
    });
  });
tE.displayName = hs;
var f3 = y.forwardRef((e, t) => {
    const n = Xt(hs, e.__scopeDialog),
      r = y.useRef(null),
      s = et(t, n.contentRef, r);
    return y.useEffect(() => {
      const o = r.current;
      if (o) return a3(o);
    }, []), p.jsx(nE, {
      ...e,
      ref: s,
      trapFocus: n.open,
      disableOutsidePointerEvents: !0,
      onCloseAutoFocus: ge(e.onCloseAutoFocus, o => {
        var i;
        o.preventDefault(), (i = n.triggerRef.current) == null || i.focus();
      }),
      onPointerDownOutside: ge(e.onPointerDownOutside, o => {
        const i = o.detail.originalEvent,
          a = i.button === 0 && i.ctrlKey === !0;
        (i.button === 2 || a) && o.preventDefault();
      }),
      onFocusOutside: ge(e.onFocusOutside, o => o.preventDefault())
    });
  }),
  h3 = y.forwardRef((e, t) => {
    const n = Xt(hs, e.__scopeDialog),
      r = y.useRef(!1),
      s = y.useRef(!1);
    return p.jsx(nE, {
      ...e,
      ref: t,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      onCloseAutoFocus: o => {
        var i, a;
        (i = e.onCloseAutoFocus) == null || i.call(e, o), o.defaultPrevented || (r.current || (a = n.triggerRef.current) == null || a.focus(), o.preventDefault()), r.current = !1, s.current = !1;
      },
      onInteractOutside: o => {
        var l, u;
        (l = e.onInteractOutside) == null || l.call(e, o), o.defaultPrevented || (r.current = !0, o.detail.originalEvent.type === "pointerdown" && (s.current = !0));
        const i = o.target;
        ((u = n.triggerRef.current) == null ? void 0 : u.contains(i)) && o.preventDefault(), o.detail.originalEvent.type === "focusin" && s.current && o.preventDefault();
      }
    });
  }),
  nE = y.forwardRef((e, t) => {
    const {
        __scopeDialog: n,
        trapFocus: r,
        onOpenAutoFocus: s,
        onCloseAutoFocus: o,
        ...i
      } = e,
      a = Xt(hs, n),
      l = y.useRef(null),
      u = et(t, l);
    return bD(), p.jsxs(p.Fragment, {
      children: [p.jsx(FS, {
        asChild: !0,
        loop: !0,
        trapped: r,
        onMountAutoFocus: s,
        onUnmountAutoFocus: o,
        children: p.jsx(Au, {
          role: "dialog",
          id: a.contentId,
          "aria-describedby": a.descriptionId,
          "aria-labelledby": a.titleId,
          "data-state": Jp(a.open),
          ...i,
          ref: u,
          onDismiss: () => a.onOpenChange(!1)
        })
      }), p.jsxs(p.Fragment, {
        children: [p.jsx(p3, {
          titleId: a.titleId
        }), p.jsx(g3, {
          contentRef: l,
          descriptionId: a.descriptionId
        })]
      })]
    });
  }),
  Zp = "DialogTitle",
  rE = y.forwardRef((e, t) => {
    const {
        __scopeDialog: n,
        ...r
      } = e,
      s = Xt(Zp, n);
    return p.jsx(Re.h2, {
      id: s.titleId,
      ...r,
      ref: t
    });
  });
rE.displayName = Zp;
var sE = "DialogDescription",
  oE = y.forwardRef((e, t) => {
    const {
        __scopeDialog: n,
        ...r
      } = e,
      s = Xt(sE, n);
    return p.jsx(Re.p, {
      id: s.descriptionId,
      ...r,
      ref: t
    });
  });
oE.displayName = sE;
var iE = "DialogClose",
  aE = y.forwardRef((e, t) => {
    const {
        __scopeDialog: n,
        ...r
      } = e,
      s = Xt(iE, n);
    return p.jsx(Re.button, {
      type: "button",
      ...r,
      ref: t,
      onClick: ge(e.onClick, () => s.onOpenChange(!1))
    });
  });
aE.displayName = iE;
function Jp(e) {
  return e ? "open" : "closed";
}
var lE = "DialogTitleWarning",
  [k5, uE] = L2(lE, {
    contentName: hs,
    titleName: Zp,
    docsSlug: "dialog"
  }),
  p3 = ({
    titleId: e
  }) => {
    const t = uE(lE),
      n = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
    return y.useEffect(() => {
      e && (document.getElementById(e) || console.error(n));
    }, [n, e]), null;
  },
  m3 = "DialogDescriptionWarning",
  g3 = ({
    contentRef: e,
    descriptionId: t
  }) => {
    const r = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${uE(m3).contentName}}.`;
    return y.useEffect(() => {
      var o;
      const s = (o = e.current) == null ? void 0 : o.getAttribute("aria-describedby");
      t && s && (document.getElementById(t) || console.warn(r));
    }, [r, e, t]), null;
  },
  y3 = GS,
  v3 = XS,
  x3 = JS,
  cE = eE,
  dE = tE,
  fE = rE,
  hE = oE,
  w3 = aE;
const b3 = y3,
  S3 = v3,
  E3 = x3,
  pE = y.forwardRef(({
    className: e,
    ...t
  }, n) => p.jsx(cE, {
    className: Y("fixed inset-0 z-50 bg-black/80 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0", e),
    ...t,
    ref: n
  }));
pE.displayName = cE.displayName;
const C3 = lp("fixed z-50 gap-4 bg-background p-6 shadow-lg transition ease-in-out data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:duration-300 data-[state=open]:duration-500", {
    variants: {
      side: {
        top: "inset-x-0 top-0 border-b data-[state=closed]:slide-out-to-top data-[state=open]:slide-in-from-top",
        bottom: "inset-x-0 bottom-0 border-t data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom",
        left: "inset-y-0 left-0 h-full w-3/4 border-r data-[state=closed]:slide-out-to-left data-[state=open]:slide-in-from-left sm:max-w-sm",
        right: "inset-y-0 right-0 h-full w-3/4  border-l data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right sm:max-w-sm"
      }
    },
    defaultVariants: {
      side: "right"
    }
  }),
  mE = y.forwardRef(({
    side: e = "right",
    className: t,
    children: n,
    ...r
  }, s) => p.jsxs(E3, {
    children: [p.jsx(pE, {}), p.jsxs(dE, {
      ref: s,
      className: Y(C3({
        side: e
      }), t),
      ...r,
      children: [n, p.jsxs(w3, {
        className: "absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity data-[state=open]:bg-secondary hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none",
        children: [p.jsx(ia, {
          className: "h-4 w-4"
        }), p.jsx("span", {
          className: "sr-only",
          get children() {
            return window.LyoEditor.text("txt_4e0bb71ec92f", "Close");
          }
        })]
      })]
    })]
  }));
mE.displayName = dE.displayName;
const gE = ({
  className: e,
  ...t
}) => p.jsx("div", {
  className: Y("flex flex-col space-y-2 text-center sm:text-left", e),
  ...t
});
gE.displayName = "SheetHeader";
const yE = y.forwardRef(({
  className: e,
  ...t
}, n) => p.jsx(fE, {
  ref: n,
  className: Y("text-lg font-semibold text-foreground", e),
  ...t
}));
yE.displayName = fE.displayName;
const vE = y.forwardRef(({
  className: e,
  ...t
}, n) => p.jsx(hE, {
  ref: n,
  className: Y("text-sm text-muted-foreground", e),
  ...t
}));
vE.displayName = hE.displayName;
const Ov = e => {
    let t;
    const n = new Set(),
      r = (u, d) => {
        const c = typeof u == "function" ? u(t) : u;
        if (!Object.is(c, t)) {
          const f = t;
          t = d ?? (typeof c != "object" || c === null) ? c : Object.assign({}, t, c), n.forEach(h => h(t, f));
        }
      },
      s = () => t,
      a = {
        setState: r,
        getState: s,
        getInitialState: () => l,
        subscribe: u => (n.add(u), () => n.delete(u))
      },
      l = t = e(r, s, a);
    return a;
  },
  T3 = e => e ? Ov(e) : Ov,
  P3 = e => e;
function k3(e, t = P3) {
  const n = L.useSyncExternalStore(e.subscribe, L.useCallback(() => t(e.getState()), [e, t]), L.useCallback(() => t(e.getInitialState()), [e, t]));
  return L.useDebugValue(n), n;
}
const R3 = e => {
    const t = T3(e),
      n = r => k3(t, r);
    return Object.assign(n, t), n;
  },
  N3 = e => R3;
function xE(e, t) {
  let n;
  try {
    n = e();
  } catch {
    return;
  }
  return {
    getItem: s => {
      var o;
      const i = l => l === null ? null : JSON.parse(l, void 0),
        a = (o = n.getItem(s)) != null ? o : null;
      return a instanceof Promise ? a.then(i) : i(a);
    },
    setItem: (s, o) => n.setItem(s, JSON.stringify(o, void 0)),
    removeItem: s => n.removeItem(s)
  };
}
const eh = e => t => {
    try {
      const n = e(t);
      return n instanceof Promise ? n : {
        then(r) {
          return eh(r)(n);
        },
        catch(r) {
          return this;
        }
      };
    } catch (n) {
      return {
        then(r) {
          return this;
        },
        catch(r) {
          return eh(r)(n);
        }
      };
    }
  },
  A3 = (e, t) => (n, r, s) => {
    let o = {
        storage: xE(() => window.localStorage),
        partialize: x => x,
        version: 0,
        merge: (x, g) => ({
          ...g,
          ...x
        }),
        ...t
      },
      i = !1,
      a = 0;
    const l = new Set(),
      u = new Set();
    let d = o.storage;
    if (!d) return e((...x) => {
      console.warn(`[zustand persist middleware] Unable to update item '${o.name}', the given storage is currently unavailable.`), n(...x);
    }, r, s);
    const c = () => {
        const x = o.partialize({
          ...r()
        });
        return d.setItem(o.name, {
          state: x,
          version: o.version
        });
      },
      f = s.setState;
    s.setState = (x, g) => (f(x, g), c());
    const h = e((...x) => (n(...x), c()), r, s);
    s.getInitialState = () => h;
    let w;
    const m = () => {
      var x, g;
      if (!d) return;
      const v = ++a;
      i = !1, l.forEach(S => {
        var E;
        return S((E = r()) != null ? E : h);
      });
      const b = ((g = o.onRehydrateStorage) == null ? void 0 : g.call(o, (x = r()) != null ? x : h)) || void 0;
      return eh(d.getItem.bind(d))(o.name).then(S => {
        if (S) if (typeof S.version == "number" && S.version !== o.version) {
          if (o.migrate) {
            const E = o.migrate(S.state, S.version);
            return E instanceof Promise ? E.then(P => [!0, P]) : [!0, E];
          }
          console.error("State loaded from storage couldn't be migrated since no migrate function was provided");
        } else return [!1, S.state];
        return [!1, void 0];
      }).then(S => {
        var E;
        if (v !== a) return;
        const [P, T] = S;
        if (w = o.merge(T, (E = r()) != null ? E : h), n(w, !0), P) return c();
      }).then(() => {
        v === a && (b == null || b(r(), void 0), w = r(), i = !0, u.forEach(S => S(w)));
      }).catch(S => {
        v === a && (b == null || b(void 0, S));
      });
    };
    return s.persist = {
      setOptions: x => {
        o = {
          ...o,
          ...x
        }, x.storage && (d = x.storage);
      },
      clearStorage: () => {
        d == null || d.removeItem(o.name);
      },
      getOptions: () => o,
      rehydrate: () => m(),
      hasHydrated: () => i,
      onHydrate: x => (l.add(x), () => {
        l.delete(x);
      }),
      onFinishHydration: x => (u.add(x), () => {
        u.delete(x);
      })
    }, o.skipHydration || m(), w || h;
  },
  j3 = A3;
class th extends Error {}
async function q3() {
  const map = new Map();
  for (const product of Object.values(window.LyoShopify.catalog)) {
    if (product.variantId) map.set(String(product.variantId), {
      variantId: String(product.variantId),
      productTitle: product.title,
      productHandle: product.handle,
      price: product.price,
      currencyCode: window.LyoShopify.config.currency,
      availableForSale: product.available,
      currentlyNotInStock: false
    });
  }
  return map;
}
function K3(e, t) {
  return t ? `${e}:${t.sweet}-${t.carrot}-${t.bean}` : e;
}
function Q3(e, t) {
  if (!t) return;
  const n = [];
  return t.sweet && n.push(`${t.sweet} Patate douce`), t.carrot && n.push(`${t.carrot} Carotte`), t.bean && n.push(`${t.bean} Haricots verts`), [{
    key: "Composition",
    value: `${e} — ${n.join(", ")}`
  }];
}
const Ku = N3()((set, get) => ({
    items: [],
    cartId: null,
    checkoutUrl: null,
    totalPrice: 0,
    isLoading: false,
    isSyncing: false,
    addItem: async (item, quantity = 1) => {
      if (get().isLoading) return 'error';
      set({
        isLoading: true
      });
      try {
        set(await window.LyoShopify.add(item, quantity));
        return 'ok';
      } catch (error) {
        console.error('Shopify cart:', error.message);
        return 'error';
      } finally {
        set({
          isLoading: false
        });
      }
    },
    updateQuantity: async (key, quantity) => {
      if (get().isLoading) return;
      const item = get().items.find(m => m.slug === key);
      const items = get().items;
      const hasAddons = items.some(m => {
        if (window.LyoShopify?.isGiftItem?.(m) || m.isGift) return false;
        if (window.LyoShopify?.isAddonItem?.(m)) return true;
        const slug = String(m.baseSlug || m.handle || "");
        return slug.startsWith("addon-") || slug.includes("sac-lyopup") || (!m.composition && Number(m.bags) === 1);
      });
      const slug = String(item?.baseSlug || item?.handle || "");
      const isBox = item && (window.LyoShopify?.isBoxItem?.(item) || !!item.composition || Number(item.bags) >= 3 || ["decouverte", "grande", "garde-manger"].includes(slug) || slug.includes("boite"));
      if (item && quantity <= 0 && hasAddons && isBox) return;
      if (item && quantity <= 0 && window.LyoShopify?.canRemoveItem && !window.LyoShopify.canRemoveItem(item, items)) return;
      set({
        isLoading: true
      });
      try {
        set(await window.LyoShopify.change(key, Math.max(0, quantity)));
      } catch (error) {
        La.error(error.message);
      } finally {
        set({
          isLoading: false
        });
      }
    },
    removeItem: async key => get().updateQuantity(key, 0),
    clearCart: () => set({
      items: [],
      cartId: null,
      checkoutUrl: null,
      totalPrice: 0
    }),
    getCheckoutUrl: () => get().checkoutUrl,
    syncCart: async () => {
      if (get().isSyncing || get().isLoading) return;
      set({
        isSyncing: true
      });
      try {
        set(await window.LyoShopify.refresh());
      } catch (error) {
        console.error('Shopify cart sync:', error.message);
      } finally {
        set({
          isSyncing: false
        });
      }
    }
  })),
  G3 = {
    3: {
      bags: 3,
      slug: "decouverte",
      price: 39.99
    },
    6: {
      bags: 6,
      slug: "grande",
      price: 64.99,
      subPrice: 59.99,
      subFirstPrice: 54.99,
      freeBadge: "Le meilleur prix par sac",
      freeBadgeEn: "The best price per bag"
    },
    10: {
      bags: 10,
      slug: "garde-manger",
      price: 99.99,
      subPrice: 94.99,
      subFirstPrice: 89.99,
      freeBadge: "Notre plus bas prix par sac",
      freeBadgeEn: "Our lowest price per bag"
    }
  },
  R5 = [3, 6, 10],
  N5 = 3,
  A5 = !1,
  od = 13.99,
  Y3 = 3,
  X3 = {
    sweet: window.LyoShopify.catalog["addon-sweet"]?.variantId || "",
    carrot: window.LyoShopify.catalog["addon-carrot"]?.variantId || "",
    bean: window.LyoShopify.catalog["addon-bean"]?.variantId || ""
  },
  j5 = 6,
  Z3 = (e, t) => Math.floor(e / t * 100) / 100,
  Qu = window.LyoShopify.asset("pouch-carrot-DaBR63mC.webp"),
  tm = window.LyoShopify.asset("pouch-sweet-potato-v7x4wwy2.webp"),
  nm = window.LyoShopify.asset("pouch-green-beans-60b1yudp.webp"),
  J3 = [{
    id: "sweet",
    nameKey: "flav.sweet",
    img: tm
  }, {
    id: "carrot",
    nameKey: "flav.carrot",
    img: Qu
  }, {
    id: "bean",
    nameKey: "flav.bean",
    img: nm
  }],
  eI = ({
    onClose: e
  }) => {
    const {
        t,
        lang: n
      } = Me(),
      {
        items: r,
        addItem: s,
        isLoading: o
      } = Ku();
    return p.jsxs("div", {
      className: "relative rounded-sm border border-foreground/10 bg-lyo-leaf/5 p-6 transition-colors",
      children: [p.jsxs("div", {
        className: "mb-6 mt-1 flex flex-col items-center",
        children: [p.jsx("h4", {
          className: "text-[11px] font-semibold uppercase tracking-widest text-lyo-leaf",
          children: n === "fr" ? window.LyoEditor.text("txt_0f74f446ea08", "Ajoute un sac à ta boîte") : window.LyoEditor.text("txt_fe0939646307", "Add a bag to your box")
        }), p.jsx("p", {
          className: "mt-1 text-center font-body text-[11px] italic text-foreground/55",
          children: n === "fr" ? window.LyoEditor.text("txt_04ccb1c4892b", "La livraison est déjà payée.") : window.LyoEditor.text("txt_5cc6b5085587", "Shipping is already covered.")
        })]
      }), p.jsx("div", {
        className: "grid grid-cols-3 gap-4",
        children: J3.map(i => {
          const a = X3[i.id],
            l = r.find(c => c.baseSlug === `addon-${i.id}`),
            u = ((l == null ? void 0 : l.quantity) ?? 0) >= Y3,
            d = !a || !window.LyoShopify.catalog[`addon-${i.id}`]?.available || u || o;
          return p.jsxs("button", {
            type: "button",
            disabled: d,
            "aria-disabled": d,
            onClick: () => s({
              baseSlug: `addon-${i.id}`,
              nameKey: i.nameKey,
              price: window.LyoShopify.catalog[`addon-${i.id}`]?.price ?? od,
              bags: 1,
              variantId: a
            }),
            className: "flex flex-col items-center transition-opacity hover:opacity-80 disabled:cursor-not-allowed disabled:opacity-40",
            children: [p.jsxs("span", {
              className: "relative mb-2 aspect-square w-full overflow-hidden rounded-full border border-lyo-leaf/10 bg-white",
              children: [p.jsx("img", window.LyoEditor.mediaProps({
                src: i.img,
                alt: "",
                loading: "lazy",
                className: "h-full w-full object-cover"
              })), !u && p.jsx("span", {
                className: "absolute inset-0 flex items-center justify-center bg-foreground/0 transition-colors hover:bg-lyo-leaf/10",
                children: p.jsx(dp, {
                  className: "h-4 w-4 text-lyo-leaf"
                })
              })]
            }), p.jsx("span", {
              className: "text-center font-body text-[10px] font-medium leading-tight text-foreground/80",
              children: t(i.nameKey)
            }), p.jsx("span", {
              className: "mt-0.5 font-body text-[9px] italic text-foreground/45",
              children: xo(window.LyoShopify.catalog[`addon-${i.id}`]?.price ?? od, n)
            })]
          }, i.id);
        })
      }), p.jsx("div", {
        className: "mt-5 text-center",
        children: p.jsxs("span", {
          className: "font-display text-sm italic text-lyo-leaf",
          children: ["+", xo(od, n), " / ", n === "fr" ? window.LyoEditor.text("txt_33c2b2da8572", "sac") : window.LyoEditor.text("txt_ee79b2d65f26", "bag")]
        })
      })]
    });
  },
  Dv = "lyo:open-cart",
  wE = window.LyoShopify.asset("boite-3-sacs-B5JIKNPH.png"),
  bE = window.LyoShopify.asset("boite-6-sacs-DhWfx7QL.png"),
  SE = window.LyoShopify.asset("boite-10-sacs-DLXmOyV6.png"),
  Iv = {
    decouverte: wE,
    grande: bE,
    "garde-manger": SE,
    "addon-sweet": tm,
    "addon-carrot": Qu,
    "addon-bean": nm
  },
  tI = ({
    inverse: e = !1
  }) => {
    const [t, n] = y.useState(location.pathname.endsWith("/cart")),
      {
        t: r,
        lang: s
      } = Me(),
      {
        items: o,
        updateQuantity: i,
        removeItem: a,
        checkoutUrl: l,
        isLoading: u,
        isSyncing: d,
        syncCart: c
      } = Ku(),
      f = o.reduce((m, x) => m + x.quantity, 0),
      h = Ku.getState().totalPrice,
      hasAddons = o.some(m => {
        if (window.LyoShopify?.isGiftItem?.(m) || m.isGift) return false;
        if (window.LyoShopify?.isAddonItem?.(m)) return true;
        const slug = String(m.baseSlug || m.handle || "");
        if (slug.startsWith("addon-") || slug.includes("sac-lyopup") || slug.includes("gateries")) return true;
        return !m.composition && Number(m.bags) === 1;
      });
    y.useEffect(() => {
      const m = () => n(!0);
      return window.addEventListener(Dv, m), () => window.removeEventListener(Dv, m);
    }, []), y.useEffect(() => {
      t && c();
    }, [t, c]);
    const w = m => {
      if (!l || u || d) {
        m.preventDefault();
        return;
      }
      m.preventDefault();
      try {
        window.top && window.top !== window.self ? window.top.location.href = l : window.location.href = l;
      } catch {
        window.location.href = l;
      }
    };
    y.useEffect(() => {
      if (!window.Shopify?.designMode) return;
      const handle = event => n(event.detail?.region === "cart");
      window.addEventListener('lyopup:editor-select', handle);
      return () => window.removeEventListener('lyopup:editor-select', handle);
    }, []);
    return p.jsxs(b3, {
      open: t,
      onOpenChange: n,
      children: [p.jsx(S3, {
        asChild: !0,
        children: p.jsxs("button", {
          "aria-label": r("cart.label"),
          className: Y("relative flex h-11 w-11 items-center justify-center rounded-full transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-lyo-leaf", e ? "text-[#F4EEDF] hover:bg-white/15" : "text-foreground hover:bg-foreground/5"),
          children: [p.jsx(Sf, {
            className: "h-5 w-5"
          }), f > 0 && p.jsx("span", {
            className: "absolute -right-0.5 -top-0.5 flex h-[18px] min-w-[18px] items-center justify-center rounded-full bg-lyo-carrot px-1 text-[10px] font-bold text-lyo-on-carrot",
            children: f
          })]
        })
      }), p.jsxs(mE, window.LyoEditor.regionProps("cart", {
        className: "flex h-dvh max-h-dvh w-full flex-col overflow-hidden bg-background p-0 sm:max-w-md",
        children: [p.jsxs(gE, {
          className: "border-b border-foreground/5 px-6 pb-4 pt-6",
          children: [p.jsx(yE, {
            className: "font-display text-xl font-semibold text-foreground",
            children: r("cart.title")
          }), p.jsx(vE, {
            className: "font-body text-sm text-foreground/60",
            children: f === 0 ? r("cart.empty") : window.LyoEditor.format("txt_4400974cbe76", "{{value1}} {{value2}}", [f, r(f === 1 ? "cart.item" : "cart.items")])
          })]
        }), o.length === 0 ? p.jsxs("div", {
          className: "flex min-h-0 flex-1 flex-col items-center justify-center overflow-y-auto p-6 text-center",
          children: [p.jsx(Sf, {
            className: "mb-3 h-10 w-10 text-foreground/30"
          }), p.jsx("p", {
            className: "mb-4 font-body text-sm text-foreground/60",
            children: r("cart.empty")
          }), p.jsx(Le, {
            to: "/shop",
            onClick: () => n(!1),
            className: "rounded-full bg-lyo-carrot px-5 py-2.5 font-display text-sm font-semibold text-lyo-on-carrot transition-opacity hover:opacity-90",
            children: r("cart.empty.cta")
          })]
        }) : p.jsxs(p.Fragment, {
          children: [p.jsxs("div", {
            className: "min-h-0 flex-1 overflow-y-auto overscroll-contain px-6 py-4",
            children: [p.jsx("ul", {
              className: "space-y-5",
              children: o.map(m => {
                const x = [];
                if (m.composition) {
                  const g = m.composition;
                  g.sweet && x.push(`${g.sweet} ${r("flav.sweet")}`), g.carrot && x.push(`${g.carrot} ${r("flav.carrot")}`), g.bean && x.push(`${g.bean} ${r("flav.bean")}`);
                }
                const slug = String(m.baseSlug || m.handle || ""),
                  isGift = Boolean(window.LyoShopify?.isGiftItem?.(m) || m.isGift),
                  isBox = window.LyoShopify?.isBoxItem?.(m) || !!m.composition || Number(m.bags) >= 3 || ["decouverte", "grande", "garde-manger"].includes(slug) || slug.startsWith("boite-") || slug.includes("boite"),
                  boxLocked = Boolean(hasAddons && isBox),
                  removeBlocked = isGift || boxLocked,
                  decrementBlocked = isGift || boxLocked && m.quantity <= 1;
                return p.jsxs("li", {
                  className: "flex gap-3",
                  children: [p.jsx("div", {
                    className: "flex h-14 w-14 flex-shrink-0 items-center justify-center overflow-hidden rounded-xl bg-lyo-sand sm:h-16 sm:w-16",
                    children: Iv[m.baseSlug] ? p.jsx("img", window.LyoEditor.mediaProps({
                      src: m.image || Iv[m.baseSlug],
                      alt: r(m.nameKey),
                      loading: "lazy",
                      className: "h-full w-full object-cover"
                    })) : p.jsxs("span", {
                      className: "px-1 text-center font-display text-[10px] font-semibold uppercase leading-tight tracking-[0.18em] text-foreground/50",
                      children: [m.bags, " ", r("ladder.bags")]
                    })
                  }), p.jsxs("div", {
                    className: "min-w-0 flex-1",
                    children: [p.jsxs("div", {
                      className: "flex items-start justify-between gap-2",
                      children: [p.jsx("h4", {
                        className: "font-display text-sm font-semibold leading-tight text-foreground",
                        children: r(m.nameKey)
                      }), p.jsx("p", {
                        className: "whitespace-nowrap font-display text-sm font-semibold leading-tight text-foreground",
                        children: isGift ? xo(0, s) : xo(m.price * m.quantity, s)
                      })]
                    }), p.jsxs("p", {
                      className: "mt-0.5 font-body text-xs text-foreground/60",
                      children: isGift ? r("launch.gift.meta") : [m.bags, " ", r("ladder.bags"), x.length > 0 && p.jsxs("span", {
                        className: "text-foreground/40",
                        children: [" · ", x.join(", ")]
                      })]
                    }), !isGift && p.jsxs("div", {
                      className: "mt-2 flex items-center gap-2",
                      children: [p.jsxs("div", {
                        className: "inline-flex items-center rounded-full border border-foreground/15",
                        children: [p.jsx("button", {
                          onClick: () => {
                            if (decrementBlocked) return;
                            i(m.slug, m.quantity - 1);
                          },
                          disabled: decrementBlocked || u || d,
                          className: "flex h-7 w-7 items-center justify-center text-foreground/70 hover:text-foreground disabled:cursor-not-allowed disabled:opacity-30",
                          "aria-label": "−",
                          children: p.jsx(l1, {
                            className: "h-3 w-3"
                          })
                        }), p.jsx("span", {
                          className: "w-6 text-center font-body text-sm",
                          children: m.quantity
                        }), p.jsx("button", {
                          onClick: () => i(m.slug, m.quantity + 1),
                          className: "flex h-7 w-7 items-center justify-center text-foreground/70 hover:text-foreground",
                          "aria-label": "+",
                          children: p.jsx(dp, {
                            className: "h-3 w-3"
                          })
                        })]
                      }), !removeBlocked && p.jsx("button", {
                        onClick: () => {
                          a(m.slug);
                        },
                        disabled: u || d,
                        className: "p-1 text-foreground/40 hover:text-destructive",
                        get "aria-label"() {
                          return window.LyoEditor.text("txt_70eee9043ebe", "Remove");
                        },
                        children: p.jsx(zR, {
                          className: "h-3.5 w-3.5"
                        })
                      }), removeBlocked && p.jsx("span", {
                        className: "p-1 text-foreground/20",
                        title: s === "fr" ? "Supprime d’abord le sac seul pour retirer la boîte" : "Remove the add-on bag before removing the box",
                        "aria-label": s === "fr" ? "Suppression de la boîte bloquée" : "Box removal locked",
                        children: p.jsx(zR, {
                          className: "h-3.5 w-3.5"
                        })
                      })]
                    }), boxLocked && p.jsx("p", {
                      className: "mt-1.5 font-body text-[11px] leading-snug text-lyo-carrot",
                      children: s === "fr" ? "Supprime le sac seul avant de retirer la boîte." : "Remove the add-on bag before removing the box."
                    })]
                  })]
                }, m.slug);
              })
            }), o.some(m => m.baseSlug === "decouverte") && p.jsxs("div", {
              className: "mt-5 rounded-2xl bg-lyo-sand px-4 py-3",
              children: [p.jsx("p", {
                className: "font-body text-xs text-foreground/75",
                children: s === "fr" ? window.LyoEditor.text("txt_b80b070ce56b", "Passe à La Grande Boîte : 3 sacs de plus, dont 1 gratuit, pour 25 $ de plus.") : window.LyoEditor.text("txt_8f5da7484fab", "Upgrade to The Big Box: 3 more bags, 1 of them free, for $25 more.")
              }), p.jsx(Le, {
                to: "/shop?taille=6",
                onClick: () => n(!1),
                className: "mt-1.5 inline-block font-display text-xs font-semibold text-lyo-leaf underline underline-offset-4",
                children: s === "fr" ? window.LyoEditor.text("txt_c6b0d9592d43", "Voir La Grande Boîte") : window.LyoEditor.text("txt_2dc56c51fa62", "See The Big Box")
              })]
            }), p.jsx("div", {
              className: "mt-5",
              children: p.jsx(eI, {
                onClose: () => n(!1)
              })
            })]
          }), p.jsxs("div", {
            className: "shrink-0 space-y-3 border-t border-foreground/5 bg-background px-6 py-4 pb-[max(1rem,env(safe-area-inset-bottom))]",
            children: [p.jsxs("div", {
              className: "flex items-center justify-between",
              children: [p.jsx("span", {
                className: "font-display font-semibold text-foreground",
                children: r("cart.subtotal")
              }), p.jsx("span", {
                className: "font-display text-lg font-bold text-foreground",
                children: xo(h, s)
              })]
            }), p.jsxs("p", {
              className: "font-body text-xs font-medium text-lyo-leaf",
              children: ["✓ ", r("cart.shipping")]
            }), p.jsxs("a", {
              href: l ?? "#",
              target: "_self",
              rel: "noopener noreferrer",
              onClick: w,
              "aria-disabled": !l || u || d,
              className: `inline-flex w-full items-center justify-center gap-2 rounded-full bg-lyo-carrot py-3.5 font-display font-semibold text-lyo-on-carrot transition-opacity hover:opacity-90 ${!l || u || d ? "pointer-events-none opacity-60" : ""}`,
              children: [(u || d) && p.jsx(cp, {
                className: "h-4 w-4 animate-spin"
              }), r("cart.checkout")]
            }), p.jsx("button", {
              onClick: () => n(!1),
              className: "w-full font-body text-sm text-foreground/60 hover:text-foreground",
              children: r("cart.continue")
            })]
          })]
        })]
      }))]
    });
  },
  du = ({
    className: e,
    size: t = "md",
    inverse: n = !1
  }) => {
    const r = {
      sm: "text-xl",
      md: "text-2xl",
      lg: "text-4xl md:text-5xl"
    }[t];
    return p.jsxs("span", {
      className: Y("font-display font-bold tracking-tight", r, e),
      children: [p.jsx("span", {
        className: n ? "text-[#F4EEDF]" : "text-lyo-leaf",
        get children() {
          return window.LyoEditor.text("txt_0ace644687ce", "Lyo");
        }
      }), p.jsx("span", {
        className: "text-lyo-carrot",
        get children() {
          return window.LyoEditor.text("txt_94aa0c3e2229", "Pup");
        }
      })]
    });
  },
  Pn = [0.22, 1, 0.36, 1],
  Xo = ({
    children: e,
    className: t,
    delay: n = 0
  }) => Fo() ? p.jsx("div", {
    className: t,
    children: e
  }) : p.jsx(Pt.div, {
    className: t,
    initial: {
      opacity: 0,
      y: 28
    },
    whileInView: {
      opacity: 1,
      y: 0
    },
    viewport: {
      once: !0,
      amount: 0.12
    },
    transition: {
      duration: 0.65,
      delay: n,
      ease: Pn
    },
    children: e
  }),
  nI = () => {
    const [e, t] = y.useState(!1),
      [n, r] = y.useState(!1),
      s = Fo(),
      {
        t: o
      } = Me(),
      i = Vn(),
      a = n || e,
      l = s ? "transition-none" : "transition-all duration-500";
    y.useEffect(() => {
      t(!1), r(!1);
    }, [i.pathname]), y.useEffect(() => (document.body.style.overflow = e ? "hidden" : "", () => {
      document.body.style.overflow = "";
    }), [e]), y.useEffect(() => {
      const c = () => r(window.scrollY > 80);
      return c(), window.addEventListener("scroll", c, {
        passive: !0
      }), () => window.removeEventListener("scroll", c);
    }, []);
    const u = [{
        to: "/shop",
        label: o("nav.shop")
      }, {
        to: "/notre-mission",
        label: o("nav.story")
      }, {
        to: "/faq",
        label: o("nav.faq")
      }, {
        to: "/contact",
        label: o("nav.contact")
      }],
      d = ({
        isActive: c
      }) => Y("relative rounded-full px-3 py-1.5 font-display text-sm font-semibold leading-none tracking-wide transition-colors duration-200", a ? c ? "bg-white/20 text-[#F4EEDF]" : "text-[#F4EEDF]/85 hover:bg-white/20 hover:text-[#F4EEDF]" : c ? "bg-lyo-leaf text-white" : "text-foreground/70 hover:bg-foreground/5 hover:text-foreground");
    return p.jsxs(p.Fragment, {
      children: [p.jsx("div", window.LyoEditor.regionProps("announcement", {
        className: Y("relative z-50 overflow-hidden bg-lyo-leaf text-[#F4EEDF]", e ? "h-0" : "h-8"),
        children: p.jsx("div", {
          className: "flex h-8 items-center justify-center px-4",
          children: p.jsx("p", {
            className: "w-full text-center font-body text-xs leading-none sm:text-sm",
            children: o("announce.bar")
          })
        })
      })), p.jsx("header", window.LyoEditor.regionProps("header", {
        className: Y("fixed z-40 flex justify-center", l, e ? "inset-x-0 top-0 px-0" : n ? "inset-x-0 top-4 px-4" : "inset-x-0 top-8 px-4"),
        children: p.jsx("div", window.LyoEditor.mediaProps({
          className: Y("px-4 py-2 md:px-7 md:py-2.5", l, e ? "w-full max-w-none rounded-none border-0 bg-lyo-leaf" : Y("w-[92%] max-w-[1300px]", a ? "border border-white/10 bg-lyo-leaf/80 shadow-lg shadow-ink/20" : "border border-transparent bg-transparent")),
          style: e ? void 0 : {
            borderRadius: 50,
            backdropFilter: a ? "blur(20px)" : void 0,
            WebkitBackdropFilter: a ? "blur(20px)" : void 0
          },
          children: p.jsxs("div", {
            className: "grid grid-cols-[auto_1fr_auto] items-center gap-2",
            children: [p.jsxs("div", {
              className: "flex min-w-0 items-center",
              children: [p.jsx("button", {
                type: "button",
                onClick: () => t(!e),
                className: Y("flex h-11 w-11 items-center justify-center rounded-full focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-lyo-leaf md:hidden", a ? "text-[#F4EEDF] hover:bg-white/15" : "text-foreground hover:bg-foreground/5"),
                "aria-label": o(e ? "nav.close" : "nav.menu"),
                "aria-expanded": e,
                children: e ? p.jsx(ia, {
                  className: "h-5 w-5"
                }) : p.jsx(DR, {
                  className: "h-5 w-5"
                })
              }), p.jsx(Le, {
                to: "/",
                get "aria-label"() {
                  return window.LyoEditor.text("txt_1b01b499f17f", "LyoPup");
                },
                className: "hidden min-w-[7rem] md:block",
                children: p.jsx(du, {
                  size: "md",
                  inverse: a,
                  className: "text-[1.35rem]"
                })
              })]
            }), p.jsxs("div", {
              className: "flex items-center justify-center",
              children: [p.jsx(Le, {
                to: "/",
                get "aria-label"() {
                  return window.LyoEditor.text("txt_1b01b499f17f", "LyoPup");
                },
                className: "md:hidden",
                children: p.jsx(du, {
                  size: "sm",
                  inverse: a,
                  className: "text-[1.2rem]"
                })
              }), p.jsx("nav", {
                className: "hidden items-center justify-center gap-1 whitespace-nowrap md:flex",
                children: u.map(c => p.jsx(Lg, {
                  to: c.to,
                  className: d,
                  children: c.label
                }, c.to))
              })]
            }), p.jsxs("div", {
              className: "flex items-center justify-end gap-1.5",
              children: [a && p.jsx(Le, {
                to: "/shop",
                className: "hidden rounded-full bg-[#F4EEDF] px-4 py-2.5 font-display text-xs font-semibold tracking-wide text-lyo-leaf transition-colors hover:bg-white lg:inline-flex",
                children: o("hero.cta")
              }), p.jsx(hD, {
                inverse: a
              }), p.jsx(tI, {
                inverse: a
              })]
            })]
          })
        }))
      })), p.jsx(o4, {
        children: e && p.jsx(Pt.div, {
          className: "fixed inset-0 z-30 overflow-y-auto bg-[#F4EEDF] md:hidden",
          initial: s ? !1 : {
            opacity: 0,
            y: -8
          },
          animate: {
            opacity: 1,
            y: 0
          },
          exit: s ? void 0 : {
            opacity: 0,
            y: -8
          },
          transition: {
            duration: 0.28,
            ease: Pn
          },
          children: p.jsxs("nav", {
            className: "container mx-auto flex flex-col px-4 pb-8 pt-24",
            children: [u.map((c, f) => p.jsx(Pt.div, {
              initial: s ? !1 : {
                opacity: 0,
                x: 18
              },
              animate: {
                opacity: 1,
                x: 0
              },
              transition: {
                delay: s ? 0 : 0.05 * f,
                duration: 0.4,
                ease: Pn
              },
              children: p.jsx(Lg, {
                to: c.to,
                className: ({
                  isActive: h
                }) => Y("block rounded-2xl px-3 py-3 font-display text-3xl tracking-tight", h ? "text-lyo-leaf" : "text-foreground"),
                children: c.label
              })
            }, c.to)), p.jsx(Le, {
              to: "/shop",
              className: "btn-lyo mt-8 self-start bg-lyo-carrot hover:brightness-110",
              children: o("hero.cta")
            })]
          })
        })
      })]
    });
  },
  Fv = e => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(e.trim());
async function aI(email, source) {
  const response = await fetch("https://a.klaviyo.com/client/subscriptions/?company_id=S8bqhz", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      revision: "2024-10-15"
    },
    body: JSON.stringify({
      data: {
        type: "subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: {
                email: email.trim(),
                properties: {
                  source
                }
              }
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: "list",
              id: "ViQTvh"
            }
          }
        }
      }
    })
  });
  if (!response.ok) throw new Error(`Klaviyo subscription failed (${response.status})`);
}
const EE = ({
    source: e,
    id: t,
    className: n,
    tone: r = "default",
    subline: s,
    ctaLabel: o,
    successCode: m,
    stacked: g = !1
  }) => {
    const {
        t: i
      } = Me(),
      [a, l] = y.useState(""),
      [u, d] = y.useState("idle"),
      c = r === "inverted",
      f = async h => {
        if (h.preventDefault(), u !== "loading") {
          if (!Fv(a)) {
            d("error");
            return;
          }
          d("loading");
          try {
            await aI(a, e), d("success"), l("");
          } catch {
            d("error");
          }
        }
      };
    if (u === "success" && m) return p.jsx("div", {
      id: t,
      className: Y("max-w-md", n),
      children: p.jsxs("div", {
        className: "rounded-2xl bg-lyo-leaf/10 px-5 py-5 text-center",
        children: [p.jsx(up, {
          className: "mx-auto h-6 w-6 text-lyo-leaf",
          strokeWidth: 2.5
        }), p.jsx("p", {
          className: "mt-2 font-display text-sm font-semibold text-foreground",
          children: i("popup.thanks")
        }), p.jsx("div", {
          className: "mt-3 rounded-xl border border-dashed border-lyo-leaf/40 bg-card px-4 py-3 font-display text-xl font-bold tracking-[0.12em] text-lyo-leaf",
          children: m
        })]
      })
    });
    return u === "success" ? p.jsx("div", {
      id: t,
      className: Y("max-w-md", n),
      children: p.jsxs("div", {
        className: Y("flex items-start gap-2 rounded-2xl px-4 py-3", c ? "bg-primary-foreground/10" : "bg-lyo-leaf/10"),
        children: [p.jsx(up, {
          className: Y("w-4 h-4 mt-0.5 flex-shrink-0", c ? "text-primary-foreground" : "text-lyo-leaf")
        }), p.jsxs("div", {
          children: [p.jsx("p", {
            className: Y("font-display font-semibold text-sm", c ? "text-primary-foreground" : "text-foreground"),
            children: i("email.success.title")
          }), p.jsx("p", {
            className: Y("font-body text-xs mt-0.5", c ? "text-primary-foreground/75" : "text-foreground/65"),
            children: i("email.success.body")
          })]
        })]
      })
    }) : p.jsxs("div", {
      id: t,
      className: Y("max-w-md", n),
      children: [p.jsxs("form", {
        onSubmit: f,
        className: Y("flex flex-col gap-2", !g && "sm:flex-row"),
        children: [p.jsx("label", {
          className: "sr-only",
          htmlFor: `${t ?? e}-email`,
          children: i("email.placeholder")
        }), p.jsx("input", {
          id: `${t ?? e}-email`,
          type: "email",
          inputMode: "email",
          autoComplete: "email",
          maxLength: 254,
          value: a,
          onChange: h => {
            l(h.target.value), u === "error" && d("idle");
          },
          placeholder: i("email.placeholder"),
          className: Y("flex-1 min-w-0 rounded-full px-4 py-3 text-sm font-body focus:outline-none", c ? "bg-primary-foreground/10 text-primary-foreground placeholder:text-primary-foreground/50 border border-primary-foreground/20 focus:border-primary-foreground/50" : "bg-card text-foreground placeholder:text-foreground/45 border border-foreground/15 focus:border-lyo-leaf")
        }), p.jsxs("button", {
          type: "submit",
          disabled: u === "loading",
          className: Y("inline-flex items-center justify-center gap-2 bg-lyo-carrot text-lyo-on-carrot font-display font-semibold text-sm px-6 py-3 rounded-full hover:opacity-90 transition-opacity disabled:opacity-60 disabled:cursor-not-allowed flex-shrink-0", g && "w-full"),
          children: [u === "loading" && p.jsx(cp, {
            className: "w-4 h-4 animate-spin"
          }), u === "loading" ? i("email.sending") : o ?? i("email.cta")]
        })]
      }), s && p.jsx("p", {
        className: Y("font-body text-xs mt-2", c ? "text-primary-foreground/70" : "text-foreground/60"),
        children: s
      }), u === "error" && p.jsx("p", {
        className: Y("font-body text-xs mt-2", c ? "text-primary-foreground" : "text-lyo-terra"),
        children: Fv(a) || a === "" ? i("email.error") : i("email.invalid")
      })]
    });
  },
  lI = ({
    className: e
  }) => p.jsx("svg", {
    viewBox: "0 0 24 24",
    fill: "currentColor",
    className: e,
    "aria-hidden": "true",
    children: p.jsx("path", {
      d: "M16.6 5.82a4.28 4.28 0 0 1-3.77-4.05h-3.3v13.6a2.55 2.55 0 1 1-1.8-2.43V9.6a5.84 5.84 0 1 0 5.1 5.79V8.94a7.55 7.55 0 0 0 4.4 1.4V7.06a4.32 4.32 0 0 1-.63-.05c-.01-.4 0-.79 0-1.19Z"
    })
  }),
  uI = () => {
    const {
      t: e
    } = Me();
    return p.jsx("footer", window.LyoEditor.regionProps("footer", {
      className: "mt-16 bg-lyo-leaf-deep pb-[var(--sticky-cta,0px)] text-primary-foreground",
      children: p.jsxs("div", {
        className: "container mx-auto px-4 py-14",
        children: [p.jsxs("div", {
          className: "grid grid-cols-1 md:grid-cols-12 gap-10",
          children: [p.jsxs("div", {
            className: "md:col-span-5",
            children: [p.jsx(du, {
              size: "lg"
            }), p.jsx("p", {
              className: "font-body text-sm mt-4 text-primary-foreground/80 max-w-sm leading-relaxed",
              children: e("footer.signup.title")
            }), p.jsx(EE, {
              source: "footer",
              tone: "inverted",
              className: "mt-4"
            })]
          }), p.jsxs("div", {
            className: "md:col-span-3",
            children: [p.jsx("h4", {
              className: "font-display text-sm font-semibold uppercase tracking-wider text-primary-foreground/60 mb-4",
              children: e("footer.col.shop")
            }), p.jsxs("ul", {
              className: "space-y-2.5 font-body text-sm",
              children: [p.jsx("li", {
                children: p.jsx(Le, {
                  to: "/shop",
                  className: "text-primary-foreground/85 hover:text-primary-foreground",
                  children: e("nav.shop")
                })
              }), p.jsx("li", {
                children: p.jsx(Le, {
                  to: "/notre-mission",
                  className: "text-primary-foreground/85 hover:text-primary-foreground",
                  children: e("nav.story")
                })
              }), p.jsx("li", {
                children: p.jsx(Le, {
                  to: "/contact",
                  className: "text-primary-foreground/85 hover:text-primary-foreground",
                  children: e("nav.contact")
                })
              })]
            })]
          }), p.jsxs("div", {
            className: "md:col-span-3",
            children: [p.jsx("h4", {
              className: "font-display text-sm font-semibold uppercase tracking-wider text-primary-foreground/60 mb-4",
              children: e("footer.col.help")
            }), p.jsxs("ul", {
              className: "space-y-2.5 font-body text-sm",
              children: [p.jsx("li", {
                children: p.jsx(Le, {
                  to: "/faq",
                  className: "text-primary-foreground/85 hover:text-primary-foreground",
                  children: e("footer.faq")
                })
              }), p.jsx("li", {
                children: p.jsx(Le, {
                  to: "/remboursement",
                  className: "text-primary-foreground/85 hover:text-primary-foreground",
                  children: e("footer.refund")
                })
              }), p.jsx("li", {
                children: p.jsx(Le, {
                  to: "/livraison",
                  className: "text-primary-foreground/85 hover:text-primary-foreground",
                  children: e("footer.shipping")
                })
              }), p.jsx("li", {
                children: p.jsx(Le, {
                  to: "/conditions",
                  className: "text-primary-foreground/85 hover:text-primary-foreground",
                  children: e("footer.terms")
                })
              })]
            })]
          }), p.jsxs("div", {
            className: "md:col-span-1 flex md:flex-col items-start gap-3",
            children: [p.jsx("a", {
              href: window.LyoShopify.config.instagram || "https://instagram.com",
              target: "_self",
              rel: "noreferrer",
              get "aria-label"() {
                return window.LyoEditor.text("txt_298383514597", "Instagram");
              },
              className: "w-9 h-9 rounded-full bg-primary-foreground/10 hover:bg-primary-foreground/20 flex items-center justify-center transition-colors",
              children: p.jsx(OR, {
                className: "w-4 h-4"
              })
            }), p.jsx("a", {
              href: window.LyoShopify.config.tiktok || "https://tiktok.com",
              target: "_self",
              rel: "noreferrer",
              get "aria-label"() {
                return window.LyoEditor.text("txt_d6171a8febfe", "TikTok");
              },
              className: "w-9 h-9 rounded-full bg-primary-foreground/10 hover:bg-primary-foreground/20 flex items-center justify-center transition-colors",
              children: p.jsx(lI, {
                className: "w-4 h-4"
              })
            })]
          })]
        }), p.jsxs("div", {
          className: "border-t border-primary-foreground/15 mt-12 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3",
          children: [p.jsxs("p", {
            className: "font-body text-xs text-primary-foreground/60",
            children: window.LyoEditor.array([() => window.LyoEditor.text("txt_e7fb94dc4544", "© "), new Date().getFullYear(), () => window.LyoEditor.text("txt_79020d5074db", " LyoPup · "), e("footer.rights")], [0, 2])
          }), p.jsx("p", {
            className: "font-body text-xs text-primary-foreground/60",
            children: e("footer.made")
          })]
        })]
      })
    }));
  },
  popupLifestyleImage = window.LyoShopify.asset("popup-dog-carrot.jpg"),
  _v = "lyopup-popup-seen",
  cI = () => {
    const {
        t: e
      } = Me(),
      [t, n] = y.useState(!1);
    y.useEffect(() => {
      if (localStorage.getItem(_v) && !window.LyoEditor.popupPreview() || !window.LyoShopify.config.popup || window.Shopify?.designMode && !window.LyoEditor.popupPreview()) return;
      const s = window.setTimeout(() => n(!0), 5e3);
      return () => window.clearTimeout(s);
    }, []);
    const r = () => {
      n(!1), localStorage.setItem(_v, "1");
    };
    y.useEffect(() => {
      if (!window.Shopify?.designMode) return;
      const handle = event => n(event.detail?.region === "popup");
      window.addEventListener('lyopup:editor-select', handle);
      return () => window.removeEventListener('lyopup:editor-select', handle);
    }, []);
    return t ? p.jsx("div", window.LyoEditor.regionProps("popup", {
      className: "fixed inset-0 z-50 flex items-center justify-center p-4 bg-foreground/40 animate-in fade-in duration-200",
      children: [p.jsx("style", {
        children: `.lyo-email-popup{width:min(94vw,47.5rem);overflow:hidden;border-radius:2rem;background:#f7f0df}.lyo-email-popup__layout{display:grid;grid-template-columns:1fr}.lyo-email-popup__visual{display:none;min-height:31rem}.lyo-email-popup__visual img{width:100%;height:100%;object-fit:cover;object-position:52% center}.lyo-email-popup__content{display:flex;flex-direction:column;justify-content:center;padding:2rem}@media (min-width:640px){.lyo-email-popup__layout{grid-template-columns:42% 58%}.lyo-email-popup__visual{display:block}.lyo-email-popup__content{padding:3rem}}`
      }), p.jsxs("div", {
        className: "lyo-email-popup relative shadow-card",
        children: [p.jsx("button", {
          onClick: r,
          get "aria-label"() {
            return window.LyoEditor.text("txt_81e2231bf41f", "Close");
          },
          className: "absolute right-4 top-4 z-10 flex h-9 w-9 items-center justify-center rounded-full bg-background/80 text-foreground/60 shadow-sm hover:text-foreground",
          children: p.jsx(ia, {
            className: "w-5 h-5"
          })
        }), p.jsxs("div", {
          className: "lyo-email-popup__layout",
          children: [p.jsx("div", {
            className: "lyo-email-popup__visual bg-lyo-chamber",
            children: p.jsx("img", window.LyoEditor.mediaProps({
              src: window.LyoEditor.image("__popup_image", popupLifestyleImage),
              alt: "",
            }))
          }), p.jsxs("div", {
            className: "lyo-email-popup__content",
            children: [p.jsx("p", {
              className: "self-start rounded-full bg-lyo-leaf/10 px-4 py-2 font-display text-xs font-bold uppercase tracking-[0.16em] text-lyo-leaf",
              children: e("popup.badge")
            }), p.jsx("h3", {
              className: "mt-4 font-display text-3xl font-bold leading-tight text-foreground",
              children: e("popup.title")
            }), p.jsx("p", {
              className: "mt-3 font-body text-base leading-relaxed text-foreground/65",
              style: {
                whiteSpace: "pre-line"
              },
              children: e("popup.body")
            }), p.jsx(EE, {
              source: "popup",
              className: "mt-6 max-w-none",
              ctaLabel: e("popup.cta"),
              successCode: "BIENVENUE10",
              stacked: !0
            }), p.jsx("button", {
              type: "button",
              onClick: r,
              className: "mt-4 w-full font-body text-xs text-foreground/50 hover:text-foreground",
              children: e("popup.dismiss")
            })]
          })]
        })]
      })]
    })) : null;
  };
function dI() {
  const e = Ku(t => t.syncCart);
  y.useEffect(() => {
    e();
    const t = () => {
      document.visibilityState === "visible" && e();
    };
    return document.addEventListener("visibilitychange", t), () => document.removeEventListener("visibilitychange", t);
  }, [e]);
}
const fI = window.LyoShopify.asset("carrot-JsgwG7Dh.webp"),
  hI = window.LyoShopify.asset("frost-nIyc3c5x.webp"),
  pI = window.LyoShopify.asset("green-beans-BwhRPBOL.webp"),
  mI = window.LyoShopify.asset("paw-trail-DRI8R7re.webp"),
  gI = window.LyoShopify.asset("receipt-DuqZG3uk.webp"),
  yI = window.LyoShopify.asset("sweet-potato-ywMXd9un.webp"),
  vI = {
    carrot: fI,
    frost: hI,
    greenBeans: pI,
    pawTrail: mI,
    receipt: gI,
    sweetPotato: yI
  },
  xl = ({
    motif: e,
    className: t,
    imageClassName: n
  }) => p.jsx("span", {
    className: Y("pointer-events-none select-none", t),
    "aria-hidden": "true",
    children: p.jsx("img", window.LyoEditor.mediaProps({
      src: vI[e],
      alt: "",
      loading: "lazy",
      fetchPriority: "low",
      decoding: "async",
      draggable: !1,
      className: Y("block h-full w-full object-contain", n)
    }))
  }),
  xI = ({
    items: e
  }) => {
    const [t, n] = y.useState(0);
    return p.jsx("ul", {
      className: "divide-y divide-foreground/10 border-y border-foreground/10",
      children: e.map((r, s) => {
        const o = t === s;
        return p.jsxs("li", {
          children: [p.jsxs("button", {
            onClick: () => n(o ? null : s),
            className: "w-full flex items-start justify-between gap-4 py-5 text-left",
            "aria-expanded": o,
            children: [p.jsx("span", {
              className: "font-display font-semibold text-foreground text-base sm:text-lg",
              children: r.q
            }), p.jsx("span", {
              className: "flex-shrink-0 mt-1 text-foreground/60",
              children: o ? p.jsx(l1, {
                className: "w-4 h-4"
              }) : p.jsx(dp, {
                className: "w-4 h-4"
              })
            })]
          }), o && p.jsx("div", {
            className: "pb-5 -mt-2 font-body text-foreground/70 leading-relaxed",
            children: r.a
          })]
        }, s);
      })
    });
  },
  CE = ({
    className: e,
    tone: t = "default"
  }) => {
    const {
      t: n
    } = Me();
    return p.jsxs("div", {
      className: Y("flex flex-wrap items-center gap-x-3 gap-y-1 font-body text-sm", t === "inverted" ? "text-primary-foreground/85" : "text-foreground/85", e),
      children: [p.jsxs("span", {
        className: "inline-flex items-center gap-1.5",
        children: [p.jsx(IR, {
          className: "h-4 w-4",
          "aria-hidden": !0
        }), n("badge.shipping")]
      }), p.jsx("span", {
        "aria-hidden": "true",
        className: "opacity-50",
        children: "·"
      }), p.jsxs("span", {
        className: "inline-flex items-center gap-1.5",
        children: [p.jsx(c1, {
          className: "h-4 w-4",
          "aria-hidden": !0
        }), n("badge.guarantee")]
      })]
    });
  },
  wI = [{
    icon: a1,
    titleKey: "truths.1.title",
    descKey: "truths.1.desc"
  }, {
    icon: jR,
    titleKey: "truths.2.title",
    descKey: "truths.2.desc"
  }, {
    icon: fp,
    titleKey: "truths.3.title",
    descKey: "truths.3.desc"
  }, {
    icon: _R,
    titleKey: "truths.4.title",
    descKey: "truths.4.desc"
  }],
  bI = () => {
    const {
      t: e
    } = Me();
    return p.jsx("section", window.LyoEditor.regionProps("benefits", {
      className: "container mx-auto px-4 pb-8 pt-14 sm:pb-12 sm:pt-20",
      children: p.jsxs("div", {
        className: "mx-auto max-w-5xl",
        children: [p.jsx("h2", {
          className: "mb-8 text-center font-display text-2xl font-bold text-foreground sm:mb-10 sm:text-3xl",
          children: e("truths.title")
        }), p.jsx("div", {
          className: "grid grid-cols-2 gap-4 sm:gap-6 lg:grid-cols-4",
          children: wI.map(({
            icon: t,
            titleKey: n,
            descKey: r
          }) => p.jsxs("div", {
            className: "bg-background border border-foreground/10 rounded-2xl p-5 sm:p-6",
            children: [p.jsx(t, {
              className: "w-6 h-6 text-lyo-leaf mb-3",
              strokeWidth: 1.75
            }), p.jsx("p", {
              className: "font-display font-bold text-foreground text-sm sm:text-base leading-snug",
              children: e(n)
            }), p.jsx("p", {
              className: "font-body text-xs sm:text-sm text-foreground/70 mt-1.5 leading-relaxed",
              children: e(r)
            })]
          }, n))
        })]
      })
    }));
  },
  Xs = {
    cream: "#F4EEDF",
    leaf: "#5E8C3A",
    carrot: "#E0852E",
    ink: "#2C2C2A",
    terra: "#C56B3B",
    olive: "#7E9152"
  },
  Vv = ({
    src: e,
    alt: t,
    className: n,
    imgClassName: r,
    loading: s = "lazy"
  }) => {
    const {
        t: o
      } = Me(),
      [i, a] = y.useState(!1);
    return i ? p.jsxs("div", {
      className: Y("flex flex-col items-center justify-center bg-lyo-rime/50 text-center px-4", n),
      role: "img",
      "aria-label": t,
      children: [p.jsx("p", {
        className: "kicker text-foreground/40",
        children: o("img.missing")
      }), p.jsx("p", {
        className: "font-body text-sm text-foreground/55 mt-2 max-w-[14rem]",
        children: t
      })]
    }) : p.jsx("img", window.LyoEditor.mediaProps({
      src: e,
      alt: t,
      loading: s,
      decoding: "async",
      onError: () => a(!0),
      className: Y(r ?? n)
    }));
  },
  SI = window.LyoShopify.asset("legume-patate-douce-BIKkAOUk.jpg"),
  EI = window.LyoShopify.asset("legume-carotte-m1rRR0ZX.jpg"),
  CI = window.LyoShopify.asset("legume-haricots-DgSXXBkU.jpg"),
  TI = [{
    id: 2,
    titleKey: "bybenefit.2.title",
    vegKey: "bybenefit.2.veg",
    descKey: "bybenefit.2.desc",
    sensKey: "bybenefit.2.sens",
    hex: Xs.carrot,
    pouch: Qu,
    veg: EI
  }, {
    id: 1,
    titleKey: "bybenefit.1.title",
    vegKey: "bybenefit.1.veg",
    descKey: "bybenefit.1.desc",
    sensKey: "bybenefit.1.sens",
    hex: Xs.terra,
    pouch: tm,
    veg: SI
  }, {
    id: 3,
    titleKey: "bybenefit.3.title",
    vegKey: "bybenefit.3.veg",
    descKey: "bybenefit.3.desc",
    sensKey: "bybenefit.3.sens",
    hex: Xs.olive,
    pouch: nm,
    veg: CI
  }],
  PI = () => {
    const {
        t: e
      } = Me();
    return p.jsxs("section", window.LyoEditor.regionProps("vegetables", {
      className: "container mx-auto px-4 py-16 sm:py-24",
      children: [p.jsx("style", {
        children: `.lyo-veg-list{display:grid;grid-template-columns:1fr;gap:3rem}.lyo-veg-row{text-align:center}.lyo-veg-row__image{width:min(72vw,17rem);aspect-ratio:1;margin:0 auto;overflow:hidden;border-radius:9999px;box-shadow:0 16px 34px rgba(44,44,42,.12)}.lyo-veg-row__image img{width:100%;height:100%;object-fit:cover}.lyo-veg-row__content{max-width:20rem;margin:1.5rem auto 0}@media (min-width:768px){.lyo-veg-list{grid-template-columns:repeat(3,minmax(0,1fr));gap:2rem}.lyo-veg-row__image{width:min(24vw,17rem)}}`
      }), p.jsxs("div", {
        className: "mx-auto mb-10 max-w-2xl text-center",
        children: [p.jsx("p", {
          className: "kicker text-lyo-leaf",
          children: e("bybenefit.eyebrow")
        }), p.jsx("h2", {
          className: "mt-2 font-display text-3xl font-bold leading-tight text-foreground sm:text-4xl",
          children: e("bybenefit.title")
        })]
      }), p.jsx("div", {
        className: "lyo-veg-list mx-auto max-w-5xl",
        children: TI.map(({
          id: r,
          titleKey: s,
          vegKey: o,
          descKey: i,
          hex: l,
          veg: d
        }) => {
          const h = e(o);
          return p.jsxs("article", {
            id: `benefit-${r}`,
            className: "lyo-veg-row scroll-mt-24",
            children: [p.jsx("div", {
              className: "lyo-veg-row__image bg-lyo-sand",
              children: p.jsx(Vv, window.LyoEditor.mediaProps({
                src: d,
                alt: h,
                className: "h-full w-full",
                imgClassName: "h-full w-full object-cover object-center"
              }))
            }), p.jsxs("div", {
              className: "lyo-veg-row__content",
              children: [p.jsxs("div", {
                className: "flex items-center justify-center gap-2",
                "aria-hidden": !0,
                children: [p.jsx("span", window.LyoEditor.mediaProps({
                  className: "h-2.5 w-2.5 rounded-full",
                  style: {
                    backgroundColor: l
                  }
                })), p.jsx(a1, window.LyoEditor.mediaProps({
                  className: "h-4 w-4",
                  style: {
                    color: l
                  },
                  strokeWidth: 1.75
                }))]
              }), p.jsx("h3", window.LyoEditor.mediaProps({
                className: "mt-3 font-display text-2xl font-bold leading-tight sm:text-[1.7rem]",
                style: {
                  color: l
                },
                children: e(s)
              })), p.jsx("p", {
                className: "mt-3 font-body text-sm leading-relaxed text-foreground/70",
                children: e(i)
              })]
            })]
          }, s);
        })
      }), p.jsxs("div", {
        className: "mt-10 text-center",
        children: [p.jsx("p", {
          className: "font-display text-lg font-semibold text-foreground",
          children: e("bybenefit.footer")
        }), p.jsxs(Le, {
          to: "/shop",
          className: "btn-lyo mt-6 bg-lyo-carrot hover:brightness-110",
          children: [e("bybenefit.cta"), p.jsx(Ou, {
            className: "h-4 w-4",
            "aria-hidden": !0
          })]
        })]
      })]
    }));
  },
  kI = window.LyoShopify.asset("lyopup-mark-Hp7UqKEb.png"),
  id = [1, 2, 3, 4],
  RI = ({
    label: e
  }) => p.jsx("span", {
    className: "flex h-9 w-9 items-center justify-center rounded-full bg-lyo-leaf shadow-sm sm:h-10 sm:w-10",
    "aria-label": e,
    children: p.jsx(up, {
      className: "h-4 w-4 text-white sm:h-5 sm:w-5",
      strokeWidth: 2.75,
      "aria-hidden": !0
    })
  }),
  NI = ({
    label: e
  }) => p.jsx("span", {
    className: "flex h-9 w-9 items-center justify-center rounded-full border border-foreground/15 bg-white sm:h-10 sm:w-10",
    "aria-label": e,
    children: p.jsx(ia, {
      className: "h-4 w-4 text-foreground sm:h-5 sm:w-5",
      strokeWidth: 2.25,
      "aria-hidden": !0
    })
  }),
  AI = () => {
    const {
      t: e
    } = Me();
    return p.jsxs("section", window.LyoEditor.regionProps("label", {
      className: "container mx-auto px-4 pb-16 sm:pb-24",
      children: [p.jsxs("div", {
        className: "mx-auto mb-2 max-w-xl text-center",
        children: [p.jsx("span", {
          className: "font-display text-lg font-semibold uppercase tracking-[0.18em] text-lyo-leaf",
          children: e("label.eyebrow")
        }), p.jsx("h2", {
          className: "mt-2 font-display text-3xl font-bold leading-tight text-foreground sm:text-4xl",
          children: e("label.title")
        })]
      }), p.jsx("div", {
        className: "mx-auto max-w-6xl",
        style: {
          marginTop: "6rem"
        },
        children: p.jsxs("div", {
          className: "relative",
          children: [p.jsx("div", {
            "aria-hidden": !0,
            className: "pointer-events-none absolute -bottom-4 top-0 left-1/2 z-0 w-[8.5rem] -translate-x-1/2 rounded-[2rem] bg-[#DCE6C4] shadow-[0_18px_40px_-16px_hsl(92_41%_18%/0.4)] sm:w-[14rem]"
          }), p.jsxs("div", {
            className: "relative z-10 grid grid-cols-[minmax(0,1fr)_8.5rem_minmax(0,1fr)] items-end sm:grid-cols-[minmax(0,1fr)_14rem_minmax(0,1fr)]",
            children: [p.jsx("p", {
              className: "pb-5 text-center font-display text-3xl font-bold leading-none text-foreground sm:pb-6 sm:text-5xl",
              children: e("label.vs")
            }), p.jsxs("div", {
              className: "flex flex-col items-center justify-end px-2 pb-4 sm:pb-5",
              children: [p.jsx("img", window.LyoEditor.mediaProps({
                src: kI,
                alt: "",
                className: "mx-auto h-20 w-20 rounded-full object-cover sm:h-24 sm:w-24"
              })), p.jsx("span", {
                className: "mt-2 inline-flex rounded-full bg-white px-4 py-1.5 shadow-sm ring-1 ring-foreground/8",
                children: p.jsx(du, {
                  size: "sm",
                  className: "text-base sm:text-lg"
                })
              })]
            }), p.jsx("p", {
              className: "pb-5 text-center font-display text-lg font-medium leading-none text-foreground/40 sm:pb-6 sm:text-3xl",
              children: e("label.typical")
            })]
          }), p.jsx("div", {
            className: "relative z-10 overflow-hidden rounded-[2rem]",
            children: id.map((t, n) => {
              const r = n === 0,
                s = n === id.length - 1;
              return p.jsxs("div", {
                className: "grid grid-cols-[minmax(0,1fr)_8.5rem_minmax(0,1fr)] sm:grid-cols-[minmax(0,1fr)_14rem_minmax(0,1fr)]",
                style: {
                  minHeight: "4.75rem"
                },
                children: [p.jsx("div", {
                  className: `flex items-center justify-start bg-card px-4 py-4 text-left font-body text-sm leading-snug text-foreground sm:px-8 sm:text-lg${r ? " rounded-tl-[2rem]" : ""}${s ? " rounded-bl-[2rem]" : ""}`,
                  children: e(`label.row.${t}.label`)
                }), p.jsx("div", {
                  className: "flex items-center justify-center px-2 py-4",
                  children: p.jsx(RI, {
                    label: `${e("label.us")}: ${e(`label.row.${t}.us`)}`
                  })
                }), p.jsx("div", {
                  className: `flex items-center justify-center bg-card px-5 py-4 sm:px-8${r ? " rounded-tr-[2rem]" : ""}${s ? " rounded-br-[2rem]" : ""}`,
                  children: p.jsx(NI, {
                    label: `${e("label.typical")}: ${e(`label.row.${t}.them`)}`
                  })
                })]
              }, t);
            })
          })]
        })
      }), p.jsx("p", {
        className: "mt-8 text-center font-display text-xl font-bold text-lyo-leaf",
        children: e("label.footer")
      })]
    }));
  },
  TE = ({
    className: e
  }) => {
    const {
        t
      } = Me(),
      n = ["trustbar.ingredient", "trustbar.quebec", "trustbar.guarantee", "trustbar.shipping"];
    return p.jsx("div", window.LyoEditor.regionProps("ticker", {
      className: Y("group w-full overflow-hidden bg-lyo-leaf text-primary-foreground", e),
      "aria-label": n.map(t).join(" · "),
      children: p.jsx("div", {
        className: "nav-ticker-track is-running py-3.5 sm:py-4",
        children: [0, 1].map(r => p.jsx("span", {
          className: "nav-ticker-set trust-ticker-set",
          children: n.map(s => p.jsxs("span", {
            className: "inline-flex shrink-0 items-center gap-2 whitespace-nowrap font-display text-sm font-semibold sm:text-base",
            children: [p.jsx(AR, {
              className: "h-4 w-4 shrink-0",
              strokeWidth: 2.25,
              "aria-hidden": !0
            }), t(s)]
          }, `${r}-${s}`))
        }, r))
      })
    }));
  },
  jI = window.LyoShopify.asset("hero-lyopup-DNmKvlH1.png"),
  MI = window.LyoShopify.asset("hero-lyopup-BI10TST8.webp"),
  OI = window.LyoShopify.asset("hero-lyopup-mobile-B_im-QTc.png"),
  LI = window.LyoShopify.asset("hero-lyopup-mobile-BLSZ4Dx6.webp"),
  DI = Pt(Le),
  II = () => {
    const {
        t: e
      } = Me(),
      t = Fo(),
      n = e("hero.title").split(`
`),
      r = (s, o = 0.6) => t ? {} : {
        initial: {
          opacity: 0,
          y: 18
        },
        animate: {
          opacity: 1,
          y: 0
        },
        transition: {
          duration: o,
          delay: s,
          ease: Pn
        }
      };
    return p.jsxs("section", window.LyoEditor.regionProps("hero", {
      className: "relative -mt-8 min-h-dvh overflow-hidden bg-background text-foreground lg:mt-0 lg:h-screen lg:max-h-[860px] lg:min-h-0",
      children: [p.jsxs(Pt.div, {
        className: "pointer-events-none absolute inset-0",
        initial: t ? !1 : {
          opacity: 0
        },
        animate: {
          opacity: 1
        },
        transition: {
          duration: 0.75,
          delay: t ? 0 : 0.2,
          ease: Pn
        },
        children: [p.jsxs("picture", {
          children: [p.jsx("source", window.LyoEditor.mediaProps({
            media: "(min-width: 1024px)",
            srcSet: MI,
            type: "image/webp"
          })), p.jsx("source", window.LyoEditor.mediaProps({
            media: "(min-width: 1024px)",
            srcSet: jI
          })), p.jsx("source", window.LyoEditor.mediaProps({
            srcSet: LI,
            type: "image/webp"
          })), p.jsx("img", window.LyoEditor.mediaProps({
            src: OI,
            get alt() {
              return window.LyoEditor.text("txt_967dbd8093cf", "Chien qui saute pour attraper une gâterie LyoPup");
            },
            loading: "eager",
            fetchPriority: "high",
            decoding: "async",
            className: "h-full w-full object-cover object-[50%_42%] lg:object-[46%_46%]"
          }))]
        }), p.jsx("div", {
          className: "absolute inset-x-0 top-0 h-24 bg-gradient-to-b from-background/70 to-transparent lg:hidden",
          "aria-hidden": !0
        }), p.jsx("div", {
          className: "absolute left-0 top-16 h-[48%] w-[78%] bg-gradient-to-br from-background/75 via-background/35 to-transparent lg:hidden",
          "aria-hidden": !0
        }), p.jsx("div", {
          className: "absolute left-[10%] top-[58%] h-[22%] w-[36%] rounded-full bg-background/50 blur-2xl lg:hidden",
          "aria-hidden": !0
        }), p.jsxs("div", {
          className: "absolute inset-0 hidden lg:block",
          "aria-hidden": !0,
          children: [p.jsx("div", {
            className: "absolute inset-y-0 left-0 w-[52%] bg-gradient-to-r from-background via-background/80 to-transparent"
          }), p.jsx("div", {
            className: "hero-window-light absolute inset-y-0 left-0 w-[46%] opacity-50 mix-blend-multiply"
          }), p.jsx("div", {
            className: "absolute inset-0 bg-gradient-to-t from-background/25 via-transparent to-background/20"
          })]
        }), p.jsx("div", {
          className: "absolute inset-x-0 bottom-0 hidden h-20 bg-gradient-to-t from-lyo-leaf via-lyo-leaf/80 to-transparent lg:block",
          "aria-hidden": !0
        })]
      }), p.jsxs("div", {
        className: "relative z-10 flex min-h-dvh flex-col justify-start px-6 pb-24 pt-28 pr-28 sm:pr-32 lg:absolute lg:inset-y-0 lg:left-0 lg:flex lg:min-h-0 lg:w-5/12 lg:justify-center lg:px-16 lg:pb-0 lg:pr-16 lg:pt-0",
        children: [p.jsx(Pt.p, {
          className: "font-hand text-xl leading-tight text-lyo-leaf",
          initial: t ? !1 : {
            opacity: 0,
            y: 12
          },
          animate: {
            opacity: 1,
            y: 0
          },
          transition: {
            duration: 0.55,
            delay: t ? 0 : 0.08,
            ease: Pn
          },
          children: e("hero.eyebrow")
        }), p.jsx("h1", {
          className: "mt-3 font-display text-4xl font-bold leading-[1.18] tracking-tight text-foreground [text-shadow:0_1px_16px_hsl(var(--background))] sm:text-5xl md:text-6xl",
          children: n.map(s => p.jsx(Pt.span, {
            className: "block",
            initial: t ? !1 : {
              opacity: 0,
              y: 28
            },
            animate: {
              opacity: 1,
              y: 0
            },
            transition: {
              duration: 0.65,
              delay: t ? 0 : 0.16,
              ease: Pn
            },
            children: s
          }, s))
        }), p.jsxs(Pt.div, {
          className: "relative mt-4 max-w-[19.5rem] sm:max-w-sm lg:max-w-lg",
          ...r(0.36),
          children: [p.jsx("span", {
            className: "pointer-events-none absolute -inset-x-4 -inset-y-3 rounded-2xl bg-background/85 blur-2xl lg:hidden",
            "aria-hidden": !0
          }), p.jsx("p", {
            className: "relative whitespace-pre-line font-body text-base leading-relaxed text-foreground/80 sm:text-lg lg:text-foreground/70",
            children: e("hero.subtitle")
          })]
        }), p.jsxs(Pt.div, {
          className: "mt-6",
          ...r(0.48),
          children: [p.jsxs(DI, {
            to: "/shop",
            className: "btn-lyo bg-lyo-carrot hover:brightness-110",
            whileHover: t ? void 0 : {
              y: -2
            },
            whileTap: {
              scale: 0.98
            },
            children: [e("hero.cta"), p.jsx(Ou, {
              className: "h-4 w-4",
              "aria-hidden": !0
            })]
          }), p.jsx(CE, {
            className: "mt-3"
          })]
        })]
      }), p.jsxs("div", {
        className: "absolute inset-x-0 bottom-0 z-20 lg:hidden",
        children: [p.jsx("div", {
          className: "h-16 bg-gradient-to-t from-lyo-leaf to-transparent",
          "aria-hidden": !0
        }), p.jsx(TE, {
          className: "-mt-px"
        })]
      })]
    }));
  },
  FI = lp("inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0", {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground hover:bg-primary/90",
        destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
        outline: "border border-input bg-background hover:bg-accent hover:text-accent-foreground",
        secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline"
      },
      size: {
        default: "h-10 px-4 py-2",
        sm: "h-9 rounded-md px-3",
        lg: "h-11 rounded-md px-8",
        icon: "h-10 w-10"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }),
  PE = y.forwardRef(({
    className: e,
    variant: t,
    size: n,
    asChild: r = !1,
    ...s
  }, o) => {
    const i = r ? I2 : "button";
    return p.jsx(i, {
      className: Y(FI({
        variant: t,
        size: n,
        className: e
      })),
      ref: o,
      ...s
    });
  });
PE.displayName = "Button";
const _I = window.LyoShopify.asset("transformation-patate-douce-BJBsf2cg.webp"),
  VI = window.LyoShopify.asset("transformation-haricots-verts-Y-wagE6W.webp"),
  BI = window.LyoShopify.asset("carotte-Cq7HymKU.jpeg"),
  zI = {
    fr: {
      get recommended() {
        return window.LyoEditor.text("txt_20c29360dd8c", "NOTRE RECOMMANDATION");
      },
      get perBag() {
        return window.LyoEditor.text("txt_0f11f391f830", "/ sac");
      },
      boxNames: {
        get 3() {
          return window.LyoEditor.text("txt_1d07e8990da9", "Boîte Découverte");
        },
        get 6() {
          return window.LyoEditor.text("txt_12597c93216c", "La Grande Boîte");
        },
        get 10() {
          return window.LyoEditor.text("txt_d3833c0357e7", "Le Garde-Manger");
        }
      },
      names: {
        get 3() {
          return window.LyoEditor.text("txt_7ad5bce65847", "Boîte Découverte");
        },
        get 6() {
          return window.LyoEditor.text("txt_ddb4cf8b1025", "La Grande Boîte");
        },
        get 10() {
          return window.LyoEditor.text("txt_bfbb069166ec", "Le Garde-Manger");
        }
      },
      qty: {
        get 3() {
          return window.LyoEditor.text("txt_bb4c56cb7eec", "3 SACS");
        },
        get 6() {
          return window.LyoEditor.text("txt_4ea7f73a7121", "6 SACS");
        },
        get 10() {
          return window.LyoEditor.text("txt_77cb6c2d4f19", "10 SACS");
        }
      },
      bonus: {
        get 3() {
          return window.LyoEditor.text("txt_6d6b601074c4", "");
        },
        get 6() {
          return window.LyoEditor.text("txt_dd594d4f0f70", "");
        },
        get 10() {
          return window.LyoEditor.text("txt_4713f5ae5424", "");
        }
      },
      bestValue: window.LyoEditor.array([() => window.LyoEditor.text("txt_b6e1e203ec23", "MEILLEURE"), () => window.LyoEditor.text("txt_44f4aa4fb38d", "VALEUR")], [0, 1]),
      checks: {
        get 3() {
          return window.LyoEditor.text("txt_a0565e36c080", "Les 3 saveurs, avec 1 sac de chaque.");
        },
        get 6() {
          return window.LyoEditor.text("txt_03e5cf096028", "Les 3 saveurs, avec 2 sacs de chaque.");
        },
        get 10() {
          return window.LyoEditor.text("txt_7e101b6c3bac", "Un assortiment généreux de nos 3 saveurs, au meilleur prix par sac.");
        }
      }
    },
    en: {
      get recommended() {
        return window.LyoEditor.text("txt_323d6ac1f4f1", "OUR RECOMMENDATION");
      },
      get perBag() {
        return window.LyoEditor.text("txt_c2708d3080be", "/ bag");
      },
      boxNames: {
        get 3() {
          return window.LyoEditor.text("txt_c46d6c8ef127", "Discovery Box");
        },
        get 6() {
          return window.LyoEditor.text("txt_e09c7449735a", "The Big Box");
        },
        get 10() {
          return window.LyoEditor.text("txt_7da92e2af891", "The Pantry");
        }
      },
      names: {
        get 3() {
          return window.LyoEditor.text("txt_ecd3ae336718", "Discovery Box");
        },
        get 6() {
          return window.LyoEditor.text("txt_2f06ebb87b8b", "The Big Box");
        },
        get 10() {
          return window.LyoEditor.text("txt_2123597ee4e0", "The Pantry");
        }
      },
      qty: {
        get 3() {
          return window.LyoEditor.text("txt_c658c96f3f4a", "3 BAGS");
        },
        get 6() {
          return window.LyoEditor.text("txt_4df652a13ecf", "6 BAGS");
        },
        get 10() {
          return window.LyoEditor.text("txt_cb68826007d4", "10 BAGS");
        }
      },
      bonus: {
        get 3() {
          return window.LyoEditor.text("txt_1fdeec5494b1", "");
        },
        get 6() {
          return window.LyoEditor.text("txt_e5ee9b4204a7", "");
        },
        get 10() {
          return window.LyoEditor.text("txt_418ac8db7747", "");
        }
      },
      bestValue: window.LyoEditor.array([() => window.LyoEditor.text("txt_9db9560c40be", "BEST"), () => window.LyoEditor.text("txt_75229683a3de", "VALUE")], [0, 1]),
      checks: {
        get 3() {
          return window.LyoEditor.text("txt_45f501a1162e", "All 3 flavours, with 1 bag of each.");
        },
        get 6() {
          return window.LyoEditor.text("txt_463f2caa9dbc", "All 3 flavours, with 2 bags of each.");
        },
        get 10() {
          return window.LyoEditor.text("txt_61db169a20eb", "A generous mix of our 3 flavours, at the best price per bag.");
        }
      }
    }
  };
function $I(e) {
  if (e === 3) return {
    sweet: 1,
    carrot: 1,
    bean: 1
  };
  if (e === 6) return {
    sweet: 2,
    carrot: 2,
    bean: 2
  };
  if (e === 10) return {
    sweet: 2,
    carrot: 4,
    bean: 4
  };
  const t = Math.floor(e / 3);
  return {
    sweet: t + (e - t * 3),
    carrot: t,
    bean: t
  };
}
function UI(e, t, n = $I(t.bags), r) {
  return e({
    baseSlug: t.slug,
    nameKey: t.nameKey,
    price: t.displayPrice,
    bags: t.bags,
    variantId: t.variantId,
    composition: n,
    giftFlavor: r
  });
}
const WI = {
    decouverte: wE,
    grande: bE,
    "garde-manger": SE
  },
  HI = ({
    boxes: e,
    productsLoading: t
  }) => {
    const {
        t: n,
        lang: r
      } = Me(),
      s = zI[r],
      o = Ku(d => d.addItem),
      [i, a] = y.useState(null),
      l = [...e].sort((d, c) => d.bags - c.bags),
      u = async d => {
        if (!d.available) {
          La.error(n("cart.add.oos"));
          return;
        }
        a(d.bags);
        const c = await UI(o, d);
        a(null), c === "ok" ? La.success(n("cart.add.success")) : c === "throttled" ? La.error(n("cart.add.throttled")) : La.error(n("cart.add.error"));
      };
    return p.jsxs("section", {
      id: "boxes",
      className: "container mx-auto scroll-mt-24 px-4 py-14 sm:py-20",
      children: [p.jsxs("div", window.LyoEditor.regionProps("home_boxes", {
        className: "mx-auto max-w-2xl text-center",
        children: [p.jsx("p", {
          className: "kicker text-lyo-leaf",
          children: n("homeboxes.eyebrow")
        }), p.jsx("h2", {
          className: "mt-3 font-display text-3xl font-bold text-foreground sm:text-4xl",
          children: n("homeboxes.title")
        }), p.jsx("p", {
          className: "mt-3 whitespace-pre-line font-body text-base leading-relaxed text-foreground/70",
          children: n("homeboxes.subtitle")
        }), p.jsxs(Le, {
          to: "/shop",
          className: "btn-lyo mt-6 bg-lyo-carrot hover:brightness-110",
          children: [n("homeboxes.cta"), p.jsx(Ou, {
            className: "h-4 w-4",
            "aria-hidden": !0
          })]
        })]
      })), p.jsx("div", window.LyoEditor.regionProps("box_cards", {
        className: "isolate -mx-4 mt-9 flex snap-x snap-mandatory items-stretch gap-4 overflow-x-auto px-4 pb-3 [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden md:mx-0 md:grid md:grid-cols-3 md:gap-5 md:overflow-visible md:px-0",
        children: l.map(d => {
          const c = d.bags,
            f = d.displayPrice ?? G3[c].price,
            h = c === 3,
            w = c === 10,
            m = i === c;
          return p.jsxs("article", {
            className: Y("relative flex min-w-[82vw] snap-start flex-col overflow-hidden rounded-2xl border bg-card sm:min-w-[21rem] md:min-w-0", h ? "border-lyo-leaf" : w ? "border-lyo-carrot" : "border-foreground/15"),
            children: [h && p.jsx("span", {
              className: "absolute left-4 top-4 z-10 rounded-full bg-lyo-leaf px-3 py-1.5 font-display text-[10px] font-semibold uppercase text-primary-foreground",
              children: n("hero.sticker.label")
            }), w && p.jsxs("span", {
              className: "absolute right-4 top-4 z-10 inline-flex items-center gap-1 rounded-full bg-lyo-carrot px-3 py-1.5 font-display text-[10px] font-semibold uppercase text-secondary-foreground",
              children: [p.jsx(BR, {
                className: "h-3 w-3 fill-current",
                "aria-hidden": !0
              }), s.bestValue.join(" ")]
            }), window.LyoShopify.config.launchOffer?.enabled && c >= 6 && p.jsx("span", {
              className: "absolute left-4 top-4 z-10 rounded-full bg-lyo-carrot px-3 py-1.5 font-display text-[10px] font-bold uppercase tracking-[0.08em] text-white",
              children: n("launch.badge")
            }), p.jsx("img", window.LyoEditor.mediaProps({
              src: WI[d.slug],
              alt: s.boxNames[c],
              className: "aspect-[4/3] w-full bg-lyo-sand object-cover object-center",
              loading: "eager",
              decoding: "async"
            })), p.jsxs("div", {
              className: "flex flex-1 flex-col p-5 sm:p-6",
              children: [p.jsx("h3", {
                className: "font-display text-xl font-bold text-foreground",
                children: s.boxNames[c]
              }), p.jsx("p", {
                className: "mt-1 font-body text-sm text-foreground/65",
                children: s.qty[c]
              }), p.jsx("p", {
                className: "mt-4 font-display text-3xl font-bold tabular-nums text-foreground",
                children: xo(f, r)
              }), p.jsxs("p", {
                className: "mt-1 font-body text-sm text-foreground/65",
                children: [xo(Z3(f, c), r), " ", s.perBag]
              }), p.jsxs("p", {
                className: "mt-4 flex min-h-[2.75rem] items-start gap-2 font-body text-sm leading-relaxed text-foreground/80",
                children: [p.jsx(up, {
                  className: "mt-0.5 h-4 w-4 shrink-0 text-lyo-leaf",
                  "aria-hidden": !0
                }), s.checks[c]]
              }), p.jsx("div", {
                className: "mt-auto pt-6",
                children: p.jsxs(PE, {
                  className: "btn-lyo w-full rounded-full bg-lyo-carrot hover:brightness-110",
                  disabled: t || m || !d.available,
                  onClick: () => void u(d),
                  children: [m || t ? p.jsx(cp, {
                    className: "animate-spin",
                    "aria-hidden": !0
                  }) : p.jsx(Sf, {
                    "aria-hidden": !0
                  }), d.available ? n("shop.add") : n("cart.add.oos")]
                })
              })]
            })]
          }, d.slug);
        })
      }))]
    });
  },
  qI = ({
    children: e,
    rootMargin: t = "480px 0px",
    minHeightClass: n = "min-h-[36rem]"
  }) => {
    const r = y.useRef(null),
      [s, o] = y.useState(!1);
    return y.useEffect(() => {
      const i = r.current;
      if (!i) return;
      if (typeof IntersectionObserver > "u") {
        o(!0);
        return;
      }
      const a = new IntersectionObserver(l => {
        l.some(u => u.isIntersecting) && (o(!0), a.disconnect());
      }, {
        root: null,
        rootMargin: t,
        threshold: 0
      });
      return a.observe(i), () => a.disconnect();
    }, [t]), p.jsx("div", {
      ref: r,
      className: s ? void 0 : n,
      children: s ? e : null
    });
  },
  KI = [{
    icon: u1,
    titleKey: "how.1.title",
    subKey: "how.1.sub"
  }, {
    icon: fp,
    titleKey: "how.2.title",
    subKey: "how.2.sub"
  }, {
    icon: $R,
    titleKey: "how.3.title",
    subKey: "how.3.sub"
  }, {
    icon: FR,
    titleKey: "how.4.title",
    subKey: "how.4.sub"
  }, {
    icon: MR,
    titleKey: "how.5.title",
    subKey: "how.5.sub"
  }],
  QI = () => {
    const {
        t: e
      } = Me(),
      t = Fo();
    return p.jsx("section", window.LyoEditor.regionProps("how", {
      className: "py-16 sm:py-24",
      children: p.jsxs("div", {
        className: "container mx-auto px-4",
        children: [p.jsx("h2", {
          className: "text-center font-display text-3xl font-bold text-foreground sm:text-4xl",
          children: e("how.title")
        }), p.jsxs("div", {
          className: "relative mx-auto mt-12 flex max-w-5xl flex-col gap-8 md:flex-row md:gap-6",
          children: [p.jsx("span", {
            "aria-hidden": !0,
            className: "absolute bottom-7 left-7 top-7 w-px bg-lyo-leaf/20 md:bottom-auto md:left-[12%] md:right-[12%] md:top-7 md:h-px md:w-auto"
          }), KI.map(({
            icon: n,
            titleKey: r,
            subKey: s
          }, o) => p.jsxs(Pt.div, {
            initial: t ? !1 : {
              opacity: 0,
              y: 16
            },
            whileInView: {
              opacity: 1,
              y: 0
            },
            viewport: {
              once: !0,
              amount: 0.25
            },
            transition: {
              duration: 0.55,
              delay: t ? 0 : o * 0.08,
              ease: Pn
            },
            className: "relative flex flex-1 items-center gap-5 md:flex-col md:gap-4 md:text-center",
            children: [p.jsxs("div", {
              className: "relative flex-shrink-0",
              children: [p.jsx("span", {
                className: "absolute -left-1.5 -top-1.5 z-20 flex h-5 w-5 items-center justify-center rounded-full bg-lyo-leaf font-display text-[10px] font-bold text-white",
                children: o + 1
              }), p.jsx("span", {
                className: "relative z-10 flex h-14 w-14 items-center justify-center rounded-full border border-foreground/10 bg-card",
                children: p.jsx(n, {
                  className: "h-6 w-6 text-lyo-leaf",
                  strokeWidth: 1.75,
                  "aria-hidden": !0
                })
              })]
            }), p.jsxs("div", {
              children: [p.jsx("h3", {
                className: "font-display text-base font-semibold text-foreground",
                children: e(r)
              }), p.jsx("p", {
                className: "mt-1 font-body text-sm leading-relaxed text-foreground/60",
                children: e(s)
              })]
            })]
          }, r))]
        })]
      })
    }));
  },
  GI = {
    cream: "text-lyo-cream",
    sand: "text-lyo-sand",
    leaf: "text-lyo-leaf"
  },
  Jt = ({
    fill: e,
    flip: t = !1,
    fromTop: n = !1
  }) => p.jsx("div", {
    className: `h-12 w-full overflow-hidden sm:h-14 ${GI[e]} ${n ? "rotate-180" : ""}`,
    "aria-hidden": !0,
    children: p.jsx("svg", {
      viewBox: "0 0 1440 80",
      preserveAspectRatio: "none",
      className: `block h-full w-full ${t ? "-scale-x-100" : ""}`,
      children: p.jsx("path", {
        className: "fill-current",
        d: "M0 40C160 72 280 12 480 36C680 60 800 8 1000 40C1160 64 1280 16 1440 40V80H0Z"
      })
    })
  }),
  YI = [{
    icon: LR,
    titleKey: "trust.1.title",
    lineKey: "trust.1.line"
  }, {
    icon: VR,
    titleKey: "trust.2.title",
    lineKey: "trust.2.line"
  }, {
    icon: UR,
    titleKey: "trust.3.title",
    lineKey: "trust.3.line"
  }, {
    icon: fp,
    titleKey: "trust.4.title",
    lineKey: "trust.4.line"
  }, {
    icon: u1,
    titleKey: "trust.5.title",
    lineKey: "trust.5.line"
  }, {
    icon: c1,
    titleKey: "trust.6.title",
    lineKey: "trust.6.line"
  }],
  XI = () => {
    const {
      t: e
    } = Me();
    return p.jsx("section", window.LyoEditor.regionProps("promises", {
      className: "container mx-auto px-4 py-16 sm:py-24",
      children: p.jsxs("div", {
        className: "mx-auto max-w-5xl",
        children: [p.jsx("h2", {
          className: "text-center font-display text-3xl font-bold text-foreground sm:text-4xl",
          children: e("trust.title")
        }), p.jsx("div", {
          className: "mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3",
          children: YI.map(({
            icon: t,
            titleKey: n,
            lineKey: r
          }) => p.jsxs("article", {
            className: "rounded-2xl border border-foreground/5 bg-card p-6 sm:p-7",
            children: [p.jsx(t, {
              className: "mb-3 h-7 w-7 text-lyo-leaf",
              strokeWidth: 1.75,
              "aria-hidden": !0
            }), p.jsx("h3", {
              className: "font-display text-base font-semibold text-foreground",
              children: e(n)
            }), p.jsx("p", {
              className: "mt-1 font-body text-sm leading-relaxed text-foreground/70",
              children: e(r)
            })]
          }, n))
        })]
      })
    }));
  },
  kE = [{
    slug: "decouverte",
    nameKey: "box.discovery",
    descKey: "box.discovery.desc",
    bags: 3,
    price: 39.99,
    variantId: window.LyoShopify.catalog["decouverte"]?.variantId || ""
  }, {
    slug: "grande",
    nameKey: "box.grande",
    descKey: "box.grande.desc",
    bags: 6,
    price: 64.99,
    variantId: window.LyoShopify.catalog["grande"]?.variantId || "",
    badge: "popular",
    recommended: !0
  }, {
    slug: "garde-manger",
    nameKey: "box.pantry",
    descKey: "box.pantry.desc",
    bags: 10,
    price: 99.99,
    variantId: window.LyoShopify.catalog["garde-manger"]?.variantId || "",
    badge: "bestprice"
  }],
  M5 = e => kE.find(t => t.slug === e);
function ZI() {
  return HP({
    queryKey: ["shopify-products"],
    queryFn: q3,
    staleTime: 1e3 * 60 * 5
  });
}
function JI() {
  const {
    data: e,
    isLoading: t,
    isError: n
  } = ZI();
  return {
    boxes: kE.map(s => {
      const o = e == null ? void 0 : e.get(s.variantId);
      return {
        ...s,
        shopify: o,
        displayPrice: (o == null ? void 0 : o.price) ?? s.price,
        available: o ? o.availableForSale && !o.currentlyNotInStock : false,
        shopifyTitle: o == null ? void 0 : o.productTitle
      };
    }),
    isLoading: t,
    isError: n
  };
}
const e5 = window.LyoShopify.asset("final-cta-puppy-BfWiOu84.jpeg"),
  Bv = [{
    id: "carrot",
    img: BI,
    nameKey: "flav.carrot",
    accent: Xs.carrot
  }, {
    id: "sweet",
    img: _I,
    nameKey: "flav.sweet",
    accent: Xs.terra
  }, {
    id: "bean",
    img: VI,
    nameKey: "flav.bean",
    accent: Xs.olive
  }],
  t5 = () => {
    const {
        t: e
      } = Me(),
      t = Fo(),
      [n, r] = y.useState(0),
      [s, o] = y.useState(0.47),
      [i, a] = y.useState(!1),
      l = y.useRef(null),
      u = y.useRef(!1),
      d = Bv[n],
      c = y.useCallback(g => {
        const v = l.current;
        if (!v) return;
        const b = v.getBoundingClientRect(),
          S = Math.min(1, Math.max(0, (g - b.left) / b.width));
        o(S), a(!0);
      }, []),
      f = g => {
        u.current = !0, g.currentTarget.setPointerCapture(g.pointerId), c(g.clientX);
      },
      h = g => {
        u.current && c(g.clientX);
      },
      w = () => {
        u.current = !1;
      },
      m = Math.round(s * 100),
      x = t ? 0 : Math.max(0, (1 - s) * 18);
    return p.jsx("section", window.LyoEditor.regionProps("freeze", {
      className: "text-foreground",
      children: p.jsxs("div", {
        className: "container mx-auto px-4 py-16 sm:py-24",
        children: [p.jsxs("div", {
          className: "relative mx-auto mb-8 max-w-2xl text-center",
          children: [p.jsx(xl, {
            motif: "frost",
            className: "absolute -right-8 -top-6 hidden w-20 rotate-6 opacity-[0.28] sm:block"
          }), p.jsx("p", {
            className: "kicker text-lyo-leaf",
            children: e("eyebrow.method")
          }), p.jsx("h2", {
            className: "mt-2 font-display text-3xl font-bold leading-tight text-foreground sm:text-4xl",
            children: e("trans.title")
          }), p.jsx("p", {
            className: "mt-4 font-body text-base leading-relaxed text-foreground/70 whitespace-pre-line",
            children: e("trans.body")
          }), p.jsx("div", {
            className: "mt-6 flex flex-wrap justify-center gap-2",
            children: Bv.map((g, v) => p.jsx("button", {
              type: "button",
              onClick: () => {
                r(v), o(0.47), a(!1);
              },
              className: Y("min-h-11 rounded-full border px-4 py-2 font-display text-sm font-semibold transition-colors", v === n ? "border-lyo-carrot bg-lyo-carrot/10 text-foreground" : "border-foreground/15 text-foreground/50 hover:text-foreground"),
              children: e(g.nameKey)
            }, g.id))
          })]
        }), p.jsx("div", {
          className: "relative",
          children: p.jsxs("div", {
            ref: l,
            className: "relative aspect-[4/3] sm:aspect-[16/9] overflow-hidden rounded-2xl bg-black select-none touch-none cursor-ew-resize",
            onPointerDown: f,
            onPointerMove: h,
            onPointerUp: w,
            onPointerCancel: w,
            role: "slider",
            "aria-label": e("freeze.title"),
            "aria-valuemin": 0,
            "aria-valuemax": 100,
            "aria-valuenow": m,
            tabIndex: 0,
            onKeyDown: g => {
              g.key === "ArrowRight" && (o(v => Math.min(1, v + 0.05)), a(!0)), g.key === "ArrowLeft" && (o(v => Math.max(0, v - 0.05)), a(!0));
            },
            children: [p.jsx("img", window.LyoEditor.mediaProps({
              src: d.img,
              alt: "",
              draggable: !1,
              decoding: "async",
              className: "absolute inset-0 w-[110%] h-[110%] -left-[5%] -top-[5%] max-w-none object-cover saturate-[1.4] brightness-110",
              style: {
                filter: x > 0.4 ? `blur(${x}px)` : "none"
              }
            })), p.jsx("img", window.LyoEditor.mediaProps({
              src: d.img,
              alt: e(d.nameKey),
              draggable: !1,
              decoding: "async",
              className: "absolute inset-0 w-full h-full object-cover",
              style: {
                clipPath: `inset(0 ${100 - m}% 0 0)`,
                WebkitClipPath: `inset(0 ${100 - m}% 0 0)`
              }
            })), p.jsx("div", window.LyoEditor.mediaProps({
              className: "absolute inset-0 pointer-events-none",
              style: {
                background: `linear-gradient(90deg, rgba(232,240,235,${0.18 * (1 - s)}) ${m}%, transparent ${m}%)`
              }
            })), p.jsxs("div", window.LyoEditor.mediaProps({
              className: "absolute top-0 bottom-0 z-10 pointer-events-none",
              style: {
                left: `${m}%`
              },
              children: [p.jsx("span", {
                className: "absolute inset-y-0 left-0 w-px bg-[#2C2C2A]"
              }), p.jsx("span", window.LyoEditor.mediaProps({
                className: Y("freeze-handle w-3 h-11 rounded-full border bg-[#2C2C2A]", !i && !t && "handle-nudge"),
                style: {
                  borderColor: d.accent
                }
              })), !i && p.jsxs("span", {
                className: "absolute top-1/2 left-4 -translate-y-1/2 whitespace-nowrap rounded-full bg-[#2C2C2A] px-3 py-1 font-display text-xs font-semibold text-[#F4EEDF]",
                children: [e("freeze.drag"), " →"]
              })]
            })), p.jsx("div", {
              className: "absolute top-4 left-4 rounded-full bg-[#F4EEDF]/90 px-3 py-1 font-display text-xs font-semibold text-[#2C2C2A]",
              children: e("freeze.fresh")
            }), p.jsx("div", {
              className: "absolute top-4 right-4 rounded-full bg-[#F4EEDF]/90 px-3 py-1 font-display text-xs font-semibold text-[#2C2C2A]",
              children: e("freeze.dry")
            })]
          })
        })]
      })
    }));
  },
  n5 = Pt(Le),
  r5 = () => {
    const {
        t: e
      } = Me(),
      {
        boxes: t,
        isLoading: n
      } = JI(),
      r = Fo(),
      s = o => {
        var i;
        (i = document.getElementById(`benefit-${o}`)) == null || i.scrollIntoView({
          behavior: "smooth",
          block: "center"
        });
      };
    return p.jsxs("div", {
      children: [p.jsx(II, {}), p.jsx(TE, {
        className: "hidden lg:block"
      }), p.jsxs("div", {
        className: "bg-lyo-sand",
        children: [p.jsx(Jt, {
          fill: "leaf",
          fromTop: !0
        }), p.jsx(HI, {
          boxes: t,
          productsLoading: n
        }), p.jsx(Jt, {
          fill: "cream"
        })]
      }), p.jsxs("div", {
        className: "bg-lyo-cream",
        children: [p.jsx(bI, {}), p.jsx("section", window.LyoEditor.regionProps("flavors", {
          className: "container mx-auto px-4 pt-10 pb-2 sm:pt-14",
          children: p.jsxs("div", {
            className: "relative mx-auto max-w-3xl",
            children: [p.jsx(xl, {
              motif: "carrot",
              className: "absolute left-5 top-1/2 hidden w-10 -translate-y-1/2 -rotate-12 opacity-[0.34] sm:block"
            }), p.jsx(xl, {
              motif: "greenBeans",
              className: "absolute right-4 top-1/2 hidden w-11 -translate-y-1/2 rotate-12 opacity-[0.3] sm:block"
            }), p.jsxs("div", {
              className: "relative z-[1] text-center",
              children: [p.jsx("h2", {
                className: "font-display text-xl font-semibold text-foreground sm:text-2xl",
                children: e("selector.title")
              }), p.jsx("div", {
                className: "mt-5 flex flex-wrap justify-center gap-2.5 sm:gap-3",
                children: [2, 1, 3].map(o => p.jsx("button", {
                  type: "button",
                  onClick: () => s(o),
                  className: "min-h-11 rounded-full border border-foreground/15 bg-card px-5 py-2.5 font-display text-sm font-semibold text-foreground transition-colors hover:border-foreground/40 sm:text-base",
                  children: e(`selector.${o}`)
                }, o))
              })]
            })]
          })
        })), p.jsx(Jt, {
          fill: "sand",
          flip: !0
        })]
      }), p.jsxs("div", {
        className: "bg-lyo-sand",
        children: [p.jsx(Xo, {
          children: p.jsx(PI, {})
        }), p.jsx(Jt, {
          fill: "cream"
        })]
      }), p.jsxs("div", {
        className: "bg-lyo-cream",
        children: [p.jsx(Xo, {
          children: p.jsxs("section", window.LyoEditor.regionProps("why", {
            className: "container mx-auto px-4 pb-16 sm:pb-24",
            children: [p.jsx("h2", {
              className: "text-center font-display text-3xl font-bold text-foreground sm:text-4xl",
              children: e("why.title")
            }), p.jsx("div", {
              className: "mx-auto mt-10 grid max-w-5xl grid-cols-1 gap-4 md:grid-cols-3",
              children: [1, 2, 3].map(o => p.jsxs("div", {
                className: "rounded-3xl border border-foreground/10 bg-card p-6 sm:p-7",
                children: [p.jsx("span", {
                  className: "font-display text-xs font-bold text-lyo-leaf",
                  get children() {
                    return window.LyoEditor.format("txt_f1b63bc7de42", "0{{value1}}", [o]);
                  }
                }), p.jsx("h3", {
                  className: "mt-2 font-display text-lg font-semibold text-foreground",
                  children: e(`why.${o}.title`)
                }), p.jsx("p", {
                  className: "mt-2 font-body text-sm leading-relaxed text-foreground/70",
                  children: e(`why.${o}.desc`)
                })]
              }, o))
            })]
          }))
        }), p.jsx(Jt, {
          fill: "sand",
          flip: !0
        })]
      }), p.jsxs("div", {
        className: "bg-lyo-sand",
        children: [p.jsx(qI, {
          children: p.jsx(y.Suspense, {
            fallback: null,
            children: p.jsx(t5, {})
          })
        }), p.jsx(Jt, {
          fill: "cream"
        })]
      }), p.jsxs("div", {
        className: "bg-lyo-cream",
        children: [p.jsx(Xo, {
          children: p.jsx(AI, {})
        }), p.jsx(Jt, {
          fill: "sand",
          flip: !0
        })]
      }), p.jsxs("div", {
        className: "bg-lyo-sand",
        children: [p.jsx(QI, {}), p.jsx(Jt, {
          fill: "cream"
        })]
      }), p.jsxs("div", {
        className: "bg-lyo-cream",
        children: [p.jsx(XI, {}), p.jsx(Jt, {
          fill: "sand",
          flip: !0
        })]
      }), p.jsxs("div", {
        className: "bg-lyo-sand",
        children: [p.jsx(Xo, {
          children: p.jsx("section", window.LyoEditor.regionProps("faq", {
            className: "mx-auto flex w-full justify-center px-4 py-16 sm:py-24",
            children: p.jsxs("div", {
              className: "relative w-full max-w-3xl",
              children: [p.jsx(xl, {
                motif: "pawTrail",
                className: "absolute -top-4 left-[calc(50%+9rem)] hidden w-14 rotate-12 opacity-[0.24] sm:block"
              }), p.jsx("h2", {
                className: "mb-10 text-center font-display text-3xl font-bold text-foreground sm:text-4xl",
                children: e("faq.title")
              }), p.jsx(xI, {
                items: [{
                  q: e("faq.q0a"),
                  a: e("faq.a0a")
                }, {
                  q: e("faq.q0b"),
                  a: e("faq.a0b")
                }, {
                  q: e("faq.q1"),
                  a: e("faq.a1")
                }, {
                  q: e("faq.q2"),
                  a: e("faq.a2")
                }, {
                  q: e("faq.q3"),
                  a: e("faq.a3")
                }, {
                  q: e("faq.q4"),
                  a: e("faq.a4")
                }, {
                  q: e("faq.q5"),
                  a: e("faq.a5")
                }, {
                  q: e("faq.q6"),
                  a: e("faq.a6")
                }, {
                  q: e("faq.q7"),
                  a: e("faq.a7")
                }]
              })]
            })
          }))
        }), p.jsx(Jt, {
          fill: "cream"
        })]
      }), p.jsx("div", {
        className: "bg-lyo-cream",
        children: p.jsx(Xo, {
          children: p.jsx("section", window.LyoEditor.regionProps("final", {
            className: "container mx-auto px-4 pb-20 pt-4",
            children: p.jsx("div", {
              className: "relative overflow-hidden rounded-3xl bg-lyo-leaf-deep text-[#F4EEDF]",
              children: p.jsxs("div", {
                className: "grid grid-cols-1 md:grid-cols-2",
                children: [p.jsxs("div", {
                  className: "flex flex-col justify-center p-8 sm:p-12 md:p-16",
                  children: [p.jsx("h2", {
                    className: "font-display text-3xl font-bold leading-snug sm:text-4xl md:text-5xl",
                    children: e("final.title")
                  }), p.jsxs(n5, {
                    to: "/shop",
                    className: "btn-lyo mt-8 self-start bg-lyo-carrot hover:brightness-110",
                    whileHover: r ? void 0 : {
                      y: -2
                    },
                    whileTap: {
                      scale: 0.98
                    },
                    children: [e("final.cta"), p.jsx(Ou, {
                      className: "h-4 w-4",
                      "aria-hidden": !0
                    })]
                  }), p.jsx(CE, {
                    tone: "inverted",
                    className: "mt-4"
                  })]
                }), p.jsx("div", {
                  className: "relative min-h-[240px] overflow-hidden md:min-h-0",
                  children: p.jsx(Pt.img, window.LyoEditor.mediaProps({
                    src: e5,
                    get alt() {
                      return window.LyoEditor.text("txt_15d6c14f010d", "Chiot golden retriever heureux dans les bras de son humain");
                    },
                    loading: "lazy",
                    decoding: "async",
                    className: "h-full min-h-[240px] w-full object-cover",
                    whileHover: r ? void 0 : {
                      scale: 1.04
                    },
                    transition: {
                      duration: 0.7,
                      ease: Pn
                    }
                  }))
                })]
              })
            })
          }))
        })
      })]
    });
  },
  s5 = y.lazy(() => In(() => import("./Shop-launch-offer-v8.js"), [])),
  o5 = y.lazy(() => In(() => import("./ProductDetail-DDvq_ppn.js"), [])),
  i5 = y.lazy(() => In(() => import("./Story-BX1YgeLA.js"), [])),
  a5 = y.lazy(() => In(() => import("./FAQ-Dx7rzuXM.js"), [])),
  l5 = y.lazy(() => In(() => import("./Contact-C_0uS4OP.js"), [])),
  u5 = y.lazy(() => In(() => import("./Policy-BbeiX2CR.js"), []).then(e => ({
    default: e.RefundPage
  }))),
  c5 = y.lazy(() => In(() => import("./Policy-BbeiX2CR.js"), []).then(e => ({
    default: e.ShippingPage
  }))),
  d5 = y.lazy(() => In(() => import("./Policy-BbeiX2CR.js"), []).then(e => ({
    default: e.TermsPage
  }))),
  f5 = y.lazy(() => In(() => import("./NotFound-BtIqHq-h.js"), [])),
  h5 = new RP(),
  p5 = () => (dI(), p.jsxs(p.Fragment, {
    children: [p.jsx(pj, {}), p.jsxs("div", {
      className: "flex flex-col min-h-screen",
      children: [p.jsx(nI, {}), p.jsx("main", {
        className: "relative isolate flex-1",
        children: p.jsx(y.Suspense, {
          fallback: null,
          children: p.jsxs(Dk, {
            children: [p.jsx(bt, {
              path: "/",
              element: p.jsx(r5, {})
            }), p.jsx(bt, {
              path: "/shop",
              element: p.jsx(s5, {})
            }), p.jsx(bt, {
              path: "/produit/:slug",
              element: p.jsx(o5, {})
            }), p.jsx(bt, {
              path: "/notre-mission",
              element: p.jsx(i5, {})
            }), p.jsx(bt, {
              path: "/notre-histoire",
              element: p.jsx(Ok, {
                to: "/notre-mission",
                replace: !0
              })
            }), p.jsx(bt, {
              path: "/faq",
              element: p.jsx(a5, {})
            }), p.jsx(bt, {
              path: "/contact",
              element: p.jsx(l5, {})
            }), p.jsx(bt, {
              path: "/remboursement",
              element: p.jsx(u5, {})
            }), p.jsx(bt, {
              path: "/livraison",
              element: p.jsx(c5, {})
            }), p.jsx(bt, {
              path: "/conditions",
              element: p.jsx(d5, {})
            }), p.jsx(bt, {
              path: "*",
              element: p.jsx(f5, {})
            })]
          })
        })
      }), p.jsx(uI, {}), p.jsx(cI, {})]
    })]
  })),
  m5 = () => p.jsx(OP, {
    client: h5,
    children: p.jsx(fj, {
      children: p.jsxs(mj, {
        children: [p.jsx(TN, {}), p.jsx(k2, {}), p.jsx(Wk, {
          future: {
            v7_startTransition: !0,
            v7_relativeSplatPath: !0
          },
          children: p.jsx(p5, {})
        })]
      })
    })
  });
class StorefrontErrorBoundary extends y.Component {
  constructor(props) { super(props); this.state = { failed: false }; }
  static getDerivedStateFromError() { return { failed: true }; }
  componentDidCatch(error) { this.props.onError(); console.error('LyoPup storefront error.', error); }
  render() { return this.state.failed ? null : this.props.children; }
}
window.LyoStorefrontLifecycle?.destroy();
window.LyoStorefrontLifecycle = installStorefrontLifecycle({
  createRoot: cw,
  render: onError => p.jsx(StorefrontErrorBoundary, {
    onError,
    children: p.jsx(m5, {})
  }, String(window.LyoEditor.revision))
});
export { Z3 as A, R5 as B, up as C, j5 as D, zI as E, xI as F, y5 as G, M5 as H, xl as I, Le as J, Ou as K, a1 as L, LR as M, Ok as N, dp as P, Jt as S, $R as T, ia as X, Y as a, fp as b, he as c, JI as d, v5 as e, Ku as f, $I as g, xo as h, BR as i, p as j, l1 as k, A5 as l, cp as m, CE as n, Qu as o, tm as p, nm as q, y as r, wE as s, bE as t, Me as u, SE as v, N5 as w, G3 as x, La as y, UI as z };
